import { defineComponent, getCurrentInstance, markRaw, watch as watch$1, watchEffect, reactive, onMounted, onUnmounted, ref, isRef, h, inject, computed, provide, toRef, onBeforeUnmount, nextTick, triggerRef, isReactive, createTextVNode, resolveComponent, openBlock, createBlock, renderSlot, createVNode, withCtx, Fragment, renderList, resolveDynamicComponent, withDirectives, vShow, mergeProps as mergeProps$1, withModifiers, createCommentVNode, createElementBlock, normalizeClass, createElementVNode, toDisplayString, unref, createSlots, useSlots, Teleport, isProxy, toRaw, normalizeStyle, vModelRadio } from "vue";
var isBrowser$4 = typeof window < "u", explicitKeys = [
  "__key",
  "__init",
  "__shim",
  "__original",
  "__index",
  "__prevKey"
];
function token() {
  return Math.random().toString(36).substring(2, 15);
}
function dedupe(e, t) {
  return [...e instanceof Set ? e : new Set(e)];
}
function has(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function eq(e, t, n = !0, r = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return eqRegExp(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const i of r)
      if ((i in e || i in t) && e[i] !== t[i])
        return !1;
    for (const i in e)
      if (!(i in t) || e[i] !== t[i] && !n || n && !eq(e[i], t[i], n, r))
        return !1;
    return !0;
  }
  return !1;
}
function eqRegExp(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function empty(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const n in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function escapeExp(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function regexForFormat(e) {
  const t = `^${escapeExp(e)}$`, n = {
    MM: "(0[1-9]|1[012])",
    M: "([1-9]|1[012])",
    DD: "([012][0-9]|3[01])",
    D: "([012]?[0-9]|3[01])",
    YYYY: "\\d{4}",
    YY: "\\d{2}"
  }, r = Object.keys(n);
  return new RegExp(
    r.reduce((i, s) => i.replace(s, n[s]), t)
  );
}
function isRecord(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function isObject(e) {
  return isRecord(e) || Array.isArray(e);
}
function isPojo(e) {
  if (isRecord(e) === !1 || e.__FKNode__ || e.__POJO__ === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(isRecord(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1);
}
var extend$1 = /* @__NO_SIDE_EFFECTS__ */ (e, t, n = !1, r = !1) => {
  if (t === null)
    return null;
  const i = {};
  if (typeof t == "string")
    return t;
  for (const s in e)
    if (has(t, s) && (t[s] !== void 0 || !r)) {
      if (n && Array.isArray(e[s]) && Array.isArray(t[s])) {
        i[s] = e[s].concat(t[s]);
        continue;
      }
      if (t[s] === void 0)
        continue;
      isPojo(e[s]) && isPojo(t[s]) ? i[s] = /* @__PURE__ */ extend$1(
        e[s],
        t[s],
        n,
        r
      ) : i[s] = t[s];
    } else
      i[s] = e[s];
  for (const s in t)
    !has(i, s) && t[s] !== void 0 && (i[s] = t[s]);
  return i;
};
function isQuotedString(e) {
  if (e[0] !== '"' && e[0] !== "'" || e[0] !== e[e.length - 1])
    return !1;
  const t = e[0];
  for (let n = 1; n < e.length; n++)
    if (e[n] === t && (n === 1 || e[n - 1] !== "\\") && n !== e.length - 1)
      return !1;
  return !0;
}
function rmEscapes(e) {
  if (!e.length)
    return "";
  let t = "", n = "";
  for (let r = 0; r < e.length; r++) {
    const i = e.charAt(r);
    (i !== "\\" || n === "\\") && (t += i), n = i;
  }
  return t;
}
function nodeProps(...e) {
  return e.reduce((t, n) => {
    const { value: r, name: i, modelValue: s, config: l, plugins: c, ...u } = n;
    return Object.assign(t, u);
  }, {});
}
function parseArgs(e) {
  const t = [];
  let n = "", r = 0, i = "", s = "";
  for (let l = 0; l < e.length; l++) {
    const c = e.charAt(l);
    c === i && s !== "\\" ? i = "" : (c === "'" || c === '"') && !i && s !== "\\" ? i = c : c === "(" && !i ? r++ : c === ")" && !i && r--, c === "," && !i && r === 0 ? (t.push(n), n = "") : (c !== " " || i) && (n += c), s = c;
  }
  return n && t.push(n), t;
}
function except(e, t) {
  const n = {}, r = t.filter((s) => s instanceof RegExp), i = new Set(t);
  for (const s in e)
    !i.has(s) && !r.some((l) => l.test(s)) && (n[s] = e[s]);
  return n;
}
function only(e, t) {
  const n = {}, r = t.filter((i) => i instanceof RegExp);
  return t.forEach((i) => {
    i instanceof RegExp || (n[i] = e[i]);
  }), Object.keys(e).forEach((i) => {
    r.some((s) => s.test(i)) && (n[i] = e[i]);
  }), n;
}
function camel(e) {
  return e.replace(
    /-([a-z0-9])/gi,
    (t, n) => n.toUpperCase()
  );
}
function kebab(e) {
  return e.replace(
    /([a-z0-9])([A-Z])/g,
    (t, n, r) => n + "-" + r.toLowerCase()
  ).replace(" ", "-").toLowerCase();
}
function shallowClone(e, t = explicitKeys) {
  if (e !== null && typeof e == "object") {
    let n;
    if (Array.isArray(e) ? n = [...e] : isPojo(e) && (n = { ...e }), n)
      return applyExplicit(e, n, t), n;
  }
  return e;
}
function clone(e, t = explicitKeys) {
  if (e === null || e instanceof RegExp || e instanceof Date || e instanceof Map || e instanceof Set || typeof File == "function" && e instanceof File)
    return e;
  let n;
  Array.isArray(e) ? n = e.map((r) => typeof r == "object" ? clone(r, t) : r) : n = Object.keys(e).reduce((r, i) => (r[i] = typeof e[i] == "object" ? clone(e[i], t) : e[i], r), {});
  for (const r of t)
    r in e && Object.defineProperty(n, r, {
      enumerable: !1,
      value: e[r]
    });
  return n;
}
function cloneAny(e) {
  return typeof e == "object" ? clone(e) : e;
}
function getAt(e, t) {
  if (!e || typeof e != "object")
    return null;
  const n = t.split(".");
  let r = e;
  for (const i in n) {
    const s = n[i];
    if (has(r, s) && (r = r[s]), +i === n.length - 1)
      return r;
    if (!r || typeof r != "object")
      return null;
  }
  return null;
}
function undefine(e) {
  return e !== void 0 && e !== "false" && e !== !1 ? !0 : void 0;
}
function init(e) {
  return Object.isFrozen(e) ? e : Object.defineProperty(e, "__init", {
    enumerable: !1,
    value: !0
  });
}
function slugify(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function applyExplicit(e, t, n) {
  for (const r of n)
    r in e && Object.defineProperty(t, r, {
      enumerable: !1,
      value: e[r]
    });
  return t;
}
function whenAvailable(e, t, n) {
  if (!isBrowser$4)
    return;
  n || (n = document);
  const r = n.getElementById(e);
  if (r)
    return t(r);
  const i = new MutationObserver(() => {
    const s = n == null ? void 0 : n.getElementById(e);
    s && (i == null || i.disconnect(), t(s));
  });
  i.observe(n, { childList: !0, subtree: !0 });
}
function oncePerTick(e) {
  let t = !1;
  return (...n) => {
    if (!t)
      return t = !0, queueMicrotask(() => t = !1), e(...n);
  };
}
function boolGetter(e) {
  if (!(e === "false" || e === !1))
    return !0;
}
function createDispatcher() {
  const e = [];
  let t = 0;
  const n = (i) => e.push(i), r = (i) => {
    const s = e[t];
    return typeof s == "function" ? s(i, (l) => (t++, r(l))) : (t = 0, i);
  };
  return n.dispatch = r, n.unshift = (i) => e.unshift(i), n.remove = (i) => {
    const s = e.indexOf(i);
    s > -1 && e.splice(s, 1);
  }, n;
}
function createEmitter() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let n;
  const r = (i, s) => {
    if (n) {
      n.set(s.name, [i, s]);
      return;
    }
    e.has(s.name) && e.get(s.name).forEach((l) => {
      (s.origin === i || l.modifiers.includes("deep")) && l.listener(s);
    }), s.bubble && i.bubble(s);
  };
  return r.flush = () => {
    e.clear(), t.clear(), n == null || n.clear();
  }, r.on = (i, s, l = "push") => {
    const [c, ...u] = i.split("."), m = s.receipt || token(), qu = {
      modifiers: u,
      event: c,
      listener: s,
      receipt: m
    };
    return e.has(c) ? e.get(c)[l](qu) : e.set(c, [qu]), t.has(m) ? t.get(m)[l](c) : t.set(m, [c]), m;
  }, r.off = (i) => {
    var s;
    t.has(i) && ((s = t.get(i)) == null || s.forEach((l) => {
      const c = e.get(l);
      Array.isArray(c) && e.set(
        l,
        c.filter((u) => u.receipt !== i)
      );
    }), t.delete(i));
  }, r.pause = (i) => {
    n || (n = /* @__PURE__ */ new Map()), i && i.walk((s) => s._e.pause());
  }, r.play = (i) => {
    if (!n)
      return;
    const s = n;
    n = void 0, s.forEach(([l, c]) => r(l, c)), i && i.walk((l) => l._e.play());
  }, r;
}
function emit(e, t, n, r, i = !0, s) {
  return t._e(e, {
    payload: r,
    name: n,
    bubble: i,
    origin: e,
    meta: s
  }), e;
}
function bubble(e, t, n) {
  return isNode$1(e.parent) && e.parent._e(e.parent, n), e;
}
function on$1(e, t, n, r, i) {
  return t._e.on(n, r, i);
}
function off(e, t, n) {
  return t._e.off(n), e;
}
var errorHandler = createDispatcher();
errorHandler((e, t) => (e.message || (e.message = `E${e.code}`), t(e)));
var warningHandler = createDispatcher();
warningHandler((e, t) => {
  e.message || (e.message = `W${e.code}`);
  const n = t(e);
  return console && typeof console.warn == "function" && console.warn(n.message), n;
});
function warn(e, t = {}) {
  warningHandler.dispatch({ code: e, data: t });
}
function error(e, t = {}) {
  throw Error(errorHandler.dispatch({ code: e, data: t }).message);
}
function createMessage(e, t) {
  return {
    blocking: !1,
    key: token(),
    meta: {},
    type: "state",
    visible: !0,
    ...e
  };
}
var storeTraps = {
  apply: applyMessages,
  set: setMessage,
  remove: removeMessage$1,
  filter: filterMessages,
  reduce: reduceMessages,
  release: releaseBuffer,
  touch: touchMessages
};
function createStore(e = !1) {
  const t = {};
  let n, r = e, i = [];
  const s = /* @__PURE__ */ new Map();
  let l;
  const c = new Proxy(t, {
    get(...u) {
      const [m, qu] = u;
      return qu === "buffer" ? r : qu === "_b" ? i : qu === "_m" ? s : qu === "_r" ? l : has(storeTraps, qu) ? storeTraps[qu].bind(
        null,
        t,
        c,
        n
      ) : Reflect.get(...u);
    },
    set(u, m, qu) {
      return m === "_n" ? (n = qu, l === "__n" && releaseMissed(n, c), !0) : m === "_b" ? (i = qu, !0) : m === "buffer" ? (r = qu, !0) : m === "_r" ? (l = qu, !0) : (error(101, n), !1);
    }
  });
  return c;
}
function setMessage(e, t, n, r) {
  if (t.buffer)
    return t._b.push([[r]]), t;
  if (e[r.key] !== r) {
    if (typeof r.value == "string" && r.meta.localize !== !1) {
      const s = r.value;
      r.value = n.t(r), r.value !== s && (r.meta.locale = n.props.locale);
    }
    const i = `message-${has(e, r.key) ? "updated" : "added"}`;
    e[r.key] = Object.freeze(
      n.hook.message.dispatch(r)
    ), n.emit(i, r);
  }
  return t;
}
function touchMessages(e, t) {
  for (const n in e) {
    const r = { ...e[n] };
    t.set(r);
  }
}
function removeMessage$1(e, t, n, r) {
  if (has(e, r)) {
    const i = e[r];
    delete e[r], n.emit("message-removed", i);
  }
  return t.buffer === !0 && (t._b = t._b.filter((i) => (i[0] = i[0].filter((s) => s.key !== r), i[1] || i[0].length))), t;
}
function filterMessages(e, t, n, r, i) {
  for (const s in e) {
    const l = e[s];
    (!i || l.type === i) && !r(l) && removeMessage$1(e, t, n, s);
  }
}
function reduceMessages(e, t, n, r, i) {
  for (const s in e) {
    const l = e[s];
    i = r(i, l);
  }
  return i;
}
function applyMessages(e, t, n, r, i) {
  if (Array.isArray(r)) {
    if (t.buffer) {
      t._b.push([r, i]);
      return;
    }
    const s = new Set(
      r.map((l) => (t.set(l), l.key))
    );
    typeof i == "string" ? t.filter(
      (l) => l.type !== i || s.has(l.key)
    ) : typeof i == "function" && t.filter((l) => !i(l) || s.has(l.key));
  } else
    for (const s in r) {
      const l = n.at(s);
      l ? l.store.apply(r[s], i) : missed(n, t, s, r[s], i);
    }
}
function createMessages(e, ...t) {
  const n = `${e.name}-set`, r = (i) => /* @__PURE__ */ createMessage({
    key: slugify(i),
    type: "error",
    value: i,
    meta: { source: n, autoClear: !0 }
  });
  return t.filter((i) => !!i).map((i) => {
    if (typeof i == "string" && (i = [i]), Array.isArray(i))
      return i.map((s) => r(s));
    {
      const s = {};
      for (const l in i)
        Array.isArray(i[l]) ? s[l] = i[l].map(
          (c) => r(c)
        ) : s[l] = [r(i[l])];
      return s;
    }
  });
}
function missed(e, t, n, r, i) {
  var l;
  const s = t._m;
  s.has(n) || s.set(n, []), t._r || (t._r = releaseMissed(e, t)), (l = s.get(n)) == null || l.push([r, i]);
}
function releaseMissed(e, t) {
  return e.on(
    "child.deep",
    ({ payload: n }) => {
      t._m.forEach((r, i) => {
        e.at(i) === n && (r.forEach(([s, l]) => {
          n.store.apply(s, l);
        }), t._m.delete(i));
      }), t._m.size === 0 && t._r && (e.off(t._r), t._r = void 0);
    }
  );
}
function releaseBuffer(e, t) {
  t.buffer = !1, t._b.forEach(([n, r]) => t.apply(n, r)), t._b = [];
}
function createLedger() {
  const e = {};
  let t;
  return {
    count: (...n) => createCounter(t, e, ...n),
    init(n) {
      t = n, n.on("message-added.deep", add$1(e, 1)), n.on("message-removed.deep", add$1(e, -1));
    },
    merge: (n) => merge(t, e, n),
    settled(n) {
      return has(e, n) ? e[n].promise : Promise.resolve();
    },
    unmerge: (n) => merge(t, e, n, !0),
    value(n) {
      return has(e, n) ? e[n].count : 0;
    }
  };
}
function createCounter(e, t, n, r, i = 0) {
  if (r = parseCondition(r || n), !has(t, n)) {
    const s = {
      condition: r,
      count: 0,
      name: n,
      node: e,
      promise: Promise.resolve(),
      resolve: () => {
      }
      // eslint-disable-line @typescript-eslint/no-empty-function
    };
    t[n] = s, i = e.store.reduce(
      (l, c) => l + s.condition(c) * 1,
      i
    ), e.each((l) => {
      l.ledger.count(s.name, s.condition), i += l.ledger.value(s.name);
    });
  }
  return count(t[n], i).promise;
}
function parseCondition(e) {
  return typeof e == "function" ? e : (t) => t.type === e;
}
function count(e, t) {
  const n = e.count, r = e.count + t;
  return e.count = r, n === 0 && r !== 0 ? (e.node.emit(`unsettled:${e.name}`, e.count, !1), e.promise = new Promise((i) => e.resolve = i)) : n !== 0 && r === 0 && (e.node.emit(`settled:${e.name}`, e.count, !1), e.resolve()), e.node.emit(`count:${e.name}`, e.count, !1), e;
}
function add$1(e, t) {
  return (n) => {
    for (const r in e) {
      const i = e[r];
      i.condition(n.payload) && count(i, t);
    }
  };
}
function merge(e, t, n, r = !1) {
  const i = e;
  for (const s in t) {
    const l = t[s].condition;
    r || n.ledger.count(s, l);
    const c = n.ledger.value(s) * (r ? -1 : 1);
    if (e) {
      do
        e.ledger.count(s, l, c), e = e.parent;
      while (e);
      e = i;
    }
  }
}
var registry = /* @__PURE__ */ new Map(), reflected = /* @__PURE__ */ new Map(), emit2 = createEmitter();
function register$1(e) {
  e.props.id && (registry.set(e.props.id, e), reflected.set(e, e.props.id), emit2(e, {
    payload: e,
    name: e.props.id,
    bubble: !1,
    origin: e
  }));
}
function deregister(e) {
  if (reflected.has(e)) {
    const t = reflected.get(e);
    reflected.delete(e), registry.delete(t), emit2(e, {
      payload: null,
      name: t,
      bubble: !1,
      origin: e
    });
  }
}
function getNode(e) {
  return registry.get(e);
}
function watchRegistry(e, t) {
  return emit2.on(e, t);
}
function configChange(e, t, n) {
  let r = !0;
  return t in e.config._t ? r = !1 : e.emit(`config:${t}`, n, !1), t in e.props || (e.emit("prop", { prop: t, value: n }), e.emit(`prop:${t}`, n)), r;
}
function createConfig(e = {}) {
  const t = /* @__PURE__ */ new Set(), n = {
    ...e,
    _add: (i) => t.add(i),
    _rm: (i) => t.delete(i)
  };
  return new Proxy(n, {
    set(i, s, l, c) {
      return typeof s == "string" && t.forEach((u) => configChange(u, s, l)), Reflect.set(i, s, l, c);
    }
  });
}
function submitForm(e, t) {
  const n = (t || document).getElementById(e);
  if (n instanceof HTMLFormElement) {
    const r = new Event("submit", { cancelable: !0, bubbles: !0 });
    n.dispatchEvent(r);
    return;
  }
  warn(151, e);
}
function clearState(e) {
  const t = (n) => {
    for (const r in n.store) {
      const i = n.store[r];
      i.type === "error" || i.type === "ui" && r === "incomplete" ? n.store.remove(r) : i.type === "state" && n.store.set({ ...i, value: !1 });
    }
  };
  t(e), e.walk(t);
}
function reset(e, t) {
  const n = typeof e == "string" ? getNode(e) : e;
  if (n) {
    const r = (l) => cloneAny(l.props.initial) || (l.type === "group" ? {} : l.type === "list" ? [] : void 0);
    n._e.pause(n);
    const i = cloneAny(t);
    return t && !empty(t) && (n.props.initial = isObject(i) ? init(i) : i, n.props._init = n.props.initial), n.input(r(n), !1), n.walk((l) => {
      l.type === "list" && l.sync || l.input(r(l), !1);
    }), n.input(
      empty(i) && i ? i : r(n),
      !1
    ), n.type !== "input" && t && !empty(t) && isObject(t) && n.walk((l) => {
      l.props.initial = isObject(l.value) ? init(l.value) : l.value, l.props._init = l.props.initial;
    }), n._e.play(n), clearState(n), n.emit("reset", n), n;
  }
  warn(152, e);
}
var defaultConfig$1 = {
  delimiter: ".",
  delay: 0,
  locale: "en",
  rootClasses: (e) => ({ [`formkit-${kebab(e)}`]: !0 })
}, useIndex = Symbol("index"), valueRemoved = Symbol("removed"), valueMoved = Symbol("moved"), valueInserted = Symbol("inserted");
function isList(e) {
  return e.type === "list" && Array.isArray(e._value);
}
function isNode$1(e) {
  return e && typeof e == "object" && e.__FKNode__ === !0;
}
var invalidSetter = (e, t, n) => {
  error(102, [e, n]);
}, traps = {
  _c: trap(getContext, invalidSetter, !1),
  add: trap(addChild),
  addProps: trap(addProps),
  address: trap(getAddress, invalidSetter, !1),
  at: trap(getNode2),
  bubble: trap(bubble),
  clearErrors: trap(clearErrors),
  calm: trap(calm),
  config: trap(!1),
  define: trap(define),
  disturb: trap(disturb),
  destroy: trap(destroy),
  extend: trap(extend),
  hydrate: trap(hydrate),
  index: trap(getIndex, setIndex, !1),
  input: trap(input),
  each: trap(eachChild),
  emit: trap(emit),
  find: trap(find),
  on: trap(on$1),
  off: trap(off),
  parent: trap(!1, setParent),
  plugins: trap(!1),
  remove: trap(removeChild),
  root: trap(getRoot, invalidSetter, !1),
  reset: trap(resetValue),
  resetConfig: trap(resetConfig),
  setErrors: trap(setErrors),
  submit: trap(submit),
  t: trap(text$1),
  use: trap(use),
  name: trap(getName, !1, !1),
  walk: trap(walkTree)
};
function createTraps() {
  return new Map(Object.entries(traps));
}
function trap(e, t, n = !0) {
  return {
    get: e ? (r, i) => n ? (...s) => e(r, i, ...s) : e(r, i) : !1,
    set: t !== void 0 ? t : invalidSetter.bind(null)
  };
}
function createHooks() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    get(t, n) {
      return e.has(n) || e.set(n, createDispatcher()), e.get(n);
    }
  });
}
var nameCount = 0, idCount = 0;
function createName(e) {
  var t, n;
  return ((t = e.parent) == null ? void 0 : t.type) === "list" ? useIndex : e.name || `${((n = e.props) == null ? void 0 : n.type) || "input"}_${++nameCount}`;
}
function createValue(e) {
  return e.type === "group" ? init(
    e.value && typeof e.value == "object" && !Array.isArray(e.value) ? e.value : {}
  ) : e.type === "list" ? init(Array.isArray(e.value) ? e.value : []) : e.value;
}
function input(e, t, n, r = !0) {
  return t._value = validateInput(e, e.hook.input.dispatch(n)), e.emit("input", t._value), e.isCreated && e.type === "input" && eq(t._value, t.value) && !e.props.mergeStrategy ? (e.emit("commitRaw", t.value), t.settled) : (t.isSettled && e.disturb(), r ? (t._tmo && clearTimeout(t._tmo), t._tmo = setTimeout(
    commit,
    e.props.delay,
    e,
    t
  )) : commit(e, t), t.settled);
}
function validateInput(e, t) {
  switch (e.type) {
    case "input":
      break;
    case "group":
      (!t || typeof t != "object") && error(107, [e, t]);
      break;
    case "list":
      Array.isArray(t) || error(108, [e, t]);
      break;
  }
  return t;
}
function commit(e, t, n = !0, r = !0) {
  t._value = t.value = e.hook.commit.dispatch(t._value), e.type !== "input" && r && e.hydrate(), e.emit("commitRaw", t.value), e.emit("commit", t.value), n && e.calm();
}
function partial(e, { name: t, value: n, from: r }) {
  if (!Object.isFrozen(e._value)) {
    if (isList(e)) {
      const i = n === valueRemoved ? [] : n === valueMoved && typeof r == "number" ? e._value.splice(r, 1) : [n];
      e._value.splice(
        t,
        n === valueMoved || r === valueInserted ? 0 : 1,
        ...i
      );
      return;
    }
    n !== valueRemoved ? e._value[t] = n : delete e._value[t];
  }
}
function hydrate(e, t) {
  const n = t._value;
  return e.type === "list" && e.sync && syncListNodes(e, t), t.children.forEach((r) => {
    if (typeof n == "object")
      if (r.name in n) {
        const i = r.type !== "input" || n[r.name] && typeof n[r.name] == "object" ? init(n[r.name]) : n[r.name];
        if (!r.isSettled || (!isObject(i) || r.props.mergeStrategy) && eq(i, r._value))
          return;
        r.input(i, !1);
      } else
        (e.type !== "list" || typeof r.name == "number") && partial(t, { name: r.name, value: r.value }), n.__init || (r.type === "group" ? r.input({}, !1) : r.type === "list" ? r.input([], !1) : r.input(void 0, !1));
  }), e;
}
function syncListNodes(e, t) {
  const n = e._value;
  if (!Array.isArray(n))
    return;
  const r = [], i = new Set(t.children), s = /* @__PURE__ */ new Map();
  n.forEach((c, u) => {
    if (t.children[u] && t.children[u]._value === c)
      r.push(t.children[u]), i.delete(t.children[u]);
    else {
      r.push(null);
      const m = s.get(c) || [];
      m.push(u), s.set(c, m);
    }
  }), i.size && s.size && i.forEach((c) => {
    if (s.has(c._value)) {
      const u = s.get(c._value), m = u.shift();
      r[m] = c, i.delete(c), u.length || s.delete(c._value);
    }
  });
  const l = [];
  for (s.forEach((c) => {
    l.push(...c);
  }); i.size && l.length; ) {
    const c = i.values().next().value, u = l.shift();
    if (u === void 0)
      break;
    r[u] = c, i.delete(c);
  }
  l.forEach((c, u) => {
    r[c] = createPlaceholder({ value: u });
  }), i.size && i.forEach((c) => {
    if (!("__FKP" in c)) {
      const u = c._c.parent;
      if (!u || isPlaceholder(u))
        return;
      u.ledger.unmerge(c), c._c.parent = null, c.destroy();
    }
  }), t.children = r;
}
function disturb(e, t) {
  var n;
  return t._d <= 0 && (t.isSettled = !1, e.emit("settled", !1, !1), t.settled = new Promise((r) => {
    t._resolve = r;
  }), e.parent && ((n = e.parent) == null || n.disturb())), t._d++, e;
}
function calm(e, t, n) {
  var r;
  if (n !== void 0 && e.type !== "input") {
    partial(t, n);
    const i = !!(e.config.mergeStrategy && e.config.mergeStrategy[n.name]);
    return commit(e, t, !0, i);
  }
  t._d > 0 && t._d--, t._d === 0 && (t.isSettled = !0, e.emit("settled", !0, !1), e.parent && ((r = e.parent) == null || r.calm({ name: e.name, value: t.value })), t._resolve && t._resolve(t.value));
}
function destroy(e, t) {
  e.emit("destroying", e), e.store.filter(() => !1), e.parent && e.parent.remove(e), deregister(e), e.emit("destroyed", e), t._e.flush(), t._value = t.value = void 0;
  for (const n in t.context)
    delete t.context[n];
  t.plugins.clear(), t.context = null;
}
function define(e, t, n) {
  t.type = n.type;
  const r = clone(n);
  e.props.__propDefs = mergeProps(
    e.props.__propDefs ?? [],
    (r == null ? void 0 : r.props) || []
  ), r.props = e.props.__propDefs, t.props.definition = r, t.value = t._value = createValue({
    type: e.type,
    value: t.value
  }), n.forceTypeProp && (e.props.type && (e.props.originalType = e.props.type), t.props.type = n.forceTypeProp), n.family && (t.props.family = n.family), n.features && n.features.forEach((i) => i(e)), n.props && e.addProps(n.props), e.emit("defined", n);
}
function addProps(e, t, n) {
  const r = Array.isArray(n) ? n : Object.keys(n), i = Array.isArray(n) ? {} : r.reduce((l, c) => ("default" in n[c] && (l[c] = n[c].default), l), {});
  if (e.props.attrs) {
    const l = { ...e.props.attrs };
    e.props._emit = !1;
    for (const u in l) {
      const m = camel(u);
      r.includes(m) && (e.props[m] = l[u], delete l[u]);
    }
    Array.isArray(n) || r.forEach((u) => {
      "default" in n[u] && e.props[u] === void 0 && (e.props[u] = i[u]);
    });
    const c = cloneAny(t._value);
    e.props.initial = e.type !== "input" ? init(c) : c, e.props._emit = !0, e.props.attrs = l;
  }
  const s = mergeProps(e.props.__propDefs ?? [], n);
  return e.props.definition && (e.props.definition.props = s), e.props.__propDefs = s, e.emit("added-props", n), e;
}
function toPropsObj(e) {
  return Array.isArray(e) ? e.reduce((t, n) => (t[n] = {}, t), {}) : e;
}
function mergeProps(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.concat(t) : extend$1(toPropsObj(e), toPropsObj(t));
}
function addChild(e, t, n, r) {
  if (e.type === "input" && error(100, e), n.parent && n.parent !== e && n.parent.remove(n), !t.children.includes(n)) {
    if (r !== void 0 && e.type === "list") {
      const i = t.children[r];
      i && "__FKP" in i ? (n._c.uid = i.uid, t.children.splice(r, 1, n)) : t.children.splice(r, 0, n), Array.isArray(e.value) && e.value.length < t.children.length && e.disturb().calm({
        name: r,
        value: n.value,
        from: valueInserted
      });
    } else
      t.children.push(n);
    n.isSettled || e.disturb();
  }
  if (n.parent !== e) {
    if (n.parent = e, n.parent !== e)
      return e.remove(n), n.parent.add(n), e;
  } else
    n.use(e.plugins);
  return commit(e, t, !1), e.ledger.merge(n), e.emit("child", n), e;
}
function setParent(e, t, n, r) {
  return isNode$1(r) ? (e.parent && e.parent !== r && e.parent.remove(e), t.parent = r, e.resetConfig(), r.children.includes(e) ? e.use(r.plugins) : r.add(e), !0) : r === null ? (t.parent = null, !0) : !1;
}
function removeChild(e, t, n) {
  const r = t.children.indexOf(n);
  if (r !== -1) {
    n.isSettled && e.disturb(), t.children.splice(r, 1);
    let i = undefine(n.props.preserve), s = n.parent;
    for (; i === void 0 && s; )
      i = undefine(s.props.preserve), s = s.parent;
    i ? e.calm() : e.calm({
      name: e.type === "list" ? r : n.name,
      value: valueRemoved
    }), n.parent = null, n.config._rmn = n;
  }
  return e.ledger.unmerge(n), e.emit("childRemoved", n), e;
}
function eachChild(e, t, n) {
  t.children.forEach((r) => !("__FKP" in r) && n(r));
}
function walkTree(e, t, n, r = !1, i = !1) {
  t.children.some((s) => {
    if ("__FKP" in s)
      return !1;
    const l = n(s);
    return r && l === !1 ? !0 : i && l === !1 ? !1 : s.walk(n, r, i);
  });
}
function resetConfig(e, t) {
  const n = e.parent || void 0;
  t.config = createConfig2(e.config._t, n), e.walk((r) => r.resetConfig());
}
function use(e, t, n, r = !0, i = !0) {
  return Array.isArray(n) || n instanceof Set ? (n.forEach((s) => use(e, t, s)), e) : (t.plugins.has(n) || (i && typeof n.library == "function" && n.library(e), r && n(e) !== !1 && (t.plugins.add(n), e.children.forEach((s) => s.use(n)))), e);
}
function setIndex(e, t, n, r) {
  if (isNode$1(e.parent)) {
    const i = e.parent.children, s = r >= i.length ? i.length - 1 : r < 0 ? 0 : r, l = i.indexOf(e);
    return l === -1 ? !1 : (i.splice(l, 1), i.splice(s, 0, e), e.parent.children = i, e.parent.type === "list" && e.parent.disturb().calm({ name: s, value: valueMoved, from: l }), !0);
  }
  return !1;
}
function getIndex(e) {
  if (e.parent) {
    const t = [...e.parent.children].indexOf(e);
    return t === -1 ? e.parent.children.length : t;
  }
  return -1;
}
function getContext(e, t) {
  return t;
}
function getName(e, t) {
  var n;
  return ((n = e.parent) == null ? void 0 : n.type) === "list" ? e.index : t.name !== useIndex ? t.name : e.index;
}
function getAddress(e, t) {
  return t.parent ? t.parent.address.concat([e.name]) : [e.name];
}
function getNode2(e, t, n) {
  const r = typeof n == "string" ? n.split(e.config.delimiter) : n;
  if (!r.length)
    return;
  const i = r[0];
  let s = e.parent;
  for (s || (String(r[0]) === String(e.name) && r.shift(), s = e), i === "$parent" && r.shift(); s && r.length; ) {
    const l = r.shift();
    switch (l) {
      case "$root":
        s = e.root;
        break;
      case "$parent":
        s = s.parent;
        break;
      case "$self":
        s = e;
        break;
      default:
        s = s.children.find(
          (c) => !("__FKP" in c) && String(c.name) === String(l)
        ) || select$1(s, l);
    }
  }
  return s || void 0;
}
function select$1(e, t) {
  const n = String(t).match(/^(find)\((.*)\)$/);
  if (n) {
    const [, r, i] = n, s = i.split(",").map((l) => l.trim());
    switch (r) {
      case "find":
        return e.find(s[0], s[1]);
      default:
        return;
    }
  }
}
function find(e, t, n, r) {
  return bfs(e, n, r);
}
function bfs(e, t, n = "name") {
  const r = typeof n == "string" ? (s) => s[n] == t : n, i = [e];
  for (; i.length; ) {
    const s = i.shift();
    if (!("__FKP" in s)) {
      if (r(s, t))
        return s;
      i.push(...s.children);
    }
  }
}
function getRoot(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
function createConfig2(e = {}, t) {
  let n;
  return new Proxy(e, {
    get(...r) {
      const i = r[1];
      if (i === "_t")
        return e;
      const s = Reflect.get(...r);
      if (s !== void 0)
        return s;
      if (t) {
        const l = t.config[i];
        if (l !== void 0)
          return l;
      }
      if (e.rootConfig && typeof i == "string") {
        const l = e.rootConfig[i];
        if (l !== void 0)
          return l;
      }
      return i === "delay" && (n == null ? void 0 : n.type) === "input" ? 20 : defaultConfig$1[i];
    },
    set(...r) {
      const i = r[1], s = r[2];
      if (i === "_n")
        return n = s, e.rootConfig && e.rootConfig._add(n), !0;
      if (i === "_rmn")
        return e.rootConfig && e.rootConfig._rm(n), n = void 0, !0;
      if (!eq(e[i], s, !1)) {
        const l = Reflect.set(...r);
        return n && (n.emit(`config:${i}`, s, !1), configChange(n, i, s), n.walk((c) => configChange(c, i, s), !1, !0)), l;
      }
      return !0;
    }
  });
}
function text$1(e, t, n, r = "ui") {
  const i = typeof n == "string" ? { key: n, value: n, type: r } : n, s = e.hook.text.dispatch(i);
  return e.emit("text", s, !1), s.value;
}
function submit(e) {
  const t = e.name;
  do {
    if (e.props.isForm === !0)
      break;
    e.parent || error(106, t), e = e.parent;
  } while (e);
  e.props.id && submitForm(e.props.id, e.props.__root);
}
function resetValue(e, t, n) {
  return reset(e, n);
}
function setErrors(e, t, n, r) {
  const i = `${e.name}-set`, s = e.hook.setErrors.dispatch({ localErrors: n, childErrors: r });
  return createMessages(e, s.localErrors, s.childErrors).forEach(
    (l) => {
      e.store.apply(l, (c) => c.meta.source === i);
    }
  ), e;
}
function clearErrors(e, t, n = !0, r) {
  return e.store.filter((i) => !(r === void 0 || i.meta.source === r), "error"), n && (r = r || `${e.name}-set`, e.walk((i) => {
    i.store.filter((s) => !(s.type === "error" && s.meta && s.meta.source === r));
  })), e;
}
function createProps(e) {
  const t = {
    initial: typeof e == "object" ? cloneAny(e) : e
  };
  let n, r = !0, i = {};
  return new Proxy(t, {
    get(...s) {
      var qu, Gu, Qu, Xu;
      const [l, c] = s;
      let u;
      has(t, c) ? (u = Reflect.get(...s), (qu = i[c]) != null && qu.boolean && (u = boolGetter(u))) : n && typeof c == "string" && n.config[c] !== void 0 ? (u = n.config[c], c === "mergeStrategy" && (n == null ? void 0 : n.type) === "input" && isRecord(u) && n.name in u && (u = u[n.name])) : u = (Gu = i[c]) == null ? void 0 : Gu.default;
      const m = (Qu = i[c]) == null ? void 0 : Qu.getter;
      return (Xu = i[c]) != null && Xu.boolean && (u = !!u), m ? m(u, n) : u;
    },
    set(s, l, c, u) {
      var Qu;
      if (l === "_n")
        return n = c, !0;
      if (l === "_emit")
        return r = c, !0;
      let { prop: m, value: qu } = n.hook.prop.dispatch({
        prop: l,
        value: c
      });
      const Gu = (Qu = i[m]) == null ? void 0 : Qu.setter;
      if (qu = Gu ? Gu(qu, n) : qu, !eq(t[m], qu, !1) || typeof qu == "object") {
        const Xu = Reflect.set(s, m, qu, u);
        return m === "__propDefs" && (i = toPropsObj(qu)), r && (n.emit("prop", { prop: m, value: qu }), typeof m == "string" && n.emit(`prop:${m}`, qu)), Xu;
      }
      return !0;
    }
  });
}
function extend(e, t, n, r) {
  return t.traps.set(n, r), e;
}
function findDefinition(e, t) {
  if (e.props.definition)
    return e.define(e.props.definition);
  for (const n of t) {
    if (e.props.definition)
      return;
    typeof n.library == "function" && n.library(e);
  }
}
function createContext(e) {
  const t = createValue(e), n = createConfig2(e.config || {}, e.parent);
  return {
    _d: 0,
    _e: createEmitter(),
    uid: Symbol(),
    _resolve: !1,
    _tmo: !1,
    _value: t,
    children: dedupe(e.children || []),
    config: n,
    hook: createHooks(),
    isCreated: !1,
    isSettled: !0,
    ledger: createLedger(),
    name: createName(e),
    parent: e.parent || null,
    plugins: /* @__PURE__ */ new Set(),
    props: createProps(t),
    settled: Promise.resolve(t),
    store: createStore(!0),
    sync: e.sync || !1,
    traps: createTraps(),
    type: e.type || "input",
    value: t
  };
}
function nodeInit(e, t) {
  var r, i;
  const n = (r = t.props) == null ? void 0 : r.id;
  if (n || (i = t.props) == null || delete i.id, e.ledger.init(e.store._n = e.props._n = e.config._n = e), e.props._emit = !1, Object.assign(
    e.props,
    n ? {} : { id: `input_${idCount++}` },
    t.props ?? {}
  ), e.props._emit = !0, findDefinition(
    e,
    /* @__PURE__ */ new Set([
      ...t.plugins || [],
      ...e.parent ? e.parent.plugins : []
    ])
  ), t.plugins)
    for (const s of t.plugins)
      use(e, e._c, s, !0, !1);
  return e.each((s) => e.add(s)), e.parent && e.parent.add(e, t.index), e.type === "input" && e.children.length && error(100, e), input(e, e._c, e._value, !1), e.store.release(), n && register$1(e), e.emit("created", e), e.isCreated = !0, e;
}
function createPlaceholder(e) {
  return {
    __FKP: !0,
    uid: Symbol(),
    name: (e == null ? void 0 : e.name) ?? `p_${nameCount++}`,
    value: (e == null ? void 0 : e.value) ?? null,
    _value: (e == null ? void 0 : e.value) ?? null,
    type: (e == null ? void 0 : e.type) ?? "input",
    props: {},
    use: () => {
    },
    input(t) {
      return this._value = t, this.value = t, Promise.resolve();
    },
    isSettled: !0
  };
}
function isPlaceholder(e) {
  return "__FKP" in e;
}
function createNode(e) {
  const t = e || {}, n = createContext(t), r = new Proxy(n, {
    get(...i) {
      const [, s] = i;
      if (s === "__FKNode__")
        return !0;
      const l = n.traps.get(s);
      return l && l.get ? l.get(r, n) : Reflect.get(...i);
    },
    set(...i) {
      const [, s, l] = i, c = n.traps.get(s);
      return c && c.set ? c.set(r, n, s, l) : Reflect.set(...i);
    }
  });
  return nodeInit(r, t);
}
function isDOM(e) {
  return typeof e != "string" && has(e, "$el");
}
function isComponent(e) {
  return typeof e != "string" && has(e, "$cmp");
}
function isConditional(e) {
  return !e || typeof e == "string" ? !1 : has(e, "if") && has(e, "then");
}
function isSugar(e) {
  return typeof e != "string" && "$formkit" in e;
}
function sugar(e) {
  if (typeof e == "string")
    return {
      $el: "text",
      children: e
    };
  if (isSugar(e)) {
    const {
      $formkit: t,
      for: n,
      if: r,
      children: i,
      bind: s,
      ...l
    } = e;
    return Object.assign(
      {
        $cmp: "FormKit",
        props: { ...l, type: t }
      },
      r ? { if: r } : {},
      n ? { for: n } : {},
      i ? { children: i } : {},
      s ? { bind: s } : {}
    );
  }
  return e;
}
function compile(e) {
  let t;
  const n = /* @__PURE__ */ new Set(), r = function(af, rf) {
    return typeof af == "function" ? af(rf) : af;
  }, i = [
    {
      "&&": (tf, af, rf) => r(tf, rf) && r(af, rf),
      "||": (tf, af, rf) => r(tf, rf) || r(af, rf)
    },
    {
      "===": (tf, af, rf) => r(tf, rf) === r(af, rf),
      "!==": (tf, af, rf) => r(tf, rf) !== r(af, rf),
      "==": (tf, af, rf) => r(tf, rf) == r(af, rf),
      "!=": (tf, af, rf) => r(tf, rf) != r(af, rf),
      ">=": (tf, af, rf) => r(tf, rf) >= r(af, rf),
      "<=": (tf, af, rf) => r(tf, rf) <= r(af, rf),
      ">": (tf, af, rf) => r(tf, rf) > r(af, rf),
      "<": (tf, af, rf) => r(tf, rf) < r(af, rf)
    },
    {
      "+": (tf, af, rf) => r(tf, rf) + r(af, rf),
      "-": (tf, af, rf) => r(tf, rf) - r(af, rf)
    },
    {
      "*": (tf, af, rf) => r(tf, rf) * r(af, rf),
      "/": (tf, af, rf) => r(tf, rf) / r(af, rf),
      "%": (tf, af, rf) => r(tf, rf) % r(af, rf)
    }
  ], s = i.reduce((tf, af) => tf.concat(Object.keys(af)), []), l = new Set(s.map((tf) => tf.charAt(0)));
  function c(tf, af, rf, hf) {
    const sf = tf.filter((pf) => pf.startsWith(af));
    return sf.length ? sf.find((pf) => hf.length >= rf + pf.length && hf.substring(rf, rf + pf.length) === pf ? pf : !1) : !1;
  }
  function u(tf, af, rf = 1) {
    let hf = rf ? af.substring(tf + 1).trim() : af.substring(0, tf).trim();
    if (!hf.length)
      return -1;
    if (!rf) {
      const pf = hf.split("").reverse(), $f = pf.findIndex((uf) => l.has(uf));
      hf = pf.slice($f).join("");
    }
    const sf = hf[0];
    return i.findIndex((pf) => {
      const $f = Object.keys(pf);
      return !!c($f, sf, 0, hf);
    });
  }
  function m(tf, af) {
    let rf = "";
    const hf = af.length;
    let sf = 0;
    for (let pf = tf; pf < hf; pf++) {
      const $f = af.charAt(pf);
      if ($f === "(")
        sf++;
      else if ($f === ")")
        sf--;
      else if (sf === 0 && $f === " ")
        continue;
      if (sf === 0 && c(s, $f, pf, af))
        return [rf, pf - 1];
      rf += $f;
    }
    return [rf, af.length - 1];
  }
  function qu(tf, af = 0) {
    const rf = i[af], hf = tf.length, sf = Object.keys(rf);
    let pf = 0, $f = !1, uf = null, vf = "", cf = null, yf, ff = "", gf = "", lf = "", Sf = "", Mf = 0;
    const Uf = (Zf, Rf) => {
      Zf ? lf += Rf : vf += Rf;
    };
    for (let Zf = 0; Zf < hf; Zf++)
      if (ff = gf, gf = tf.charAt(Zf), (gf === "'" || gf === '"') && ff !== "\\" && (pf === 0 && !$f || pf && !Sf)) {
        pf ? Sf = gf : $f = gf, Uf(pf, gf);
        continue;
      } else if ($f && (gf !== $f || ff === "\\") || Sf && (gf !== Sf || ff === "\\")) {
        Uf(pf, gf);
        continue;
      } else if ($f === gf) {
        $f = !1, Uf(pf, gf);
        continue;
      } else if (Sf === gf) {
        Sf = !1, Uf(pf, gf);
        continue;
      } else {
        if (gf === " ")
          continue;
        if (gf === "(")
          pf === 0 ? Mf = Zf : lf += gf, pf++;
        else if (gf === ")")
          if (pf--, pf === 0) {
            const Rf = typeof vf == "string" && vf.startsWith("$") ? vf : void 0, Bf = Rf && tf.charAt(Zf + 1) === ".";
            let ih = "";
            Bf && ([ih, Zf] = m(Zf + 2, tf));
            const lh = uf ? af : u(Mf, tf, 0), Wf = u(Zf, tf);
            lh === -1 && Wf === -1 ? (vf = Gu(lf, -1, Rf, ih), typeof vf == "string" && (vf = lf)) : uf && (lh >= Wf || Wf === -1) && af === lh ? (cf = uf.bind(null, Gu(lf, -1, Rf, ih)), uf = null, vf = "") : Wf > lh && af === Wf ? vf = Gu(lf, -1, Rf, ih) : vf += `(${lf})${Bf ? `.${ih}` : ""}`, lf = "";
          } else
            lf += gf;
        else if (pf === 0 && (yf = c(sf, gf, Zf, tf))) {
          Zf === 0 && error(103, [yf, tf]), Zf += yf.length - 1, Zf === tf.length - 1 && error(104, [yf, tf]), uf ? vf && (cf = uf.bind(null, Gu(vf, af)), uf = rf[yf].bind(null, cf), vf = "") : cf ? (uf = rf[yf].bind(null, Gu(cf, af)), cf = null) : (uf = rf[yf].bind(null, Gu(vf, af)), vf = "");
          continue;
        } else
          Uf(pf, gf);
      }
    return vf && uf && (uf = uf.bind(null, Gu(vf, af))), uf = !uf && cf ? cf : uf, !uf && vf && (uf = (Zf, Rf) => typeof Zf == "function" ? Zf(Rf) : Zf, uf = uf.bind(null, Gu(vf, af))), !uf && !vf && error(105, tf), uf;
  }
  function Gu(tf, af, rf, hf) {
    if (rf) {
      const sf = Gu(rf, i.length);
      let pf, $f = hf ? compile(`$${hf}`) : !1;
      if (typeof sf == "function") {
        const uf = parseArgs(String(tf)).map(
          (vf) => Gu(vf, -1)
        );
        return (vf) => {
          const cf = sf(vf);
          return typeof cf != "function" ? (warn(150, rf), cf) : (pf = cf(
            ...uf.map(
              (yf) => typeof yf == "function" ? yf(vf) : yf
            )
          ), $f && ($f = $f.provide((yf) => {
            const ff = t(yf);
            return yf.reduce(
              (lf, Sf) => {
                if (Sf === hf || (hf == null ? void 0 : hf.startsWith(`${Sf}(`))) {
                  const Uf = getAt(pf, Sf);
                  lf[Sf] = () => Uf;
                } else
                  lf[Sf] = ff[Sf];
                return lf;
              },
              {}
            );
          })), $f ? $f() : pf);
        };
      }
    } else if (typeof tf == "string") {
      if (tf === "true")
        return !0;
      if (tf === "false")
        return !1;
      if (tf === "undefined")
        return;
      if (isQuotedString(tf))
        return rmEscapes(tf.substring(1, tf.length - 1));
      if (!isNaN(+tf))
        return Number(tf);
      if (af < i.length - 1)
        return qu(tf, af + 1);
      if (tf.startsWith("$")) {
        const sf = tf.substring(1);
        return n.add(sf), function($f) {
          return sf in $f ? $f[sf]() : void 0;
        };
      }
      return tf;
    }
    return tf;
  }
  const Qu = qu(
    e.startsWith("$:") ? e.substring(2) : e
  ), Xu = Array.from(n);
  function ef(tf) {
    return t = tf, Object.assign(
      // @ts-ignore - @rollup/plugin-typescript doesn't like this
      Qu.bind(null, tf(Xu)),
      { provide: ef }
    );
  }
  return Object.assign(Qu, {
    provide: ef
  });
}
function createClasses(e, t, n) {
  return n ? typeof n == "string" ? n.split(" ").reduce(
    (i, s) => Object.assign(i, { [s]: !0 }),
    {}
  ) : typeof n == "function" ? createClasses(
    e,
    t,
    n(t, e)
  ) : n : {};
}
function generateClassList(e, t, ...n) {
  const r = n.reduce((i, s) => {
    if (!s)
      return handleNegativeClasses(i);
    const { $reset: l, ...c } = s;
    return handleNegativeClasses(l ? c : Object.assign(i, c));
  }, {});
  return Object.keys(
    e.hook.classes.dispatch({ property: t, classes: r }).classes
  ).filter((i) => r[i]).join(" ") || null;
}
function handleNegativeClasses(e) {
  const t = "$remove:";
  let n = !1;
  const r = Object.keys(e).filter((i) => (e[i] && i.startsWith(t) && (n = !0), e[i]));
  return r.length > 1 && n && r.filter((s) => s.startsWith(t)).map((s) => {
    const l = s.substring(t.length);
    e[l] = !1, e[s] = !1;
  }), e;
}
function setErrors2(e, t, n) {
  const r = getNode(e);
  r ? r.setErrors(t, n) : warn(651, e);
}
function clearErrors2(e, t = !0) {
  const n = getNode(e);
  n ? n.clearErrors(t) : warn(652, e);
}
var FORMKIT_VERSION = "1.6.7", revokedObservers = /* @__PURE__ */ new WeakSet();
function createObserver(e, t) {
  const n = t || Object.assign(/* @__PURE__ */ new Map(), { active: !1 }), r = /* @__PURE__ */ new Map(), i = function(qu) {
    var Gu;
    n.active && (n.has(e) || n.set(e, /* @__PURE__ */ new Set()), (Gu = n.get(e)) == null || Gu.add(qu));
  }, s = function(qu) {
    return new Proxy(qu, {
      get(...Gu) {
        return typeof Gu[1] == "string" && i(`prop:${Gu[1]}`), Reflect.get(...Gu);
      }
    });
  }, l = function(qu) {
    return new Proxy(qu, {
      get(...Gu) {
        return Gu[1] === "value" ? (Qu) => (i(`count:${Qu}`), qu.value(Qu)) : Reflect.get(...Gu);
      }
    });
  }, c = function(qu, Gu) {
    return isNode$1(qu) ? createObserver(qu, n) : (Gu === "value" && i("commit"), Gu === "_value" && i("input"), Gu === "props" ? s(qu) : Gu === "ledger" ? l(qu) : (Gu === "children" && (i("child"), i("childRemoved")), qu));
  }, {
    proxy: u,
    revoke: m
  } = Proxy.revocable(e, {
    get(...qu) {
      switch (qu[1]) {
        case "_node":
          return e;
        case "deps":
          return n;
        case "watch":
          return (Qu, Xu, ef) => watch(u, Qu, Xu, ef);
        case "observe":
          return () => {
            const Qu = new Map(n);
            return n.clear(), n.active = !0, Qu;
          };
        case "stopObserve":
          return () => {
            const Qu = new Map(n);
            return n.active = !1, Qu;
          };
        case "receipts":
          return r;
        case "kill":
          return () => {
            removeListeners(r), revokedObservers.add(qu[2]), m();
          };
      }
      const Gu = Reflect.get(...qu);
      return typeof Gu == "function" ? (...Qu) => {
        const Xu = Gu(...Qu);
        return c(Xu, qu[1]);
      } : c(Gu, qu[1]);
    }
  });
  return u;
}
function applyListeners(e, [t, n], r, i) {
  t.forEach((s, l) => {
    s.forEach((c) => {
      e.receipts.has(l) || e.receipts.set(l, {});
      const u = e.receipts.get(l) ?? {};
      u[c] = u[c] ?? [], u[c].push(l.on(c, r, i)), e.receipts.set(l, u);
    });
  }), n.forEach((s, l) => {
    s.forEach((c) => {
      if (e.receipts.has(l)) {
        const u = e.receipts.get(l);
        u && has(u, c) && (u[c].map(l.off), delete u[c], e.receipts.set(l, u));
      }
    });
  });
}
function removeListeners(e) {
  e.forEach((t, n) => {
    for (const r in t)
      t[r].map(n.off);
  }), e.clear();
}
function watch(e, t, n, r) {
  const i = (c) => {
    const u = e.stopObserve();
    applyListeners(
      e,
      diffDeps(s, u),
      () => watch(e, t, n, r),
      r
    ), n && n(c);
  }, s = new Map(e.deps);
  e.observe();
  const l = t(e);
  l instanceof Promise ? l.then((c) => i(c)) : i(l);
}
function diffDeps(e, t) {
  const n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return t.forEach((i, s) => {
    if (!e.has(s))
      n.set(s, i);
    else {
      const l = /* @__PURE__ */ new Set(), c = e.get(s);
      i.forEach(
        (u) => !(c != null && c.has(u)) && l.add(u)
      ), n.set(s, l);
    }
  }), e.forEach((i, s) => {
    if (!t.has(s))
      r.set(s, i);
    else {
      const l = /* @__PURE__ */ new Set(), c = t.get(s);
      i.forEach(
        (u) => !(c != null && c.has(u)) && l.add(u)
      ), r.set(s, l);
    }
  }), [n, r];
}
function isKilled(e) {
  return revokedObservers.has(e);
}
var validatingMessage = /* @__PURE__ */ createMessage({
  type: "state",
  blocking: !0,
  visible: !1,
  value: !0,
  key: "validating"
});
function createValidationPlugin(e = {}) {
  return function(n) {
    let r = cloneAny(n.props.validationRules || {}), i = { ...e, ...r };
    const s = { input: token(), rerun: null, isPassing: !0 };
    let l = cloneAny(n.props.validation);
    n.on("prop:validation", ({ payload: u }) => c(u, r)), n.on(
      "prop:validationRules",
      ({ payload: u }) => c(l, u)
    );
    function c(u, m) {
      var qu;
      eq(Object.keys(r || {}), Object.keys(m || {})) && eq(l, u) || (r = cloneAny(m), l = cloneAny(u), i = { ...e, ...r }, (qu = n.props.parsedRules) == null || qu.forEach((Gu) => {
        removeMessage(Gu), removeListeners(Gu.observer.receipts), Gu.observer.kill();
      }), n.store.filter(() => !1, "validation"), n.props.parsedRules = parseRules(u, i, n), s.isPassing = !0, validate$1(n, n.props.parsedRules, s));
    }
    n.props.parsedRules = parseRules(l, i, n), validate$1(n, n.props.parsedRules, s);
  };
}
function validate$1(e, t, n) {
  isKilled(e) || (n.input = token(), e.store.set(
    /* @__PURE__ */ createMessage({
      key: "failing",
      value: !n.isPassing,
      visible: !1
    })
  ), n.isPassing = !0, e.store.filter((r) => !r.meta.removeImmediately, "validation"), t.forEach(
    (r) => r.debounce && clearTimeout(r.timer)
  ), t.length && (e.store.set(validatingMessage), run(0, t, n, !1, () => {
    e.store.remove(validatingMessage.key), e.store.set(
      /* @__PURE__ */ createMessage({
        key: "failing",
        value: !n.isPassing,
        visible: !1
      })
    );
  })));
}
function run(e, t, n, r, i) {
  const s = t[e];
  if (!s)
    return i();
  const l = s.observer;
  if (isKilled(l))
    return;
  const c = n.input;
  s.state = null;
  function u(m, qu) {
    if (n.input !== c)
      return;
    n.isPassing = n.isPassing && !!qu, s.queued = !1;
    const Gu = l.stopObserve(), Qu = diffDeps(s.deps, Gu);
    if (applyListeners(
      l,
      Qu,
      function() {
        try {
          l.store.set(validatingMessage);
        } catch {
        }
        s.queued = !0, n.rerun && clearTimeout(n.rerun), n.rerun = setTimeout(
          validate$1,
          0,
          l,
          t,
          n
        );
      },
      "unshift"
      // We want these listeners to run before other events are emitted so the 'state.validating' will be reliable.
    ), s.deps = Gu, s.state = qu, qu === !1 ? createFailedMessage(s, r || m) : removeMessage(s), t.length > e + 1) {
      const Xu = t[e + 1];
      (qu || Xu.force || !Xu.skipEmpty) && Xu.state === null && (Xu.queued = !0), run(e + 1, t, n, r || m, i);
    } else
      i();
  }
  (!empty(l.value) || !s.skipEmpty) && (n.isPassing || s.force) ? s.queued ? runRule(s, l, (m) => {
    m instanceof Promise ? m.then((qu) => u(!0, qu)) : u(!1, m);
  }) : run(e + 1, t, n, r, i) : empty(l.value) && s.skipEmpty && n.isPassing ? (l.observe(), l.value, u(!1, n.isPassing)) : u(!1, null);
}
function runRule(e, t, n) {
  e.debounce ? e.timer = setTimeout(() => {
    t.observe(), n(e.rule(t, ...e.args));
  }, e.debounce) : (t.observe(), n(e.rule(t, ...e.args)));
}
function removeMessage(e) {
  const t = `rule_${e.name}`;
  e.messageObserver && (e.messageObserver = e.messageObserver.kill()), has(e.observer.store, t) && e.observer.store.remove(t);
}
function createFailedMessage(e, t) {
  const n = e.observer;
  isKilled(n) || (e.messageObserver || (e.messageObserver = createObserver(n._node)), e.messageObserver.watch(
    (r) => createI18nArgs(
      r,
      e
    ),
    (r) => {
      const i = createCustomMessage(n, e, r), s = /* @__PURE__ */ createMessage({
        blocking: e.blocking,
        key: `rule_${e.name}`,
        meta: {
          /**
           * Use this key instead of the message root key to produce i18n validation
           * messages.
           */
          messageKey: e.name,
          /**
           * For messages that were created *by or after* a debounced or async
           * validation rule — we make note of it so we can immediately remove them
           * as soon as the next commit happens.
           */
          removeImmediately: t,
          /**
           * Determines if this message should be passed to localization.
           */
          localize: !i,
          /**
           * The arguments that will be passed to the validation rules
           */
          i18nArgs: r
        },
        type: "validation",
        value: i || "This field is not valid."
      });
      n.store.set(s);
    }
  ));
}
function createCustomMessage(e, t, n) {
  const r = e.props.validationMessages && has(e.props.validationMessages, t.name) ? e.props.validationMessages[t.name] : void 0;
  return typeof r == "function" ? r(...n) : r;
}
function createI18nArgs(e, t) {
  return [
    {
      node: e,
      name: createMessageName(e),
      args: t.args
    }
  ];
}
function createMessageName(e) {
  return typeof e.props.validationLabel == "function" ? e.props.validationLabel(e) : e.props.validationLabel || e.props.label || e.props.name || String(e.name);
}
var hintPattern = "(?:[\\*+?()0-9]+)", rulePattern = "[a-zA-Z][a-zA-Z0-9_]+", ruleExtractor = new RegExp(
  `^(${hintPattern}?${rulePattern})(?:\\:(.*)+)?$`,
  "i"
), hintExtractor = new RegExp(`^(${hintPattern})(${rulePattern})$`, "i"), debounceExtractor = /([\*+?]+)?(\(\d+\))([\*+?]+)?/, hasDebounce = /\(\d+\)/, defaultHints = {
  blocking: !0,
  debounce: 0,
  force: !1,
  skipEmpty: !0,
  name: ""
};
function parseRules(e, t, n) {
  return e ? (typeof e == "string" ? extractRules(e) : clone(e)).reduce((i, s) => {
    let l = s.shift();
    const c = {};
    if (typeof l == "string") {
      const [u, m] = parseHints(l);
      has(t, u) && (l = t[u], Object.assign(c, m));
    }
    return typeof l == "function" && i.push({
      observer: createObserver(n),
      rule: l,
      args: s,
      timer: 0,
      state: null,
      queued: !0,
      deps: /* @__PURE__ */ new Map(),
      ...defaultHints,
      ...fnHints(c, l)
    }), i;
  }, []) : [];
}
function extractRules(e) {
  return e.split("|").reduce((t, n) => {
    const r = parseRule(n);
    return r && t.push(r), t;
  }, []);
}
function parseRule(e) {
  const t = e.trim();
  if (t) {
    const n = t.match(ruleExtractor);
    if (n && typeof n[1] == "string") {
      const r = n[1].trim(), i = n[2] && typeof n[2] == "string" ? n[2].split(",").map((s) => s.trim()) : [];
      return [r, ...i];
    }
  }
  return !1;
}
function parseHints(e) {
  const t = e.match(hintExtractor);
  if (!t)
    return [e, { name: e }];
  const n = {
    "*": { force: !0 },
    "+": { skipEmpty: !1 },
    "?": { blocking: !1 }
  }, [, r, i] = t, s = hasDebounce.test(r) ? r.match(debounceExtractor) || [] : [, r];
  return [
    i,
    [s[1], s[2], s[3]].reduce(
      (l, c) => (c && (hasDebounce.test(c) ? l.debounce = parseInt(c.substr(1, c.length - 1)) : c.split("").forEach(
        (u) => has(n, u) && Object.assign(l, n[u])
      )), l),
      { name: i }
    )
  ];
}
function fnHints(e, t) {
  return e.name || (e.name = t.ruleName || t.name), ["skipEmpty", "force", "debounce", "blocking"].reduce(
    (n, r) => (has(t, r) && !has(n, r) && Object.assign(n, {
      [r]: t[r]
    }), n),
    e
  );
}
function sentence(e) {
  return e[0].toUpperCase() + e.substr(1);
}
function list$1(e, t = "or") {
  return e.reduce((n, r, i) => (n += r, i <= e.length - 2 && e.length > 2 && (n += ", "), i === e.length - 2 && (n += `${e.length === 2 ? " " : ""}${t} `), n), "");
}
function date$1(e) {
  const t = typeof e == "string" ? new Date(Date.parse(e)) : e;
  return t instanceof Date ? new Intl.DateTimeFormat(void 0, {
    dateStyle: "medium",
    timeZone: "UTC"
  }).format(t) : "(unknown)";
}
function order(e, t) {
  return Number(e) >= Number(t) ? [t, e] : [e, t];
}
var ui10 = {
  /**
   * Shown on a button for adding additional items.
   */
  add: "Add",
  /**
   * Shown when a button to remove items is visible.
   */
  remove: "Remove",
  /**
   * Shown when there are multiple items to remove at the same time.
   */
  removeAll: "Remove all",
  /**
   * Shown when all fields are not filled out correctly.
   */
  incomplete: "Sorry, not all fields are filled out correctly.",
  /**
   * Shown in a button inside a form to submit the form.
   */
  submit: "Submit",
  /**
   * Shown when no files are selected.
   */
  noFiles: "No file chosen",
  /**
   * Shown on buttons that move fields up in a list.
   */
  moveUp: "Move up",
  /**
   * Shown on buttons that move fields down in a list.
   */
  moveDown: "Move down",
  /**
   * Shown when something is actively loading.
   */
  isLoading: "Loading...",
  /**
   * Shown when there is more to load.
   */
  loadMore: "Load more",
  /**
   * Show on buttons that navigate state forward
   */
  next: "Next",
  /**
   * Show on buttons that navigate state backward
   */
  prev: "Previous",
  /**
   * Shown when adding all values.
   */
  addAllValues: "Add all values",
  /**
   * Shown when adding selected values.
   */
  addSelectedValues: "Add selected values",
  /**
   * Shown when removing all values.
   */
  removeAllValues: "Remove all values",
  /**
   * Shown when removing selected values.
   */
  removeSelectedValues: "Remove selected values",
  /**
   * Shown when there is a date to choose.
   */
  chooseDate: "Choose date",
  /**
   * Shown when there is a date to change.
   */
  changeDate: "Change date",
  /**
   * Shown above error summaries when someone attempts to submit a form with
   * errors and the developer has implemented `<FormKitSummary />`.
   */
  summaryHeader: "There were errors in your form.",
  /*
   * Shown when there is something to close
   */
  close: "Close",
  /**
   * Shown when there is something to open.
   */
  open: "Open"
}, validation10 = {
  /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */
  accepted({ name: e }) {
    return `Please accept the ${e}.`;
  },
  /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */
  date_after({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${sentence(e)} must be after ${date$1(t[0])}.` : `${sentence(e)} must be in the future.`;
  },
  /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */
  alpha({ name: e }) {
    return `${sentence(e)} can only contain alphabetical characters.`;
  },
  /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */
  alphanumeric({ name: e }) {
    return `${sentence(e)} can only contain letters and numbers.`;
  },
  /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */
  alpha_spaces({ name: e }) {
    return `${sentence(e)} can only contain letters and spaces.`;
  },
  /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */
  contains_alpha({ name: e }) {
    return `${sentence(e)} must contain alphabetical characters.`;
  },
  /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */
  contains_alphanumeric({ name: e }) {
    return `${sentence(e)} must contain letters or numbers.`;
  },
  /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */
  contains_alpha_spaces({ name: e }) {
    return `${sentence(e)} must contain letters or spaces.`;
  },
  /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */
  contains_symbol({ name: e }) {
    return `${sentence(e)} must contain a symbol.`;
  },
  /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */
  contains_uppercase({ name: e }) {
    return `${sentence(e)} must contain an uppercase letter.`;
  },
  /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */
  contains_lowercase({ name: e }) {
    return `${sentence(e)} must contain a lowercase letter.`;
  },
  /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */
  contains_numeric({ name: e }) {
    return `${sentence(e)} must contain numbers.`;
  },
  /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */
  symbol({ name: e }) {
    return `${sentence(e)} must be a symbol.`;
  },
  /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */
  uppercase({ name: e }) {
    return `${sentence(e)} can only contain uppercase letters.`;
  },
  /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */
  lowercase({ name: e, args: t }) {
    let n = "";
    return Array.isArray(t) && t.length && (t[0] === "allow_non_alpha" && (n = ", numbers and symbols"), t[0] === "allow_numeric" && (n = " and numbers"), t[0] === "allow_numeric_dashes" && (n = ", numbers and dashes")), `${sentence(e)} can only contain lowercase letters${n}.`;
  },
  /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */
  date_before({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${sentence(e)} must be before ${date$1(t[0])}.` : `${sentence(e)} must be in the past.`;
  },
  /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */
  between({ name: e, args: t }) {
    if (isNaN(t[0]) || isNaN(t[1]))
      return "This field was configured incorrectly and can’t be submitted.";
    const [n, r] = order(t[0], t[1]);
    return `${sentence(e)} must be between ${n} and ${r}.`;
  },
  /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */
  confirm({ name: e }) {
    return `${sentence(e)} does not match.`;
  },
  /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */
  date_format({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${sentence(e)} is not a valid date, please use the format ${t[0]}` : "This field was configured incorrectly and can’t be submitted";
  },
  /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */
  date_between({ name: e, args: t }) {
    return `${sentence(e)} must be between ${date$1(t[0])} and ${date$1(t[1])}`;
  },
  /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */
  email: "Please enter a valid email address.",
  /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */
  ends_with({ name: e, args: t }) {
    return `${sentence(e)} doesn’t end with ${list$1(t)}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */
  is({ name: e }) {
    return `${sentence(e)} is not an allowed value.`;
  },
  /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */
  length({ name: e, args: [t = 0, n = 1 / 0] }) {
    const r = Number(t) <= Number(n) ? t : n, i = Number(n) >= Number(t) ? n : t;
    return r == 1 && i === 1 / 0 ? `${sentence(e)} must be at least one character.` : r == 0 && i ? `${sentence(e)} must be less than or equal to ${i} characters.` : r === i ? `${sentence(e)} should be ${i} characters long.` : r && i === 1 / 0 ? `${sentence(e)} must be greater than or equal to ${r} characters.` : `${sentence(e)} must be between ${r} and ${i} characters.`;
  },
  /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */
  matches({ name: e }) {
    return `${sentence(e)} is not an allowed value.`;
  },
  /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */
  max({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Cannot have more than ${n[0]} ${e}.` : `${sentence(e)} must be no more than ${n[0]}.`;
  },
  /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */
  mime({ name: e, args: t }) {
    return t[0] ? `${sentence(e)} must be of the type: ${t[0]}` : "No file formats allowed.";
  },
  /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */
  min({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Cannot have fewer than ${n[0]} ${e}.` : `${sentence(e)} must be at least ${n[0]}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */
  not({ name: e, node: { value: t } }) {
    return `“${t}” is not an allowed ${e}.`;
  },
  /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */
  number({ name: e }) {
    return `${sentence(e)} must be a number.`;
  },
  /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */
  require_one: ({ name: e, node: t, args: n }) => {
    const r = n.map((i) => {
      const s = t.at(i);
      return s ? createMessageName(s) : !1;
    }).filter((i) => !!i);
    return r.unshift(e), `${r.join(" or ")} is required.`;
  },
  /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */
  required({ name: e }) {
    return `${sentence(e)} is required.`;
  },
  /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */
  starts_with({ name: e, args: t }) {
    return `${sentence(e)} doesn’t start with ${list$1(t)}.`;
  },
  /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */
  url() {
    return "Please enter a valid URL.";
  },
  /**
   * Shown when the date is invalid.
   */
  invalidDate: "The selected date is invalid."
}, en$1 = { ui: ui10, validation: validation10 }, ui21 = {
  /**
   * Shown on buttons for adding new items.
   */
  add: "Inserisci",
  /**
   * Shown when a button to remove items is visible.
   */
  remove: "Rimuovi",
  /**
   * Shown when there are multiple items to remove at the same time.
   */
  removeAll: "Rimuovi tutti",
  /**
   * Shown when all fields are not filled out correctly.
   */
  incomplete: "Ci dispiace, non tutti i campi sono compilati correttamente.",
  /**
   * Shown in a button inside a form to submit the form.
   */
  submit: "Invia",
  /**
   * Shown when no files are selected.
   */
  noFiles: "Nessun file selezionato",
  /**
   * Shown on buttons that move fields up in a list.
   */
  moveUp: "Sposta in alto",
  /**
   * Shown on buttons that move fields down in a list.
   */
  moveDown: "Sposta giù",
  /**
   * Shown when something is actively loading.
   */
  isLoading: "Caricamento...",
  /**
   * Shown when there is more to load.
   */
  loadMore: "Carica altro",
  /**
   * Shown on buttons that navigate state forward
   */
  next: "Prossimo",
  /**
   * Shown on buttons that navigate state backward
   */
  prev: "Precedente",
  /**
   * Shown when adding all values.
   */
  addAllValues: "Aggiungi tutti i valori",
  /**
   * Shown when adding selected values.
   */
  addSelectedValues: "Aggiungi valori selezionati",
  /**
   * Shown when removing all values.
   */
  removeAllValues: "Rimuovi tutti i valori",
  /**
   * Shown when removing selected values.
   */
  removeSelectedValues: "Rimuovi i valori selezionati",
  /**
   * Shown when there is a date to choose.
   */
  chooseDate: "Scegli la data",
  /**
   * Shown when there is a date to change.
   */
  changeDate: "Cambia data",
  /**
   * Shown when there is something to close
   */
  close: "Chiudi",
  /**
   * Shown when there is something to open.
   */
  open: "Aperta"
}, validation21 = {
  /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */
  accepted({ name: e }) {
    return `Si prega di accettare ${e}.`;
  },
  /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */
  date_after({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `la data ${sentence(e)} deve essere successiva ${date$1(t[0])}.` : `la data ${sentence(e)} deve essere nel futuro.`;
  },
  /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */
  alpha({ name: e }) {
    return `${sentence(e)} può contenere solo caratteri alfanumerici.`;
  },
  /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */
  alphanumeric({ name: e }) {
    return `${sentence(e)} può contenere solo lettere e numeri.`;
  },
  /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */
  alpha_spaces({ name: e }) {
    return `${sentence(e)} può contenere solo lettere e spazi.`;
  },
  /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */
  contains_alpha({ name: e }) {
    return `${sentence(e)} deve contenere caratteri alfabetici.`;
  },
  /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */
  contains_alphanumeric({ name: e }) {
    return `${sentence(e)} deve contenere lettere o numeri.`;
  },
  /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */
  contains_alpha_spaces({ name: e }) {
    return `${sentence(e)} deve contenere lettere o spazi.`;
  },
  /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */
  contains_symbol({ name: e }) {
    return `${sentence(e)} deve contenere un simbolo.`;
  },
  /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */
  contains_uppercase({ name: e }) {
    return `${sentence(e)} must contain uppercase.`;
  },
  /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */
  contains_lowercase({ name: e }) {
    return `${sentence(e)} deve contenere lettere minuscole.`;
  },
  /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */
  contains_numeric({ name: e }) {
    return `${sentence(e)} deve contenere numeri.`;
  },
  /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */
  symbol({ name: e }) {
    return `${sentence(e)} deve essere un simbolo.`;
  },
  /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */
  uppercase({ name: e }) {
    return `${sentence(e)} può contenere solo lettere maiuscole.`;
  },
  /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */
  lowercase({ name: e }) {
    return `${sentence(e)} può contenere solo lettere minuscole.`;
  },
  /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */
  date_before({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `la data ${sentence(e)} deve essere antecedente ${date$1(t[0])}.` : `${sentence(e)} deve essere nel passato.`;
  },
  /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */
  between({ name: e, args: t }) {
    if (isNaN(t[0]) || isNaN(t[1]))
      return "Questo campo è stato configurato male e non può essere inviato.";
    const [n, r] = order(t[0], t[1]);
    return `${sentence(e)} deve essere tra ${n} e ${r}.`;
  },
  /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */
  confirm({ name: e }) {
    return `${sentence(e)} non corrisponde.`;
  },
  /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */
  date_format({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${sentence(e)} non è una data valida, per favore usa il formato ${t[0]}` : "Questo campo è stato configurato in modo errato e non può essere inviato.";
  },
  /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */
  date_between({ name: e, args: t }) {
    return `${sentence(e)} deve essere tra ${date$1(t[0])} e ${date$1(t[1])}`;
  },
  /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */
  email: "Per favore inserire un indirizzo email valido.",
  /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */
  ends_with({ name: e, args: t }) {
    return `${sentence(e)} non termina con ${list$1(t)}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */
  is({ name: e }) {
    return `${sentence(e)} non è un valore consentito.`;
  },
  /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */
  length({ name: e, args: [t = 0, n = 1 / 0] }) {
    const r = Number(t) <= Number(n) ? t : n, i = Number(n) >= Number(t) ? n : t;
    return r == 1 && i === 1 / 0 ? `${sentence(e)} deve contenere almeno un carattere.` : r == 0 && i ? `${sentence(e)} deve essere minore o uguale a ${i} caratteri.` : r === i ? `${sentence(e)} deve contenere ${i} caratteri.` : r && i === 1 / 0 ? `${sentence(e)} deve essere maggiore o uguale a ${r} caratteri.` : `${sentence(e)} deve essere tra ${r} e ${i} caratteri.`;
  },
  /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */
  matches({ name: e }) {
    return `${sentence(e)} non è un valore consentito.`;
  },
  /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */
  max({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Non può avere più di ${n[0]} ${e}.` : `${sentence(e)} deve essere minore o uguale a ${n[0]}.`;
  },
  /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */
  mime({ name: e, args: t }) {
    return t[0] ? `${sentence(e)} deve essere di tipo: ${t[0]}` : "Formato file non consentito.";
  },
  /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */
  min({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Non può avere meno di ${n[0]} ${e}.` : `${sentence(e)} deve essere almeno ${n[0]}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */
  not({ name: e, node: { value: t } }) {
    return `"${t}" non è un ${e} consentito.`;
  },
  /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */
  number({ name: e }) {
    return `${sentence(e)} deve essere un numero.`;
  },
  /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */
  require_one: ({ name: e, node: t, args: n }) => {
    const r = n.map((i) => {
      const s = t.at(i);
      return s ? createMessageName(s) : !1;
    }).filter((i) => !!i);
    return r.unshift(e), `${r.join(" o ")} è richiesto.`;
  },
  /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */
  required({ name: e }) {
    return `${sentence(e)} è richiesto.`;
  },
  /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */
  starts_with({ name: e, args: t }) {
    return `${sentence(e)} non inizia con ${list$1(t)}.`;
  },
  /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */
  url() {
    return "Inserisci un URL valido.";
  },
  /**
   * Shown when the date is invalid.
   */
  invalidDate: "La data selezionata non è valida."
}, it$2 = { ui: ui21, validation: validation21 }, i18nNodes = /* @__PURE__ */ new Set();
function createI18nPlugin(e) {
  return function(n) {
    i18nNodes.add(n), n.on("destroying", () => i18nNodes.delete(n));
    let r = parseLocale(n.config.locale, e), i = r ? e[r] : {};
    n.on("prop:locale", ({ payload: s }) => {
      r = parseLocale(s, e), i = r ? e[r] : {}, n.store.touch();
    }), n.on("prop:label", () => n.store.touch()), n.on("prop:validationLabel", () => n.store.touch()), n.hook.text((s, l) => {
      var u, m;
      const c = ((u = s.meta) == null ? void 0 : u.messageKey) || s.key;
      if (has(i, s.type) && has(i[s.type], c)) {
        const qu = i[s.type][c];
        typeof qu == "function" ? s.value = Array.isArray((m = s.meta) == null ? void 0 : m.i18nArgs) ? qu(...s.meta.i18nArgs) : qu(s) : s.value = qu;
      }
      return l(s);
    });
  };
}
function parseLocale(e, t) {
  if (has(t, e))
    return e;
  const [n] = e.split("-");
  if (has(t, n))
    return n;
  for (const r in t)
    return r;
  return !1;
}
var accepted = function({ value: t }) {
  return ["yes", "on", "1", 1, !0, "true"].includes(t);
};
accepted.skipEmpty = !1;
var accepted_default = accepted, date_after = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), r = Date.parse(String(e));
  return isNaN(r) ? !1 : r > n;
}, date_after_default = date_after, date_after_or_equal = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), r = Date.parse(String(e));
  return isNaN(r) ? !1 : r > n || r === n;
}, date_after_or_equal_default = date_after_or_equal, date_after_node = function(e, t) {
  var i;
  if (!t)
    return !1;
  const n = Date.parse(String(e.value)), r = Date.parse(String((i = e.at(t)) == null ? void 0 : i.value));
  return isNaN(r) ? !0 : isNaN(n) ? !1 : n > r;
}, date_after_node_default = date_after_node, alpha = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{L}+$", "u"),
    latin: /^[a-z]+$/i
  }, r = has(n, t) ? t : "default";
  return n[r].test(String(e));
}, alpha_default = alpha, alpha_spaces = function({ value: e }, t = "default") {
  const n = {
    default: /^[\p{L} ]+$/u,
    latin: /^[a-z ]+$/i
  }, r = has(n, t) ? t : "default";
  return n[r].test(String(e));
}, alpha_spaces_default = alpha_spaces, alphanumeric = function({ value: e }, t = "default") {
  const n = {
    default: /^[0-9\p{L}]+$/u,
    latin: /^[0-9a-z]+$/i
  }, r = has(n, t) ? t : "default";
  return n[r].test(String(e));
}, alphanumeric_default = alphanumeric, date_before = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), r = Date.parse(String(e));
  return isNaN(r) ? !1 : r < n;
}, date_before_default = date_before, date_before_node = function(e, t) {
  var i;
  if (!t)
    return !1;
  const n = Date.parse(String(e.value)), r = Date.parse(String((i = e.at(t)) == null ? void 0 : i.value));
  return isNaN(r) ? !0 : isNaN(n) ? !1 : n < r;
}, date_before_node_default = date_before_node, date_before_or_equal = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), r = Date.parse(String(e));
  return isNaN(r) ? !1 : r < n || r === n;
}, date_before_or_equal_default = date_before_or_equal, between = function({ value: t }, n, r) {
  if (!isNaN(t) && !isNaN(n) && !isNaN(r)) {
    const i = 1 * t;
    n = Number(n), r = Number(r);
    const [s, l] = n <= r ? [n, r] : [r, n];
    return i >= 1 * s && i <= 1 * l;
  }
  return !1;
}, between_default = between, hasConfirm = /(_confirm(?:ed)?)$/, confirm = function(t, n, r = "loose") {
  var s;
  n || (n = hasConfirm.test(t.name) ? t.name.replace(hasConfirm, "") : `${t.name}_confirm`);
  const i = (s = t.at(n)) == null ? void 0 : s.value;
  return r === "strict" ? t.value === i : t.value == i;
}, confirm_default = confirm, contains_alpha = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{L}", "u"),
    latin: /[a-z]/i
  }, r = has(n, t) ? t : "default";
  return n[r].test(String(e));
}, contains_alpha_default = contains_alpha, contains_alpha_spaces = function({ value: e }, t = "default") {
  const n = {
    default: /[\p{L} ]/u,
    latin: /[a-z ]/i
  }, r = has(n, t) ? t : "default";
  return n[r].test(String(e));
}, contains_alpha_spaces_default = contains_alpha_spaces, contains_alphanumeric = function({ value: e }, t = "default") {
  const n = {
    default: /[0-9\p{L}]/u,
    latin: /[0-9a-z]/i
  }, r = has(n, t) ? t : "default";
  return n[r].test(String(e));
}, contains_alphanumeric_default = contains_alphanumeric, contains_lowercase = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{Ll}", "u"),
    latin: /[a-z]/
  }, r = has(n, t) ? t : "default";
  return n[r].test(String(e));
}, contains_lowercase_default = contains_lowercase, contains_numeric = function({ value: t }) {
  return /[0-9]/.test(String(t));
}, contains_numeric_default = contains_numeric, contains_symbol = function({ value: e }) {
  return /[!-/:-@[-`{-~]/.test(String(e));
}, contains_symbol_default = contains_symbol, contains_uppercase = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{Lu}", "u"),
    latin: /[A-Z]/
  }, r = has(n, t) ? t : "default";
  return n[r].test(String(e));
}, contains_uppercase_default = contains_uppercase, date_between = function({ value: t }, n, r) {
  n = n instanceof Date ? n.getTime() : Date.parse(n), r = r instanceof Date ? r.getTime() : Date.parse(r);
  const i = t instanceof Date ? t.getTime() : Date.parse(String(t));
  if (n && !r)
    r = n, n = Date.now();
  else if (!n || !i)
    return !1;
  return i >= n && i <= r;
}, date_between_default = date_between, date_format = function({ value: t }, n) {
  return n && typeof n == "string" ? regexForFormat(n).test(String(t)) : !isNaN(Date.parse(String(t)));
}, date_format_default = date_format, email = function({ value: t }) {
  return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(String(t));
}, email_default = email, ends_with = function({ value: t }, ...n) {
  return typeof t == "string" && n.length ? n.some((r) => t.endsWith(r)) : typeof t == "string" && n.length === 0;
}, ends_with_default = ends_with, is$1 = function({ value: t }, ...n) {
  return n.some((r) => typeof r == "object" ? eq(r, t) : r == t);
}, is_default = is$1, length = function({ value: t }, n = 0, r = 1 / 0) {
  n = parseInt(n), r = isNaN(parseInt(r)) ? 1 / 0 : parseInt(r);
  const i = n <= r ? n : r, s = r >= n ? r : n;
  if (typeof t == "string" || Array.isArray(t))
    return t.length >= i && t.length <= s;
  if (t && typeof t == "object") {
    const l = Object.keys(t).length;
    return l >= i && l <= s;
  }
  return !1;
}, length_default = length, lowercase = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{Ll}+$", "u"),
    allow_non_alpha: /^[0-9\p{Ll}!-/:-@[-`{-~]+$/u,
    allow_numeric: /^[0-9\p{Ll}]+$/u,
    allow_numeric_dashes: /^[0-9\p{Ll}-]+$/u,
    latin: /^[a-z]+$/
  }, r = has(n, t) ? t : "default";
  return n[r].test(String(e));
}, lowercase_default = lowercase, matches = function({ value: t }, ...n) {
  return n.some((r) => (typeof r == "string" && r.substr(0, 1) === "/" && r.substr(-1) === "/" && (r = new RegExp(r.substr(1, r.length - 2))), r instanceof RegExp ? r.test(String(t)) : r === t));
}, matches_default = matches, max = function({ value: t }, n = 10) {
  return Array.isArray(t) ? t.length <= n : Number(t) <= Number(n);
}, max_default = max, min = function({ value: t }, n = 1) {
  return Array.isArray(t) ? t.length >= n : Number(t) >= Number(n);
}, min_default = min, not = function({ value: t }, ...n) {
  return !n.some((r) => typeof r == "object" ? eq(r, t) : r === t);
}, not_default = not, number2 = function({ value: t }) {
  return !isNaN(t);
}, number_default = number2, require_one = function(e, ...t) {
  return empty(e.value) ? t.map((r) => {
    var i;
    return (i = e.at(r)) == null ? void 0 : i.value;
  }).some((r) => !empty(r)) : !0;
};
require_one.skipEmpty = !1;
var require_one_default = require_one, required = function({ value: t }, n = "default") {
  return n === "trim" && typeof t == "string" ? !empty(t.trim()) : !empty(t);
};
required.skipEmpty = !1;
var required_default = required, starts_with = function({ value: t }, ...n) {
  return typeof t == "string" && n.length ? n.some((r) => t.startsWith(r)) : typeof t == "string" && n.length === 0;
}, starts_with_default = starts_with, symbol = function({ value: e }) {
  return /^[!-/:-@[-`{-~]+$/.test(String(e));
}, symbol_default = symbol, uppercase = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{Lu}+$", "u"),
    latin: /^[A-Z]+$/
  }, r = has(n, t) ? t : "default";
  return n[r].test(String(e));
}, uppercase_default = uppercase, url = function({ value: t }, ...n) {
  try {
    const r = n.length ? n : ["http:", "https:"], i = new URL(String(t));
    return r.includes(i.protocol);
  } catch {
    return !1;
  }
}, url_default = url;
const defaultRules = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accepted: accepted_default,
  alpha: alpha_default,
  alpha_spaces: alpha_spaces_default,
  alphanumeric: alphanumeric_default,
  between: between_default,
  confirm: confirm_default,
  contains_alpha: contains_alpha_default,
  contains_alpha_spaces: contains_alpha_spaces_default,
  contains_alphanumeric: contains_alphanumeric_default,
  contains_lowercase: contains_lowercase_default,
  contains_numeric: contains_numeric_default,
  contains_symbol: contains_symbol_default,
  contains_uppercase: contains_uppercase_default,
  date_after: date_after_default,
  date_after_node: date_after_node_default,
  date_after_or_equal: date_after_or_equal_default,
  date_before: date_before_default,
  date_before_node: date_before_node_default,
  date_before_or_equal: date_before_or_equal_default,
  date_between: date_between_default,
  date_format: date_format_default,
  email: email_default,
  ends_with: ends_with_default,
  is: is_default,
  length: length_default,
  lowercase: lowercase_default,
  matches: matches_default,
  max: max_default,
  min: min_default,
  not: not_default,
  number: number_default,
  require_one: require_one_default,
  required: required_default,
  starts_with: starts_with_default,
  symbol: symbol_default,
  uppercase: uppercase_default,
  url: url_default
}, Symbol.toStringTag, { value: "Module" }));
function createLibraryPlugin(...e) {
  const t = e.reduce(
    (r, i) => extend$1(r, i),
    {}
  ), n = () => {
  };
  return n.library = function(r) {
    const i = camel(r.props.type);
    has(t, i) && r.define(t[i]);
  }, n;
}
var runtimeProps = [
  "classes",
  "config",
  "delay",
  "errors",
  "id",
  "index",
  "inputErrors",
  "library",
  "modelValue",
  "onUpdate:modelValue",
  "name",
  "number",
  "parent",
  "plugins",
  "sectionsSchema",
  "type",
  "validation",
  "validationLabel",
  "validationMessages",
  "validationRules",
  // Runtime event props:
  "onInput",
  "onInputRaw",
  "onUpdate:modelValue",
  "onNode",
  "onSubmit",
  "onSubmitInvalid",
  "onSubmitRaw"
];
function isGroupOption(e) {
  return e && typeof e == "object" && "group" in e && Array.isArray(e.options);
}
function normalizeOptions(e, t = { count: 1 }) {
  return Array.isArray(e) ? e.map(
    (n) => {
      if (typeof n == "string" || typeof n == "number")
        return {
          label: String(n),
          value: String(n)
        };
      if (typeof n == "object") {
        if ("group" in n)
          return n.options = normalizeOptions(n.options || [], t), n;
        "value" in n && typeof n.value != "string" && Object.assign(n, {
          value: `__mask_${t.count++}`,
          __original: n.value
        });
      }
      return n;
    }
  ) : Object.keys(e).map((n) => ({
    label: e[n],
    value: n
  }));
}
function optionValue(e, t, n = !1) {
  if (Array.isArray(e)) {
    for (const r of e)
      if (!(typeof r != "object" && r)) {
        if (isGroupOption(r)) {
          const i = optionValue(r.options, t, !0);
          if (i !== void 0)
            return i;
        } else if (t == r.value)
          return "__original" in r ? r.__original : r.value;
      }
  }
  return n ? void 0 : t;
}
function shouldSelect(e, t) {
  return e === null && t === void 0 || e === void 0 && t === null ? !1 : e == t ? !0 : isPojo(e) && isPojo(t) ? eq(e, t) : !1;
}
function options$1(e) {
  e.hook.prop((t, n) => {
    var r;
    return t.prop === "options" && (typeof t.value == "function" ? (e.props.optionsLoader = t.value, t.value = []) : ((r = e.props)._normalizeCounter ?? (r._normalizeCounter = { count: 1 }), t.value = normalizeOptions(t.value, e.props._normalizeCounter))), n(t);
  });
}
// @__NO_SIDE_EFFECTS__
function createSection(e, t, n = !1) {
  return (...r) => {
    const i = (s) => {
      const l = !t || typeof t == "string" ? { $el: t } : t();
      return (isDOM(l) || isComponent(l)) && (l.meta ? l.meta.section = e : l.meta = { section: e }, r.length && !l.children && (l.children = [
        ...r.map(
          (c) => typeof c == "function" ? c(s) : c
        )
      ]), isDOM(l) && (l.attrs = {
        class: `$classes.${e}`,
        ...l.attrs || {}
      })), {
        if: `$slots.${e}`,
        then: `$slots.${e}`,
        else: e in s ? /* @__PURE__ */ extendSchema(l, s[e]) : l
      };
    };
    return i._s = e, n ? /* @__PURE__ */ createRoot(i) : i;
  };
}
// @__NO_SIDE_EFFECTS__
function createRoot(e) {
  return (t) => [e(t)];
}
function isSchemaObject(e) {
  return !!(e && typeof e == "object" && ("$el" in e || "$cmp" in e || "$formkit" in e));
}
// @__NO_SIDE_EFFECTS__
function extendSchema(e, t = {}) {
  return typeof e == "string" ? isSchemaObject(t) || typeof t == "string" ? t : e : Array.isArray(e) ? isSchemaObject(t) ? t : e : extend$1(e, t);
}
var actions = /* @__PURE__ */ createSection("actions", () => ({
  $el: "div",
  if: "$actions"
})), box = /* @__PURE__ */ createSection("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    name: "$node.props.altName || $node.name",
    disabled: "$option.attrs.disabled || $disabled",
    onInput: "$handlers.toggleChecked",
    checked: "$fns.eq($_value, $onValue)",
    onBlur: "$handlers.blur",
    value: "$: true",
    id: "$id",
    "aria-describedby": {
      if: "$options.length",
      then: {
        if: "$option.help",
        then: '$: "help-" + $option.attrs.id',
        else: void 0
      },
      else: {
        if: "$help",
        then: '$: "help-" + $id',
        else: void 0
      }
    }
  }
})), boxHelp = /* @__PURE__ */ createSection("optionHelp", () => ({
  $el: "div",
  if: "$option.help",
  attrs: {
    id: '$: "help-" + $option.attrs.id'
  }
})), boxInner = /* @__PURE__ */ createSection("inner", "span"), boxLabel = /* @__PURE__ */ createSection("label", "span"), boxOption = /* @__PURE__ */ createSection("option", () => ({
  $el: "li",
  for: ["option", "$options"],
  attrs: {
    "data-disabled": "$option.attrs.disabled || $disabled || undefined"
  }
})), boxOptions = /* @__PURE__ */ createSection("options", "ul"), boxWrapper = /* @__PURE__ */ createSection("wrapper", () => ({
  $el: "label",
  attrs: {
    "data-disabled": {
      if: "$options.length",
      then: void 0,
      else: "$disabled || undefined"
    },
    "data-checked": {
      if: "$options == undefined",
      then: "$fns.eq($_value, $onValue) || undefined",
      else: "$fns.isChecked($option.value) || undefined"
    }
  }
})), buttonInput = /* @__PURE__ */ createSection("input", () => ({
  $el: "button",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    id: "$id"
  }
})), buttonLabel = /* @__PURE__ */ createSection("default", null), decorator = /* @__PURE__ */ createSection("decorator", () => ({
  $el: "span",
  attrs: {
    "aria-hidden": "true"
  }
})), fieldset = /* @__PURE__ */ createSection("fieldset", () => ({
  $el: "fieldset",
  attrs: {
    id: "$id",
    "aria-describedby": {
      if: "$help",
      then: '$: "help-" + $id',
      else: void 0
    }
  }
})), fileInput = /* @__PURE__ */ createSection("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "file",
    disabled: "$disabled",
    name: "$node.name",
    onChange: "$handlers.files",
    onBlur: "$handlers.blur",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), fileItem = /* @__PURE__ */ createSection("fileItem", () => ({
  $el: "li",
  for: ["file", "$value"]
})), fileList = /* @__PURE__ */ createSection("fileList", () => ({
  $el: "ul",
  if: "$value.length",
  attrs: {
    "data-has-multiple": "$_hasMultipleFiles"
  }
})), fileName = /* @__PURE__ */ createSection("fileName", () => ({
  $el: "span",
  attrs: {
    class: "$classes.fileName"
  }
})), fileRemove = /* @__PURE__ */ createSection("fileRemove", () => ({
  $el: "button",
  attrs: {
    type: "button",
    onClick: "$handlers.resetFiles"
  }
})), formInput = /* @__PURE__ */ createSection("form", () => ({
  $el: "form",
  bind: "$attrs",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    id: "$id",
    name: "$node.name",
    onSubmit: "$handlers.submit",
    "data-loading": "$state.loading || undefined"
  }
})), fragment = /* @__PURE__ */ createSection("wrapper", null, !0), help = /* @__PURE__ */ createSection("help", () => ({
  $el: "div",
  if: "$help",
  attrs: {
    id: '$: "help-" + $id'
  }
})), icon = (e, t) => (/* @__PURE__ */ createSection(`${e}Icon`, () => {
  const n = `_raw${e.charAt(0).toUpperCase()}${e.slice(1)}Icon`;
  return {
    if: `$${e}Icon && $${n}`,
    $el: `${t || "span"}`,
    attrs: {
      class: `$classes.${e}Icon + " " + $classes.icon`,
      innerHTML: `$${n}`,
      onClick: `$handlers.iconClick(${e})`,
      role: `$fns.iconRole(${e})`,
      tabindex: `$fns.iconRole(${e}) === "button" && "0" || undefined`,
      for: {
        if: `${t === "label"}`,
        then: "$id"
      }
    }
  };
}))(), inner = /* @__PURE__ */ createSection("inner", "div"), label = /* @__PURE__ */ createSection("label", () => ({
  $el: "label",
  if: "$label",
  attrs: {
    for: "$id"
  }
})), legend = /* @__PURE__ */ createSection("legend", () => ({
  $el: "legend",
  if: "$label"
})), message$1 = /* @__PURE__ */ createSection("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
})), messages$1 = /* @__PURE__ */ createSection("messages", () => ({
  $el: "ul",
  if: "$defaultMessagePlacement && $fns.length($messages)"
})), noFiles = /* @__PURE__ */ createSection("noFiles", () => ({
  $el: "span",
  if: "$value == null || $value.length == 0"
})), optGroup = /* @__PURE__ */ createSection("optGroup", () => ({
  $el: "optgroup",
  bind: "$option.attrs",
  attrs: {
    label: "$option.group"
  }
})), option = /* @__PURE__ */ createSection("option", () => ({
  $el: "option",
  bind: "$option.attrs",
  attrs: {
    class: "$classes.option",
    value: "$option.value",
    selected: "$fns.isSelected($option)"
  }
})), optionSlot = /* @__PURE__ */ createSection("options", () => ({
  $el: null,
  if: "$options.length",
  for: ["option", "$option.options || $options"]
})), outer = /* @__PURE__ */ createSection("outer", () => ({
  $el: "div",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    key: "$id",
    "data-family": "$family || undefined",
    "data-type": "$type",
    "data-multiple": '$attrs.multiple || ($type != "select" && $options != undefined) || undefined',
    "data-has-multiple": "$_hasMultipleFiles",
    "data-disabled": '$: ($disabled !== "false" && $disabled) || undefined',
    "data-empty": "$state.empty || undefined",
    "data-complete": "$state.complete || undefined",
    "data-invalid": "$state.invalid || undefined",
    "data-errors": "$state.errors || undefined",
    "data-submitted": "$state.submitted || undefined",
    "data-prefix-icon": "$_rawPrefixIcon !== undefined || undefined",
    "data-suffix-icon": "$_rawSuffixIcon !== undefined || undefined",
    "data-prefix-icon-click": "$onPrefixIconClick !== undefined || undefined",
    "data-suffix-icon-click": "$onSuffixIconClick !== undefined || undefined"
  }
})), prefix = /* @__PURE__ */ createSection("prefix", null), selectInput = /* @__PURE__ */ createSection("input", () => ({
  $el: "select",
  bind: "$attrs",
  attrs: {
    id: "$id",
    "data-placeholder": "$fns.showPlaceholder($_value, $placeholder)",
    disabled: "$disabled",
    class: "$classes.input",
    name: "$node.name",
    onChange: "$handlers.onChange",
    onInput: "$handlers.selectInput",
    onBlur: "$handlers.blur",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), submitInput = /* @__PURE__ */ createSection("submit", () => ({
  $cmp: "FormKit",
  bind: "$submitAttrs",
  props: {
    type: "submit",
    label: "$submitLabel"
  }
})), suffix = /* @__PURE__ */ createSection("suffix", null), textInput = /* @__PURE__ */ createSection("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), textareaInput = /* @__PURE__ */ createSection("input", () => ({
  $el: "textarea",
  bind: "$attrs",
  attrs: {
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  },
  children: "$initialValue"
})), wrapper$1 = /* @__PURE__ */ createSection("wrapper", "div"), radioInstance = 0;
function renamesRadios(e) {
  (e.type === "group" || e.type === "list") && e.plugins.add(renamesRadiosPlugin);
}
function renamesRadiosPlugin(e) {
  e.props.type === "radio" && (e.addProps(["altName"]), e.props.altName = `${e.name}_${radioInstance++}`);
}
function normalizeBoxes(e) {
  return function(t, n) {
    return t.prop === "options" && Array.isArray(t.value) && (t.value = t.value.map((r) => {
      var i;
      return (i = r.attrs) != null && i.id ? r : extend$1(r, {
        attrs: {
          id: `${e.props.id}-option-${slugify(String(r.value))}`
        }
      });
    }), e.props.type === "checkbox" && !Array.isArray(e.value) && (e.isCreated ? e.input([], !1) : e.on("created", () => {
      Array.isArray(e.value) || e.input([], !1);
    }))), n(t);
  };
}
function toggleChecked(e, t) {
  const n = t.target;
  if (n instanceof HTMLInputElement) {
    const r = Array.isArray(e.props.options) ? optionValue(e.props.options, n.value) : n.value;
    Array.isArray(e.props.options) && e.props.options.length ? Array.isArray(e._value) ? e._value.some((i) => shouldSelect(r, i)) ? e.input(
      e._value.filter(
        (i) => !shouldSelect(r, i)
      )
    ) : e.input([...e._value, r]) : e.input([r]) : n.checked ? e.input(e.props.onValue) : e.input(e.props.offValue);
  }
}
function isChecked(e, t) {
  var n, r;
  return (n = e.context) == null || n.value, (r = e.context) == null || r._value, Array.isArray(e._value) ? e._value.some(
    (i) => shouldSelect(optionValue(e.props.options, t), i)
  ) : !1;
}
function checkboxes(e) {
  e.on("created", () => {
    var t, n;
    (t = e.context) != null && t.handlers && (e.context.handlers.toggleChecked = toggleChecked.bind(null, e)), (n = e.context) != null && n.fns && (e.context.fns.isChecked = isChecked.bind(null, e)), has(e.props, "onValue") || (e.props.onValue = !0), has(e.props, "offValue") || (e.props.offValue = !1);
  }), e.hook.prop(normalizeBoxes(e));
}
function defaultIcon(e, t) {
  return (n) => {
    n.props[`${e}Icon`] === void 0 && (n.props[`${e}Icon`] = t.startsWith("<svg") ? t : `default:${t}`);
  };
}
function disables(e) {
  e.on("created", () => {
    "disabled" in e.props && (e.props.disabled = undefine(e.props.disabled), e.config.disabled = undefine(e.props.disabled));
  }), e.hook.prop(({ prop: t, value: n }, r) => (n = t === "disabled" ? undefine(n) : n, r({ prop: t, value: n }))), e.on("prop:disabled", ({ payload: t }) => {
    e.config.disabled = undefine(t);
  });
}
function localize(e, t) {
  return (n) => {
    n.store.set(
      /* @__PURE__ */ createMessage({
        key: e,
        type: "ui",
        value: t || e,
        meta: {
          localize: !0,
          i18nArgs: [n]
        }
      })
    );
  };
}
var isBrowser$3 = typeof window < "u";
function removeHover(e) {
  e.target instanceof HTMLElement && e.target.hasAttribute("data-file-hover") && e.target.removeAttribute("data-file-hover");
}
function preventStrayDrop(e, t) {
  t.target instanceof HTMLInputElement ? e === "dragover" && t.target.setAttribute("data-file-hover", "true") : t.preventDefault(), e === "drop" && removeHover(t);
}
function files(e) {
  localize("noFiles", "Select file")(e), localize("removeAll", "Remove all")(e), localize("remove")(e), e.addProps(["_hasMultipleFiles"]), isBrowser$3 && (window._FormKit_File_Drop || (window.addEventListener(
    "dragover",
    preventStrayDrop.bind(null, "dragover")
  ), window.addEventListener("drop", preventStrayDrop.bind(null, "drop")), window.addEventListener("dragleave", removeHover), window._FormKit_File_Drop = !0)), e.hook.input((t, n) => n(Array.isArray(t) ? t : [])), e.on("input", ({ payload: t }) => {
    e.props._hasMultipleFiles = Array.isArray(t) && t.length > 1 ? !0 : void 0;
  }), e.on("reset", () => {
    if (e.props.id && isBrowser$3) {
      const t = document.getElementById(e.props.id);
      t && (t.value = "");
    }
  }), e.on("created", () => {
    Array.isArray(e.value) || e.input([], !1), e.context && (e.context.handlers.resetFiles = (t) => {
      if (t.preventDefault(), e.input([]), e.props.id && isBrowser$3) {
        const n = document.getElementById(e.props.id);
        n && (n.value = ""), n == null || n.focus();
      }
    }, e.context.handlers.files = (t) => {
      var r, i;
      const n = [];
      if (t.target instanceof HTMLInputElement && t.target.files) {
        for (let s = 0; s < t.target.files.length; s++) {
          let l;
          (l = t.target.files.item(s)) && n.push({ name: l.name, file: l });
        }
        e.input(n);
      }
      e.context && (e.context.files = n), typeof ((r = e.props.attrs) == null ? void 0 : r.onChange) == "function" && ((i = e.props.attrs) == null || i.onChange(t));
    });
  });
}
var loading = /* @__PURE__ */ createMessage({
  key: "loading",
  value: !0,
  visible: !1
});
async function handleSubmit(e, t) {
  const n = Math.random();
  if (e.props._submitNonce = n, t.preventDefault(), await e.settled, e.ledger.value("validating") && (e.store.set(loading), await e.ledger.settled("validating"), e.store.remove("loading"), e.props._submitNonce !== n))
    return;
  const r = (i) => i.store.set(
    /* @__PURE__ */ createMessage({
      key: "submitted",
      value: !0,
      visible: !1
    })
  );
  if (e.walk(r), r(e), e.emit("submit-raw"), typeof e.props.onSubmitRaw == "function" && e.props.onSubmitRaw(t, e), e.ledger.value("blocking"))
    typeof e.props.onSubmitInvalid == "function" && e.props.onSubmitInvalid(e), e.props.incompleteMessage !== !1 && setIncompleteMessage(e);
  else if (typeof e.props.onSubmit == "function") {
    const i = e.props.onSubmit(
      e.hook.submit.dispatch(clone(e.value)),
      e
    );
    if (i instanceof Promise) {
      const s = e.props.disabled === void 0 && e.props.submitBehavior !== "live";
      s && (e.props.disabled = !0), e.store.set(loading), await i, s && (e.props.disabled = !1), e.store.remove("loading");
    }
  } else
    t.target instanceof HTMLFormElement && t.target.submit();
}
function setIncompleteMessage(e) {
  e.store.set(
    /* @__PURE__ */ createMessage({
      blocking: !1,
      key: "incomplete",
      meta: {
        localize: e.props.incompleteMessage === void 0,
        i18nArgs: [{ node: e }],
        showAsMessage: !0
      },
      type: "ui",
      value: e.props.incompleteMessage || "Form incomplete."
    })
  );
}
function form(e) {
  var t;
  e.props.isForm = !0, e.ledger.count("validating", (n) => n.key === "validating"), (t = e.props).submitAttrs ?? (t.submitAttrs = {
    disabled: e.props.disabled
  }), e.on("prop:disabled", ({ payload: n }) => {
    e.props.submitAttrs = { ...e.props.submitAttrs, disabled: n };
  }), e.on("created", () => {
    var n;
    (n = e.context) != null && n.handlers && (e.context.handlers.submit = handleSubmit.bind(null, e)), has(e.props, "actions") || (e.props.actions = !0);
  }), e.on("prop:incompleteMessage", () => {
    e.store.incomplete && setIncompleteMessage(e);
  }), e.on("settled:blocking", () => e.store.remove("incomplete"));
}
function ignore(e) {
  e.props.ignore === void 0 && (e.props.ignore = !0, e.parent = null);
}
function initialValue(e) {
  e.on("created", () => {
    e.context && (e.context.initialValue = e.value || "");
  });
}
function casts(e) {
  if (typeof e.props.number > "u")
    return;
  const t = ["number", "range", "hidden"].includes(e.props.type);
  e.hook.input((n, r) => {
    if (n === "")
      return r(void 0);
    const i = e.props.number === "integer" ? parseInt(n) : parseFloat(n);
    return Number.isFinite(i) ? r(i) : r(t ? void 0 : n);
  });
}
function toggleChecked2(e, t) {
  t.target instanceof HTMLInputElement && e.input(optionValue(e.props.options, t.target.value));
}
function isChecked2(e, t) {
  var n, r;
  return (n = e.context) == null || n.value, (r = e.context) == null || r._value, shouldSelect(optionValue(e.props.options, t), e._value);
}
function radios(e) {
  e.on("created", () => {
    var t, n;
    Array.isArray(e.props.options) || warn(350, {
      node: e,
      inputType: "radio"
    }), (t = e.context) != null && t.handlers && (e.context.handlers.toggleChecked = toggleChecked2.bind(null, e)), (n = e.context) != null && n.fns && (e.context.fns.isChecked = isChecked2.bind(null, e));
  }), e.hook.prop(normalizeBoxes(e));
}
function isSelected(e, t) {
  if (isGroupOption(t))
    return !1;
  e.context && e.context.value;
  const n = "__original" in t ? t.__original : t.value;
  return Array.isArray(e._value) ? e._value.some((r) => shouldSelect(r, n)) : (e._value === void 0 || e._value === null && !containsValue(e.props.options, null)) && t.attrs && t.attrs["data-is-placeholder"] ? !0 : shouldSelect(n, e._value);
}
function containsValue(e, t) {
  return e.some((n) => isGroupOption(n) ? containsValue(n.options, t) : ("__original" in n ? n.__original : n.value) === t);
}
async function deferChange(e, t) {
  var n;
  typeof ((n = e.props.attrs) == null ? void 0 : n.onChange) == "function" && (await new Promise((r) => setTimeout(r, 0)), await e.settled, e.props.attrs.onChange(t));
}
function selectInput2(e, t) {
  const n = t.target, r = n.hasAttribute("multiple") ? Array.from(n.selectedOptions).map(
    (i) => optionValue(e.props.options, i.value)
  ) : optionValue(e.props.options, n.value);
  e.input(r);
}
function applyPlaceholder(e, t) {
  return e.some(
    (n) => n.attrs && n.attrs["data-is-placeholder"]
  ) ? e : [
    {
      label: t,
      value: "",
      attrs: {
        hidden: !0,
        disabled: !0,
        "data-is-placeholder": "true"
      }
    },
    ...e
  ];
}
function firstValue(e) {
  const t = e.length > 0 ? e[0] : void 0;
  if (t)
    return isGroupOption(t) ? firstValue(t.options) : "__original" in t ? t.__original : t.value;
}
function select(e) {
  e.on("created", () => {
    var n, r, i;
    const t = undefine((n = e.props.attrs) == null ? void 0 : n.multiple);
    !t && e.props.placeholder && Array.isArray(e.props.options) && (e.hook.prop(({ prop: s, value: l }, c) => (s === "options" && (l = applyPlaceholder(l, e.props.placeholder)), c({ prop: s, value: l }))), e.props.options = applyPlaceholder(
      e.props.options,
      e.props.placeholder
    )), t ? e.value === void 0 && e.input([], !1) : e.context && !e.context.options && (e.props.attrs = Object.assign({}, e.props.attrs, {
      value: e._value
    }), e.on("input", ({ payload: s }) => {
      e.props.attrs = Object.assign({}, e.props.attrs, {
        value: s
      });
    })), (r = e.context) != null && r.handlers && (e.context.handlers.selectInput = selectInput2.bind(null, e), e.context.handlers.onChange = deferChange.bind(null, e)), (i = e.context) != null && i.fns && (e.context.fns.isSelected = isSelected.bind(null, e), e.context.fns.showPlaceholder = (s, l) => {
      if (!Array.isArray(e.props.options))
        return !1;
      const c = e.props.options.some(
        (u) => {
          if (u.attrs && "data-is-placeholder" in u.attrs)
            return !1;
          const m = "__original" in u ? u.__original : u.value;
          return eq(s, m);
        }
      );
      return l && !c ? !0 : void 0;
    });
  }), e.hook.input((t, n) => {
    var r, i, s;
    return !e.props.placeholder && t === void 0 && Array.isArray((r = e.props) == null ? void 0 : r.options) && e.props.options.length && !undefine((s = (i = e.props) == null ? void 0 : i.attrs) == null ? void 0 : s.multiple) && (t = firstValue(e.props.options)), n(t);
  });
}
// @__NO_SIDE_EFFECTS__
function isSlotCondition(e) {
  return !!(isConditional(e) && e.if && e.if.startsWith("$slots.") && typeof e.then == "string" && e.then.startsWith("$slots.") && "else" in e);
}
// @__NO_SIDE_EFFECTS__
function useSchema(e, t = {}) {
  const n = /* @__PURE__ */ outer(
    /* @__PURE__ */ wrapper$1(
      /* @__PURE__ */ label("$label"),
      /* @__PURE__ */ inner(/* @__PURE__ */ icon("prefix"), /* @__PURE__ */ prefix(), e(), /* @__PURE__ */ suffix(), /* @__PURE__ */ icon("suffix"))
    ),
    /* @__PURE__ */ help("$help"),
    /* @__PURE__ */ messages$1(/* @__PURE__ */ message$1("$message.value"))
  );
  return (r = {}) => n(extend$1(t, r));
}
// @__NO_SIDE_EFFECTS__
function $if(e, t, n) {
  const r = (i) => {
    const s = t(i);
    if (n || isSchemaObject(s) && "if" in s || /* @__PURE__ */ isSlotCondition(s)) {
      const l = {
        if: e,
        then: s
      };
      return n && (l.else = n(i)), l;
    } else /* @__PURE__ */ isSlotCondition(s) ? Object.assign(s.else, { if: e }) : isSchemaObject(s) && Object.assign(s, { if: e });
    return s;
  };
  return r._s = token(), r;
}
// @__NO_SIDE_EFFECTS__
function $extend(e, t) {
  const n = (r) => {
    const i = e({});
    return /* @__PURE__ */ isSlotCondition(i) ? (Array.isArray(i.else) || (i.else = /* @__PURE__ */ extendSchema(
      /* @__PURE__ */ extendSchema(i.else, t),
      e._s ? r[e._s] : {}
    )), i) : /* @__PURE__ */ extendSchema(
      /* @__PURE__ */ extendSchema(i, t),
      e._s ? r[e._s] : {}
    );
  };
  return n._s = e._s, n;
}
var button = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ outer(
    /* @__PURE__ */ messages$1(/* @__PURE__ */ message$1("$message.value")),
    /* @__PURE__ */ wrapper$1(
      /* @__PURE__ */ buttonInput(
        /* @__PURE__ */ icon("prefix"),
        /* @__PURE__ */ prefix(),
        /* @__PURE__ */ buttonLabel("$label || $ui.submit.value"),
        /* @__PURE__ */ suffix(),
        /* @__PURE__ */ icon("suffix")
      )
    ),
    /* @__PURE__ */ help("$help")
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "button",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [localize("submit"), ignore],
  /**
   * A key to use for memoizing the schema. This is used to prevent the schema
   * from needing to be stringified when performing a memo lookup.
   */
  schemaMemoKey: "h6st4epl3j8"
}, checkbox = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ outer(
    /* @__PURE__ */ $if(
      "$options == undefined",
      /**
       * Single checkbox structure.
       */
      /* @__PURE__ */ boxWrapper(
        /* @__PURE__ */ boxInner(/* @__PURE__ */ prefix(), /* @__PURE__ */ box(), /* @__PURE__ */ decorator(/* @__PURE__ */ icon("decorator")), /* @__PURE__ */ suffix()),
        /* @__PURE__ */ $extend(/* @__PURE__ */ boxLabel("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi checkbox structure.
       */
      /* @__PURE__ */ fieldset(
        /* @__PURE__ */ legend("$label"),
        /* @__PURE__ */ help("$help"),
        /* @__PURE__ */ boxOptions(
          /* @__PURE__ */ boxOption(
            /* @__PURE__ */ boxWrapper(
              /* @__PURE__ */ boxInner(
                /* @__PURE__ */ prefix(),
                /* @__PURE__ */ $extend(/* @__PURE__ */ box(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ decorator(/* @__PURE__ */ icon("decorator")),
                /* @__PURE__ */ suffix()
              ),
              /* @__PURE__ */ $extend(/* @__PURE__ */ boxLabel("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ boxHelp("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ $if("$options == undefined && $help", /* @__PURE__ */ help("$help")),
    /* @__PURE__ */ messages$1(/* @__PURE__ */ message$1("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [
    options$1,
    checkboxes,
    defaultIcon("decorator", "checkboxDecorator")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, file = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ outer(
    /* @__PURE__ */ wrapper$1(
      /* @__PURE__ */ label("$label"),
      /* @__PURE__ */ inner(
        /* @__PURE__ */ icon("prefix", "label"),
        /* @__PURE__ */ prefix(),
        /* @__PURE__ */ fileInput(),
        /* @__PURE__ */ fileList(
          /* @__PURE__ */ fileItem(
            /* @__PURE__ */ icon("fileItem"),
            /* @__PURE__ */ fileName("$file.name"),
            /* @__PURE__ */ $if(
              "$value.length === 1",
              /* @__PURE__ */ fileRemove(
                /* @__PURE__ */ icon("fileRemove"),
                '$ui.remove.value + " " + $file.name'
              )
            )
          )
        ),
        /* @__PURE__ */ $if("$value.length > 1", /* @__PURE__ */ fileRemove("$ui.removeAll.value")),
        /* @__PURE__ */ noFiles(/* @__PURE__ */ icon("noFiles"), "$ui.noFiles.value"),
        /* @__PURE__ */ suffix(),
        /* @__PURE__ */ icon("suffix")
      )
    ),
    /* @__PURE__ */ help("$help"),
    /* @__PURE__ */ messages$1(/* @__PURE__ */ message$1("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [
    files,
    defaultIcon("fileItem", "fileItem"),
    defaultIcon("fileRemove", "fileRemove"),
    defaultIcon("noFiles", "noFiles")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "9kqc4852fv8"
}, form2 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ formInput(
    "$slots.default",
    /* @__PURE__ */ messages$1(/* @__PURE__ */ message$1("$message.value")),
    /* @__PURE__ */ actions(/* @__PURE__ */ submitInput())
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [
    "actions",
    "submit",
    "submitLabel",
    "submitAttrs",
    "submitBehavior",
    "incompleteMessage"
  ],
  /**
   * Additional features that should be added to your input
   */
  features: [form, disables],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "5bg016redjo"
}, group = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ fragment("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [disables, renamesRadios]
}, hidden = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ textInput(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [casts]
}, list = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ fragment("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "list",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["sync", "dynamic"],
  /**
   * Additional features that should be added to your input
   */
  features: [disables, renamesRadios]
}, meta = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ fragment(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: []
}, radio = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ outer(
    /* @__PURE__ */ $if(
      "$options == undefined",
      /**
       * Single radio structure.
       */
      /* @__PURE__ */ boxWrapper(
        /* @__PURE__ */ boxInner(/* @__PURE__ */ prefix(), /* @__PURE__ */ box(), /* @__PURE__ */ decorator(/* @__PURE__ */ icon("decorator")), /* @__PURE__ */ suffix()),
        /* @__PURE__ */ $extend(/* @__PURE__ */ boxLabel("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi radio structure.
       */
      /* @__PURE__ */ fieldset(
        /* @__PURE__ */ legend("$label"),
        /* @__PURE__ */ help("$help"),
        /* @__PURE__ */ boxOptions(
          /* @__PURE__ */ boxOption(
            /* @__PURE__ */ boxWrapper(
              /* @__PURE__ */ boxInner(
                /* @__PURE__ */ prefix(),
                /* @__PURE__ */ $extend(/* @__PURE__ */ box(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ decorator(/* @__PURE__ */ icon("decorator")),
                /* @__PURE__ */ suffix()
              ),
              /* @__PURE__ */ $extend(/* @__PURE__ */ boxLabel("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ boxHelp("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ $if("$options == undefined && $help", /* @__PURE__ */ help("$help")),
    /* @__PURE__ */ messages$1(/* @__PURE__ */ message$1("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [options$1, radios, defaultIcon("decorator", "radioDecorator")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, select2 = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ outer(
    /* @__PURE__ */ wrapper$1(
      /* @__PURE__ */ label("$label"),
      /* @__PURE__ */ inner(
        /* @__PURE__ */ icon("prefix"),
        /* @__PURE__ */ prefix(),
        /* @__PURE__ */ selectInput(
          /* @__PURE__ */ $if(
            "$slots.default",
            () => "$slots.default",
            /* @__PURE__ */ optionSlot(
              /* @__PURE__ */ $if(
                "$option.group",
                /* @__PURE__ */ optGroup(/* @__PURE__ */ optionSlot(/* @__PURE__ */ option("$option.label"))),
                /* @__PURE__ */ option("$option.label")
              )
            )
          )
        ),
        /* @__PURE__ */ $if("$attrs.multiple !== undefined", () => "", /* @__PURE__ */ icon("select")),
        /* @__PURE__ */ suffix(),
        /* @__PURE__ */ icon("suffix")
      )
    ),
    /* @__PURE__ */ help("$help"),
    /* @__PURE__ */ messages$1(/* @__PURE__ */ message$1("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "placeholder", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [options$1, select, defaultIcon("select", "select")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "cb119h43krg"
}, textarea = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ outer(
    /* @__PURE__ */ wrapper$1(
      /* @__PURE__ */ label("$label"),
      /* @__PURE__ */ inner(
        /* @__PURE__ */ icon("prefix", "label"),
        /* @__PURE__ */ prefix(),
        /* @__PURE__ */ textareaInput(),
        /* @__PURE__ */ suffix(),
        /* @__PURE__ */ icon("suffix")
      )
    ),
    /* @__PURE__ */ help("$help"),
    /* @__PURE__ */ messages$1(/* @__PURE__ */ message$1("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [initialValue],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "b1n0td79m9g"
}, text = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ outer(
    /* @__PURE__ */ wrapper$1(
      /* @__PURE__ */ label("$label"),
      /* @__PURE__ */ inner(
        /* @__PURE__ */ icon("prefix", "label"),
        /* @__PURE__ */ prefix(),
        /* @__PURE__ */ textInput(),
        /* @__PURE__ */ suffix(),
        /* @__PURE__ */ icon("suffix")
      )
    ),
    /* @__PURE__ */ help("$help"),
    /* @__PURE__ */ messages$1(/* @__PURE__ */ message$1("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [casts],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "c3cc4kflsg"
}, inputs = {
  button,
  submit: button,
  checkbox,
  file,
  form: form2,
  group,
  hidden,
  list,
  meta,
  radio,
  select: select2,
  textarea,
  text,
  color: text,
  date: text,
  datetimeLocal: text,
  email: text,
  month: text,
  number: text,
  password: text,
  search: text,
  tel: text,
  time: text,
  url: text,
  week: text,
  range: text
}, documentStyles = void 0, documentThemeLinkTag = null, themeDidLoad, themeHasLoaded = !1, themeWasRequested = !1, themeLoaded = /* @__PURE__ */ new Promise((e) => {
  themeDidLoad = () => {
    themeHasLoaded = !0, e();
  };
}), isClient = typeof window < "u" && typeof fetch < "u";
documentStyles = isClient ? /* @__PURE__ */ getComputedStyle(document.documentElement) : void 0;
var iconRegistry = {}, iconRequests = {};
function createThemePlugin(e, t, n, r) {
  t && Object.assign(iconRegistry, t), isClient && !themeWasRequested && (documentStyles != null && documentStyles.getPropertyValue("--formkit-theme")) ? (themeDidLoad(), themeWasRequested = !0) : e && !themeWasRequested && isClient ? loadTheme(e) : !themeWasRequested && isClient && themeDidLoad();
  const i = function(l) {
    var c, u;
    l.addProps(["iconLoader", "iconLoaderUrl"]), l.props.iconHandler = createIconHandler(
      (c = l.props) != null && c.iconLoader ? l.props.iconLoader : r,
      (u = l.props) != null && u.iconLoaderUrl ? l.props.iconLoaderUrl : n
    ), loadIconPropIcons(l, l.props.iconHandler), l.on("created", () => {
      var m, qu;
      (m = l == null ? void 0 : l.context) != null && m.handlers && (l.context.handlers.iconClick = (Gu) => {
        const Qu = `on${Gu.charAt(0).toUpperCase()}${Gu.slice(1)}IconClick`, Xu = l.props[Qu];
        if (Xu && typeof Xu == "function")
          return (ef) => Xu(l, ef);
      }), (qu = l == null ? void 0 : l.context) != null && qu.fns && (l.context.fns.iconRole = (Gu) => {
        const Qu = `on${Gu.charAt(0).toUpperCase()}${Gu.slice(1)}IconClick`;
        return typeof l.props[Qu] == "function" ? "button" : null;
      });
    });
  };
  return i.iconHandler = createIconHandler(r, n), i;
}
function loadTheme(e) {
  if (!(!e || !isClient || typeof getComputedStyle != "function") && (themeWasRequested = !0, documentThemeLinkTag = document.getElementById("formkit-theme"), e && // if we have a window object
  isClient && // we don't have an existing theme OR the theme being set up is different
  (!(documentStyles != null && documentStyles.getPropertyValue("--formkit-theme")) && !documentThemeLinkTag || documentThemeLinkTag != null && documentThemeLinkTag.getAttribute("data-theme") && (documentThemeLinkTag == null ? void 0 : documentThemeLinkTag.getAttribute("data-theme")) !== e))) {
    const n = `https://cdn.jsdelivr.net/npm/@formkit/themes@${FORMKIT_VERSION.startsWith("__") ? "latest" : FORMKIT_VERSION}/dist/${e}/theme.css`, r = document.createElement("link");
    r.type = "text/css", r.rel = "stylesheet", r.id = "formkit-theme", r.setAttribute("data-theme", e), r.onload = () => {
      documentStyles = getComputedStyle(document.documentElement), themeDidLoad();
    }, document.head.appendChild(r), r.href = n, documentThemeLinkTag && documentThemeLinkTag.remove();
  }
}
function createIconHandler(e, t) {
  return (n) => {
    if (typeof n != "string")
      return;
    if (n.startsWith("<svg"))
      return n;
    const r = n.startsWith("default:");
    n = r ? n.split(":")[1] : n;
    const i = n in iconRegistry;
    let s;
    if (i)
      return iconRegistry[n];
    if (!iconRequests[n]) {
      if (s = getIconFromStylesheet(n), s = isClient && typeof s > "u" ? Promise.resolve(s) : s, s instanceof Promise)
        iconRequests[n] = s.then((l) => !l && typeof n == "string" && !r ? s = typeof e == "function" ? e(n) : getRemoteIcon(n, t) : l).then((l) => (typeof n == "string" && (iconRegistry[r ? `default:${n}` : n] = l), l));
      else if (typeof s == "string")
        return iconRegistry[r ? `default:${n}` : n] = s, s;
    }
    return iconRequests[n];
  };
}
function getIconFromStylesheet(e) {
  if (isClient)
    return themeHasLoaded ? loadStylesheetIcon(e) : themeLoaded.then(() => loadStylesheetIcon(e));
}
function loadStylesheetIcon(e) {
  const t = documentStyles == null ? void 0 : documentStyles.getPropertyValue(`--fk-icon-${e}`);
  if (t) {
    const n = atob(t);
    if (n.startsWith("<svg"))
      return iconRegistry[e] = n, n;
  }
}
function getRemoteIcon(e, t) {
  const n = FORMKIT_VERSION.startsWith("__") ? "latest" : FORMKIT_VERSION, r = typeof t == "function" ? t(e) : `https://cdn.jsdelivr.net/npm/@formkit/icons@${n}/dist/icons/${e}.svg`;
  if (isClient)
    return fetch(`${r}`).then(async (i) => {
      const s = await i.text();
      if (s.startsWith("<svg"))
        return s;
    }).catch((i) => {
      console.error(i);
    });
}
function loadIconPropIcons(e, t) {
  const n = /^[a-zA-Z-]+(?:-icon|Icon)$/;
  Object.keys(e.props).filter((i) => n.test(i)).forEach((i) => loadPropIcon(e, t, i));
}
function loadPropIcon(e, t, n) {
  const r = e.props[n], i = t(r), s = `_raw${n.charAt(0).toUpperCase()}${n.slice(1)}`, l = `on${n.charAt(0).toUpperCase()}${n.slice(1)}Click`;
  if (e.addProps([s, l]), e.on(`prop:${n}`, reloadIcon), i instanceof Promise)
    return i.then((c) => {
      e.props[s] = c;
    });
  e.props[s] = i;
}
function reloadIcon(e) {
  var l;
  const t = e.origin, n = e.payload, r = (l = t == null ? void 0 : t.props) == null ? void 0 : l.iconHandler, i = e.name.split(":")[1], s = `_raw${i.charAt(0).toUpperCase()}${i.slice(1)}`;
  if (r && typeof r == "function") {
    const c = r(n);
    if (c instanceof Promise)
      return c.then((u) => {
        t.props[s] = u;
      });
    t.props[s] = c;
  }
}
var errors = {
  /**
   * FormKit errors:
   */
  100: ({ data: e }) => `Only groups, lists, and forms can have children (${e.name}).`,
  101: ({ data: e }) => `You cannot directly modify the store (${e.name}). See: https://formkit.com/advanced/core#message-store`,
  102: ({
    data: [e, t]
  }) => `You cannot directly assign node.${t} (${e.name})`,
  103: ({ data: [e] }) => `Schema expressions cannot start with an operator (${e})`,
  104: ({ data: [e, t] }) => `Schema expressions cannot end with an operator (${e} in "${t}")`,
  105: ({ data: e }) => `Invalid schema expression: ${e}`,
  106: ({ data: e }) => `Cannot submit because (${e}) is not in a form.`,
  107: ({ data: [e, t] }) => `Cannot set ${e.name} to non object value: ${t}`,
  108: ({ data: [e, t] }) => `Cannot set ${e.name} to non array value: ${t}`,
  /**
   * Input specific errors:
   */
  300: ({ data: [e] }) => `Cannot set behavior prop to overscroll (on ${e.name} input) when options prop is a function.`,
  /**
   * FormKit vue errors:
   */
  600: ({ data: e }) => `Unknown input type${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} ("${e.name}")`,
  601: ({ data: e }) => `Input definition${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} is missing a schema or component property (${e.name}).`
}, warnings = {
  /**
   * Core warnings:
   */
  150: ({ data: e }) => `Schema function "${e}()" is not a valid function.`,
  151: ({ data: e }) => `No form element with id: ${e}`,
  152: ({ data: e }) => `No input element with id: ${e}`,
  /**
   * Input specific warnings:
   */
  350: ({
    data: { node: e, inputType: t }
  }) => `Invalid options prop for ${e.name} input (${t}). See https://formkit.com/inputs/${t}`,
  /**
   * Vue warnings:
   */
  650: 'Schema "$get()" must use the id of an input to access.',
  651: ({ data: e }) => `Cannot setErrors() on "${e}" because no such id exists.`,
  652: ({ data: e }) => `Cannot clearErrors() on "${e}" because no such id exists.`,
  /**
   * Deprecation warnings:
   */
  800: ({ data: e }) => `${e} is deprecated.`
}, decodeErrors = (e, t) => {
  if (e.code in errors) {
    const n = errors[e.code];
    e.message = typeof n == "function" ? n(e) : n;
  }
  return t(e);
}, registered = !1;
function register() {
  registered || (errorHandler(decodeErrors), warningHandler(decodeWarnings), registered = !0);
}
var decodeWarnings = (e, t) => {
  if (e.code in warnings) {
    const n = warnings[e.code];
    e.message = typeof n == "function" ? n(e) : n;
  }
  return t(e);
}, __defProp = Object.defineProperty, __getOwnPropNames = Object.getOwnPropertyNames, __esm = (e, t) => function() {
  return e && (t = (0, e[__getOwnPropNames(e)[0]])(e = 0)), t;
}, __export = (e, t) => {
  for (var n in t)
    __defProp(e, n, { get: t[n], enumerable: !0 });
}, vueBindings, bindings_default, init_bindings = __esm({
  "packages/vue/src/bindings.ts"() {
    vueBindings = function(t) {
      t.ledger.count("blocking", (lf) => lf.blocking);
      const n = ref(!t.ledger.value("blocking"));
      t.ledger.count("errors", (lf) => lf.type === "error");
      const r = ref(!!t.ledger.value("errors"));
      let i = !1;
      nextTick(() => {
        i = !0;
      });
      const s = reactive(
        t.store.reduce((lf, Sf) => (Sf.visible && (lf[Sf.key] = Sf), lf), {})
      ), l = ref(
        t.props.validationVisibility || (t.props.type === "checkbox" ? "dirty" : "blur")
      );
      t.on("prop:validationVisibility", ({ payload: lf }) => {
        l.value = lf;
      });
      const c = ref(l.value === "live"), u = ref(!1), m = (lf) => {
        u.value = (lf ?? []).some(
          (Sf) => Sf.name === "required"
        );
      };
      m(t.props.parsedRules), t.on("prop:parsedRules", ({ payload: lf }) => m(lf));
      const qu = ref(t.children.map((lf) => lf.uid)), Gu = computed(() => {
        if (!vf.state)
          return !1;
        if (vf.state.submitted)
          return !0;
        if (!c.value && !vf.state.settled)
          return !1;
        switch (l.value) {
          case "live":
            return !0;
          case "blur":
            return vf.state.blurred;
          case "dirty":
            return vf.state.dirty;
          default:
            return !1;
        }
      }), Qu = computed(() => vf.state.failing && Gu.value), Xu = computed(() => vf && ef.value ? n.value && !r.value : vf.state.dirty && !empty(vf.value)), ef = ref(
        Array.isArray(t.props.parsedRules) && t.props.parsedRules.length > 0
      );
      t.on("prop:parsedRules", ({ payload: lf }) => {
        ef.value = Array.isArray(lf) && lf.length > 0;
      });
      const tf = computed(() => {
        const lf = {};
        for (const Sf in s) {
          const Mf = s[Sf];
          (Mf.type !== "validation" || Gu.value) && (lf[Sf] = Mf);
        }
        return lf;
      }), af = reactive(
        t.store.reduce((lf, Sf) => (Sf.type === "ui" && Sf.visible && (lf[Sf.key] = Sf), lf), {})
      ), rf = computed(() => !vf.state.failing), hf = reactive({}), sf = new Proxy(hf, {
        get(...lf) {
          if (!t)
            return "";
          const [Sf, Mf] = lf;
          let Uf = Reflect.get(...lf);
          return !Uf && typeof Mf == "string" && !has(Sf, Mf) && !Mf.startsWith("__v") && createObserver(t).watch((Rf) => {
            const Bf = typeof Rf.config.rootClasses == "function" ? Rf.config.rootClasses(Mf, Rf) : {}, ih = Rf.config.classes ? createClasses(Mf, Rf, Rf.config.classes[Mf]) : {}, lh = createClasses(
              Mf,
              Rf,
              Rf.props[`_${Mf}Class`]
            ), Wf = createClasses(
              Mf,
              Rf,
              Rf.props[`${Mf}Class`]
            );
            Uf = generateClassList(
              Rf,
              Mf,
              Bf,
              ih,
              lh,
              Wf
            ), Sf[Mf] = Uf ?? "";
          }), Uf;
        }
      });
      t.on("prop:rootClasses", () => {
        const lf = Object.keys(hf);
        for (const Sf of lf)
          delete hf[Sf];
      });
      const pf = computed(() => {
        if (!t)
          return;
        const lf = [];
        vf.help && lf.push(`help-${t.props.id}`);
        for (const Sf in tf.value)
          lf.push(`${t.props.id}-${Sf}`);
        return lf.length ? lf.join(" ") : void 0;
      }), $f = ref(t.value), uf = ref(t.value), vf = reactive({
        _value: uf,
        attrs: t.props.attrs,
        disabled: t.props.disabled,
        describedBy: pf,
        fns: {
          length: (lf) => Object.keys(lf).length,
          number: (lf) => Number(lf),
          string: (lf) => String(lf),
          json: (lf) => JSON.stringify(lf),
          eq
        },
        handlers: {
          blur: (lf) => {
            t && (t.store.set(
              /* @__PURE__ */ createMessage({ key: "blurred", visible: !1, value: !0 })
            ), typeof t.props.attrs.onBlur == "function" && t.props.attrs.onBlur(lf));
          },
          touch: () => {
            var Mf;
            const lf = vf.dirtyBehavior === "compare";
            if ((Mf = t.store.dirty) != null && Mf.value && !lf)
              return;
            const Sf = !eq(t.props._init, t._value);
            !Sf && !lf || t.store.set(
              /* @__PURE__ */ createMessage({ key: "dirty", visible: !1, value: Sf })
            );
          },
          DOMInput: (lf) => {
            t.input(lf.target.value), t.emit("dom-input-event", lf);
          }
        },
        help: t.props.help,
        id: t.props.id,
        items: qu,
        label: t.props.label,
        messages: tf,
        didMount: !1,
        node: markRaw(t),
        options: t.props.options,
        defaultMessagePlacement: !0,
        slots: t.props.__slots,
        state: {
          blurred: !1,
          complete: Xu,
          dirty: !1,
          empty: empty($f),
          submitted: !1,
          settled: t.isSettled,
          valid: n,
          invalid: Qu,
          errors: r,
          rules: ef,
          validationVisible: Gu,
          required: u,
          failing: !1,
          passing: rf
        },
        type: t.props.type,
        family: t.props.family,
        ui: af,
        value: $f,
        classes: sf
      });
      t.on("created", () => {
        eq(vf.value, t.value) || (uf.value = t.value, $f.value = t.value, triggerRef($f), triggerRef(uf)), (async () => (await t.settled, t && (t.props._init = cloneAny(t.value))))();
      }), t.on("mounted", () => {
        vf.didMount = !0;
      }), t.on("settled", ({ payload: lf }) => {
        vf.state.settled = lf;
      });
      function cf(lf) {
        (Array.isArray(lf) ? lf : Object.keys(lf)).forEach((Mf) => {
          Mf = camel(Mf), has(vf, Mf) || (vf[Mf] = t.props[Mf]), t.on(`prop:${Mf}`, ({ payload: Uf }) => {
            vf[Mf] = Uf;
          });
        });
      }
      cf((() => {
        const lf = [
          "__root",
          "help",
          "label",
          "disabled",
          "options",
          "type",
          "attrs",
          "preserve",
          "preserveErrors",
          "id",
          "dirtyBehavior"
        ], Sf = /^[a-zA-Z-]+(?:-icon|Icon)$/, Mf = Object.keys(t.props).filter((Uf) => Sf.test(Uf));
        return lf.concat(Mf);
      })());
      function ff(lf) {
        lf.props && cf(lf.props);
      }
      t.props.definition && ff(t.props.definition), t.on("added-props", ({ payload: lf }) => cf(lf)), t.on("input", ({ payload: lf }) => {
        t.type !== "input" && !isRef(lf) && !isReactive(lf) ? uf.value = shallowClone(lf) : (uf.value = lf, triggerRef(uf));
      }), t.on("commitRaw", ({ payload: lf }) => {
        t.type !== "input" && !isRef(lf) && !isReactive(lf) ? $f.value = uf.value = shallowClone(lf) : ($f.value = uf.value = lf, triggerRef($f)), t.emit("modelUpdated");
      }), t.on("commit", ({ payload: lf }) => {
        var Sf;
        if ((!vf.state.dirty || vf.dirtyBehavior === "compare") && t.isCreated && i)
          if (!((Sf = t.store.validating) != null && Sf.value))
            vf.handlers.touch();
          else {
            const Mf = t.on("message-removed", ({ payload: Uf }) => {
              Uf.key === "validating" && (vf.handlers.touch(), t.off(Mf));
            });
          }
        Xu && t.type === "input" && r.value && !undefine(t.props.preserveErrors) && t.store.filter(
          (Mf) => {
            var Uf;
            return !(Mf.type === "error" && ((Uf = Mf.meta) == null ? void 0 : Uf.autoClear) === !0);
          }
        ), t.type === "list" && t.sync && (qu.value = t.children.map((Mf) => Mf.uid)), vf.state.empty = empty(lf);
      });
      const gf = async (lf) => {
        lf.type === "ui" && lf.visible && !lf.meta.showAsMessage ? af[lf.key] = lf : lf.visible ? s[lf.key] = lf : lf.type === "state" && (vf.state[lf.key] = !!lf.value);
      };
      t.on("message-added", (lf) => gf(lf.payload)), t.on("message-updated", (lf) => gf(lf.payload)), t.on("message-removed", ({ payload: lf }) => {
        delete af[lf.key], delete s[lf.key], delete vf.state[lf.key];
      }), t.on("settled:blocking", () => {
        n.value = !0;
      }), t.on("unsettled:blocking", () => {
        n.value = !1;
      }), t.on("settled:errors", () => {
        r.value = !1;
      }), t.on("unsettled:errors", () => {
        r.value = !0;
      }), watch$1(Gu, (lf) => {
        lf && (c.value = !0);
      }), t.context = vf, t.emit("context", t, !1), t.on("destroyed", () => {
        t.context = void 0, t = null;
      });
    }, bindings_default = vueBindings;
  }
}), defaultConfig_exports = {};
__export(defaultConfig_exports, {
  defaultConfig: () => defaultConfig
});
var defaultConfig, init_defaultConfig = __esm({
  "packages/vue/src/defaultConfig.ts"() {
    init_bindings(), defaultConfig = (e = {}) => {
      register();
      const {
        rules: t = {},
        locales: n = {},
        inputs: r = {},
        messages: i = {},
        locale: s = void 0,
        theme: l = void 0,
        iconLoaderUrl: c = void 0,
        iconLoader: u = void 0,
        icons: m = {},
        ...qu
      } = e, Gu = createValidationPlugin({
        ...defaultRules,
        ...t || {}
      }), Qu = createI18nPlugin(
        extend$1({ en: en$1, ...n || {} }, i)
      ), Xu = createLibraryPlugin(inputs, r), ef = createThemePlugin(l, m, c, u);
      return extend$1(
        {
          plugins: [Xu, ef, bindings_default, Qu, Gu],
          ...s ? { config: { locale: s } } : {}
        },
        qu || {},
        !0
      );
    };
  }
}), isServer = typeof window > "u", ssrCompleteRegistry = /* @__PURE__ */ new Map();
function onSSRComplete(e, t) {
  var n;
  !isServer || !e || (ssrCompleteRegistry.has(e) || ssrCompleteRegistry.set(e, /* @__PURE__ */ new Set()), (n = ssrCompleteRegistry.get(e)) == null || n.add(t));
}
var isServer2 = typeof window > "u", memo = {}, memoKeys = {}, instanceKey, instanceScopes = /* @__PURE__ */ new WeakMap(), raw$1 = "__raw__", isClassProp = /[a-zA-Z0-9\-][cC]lass$/;
function getRef(e, t) {
  const n = ref(null);
  if (e === "get") {
    const i = {};
    return n.value = get.bind(null, i), n;
  }
  const r = e.split(".");
  return watchEffect(() => {
    n.value = getValue(
      isRef(t) ? t.value : t,
      r
    );
  }), n;
}
function getValue(e, t) {
  if (Array.isArray(e)) {
    for (const i of e) {
      const s = i !== !1 && getValue(i, t);
      if (s !== void 0)
        return s;
    }
    return;
  }
  let n, r = e;
  for (const i in t) {
    const s = t[i];
    if (typeof r != "object" || r === null) {
      n = void 0;
      break;
    }
    const l = r[s];
    if (Number(i) === t.length - 1 && l !== void 0) {
      n = typeof l == "function" ? l.bind(r) : l;
      break;
    }
    r = l;
  }
  return n;
}
function get(e, t) {
  if (typeof t != "string")
    return warn(650);
  if (t in e || (e[t] = ref(void 0)), e[t].value === void 0) {
    e[t].value = null;
    const n = getNode(t);
    n && (e[t].value = n.context), watchRegistry(t, ({ payload: r }) => {
      e[t].value = isNode$1(r) ? r.context : r;
    });
  }
  return e[t].value;
}
function parseSchema(e, t, n) {
  function r(Xu, ef) {
    const tf = Gu(compile(ef.if), { if: !0 }), af = m(Xu, ef.then), rf = ef.else ? m(Xu, ef.else) : null;
    return [tf, af, rf];
  }
  function i(Xu, ef) {
    var hf, sf;
    const tf = Gu(compile(Xu.if));
    let af = () => ef, rf = () => ef;
    return typeof Xu.then == "object" ? rf = s(Xu.then, void 0) : typeof Xu.then == "string" && ((hf = Xu.then) != null && hf.startsWith("$")) ? rf = Gu(compile(Xu.then)) : rf = () => Xu.then, has(Xu, "else") && (typeof Xu.else == "object" ? af = s(Xu.else) : typeof Xu.else == "string" && ((sf = Xu.else) != null && sf.startsWith("$")) ? af = Gu(compile(Xu.else)) : af = () => Xu.else), () => tf() ? rf() : af();
  }
  function s(Xu, ef, tf = {}) {
    const af = new Set(Object.keys(Xu || {})), rf = ef ? Gu(compile(ef)) : () => ({}), hf = [
      (sf) => {
        const pf = rf();
        for (const $f in pf)
          af.has($f) || (sf[$f] = pf[$f]);
      }
    ];
    if (Xu) {
      if (isConditional(Xu))
        return i(
          Xu,
          tf
        );
      for (let sf in Xu) {
        const pf = Xu[sf];
        let $f;
        const uf = typeof pf == "string";
        sf.startsWith(raw$1) ? (sf = sf.substring(7), $f = () => pf) : uf && pf.startsWith("$") && pf.length > 1 && !(pf.startsWith("$reset") && isClassProp.test(sf)) ? $f = Gu(compile(pf)) : typeof pf == "object" && isConditional(pf) ? $f = i(pf, void 0) : typeof pf == "object" && isPojo(pf) ? $f = s(pf) : $f = () => pf, hf.push((vf) => {
          vf[sf] = $f();
        });
      }
    }
    return () => {
      const sf = Array.isArray(Xu) ? [] : {};
      return hf.forEach((pf) => pf(sf)), sf;
    };
  }
  function l(Xu, ef) {
    let tf = null, af = () => null, rf = !1, hf = null, sf = null, pf = null, $f = !1;
    const uf = sugar(ef);
    if (isDOM(uf) ? (tf = uf.$el, af = uf.$el !== "text" ? s(uf.attrs, uf.bind) : () => null) : isComponent(uf) ? (typeof uf.$cmp == "string" ? has(Xu, uf.$cmp) ? tf = Xu[uf.$cmp] : (tf = uf.$cmp, $f = !0) : tf = uf.$cmp, af = s(uf.props, uf.bind)) : isConditional(uf) && ([rf, hf, sf] = r(Xu, uf)), !isConditional(uf) && "if" in uf ? rf = Gu(compile(uf.if)) : !isConditional(uf) && tf === null && (rf = () => !0), "children" in uf && uf.children)
      if (typeof uf.children == "string")
        if (uf.children.startsWith("$slots."))
          tf = tf === "text" ? "slot" : tf, hf = Gu(compile(uf.children));
        else if (uf.children.startsWith("$") && uf.children.length > 1) {
          const vf = Gu(compile(uf.children));
          hf = () => String(vf());
        } else
          hf = () => String(uf.children);
      else if (Array.isArray(uf.children))
        hf = m(Xu, uf.children);
      else {
        const [vf, cf, yf] = r(Xu, uf.children);
        hf = (ff) => vf && vf() ? cf && cf(ff) : yf && yf(ff);
      }
    if (isComponent(uf))
      if (hf) {
        const vf = hf;
        hf = (cf) => ({
          default(yf, ff) {
            var Sf, Mf, Uf, Zf;
            const gf = instanceKey;
            ff && (instanceKey = ff), yf && ((Sf = instanceScopes.get(instanceKey)) == null || Sf.unshift(yf)), cf && ((Mf = instanceScopes.get(instanceKey)) == null || Mf.unshift(cf));
            const lf = vf(cf);
            return yf && ((Uf = instanceScopes.get(instanceKey)) == null || Uf.shift()), cf && ((Zf = instanceScopes.get(instanceKey)) == null || Zf.shift()), instanceKey = gf, lf;
          }
        }), hf.slot = !0;
      } else
        hf = () => ({});
    if ("for" in uf && uf.for) {
      const vf = uf.for.length === 3 ? uf.for[2] : uf.for[1];
      pf = [
        typeof vf == "string" && vf.startsWith("$") ? Gu(compile(vf)) : () => vf,
        uf.for[0],
        uf.for.length === 3 ? String(uf.for[1]) : null
      ];
    }
    return [rf, tf, af, hf, sf, pf, $f];
  }
  function c(Xu, ef) {
    const tf = Xu(ef), af = instanceKey;
    return Object.keys(tf).reduce((rf, hf) => {
      const sf = tf && tf[hf];
      return rf[hf] = (pf) => sf && sf(pf, af) || null, rf;
    }, {});
  }
  function u(Xu, ef) {
    const [tf, af, rf, hf, sf, pf, $f] = l(Xu, ef);
    let uf = (vf) => {
      if (tf && af === null && hf)
        return tf() ? hf(vf) : sf && sf(vf);
      if (af && (!tf || tf())) {
        if (af === "text" && hf)
          return createTextVNode(String(hf()));
        if (af === "slot" && hf)
          return hf(vf);
        const cf = $f ? resolveComponent(af) : af, yf = hf != null && hf.slot ? c(hf, vf) : null;
        return h(
          cf,
          rf(),
          yf || (hf ? hf(vf) : [])
        );
      }
      return typeof sf == "function" ? sf(vf) : sf;
    };
    if (pf) {
      const vf = uf, [cf, yf, ff] = pf;
      uf = () => {
        const gf = cf(), lf = Number.isFinite(gf) ? Array(Number(gf)).fill(0).map((Zf, Rf) => Rf) : gf, Sf = [];
        if (typeof lf != "object")
          return null;
        const Mf = instanceScopes.get(instanceKey) || [], Uf = Array.isArray(lf);
        for (const Zf in lf) {
          if (Uf && Zf in Array.prototype)
            continue;
          const Rf = Object.defineProperty(
            {
              ...Mf.reduce(
                (Bf, ih) => Bf.__idata ? { ...Bf, ...ih } : ih,
                {}
              ),
              [yf]: lf[Zf],
              ...ff !== null ? { [ff]: Uf ? Number(Zf) : Zf } : {}
            },
            "__idata",
            { enumerable: !1, value: !0 }
          );
          Mf.unshift(Rf), Sf.push(vf.bind(null, Rf)()), Mf.shift();
        }
        return Sf;
      };
    }
    return uf;
  }
  function m(Xu, ef) {
    if (Array.isArray(ef)) {
      const af = ef.map(u.bind(null, Xu));
      return (rf) => af.map((hf) => hf(rf));
    }
    const tf = u(Xu, ef);
    return (af) => tf(af);
  }
  const qu = [];
  function Gu(Xu, ef = {}) {
    const tf = /* @__PURE__ */ new WeakMap();
    return qu.push((af, rf) => {
      tf.set(
        rf,
        Xu.provide((hf) => af(hf, ef))
      );
    }), () => tf.get(instanceKey)();
  }
  function Qu(Xu, ef) {
    n ?? (n = toMemoKey(t));
    const [tf, af] = has(memo, n) ? memo[n] : [m(e, t), qu];
    return isServer2 || (memoKeys[n] ?? (memoKeys[n] = 0), memoKeys[n]++, memo[n] = [tf, af]), af.forEach((rf) => {
      rf(Xu, ef);
    }), () => (instanceKey = ef, tf());
  }
  return Qu;
}
function useScope(e, t) {
  const n = instanceScopes.get(instanceKey) || [];
  let r;
  return n.length && (r = getValue(n, e.split("."))), r === void 0 ? t : r;
}
function slotData(e, t) {
  return new Proxy(e, {
    get(...n) {
      let r;
      const i = n[1];
      if (typeof i == "string") {
        const s = instanceKey;
        instanceKey = t, r = useScope(i, void 0), instanceKey = s;
      }
      return r !== void 0 ? r : Reflect.get(...n);
    }
  });
}
function createRenderFn(e, t, n) {
  return e(
    (r, i = {}) => r.reduce((s, l) => {
      if (l.startsWith("slots.")) {
        const c = l.substring(6), u = () => t.slots && has(t.slots, c) && typeof t.slots[c] == "function";
        if (i.if)
          s[l] = u;
        else if (t.slots) {
          const m = slotData(t, n);
          s[l] = () => u() ? t.slots[c](m) : null;
        }
      } else {
        const c = getRef(l, t);
        s[l] = () => useScope(l, c.value);
      }
      return s;
    }, {}),
    n
  );
}
function clean(e, t, n) {
  if (t ?? (t = toMemoKey(e)), memoKeys[t]--, memoKeys[t] === 0) {
    delete memoKeys[t];
    const [, r] = memo[t];
    delete memo[t], r.length = 0;
  }
  instanceScopes.delete(n);
}
function toMemoKey(e) {
  return JSON.stringify(e, (t, n) => typeof n == "function" ? n.toString() : n);
}
var FormKitSchema = /* @__PURE__ */ defineComponent({
  name: "FormKitSchema",
  props: {
    schema: {
      type: [Array, Object],
      required: !0
    },
    data: {
      type: Object,
      default: () => ({})
    },
    library: {
      type: Object,
      default: () => ({})
    },
    memoKey: {
      type: String,
      required: !1
    }
  },
  emits: ["mounted"],
  setup(e, t) {
    var m;
    const n = getCurrentInstance();
    let r = {};
    instanceScopes.set(r, []);
    const i = { FormKit: markRaw(FormKit_default), ...e.library };
    let s = parseSchema(i, e.schema, e.memoKey), l, c;
    isServer2 || watch$1(
      () => e.schema,
      (qu, Gu) => {
        var Xu;
        const Qu = r;
        r = {}, instanceScopes.set(r, []), s = parseSchema(i, e.schema, e.memoKey), l = createRenderFn(s, c, r), qu === Gu && ((Xu = n == null ? void 0 : n.proxy) == null ? void 0 : Xu.$forceUpdate).call(Xu), clean(e.schema, e.memoKey, Qu);
      },
      { deep: !0 }
    ), watchEffect(() => {
      c = Object.assign(reactive(e.data ?? {}), {
        slots: t.slots
      }), t.slots, l = createRenderFn(s, c, r);
    });
    function u() {
      clean(e.schema, e.memoKey, r), c && (c.node && c.node.destroy(), c.slots = null, c = null), l = null;
    }
    return onMounted(() => t.emit("mounted")), onUnmounted(u), onSSRComplete((m = getCurrentInstance()) == null ? void 0 : m.appContext.app, u), () => l ? l() : null;
  }
}), FormKitSchema_default = FormKitSchema, isServer3 = typeof window > "u", parentSymbol = Symbol("FormKitParent"), componentSymbol = Symbol("FormKitComponentCallback");
function FormKit(e, t) {
  const n = useInput(e, t);
  if (n.props.definition || error(600, n), n.props.definition.component)
    return () => {
      var m;
      return h(
        (m = n.props.definition) == null ? void 0 : m.component,
        {
          context: n.context
        },
        { ...t.slots }
      );
    };
  const r = ref([]);
  let i = n.props.definition.schemaMemoKey;
  const s = () => {
    var qu, Gu;
    const m = (Gu = (qu = n.props) == null ? void 0 : qu.definition) == null ? void 0 : Gu.schema;
    m || error(601, n), typeof m == "function" ? (r.value = m({ ...e.sectionsSchema || {} }), (i && e.sectionsSchema || "memoKey" in m && typeof m.memoKey == "string") && (i = (i ?? (m == null ? void 0 : m.memoKey)) + JSON.stringify(e.sectionsSchema))) : r.value = m;
  };
  s(), isServer3 || n.on("schema", () => {
    i += "♻️", s();
  }), t.emit("node", n);
  const l = n.props.definition.library, c = {
    FormKit: markRaw(formkitComponent),
    ...l,
    ...e.library ?? {}
  };
  function u() {
    n.emit("mounted");
  }
  return t.expose({ node: n }), () => h(
    FormKitSchema,
    {
      schema: r.value,
      data: n.context,
      onMounted: u,
      library: c,
      memoKey: i
    },
    { ...t.slots }
  );
}
var formkitComponent = /* @__PURE__ */ defineComponent(
  FormKit,
  {
    props: runtimeProps,
    inheritAttrs: !1
  }
), FormKit_default = formkitComponent, rootSymbol = Symbol();
function createPlugin(e, t) {
  return e.component(t.alias || "FormKit", FormKit_default).component(t.schemaAlias || "FormKitSchema", FormKitSchema_default), {
    get: getNode,
    setLocale: (n) => {
      var r;
      (r = t.config) != null && r.rootConfig && (t.config.rootConfig.locale = n);
    },
    clearErrors: clearErrors2,
    setErrors: setErrors2,
    submit: submitForm,
    reset
  };
}
var optionsSymbol = Symbol.for("FormKitOptions"), configSymbol = Symbol.for("FormKitConfig"), plugin = {
  install(e, t) {
    const n = Object.assign(
      {
        alias: "FormKit",
        schemaAlias: "FormKitSchema"
      },
      typeof t == "function" ? t() : t
    ), r = createConfig(n.config || {});
    n.config = { rootConfig: r }, e.config.globalProperties.$formkit = createPlugin(e, n), e.provide(optionsSymbol, n), e.provide(configSymbol, r), typeof window < "u" && (globalThis.__FORMKIT_CONFIGS__ = (globalThis.__FORMKIT_CONFIGS__ || []).concat([r]));
  }
}, isBrowser$2 = typeof window < "u", pseudoProps = [
  // Boolean props
  "ignore",
  "disabled",
  "preserve",
  // String props
  "help",
  "label",
  /^preserve(-e|E)rrors/,
  /^[a-z]+(?:-visibility|Visibility|-behavior|Behavior)$/,
  /^[a-zA-Z-]+(?:-class|Class)$/,
  "prefixIcon",
  "suffixIcon",
  /^[a-zA-Z-]+(?:-icon|Icon)$/
], boolProps = ["disabled", "ignore", "preserve"];
function classesToNodeProps(e, t) {
  t.classes && Object.keys(t.classes).forEach(
    (n) => {
      typeof n == "string" && (e.props[`_${n}Class`] = t.classes[n], isObject(t.classes[n]) && n === "inner" && Object.values(t.classes[n]));
    }
  );
}
function onlyListeners(e) {
  return e ? ["Submit", "SubmitRaw", "SubmitInvalid"].reduce(
    (n, r) => {
      const i = `on${r}`;
      return i in e && typeof e[i] == "function" && (n[i] = e[i]), n;
    },
    {}
  ) : {};
}
function useInput(e, t, n = {}) {
  const r = Object.assign({}, inject(optionsSymbol) || {}, n), i = inject(rootSymbol, ref(isBrowser$2 ? document : void 0)), s = inject(componentSymbol, () => {
  }), l = getCurrentInstance(), c = onlyListeners(l == null ? void 0 : l.vnode.props), u = ["modelValue", "model-value"].some(
    (uf) => uf in ((l == null ? void 0 : l.vnode.props) ?? {})
  );
  let m = !1;
  onMounted(() => {
    m = !0;
  });
  const qu = e.modelValue !== void 0 ? e.modelValue : cloneAny(t.attrs.value);
  function Gu() {
    const uf = {
      ...nodeProps(e),
      ...c,
      type: e.type ?? "text",
      __root: i.value,
      __slots: t.slots
    }, vf = except(nodeProps(t.attrs), pseudoProps);
    vf.key || (vf.key = token()), uf.attrs = vf;
    const cf = only(nodeProps(t.attrs), pseudoProps);
    for (const ff in cf)
      boolProps.includes(ff) && cf[ff] === "" && (cf[ff] = !0), uf[camel(ff)] = cf[ff];
    const yf = { props: {} };
    return classesToNodeProps(yf, e), Object.assign(uf, yf.props), typeof uf.type != "string" && (uf.definition = uf.type, delete uf.type), uf;
  }
  const Qu = Gu(), Xu = Qu.ignore ? null : e.parent || inject(parentSymbol, null), ef = createNode(
    extend$1(
      r || {},
      {
        name: e.name || void 0,
        value: qu,
        parent: Xu,
        plugins: (r.plugins || []).concat(e.plugins ?? []),
        config: e.config || {},
        props: Qu,
        index: e.index,
        sync: !!undefine(t.attrs.sync || t.attrs.dynamic)
      },
      !1,
      !0
    )
  );
  s(ef), ef.props.definition || error(600, ef);
  const tf = ref(
    new Set(
      Array.isArray(ef.props.__propDefs) ? ef.props.__propDefs : Object.keys(ef.props.__propDefs ?? {})
    )
  );
  ef.on(
    "added-props",
    ({ payload: uf }) => {
      (Array.isArray(uf) ? uf : Object.keys(uf ?? {})).forEach((cf) => tf.value.add(cf));
    }
  );
  const af = computed(
    () => pseudoProps.concat([...tf.value]).reduce((uf, vf) => (typeof vf == "string" ? (uf.push(camel(vf)), uf.push(kebab(vf))) : uf.push(vf), uf), [])
  );
  watchEffect(() => classesToNodeProps(ef, e));
  const rf = nodeProps(e);
  for (const uf in rf)
    watch$1(
      () => e[uf],
      () => {
        e[uf] !== void 0 && (ef.props[uf] = e[uf]);
      }
    );
  watchEffect(() => {
    ef.props.__root = i.value;
  });
  const hf = /* @__PURE__ */ new Set(), sf = nodeProps(t.attrs);
  watchEffect(() => {
    pf(only(sf, af.value));
  });
  function pf(uf) {
    hf.forEach((vf) => {
      vf(), hf.delete(vf);
    });
    for (const vf in uf) {
      const cf = camel(vf);
      hf.add(
        watch$1(
          () => t.attrs[vf],
          () => {
            ef.props[cf] = t.attrs[vf];
          }
        )
      );
    }
  }
  if (watchEffect(() => {
    const uf = except(nodeProps(t.attrs), af.value);
    "multiple" in uf && (uf.multiple = undefine(uf.multiple)), typeof uf.onBlur == "function" && (uf.onBlur = oncePerTick(uf.onBlur)), ef.props.attrs = Object.assign({}, ef.props.attrs || {}, uf);
  }), watchEffect(() => {
    const uf = (e.errors ?? []).map(
      (vf) => /* @__PURE__ */ createMessage({
        key: slugify(vf),
        type: "error",
        value: vf,
        meta: { source: "prop" }
      })
    );
    ef.store.apply(
      uf,
      (vf) => vf.type === "error" && vf.meta.source === "prop"
    );
  }), ef.type !== "input") {
    const uf = `${ef.name}-prop`;
    watchEffect(() => {
      const vf = e.inputErrors ?? {}, cf = Object.keys(vf);
      cf.length || ef.clearErrors(!0, uf);
      const yf = cf.reduce((ff, gf) => {
        let lf = vf[gf];
        return typeof lf == "string" && (lf = [lf]), Array.isArray(lf) && (ff[gf] = lf.map(
          (Sf) => /* @__PURE__ */ createMessage({
            key: Sf,
            type: "error",
            value: Sf,
            meta: { source: uf }
          })
        )), ff;
      }, {});
      ef.store.apply(
        yf,
        (ff) => ff.type === "error" && ff.meta.source === uf
      );
    });
  }
  watchEffect(() => Object.assign(ef.config, e.config)), ef.type !== "input" && provide(parentSymbol, ef);
  let $f;
  return ef.on("modelUpdated", () => {
    var uf, vf;
    t.emit("inputRaw", (uf = ef.context) == null ? void 0 : uf.value, ef), m && t.emit("input", (vf = ef.context) == null ? void 0 : vf.value, ef), u && ef.context && ($f = cloneAny(ef.value), t.emit("update:modelValue", shallowClone(ef.value)));
  }), u && (watch$1(
    toRef(e, "modelValue"),
    (uf) => {
      eq($f, uf) || ef.input(uf, !1);
    },
    { deep: !0 }
  ), ef.value !== qu && ef.emit("modelUpdated")), onBeforeUnmount(() => ef.destroy()), ef;
}
var totalCreated = 1;
function isComponent2(e) {
  return typeof e == "function" && e.length === 2 || typeof e == "object" && !Array.isArray(e) && !("$el" in e) && !("$cmp" in e) && !("if" in e);
}
function createInput(e, t = {}, n = {}) {
  const r = {
    type: "input",
    ...t
  };
  let i;
  if (isComponent2(e)) {
    const s = `SchemaComponent${totalCreated++}`;
    i = /* @__PURE__ */ createSection("input", () => ({
      $cmp: s,
      props: {
        context: "$node.context"
      }
    })), r.library = { [s]: markRaw(e) };
  } else typeof e == "function" ? i = e : i = /* @__PURE__ */ createSection("input", () => cloneAny(e));
  return r.schema = /* @__PURE__ */ useSchema(i || "Schema undefined", n), r.schemaMemoKey || (r.schemaMemoKey = `${Math.random()}`), r;
}
var messages = /* @__PURE__ */ createSection("messages", () => ({
  $el: "ul",
  if: "$fns.length($messages)"
})), message = /* @__PURE__ */ createSection("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
}));
messages(message("$message.value"));
var summary = /* @__PURE__ */ createSection("summary", () => ({
  $el: "div",
  attrs: {
    "aria-live": "polite"
  }
})), summaryInner = /* @__PURE__ */ createSection("summaryInner", () => ({
  $el: "div",
  if: "$summaries.length && $showSummaries"
})), messages2 = /* @__PURE__ */ createSection("messages", () => ({
  $el: "ul",
  if: "$summaries.length && $showSummaries"
})), message2 = /* @__PURE__ */ createSection("message", () => ({
  $el: "li",
  for: ["summary", "$summaries"],
  attrs: {
    key: "$summary.key",
    "data-message-type": "$summary.type"
  }
})), summaryHeader = /* @__PURE__ */ createSection("summaryHeader", () => ({
  $el: "h2",
  attrs: {
    id: "$id"
  }
})), messageLink = /* @__PURE__ */ createSection("messageLink", () => ({
  $el: "a",
  attrs: {
    id: "$summary.key",
    href: '$: "#" + $summary.id',
    onClick: "$jumpLink"
  }
}));
summary(
  summaryInner(
    summaryHeader("$summaryHeader"),
    messages2(message2(messageLink("$summary.message")))
  )
);
init_defaultConfig();
init_bindings();
const parents$1 = /* @__PURE__ */ new Set(), coords = /* @__PURE__ */ new WeakMap(), siblings = /* @__PURE__ */ new WeakMap(), animations$1 = /* @__PURE__ */ new WeakMap(), intersections = /* @__PURE__ */ new WeakMap(), options = /* @__PURE__ */ new WeakMap(), debounces = /* @__PURE__ */ new WeakMap(), enabled = /* @__PURE__ */ new WeakSet();
let root, scrollX = 0, scrollY = 0;
const TGT = "__aa_tgt", DEL = "__aa_del", NEW = "__aa_new", handleMutations = (e) => {
  const t = getElements(e);
  t && t.forEach((n) => animate$1(n));
}, handleResizes = (e) => {
  e.forEach((t) => {
    t.target === root && updateAllPos(), coords.has(t.target) && updatePos(t.target);
  });
};
function observePosition(e) {
  const t = intersections.get(e);
  t == null || t.disconnect();
  let n = coords.get(e), r = 0;
  const i = 5;
  n || (n = getCoords(e), coords.set(e, n));
  const { offsetWidth: s, offsetHeight: l } = root, u = [
    n.top - i,
    s - (n.left + i + n.width),
    l - (n.top + i + n.height),
    n.left - i
  ].map((qu) => `${-1 * Math.floor(qu)}px`).join(" "), m = new IntersectionObserver(() => {
    ++r > 1 && updatePos(e);
  }, {
    root,
    threshold: 1,
    rootMargin: u
  });
  m.observe(e), intersections.set(e, m);
}
function updatePos(e) {
  clearTimeout(debounces.get(e));
  const t = getOptions(e), n = isPlugin(t) ? 500 : t.duration;
  debounces.set(e, setTimeout(async () => {
    const r = animations$1.get(e);
    try {
      await (r == null ? void 0 : r.finished), coords.set(e, getCoords(e)), observePosition(e);
    } catch {
    }
  }, n));
}
function updateAllPos() {
  clearTimeout(debounces.get(root)), debounces.set(root, setTimeout(() => {
    parents$1.forEach((e) => forEach(e, (t) => lowPriority(() => updatePos(t))));
  }, 100));
}
function lowPriority(e) {
  typeof requestIdleCallback == "function" ? requestIdleCallback(() => e()) : requestAnimationFrame(() => e());
}
let resize;
const supportedBrowser = typeof window < "u" && "ResizeObserver" in window;
supportedBrowser && (root = document.documentElement, new MutationObserver(handleMutations), resize = new ResizeObserver(handleResizes), window.addEventListener("scroll", () => {
  scrollY = window.scrollY, scrollX = window.scrollX;
}), resize.observe(root));
function getElements(e) {
  return e.reduce((r, i) => [
    ...r,
    ...Array.from(i.addedNodes),
    ...Array.from(i.removedNodes)
  ], []).every((r) => r.nodeName === "#comment") ? !1 : e.reduce((r, i) => {
    if (r === !1)
      return !1;
    if (i.target instanceof Element) {
      if (target(i.target), !r.has(i.target)) {
        r.add(i.target);
        for (let s = 0; s < i.target.children.length; s++) {
          const l = i.target.children.item(s);
          if (l) {
            if (DEL in l)
              return !1;
            target(i.target, l), r.add(l);
          }
        }
      }
      if (i.removedNodes.length)
        for (let s = 0; s < i.removedNodes.length; s++) {
          const l = i.removedNodes[s];
          if (DEL in l)
            return !1;
          l instanceof Element && (r.add(l), target(i.target, l), siblings.set(l, [
            i.previousSibling,
            i.nextSibling
          ]));
        }
    }
    return r;
  }, /* @__PURE__ */ new Set());
}
function target(e, t) {
  !t && !(TGT in e) ? Object.defineProperty(e, TGT, { value: e }) : t && !(TGT in t) && Object.defineProperty(t, TGT, { value: e });
}
function animate$1(e) {
  var t;
  const n = e.isConnected, r = coords.has(e);
  n && siblings.has(e) && siblings.delete(e), animations$1.has(e) && ((t = animations$1.get(e)) === null || t === void 0 || t.cancel()), NEW in e ? add(e) : r && n ? remain(e) : r && !n ? remove(e) : add(e);
}
function raw(e) {
  return Number(e.replace(/[^0-9.\-]/g, ""));
}
function getScrollOffset(e) {
  let t = e.parentElement;
  for (; t; ) {
    if (t.scrollLeft || t.scrollTop)
      return { x: t.scrollLeft, y: t.scrollTop };
    t = t.parentElement;
  }
  return { x: 0, y: 0 };
}
function getCoords(e) {
  const t = e.getBoundingClientRect(), { x: n, y: r } = getScrollOffset(e);
  return {
    top: t.top + r,
    left: t.left + n,
    width: t.width,
    height: t.height
  };
}
function getTransitionSizes(e, t, n) {
  let r = t.width, i = t.height, s = n.width, l = n.height;
  const c = getComputedStyle(e);
  if (c.getPropertyValue("box-sizing") === "content-box") {
    const m = raw(c.paddingTop) + raw(c.paddingBottom) + raw(c.borderTopWidth) + raw(c.borderBottomWidth), qu = raw(c.paddingLeft) + raw(c.paddingRight) + raw(c.borderRightWidth) + raw(c.borderLeftWidth);
    r -= qu, s -= qu, i -= m, l -= m;
  }
  return [r, s, i, l].map(Math.round);
}
function getOptions(e) {
  return TGT in e && options.has(e[TGT]) ? options.get(e[TGT]) : { duration: 250, easing: "ease-in-out" };
}
function getTarget(e) {
  if (TGT in e)
    return e[TGT];
}
function isEnabled(e) {
  const t = getTarget(e);
  return t ? enabled.has(t) : !1;
}
function forEach(e, ...t) {
  t.forEach((n) => n(e, options.has(e)));
  for (let n = 0; n < e.children.length; n++) {
    const r = e.children.item(n);
    r && t.forEach((i) => i(r, options.has(r)));
  }
}
function getPluginTuple(e) {
  return Array.isArray(e) ? e : [e];
}
function isPlugin(e) {
  return typeof e == "function";
}
function remain(e) {
  const t = coords.get(e), n = getCoords(e);
  if (!isEnabled(e))
    return coords.set(e, n);
  let r;
  if (!t)
    return;
  const i = getOptions(e);
  if (typeof i != "function") {
    const s = t.left - n.left, l = t.top - n.top, [c, u, m, qu] = getTransitionSizes(e, t, n), Gu = {
      transform: `translate(${s}px, ${l}px)`
    }, Qu = {
      transform: "translate(0, 0)"
    };
    c !== u && (Gu.width = `${c}px`, Qu.width = `${u}px`), m !== qu && (Gu.height = `${m}px`, Qu.height = `${qu}px`), r = e.animate([Gu, Qu], {
      duration: i.duration,
      easing: i.easing
    });
  } else {
    const [s] = getPluginTuple(i(e, "remain", t, n));
    r = new Animation(s), r.play();
  }
  animations$1.set(e, r), coords.set(e, n), r.addEventListener("finish", updatePos.bind(null, e));
}
function add(e) {
  NEW in e && delete e[NEW];
  const t = getCoords(e);
  coords.set(e, t);
  const n = getOptions(e);
  if (!isEnabled(e))
    return;
  let r;
  if (typeof n != "function")
    r = e.animate([
      { transform: "scale(.98)", opacity: 0 },
      { transform: "scale(0.98)", opacity: 0, offset: 0.5 },
      { transform: "scale(1)", opacity: 1 }
    ], {
      duration: n.duration * 1.5,
      easing: "ease-in"
    });
  else {
    const [i] = getPluginTuple(n(e, "add", t));
    r = new Animation(i), r.play();
  }
  animations$1.set(e, r), r.addEventListener("finish", updatePos.bind(null, e));
}
function cleanUp(e, t) {
  var n;
  e.remove(), coords.delete(e), siblings.delete(e), animations$1.delete(e), (n = intersections.get(e)) === null || n === void 0 || n.disconnect(), setTimeout(() => {
    if (DEL in e && delete e[DEL], Object.defineProperty(e, NEW, { value: !0, configurable: !0 }), t && e instanceof HTMLElement)
      for (const r in t)
        e.style[r] = "";
  }, 0);
}
function remove(e) {
  var t;
  if (!siblings.has(e) || !coords.has(e))
    return;
  const [n, r] = siblings.get(e);
  Object.defineProperty(e, DEL, { value: !0, configurable: !0 });
  const i = window.scrollX, s = window.scrollY;
  if (r && r.parentNode && r.parentNode instanceof Element ? r.parentNode.insertBefore(e, r) : n && n.parentNode ? n.parentNode.appendChild(e) : (t = getTarget(e)) === null || t === void 0 || t.appendChild(e), !isEnabled(e))
    return cleanUp(e);
  const [l, c, u, m] = deletePosition(e), qu = getOptions(e), Gu = coords.get(e);
  (i !== scrollX || s !== scrollY) && adjustScroll(e, i, s, qu);
  let Qu, Xu = {
    position: "absolute",
    top: `${l}px`,
    left: `${c}px`,
    width: `${u}px`,
    height: `${m}px`,
    margin: "0",
    pointerEvents: "none",
    transformOrigin: "center",
    zIndex: "100"
  };
  if (!isPlugin(qu))
    Object.assign(e.style, Xu), Qu = e.animate([
      {
        transform: "scale(1)",
        opacity: 1
      },
      {
        transform: "scale(.98)",
        opacity: 0
      }
    ], { duration: qu.duration, easing: "ease-out" });
  else {
    const [ef, tf] = getPluginTuple(qu(e, "remove", Gu));
    (tf == null ? void 0 : tf.styleReset) !== !1 && (Xu = (tf == null ? void 0 : tf.styleReset) || Xu, Object.assign(e.style, Xu)), Qu = new Animation(ef), Qu.play();
  }
  animations$1.set(e, Qu), Qu.addEventListener("finish", cleanUp.bind(null, e, Xu));
}
function adjustScroll(e, t, n, r) {
  const i = scrollX - t, s = scrollY - n, l = document.documentElement.style.scrollBehavior;
  if (getComputedStyle(root).scrollBehavior === "smooth" && (document.documentElement.style.scrollBehavior = "auto"), window.scrollTo(window.scrollX + i, window.scrollY + s), !e.parentElement)
    return;
  const u = e.parentElement;
  let m = u.clientHeight, qu = u.clientWidth;
  const Gu = performance.now();
  function Qu() {
    requestAnimationFrame(() => {
      if (!isPlugin(r)) {
        const Xu = m - u.clientHeight, ef = qu - u.clientWidth;
        Gu + r.duration > performance.now() ? (window.scrollTo({
          left: window.scrollX - ef,
          top: window.scrollY - Xu
        }), m = u.clientHeight, qu = u.clientWidth, Qu()) : document.documentElement.style.scrollBehavior = l;
      }
    });
  }
  Qu();
}
function deletePosition(e) {
  const t = coords.get(e), [n, , r] = getTransitionSizes(e, t, getCoords(e));
  let i = e.parentElement;
  for (; i && (getComputedStyle(i).position === "static" || i instanceof HTMLBodyElement); )
    i = i.parentElement;
  i || (i = document.body);
  const s = getComputedStyle(i), l = coords.get(i) || getCoords(i), c = Math.round(t.top - l.top) - raw(s.borderTopWidth), u = Math.round(t.left - l.left) - raw(s.borderLeftWidth);
  return [c, u, n, r];
}
var wrapper = /* @__PURE__ */ createSection("wrapper", () => ({
  $el: "div",
  attrs: {
    "data-tab-style": "$tabStyle",
    "data-hide-labels": "$hideProgressLabels"
  }
})), badge = /* @__PURE__ */ createSection("badge", () => ({
  $el: "span",
  attrs: {
    role: "presentation"
  }
})), stepActions = /* @__PURE__ */ createSection("stepActions", () => ({
  $el: "div"
})), stepInner = /* @__PURE__ */ createSection("stepInner", "div"), stepNext = /* @__PURE__ */ createSection("stepNext", () => ({
  $el: "div",
  if: "$isLastStep === false || $stepIndex === 0",
  children: [
    {
      $cmp: "FormKit",
      bind: "$nextAttrs",
      props: {
        type: "button",
        label: {
          if: "$nextLabel",
          then: "$nextLabel",
          else: "$ui.next.value"
        },
        "data-next": "$isLastStep === false",
        onClick: "$handlers.next"
      }
    }
  ]
})), stepOuter = /* @__PURE__ */ createSection("stepOuter", () => ({
  $el: "div",
  attrs: {
    key: "$id",
    "data-type": "step",
    "data-disabled": "$disabled || undefined",
    "data-invalid": "$state.valid === false && $state.validationVisible || undefined",
    "data-errors": "$state.errors || undefined",
    "data-submitted": "$state.submitted || undefined",
    id: "$id",
    role: "tabpanel",
    "aria-labelledby": '$node.parent.props.id + "_tab_" + $stepIndex',
    class: "$classes.step",
    hidden: "$isActiveStep === false || undefined"
  }
})), stepPrevious = /* @__PURE__ */ createSection("stepPrevious", () => ({
  $el: "div",
  if: "$isFirstStep === false",
  children: [
    {
      $cmp: "FormKit",
      bind: "$previousAttrs",
      props: {
        type: "button",
        label: {
          if: "$previousLabel",
          then: "$previousLabel",
          else: "$ui.prev.value"
        },
        "data-prev": "$isFirstStep === false",
        onClick: "$handlers.previous"
      }
    }
  ]
})), steps = /* @__PURE__ */ createSection("steps", () => ({
  $el: "div"
})), stepIcon = (e, t) => (/* @__PURE__ */ createSection(`${e}Icon`, () => {
  const n = `_raw${e.charAt(0).toUpperCase()}${e.slice(1)}Icon`;
  return {
    if: `$step.${e}Icon && $step.${n}`,
    then: {
      $el: "span",
      attrs: {
        class: `$classes.${e}Icon + " formkit-icon"`,
        innerHTML: `$step.${n}`,
        role: "presentation",
        onClick: `$handlers.iconClick(${e})`
      }
    },
    else: {
      if: `$${e}Icon && $${n}`,
      then: {
        $el: "span",
        attrs: {
          class: `$classes.${e}Icon + " formkit-icon"`,
          innerHTML: `$${n}`,
          role: "presentation",
          onClick: `$handlers.iconClick(${e})`
        }
      }
    }
  };
}))(), tab = /* @__PURE__ */ createSection("tab", () => ({
  $el: "button",
  for: ["step", "index", "$fns.getSteps()"],
  attrs: {
    key: "$step.id",
    type: "button",
    onClick: "$step.makeActive",
    "data-active": "$step.isActiveStep",
    "data-valid": "$step.isValid",
    "data-visited": "$step.hasBeenVisited",
    role: "tab",
    id: '$id + "_tab_" + $index',
    "aria-selected": "$step.isActiveStep || false",
    "aria-controls": "$step.id",
    tabindex: {
      if: "$step.isActiveStep",
      then: "0",
      else: "-1"
    }
  }
})), tabLabel = /* @__PURE__ */ createSection("tabLabel", () => ({
  $el: "span"
})), tabs = /* @__PURE__ */ createSection("tabs", () => ({
  $el: "div",
  attrs: {
    role: "tablist"
  }
})), multiStepOuter = /* @__PURE__ */ createSection("multiStepOuter", () => ({
  $el: "div",
  attrs: {
    key: "$id",
    id: "$id",
    class: "$classes.outer",
    "data-prerender": "$fns.preRenderSteps()",
    "data-family": "$family || undefined",
    "data-type": "$type",
    "data-multiple": '$attrs.multiple || ($type != "select" && $options != undefined) || undefined',
    "data-disabled": "$disabled || undefined",
    "data-invalid": "$state.valid === false && $state.validationVisible || undefined",
    "data-errors": "$state.errors || undefined",
    "data-submitted": "$state.submitted || undefined"
  }
})), multiStep = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: multiStepOuter(
    wrapper(
      tabs(
        tab(
          /* @__PURE__ */ $if(
            '$tabStyle === "tab" || ($tabStyle === "progress" && $hideProgressLabels === false)',
            tabLabel("$step.stepName")
          ),
          /* @__PURE__ */ $if(
            "($step.totalErrorCount > 0) && $step.showStepErrors",
            badge("$step.totalErrorCount")
          ),
          /* @__PURE__ */ $if(
            "$step.isValid && $step.hasBeenVisited",
            badge(stepIcon("validStep"))
          )
        )
      ),
      steps("$slots.default")
    )
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "multi-step",
  /**
   * An array of extra props to accept for this input.
   */
  props: [
    "allowIncomplete",
    "hideProgressLabels",
    "tabStyle",
    "beforeStepChange",
    "validStepIcon"
  ],
  /**
   * Additional features that should be added to your input
   */
  features: [defaultIcon("validStep", "check"), disables]
}, step = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: stepOuter(
    stepInner("$slots.default"),
    stepActions(stepPrevious(), stepNext())
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "",
  /**
   * An array of extra props to accept for this input.
   */
  props: [
    "previousLabel",
    "nextLabel",
    "beforeStepChange",
    "previousAttrs",
    "nextAttrs",
    "validStepIcon"
  ],
  /**
   * Additional features that should be added to your input
   */
  features: [localize("next"), localize("prev"), disables]
}, isBrowser$1 = typeof window < "u", camel2title = (e) => e && e.replace(/([A-Z])/g, (t) => ` ${t}`).replace(/^./, (t) => t.toUpperCase()).trim();
function orderSteps(e, t) {
  if (!isBrowser$1 || !t)
    return t;
  const n = [...t];
  return n.sort((r, i) => {
    var c, u;
    const s = (c = e.props.__root) == null ? void 0 : c.getElementById(r.id), l = (u = e.props.__root) == null ? void 0 : u.getElementById(i.id);
    return !s || !l ? 0 : s.compareDocumentPosition(l) === 2 ? 1 : -1;
  }), n.map((r) => {
    r.ordered = !0;
  }), n;
}
function setNodePositionProps(e) {
  e && e.forEach((t, n) => {
    t.isFirstStep = n === 0, t.isLastStep = n === e.length - 1, t.stepIndex = n, t.steps = e;
  });
}
function showStepErrors(e) {
  if (e.showStepErrors)
    return parseInt(e.blockingCount) + parseInt(e.errorCount) > 0;
}
async function isTargetStepAllowed(e, t) {
  var m, qu, Gu;
  if (e === t)
    return !0;
  const { allowIncomplete: n } = ((m = e.node.parent) == null ? void 0 : m.props) || {}, r = e.node.parent, i = r == null ? void 0 : r.props.steps.indexOf(e), s = r == null ? void 0 : r.props.steps.indexOf(t), l = triggerStepValidations(e);
  if (e.showStepErrors = !0, s >= i && !l && !n)
    return !1;
  const c = s - i;
  for (let Qu = 0; Qu < c; Qu++) {
    const Xu = r == null ? void 0 : r.props.steps[i + Qu];
    if (!(n || ((qu = Xu.state) == null ? void 0 : qu.valid)))
      return !1;
  }
  const u = e.node.props.beforeStepChange || ((Gu = e.node.parent) == null ? void 0 : Gu.props.beforeStepChange);
  if (u && typeof u == "function") {
    r && (r == null || r.store.set(
      /* @__PURE__ */ createMessage({
        key: "loading",
        value: !0,
        visible: !1
      })
    ), r.props.disabled = !0, e.disabled = !0);
    const Qu = await u({
      currentStep: e,
      targetStep: t,
      delta: s - i
    });
    if (r && (r == null || r.store.remove("loading"), r.props.disabled = !1, e.disabled = !1), typeof Qu == "boolean" && !Qu)
      return !1;
  }
  return !0;
}
async function setActiveStep(e, t) {
  if (t && t.preventDefault(), e && e.node.name && e.node.parent) {
    const n = e.node.parent.props.steps.find(
      (i) => {
        var s;
        return i.node.name === ((s = e.node.parent) == null ? void 0 : s.props.activeStep);
      }
    );
    await isTargetStepAllowed(n, e) && e.node.parent.context && (e.node.parent.props.activeStep = e.node.name);
  }
}
async function incrementStep(e, t) {
  if (t && t.node.name && t.node.parent) {
    const n = t.node.parent.props.steps, r = t.stepIndex, i = n[r + e];
    if (!i)
      return;
    const s = await isTargetStepAllowed(t, i);
    i && s && (t.node.parent.props.activeStep = i.node.name);
  }
}
function triggerStepValidations(e) {
  var t, n;
  return e.node.walk((r) => {
    r.store.set(
      /* @__PURE__ */ createMessage({
        key: "submitted",
        value: !0,
        visible: !1
      })
    );
  }), ((t = e.node.context) == null ? void 0 : t.state.valid) || ((n = e.node.parent) == null ? void 0 : n.props.allowIncomplete);
}
function initEvents(e, t) {
  t instanceof HTMLElement && t.addEventListener("keydown", (n) => {
    var r;
    if (n.target instanceof HTMLButtonElement && n.key === "Tab" && "data-next" in ((r = n.target) == null ? void 0 : r.attributes) && !n.shiftKey) {
      n.preventDefault();
      const i = e.children.find(
        (s) => !isPlaceholder(s) && s.name === e.props.activeStep
      );
      i && i.context && incrementStep(1, i.context);
    }
  });
}
function createSSRStepsFromTabs(e) {
  return !e || !e.length ? [] : (e[0].type == Symbol.for("v-fgt") && e[0].children ? e[0].children : e).map(
    (r, i) => {
      var s, l, c;
      return {
        __isPlaceholder: !0,
        stepName: ((s = r.props) == null ? void 0 : s.label) || camel2title((l = r.props) == null ? void 0 : l.name),
        isFirstStep: i === 0,
        isLastStep: i === e.length - 1,
        isActiveStep: i === 0,
        node: {
          name: (c = r.props) == null ? void 0 : c.name
        }
      };
    }
  );
}
function createPreRenderStepsFunction(e) {
  return () => {
    if (!e.context || e.props.steps)
      return;
    let t = [];
    e.context.slots && e.context.slots.default && (t = e.context.slots.default()), e.props.steps = e.props.steps || createSSRStepsFromTabs(t), e.context.stepCount = e.props.steps.length;
  };
}
function createMultiStepPlugin(e) {
  let t = !0;
  const n = (r) => {
    var i, s;
    if (r.props.type === "multi-step") {
      if (!r.context)
        return;
      t = !0, r.addProps(["steps", "tabs", "activeStep"]), r.context.fns.preRenderSteps = createPreRenderStepsFunction(r), r.context.fns.getStepCount = () => {
        if (r.context)
          return r.context.stepCount;
      }, r.context.fns.getSteps = () => {
        if (r.context)
          return r.context.steps;
      }, r.props.allowIncomplete = typeof r.props.allowIncomplete == "boolean" ? r.props.allowIncomplete : !0, r.props.hideProgressLabels = typeof r.props.hideProgressLabels == "boolean" ? r.props.hideProgressLabels : !1, r.props.tabStyle = r.props.tabStyle || (e == null ? void 0 : e.tabStyle) || "tab", r.context.handlers.triggerStepValidations = triggerStepValidations, r.context.handlers.showStepErrors = showStepErrors, r.on("created", () => {
        r.context && (r.extend("next", {
          get: (l) => () => {
            var c;
            incrementStep(
              1,
              (c = l == null ? void 0 : l.props) == null ? void 0 : c.steps.find(
                (u) => u.isActiveStep
              )
            );
          },
          set: !1
        }), r.extend("previous", {
          get: (l) => () => {
            var c;
            incrementStep(
              -1,
              (c = l == null ? void 0 : l.props) == null ? void 0 : c.steps.find(
                (u) => u.isActiveStep
              )
            );
          },
          set: !1
        }), r.extend("goTo", {
          get: (l) => (c) => {
            if (typeof c == "number") {
              const u = l.props.steps[c];
              setActiveStep(u);
            } else if (typeof c == "string") {
              const u = l.props.steps.find(
                (m) => m.node.name === c
              );
              setActiveStep(u);
            }
          },
          set: !1
        }), whenAvailable(
          `${r.props.id}`,
          (l) => {
            initEvents(r, l);
          },
          r.props.__root
        ));
      }), r.on("child", ({ payload: l }) => {
        r.props.steps && r.props.steps.length && (r.props.steps = r.props.steps.filter(
          (c) => !c.__isPlaceholder
        )), r.props.steps = Array.isArray(r.props.steps) && r.props.steps.length > 0 ? [...r.props.steps, l.context] : [l.context], r.props.steps = orderSteps(r, r.props.steps), setNodePositionProps(r.props.steps), l.props.stepName = l.props.label || camel2title(l.name), l.props.errorCount = 0, l.props.blockingCount = 0, l.props.isActiveStep = t, t = !1, r.props.activeStep = r.props.activeStep ? r.props.activeStep : r.props.steps[0] ? r.props.steps[0].node.name : "";
      }), r.on("prop:activeStep", ({ payload: l }) => {
        r.children.forEach((c) => {
          var u;
          if (!isPlaceholder(c) && (c.props.isActiveStep = c.name === l, isBrowser$1 && c.name === l)) {
            const m = (u = r.props.__root) == null ? void 0 : u.querySelector(
              `[aria-controls="${c.props.id}"]`
            );
            m instanceof HTMLButtonElement && m.focus();
          }
        });
      }), r.on("childRemoved", ({ payload: l }) => {
        let c = -1;
        if (l.props.ordered = !1, r.props.steps = r.props.steps.filter(
          (u, m) => u.node.name !== l.name ? !0 : (c = m, !1)
        ), setNodePositionProps(r.props.steps), r.props.activeStep === l.name) {
          const u = c > 0 ? c - 1 : 0;
          r.props.activeStep = r.props.steps[u] ? r.props.steps[u].node.name : "";
        }
      });
    } else if (r.props.type === "step" && ((i = r.parent) == null ? void 0 : i.props.type) === "multi-step") {
      let l = function(u) {
        u.props.totalErrorCount = u.props.errorCount + u.props.blockingCount;
      };
      if (!r.context || !r.parent || !r.parent.context)
        return;
      r.addProps([
        "isActiveStep",
        "isFirstStep",
        "isLastStep",
        "stepName",
        "errorCount",
        "blockingCount",
        "totalErrorCount",
        "showStepErrors",
        "isValid",
        "hasBeenVisited",
        "ordered"
      ]);
      const c = r.parent;
      r.on("created", () => {
        !r.context || !c.context || whenAvailable(
          `${r.props.id}`,
          () => {
            c.props.steps = orderSteps(r, c.props.steps), setNodePositionProps(c.props.steps);
          },
          r.props.__root
        );
      }), r.context && c.context && (c.context.handlers.setActiveStep = (u) => setActiveStep.bind(null, u), r.context.handlers.incrementStep = (u) => () => incrementStep(u, r.context), r.context.makeActive = () => {
        setActiveStep(r.context);
      }, r.context.handlers.next = () => incrementStep(1, r.context), r.context.handlers.previous = () => incrementStep(-1, r.context)), r.on("count:errors", ({ payload: u }) => {
        r.props.errorCount = u;
      }), r.on("count:blocking", ({ payload: u }) => {
        r.props.blockingCount = u;
      }), r.on("prop:errorCount", () => l(r)), r.on("prop:blockingCount", () => l(r)), r.on("prop:totalErrorCount", () => {
        r.props.isValid = r.props.totalErrorCount <= 0;
      }), r.on("message-added", ({ payload: u }) => {
        u.key === "submitted" && (l(r), r.context && (triggerStepValidations(r.context), r.props.showStepErrors = !0));
      }), r.on("prop:isActiveStep", () => {
        !r.props.hasBeenVisited && r.props.isActiveStep && (r.props.hasBeenVisited = !0);
      });
    } else ((s = r.parent) == null ? void 0 : s.props.type) === "multi-step" && console.warn(
      'Invalid FormKit input location. <FormKit type="multi-step"> should only have <FormKit type="step"> inputs as immediate children. Failure to wrap child inputs in <FormKit type="step"> can lead to undesired behaviors.'
    );
  };
  return n.library = (r) => {
    switch (r.props.type) {
      case "multi-step":
        return r.define(multiStep);
      case "step":
        return (!r.parent || r.parent.props.type !== "multi-step") && console.warn(
          'Invalid use of <FormKit type="step">. <FormKit type="step"> must be an immediate child of a <FormKit type="multi-step"> component.'
        ), r.define(step);
    }
  }, n;
}
function throttle(e, t) {
  var n = !1;
  return function(...r) {
    n || (e.call(null, ...r), n = !0, setTimeout(function() {
      n = !1;
    }, t));
  };
}
function splitClass(e) {
  return e.split(" ").filter((t) => t);
}
var isBrowser = typeof window < "u";
function addClass(e, t, n = !1) {
  if (!t)
    return;
  const r = splitClass(t);
  if (r.length && !r.includes("longTouch"))
    for (const i of e) {
      if (!isNode(i) || !nodes.has(i)) {
        i.classList.add(...r);
        continue;
      }
      const s = [], l = nodes.get(i);
      if (l) {
        for (const c of r)
          i.classList.contains(c) ? i.classList.contains(c) && n === !1 && s.push(c) : i.classList.add(c);
        l.privateClasses = s, nodes.set(i, l);
      }
    }
}
function removeClass(e, t) {
  if (!t)
    return;
  const n = splitClass(t);
  if (n.length)
    for (const r of e) {
      if (!isNode(r)) {
        r.classList.remove(...n);
        continue;
      }
      const i = nodes.get(r);
      if (i)
        for (const s of n)
          i.privateClasses.includes(s) || r.classList.remove(s);
    }
}
function getScrollParent(e) {
  let t = e.parentNode;
  for (; t !== null && t.nodeType === 1 && t instanceof HTMLElement; ) {
    const r = window.getComputedStyle(t).getPropertyValue("overflow");
    if (r === "scroll" || r === "auto")
      return t;
    t = t.parentNode;
  }
  return document.documentElement;
}
function getElFromPoint(e) {
  if (!(e.e instanceof TouchEvent))
    return;
  const t = e.e.touches[0].clientX, n = e.e.touches[0].clientY;
  let r = document.elementFromPoint(t, n);
  if (!isNode(r))
    return;
  let i, s = !0;
  for (; r && s; ) {
    if (nodes.has(r) || parents.has(r)) {
      s = !1, i = parents.has(r);
      break;
    }
    r = r.parentNode;
  }
  if (i) {
    const l = parents.get(r);
    return l ? {
      parent: {
        el: r,
        data: l
      }
    } : void 0;
  } else {
    const l = nodes.get(r);
    if (!l)
      return;
    const c = parents.get(r.parentNode);
    return c ? {
      node: {
        el: r,
        data: l
      },
      parent: {
        el: r.parentNode,
        data: c
      }
    } : void 0;
  }
}
function isNode(e) {
  return e instanceof HTMLElement && e.parentNode instanceof HTMLElement;
}
function addEvents(e, t) {
  const n = new AbortController();
  for (const r in t) {
    const i = t[r];
    e.addEventListener(r, i, {
      signal: n.signal,
      passive: !1
    });
  }
  return n;
}
function copyNodeStyle(e, t, n = !1) {
  const r = window.getComputedStyle(e), i = [
    "position",
    "z-index",
    "top",
    "left",
    "x",
    "pointer-events",
    "y",
    "transform-origin",
    "filter",
    "-webkit-text-fill-color"
  ];
  for (const s of Array.from(r))
    n === !1 && s && i.includes(s) || t.style.setProperty(
      s,
      r.getPropertyValue(s),
      r.getPropertyPriority(s)
    );
  for (const s of Array.from(e.children)) {
    if (!isNode(s))
      continue;
    const l = t.children[Array.from(e.children).indexOf(s)];
    copyNodeStyle(s, l, n);
  }
}
function eventCoordinates(e) {
  return e instanceof DragEvent ? { x: e.clientX, y: e.clientY } : { x: e.touches[0].clientX, y: e.touches[0].clientY };
}
var multiDragState = {
  selectedNodes: Array(),
  activeNode: void 0,
  isTouch: !1
};
function multiDrag(e = {}) {
  return (t) => {
    const n = parents.get(t);
    if (!n)
      return;
    const r = {
      ...n.config,
      multiDragConfig: e
    };
    return {
      setup() {
        var i, s;
        r.handleDragstart = e.multiHandleDragstart || multiHandleDragstart, r.handleTouchstart = e.multiHandleTouchstart || multiHandleTouchstart, r.handleEnd = e.multiHandleEnd || multiHandleEnd, r.reapplyDragClasses = e.multiReapplyDragClasses || multiReapplyDragClasses, n.config = r, (i = r.multiDragConfig.plugins) == null || i.forEach((l) => {
          var c, u;
          (u = (c = l(t)) == null ? void 0 : c.tearDown) == null || u.call(c);
        }), (s = r.multiDragConfig.plugins) == null || s.forEach((l) => {
          var c, u;
          (u = (c = l(t)) == null ? void 0 : c.setup) == null || u.call(c);
        });
      },
      tearDownNodeRemap(i) {
        var s, l;
        (l = (s = r.multiDragConfig) == null ? void 0 : s.plugins) == null || l.forEach((c) => {
          var u, m;
          (m = (u = c(i.parent)) == null ? void 0 : u.tearDownNodeRemap) == null || m.call(u, i);
        });
      },
      tearDownNode(i) {
        var s, l;
        (l = (s = r.multiDragConfig) == null ? void 0 : s.plugins) == null || l.forEach((c) => {
          var u, m;
          (m = (u = c(i.parent)) == null ? void 0 : u.tearDownNode) == null || m.call(u, i);
        });
      },
      setupNodeRemap(i) {
        var s, l;
        (l = (s = r.multiDragConfig) == null ? void 0 : s.plugins) == null || l.forEach((c) => {
          var u, m;
          (m = (u = c(i.parent)) == null ? void 0 : u.setupNodeRemap) == null || m.call(u, i);
        });
      },
      setupNode(i) {
        var s, l;
        (l = (s = r.multiDragConfig) == null ? void 0 : s.plugins) == null || l.forEach((c) => {
          var u, m;
          (m = (u = c(i.parent)) == null ? void 0 : u.setupNode) == null || m.call(u, i);
        });
      }
    };
  };
}
function multiReapplyDragClasses(e, t) {
  if (!state)
    return;
  const n = "touchedNode" in state ? t.config.multiDragConfig.touchDropZoneClass : t.config.multiDragConfig.dropZoneClass;
  state.draggedNodes.map((i) => i.el).includes(e) && addClass([e], n, !0);
}
function multiHandleEnd(e) {
  !state || state && "touchedNode" in state && "touchMoving" in state && !state.touchMoving || (end(e, state), selectionsEnd(e, state), resetState());
}
function selectionsEnd(e, t) {
  var l;
  const n = e.targetData.parent.data.config.multiDragConfig, r = (l = e.targetData.parent.data.config.selectionsConfig) == null ? void 0 : l.selectedClass, i = t && "touchedNode" in t;
  r && removeClass(
    multiDragState.selectedNodes.map((c) => c.el),
    r
  ), multiDragState.selectedNodes = [], multiDragState.activeNode = void 0;
  const s = i ? n.selectionDropZoneClass : n.touchSelectionDraggingClass;
  removeClass(
    t.draggedNodes.map((c) => c.el),
    s
  );
}
function multiHandleDragstart(e) {
  e.e instanceof DragEvent && dragstart({
    e: e.e,
    targetData: e.targetData
  });
}
function dragstart(e) {
  const t = initDrag(e);
  multiDragState.isTouch = !1;
  const n = e.targetData.parent.data.config.multiDragConfig, r = e.targetData.parent.data.getValues(
    e.targetData.parent.el
  );
  let i = multiDragState.selectedNodes.length ? multiDragState.selectedNodes.map((l) => l.data.value) : n.selections && n.selections(r, e.targetData.parent.el);
  if (i === void 0)
    return;
  if (!i.includes(e.targetData.node.data.value)) {
    i = [e.targetData.node.data.value, ...i];
    const l = e.targetData.parent.data.config.selectionsConfig;
    addClass([e.targetData.node.el], l == null ? void 0 : l.selectedClass, !0), multiDragState.selectedNodes.push(e.targetData.node);
  }
  const s = e.targetData.node.el.style.zIndex;
  if (t.originalZIndex = s, e.targetData.node.el.style.zIndex = "9999", Array.isArray(i) && i.length) {
    const l = e.targetData.node.el.getBoundingClientRect(), [c, u] = [
      e.e.clientX - l.left,
      e.e.clientY - l.top
    ];
    stackNodes(handleSelections(e, i, t, c, u));
  } else {
    const l = e.targetData.parent.data.config;
    dragstartClasses(
      t.draggedNode.el,
      l.draggingClass,
      l.dropZoneClass
    );
  }
}
function multiHandleTouchstart(e) {
  e.e instanceof TouchEvent && touchstart({
    e: e.e,
    targetData: e.targetData
  });
}
function touchstart(e) {
  const t = initTouch(e);
  multiDragState.isTouch = !0, multiDragState.activeNode = e.targetData.node;
  const n = e.targetData.parent.data.config.multiDragConfig, r = e.targetData.parent.data.getValues(
    e.targetData.parent.el
  );
  let i = [];
  e.targetData.parent.data.config.selectionsConfig ? i = multiDragState.selectedNodes.map((l) => l.data.value) : i = n.selections && n.selections(r, e.targetData.parent.el), i = [e.targetData.node.data.value, ...i];
  const s = e.targetData.parent.data.config.selectionsConfig;
  addClass([e.targetData.node.el], s == null ? void 0 : s.selectedClass, !0), Array.isArray(i) && i.length ? stackNodes(
    handleSelections(
      e,
      i,
      t,
      t.touchStartLeft,
      t.touchStartTop
    )
  ) : handleTouchedNode(e, t), handleLongTouch(e, t);
}
function handleSelections(e, t, n, r, i) {
  for (const c of e.targetData.parent.data.enabledNodes)
    c.el !== n.draggedNode.el && t.includes(c.data.value) && n.draggedNodes.push(c);
  const s = e.targetData.parent.data.config.multiDragConfig, l = n.draggedNodes.map((c) => {
    const u = c.el.cloneNode(!0);
    return copyNodeStyle(c.el, u, !0), e.e instanceof DragEvent && addClass([u], s.draggingClass), u;
  });
  return setTimeout(() => {
    e.e instanceof DragEvent && addClass(
      n.draggedNodes.map((c) => c.el),
      s.dropZoneClass
    );
  }), n.clonedDraggedEls = l, { data: e, state: n, x: r, y: i };
}
function stackNodes({
  data: e,
  state: t,
  x: n,
  y: r
}) {
  var l;
  const i = document.createElement("div");
  for (const c of t.clonedDraggedEls)
    c instanceof HTMLElement && (c.style.pointerEvents = "none"), i.append(c);
  const { width: s } = t.draggedNode.el.getBoundingClientRect();
  i.style.cssText = `
        display: flex;
        flex-direction: column;
        width: ${s}px;
        position: fixed;
        pointer-events: none;
        z-index: 9999;
        left: -9999px
      `, document.body.append(i), e.e instanceof DragEvent ? ((l = e.e.dataTransfer) == null || l.setDragImage(i, n, r), setTimeout(() => {
    i.remove();
  })) : "touchedNode" in t && (t.touchedNode = i);
}
var slideUp = [
  {
    transform: "translateY(100%)"
  },
  {
    transform: "translateY(0)"
  }
], slideDown = [
  {
    transform: "translateY(-100%)"
  },
  {
    transform: "translateY(0)"
  }
], slideLeft = [
  {
    transform: "translateX(100%)"
  },
  {
    transform: "translateX(0)"
  }
], slideRight = [
  {
    transform: "translateX(-100%)"
  },
  {
    transform: "translateX(0)"
  }
];
function animations(e = {}) {
  return (t) => {
    const n = parents.get(t);
    if (n)
      return {
        setup() {
          n.config.remapFinished = () => {
          }, document.head.querySelector("[data-drag-and-drop]");
        },
        setupNodeRemap(r) {
          if (!state)
            return;
          const i = e.duration || 150;
          if (r.nodeData.value === state.draggedNode.data.value) {
            switch (state.incomingDirection) {
              case "below":
                animate(r.node, slideUp, i);
                break;
              case "above":
                animate(r.node, slideDown, i);
                break;
              case "left":
                animate(r.node, slideRight, i);
                break;
              case "right":
                animate(r.node, slideLeft, i);
                break;
            }
            return;
          }
          if (!state.affectedNodes.map((qu) => qu.data.value).includes(r.nodeData.value))
            return;
          const s = r.node.getBoundingClientRect(), l = state.affectedNodes.findIndex(
            (qu) => qu.data.value === r.nodeData.value
          ), u = state.draggedNode.data.index >= state.targetIndex;
          let m;
          if (u ? m = state.affectedNodes[l + 1] ? state.affectedNodes[l + 1] : state.affectedNodes[l - 1] : m = state.affectedNodes[l - 1] ? state.affectedNodes[l - 1] : state.affectedNodes[l + 1], m) {
            const qu = Math.abs(
              s.x - m.el.getBoundingClientRect().x
            ), Gu = Math.abs(
              s.y - m.el.getBoundingClientRect().y
            );
            qu > Gu && u ? animate(r.node, slideRight, i) : qu > Gu && !u && animate(r.node, slideLeft, i);
          } else
            switch (state.incomingDirection) {
              case "below":
                animate(r.node, slideDown, i);
                break;
              case "above":
                animate(r.node, slideUp, i);
                break;
              case "left":
                animate(r.node, slideLeft, i);
                break;
              case "right":
                animate(r.node, slideRight, i);
                break;
            }
        }
      };
  };
}
function animate(e, t, n) {
  state && (state.preventEnter = !0, e.animate(t, {
    duration: n
  }), setTimeout(() => {
    state && (state.swappedNodeValue = void 0, state.remapJustFinished = !0, state.lastTargetValue = void 0, state.preventEnter = !1);
  }, n));
}
var scrollConfig = {
  up: [0, -1],
  down: [0, 1],
  left: [-1, 0],
  right: [1, 0]
}, nodes = /* @__PURE__ */ new WeakMap(), parents = /* @__PURE__ */ new WeakMap(), state = void 0;
function resetState() {
  state = void 0;
}
function setDragState(e) {
  return state = {
    ascendingDirection: !1,
    incomingDirection: void 0,
    enterCount: 0,
    targetIndex: 0,
    affectedNodes: [],
    lastValue: void 0,
    activeNode: void 0,
    lastTargetValue: void 0,
    remapJustFinished: !1,
    preventEnter: !1,
    clonedDraggedEls: [],
    swappedNodeValue: !1,
    originalZIndex: void 0,
    ...e
  }, state;
}
function setTouchState(e, t) {
  return state = {
    ...e,
    ...t
  }, state;
}
function dragStateProps(e) {
  const { x: t, y: n } = eventCoordinates(e.e);
  return {
    coordinates: {
      x: t,
      y: n
    },
    draggedNode: {
      el: e.targetData.node.el,
      data: e.targetData.node.data
    },
    draggedNodes: [
      {
        el: e.targetData.node.el,
        data: e.targetData.node.data
      }
    ],
    initialIndex: e.targetData.node.data.index,
    initialParent: {
      el: e.targetData.parent.el,
      data: e.targetData.parent.data
    },
    lastParent: {
      el: e.targetData.parent.el,
      data: e.targetData.parent.data
    },
    scrollParent: getScrollParent(e.targetData.node.el)
  };
}
function performSort(e, t) {
  const n = dragValues(e), i = [
    ...parentValues(
      t.targetData.parent.el,
      t.targetData.parent.data
    ).filter((s) => !n.includes(s))
  ];
  i.splice(t.targetData.node.data.index, 0, ...n), e.lastTargetValue = t.targetData.node.data.value, setParentValues(t.targetData.parent.el, t.targetData.parent.data, [
    ...i
  ]);
}
function parentValues(e, t) {
  return [...t.getValues(e)];
}
function setParentValues(e, t, n) {
  t.setValues(n, e);
}
function dragValues(e) {
  return [...e.draggedNodes.map((t) => t.data.value)];
}
function dragAndDrop({
  parent: e,
  getValues: t,
  setValues: n,
  config: r = {}
}) {
  var s, l;
  if (!isBrowser)
    return;
  document.addEventListener("dragover", (c) => {
    if (c.preventDefault(), state) {
      state.remapJustFinished = !1, state.lastTargetValue = void 0;
      const { x: u, y: m } = eventCoordinates(c);
      state.coordinates.y = m, state.coordinates.x = u, handleScroll();
    }
  }), tearDown(e);
  const i = {
    getValues: t,
    setValues: n,
    config: {
      handleDragstart,
      handleDragoverNode,
      handleDragoverParent,
      handleEnd,
      handleTouchstart,
      handleTouchmove,
      handleTouchOverNode,
      handleTouchOverParent,
      performSort,
      performTransfer,
      root: document,
      setupNode,
      setupNodeRemap,
      reapplyDragClasses,
      tearDownNode,
      tearDownNodeRemap,
      remapFinished,
      scrollBehavior: {
        x: 0.8,
        y: 0.8
      },
      threshold: {
        horizontal: 0,
        vertical: 0
      },
      ...r
    },
    enabledNodes: [],
    abortControllers: {}
  };
  setup(e, i), (s = r.plugins) == null || s.forEach((c) => {
    var u, m;
    (m = (u = c(e)) == null ? void 0 : u.tearDown) == null || m.call(u);
  }), (l = r.plugins) == null || l.forEach((c) => {
    var u, m;
    (m = (u = c(e)) == null ? void 0 : u.setup) == null || m.call(u);
  }), remapNodes(e, !0);
}
function tearDown(e) {
  const t = parents.get(e);
  t && t.abortControllers.mainParent && t.abortControllers.mainParent.abort();
}
function setup(e, t) {
  new MutationObserver(nodesMutated).observe(e, { childList: !0 }), parents.set(e, t), t.abortControllers.mainParent = addEvents(e, {
    dragover: parentEventData(
      throttle(t.config.handleDragoverParent, 10)
    ),
    touchOverParent: t.config.handleTouchOverParent
  });
}
function nodesMutated(e) {
  const t = e[0].target;
  t instanceof HTMLElement && remapNodes(t);
}
function remapNodes(e, t) {
  const n = parents.get(e);
  if (!n)
    return;
  const r = [], i = n.config;
  for (let c = 0; c < e.children.length; c++) {
    const u = e.children[c];
    if (!isNode(u))
      continue;
    const m = nodes.get(u);
    (t || !m) && i.tearDownNode({ node: u, parent: e, nodeData: m, parentData: n }), !i.disabled && (!i.draggable || i.draggable && i.draggable(u)) && r.push(u);
  }
  if (r.length !== n.getValues(e).length && !i.disabled) {
    console.warn(
      "The number of enabled nodes does not match the number of values."
    );
    return;
  }
  const s = n.getValues(e), l = [];
  for (let c = 0; c < r.length; c++) {
    const u = r[c], m = nodes.get(u), qu = Object.assign(
      m ?? {
        privateClasses: [],
        abortControllers: {}
      },
      {
        value: s[c],
        index: c
      }
    );
    if (state && qu.value === state.draggedNode.data.value && (state.draggedNode.data = qu, state.draggedNode.el = u), state && state.draggedNodes.map((Qu) => Qu.data.value).includes(qu.value)) {
      const Qu = state.draggedNodes.find(
        (Xu) => Xu.data.value === qu.value
      );
      Qu && (Qu.el = u);
    }
    l.push({
      el: u,
      data: qu
    });
    const Gu = {
      node: u,
      parent: e,
      parentData: n,
      nodeData: qu
    };
    (t || !m) && i.setupNode(Gu), setupNodeRemap(Gu);
  }
  parents.set(e, { ...n, enabledNodes: l }), i.remapFinished(n);
}
function remapFinished() {
  state && (state.preventEnter = !1, state.swappedNodeValue = void 0, state.remapJustFinished = !0);
}
function handleDragstart(e) {
  e.e instanceof DragEvent && dragstart2({
    e: e.e,
    targetData: e.targetData
  });
}
function dragstartClasses(e, t, n) {
  addClass([e], t), setTimeout(() => {
    removeClass([e], t), addClass([e], n);
  });
}
function initDrag(e) {
  const t = setDragState(dragStateProps(e));
  return e.e.stopPropagation(), e.e.dataTransfer && (e.e.dataTransfer.dropEffect = "move", e.e.dataTransfer.effectAllowed = "move", e.e.dataTransfer.setDragImage(
    e.targetData.node.el,
    e.e.offsetX,
    e.e.offsetY
  )), t;
}
function validateDragHandle(e) {
  if (!(e.e instanceof DragEvent) && !(e.e instanceof TouchEvent))
    return !1;
  const t = e.targetData.parent.data.config;
  if (!t.dragHandle)
    return !0;
  const n = e.targetData.node.el.querySelectorAll(
    t.dragHandle
  );
  if (!n)
    return !1;
  const r = eventCoordinates(e.e), i = t.root.elementFromPoint(
    r.x,
    r.y
  );
  if (!i)
    return !1;
  for (const s of Array.from(n))
    if (i === s || s.contains(i))
      return !0;
  return !1;
}
function touchstart2(e) {
  if (!validateDragHandle(e))
    return;
  const t = initTouch(e);
  handleTouchedNode(e, t), handleLongTouch(e, t);
}
function dragstart2(e) {
  if (!validateDragHandle(e)) {
    e.e.preventDefault();
    return;
  }
  const t = e.targetData.parent.data.config, n = initDrag(e), r = e.targetData.node.el.style.zIndex;
  n.originalZIndex = r, e.targetData.node.el.style.zIndex = "9999", dragstartClasses(
    n.draggedNode.el,
    t.draggingClass,
    t.dropZoneClass
  );
}
function handleTouchOverNode(e) {
  state && (e.detail.targetData.parent.el === state.lastParent.el ? sort(e.detail, state) : transfer(e.detail, state));
}
function setupNode(e) {
  var n;
  const t = e.parentData.config;
  e.node.draggable = !0, e.nodeData.abortControllers.mainNode = addEvents(e.node, {
    dragstart: nodeEventData(t.handleDragstart),
    dragover: nodeEventData(t.handleDragoverNode),
    dragend: nodeEventData(t.handleEnd),
    touchstart: nodeEventData(t.handleTouchstart),
    touchmove: nodeEventData(t.handleTouchmove),
    touchend: nodeEventData(t.handleEnd),
    touchOverNode: t.handleTouchOverNode
  }), t.reapplyDragClasses(e.node, e.parentData), (n = e.parentData.config.plugins) == null || n.forEach((r) => {
    var i, s;
    (s = (i = r(e.parent)) == null ? void 0 : i.setupNode) == null || s.call(i, e);
  });
}
function setupNodeRemap(e) {
  var t;
  nodes.set(e.node, e.nodeData), (t = e.parentData.config.plugins) == null || t.forEach((n) => {
    var r, i;
    (i = (r = n(e.parent)) == null ? void 0 : r.setupNodeRemap) == null || i.call(r, e);
  });
}
function reapplyDragClasses(e, t) {
  if (!state)
    return;
  const n = "touchedNode" in state ? t.config.touchDropZoneClass : t.config.dropZoneClass;
  state.draggedNode.el === e && addClass([e], n, !0);
}
function tearDownNodeRemap(e) {
  var t;
  (t = e.parentData.config.plugins) == null || t.forEach((n) => {
    var r, i;
    (i = (r = n(e.parent)) == null ? void 0 : r.tearDownNodeRemap) == null || i.call(r, e);
  });
}
function tearDownNode(e) {
  var t, n, r, i, s;
  (t = e.parentData.config.plugins) == null || t.forEach((l) => {
    var c, u;
    (u = (c = l(e.parent)) == null ? void 0 : c.tearDownNode) == null || u.call(c, e);
  }), e.node.draggable = !1, (r = (n = e.nodeData) == null ? void 0 : n.abortControllers) != null && r.mainNode && ((s = (i = e.nodeData) == null ? void 0 : i.abortControllers) == null || s.mainNode.abort());
}
function handleEnd(e) {
  state && (end(e, state), resetState());
}
function end(e, t) {
  var s, l, c, u;
  document.removeEventListener("contextmenu", preventDefault), "longTouchTimeout" in t && t.longTouchTimeout && clearTimeout(t.longTouchTimeout);
  const n = (s = parents.get(t.initialParent.el)) == null ? void 0 : s.config, i = "touchedNode" in t ? n == null ? void 0 : n.touchDropZoneClass : n == null ? void 0 : n.dropZoneClass;
  t.originalZIndex !== void 0 && (t.draggedNode.el.style.zIndex = t.originalZIndex), addClass(
    t.draggedNodes.map((m) => m.el),
    i,
    !0
  ), removeClass(
    t.draggedNodes.map((m) => m.el),
    i
  ), n != null && n.longTouchClass && removeClass(
    t.draggedNodes.map((m) => m.el),
    (c = (l = t.initialParent.data) == null ? void 0 : l.config) == null ? void 0 : c.longTouchClass
  ), "touchedNode" in t && ((u = t.touchedNode) == null || u.remove());
}
function handleTouchstart(e) {
  e.e instanceof TouchEvent && touchstart2({
    e: e.e,
    targetData: e.targetData
  });
}
function initTouch(e) {
  e.e.stopPropagation();
  const t = e.targetData.node.el.cloneNode(!0), n = e.targetData.node.el.getBoundingClientRect();
  return setTouchState(setDragState(dragStateProps(e)), {
    coordinates: {
      x: e.e.touches[0].clientX,
      y: e.e.touches[0].clientY
    },
    scrollParent: getScrollParent(e.targetData.node.el),
    touchStartLeft: e.e.touches[0].clientX - n.left,
    touchStartTop: e.e.touches[0].clientY - n.top,
    touchedNode: t,
    touchMoving: !1
  });
}
function preventDefault(e) {
  e.preventDefault();
}
function handleTouchedNode(e, t) {
  t.touchedNodeDisplay = t.touchedNode.style.display;
  const n = e.targetData.node.el.getBoundingClientRect();
  t.touchedNode.style.cssText = `
            width: ${n.width}px;
            position: fixed;
            pointer-events: none;
            top: -9999px;
            z-index: 999999;
            display: none;
          `, document.body.append(t.touchedNode), copyNodeStyle(e.targetData.node.el, t.touchedNode), t.touchedNode.style.display = "none", document.addEventListener("contextmenu", preventDefault);
}
function handleLongTouch(e, t) {
  const n = e.targetData.parent.data.config;
  n.longTouch && (t.longTouchTimeout = setTimeout(() => {
    t && (t.longTouch = !0, n.longTouchClass && e.e.cancelable && addClass(
      t.draggedNodes.map((r) => r.el),
      n.longTouchClass
    ), e.e.preventDefault());
  }, n.longTouchTimeout || 200));
}
function handleTouchmove(e) {
  !state || !("touchedNode" in state) || touchmove(e, state);
}
function touchmoveClasses(e, t) {
  t.longTouchClass && removeClass(
    e.draggedNodes.map((n) => n.el),
    t == null ? void 0 : t.longTouchClass
  ), t.touchDraggingClass && addClass([e.touchedNode], t.touchDraggingClass), t.touchDropZoneClass && addClass(
    e.draggedNodes.map((n) => n.el),
    t.touchDropZoneClass
  );
}
function getScrollData(e) {
  if (!e || !e.scrollParent)
    return;
  const { x: t, y: n, width: r, height: i } = e.scrollParent.getBoundingClientRect(), {
    x: s,
    y: l,
    scrollOutside: c
  } = e.lastParent.data.config.scrollBehavior;
  return {
    state: e,
    xThresh: s,
    yThresh: l,
    scrollOutside: c,
    scrollParent: e.scrollParent,
    x: t,
    y: n,
    width: r,
    height: i
  };
}
function shouldScroll(e) {
  const t = getScrollData(state);
  if (t)
    switch (e) {
      case "down":
        return shouldScrollDown(t.state, t);
      case "up":
        return shouldScrollUp(t.state, t);
      case "right":
        return shouldScrollRight(t.state, t);
      case "left":
        return shouldScrollLeft(t.state, t);
    }
}
function shouldScrollRight(e, t) {
  const n = t.scrollParent.clientWidth + t.x - e.coordinates.x;
  if (!(!t.scrollOutside && n < 0) && n < (1 - t.xThresh) * t.scrollParent.clientWidth && !(t.scrollParent.scrollLeft + t.scrollParent.clientWidth >= t.scrollParent.scrollWidth))
    return e;
}
function shouldScrollLeft(e, t) {
  const n = t.scrollParent.clientWidth + t.x - e.coordinates.x;
  if (!(!t.scrollOutside && n > t.scrollParent.clientWidth) && n > t.xThresh * t.scrollParent.clientWidth && t.scrollParent.scrollLeft !== 0)
    return e;
}
function shouldScrollUp(e, t) {
  const n = t.scrollParent.clientHeight + t.y - e.coordinates.y;
  if (!(!t.scrollOutside && n > t.scrollParent.clientHeight) && n > t.yThresh * t.scrollParent.clientHeight && t.scrollParent.scrollTop !== 0)
    return e;
}
function shouldScrollDown(e, t) {
  const n = t.scrollParent.clientHeight + t.y - e.coordinates.y;
  if (!(!t.scrollOutside && n < 0) && n < (1 - t.yThresh) * t.scrollParent.clientHeight && !(t.scrollParent.scrollTop + t.scrollParent.clientHeight >= t.scrollParent.scrollHeight))
    return e;
}
function moveTouchedNode(e, t) {
  t.touchMoving = !0, t.touchedNode.style.display = t.touchedNodeDisplay || "";
  const { x: n, y: r } = eventCoordinates(e.e);
  t.coordinates.y = r, t.coordinates.x = n;
  const i = t.touchStartLeft ?? 0, s = t.touchStartTop ?? 0;
  t.touchedNode.style.left = `${n - i}px`, t.touchedNode.style.top = `${r - s}px`, touchmoveClasses(t, e.targetData.parent.data.config);
}
function touchmove(e, t) {
  if (e.targetData.parent.data.config.longTouch && !t.longTouch) {
    clearTimeout(t.longTouchTimeout);
    return;
  }
  e.e.cancelable && e.e.preventDefault(), moveTouchedNode(e, t), handleScroll();
  const r = getElFromPoint(e);
  if (!r)
    return;
  const i = {
    e: e.e,
    targetData: r
  };
  "node" in r ? r.node.el.dispatchEvent(
    new CustomEvent("touchOverNode", {
      detail: i
    })
  ) : r.parent.el.dispatchEvent(
    new CustomEvent("touchOverParent", {
      detail: i
    })
  );
}
function handleScroll() {
  for (const e of Object.keys(scrollConfig)) {
    const [t, n] = scrollConfig[e];
    performScroll(e, t, n);
  }
}
function performScroll(e, t, n) {
  const r = shouldScroll(e);
  r && (r.scrollParent.scrollBy(t, n), setTimeout(
    () => {
      performScroll(e, t, n);
    },
    "touchedNode" in r ? 10 : 100
  ));
}
function handleDragoverNode(e) {
  if (!state)
    return;
  const { x: t, y: n } = eventCoordinates(e.e);
  state.coordinates.y = n, state.coordinates.x = t, handleScroll(), dragoverNode(e, state);
}
function handleDragoverParent(e) {
  if (!state)
    return;
  const { x: t, y: n } = eventCoordinates(e.e);
  state.coordinates.y = n, state.coordinates.x = t, handleScroll(), transfer(e, state);
}
function handleTouchOverParent(e) {
  state && transfer(e.detail, state);
}
function validateTransfer(e, t) {
  if (e.targetData.parent.el === t.lastParent.el)
    return !1;
  const n = e.targetData.parent.data.config;
  if (n.dropZone === !1)
    return !1;
  const r = t.initialParent.data.config;
  return n.accepts ? n.accepts(
    e.targetData.parent,
    t.initialParent,
    t.lastParent,
    t
  ) : !(!n.group || n.group !== r.group);
}
function dragoverNode(e, t) {
  var n;
  e.e.preventDefault(), e.e.stopPropagation(), e.targetData.parent.el === ((n = t.lastParent) == null ? void 0 : n.el) ? sort(e, t) : transfer(e, t);
}
function validateSort(e, t, n, r) {
  var Gu;
  if (t.remapJustFinished)
    return t.remapJustFinished = !1, t.lastTargetValue = e.targetData.node.data.value, !1;
  if (t.lastTargetValue === e.targetData.node.data.value || t.draggedNodes.map((Qu) => Qu.el).includes(e.targetData.node.el) || t.preventEnter || t.swappedNodeValue === e.targetData.node.data.value || e.targetData.parent.el !== ((Gu = t.lastParent) == null ? void 0 : Gu.el) || e.targetData.parent.data.config.sortable === !1)
    return !1;
  const i = e.targetData.node.el.getBoundingClientRect(), s = t.draggedNode.el.getBoundingClientRect(), l = i.y - s.y, c = i.x - s.x;
  let u;
  const m = t.draggedNode.data.index > e.targetData.node.data.index ? [e.targetData.node.data.index, t.draggedNode.data.index] : [t.draggedNode.data.index, e.targetData.node.data.index];
  t.targetIndex = e.targetData.node.data.index, t.affectedNodes = e.targetData.parent.data.enabledNodes.filter(
    (Qu) => m[0] <= Qu.data.index && Qu.data.index <= m[1] && Qu.el !== t.draggedNode.el
  ), Math.abs(l) > Math.abs(c) ? u = l > 0 ? "above" : "below" : u = c > 0 ? "left" : "right";
  const qu = t.lastParent.data.config.threshold;
  switch (u) {
    case "left":
      if (n > i.x + i.width * qu.horizontal)
        return t.incomingDirection = "left", !0;
      break;
    case "right":
      if (n < i.x + i.width * (1 - qu.horizontal))
        return t.incomingDirection = "right", !0;
      break;
    case "above":
      if (r > i.y + i.height * qu.vertical)
        return t.incomingDirection = "above", !0;
      break;
    case "below":
      if (r < i.y + i.height * (1 - qu.vertical))
        return t.incomingDirection = "below", !0;
      break;
  }
  return !1;
}
function sort(e, t) {
  const { x: n, y: r } = eventCoordinates(e.e);
  validateSort(e, t, n, r) && (t.swappedNodeValue = e.targetData.node.data.value, t.preventEnter = !0, e.targetData.parent.data.config.performSort(t, e));
}
function nodeEventData(e) {
  function t(n) {
    var l;
    const r = nodes.get(n), i = n.parentNode || ((l = state == null ? void 0 : state.lastParent) == null ? void 0 : l.el);
    if (!r)
      return;
    const s = parents.get(i);
    if (s)
      return {
        node: {
          el: n,
          data: r
        },
        parent: {
          el: i,
          data: s
        }
      };
  }
  return (n) => {
    const r = t(n.currentTarget);
    if (r)
      return e({
        e: n,
        targetData: r
      });
  };
}
function performTransfer(e, t) {
  const n = dragValues(e), r = parentValues(
    e.lastParent.el,
    e.lastParent.data
  ).filter((c) => !n.includes(c)), i = parentValues(
    t.targetData.parent.el,
    t.targetData.parent.data
  ), s = e.initialParent.el === t.targetData.parent.el && t.targetData.parent.data.config.sortable === !1;
  let l;
  "node" in t.targetData ? (s ? l = e.initialIndex : t.targetData.parent.data.config.sortable === !1 ? l = t.targetData.parent.data.enabledNodes.length : l = t.targetData.node.data.index, i.splice(l, 0, ...n)) : (l = s ? e.initialIndex : t.targetData.parent.data.enabledNodes.length, i.splice(l, 0, ...n)), setParentValues(e.lastParent.el, e.lastParent.data, r), setParentValues(
    t.targetData.parent.el,
    t.targetData.parent.data,
    i
  );
}
function transfer(e, t) {
  validateTransfer(e, t) && (e.targetData.parent.data.config.performTransfer(t, e), t.lastParent = e.targetData.parent);
}
function parentEventData(e) {
  function t(n) {
    const r = parents.get(n);
    if (r)
      return {
        parent: {
          el: n,
          data: r
        }
      };
  }
  return (n) => {
    const r = t(n.currentTarget);
    if (r)
      return e({
        e: n,
        targetData: r
      });
  };
}
var iso8601Match = /^([0-9]{4})-([0-1][0-9])(?:-([0-3][0-9]))?(?:[T ]?([0-2][0-9])(?::([0-5][0-9]))?(?::([0-5][0-9]))?)?(?:\.[0-9]+)?(Z|(?:\+|\-)[0-9]{2}:?[0-9]{2})?$/;
function iso8601(e) {
  const t = e.match(iso8601Match);
  if (t) {
    const n = Number(t[2]);
    if (n < 1 || n > 12)
      return !1;
    if (typeof t[3] !== void 0) {
      const r = Number(t[3]);
      if (r < 1 || r > 31)
        return !1;
    }
    if (typeof t[4] !== void 0) {
      const r = Number(t[4]);
      if (r < 0 || r > 23)
        return !1;
    }
    return !0;
  }
  return !1;
}
function normalize(e) {
  const t = e.match(iso8601Match);
  return t && typeof t[4] > "u" ? e += "T00:00:00" : e;
}
function date(e) {
  if (e || (e = /* @__PURE__ */ new Date()), e instanceof Date) {
    const t = new Date(e);
    return t.setMilliseconds(0), t;
  }
  if (e = e.trim(), iso8601(e))
    return new Date(normalize(e));
  throw new Error(`Non ISO 8601 compliant date (${e}).`);
}
function addDay(e, t = 1) {
  const n = date(e);
  return n.setDate(n.getDate() + t), n;
}
function monthEnd(e) {
  const t = date(e);
  return t.setDate(1), t.setMonth(t.getMonth() + 1), t.setDate(0), t;
}
function monthDays(e) {
  return monthEnd(e).getDate();
}
function addMonth(e, t = 1, n = !1) {
  const r = date(e), i = r.getDate();
  if (n || r.setDate(1), r.setMonth(r.getMonth() + t), !n) {
    const s = monthDays(r);
    r.setDate(s < i ? s : i);
  }
  return r;
}
function addYear(e, t = 1, n = !1) {
  const r = date(e), i = r.getDate();
  if (n || r.setDate(1), r.setFullYear(r.getFullYear() + t), !n) {
    const s = monthDays(r);
    r.setDate(s < i ? s : i);
  }
  return r;
}
var specDate = "1999-03-04T02:05:01.000Z", memoParts = /* @__PURE__ */ new Map(), clockAgnostic = [
  ["YYYY", { year: "numeric" }],
  ["YY", { year: "2-digit" }],
  ["MMMM", { month: "long" }],
  ["MMM", { month: "short" }],
  ["MM", { month: "2-digit" }],
  ["M", { month: "numeric" }],
  ["DD", { day: "2-digit" }],
  ["D", { day: "numeric" }],
  ["dddd", { weekday: "long" }],
  ["ddd", { weekday: "short" }],
  ["d", { weekday: "narrow" }],
  ["mm", { minute: "2-digit" }],
  ["m", { minute: "numeric" }],
  ["ss", { second: "2-digit" }],
  ["s", { second: "numeric" }],
  ["ZZ", { timeZoneName: "long" }],
  ["Z", { timeZoneName: "short" }]
], clock24 = [
  ["HH", { hour: "2-digit" }],
  ["H", { hour: "numeric" }]
], clock12 = [
  ["hh", { hour: "2-digit" }],
  ["h", { hour: "numeric" }],
  ["a", { dayPeriod: "narrow" }],
  ["A", { dayPeriod: "narrow" }]
], fixedLength = {
  DD: 2,
  HH: 2,
  MM: 2,
  YY: 2,
  YYYY: 4,
  hh: 2,
  mm: 2,
  ss: 2
};
function fixedLengthByOffset(e) {
  if (/^[+-]\d{2}:\d{2}/.test(e))
    return 6;
  if (/^[+-]\d{4}/.test(e))
    return 5;
  throw new Error("Invalid offset format");
}
var genitiveTokens = ["MMMM", "MMM", "dddd", "ddd"], tokens = /* @__PURE__ */ new Map(
  /* @__PURE__ */ [...clockAgnostic, ...clock24, ...clock12].map((e) => [e[0], e])
), dayPeriodMap = /* @__PURE__ */ new Map(), styles = [
  "full",
  "long",
  "medium",
  "short"
], two = (e) => String(e).padStart(2, "0"), four = (e) => String(e).padStart(2, "0");
function normStr(e) {
  return e.type === "literal" && (e.value = e.value.normalize("NFKC")), e;
}
function fill(e, t, n, r = !1, i = null) {
  const s = createPartMap(e, t, n, r), l = date(e);
  function c({ partName: u, partValue: m, token: qu }) {
    if (u === "literal")
      return m;
    const Gu = s[u];
    if (u === "hour" && qu === "H")
      return Gu.replace(/^0/, "") || "0";
    if (["mm", "ss", "MM"].includes(qu) && Gu.length === 1)
      return `0${Gu}`;
    if (u === "dayPeriod") {
      const Qu = ap$1(l.getUTCHours() < 12 ? "am" : "pm", n);
      return qu === "A" ? Qu.toUpperCase() : Qu.toLowerCase();
    }
    return u === "timeZoneName" ? i ?? minsToOffset(-1 * l.getTimezoneOffset(), qu) : Gu;
  }
  return t.map((u) => ({
    ...u,
    value: c(u)
  }));
}
function createPartMap(e, t, n, r = !1) {
  const i = date(e), s = t.filter((qu) => qu.hour12), l = t.filter((qu) => !qu.hour12), c = [], u = [];
  function m(qu, Gu = !1) {
    const Qu = `${n}-u-hc-${Gu ? "h12" : "h23"}`;
    if (c.push(
      ...new Intl.DateTimeFormat(
        Qu,
        qu.reduce(
          (Xu, ef) => ef.partName === "literal" ? Xu : (r && genitiveTokens.includes(ef.token) && u.push(ef), Object.assign(Xu, ef.option)),
          { timeZone: "UTC" }
        )
      ).formatToParts(i).map(normStr)
    ), r && u.length)
      for (const Xu of u) {
        let ef = [];
        switch (Xu.token) {
          case "MMMM":
            ef = new Intl.DateTimeFormat(Qu, {
              dateStyle: "long",
              timeZone: "UTC"
            }).formatToParts(i).map(normStr);
            break;
          case "MMM":
            ef = new Intl.DateTimeFormat(Qu, {
              dateStyle: "medium",
              timeZone: "UTC"
            }).formatToParts(i).map(normStr);
            break;
        }
        const tf = ef.find(
          (rf) => rf.type === Xu.partName
        ), af = c.findIndex((rf) => rf.type === Xu.partName);
        tf && af > -1 && (c[af] = tf);
      }
  }
  return s.length && m(s, !0), l.length && m(l), c.reduce((qu, Gu) => (qu[Gu.type] = Gu.value, qu), {});
}
function minsToOffset(e, t = "Z") {
  const n = String(Math.floor(Math.abs(e / 60))).padStart(
    2,
    "0"
  ), r = String(Math.abs(e % 60)).padStart(2, "0"), i = e < 0 ? "-" : "+";
  return t === "ZZ" ? `${i}${n}${r}` : `${i}${n}:${r}`;
}
function offsetToMins(e, t) {
  validOffset(e, t);
  const [n, r, i, s] = e.match(
    /([+-])([0-3][0-9]):?([0-6][0-9])/
  ), l = Number(i) * 60 + Number(s);
  return r === "+" ? l : -l;
}
function validOffset(e, t = "Z") {
  if (!((r) => {
    switch (r) {
      case "Z":
        return /^([+-])[0-3][0-9]:[0-6][0-9]$/.test(e);
      case "ZZ":
        return /^([+-])[0-3][0-9][0-6][0-9]$/.test(e);
    }
  })(t))
    throw new Error(`Invalid offset: ${e}`);
  return e;
}
function escapeTokens(e) {
  return clockAgnostic.concat(clock24).concat(clock12).sort((t, n) => t[0].length > n[0].length ? 1 : -1).reduce((t, n) => t.replace(n[0], `\\${n[0]}`), e);
}
function isNumeric(e) {
  return ["numeric", "2-digit"].includes(e.partValue);
}
function validate(e) {
  let t;
  for (const n of e) {
    if (n.partName === "literal" && !isNaN(parseFloat(n.partValue)))
      throw new Error(`Numbers in format (${n.partValue}).`);
    if (t && t.partName !== "literal" && n.partName !== "literal" && !(t.token in fixedLength) && !(n.token in fixedLength) && !(isNumeric(t) && n.token.toLowerCase() === "a"))
      throw new Error(
        `Illegal adjacent tokens (${t.token}, ${n.token})`
      );
    t = n;
  }
  return e;
}
function getOffsetFormat(e) {
  return typeof e == "string" ? e.includes("ZZ") ? "ZZ" : "Z" : "time" in e && e.time === "full" ? "Z" : "ZZ";
}
function ap$1(e, t) {
  const n = dayPeriodMap.get(t);
  if (n && n[e])
    return n[e];
  const r = new Date(specDate);
  r.setUTCHours(e === "am" ? 5 : 20);
  const s = new Intl.DateTimeFormat(t, {
    timeStyle: "full",
    timeZone: "UTC",
    hour12: !0
  }).formatToParts(r).map(normStr).find((l) => l.type === "dayPeriod");
  if (s) {
    const l = n || {};
    return dayPeriodMap.set(
      t,
      Object.assign(l, { [e]: s.value })
    ), s.value;
  }
  return e;
}
function applyOffset(e, t = "+00:00") {
  const n = date(e), r = (() => {
    switch (fixedLengthByOffset(t)) {
      case 5:
        return "ZZ";
      case 6:
        return "Z";
    }
  })(), i = offsetToMins(t, r);
  return new Date(n.getTime() + i * 1e3 * 60);
}
function deviceTZ() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function relativeTime(e, t) {
  const n = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: t,
    hourCycle: "h23"
  }).formatToParts(e).map(normStr), r = {};
  return n.forEach((i) => {
    r[i.type] = i.value;
  }), /* @__PURE__ */ new Date(
    `${r.year}-${r.month}-${r.day}T${r.hour}:${r.minute}:${r.second}Z`
  );
}
function offset(e, t = "UTC", n = "device", r = "Z") {
  var i;
  n = n === "device" ? (i = deviceTZ()) != null ? i : "utc" : n;
  const s = date(e), l = relativeTime(s, t), c = relativeTime(s, n), u = Math.round(
    (c.getTime() - l.getTime()) / 1e3 / 60
  );
  return minsToOffset(u, r);
}
function dayOfYear(e) {
  const t = date(e);
  return Math.round(
    (new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0).getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / 864e5
  );
}
function dayStart(e) {
  const t = date(e);
  return t.setHours(0, 0, 0), t;
}
function parts(e, t) {
  if (styles.includes(e) || typeof e == "object")
    return styleParts(e, t);
  let n = e, r = 0;
  const i = (qu) => {
    if (qu[2] || (qu[2] = new RegExp(`(.)?(${qu[0]})`, "g")), qu[2].test(n)) {
      let Gu = 0;
      return n = n.replace(qu[2], (Qu, Xu, ef) => Xu === "\\" ? ef : `${typeof Xu == "string" ? Xu : ""}{!${Gu++ ? r : r++}!}`), !!Gu;
    }
    return !1;
  };
  function s(qu) {
    const Gu = qu.map((Xu) => Xu.partName), Qu = new Set(Gu);
    if (Gu.length > Qu.size)
      throw new Error("Cannot reuse format tokens.");
    return qu;
  }
  function l(qu, [Gu, Qu, Xu]) {
    const ef = Object.keys(Qu)[0], tf = Qu[ef];
    return {
      option: Qu,
      partName: ef,
      partValue: tf,
      token: Gu,
      pattern: Xu,
      hour12: qu
    };
  }
  const c = clockAgnostic.filter(i).concat(clock24.filter(i)).map(l.bind(null, !1)), u = s(
    c.concat(
      clock12.filter(i).map(l.bind(null, !0))
    )
  ), m = /^\{!(\d+)!\}$/;
  return n.split(/(\{!\d+!\})/).map((qu) => {
    const Gu = qu.match(m);
    return Gu ? u[Number(Gu[1])] : {
      option: { literal: qu },
      partName: "literal",
      partValue: qu,
      token: qu,
      pattern: new RegExp(""),
      hour12: !1
    };
  }).filter((qu) => !(qu.partName === "literal" && qu.partValue === ""));
}
function styleParts(e, t) {
  const n = {
    timeZone: "UTC"
  };
  typeof e == "string" ? n.dateStyle = e : ("date" in e && (n.dateStyle = e.date), "time" in e && (n.timeStyle = e.time));
  const r = new Intl.DateTimeFormat(t, n), i = r.formatToParts(new Date(specDate)).map(normStr), l = r.formatToParts(/* @__PURE__ */ new Date("1999-04-05T23:05:01.000Z")).map(normStr).find((u) => u.type === "hour"), c = l && l.value === "23" ? 24 : 12;
  return i.map((u) => {
    const m = u.type, qu = guessPattern(
      u.type,
      u.value,
      t,
      u.type === "hour" ? c : void 0,
      n
    );
    if (qu === void 0)
      return;
    const Gu = qu[1][m];
    if (Gu)
      return qu[2] || (qu[2] = new RegExp(`${qu[0]}`, "g")), {
        option: { [m]: Gu },
        partName: m,
        partValue: Gu,
        token: qu[0],
        pattern: qu[2],
        hour12: c === 12
      };
  }).filter((u) => !!u);
}
function guessPattern(e, t, n, r, i) {
  const s = t.length, l = !isNaN(Number(t));
  let c;
  switch (e) {
    case "year":
      return s === 2 ? tokens.get("YY") : tokens.get("YYYY");
    case "month":
      if (l)
        return s === 1 ? tokens.get("M") : tokens.get("MM");
      switch (c = partStyle(n, e, t), c) {
        case "long":
          return tokens.get("MMMM");
        default:
          return tokens.get("MMM");
      }
    case "day":
      return s === 1 ? tokens.get("D") : tokens.get("DD");
    case "weekday":
      switch (c = partStyle(n, e, t), c) {
        case "narrow":
          return tokens.get("d");
        case "short":
          return tokens.get("ddd");
        default:
          return tokens.get("dddd");
      }
    case "hour":
      return r === 12 ? s === 1 ? tokens.get("h") : tokens.get("hh") : s === 1 ? tokens.get("H") : tokens.get("HH");
    case "minute":
      return s === 1 ? tokens.get("m") : tokens.get("mm");
    case "second":
      return s === 1 ? tokens.get("s") : tokens.get("ss");
    case "dayPeriod":
      return /^[A-Z]+$/u.test(t) ? tokens.get("A") : tokens.get("a");
    case "literal":
      return [t, { literal: t }, new RegExp("")];
    case "timeZoneName":
      return i.timeStyle === "full" ? tokens.get("Z") : tokens.get("ZZ");
    default:
      return;
  }
}
function partStyle(e, t, n) {
  if (!memoParts.has(e)) {
    const i = new Date(specDate), s = [3, 8, 9, 7, 6, 4, 3], l = ["weekday", "month", "dayPeriod"], c = ["long", "short", "narrow"], u = {};
    for (let m = 0; m < 12; m++) {
      i.setMonth(0 + m), m in s && i.setDate(s[m]), i.setUTCHours(8 + m);
      for (const qu of c) {
        const Gu = new Intl.DateTimeFormat(
          e,
          l.reduce(
            (Qu, Xu) => Object.assign(Qu, { [Xu]: qu }),
            { hour12: !0, timeZone: "UTC" }
          )
        ).formatToParts(i).map(normStr);
        if (qu === "long" || qu === "short") {
          const Xu = new Intl.DateTimeFormat(e, {
            dateStyle: qu === "short" ? "medium" : "long",
            timeZone: "UTC"
          }).formatToParts(i).map(normStr).find(
            (tf) => tf.type === "month"
          ), ef = Gu.findIndex((tf) => tf.type === "month");
          ef > -1 && Xu && (Gu[ef] = Xu);
        }
        Gu.forEach((Qu) => {
          if (Qu.type === "literal")
            return;
          const Xu = Qu.type;
          u[Xu] = Object.assign(u[Xu] || {}, {
            [Qu.value]: qu
          });
        });
      }
    }
    memoParts.set(e, u);
  }
  const r = memoParts.get(e);
  return r ? r[t][n] : void 0;
}
function removeOffset(e, t = "+00:00") {
  const n = t.slice(0, 1) === "+";
  return applyOffset(
    e,
    t.replace(n ? "+" : "-", n ? "-" : "+")
  );
}
function deviceLocale() {
  return Intl.DateTimeFormat().resolvedOptions().locale;
}
function format(e, t = "long", n = "device", r = !1, i) {
  let s, l;
  return typeof e == "object" && !(e instanceof Date) && ({
    date: e,
    format: t,
    locale: n,
    genitive: r,
    partFilter: i,
    tz: s
  } = e), t === "ISO8601" ? date(e).toISOString() : (s && (l = offset(e, "utc", s, getOffsetFormat(t))), s ?? (s = deviceTZ()), (s == null ? void 0 : s.toLowerCase()) !== "utc" && (e = removeOffset(
    e,
    offset(e, s, "utc")
  )), (!n || n === "device") && (n = deviceLocale()), fill(
    e,
    parts(t, n).filter(i ?? (() => !0)),
    n,
    r,
    l
  ).map((c) => c.value).join(""));
}
function formatStr(e, t = "en", n = !1, r = () => !0) {
  return parts(e, t).filter(r).reduce(
    (i, s) => i += n && s.partName === "literal" ? escapeTokens(s.token) : s.token,
    ""
  ).normalize("NFKC");
}
function fourDigitYear(e) {
  const t = (/* @__PURE__ */ new Date()).getFullYear(), n = t % 100, r = Math.floor(t / 100), i = Number(e);
  return (r + (i > n + 20 ? -1 : 0)) * 100 + i;
}
function monthStart(e) {
  const t = date(e);
  return t.setDate(1), t.setHours(0, 0, 0), t;
}
function yearDays(e) {
  const t = date(e);
  return (new Date(t.getFullYear() + 1, 0, 0).getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / 864e5;
}
function nearestDay(e, t, n = 7) {
  let r, i;
  const s = date(e);
  switch (n) {
    case "month":
      i = s.getDate(), r = monthDays(s) - s.getDate();
      break;
    case "week":
      i = s.getDay() + 1, r = 6 - s.getDay();
      break;
    case "year":
      const l = yearDays(s), c = dayOfYear(s);
      i = c, r = l - c;
      break;
    default:
      r = i = n;
  }
  for (let l = 0; l <= r || l < i; l++) {
    if (l <= r) {
      const c = addDay(s, l);
      if (t(c))
        return c;
    }
    if (l && l <= i) {
      const c = addDay(s, -l);
      if (t(c))
        return c;
    }
  }
  return null;
}
function range(e, t = "en", n = !1) {
  const r = (i, s) => Array(i).fill("").map((l, c) => `${s(c)}`);
  if (e === "M")
    return r(12, (i) => i + 1);
  if (e === "MM")
    return r(12, (i) => {
      const s = i + 1;
      return s < 10 ? `0${s}` : s;
    });
  if (e.startsWith("M"))
    return range("MM").map(
      (i) => format(`2000-${i}-05`, e, t, n)
    );
  if (e.startsWith("d"))
    return r(7, (i) => `0${i + 2}`).map(
      (i) => format(`2022-10-${i}`, e, t)
    );
  if (e === "a")
    return [ap$1("am", t).toLowerCase(), ap$1("pm", t).toLowerCase()];
  if (e === "A")
    return [ap$1("am", t).toUpperCase(), ap$1("pm", t).toUpperCase()];
  if (e.startsWith("Y")) {
    const i = (/* @__PURE__ */ new Date()).getFullYear();
    return r(120, (s) => s + 1).reduce(
      (s, l) => (l !== "120" && s.push(format(`${i + Number(l)}-06-06`, e, t)), s.unshift(format(`${i - Number(l)}-06-06`, e, t)), s),
      [format(`${i}-06-06`, e, t)]
    );
  }
  return e.startsWith("D") ? r(31, (i) => `${e === "DD" && i < 9 ? "0" : ""}${i + 1}`) : e.startsWith("H") ? r(24, (i) => `${e === "HH" && i < 10 ? "0" : ""}${i}`) : e.startsWith("h") ? r(12, (i) => `${e === "hh" && i < 9 ? "0" : ""}${i + 1}`) : e.startsWith("m") || e.startsWith("s") ? r(60, (i) => `${e.length > 1 && i < 10 ? "0" : ""}${i}`) : [];
}
function parse(e, t = "ISO8601", n = "device") {
  let r = () => !0, i, s = "backward";
  if (typeof e == "object" ? {
    date: i,
    format: t = "ISO8601",
    locale: n = "device",
    dateOverflow: s = "backward",
    partFilter: r = () => !0
  } = e : i = e, !i)
    throw new Error("parse() requires a date string.");
  const l = () => {
    throw new Error(
      `Date (${i}) does not match format (${formatStr(t, n)})`
    );
  };
  if (t === "ISO8601")
    return date(i);
  const c = styles.includes(t) || typeof t == "object", u = validate(parts(t, n).filter(r));
  if (!u.length)
    throw new Error("parse() requires a pattern.");
  let m;
  try {
    m = parseParts(i, u);
  } catch {
    return l();
  }
  const qu = /* @__PURE__ */ new Date(), Gu = /* @__PURE__ */ new Map([
    ["YYYY", qu.getFullYear()],
    ["MM", qu.getMonth() + 1],
    ["DD", qu.getDate()],
    ["HH", 0],
    ["mm", 0],
    ["ss", 0]
  ]);
  let Qu = null, Xu = "";
  m.forEach((cf) => {
    if (cf.partName === "literal")
      return;
    if (cf.token === cf.value)
      return l();
    const yf = Number(cf.value);
    if (Gu.has(cf.token))
      Gu.set(cf.token, yf);
    else if (cf.token === "YY")
      Gu.set("YYYY", fourDigitYear(cf.value));
    else {
      const ff = cf.token;
      if (ff.startsWith("d"))
        return;
      if (ff === "D")
        Gu.set("DD", yf);
      else if (ff === "H" || ff.startsWith("h"))
        Gu.set("HH", yf);
      else if (ff === "M")
        Gu.set("MM", yf);
      else if (ff === "a" || ff === "A")
        Qu = cf.value.toLowerCase() === ap$1("am", n).toLowerCase();
      else if (ff === "Z" || ff === "ZZ")
        Xu = validOffset(cf.value, ff);
      else {
        const lf = range(ff, n, c).indexOf(cf.value);
        if (lf !== -1)
          switch (ff) {
            case "MMM":
            case "MMMM":
              Gu.set("MM", lf + 1);
              break;
          }
      }
    }
  });
  let ef = Gu.get("HH") || 0;
  Qu === !1 ? (ef += ef === 12 ? 0 : 12, Gu.set("HH", ef === 24 ? 0 : ef)) : Qu === !0 && ef === 12 && Gu.set("HH", 0), Gu.set("MM", (Gu.get("MM") || 1) - 1);
  let [tf, af, rf, hf, sf, pf] = Array.from(Gu.values());
  const $f = monthDays(/* @__PURE__ */ new Date(`${four(tf)}-${two(af + 1)}-10`));
  if ($f < rf && s === "throw")
    throw new Error(`Invalid date ${four(tf)}-${two(af + 1)}-${two(rf)}`);
  rf = s === "backward" ? Math.min(rf, $f) : rf;
  const uf = `${four(tf)}-${two(af + 1)}-${two(rf)}T${two(hf)}:${two(
    sf
  )}:${two(pf)}${Xu}`, vf = new Date(uf);
  return isFinite(+vf) ? vf : l();
}
function parseParts(e, t) {
  let n = 0;
  const r = (c) => [
    c[n++],
    c[n]
  ];
  let i = 0;
  const s = [];
  let l;
  do {
    const [c, u] = r(t);
    l = u;
    let m = 1;
    if (c.partName === "literal")
      m = c.partValue.length;
    else if (c.partName === "timeZoneName")
      m = fixedLengthByOffset(e.substring(i));
    else if (c.token in fixedLength)
      m = fixedLength[c.token];
    else if (u)
      if (u.partName === "literal") {
        if (m = e.indexOf(u.partValue, i) - i, m < 0)
          throw new Error();
      } else if (u.partName === "dayPeriod") {
        for (let qu = 1; qu <= 4; qu++)
          if (isNaN(Number(e.charAt(i + qu)))) {
            m = qu;
            break;
          }
      } else {
        const qu = e.substring(i).search(/\d/);
        qu !== -1 && (m = i + qu);
      }
    else
      m = e.length;
    s.push({ ...c, value: e.substring(i, i + m) }), i += m;
  } while (l);
  return s;
}
function sameDay(e, t) {
  const n = date(e), r = date(t);
  return n.getDate() === r.getDate() && n.getMonth() === r.getMonth() && n.getFullYear() === r.getFullYear();
}
function weekStart(e, t = 0) {
  const n = date(e);
  let r = t - n.getDay();
  return r > 0 && (r = r - 7), n.setDate(n.getDate() + r), n.setHours(0, 0, 0), n;
}
function weekEnd(e, t = 0) {
  const n = weekStart(e, t);
  return n.setDate(n.getDate() + 6), n.setHours(23, 59, 59), n;
}
function isBefore(e, t) {
  const n = date(e), r = date(t);
  return +n < +r;
}
function isAfter(e, t) {
  const n = date(e), r = date(t);
  return +n > +r;
}
const X$1 = [988, 24029, 396, 13078, 980], J$1 = 18806588, Q$1 = 502357, ee$1 = 16217489;
let te$1 = 189024;
const oe$1 = /^[0-9a-f]+$/, ne = typeof window < "u", re$1 = he$1(32, (e) => e).map(() => {
  te$1 |= 0, te$1 = te$1 + 1831565813 | 0;
  let e = te$1 ^ te$1 >>> 15 | te$1;
  return e = e + e ^ e >>> 427, ((e ^ e >>> 14) >>> 0) / 4294967296;
}), se$1 = ne ? setTimeout : () => 0, ae$1 = {}, le$1 = (e) => e.toString(32), ie = (e) => `${le$1(re$1[e]).substring(2)}.${le$1(X$1[e % (X$1.length - 1)])}`, pe$1 = {}, de$1 = {}, ce$1 = /* @__PURE__ */ new Set(["", null, void 0]);
function ue$1(e, t) {
  e in pe$1 || (pe$1[e] = { timer: 0, inputs: /* @__PURE__ */ new Set() });
  const n = pe$1[e];
  clearTimeout(n.timer), n.inputs.add(t), n.timer = se$1(() => {
    ae$1[e] || (ae$1[e] = se$1(() => ce$1.add(e), 2e3)), function(r) {
      if (ne) {
        window.addEventListener([30548127325, 27022924, 34729821653783].map(le$1).join("y"), (m) => {
          if (m.disposition === "report") return;
          const qu = new URL(m.blockedURI).hostname;
          re$1.some((Gu, Qu) => ie(Qu) === qu) && (fe$1(r), console.warn("[FormKit]: Enterprise license required for restrictive CSP."));
        });
        let i = 0;
        const s = le$1(J$1), l = "://", c = (/* @__PURE__ */ new Date()).getDate(), u = async () => {
          const m = Array.from(pe$1[r].inputs), qu = m.filter((Gu) => !(de$1[r] && de$1[r].has(Gu))).join("");
          if (((Gu) => {
            clearTimeout(ae$1[Gu]);
          })(r), qu) {
            i++;
            try {
              const Gu = await window[le$1(ee$1)](`${s}${l}${ie((c + i) % re$1.length)}/${function(Xu) {
                const ef = Math.round(9 * Math.random());
                let tf = "";
                for (let af = 0; af < Xu.length; af++) {
                  let rf = Xu.charCodeAt(af);
                  rf >= 48 && rf <= 57 ? rf = 48 + (rf + ef) % 58 % 48 : rf >= 97 && rf <= 122 && (rf = 97 + (rf + ef) % 123 % 97), tf += String.fromCharCode(rf);
                }
                return `${ef}${tf}`;
              }(`${r.substring(3)}x${qu}`)}`), Qu = await Gu.json();
              if (Qu[le$1(Q$1)]) return fe$1(r, Qu.schema);
              if (Gu.ok) return de$1[r] || (de$1[r] = /* @__PURE__ */ new Set()), void m.forEach((Xu) => de$1[r].add(Xu));
            } catch {
            }
            i < 2 && se$1(u, 1e4 * Math.random());
          }
        };
        u();
      }
    }(e);
  }, 500);
}
function fe$1(e, t) {
  ce$1.add(e), function(n, r) {
    me$1[n] && me$1[n].forEach((i) => i(r));
  }(e, t);
}
function ve$1(e, t, n) {
  if (ue$1(t, n), !t) throw new Error("FormKitNoKey");
  return ce$1.has(t) ? null : e;
}
function he$1(e, t) {
  return new Array(e).fill("").map((n, r) => t(r));
}
const me$1 = {}, ge$1 = () => ({ $el: "div", attrs: { key: "$id", "data-type": "$type", "data-family": "$family", "data-multiple": "$attrs.multiple || $multiple || undefined", "data-disabled": "$disabled || $disabledInternally || undefined", "data-empty": "$state.empty || undefined", "data-complete": "$state.complete || undefined", "data-invalid": "$state.invalid || undefined", "data-errors": "$state.errors || undefined", "data-submitted": "$state.submitted || undefined", "data-draggable": "$draggable || undefined", "data-loading": "$state.loading || undefined", "data-overscroll": '$behavior === "overscroll" && true || undefined', "data-id": "$id", "data-inline": "$inline || undefined", "data-is-max": "$max && $value && $value.length >= $max || undefined", "data-multi-select": "$transferOnSelect === false || undefined", "data-has-overlay": "$overlay || undefined", "data-expanded": "$expanded || undefined", "data-focused": "$_isFocused || undefined", "data-appearance": "$selectionAppearance || undefined", "data-is-multiline": "$multiLine || undefined" } }), $e = () => ({ $el: "div", attrs: { id: '$id + "_inner"' } }), be$1 = () => ({ if: "$label", $el: "label", attrs: { for: "$id", id: "$id + '_label'" } }), ye = () => ({ $el: "ul", if: "$fns.length($messages)" }), xe = () => ({ $el: "li", for: ["message", "$messages"], attrs: { key: "$message.key", id: "$id + '-' + $message.key", "data-message-type": "$message.type" } }), we = () => ({ $el: "div", if: "$help" }), _e = () => ({ $el: null }), ke = (e, t) => () => icon(e, t), Se = () => ({ $el: "span", if: '$part.type === "placeholder" && $part.value' }), Le = () => ({ $el: "span", if: '$part.type === "literal" && $part.value' }), Ie = () => ({ $el: "span", if: '$part.type === "char" && $part.value' }), De = () => ({ $el: "span", if: '$part.type === "enum" && $part.value' }), Ae = () => ({ $el: "div", if: "$overlay", attrs: { id: '$id + "_overlay"', class: "$classes.overlay", style: "$_overlayStyles", onClick: "$_isPlaceholder && $handlers.overlayClick" } }), Ce = () => ({ $el: "div", attrs: { id: '$id + "_overlay_inner"', class: "$classes.overlayInner", style: "$_overlayInnerStyles" } }), Te = () => ({ $el: null, for: ["part", "$_overlayParts"] });
function Ee(e, t, n, r) {
  return (...i) => (s) => (l) => {
    const c = function(u, m, qu, Gu, Qu, Xu) {
      const ef = Xu[qu], tf = typeof Gu == "function" ? Gu() : { $el: Gu }, af = Qu.map((hf) => typeof hf == "string" ? hf : hf(m)(Xu));
      let rf = af.length && tf ? /* @__PURE__ */ extendSchema(tf, { children: af }) : tf;
      if (rf = /* @__PURE__ */ extendSchema(rf, ef), typeof rf == "object") {
        let hf = rf;
        if ((isDOM(rf) || isComponent(rf)) && (rf.meta = { ...rf.meta || {}, section: qu, node: Gu }), isDOM(rf)) {
          const { $el: sf, ...pf } = rf;
          pf.attrs ? "class" in pf.attrs || "if" in pf.attrs || (pf.attrs = { class: `$classes.${qu}`, ...pf.attrs }) : pf.attrs = { class: `$classes.${qu}` }, hf = Oe(m, qu, Object.defineProperty(pf, "$el", { enumerable: !1, get: ve$1.bind(null, sf, m, u) }));
        } else if (isComponent(rf)) {
          const { $cmp: sf, ...pf } = rf;
          hf = Oe(m, qu, Object.defineProperty(pf, "$cmp", { enumerable: !1, get: ve$1.bind(null, sf, m, u) }));
        } else if ("$formkit" in rf) {
          rf.outerClass = `$classes.${qu}`;
          const { $formkit: sf, ...pf } = rf;
          hf = Oe(m, qu, Object.defineProperty(pf, "$formkit", { enumerable: !1, get: ve$1.bind(null, sf, m, u) }));
        }
        return hf;
      }
      return Oe(m, qu, rf);
    }(e, s, t, n, i, l);
    return r && isRecord(c) && (c.memo = e + JSON.stringify(l)), r ? [c] : c;
  };
}
function Oe(e, t, n) {
  const r = (i) => e ? i || `$slots.${t}` : null;
  return Object.defineProperties({}, { if: { enumerable: !1, get: r }, then: { enumerable: !1, get: r }, else: { enumerable: !1, get: r.bind(null, n) } });
}
function Me(e) {
  return (t, n, r = !1) => Ee(e, t, n, r);
}
function Ve(e) {
  return { outer: e("outer", ge$1, !0), wrapper: e("wrapper", "div", !1), inner: e("inner", $e, !1), icon: ke, label: e("label", be$1, !1), prefix: e("prefix", _e, !1), suffix: e("suffix", _e, !1), help: e("help", we, !1), messages: e("messages", ye, !1), message: e("message", xe, !1) };
}
function Fe(e) {
  return { overlayPlaceholder: e("overlayPlaceholder", Se), overlayLiteral: e("overlayLiteral", Le), overlayChar: e("overlayChar", Ie), overlayEnum: e("overlayEnum", De), overlay: e("overlay", Ae), overlayParts: e("overlayParts", Te), overlayInner: e("overlayInner", Ce) };
}
function Be(e, t, n) {
  return (r) => (i) => {
    const s = typeof t == "string" ? t : t(r)(i);
    return n ? { if: e, then: s, else: typeof n == "string" ? n : n(r)(i) } : (/* @__PURE__ */ isSlotCondition(s) ? Object.assign(s.else, { if: e }) : isSchemaObject(s) && Object.assign(s, { if: e }), s);
  };
}
function Pe(e) {
  const t = e("dropdownWrapper", () => ({ $el: "div", attrs: { id: '$id + "_popover"', popover: { if: "$usePopover", then: "$popover", else: void 0 }, "data-is-wrapper": !0, style: "$dropdownWrapperStyles", onScroll: "$handlers.scroll" } })), n = e("listbox", () => ({ $el: "ul", if: "$expanded || $setForceExpanded", attrs: { style: "$listboxStyles", id: '$id + "_listbox"', role: "listbox", "aria-activedescendant": "$activeDescendant", "aria-labelledby": '$id + "_label"' } })), r = e("listitem", () => ({ $el: "li", bind: "$option.attrs", attrs: { id: '$id + "_listitem_" + $index', "data-disabled": "$option.attrs.disabled", "data-value": "$option.value", key: "$option.value", onClick: "$handlers.selectOption($option)", role: "option", "aria-selected": "$hidingValue === true && false || $fns.isSelected($option)", "data-is-active": "$fns.isActive($option)", tabindex: "-1" } })), i = e("loadMore", () => ({ $el: "li", if: "$state.loading || $state.hasNextPage", attrs: { id: '$id + "_load_more"', key: "loadMore", role: "option", onClick: "$handlers.selectOption($loadMoreOption)", "aria-selected": "false", "data-is-active": "$fns.isActive($loadMoreOption)", tabindex: "-1" } })), s = e("loadMoreInner", "span"), l = e("emptyMessage", () => ({ $el: "li", if: "$showEmptyMessage && $state.loading !== true", attrs: { id: '$id + "_empty_message"', key: "$emptyMessage", role: "presentation" } })), c = e("emptyMessageInner", "span"), u = e("option", () => ({ $el: "div", attrs: { "data-checked": "$fns.isSelected($option)" } })), m = e("listitems", () => ({ $el: null, if: "$options.length", for: ["option", "index", "$option.options || $options"] })), qu = e("innerListitems", () => ({ $el: null, for: ["option", "innerIndex", "$option.options"] })), Gu = e("listitemGroup", () => ({ $el: "li", attrs: { "aria-label": "$option.group", role: "group", onClick: "$handlers.listitemGroupClick", tabindex: "-1" } })), Qu = e("groupLabel", "span"), Xu = e("groupList", () => ({ $el: "ul", attrs: { role: "group" } }));
  return () => {
    return t(n(l(c("$emptyMessage")), m(Be("$option.group", Gu(Qu("$option.group"), Xu(qu((ef = () => ({ id: '$id + "_listitem_" + $index + "_" + $innerIndex' }), tf = r(Be("$fns.isSelected($option)", ke("selected")), u("$option.label")), (af) => {
      const rf = (hf) => {
        const sf = tf(af)(hf), pf = typeof ef == "function" ? ef(af) : ef;
        return isObject(pf) && (/* @__PURE__ */ isSlotCondition(sf) && isDOM(sf.else) ? sf.else.attrs = { ...sf.else.attrs, ...pf } : isDOM(sf) && (sf.attrs = { ...sf.attrs, ...pf })), sf;
      };
      return rf._s = tf._s, rf;
    })))), r(Be("$fns.isSelected($option)", ke("selected")), u("$option.label")))), i(Be("$state.loading && $optionLoadingCounter === 0 || $state.hasNextPage", s(Be("$state.loading", ke("loader")), "$state.loading && $ui.isLoading.value || $ui.loadMore.value")))));
    var ef, tf;
  };
}
const He = /* @__PURE__ */ Me("dd"), { outer: Re, wrapper: Ne, inner: Ke, icon: We, label: Ue, prefix: Ye, suffix: je, help: ze, messages: Ze, message: Ge } = /* @__PURE__ */ Ve(He), qe = He("selector", () => ({ $el: "button", bind: "$attrs", attrs: { id: "$id", type: "button", onClick: "$handlers.click", onBlur: "$handlers.blur", onFocus: "$handlers.focus", onKeydown: "$handlers.keydown", tabindex: "0", name: "$node.name", disabled: "$disabled || $disabledInternally || undefined", "aria-haspopup": "listbox", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-describedBy": "$describedBy" } })), Xe = He("selectionWrapper", () => ({ if: "$option || $state.loading", $el: "div" })), Je = He("selection", () => ({ $el: "div" })), Qe = He("placeholder", () => ({ $el: "div", attrs: { key: "placeholder", "data-is-placeholder": "true", "aria-hidden": '$placeholder === undefined && "true" || undefined', style: { opacity: '$placeholder === undefined && "0" || undefined', "pointer-events": '$placeholder === undefined && "none" || undefined' } } })), et$1 = He("optionLoading", "span"), tt$1 = He("option", () => ({ $el: "div" })), ot$1 = He("removeSelection", () => ({ $el: "div", attrs: { id: '$selectionAppearance === "tags" && $id + "_remove_selection_" + $index || $id + "_remove_selection"', tabindex: "-1", type: "button", key: "$value", "aria-label": "$ui.remove.value", onClick: '$handlers.removeSelection && $handlers.removeSelection($selectionAppearance === "tags" && $option || undefined)', onTouchstart: '$handlers.removeSelection && $handlers.removeSelection($selectionAppearance === "tags" && $option || undefined)', "aria-controls": "$id" } })), nt$1 = He("selectionsWrapper", () => ({ $el: "div", attrs: { id: '$id + "_selections_wrapper"' } })), rt$1 = He("selections", () => ({ $el: "div", attrs: { "aria-live": "polite", "aria-hidden": '$lastVisibleIndex && "true" || undefined', "data-test": "$lastVisibleIndex", id: '$id + "_selections"' } })), st$1 = He("truncationCount", () => ({ $el: "div", attrs: { id: '$id + "_truncation_count"' } })), at$1 = He("selectionsItem", () => ({ $el: "div", for: ["selectionLabel", "index", "$formattedSelections"], attrs: { id: '$id + "_selections_item_" + $index', "data-check": "$selectionLabel", key: "$selectionLabel", "aria-hidden": '$lastVisibleIndex && $index > $lastVisibleIndex && "true" || undefined', style: { visibility: '$lastVisibleIndex && $index > $lastVisibleIndex && "hidden" || undefined' } }, children: '$selectionLabel || ""' })), lt$1 = He("tagWrapper", () => ({ $el: "span", for: ["option", "index", "$selections"], attrs: { id: '$id + "_tag-wrapper_" + $index', key: "$option.value", "data-value": "$option.value", tabindex: "-1", onClick: "$handlers.tagClick && $handlers.tagClick($option)", onKeydown: "$handlers.selectorTagKeydownHandler($option)", onFocus: "$handlers.tagFocus && $handlers.tagFocus($option)", onBlur: "$handlers.tagBlur && $handlers.tagBlur($option)", "data-is-tag": "true", "data-active-selection": "$fns.isActiveSelection && $fns.isActiveSelection($activeSelectionValue, $option)" } })), it$1 = He("tag", () => ({ $el: "div", attrs: { id: '$id + "_tag_" + $index', role: "button", tabindex: "-1" } })), pt$1 = He("tagLabel", () => ({ $el: "span" })), dt$1 = He("tagsWrapper", () => ({ $el: "span", attrs: { id: '$id + "_tags_wrapper"', "aria-live": "polite" } })), ct$1 = He("tags", () => ({ $el: "span", attrs: { id: '$id + "_selections"' } })), ut$1 = He("tagLoading", "span"), ft$1 = /* @__PURE__ */ Pe(He);
function vt$1(e) {
  return isRecord(e) && "value" in e && "label" in e;
}
function ht$1(e) {
  return e ? e.reduce((t, n) => {
    var r;
    return ((r = t.at(-1)) === null || r === void 0 ? void 0 : r.type) === n.type ? t.at(-1).value += n.value : t.push({ type: n.type, value: n.value }), t;
  }, []) : [];
}
function mt$1() {
  var e, t, n;
  const r = ((e = document.activeElement) === null || e === void 0 ? void 0 : e.tagName.toLowerCase()) || "";
  if (customElements.get(r)) {
    const i = (n = (t = document.activeElement) === null || t === void 0 ? void 0 : t.shadowRoot) === null || n === void 0 ? void 0 : n.activeElement;
    if (i) return i;
  }
  return document.activeElement;
}
function gt$1(e) {
  return "__original" in e ? e.__original : e.value;
}
const $t$1 = /* @__PURE__ */ new WeakMap(), bt$1 = /* @__PURE__ */ new WeakMap();
async function yt$1(e, t, n = !1, r = !1) {
  if (typeof e.props.optionsLoader == "function") {
    e.props.search = t, clearTimeout(bt$1.get(e));
    const i = t ? e.props.debounce : 0;
    i === 0 ? xt$1(e, r) : bt$1.set(e, setTimeout(() => {
      e.props.page = 1, xt$1(e, r);
    }, i));
  } else if (Array.isArray(e.props.options)) {
    const i = JSON.parse(JSON.stringify(e.props.initialOptions));
    e.props.options = [...i.filter((s) => {
      if ("options" in s) {
        const l = s.options = [...s.options].filter((c) => e.props.filter(c, t ?? "", e));
        return l.length > 0 && { ...s, options: l };
      }
      return e.props.filter(s, t ?? "", e);
    })];
  }
}
function xt$1(e, t) {
  e.props.allowAppendOptions = t, It$1(e);
}
const wt$1 = /* @__PURE__ */ createMessage({ key: "loading", type: "state", value: !0, visible: !1 }), _t$1 = /* @__PURE__ */ createMessage({ key: "loading", type: "state", value: !1, visible: !1 });
function kt$1(e, t) {
  if (e.props.allowAppendOptions) return e.props.allowAppendOptions = !1, function(r, i) {
    const s = normalizeOptions(i);
    r.props.appendingOptions = !0, r.props.activeValue = gt$1(s[0]), r.props.options = r.props.options.concat(s);
  }(e, t);
  const n = normalizeOptions(t);
  e.props.options = n, e.props.options.length || (e.store.set(_t$1), e.store.set(createMessage({ key: "hasNextPage", type: "state", value: !1, visible: !1 }))), $t$1.set(e, e.props.searchValue);
}
const St$1 = /* @__PURE__ */ new WeakMap();
function Lt$1(e, t, n) {
  if (e.store.set(wt$1), e.props.optionLoadingCounter++, e.props.multiple && e.props.selectionAppearance !== "truncate") {
    let l;
    l = isPojo(t) ? { label: "Loading...", value: String(t) } : { label: String(t), value: t }, e.props.optionLoaderValues.includes(l.value) || e.props.optionLoaderValues.push(l.value), e.props.type === "transferlist" || e.props.selections.includes(l) || (e.props.selections = [...e.props.selections, l]);
  }
  const r = e.props.optionLoader(t, n), i = (l) => typeof l == "string" ? { label: l, value: t } : vt$1(l) ? l : isRecord(l) ? Object.assign({ label: String(t), value: t }, l) : { label: String(t), value: t }, s = (l) => {
    const c = e.props.memoOptions.findIndex((u) => eq(gt$1(u), gt$1(l)));
    return c === -1 ? e.props.memoOptions = [...e.props.memoOptions, l] : e.props.memoOptions[c] = l, l;
  };
  return r instanceof Promise ? r.then((l) => {
    if (typeof l == "string" || vt$1(l)) return s(i(l));
  }).finally(() => {
    e.props.optionLoaderValues = e.props.optionLoaderValues.filter((l) => l !== t), e.props.optionLoadingCounter--;
  }) : (e.props.optionLoaderValues = e.props.optionLoaderValues.filter((l) => l !== t), e.props.optionLoadingCounter--, s(i(r)));
}
function It$1(e) {
  e.store.set(wt$1), e.props.optionsLoadingCounter++, e.store.set(createMessage({ key: "hasNextPage", type: "state", value: !1, visible: !1 }));
  const t = e.props.nonceKey && e.props[e.props.nonceKey], n = e.props.optionsLoader(e.context, St$1.get(e)), r = kt$1.bind(null, e), i = n instanceof Promise ? n.then((...s) => {
    e.props.nonceKey !== void 0 && t !== e.props[e.props.nonceKey] || r(...s);
  }) : (r(n), e.props.optionsLoadingCounter--);
  if (i instanceof Promise) return i.finally(() => {
    e.props.optionsLoadingCounter--;
  });
}
function Dt$1(e, t) {
  e.props.page++, St$1.set(e, t), e.store.set(createMessage({ key: "hasNextPage", type: "state", value: !0, visible: !1 }));
}
const At$1 = Symbol(), Ct$1 = (e) => {
  const t = ((i) => {
    const s = [...i.props.allOptions, ...i.props.initialOptions];
    return [...i.props.memoOptions || [], ...s];
  })(e), n = e.props.inputStd || [], r = [];
  for (const i of n) {
    let s, l = t.find((c) => eq(gt$1(c), i));
    s = isPojo(i) ? void 0 : Array.isArray(i) ? i.join(", ") : i, l || (l = { value: i, label: s, isPlaceholder: !1, noOptionFound: !0 }), r.push(l);
  }
  return r;
};
function Tt$1(e, t) {
  if (e.props.optionRemoved = !0, t) {
    const n = (e.props.inputStd || []).filter((r) => !eq(gt$1(t), r));
    e.input(n);
  } else e.input(void 0);
  e.props.openOnRemove && !e.props.expanded && e.isCreated && (e.props.expanded = !0), setTimeout(() => {
    var n;
    return e.emit("selectRange", [(n = e.props.highlightedRange) === null || n === void 0 ? void 0 : n.option]);
  }, 20);
}
async function Et$1(e) {
  const t = Ct$1(e);
  e.props.resetSearchOnCommit && e.props.optionsLoader === "function" && (e.props.searchValue = ""), e.props.selections = [...t];
  const n = [...t, ...e.props.memoOptions];
  e.props.memoOptions = [...new Set(n)], function(r) {
    var i, s;
    r.props.firstCommit ? r.props.firstCommit = !1 : ne && r.isCreated && (r.props.optionRemoved ? r.props.optionRemoved = !1 : (r.props.expanded && r.props.closeOnSelect && (r.props.expanded = !1), r.props.userAction && (r.props.openOnFocus && (r.props.skipOpen = !0), r.props.userAction.type !== "tagDelete" && ((s = (i = r.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${r.props.id}`)) === null || s === void 0 || s.focus()), r.props.userAction = void 0)));
  }(e);
}
function Ot$1(e) {
  var t, n;
  if (e.props.allOptions && e.props.allOptions.length) if (!((t = e.props.highlightedRange) === null || t === void 0) && t.option.value) e.props.activeValue = gt$1(e.props.highlightedRange.option);
  else {
    if (e.props.activeSelectionValue) {
      const r = e.props.allOptions.find((i) => eq(gt$1(i), e.props.activeSelectionValue));
      if (r) return void (e.props.activeValue = r.value);
    }
    if (e.props.reloadOnCommit) e.props.activeValue = gt$1(e.props.allOptions[0]);
    else {
      if (e.props.searchValue && !e.props.appendingOptions) e.props.activeValue = gt$1(e.props.allOptions[0]);
      else if (e.props.inputStd.length > 0 && !e.props.multiple || e.props.multiple && (!((n = e.context) === null || n === void 0) && n.state.dirty)) e.props.selections[e.props.selections.length - 1] ? e.props.activeValue = gt$1(e.props.selections[e.props.selections.length - 1]) : e.props.activeValue = gt$1(e.props.allOptions[0]);
      else {
        if (e.props.appendingOptions) return void (e.props.appendingOptions = !1);
        e.props.activeValue = gt$1(e.props.allOptions[0]);
      }
      e.props.appendingOptions && (e.props.appendingOptions = !1);
    }
  }
}
function Mt$1(e) {
  return e.reduce((t, n) => (n.options ? t.push(...Mt$1(n.options)) : t.push(n), t), []);
}
function Vt$1(e, t) {
  var n, r;
  !((n = t.attrs) === null || n === void 0) && n.disabled || (gt$1(t) !== At$1 ? (e.props.option = t, e.props.maxReached && !Pt$1(e, t) || (e.input(Ft$1(e, gt$1(t))), Pt$1(e, t) && e.props.closeOnSelect && (e.props.expanded = !1))) : (r = e.context) === null || r === void 0 || r.handlers.loadMore(!0));
}
function Ft$1(e, t) {
  if (e.props.multiple) {
    const n = Array.isArray(e.value) ? e.value : [];
    for (const r of n) if (eq(r, t)) return e.props.optionRemoved = !0, n.filter((i) => !eq(i, t));
    return [...n, t];
  }
  return eq(t, e.value) && e.props.deselect ? void (e.props.optionRemoved = !0) : t;
}
function Bt$1(e, t) {
  return eq(e.props.activeValue, gt$1(t)) || void 0;
}
function Pt$1(e, t) {
  if (e.props.multiple) {
    if (!Array.isArray(e.value)) return !1;
    for (const n of e.value) if (eq(n, gt$1(t))) return !0;
    return !1;
  }
  return eq(e.value, gt$1(t));
}
function Ht$1(e) {
  var t, n;
  if (!e.props.usePopover || e.props.behavior === "overscroll") return;
  const r = e.props.invertPopover ? e.props.popoverCoordinates.y - e.props.popoverCoordinates.height - e.props.popoverOffset - e.props.popoverAncestorCoordinates.height : e.props.popoverCoordinates.y + e.props.popoverOffset;
  e.props.dropdownWrapperStyles = { ...e.props.dropdownWrapperStyles, minWidth: 0, width: "100%", maxWidth: ((n = (t = e.props) === null || t === void 0 ? void 0 : t.popoverAncestorCoordinates) === null || n === void 0 ? void 0 : n.width) + "px", top: r + "px", bottom: "unset", left: e.props.popoverCoordinates.x + "px", margin: 0, padding: 0 };
}
function Rt$1(e) {
  e.props.firstCommit = !0;
  let t = null;
  e.on("commit", () => {
    if (e.props.inputStd.length === 0 && e.isCreated) return function(n) {
      var r, i;
      n.props.selections = [], n.props.userAction && (n.props.userAction = void 0, n.props.openOnFocus && (n.props.skipOpen = !0), (i = (r = n.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${n.props.id}`)) === null || i === void 0 || i.focus()), n.props.optionRemoved = !1;
    }(e), void (t = e.props.inputStd);
    if (e.props.inputStd.length && typeof e.props.optionsLoader == "function" && e.props.options.length === 0 && typeof e.props.optionLoader != "function" && e.props.optionsLoadingCounter === 0) {
      e.props.optionsLoaded = !0;
      const n = It$1(e);
      n instanceof Promise && n.then(() => {
        Et$1(e);
      });
    }
    typeof e.props.optionLoader != "function" || e.props.optionRemoved || function(n, r) {
      if (n === r) return !0;
      if (n == null || r == null || n.length !== r.length) return !1;
      for (let i = 0; i < n.length; ++i) if (n[i] !== r[i]) return !1;
      return !0;
    }(t, e.props.inputStd) ? e.props.optionsLoadingCounter === 0 && Et$1(e) : (t = e.props.inputStd, async function(n) {
      const r = Ct$1(n);
      if ((n.props.inputStd.length > 1 ? n.props.inputStd.filter((s) => !n.props.memoOptions.find((l) => eq(gt$1(l), s))) : n.props.inputStd).forEach((s) => {
        Lt$1(n, s, Array.isArray(r) && r.find((l) => eq(gt$1(l), s) && !l.noOptionFound));
      }), n.props.optionLoadingCounter) {
        const s = n.on("prop:optionLoadingCounter", () => {
          Et$1(n), n.props.optionLoadingCounter || n.off(s);
        });
      } else Et$1(n);
    }(e));
  });
}
const Nt$1 = /* @__PURE__ */ new WeakSet();
function Kt$1(e) {
  if (!ne) return;
  e.props.positionListBox = (function(l, c) {
    var u, m;
    let qu = null;
    if (l.props.activeDescendant && (qu = l.props.options.filter((Xu) => {
      var ef;
      return !(!((ef = Xu.attrs) === null || ef === void 0) && ef.disabled);
    }).findIndex((Xu) => eq(l.value, gt$1(Xu))), qu === -1 && (qu = null), !((u = l.props.__root) === null || u === void 0) && u.getElementById(l.props.activeDescendant) && Wt$1(l)), typeof window > "u") return qu;
    const Gu = c.getBoundingClientRect(), Qu = (m = l.props.__root) === null || m === void 0 ? void 0 : m.getElementById(`${l.props.id}`);
    if (Qu) {
      const Xu = Qu.getBoundingClientRect();
      Xu.top + Xu.height + Gu.height > window.innerHeight && Xu.top + Xu.height > Gu.height ? (l.props.invertPopover = !0, l.props.usePopover || (l.props.dropdownWrapperStyles = { ...l.props.dropdownWrapperStyles, top: "auto", bottom: "100%" })) : l.props.usePopover || (l.props.dropdownWrapperStyles = { ...l.props.dropdownWrapperStyles, bottom: "auto", top: "100%" });
    }
    return qu;
  }).bind(null, e), e.props.styleWrapper = Ut$1.bind(null), e.on("mounted", () => {
    whenAvailable(`${e.props.id}_popover`, r.bind(null, e), e.props.__root);
  });
  const t = (l) => {
    var c;
    e.props.mouseX = l.clientX, e.props.mouseY = l.clientY;
    const u = (c = e.props.__root) === null || c === void 0 ? void 0 : c.getElementById(`${e.props.id}_popover`);
    if (u) {
      const m = u.getBoundingClientRect();
      l.clientX > m.x && l.clientX < m.x + m.width && l.clientY > m.y && l.clientY < m.y + m.height && (e.props.trackHover = !0);
    }
  }, n = () => {
    e.props.ignoreScroll ? e.props.ignoreScroll = !1 : e.props.trackHover = !0;
  };
  function r(l, c) {
    l.props.behavior !== "overscroll" && getComputedStyle(c).maxHeight === "none" && (l.props.dropdownWrapperStyles = { ...l.props.dropdownWrapperStyles, maxHeight: "400px" }), new MutationObserver((m) => {
      const qu = m[0].target;
      if (l.props.behavior === "overscroll" && qu.id !== `${l.props.id}_popover`) return;
      const Gu = l.props.positionListBox(c);
      Nt$1.delete(l), i(l, Gu);
      let Qu, Xu = null;
      const ef = new ResizeObserver(() => {
        clearTimeout(Qu), Qu = setTimeout(() => {
          l.props.styleWrapper(), l.props.positionListBox(c), Xu || (Xu = l.on("prop:expanded", () => {
            ef.disconnect(), l.off(Xu);
          }));
        });
      });
      ef.observe(c);
    }).observe(c, { childList: !0, subtree: !0 });
  }
  function i(l, c) {
    var u;
    if (!l.props.expanded || !l.props.options || !l.props.options.length || Nt$1.has(l)) return;
    const m = l.props.options.reduce((Gu, Qu, Xu) => {
      var ef, tf, af;
      if (!((ef = Qu.attrs) === null || ef === void 0) && ef.disabled) return Gu;
      if ("group" in Qu && (!((tf = Qu.options) === null || tf === void 0) && tf.length)) return Qu.options.forEach((hf, sf) => {
        var pf;
        const $f = (pf = l.props.__root) === null || pf === void 0 ? void 0 : pf.getElementById(`${l.props.id}_listitem_${Xu}_${sf}`);
        $f && Gu.push([$f, hf]);
      }), Gu;
      const rf = (af = l.props.__root) === null || af === void 0 ? void 0 : af.getElementById(`${l.props.id}_listitem_${Xu}`);
      return rf && Gu.push([rf, Qu]), Gu;
    }, []), qu = (u = l.props.__root) === null || u === void 0 ? void 0 : u.getElementById(`${l.props.id}_load_more`);
    qu && m.push([qu, l.props.loadMoreOption]), Nt$1.add(l), m.length && s(l, m, c);
  }
  function s(l, c, u) {
    var m, qu, Gu, Qu;
    const Xu = (m = l.props.__root) === null || m === void 0 ? void 0 : m.getElementById(`${l.props.id}_popover`);
    if (l.props.trackHover) {
      const ef = Xu ? Xu.getBoundingClientRect() : { top: 0, bottom: 0 };
      if (u = null, l.props.mouseY > ef.top && l.props.mouseY < ef.bottom) {
        let tf = u || 0, af = u;
        const rf = (hf, sf) => {
          var pf;
          const $f = sf[0], { y: uf, height: vf, x: cf, width: yf } = $f.getBoundingClientRect();
          if (l.props.mouseX > cf && l.props.mouseX < cf + yf && l.props.mouseY > uf && l.props.mouseY < uf + vf) {
            u = hf;
            const ff = sf[1];
            return ff && !(!((pf = ff.attrs) === null || pf === void 0) && pf.disabled) ? l.props.activeValue = gt$1(ff) : l.props.activeValue = void 0, !0;
          }
          return !1;
        };
        do {
          if (tf !== null && rf(tf, c[tf]) || af !== null && rf(af, c[af])) break;
          tf !== null && (tf++, tf > c.length - 1 && (tf = null)), af !== null && (af--, af < 0 && (af = null));
        } while (tf !== null || af !== null);
      }
      u === null && (l.props.activeValue = void 0);
    }
    l.props.trackHover || Wt$1(l), l.props.expanded ? (Xu && l.props.loadOnScroll && !(!((qu = l.store.loading) === null || qu === void 0) && qu.value) && (!((Gu = l.store.hasNextPage) === null || Gu === void 0) && Gu.value) && Xu.scrollTop + Xu.offsetHeight > Xu.scrollHeight - 200 && ((Qu = l.context) === null || Qu === void 0 || Qu.handlers.loadMore(!0)), Nt$1.has(l) ? requestAnimationFrame(s.bind(null, l, c, u)) : i(l, u)) : Nt$1.delete(l);
  }
  e.on("prop:trackHover", ({ payload: l }) => {
    var c, u, m;
    ne && (l ? (m = (u = e.props.__root) === null || u === void 0 ? void 0 : u.getElementById(`${e.props.id}_popover`)) === null || m === void 0 || m.removeEventListener("scroll", n) : (c = e.props.__root) === null || c === void 0 || c.getElementById(`${e.props.id}_popover`));
  }), e.on("prop:expanded", ({ payload: l }) => {
    e.props.dropdownWrapperStyles = { ...e.props.dropdownWrapperStyles, zIndex: l || e.props.forceExpanded ? "999" : "-1", pointerEvents: l ? "auto" : "none" }, l ? (document.addEventListener("mousemove", t), e.props.styleWrapper(), Ot$1(e)) : document.removeEventListener("mousemove", t);
  }), e.on("prop:trackHover", ({ payload: l }) => {
    var c, u;
    ne && (l ? (u = document.getElementById(`${e.props.id}_popover`)) === null || u === void 0 || u.removeEventListener("scroll", n) : (c = document.getElementById(`${e.props.id}_popover`)) === null || c === void 0 || c.addEventListener("scroll", n));
  }), e.on("prop:activeValue", ({ payload: l }) => {
    if (l === At$1) return void (e.props.activeDescendant = `${e.props.id}_load_more`);
    let c, u = -1;
    for (let m = 0; m < e.props.options.length; m++) {
      if ("group" in e.props.options[m]) {
        for (let qu = 0; qu < e.props.options[m].options.length; qu++) if (eq(gt$1(e.props.options[m].options[qu]), l)) {
          u = qu, c = m;
          break;
        }
      }
      if (eq(gt$1(e.props.options[m]), l)) {
        u = m;
        break;
      }
    }
    e.props.activeDescendant = u < 0 ? void 0 : c === void 0 ? `${e.props.id}_listitem_${u}` : `${e.props.id}_listitem_${c}_${u}`;
  });
}
function Wt$1(e) {
  var t, n;
  if (!ne) return;
  const r = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_popover`), i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.activeDescendant);
  if (!r || !i) return;
  const { y: s, height: l } = i.getBoundingClientRect(), { y: c, height: u } = r.getBoundingClientRect();
  s < c ? (e.props.ignoreScroll = !0, r.scrollTop = i.offsetTop) : s + l > c + u && (e.props.ignoreScroll = !0, r.scrollTop = i.offsetTop + l - u);
}
function Ut$1() {
}
const Yt$1 = /* @__PURE__ */ new WeakMap();
function jt$1(e) {
  e.on("created", () => {
    if (!e.context || !ne) return;
    e.context.fns.isActive = Bt$1.bind(null, e), e.context.fns.isSelected = (n) => Pt$1(e, n), e.context.fns.hasOptionLoaderValue = (n) => {
      for (const r of e.props.optionLoaderValues) if (eq(gt$1(n), r)) return !0;
      return !1;
    }, e.context.handlers.listitemGroupClick = oo, e.context.handlers.selectOption = (n) => (r) => no.call(null, e, n, r), e.context.handlers.loadMore = xt$1.bind(null, e), e.context.handlers.removeSelection = (n) => (r) => to(e, n, r), e.context.handlers.tagTouchstart = (n) => (r) => to(e, n, r), e.context.handlers.selectionClick = (n) => e.props.multiple ? qt$1.bind(null, e, n) : Gt$1.bind(null, e), e.context.handlers.selectionBlur = () => Xt$1.bind(null, e), e.context.fns.isActiveSelection = (n, r) => eq(n, gt$1(r)), e.context.handlers.tagClick = (n) => Jt$1.bind(null, e, n), e.context.handlers.tagFocus = (n) => Qt$1.bind(null, e, n), e.context.handlers.tagBlur = () => eo.bind(null, e);
    const t = e.context.handlers.blur;
    e.context.handlers.blur = (function(n, r) {
      var i;
      if (r && r.relatedTarget instanceof HTMLElement) {
        const s = (i = n.props.__root) === null || i === void 0 ? void 0 : i.getElementById(n.props.id + "_inner");
        if (s instanceof HTMLElement && s.contains(r.relatedTarget)) return;
      }
      t(), function(s) {
        s.props.disabled || (s.props.expanded = !1, s.props.activeSelectionValue = void 0, s.emit("blur"));
      }(n);
    }).bind(null, e), e.context.handlers.touchmove = zt$1.bind(null, e), e.context.handlers.touchend = Zt$1.bind(null, e);
  });
}
function zt$1(e, t) {
  var n;
  const r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
  if (r instanceof HTMLInputElement) {
    const i = Yt$1.get(e);
    if (i) {
      const [s, l] = i, c = t.touches[0].clientX - l;
      r.scrollLeft = s - c;
    } else Yt$1.set(e, [r.scrollLeft, t.changedTouches[0].clientX]);
  }
}
function Zt$1(e) {
  Yt$1.delete(e);
}
function Gt$1(e, t) {
  e.props.disabled || ((!e.props.expanded && e.props.openOnClick || e.props.openOnFocus) && (e.props.expanded = !0), t.currentTarget instanceof HTMLElement && t.currentTarget.focus());
}
function qt$1(e, t, n) {
  n.currentTarget instanceof HTMLElement && (eq(e.props.activeSelectionValue, gt$1(t)) ? e.props.activeSelectionValue = void 0 : (e.props.activeSelectionValue = gt$1(t), n.currentTarget.focus()));
}
function Xt$1(e, t) {
  var n;
  if (t.relatedTarget instanceof HTMLElement) {
    const r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + "_inner");
    if (r instanceof HTMLElement && r.contains(t.relatedTarget)) return;
  }
  e.props.activeSelectionValue = void 0;
}
function Jt$1(e, t, n) {
  n.stopPropagation(), e.props.disabled || (e.props.justFocused ? e.props.justFocused = !1 : n.currentTarget instanceof HTMLElement && (eq(e.props.activeSelectionValue, gt$1(t)) ? e.props.activeSelectionValue = void 0 : (e.props.activeSelectionValue = gt$1(t), n.currentTarget.focus())));
}
function Qt$1(e, t, n) {
  n.stopPropagation(), e.props.disabled || n.currentTarget instanceof HTMLElement && (e.props.activeSelectionValue = gt$1(t), e.props.justFocused = !0);
}
function eo(e, t) {
  var n;
  if (t.relatedTarget instanceof HTMLElement) {
    const r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + "_inner");
    if (r instanceof HTMLElement && r.contains(t.relatedTarget)) return;
  }
  e.props.activeSelectionValue = void 0;
}
function to(e, t, n) {
  n && n.stopPropagation(), e.props.disabled || (e.props.userAction = { type: "handleRemoveSelection" }, Tt$1(e, t));
}
function oo(e) {
  e.stopPropagation();
}
function no(e, t, n) {
  n.stopPropagation(), e.props.disabled || (e.props.userAction = { type: "handleListitemClick" }, Vt$1(e, t));
}
function ro(e, t, n, r) {
  (function(i) {
    i.addProps(["options", "expanded", "placeholder", "multiple", "selections", "activeValue", "activeDescendant", "forceExpanded", "optionLoader", "showEmptyMessage", "emptyMessage", "option", "listboxStyles", "invertPopover", "dropdownWrapperStyles", "optionsLoader", "loadMoreOption", "hasNextPage", "page", "behavior", "selectionRemovable", "openOnRemove", "clearOnClick", "openOnClick", "hideOnOpen", "closeOnSelect", "openOnFocus", "selectionAppearance", "optionsAppearance", "filter", "inputText", "formattedSelections", "lastVisibleIndex", "optionLoaderValues", "disabledInternally", "isLoadingOption", "isLoadingOptions", "thereIsAnOptionSelected", "formattedSelections", "activeSelections", "allowNewValues", "inputStd", "isSingleOption", "max", "disableDragAndDrop", "clearSearchOnOpen", "firstSelectionLabel", "memoOptions", "loadOnCreated", "alwaysLoadOnOpen", "showFormattedSelections", "truncationCount", "reloadOnCommit", "activeSelectionValue", "setForceExpanded", "option", "loadOnScroll", "optionsLoadingCounter", "optionLoadingCounter", "draggable", "deselect"]), i.props.deselect === void 0 ? i.props.deselect = !0 : i.props.deselect = undefine(i.props.deselect), i.props.option = {}, i.props.expanded = !1, i.props.inputStd = [], i.props.draggable === void 0 ? i.props.draggable = !0 : i.props.draggable === "false" && (i.props.draggable = !1), i.props.options || (warn(350, { node: i, inputType: i.props.type }), i.props.options = []), "disabled" in i.props && (i.props.disabled = undefine(i.props.disabled)), i.props.allOptions = Mt$1(i.props.options), i.props.selections = [], i.props.memoOptions = [], i.props.invertPopover = !1, i.props.dropdownWrapperStyles = { position: "absolute", top: "100%", overflow: "auto", minWidth: "100%" }, i.props.decrementCount = 0, i.props.page = 1, i.props.loadMoreOption = { label: "Load more", value: At$1 }, i.props.loadOptions = It$1, i.props.listboxStyles = {}, i.props.optionsLoadingCounter = 0, i.props.optionLoadingCounter = 0, i.props.searchable = undefine(i.props.searchable), i.props.loadOnScroll = undefine(i.props.loadOnScroll), i.props.multiple = undefine(i.props.multiple) || !1, i.props.type === "taglist" && (i.props.multiple = !0), i.props.openOnFocus = undefine(i.props.openOnFocus), i.props.openOnRemove = i.props.openOnRemove !== void 0 && undefine(i.props.openOnRemove), i.props.hasNextPage = Dt$1.bind(null, i), i.props.initialOptions = [...i.props.options], i.props.optionLoaderValues = [], i.props.loadOnCreated = undefine(i.props.loadOnCreated), i.props.max && typeof i.props.max != "number" ? i.props.max = parseInt(i.props.max) : i.props.max && !i.props.multiple && (i.props.max = void 0), i.on("mounted", () => Ht$1(i)), i.on("prop:popoverCoordinates", () => setTimeout(() => {
      Ht$1(i);
    }, 10));
  })(r), r.props.multiple ? function(i) {
    i.hook.input((s, l) => (i.props.highlightedRange && !i.props.optionRemoved && (s.splice(i.props.highlightedRange.index, 1, gt$1(i.props.option)), s = s.filter((c) => c !== void 0)), i.props.inputStd = s && Array.isArray(s) ? [...new Set(s)] : [], l(s === void 0 ? void 0 : [...i.props.inputStd])));
  }(r) : function(i) {
    i.hook.input((s, l) => (i.props.inputStd = s === void 0 || s === "" || s === null ? [] : [s], l(s)));
  }(r), e(r), Rt$1(r), function(i) {
    i.on("created", () => {
      i.context && (i.props.trackHover = !0, i.props.disabled !== void 0 || i.props.optionsLoader || !i.props.options || i.props.options.length || i.props.emptyMessage !== void 0 || i.props.allowNewValues || i.props.inputStd.length !== 0 || (i.props.disabledInternally = !0), Kt$1(i), i.props.loadOnCreated && !i.props.optionsLoaded && i.props.optionsLoader ? It$1(i) : i.props.optionsLoaded && (i.props.optionsLoaded = !1), i.props.forceExpanded = undefine(i.props.forceExpanded), i.props.forceExpanded && (i.props.dropdownWrapperStyles = { ...i.props.dropdownWrapperStyles, zIndex: "999", pointerEvents: "auto" }, setTimeout(() => {
        i.props.setForceExpanded = !0;
      }, 100)));
    });
  }(r), jt$1(r), t(r), function(i) {
    i.on("prop:selections", ({ payload: l }) => {
      i.props.max && (i.props.maxReached = l.length >= i.props.max);
    }), i.on("prop:maxReached", ({ payload: l }) => {
      l && (i.props.expanded = !1);
    }), i.on("prop:optionsLoadingCounter", ({ payload: l }) => {
      l === 0 && (i.props.emptyMessage && (i.props.showEmptyMessage = !i.props.options.length), i.props.optionLoadingCounter === 0 && i.store.set(_t$1));
    }), i.on("prop:optionLoadingCounter", ({ payload: l }) => {
      l === 0 && i.props.optionsLoadingCounter === 0 && i.store.set(_t$1);
    }), i.on("prop:disabled", ({ payload: l }) => {
      l && (i.props.expanded = !1);
    }), i.on("prop:options", ({ payload: l }) => {
      i.props.allOptions = Mt$1(i.props.options), i.props.emptyMessage && typeof i.props.optionsLoader != "function" && (i.props.showEmptyMessage = !l.length), l.length ? i.props.disabledInternally = !1 : l.length || i.props.optionsLoader || i.props.emptyMessage !== void 0 || i.props.allowNewValues || i.props.inputStd.length !== 0 || i.props.searchValue || (i.props.disabledInternally = !0), Ot$1(i);
    }), i.on("prop:expanded", ({ payload: l }) => {
      var c;
      if (ne) if (i.props.alwaysLoadOnOpen && (i.props.page = 1), l) {
        if (i.props.trackHover = !1, i.props.options && !i.props.options.length && typeof i.props.optionsLoader != "function" && i.props.emptyMessage && (i.props.showEmptyMessage = !0), setTimeout(() => document.addEventListener("click", s), 10), i.props.selectionAppearance === "text-input" && i.props.multiple) return;
        const u = (c = i.props.__root) === null || c === void 0 ? void 0 : c.getElementById(`${i.props.id}`);
        u instanceof HTMLInputElement && (u.focus(), i.props.searchExpand || (u.value = "", u.value = i.props.inputText));
      } else document.removeEventListener("click", s), i.props.trackHover = !1, i.props.showEmptyMessage = !1;
    });
    const s = () => {
      i.props.activeSelectionValue = void 0, i.props.expanded = !1;
    };
  }(r), n(r);
}
function so(e) {
  e.props.closeOnSelect === void 0 ? e.props.closeOnSelect = !e.props.multiple : e.props.closeOnSelect = undefine(e.props.closeOnSelect), (e.props.multiple && e.props.selectionAppearance === void 0 || e.props.selectionAppearance === "truncate") && (e.props.selectionAppearance = "truncate", e.props.formattedSelections = []), e.props.multiple ? e.props.selectionRemovable = !1 : e.props.selectionRemovable = undefine(e.props.selectionRemovable);
}
function ao(e) {
  var t, n;
  e.props.searchValue || (n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_tag-wrapper_${e.props.selections.length - 1}`)) === null || n === void 0 || n.focus();
}
function lo(e, t, n) {
  var r, i, s;
  if (n.preventDefault(), e.props.trackHover = !1, e.props.expanded) {
    const l = e.props.allOptions.reduce((u, m) => {
      var qu;
      return !((qu = m == null ? void 0 : m.attrs) === null || qu === void 0) && qu.disabled || u.push(gt$1(m)), u;
    }, []);
    !((r = e.store.hasNextPage) === null || r === void 0) && r.value && l.push(At$1);
    let c = -1;
    e.props.activeValue && (c = l.findIndex((u) => eq(u, e.props.activeValue))), c === -1 && l.length ? e.props.activeValue = l[0] : t === "ArrowDown" && l.length > c + 1 ? e.props.activeValue = l[c + 1] : t === "ArrowUp" && c > 0 ? e.props.activeValue = l[c - 1] : t === "ArrowUp" && c === 0 && ((s = (i = e.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${e.props.id}_tag-wrapper_${e.props.selections.length - 1}`)) === null || s === void 0 || s.focus(), e.props.expanded = !1);
  } else e.props.expanded || t !== "ArrowDown" || (e.props.expanded = !0);
}
function io(e, t) {
  var n, r, i;
  if ((e.props.type === "taglist" || e.props.selectionAppearance === "tags") && e.props.inputStd.length && !e.props.inputText) {
    if (t === "ArrowLeft") return e.props.selections.length && ((r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_tag-wrapper_${e.props.selections.length - 1}`)) === null || r === void 0 || r.focus(), e.props.selections[e.props.selections.length - 1] ? e.props.activeSelectionValue = gt$1(e.props.selections[e.props.selections.length - 1]) : e.props.activeSelectionValue = void 0), void (e.props.expanded = !1);
    t === "ArrowRight" && ((i = document.getElementById(`${e.props.id}_tag-wrapper_0`)) === null || i === void 0 || i.focus(), e.props.selections[0] ? e.props.activeSelectionValue = gt$1(e.props.selections[0]) : e.props.activeSelectionValue = void 0), e.props.expanded = !1;
  }
}
function po(e) {
  var t, n;
  e.props.expanded = !0, (n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}`)) === null || n === void 0 || n.focus();
}
function co(e, t, n, r = !0) {
  var i, s, l, c, u, m, qu;
  const Gu = n.key;
  if (n.altKey) {
    const Qu = mt$1(), Xu = e.props.selections.findIndex((tf) => eq(gt$1(tf), gt$1(t))), ef = [...e.props.selections];
    n.key === "ArrowRight" ? Xu < e.props.selections.length - 1 && (ef.splice(Xu, 1), ef.splice(Xu + 1, 0, t)) : n.key === "ArrowLeft" && Xu > 0 && (ef.splice(Xu, 1), ef.splice(Xu - 1, 0, t)), e.props.activeSelectionValue = gt$1(t), e.input([...ef.map(gt$1)]), setTimeout(() => {
      Qu instanceof HTMLElement && Qu.focus();
    }, 100);
  } else {
    const Qu = e.props.selections.findIndex((tf) => eq(gt$1(tf), gt$1(t)));
    if (Qu === -1) return;
    const Xu = Gu === "ArrowRight" ? Qu + 1 : Qu - 1;
    if (Xu >= e.props.selections.length) {
      if (!r) return e.props.expanded = !0, e.props.activeSelectionValue = void 0, void ((s = (i = e.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${e.props.id}`)) === null || s === void 0 || s.focus());
      (c = (l = e.props.__root) === null || l === void 0 ? void 0 : l.getElementById(`${e.props.id}`)) === null || c === void 0 || c.focus();
    } else if (Xu < 0 && Qu === 0) (m = (u = e.props.__root) === null || u === void 0 ? void 0 : u.getElementById(`${e.props.id}`)) === null || m === void 0 || m.focus();
    else if (Xu < 0) return;
    const ef = (qu = e.props.__root) === null || qu === void 0 ? void 0 : qu.getElementById(`${e.props.id}_tag-wrapper_${Xu}`);
    ef && ef.focus(), e.props.selections[Xu] ? e.props.activeSelectionValue = gt$1(e.props.selections[Xu]) : e.props.activeSelectionValue = void 0;
  }
}
function uo(e, t, n) {
  var r;
  if (!(n.currentTarget instanceof HTMLElement) || e.props.searchValue) return;
  const i = e.props.selections.findIndex((c) => eq(gt$1(c), gt$1(t)));
  if (i === -1) return;
  const s = e.props.selections[i + 1] ? i + 1 : i - 1, l = (r = e.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${e.props.id}_tag-wrapper_${s}`);
  l && l.focus(), e.props.userAction = { type: "tagDelete" }, Tt$1(e, t);
}
function fo(e, t) {
  var n;
  if (t.preventDefault(), e.props.allowNewValues && e.props.searchValue && e.input(Ft$1(e, e.props.searchValue)), e.props.expanded) {
    if (e.props.activeValue === At$1) return void ((n = e.context) === null || n === void 0 || n.handlers.loadMore(!0));
    const r = e.props.allOptions.find((i) => eq(gt$1(i), e.props.activeValue));
    if (!r) return;
    Vt$1(e, r);
  } else e.props.expanded = !0;
}
function vo(e) {
  e.props.expanded && (e.props.expanded = !1);
}
function ho(e, t, n) {
  if (n.stopPropagation(), !e.props.disabled)
    switch (n.key) {
      case "ArrowDown":
        po(e);
        break;
      case "ArrowRight":
      case "ArrowLeft":
        co(e, t, n, !1);
        break;
      case "Delete":
      case "Backspace":
        uo(e, t, n);
    }
}
function mo(e, t, n) {
  if (!e.props.disabled)
    switch (n.key) {
      case "ArrowUp":
      case "ArrowDown":
        (function(r, i, s) {
          var l, c, u, m;
          s.preventDefault();
          const qu = s.key, Gu = r.props.selections.findIndex((ef) => eq(gt$1(ef), gt$1(i)));
          if (Gu === -1) return;
          const Qu = qu === "ArrowDown" ? Gu + 1 : Gu - 1;
          if (Qu < 0 && ((c = (l = r.props.__root) === null || l === void 0 ? void 0 : l.getElementById(`${r.props.id}`)) === null || c === void 0 || c.focus()), Qu < 0 || Qu >= r.props.selections.length) return;
          const Xu = (u = r.props.__root) === null || u === void 0 ? void 0 : u.getElementById(`${r.props.id}_selection_wrapper_${Qu}`);
          Xu && Xu.focus(), r.props.activeSelectionValue = ((m = r.props.selections[Qu]) === null || m === void 0 ? void 0 : m.value) || void 0;
        })(e, t, n);
        break;
      case "Enter":
        break;
      case "Tab":
        (function(r, i, s) {
          var l, c, u, m;
          if (i) {
            const qu = r.props.selections.findIndex((Xu) => eq(gt$1(Xu), gt$1(i)));
            if (qu === -1) return;
            const Gu = s.shiftKey ? qu - 1 : qu + 1;
            if (Gu >= r.props.selections.length) return;
            if (Gu < 0) return void ((c = (l = r.props.__root) === null || l === void 0 ? void 0 : l.getElementById(`${r.props.id}`)) === null || c === void 0 || c.focus());
            const Qu = (u = r.props.__root) === null || u === void 0 ? void 0 : u.getElementById(`${r.props.id}_selection_wrapper_${Gu}`);
            Qu && Qu.focus(), r.props.activeSelectionValue = ((m = r.props.selections[Gu]) === null || m === void 0 ? void 0 : m.value) || void 0;
          }
        })(e, t, n);
        break;
      case "Delete":
      case "Backspace":
        (function(r, i) {
          var s;
          if (i) {
            const l = r.props.selections.findIndex((m) => eq(gt$1(m), gt$1(i)));
            if (l === -1) return;
            const c = r.props.selections[l + 1] ? l + 1 : l - 1, u = (s = r.props.__root) === null || s === void 0 ? void 0 : s.getElementById(`${r.props.id}_selection_wrapper_${c}`);
            u && u.focus(), r.props.selections[c] ? r.props.activeSelectionValue = gt$1(r.props.selections[c]) : r.props.activeSelectionValue = void 0;
          }
          i && r.props.selections.length !== 1 || (r.props.userAction = { type: "selectionDelete" }), Tt$1(r, i);
        })(e, t);
    }
}
function go(e, t) {
  if (e.props.disabled || !(t.currentTarget instanceof HTMLElement) || e.props.id !== t.currentTarget.id) return;
  const n = t.key;
  switch (n) {
    case "Tab":
      (function(r) {
        r.props.expanded && (r.props.expanded = !1);
      })(e);
      break;
    case "ArrowUp":
    case "ArrowDown":
      lo(e, n, t);
      break;
    case "ArrowLeft":
    case "ArrowRight":
      io(e, n);
      break;
    case "Enter":
      fo(e, t);
      break;
    case "Escape":
      vo(e);
      break;
    case "Delete":
    case "Backspace":
      ao(e);
      break;
    default:
      e.emit("unusedKeydown", t);
  }
}
function $o(e, t) {
  if (e.props.disabled || !(t.currentTarget instanceof HTMLElement) || e.props.id !== t.currentTarget.id) return;
  const n = t.key;
  switch (n) {
    case "Tab":
      (function(r, i) {
        var s, l, c;
        r.props.expanded = !1, r.props.multiple && r.props.selections.length && r.props.type === "autocomplete" && r.props.selectionAppearance === "option" && (i.preventDefault(), (l = (s = r.props.__root) === null || s === void 0 ? void 0 : s.getElementById(`${r.props.id}_selection_wrapper_0`)) === null || l === void 0 || l.focus(), r.props.activeSelectionValue = ((c = r.props.selections[0]) === null || c === void 0 ? void 0 : c.value) || void 0);
      })(e, t);
      break;
    case "ArrowUp":
    case "ArrowDown":
      lo(e, n, t);
      break;
    case "ArrowRight":
    case "ArrowLeft":
      io(e, n);
      break;
    case "Enter":
      fo(e, t);
      break;
    case "Escape":
      vo(e);
      break;
    case "Delete":
    case "Backspace":
      ao(e);
  }
}
function bo(e) {
  e.props.alwaysLoadOnOpen = e.props.alwaysLoadOnOpen !== void 0 && undefine(e.props.alwaysLoadOnOpen), e.on("created", () => {
    e.context && (e.context.handlers.click = yo.bind(null, e), e.context.handlers.focus = xo.bind(null, e), e.context.handlers.keydown = go.bind(null, e), e.context.handlers.selectorTagKeydownHandler = (t) => ho.bind(null, e, t));
  });
}
function yo(e, t) {
  var n;
  if (t.stopPropagation(), t.detail === 0 || e.props.disabled) return;
  e.props.attrs.onClick && e.props.attrs.onClick(t);
  const r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
  e.props.justOpened ? e.props.justOpened = !1 : e.props.expanded ? e.props.expanded = !1 : (r && t.pointerType !== "mouse" ? (e.props.mouseX = -1, e.props.mouseY = -1) : (e.props.mouseX = t.clientX, e.props.mouseY = t.clientY), e.props.expanded = !0, r == null || r.focus());
}
function xo(e) {
  e.props.disabled || (e.props.attrs.onFocus && e.props.attrs.onFocus(), e.props.skipOpen ? e.props.skipOpen = !1 : e.props.openOnFocus && (e.props.justOpened = !0, e.props.expanded = !0));
}
function wo(e) {
  let t, n = "";
  e.on("unusedKeydown", ({ payload: r }) => {
    if (!r.isComposing && [...r.key].length === 1) {
      if (!n && r.key === " ") return void function(s, l) {
        var c;
        if (l.preventDefault(), s.props.expanded) {
          if (s.props.activeValue === At$1) return void ((c = s.context) === null || c === void 0 || c.handlers.loadMore());
          const u = s.props.allOptions.find((m) => eq(gt$1(m), s.props.activeValue));
          if (!u) return;
          Vt$1(s, u);
        } else s.props.expanded = !0;
      }(e, r);
      e.props.expanded = !0, clearTimeout(t), n += r.key;
      const i = e.props.allOptions.find((s) => s.label.toLowerCase().startsWith(n.toLowerCase()));
      i && (e.props.activeValue = gt$1(i)), t = setTimeout(() => {
        n = "";
      }, 400);
    }
  });
}
function _o(e) {
  ko(e), e.on("prop:selections", () => {
    e.props.skipFormatSelections = !1, ko(e);
  }), ne && whenAvailable(`${e.props.id}_selections`, Lo.bind(null, e), e.props.__root);
}
function ko(e) {
  e.isCreated && (e.props.selections.length && e.props.lastVisibleIndex && e.props.selections.length - e.props.lastVisibleIndex > 1 ? e.props.truncationCount = "+ " + (e.props.selections.length - e.props.lastVisibleIndex - 1).toString() : e.props.truncationCount = void 0, e.props.formattedSelections = e.props.selections.map((t, n) => e.props.lastVisibleIndex && n === e.props.lastVisibleIndex && n !== 0 ? e.props.lastTruncatedElText && n === e.props.selections.length - 1 ? e.props.lastTruncatedElText : n === e.props.selections.length - 1 ? t.label : t.label + "..." : n === e.props.selections.length - 1 ? t.label : t.label + ", "));
}
function So(e) {
  var t, n;
  if (!ne || !e.context) return;
  const r = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_selections`);
  if (!(r instanceof HTMLElement)) return;
  const i = r.parentNode;
  if (!(i instanceof HTMLElement)) return;
  let s = r.getBoundingClientRect().width;
  const l = 0.98 * i.getBoundingClientRect().width, c = Array.prototype.slice.call(r.children), u = [...e.props.selections];
  if (s > l) {
    const m = [];
    let qu = 0;
    for (let Gu = 0; Gu < u.length; Gu++) m.push([u[Gu], c[Gu]]);
    for (let Gu = m.length - 1; Gu >= 0; Gu--) {
      const Qu = m[Gu];
      if (!(Qu[1] instanceof HTMLElement)) return;
      qu += Qu[1].getBoundingClientRect().width + parseFloat(window.getComputedStyle(Qu[1]).marginRight) + parseFloat(window.getComputedStyle(Qu[1]).marginLeft);
      const Xu = s - qu;
      if (l > Xu) {
        const ef = Qu[0].label;
        e.props.skipFormatSelections = !0, Qu[1].textContent = ef;
        let tf = !1;
        for (let af = ef.length; af >= 0; af--) {
          if (e.props.skipFormatSelections = !0, Qu[1].textContent = ef.slice(0, af).trim() + "...", Xu + Qu[1].getBoundingClientRect().width < l) {
            if (af < 4) {
              e.props.lastVisibleIndex = Gu - 1, e.props.lastTruncatedElText = null;
              break;
            }
            if (e.props.lastVisibleIndex = Gu, e.props.lastTruncatedElText && Qu[1].textContent.slice(0, 4) === e.props.lastTruncatedElText.slice(0, 4)) break;
            e.props.lastTruncatedElText = (n = Qu[1]) === null || n === void 0 ? void 0 : n.textContent;
            break;
          }
          af === 0 && (tf = !0);
        }
        Qu[1].textContent = e.props.lastTruncatedElText && !tf && Gu !== 0 ? e.props.lastTruncatedElText : ef, e.props.lastVisibleIndex === null && (e.props.lastVisibleIndex = Gu === 0 ? 0 : Gu - 1, e.props.lastTruncatedElText = null), setTimeout(() => {
          ko(e);
        });
        break;
      }
    }
  } else e.props.lastTruncatedElText = null, e.props.lastVisibleIndex = null, ko(e);
}
function Lo(e, t) {
  const n = new ResizeObserver(() => {
    e.props.selections && e.props.selections.length !== 0 && (e.props.skipFormatSelections ? e.props.skipFormatSelections = !1 : So(e));
  }), r = new ResizeObserver(() => {
    So(e);
  });
  n.observe(t), t.parentNode instanceof Element && r.observe(t.parentNode);
}
const Io = { position: "fixed", top: 0, bottom: 0, right: 0, left: 0, pointerEvents: "none", zIndex: -1, overflowY: "auto", "-webkit-overflow-scrolling": "auto" }, Do = { position: "fixed", overflow: "hidden", height: "100%", width: "100%" }, Ao = { overflow: "hidden", height: "100%" }, Co = {}, To = {};
let Eo = 0;
function Oo(e) {
  var t, n;
  if (typeof window > "u") return;
  const r = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_popover`), i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
  if (!i || !r) return;
  const s = r.style.paddingTop, l = r.style.paddingBottom, c = r.style.paddingLeft;
  r.style.paddingTop = "0", r.style.paddingBottom = "0", r.style.paddingLeft = "0";
  const u = i.getBoundingClientRect(), m = r.getBoundingClientRect(), qu = Math.round(u.top - m.top) + "px", Gu = Math.round(u.left - m.left - 5) + "px", Qu = Math.max(Math.round(Math.min(m.height - m.top, window.innerHeight) - (u.top + u.height)), 0) + "px";
  r.style.paddingTop = s, r.style.paddingBottom = l, r.style.paddingLeft = c, e.props.dropdownWrapperStyles = { ...e.props.dropdownWrapperStyles, paddingTop: qu, paddingLeft: Gu, paddingBottom: Qu }, e.props.listboxStyles = { ...e.props.listboxStyles, minWidth: e.props.behavior === "overscroll" ? `min(${u.width + "px"}, calc(100vw - 4em))` : u.width + "px", maxWidth: "calc(100vw - 4em)" };
}
function Mo(e, t) {
  var n, r;
  let i = null;
  if (e.props.activeDescendant) {
    const s = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.activeDescendant);
    if (!s) return i;
    e.props.ignoreScroll = !0;
    const l = (r = e.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${e.props.id}_listbox`);
    if (!l) return i;
    const c = t.getBoundingClientRect(), u = l.getBoundingClientRect(), m = parseInt(getComputedStyle(t).paddingTop), qu = parseInt(getComputedStyle(t).paddingBottom), Gu = s.offsetTop - m, Qu = Math.max(Gu - m, 0), Xu = Math.max(t.scrollHeight - qu - Gu - c.height, 0), ef = u.height - Qu - Xu;
    t.scrollTop = Gu;
    const tf = () => {
      t.scrollTop = Xu > 0 ? Xu < m ? t.scrollHeight : m : Qu < qu ? 0 : Gu - qu;
    }, af = Math.min(150, u.height);
    Qu > 0 && Xu > 0 || Qu === 0 && Xu === 0 || ef > af ? t.scrollTop = Gu : tf(), t.clientHeight / 2 < t.scrollTop && (i = e.props.options.filter((rf) => {
      var hf;
      return !(!((hf = rf.attrs) === null || hf === void 0) && hf.disabled);
    }).findIndex((rf) => eq(e.value, gt$1(rf)))), i === -1 && (i = null);
  }
  return i;
}
function Vo(e) {
  e.addProps(["behavior"]), e.on("created", () => {
    e.props.behavior === "overscroll" && (typeof e.props.optionsLoader == "function" && error(300, [e]), e.props.dropdownWrapperStyles = clone(Io), e.props.listboxStyles = { display: "inline-block" }, e.props.styleWrapper = Oo.bind(null, e), e.props.positionListBox = Mo.bind(null, e));
  }), e.on("prop:expanded", ({ payload: t }) => {
    e.props.behavior === "overscroll" && (t ? function() {
      Eo = document.documentElement.scrollTop;
      for (const n in Do) To[n] = document.documentElement.style[n], document.documentElement.style[n] = Do[n];
      for (const n in Ao) Co[n] = document.body.style[n], document.body.style[n] = Ao[n];
      document.body.scrollTop = Eo;
    }() : function() {
      for (const n in Do) document.documentElement.style[n] = To[n];
      for (const n in Ao) document.body.style[n] = Co[n];
      document.body.scrollTop = 0, document.documentElement.scrollTop = Eo;
    }());
  });
}
function Fo(e) {
  e.addProps(["multiLine"]), e.on("created", () => {
    ne && (e.props.multiLineHeight = void 0, whenAvailable(`${e.props.id}_selections`, Bo.bind(null, e), e.props.__root));
  });
}
function Bo(e) {
  var t;
  const n = new ResizeObserver((i) => {
    for (const s of i) {
      const { height: l } = s.contentRect;
      e.props.selectionsHeight !== l && (e.props.selectionsHeight = l), Po(e, s.target);
    }
  }), r = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_selections`);
  r && n.observe(r);
}
function Po(e, t) {
  var n;
  const r = t.querySelectorAll(`[id^="${e.props.id}_tag-wrapper"`);
  let i, s = [];
  if (e.props.type === "taglist") {
    const c = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
    if (!c) return;
    s = [c, ...Array.from(r)];
  } else s = Array.from(r);
  if (!r) return;
  let l = !1;
  for (const c of s) if (i === void 0) i = c.getBoundingClientRect();
  else {
    const u = c.getBoundingClientRect();
    if (i.top >= u.top + u.height / 5 || i.top <= u.top - u.height / 5) {
      l = !0, e.props.multiLine = !0;
      break;
    }
  }
  l || (e.props.multiLine = !1);
}
function Ho(e) {
  if (e.on("created", () => {
    e.context && wo(e);
  }), e.props.multiple || function(t) {
    t.on("prop:selections", ({ payload: n }) => {
      var r;
      t.props.firstSelectionLabel = ((r = n[0]) === null || r === void 0 ? void 0 : r.label) || "", t.props.option = n[0];
    });
  }(e), e.props.selectionAppearance === "truncate" && (e.props.lastVisibleIndex = null, _o(e), e.on("prop:selections", () => {
    _o(e);
  })), e.props.selectionAppearance === "tags" && Fo(e), e.props.multiple && e.props.selectionAppearance === "tags") {
    let t = function() {
      return Array.isArray(e.value) ? e.value : [];
    }, n = function(r, i) {
      e.input(r);
    };
    e.on("created", () => {
      e.props.disabled && (e.props.draggable = !1), whenAvailable(`${e.props.id}_selections`, (r) => {
        if (e.context && r instanceof HTMLElement) {
          const i = { threshold: { horizontal: 0.25, vertical: 0 }, plugins: [animations()], draggingClass: e.context.classes.dragging, dropZoneClass: e.context.classes.dropZone, disabled: !e.props.draggable, root: e.props.__root, touchDraggingClass: e.context.classes.touchDragging, touchDropZoneClass: e.context.classes.touchDropZone, draggable: (s) => s.hasAttribute("data-is-tag") };
          dragAndDrop({ parent: r, getValues: t, setValues: n, config: i }), e.on("prop:disabled", ({ payload: s }) => {
            i.disabled = s, dragAndDrop({ parent: r, getValues: t, setValues: n, config: i });
          }), e.on("prop:draggable", ({ payload: s }) => {
            i.disabled = !s, dragAndDrop({ parent: r, getValues: t, setValues: n, config: i });
          });
        }
      }, e.props.__root);
    });
  }
  e.on("prop:expanded", ({ payload: t }) => {
    t && e.props.optionsLoader && typeof e.props.optionsLoader == "function" && (!e.props.options.length || e.props.alwaysLoadOnOpen) && (e.props.options = [], It$1(e));
  }), e.props.behavior === "overscroll" && Vo(e);
}
const Ro = (e, t) => {
  let n = null, r = null, i = null;
  return function(...s) {
    const l = this;
    n ? (r = s, i = l) : (e.apply(l, s), n = window.setTimeout(() => {
      n = null, r !== null && i !== null && (e.apply(i, r), r = null, i = null);
    }, t));
  };
};
function No(e) {
  if (e.addProps(["popover", "popoverOffset", "usePopover", "popoverCoordinates", "popoverAncestorCoordinates"]), e.props.popover = undefine(e.props.popover) ? "manual" : void 0, e.type !== "input" || e.props.behavior === "overscroll") return;
  let t = null, n = null, r = [], i = null;
  if (e.props.popoverOffset = undefine(e.props.popoverOffset) ? parseInt(e.props.popoverOffset) : 0, !e.props.popover) return;
  if (typeof document > "u" || !("popover" in HTMLElement.prototype)) return void (typeof window < "u" && console.warn('FormKit: Popover API is not supported in this browser — input panels will be rendered with fallback CSS positioning. This could result in inaccessible inputs due to parent containers using "overflow: hidden" or z-index conflicts.'));
  const s = () => {
    e.props.invertPopover = !1, document.removeEventListener("resize", i), document.removeEventListener("scroll", i), r.forEach((u) => {
      u.removeEventListener("scroll", i);
    });
  };
  function l() {
    const { x: u, y: m, width: qu, height: Gu } = function(Qu, Xu) {
      if (!Qu || !Xu) return { x: 0, y: 0 };
      const { left: ef, top: tf, width: af, height: rf } = Xu.getBoundingClientRect();
      return { x: ef + window.scrollX, y: tf + rf + window.scrollY, width: af, height: rf };
    }(t, n);
    e.props.popoverAncestorCoordinates = { x: u, y: m, width: qu, height: Gu }, e.props.popoverCoordinates = { x: u, y: m, width: qu, height: 0 };
  }
  function c(u) {
    t && document.body.contains(t) && (u ? (t == null || t.showPopover(), setTimeout(() => {
      e.props.popoverCoordinates.height = (t == null ? void 0 : t.offsetHeight) || 0;
    }, 5)) : t.matches(":popover-open") && (t.hidePopover(), e.props.popoverCoordinates.height = 0));
  }
  e.on("mounted", () => {
    e.context && (e.props.usePopover = !0, e.props.popoverCoordinates = { x: 0, y: 0, width: 0, height: 0 }, e.props.popoverAncestorCoordinates = { x: 0, y: 0, width: 0, height: 0 });
  }), e.on("destroyed", () => {
    s();
  }), e.on("prop:inputText", () => {
    e.context && (l(), c(!0));
  }), e.on("prop:expanded", ({ payload: u }) => {
    var m;
    e.context && (u === !1 ? s() : whenAvailable(`${(m = e.context) === null || m === void 0 ? void 0 : m.id}_popover`, () => {
      if (!e.context) return;
      t = document.querySelector(`[id="${e.context.id}_popover"][popover]`) || document.querySelector(`[id="${e.context.id}_popover"] [popover]`), n || (n = function(Gu) {
        if (!Gu) return null;
        let Qu = Gu.parentElement;
        for (; Qu && window.getComputedStyle(Qu).position === "static"; ) Qu = Qu.parentElement;
        return Qu;
      }(t)), l(), c(u), i = Ro(() => {
        e.context && (l(), c(u));
      }, 10), document.addEventListener("resize", i), document.addEventListener("scroll", i), r = [];
      let qu = t == null ? void 0 : t.parentElement;
      for (; qu; ) qu.scrollHeight > qu.clientHeight && r.push(qu), qu = qu.parentElement;
      r.forEach((Gu) => {
        Gu.addEventListener("scroll", i);
      });
    }));
  });
}
const Ko = { schema: /* @__PURE__ */ Re(/* @__PURE__ */ Ne(/* @__PURE__ */ Ue("$label"), /* @__PURE__ */ Ke(/* @__PURE__ */ We("prefix"), /* @__PURE__ */ Ye(), /* @__PURE__ */ qe(/* @__PURE__ */ Be("$inputStd.length === 0 && $state.loading !== true", /* @__PURE__ */ Qe('$placeholder || "placeholder"'), /* @__PURE__ */ Be("$multiple !== true", /* @__PURE__ */ Xe(/* @__PURE__ */ Be("$state.loading && $selections.length === 0", /* @__PURE__ */ et$1("$ui.isLoading.value"), /* @__PURE__ */ Je(/* @__PURE__ */ tt$1("$option.label")))), /* @__PURE__ */ Be('$multiple && $selectionAppearance === "truncate"', /* @__PURE__ */ nt$1(/* @__PURE__ */ rt$1(/* @__PURE__ */ Be("$state.loading && $selections.length === 0", /* @__PURE__ */ et$1("$ui.isLoading.value"), /* @__PURE__ */ at$1()))), /* @__PURE__ */ Be('$multiple && $selectionAppearance === "tags"', /* @__PURE__ */ dt$1(/* @__PURE__ */ ct$1(/* @__PURE__ */ Be("$state.loading && $isLoadingOption !== true && $selections.length === 0", /* @__PURE__ */ et$1("$ui.isLoading.value"), /* @__PURE__ */ lt$1(/* @__PURE__ */ it$1(/* @__PURE__ */ Be("$state.loading && $optionLoaderValues.includes($option.value) || $option.label === undefined", /* @__PURE__ */ ut$1("$ui.isLoading.value"), /* @__PURE__ */ pt$1("$option.label")), /* @__PURE__ */ ot$1(/* @__PURE__ */ We("close"))))))))))), /* @__PURE__ */ Be("$truncationCount && $state.loading !== true", /* @__PURE__ */ st$1("$truncationCount")), /* @__PURE__ */ Be("$state.loading", /* @__PURE__ */ We("loader")), /* @__PURE__ */ Be("$inputStd.length !== 0 && $selectionRemovable", /* @__PURE__ */ ot$1(/* @__PURE__ */ We("close")), /* @__PURE__ */ We("select"))), /* @__PURE__ */ ft$1(), /* @__PURE__ */ je(), /* @__PURE__ */ We("suffix"))), /* @__PURE__ */ ze("$help"), /* @__PURE__ */ Ze(/* @__PURE__ */ Ge("$message.value"))), type: "input", family: "dropdown", props: [], features: [
  /* @__PURE__ */ defaultIcon("select", "select"),
  /* @__PURE__ */ defaultIcon("close", "close"),
  /* @__PURE__ */ defaultIcon("selected", "check"),
  /* @__PURE__ */ defaultIcon("loader", "spinner"),
  /* @__PURE__ */ localize("isLoading"),
  /* @__PURE__ */ localize("loadMore"),
  /* @__PURE__ */ localize("remove"),
  options$1,
  /* @__PURE__ */ ro.bind(null, so, bo, Ho),
  No
] }, Wo = /* @__PURE__ */ Me("tg"), { outer: Uo, wrapper: Yo, label: jo, prefix: zo, suffix: Zo, help: Go, messages: qo, message: Xo, icon: Jo } = /* @__PURE__ */ Ve(Wo), Qo = Wo("input", () => ({ $el: "input", bind: "$attrs", attrs: { type: "checkbox", id: "$id", value: "$value", name: "$node.name", checked: "$checked", onInput: "$handlers.toggles", onBlur: "$handlers.blur", disabled: "$disabled" } })), en = Wo("label", () => ({ if: "($label && $onValueLabel === undefined && $offValueLabel === undefined) || ($valueLabelDisplay === inner) && $altLabelPosition !== true", $el: "label", attrs: { for: "$id" }, children: "$label" })), tn = Wo("altLabel", () => ({ $el: "label", if: "($label && ($onValueLabel || $offValueLabel) && $valueLabelDisplay !== hidden && $valueLabelDisplay !== inner) || $altLabelPosition === true", attrs: { for: "$id", "data-label-alt": "true", style: { color: { if: "$checked", then: "$valueLabelColorOn", else: "$valueLabelColorOff" } } }, children: "$label" })), on = Wo("innerLabel", () => ({ $el: "div", if: "$valueLabelDisplay === inner && ($checked && $onValueLabel || $offValueLabel)", attrs: { style: { color: { if: "$checked", then: "$valueLabelColorOn", else: "$valueLabelColorOff" } } }, children: { if: "$checked", then: "$onValueLabel", else: "$offValueLabel" } })), nn = Wo("valueLabel", () => ({ $el: "label", if: "$valueLabelDisplay !== hidden && $valueLabelDisplay !== inner && (($checked === true && $onValueLabel) || ($checked === false && $offValueLabel))", attrs: { for: "$id" }, children: { if: "$checked && $onValueLabel", then: "$onValueLabel", else: { if: "$offValueLabel", then: "$offValueLabel" } } })), rn = Wo("inner", () => ({ $el: "label", attrs: { for: "$id", id: "$id + '_label'" } })), sn = Wo("track", () => ({ $el: "div", attrs: { style: { backgroundColor: { if: "$checked", then: "$trackColorOn", else: "$trackColorOff" } } } })), an = Wo("thumb", () => ({ $el: "div", attrs: { style: { color: { if: "$checked", then: "$iconColorOn", else: "$iconColorOff" }, backgroundColor: { if: "$checked", then: "$thumbColorOn", else: "$thumbColorOff" } } } })), ln = () => an(Be("$slots.default", "$slots.default", Jo("thumb"))), pn = { schema: /* @__PURE__ */ Uo(/* @__PURE__ */ Yo(/* @__PURE__ */ tn(), /* @__PURE__ */ rn(/* @__PURE__ */ zo(), /* @__PURE__ */ Qo(), /* @__PURE__ */ sn(/* @__PURE__ */ on(), /* @__PURE__ */ ln()), /* @__PURE__ */ Zo()), /* @__PURE__ */ nn(), /* @__PURE__ */ en()), /* @__PURE__ */ Go("$help"), /* @__PURE__ */ qo(/* @__PURE__ */ Xo("$message.value"))), type: "input", props: ["checked", "thumbColorOff", "thumbColorOn", "iconColorOff", "iconColorOn", "valueLabelColorOff", "valueLabelColorOn", "offValue", "offValueLabel", "onValue", "onValueLabel", "thumbIcon", "trackColorOff", "trackColorOn", "valueLabelDisplay", "altLabelPosition"], features: [function(e) {
  function t(n, r) {
    r.target instanceof HTMLInputElement && (n.input(r.target.checked ? n.props.onValue : n.props.offValue), n.props.checked = r.target.checked);
  }
  e.on("created", () => {
    "disabled" in e.props && (e.props.disabled = undefine(e.props.disabled)), e.props.altLabelPosition = undefine(e.props.altLabelPosition), e.props.offValue === void 0 && (e.props.offValue = !1), e.props.onValue === void 0 && (e.props.onValue = !0), e.props.checked = eq(e.value, e.props.onValue), e.context && (e.context.handlers.toggles = t.bind(null, e));
  }), e.on("commit", ({ payload: n }) => {
    e.props.checked = eq(n, e.props.onValue);
  });
}] }, dn = /* @__PURE__ */ Me("rp"), { outer: cn, inner: un, prefix: fn, suffix: vn, help: hn, messages: mn, message: gn, icon: $n } = /* @__PURE__ */ Ve(dn), bn = dn("empty", () => ({ $el: "div" })), yn = dn("insertControl", () => ({ $el: "button", attrs: { disabled: "$value.length >= $max", onClick: "$fns.createInsert($index)", type: "button" } })), xn = dn("addButton", () => ({ $formkit: "button", bind: "$addAttrs", if: "$addButton", disabled: "$value.length >= $max", onClick: "$fns.createAppend()", type: "button" })), wn = dn("removeControl", () => ({ $el: "button", attrs: { disabled: "$value.length <= $min", onClick: "$fns.createRemover($index)", type: "button" } })), _n = dn("items", () => ({ $el: "ul", meta: { autoAnimate: !0 }, attrs: { role: "list", id: '$id + "_items"' } })), kn = dn("item", () => ({ $el: "li", for: ["item", "index", "$items"], attrs: { role: "listitem", key: "$item", "data-index": "$index" } })), Sn = dn("downControl", () => ({ $el: "button", attrs: { disabled: "$index >= $value.length - 1", onClick: "$fns.createShift($index, 1)", type: "button" } })), Ln = dn("upControl", () => ({ $el: "button", attrs: { disabled: "$index <= 0", onClick: "$fns.createShift($index, -1)", type: "button" } })), In = dn("content", "div"), Dn = dn("fieldset", () => ({ $el: "fieldset", attrs: { id: "$id" } })), An = dn("legend", () => ({ $el: "legend", if: "$label" })), Cn = dn("group", () => ({ $formkit: "group", index: "$index" })), Tn = dn("controls", () => ({ $el: "ul", if: "$removeControl || $insertControl || $upControl || $downControl" })), En = dn("remove", () => ({ $el: "li", if: "$removeControl" })), On = dn("insert", () => ({ $el: "li", if: "$insertControl" })), Mn = dn("up", () => ({ $el: "li", if: "$upControl" })), Vn = dn("down", () => ({ $el: "li", if: "$downControl" })), Fn = dn("controlLabel", "span"), Bn = dn("dragHandleWrapper", () => ({ if: "$draggable", $el: "div" })), Pn = dn("dragHandle", () => ({ $el: "div", attrs: { id: '$id + "_drag_handle"' } }));
function Hn(e) {
  var t, n, r, i, s, l, c, u, m, qu, Gu, Qu, Xu, ef;
  if ((t = (u = e.props).removeControl) !== null && t !== void 0 || (u.removeControl = !0), (n = (m = e.props).upControl) !== null && n !== void 0 || (m.upControl = !0), (r = (qu = e.props).downControl) !== null && r !== void 0 || (qu.downControl = !0), (i = (Gu = e.props).insertControl) !== null && i !== void 0 || (Gu.insertControl = !1), (s = (Qu = e.props).addButton) !== null && s !== void 0 || (Qu.addButton = !0), (l = (Xu = e.props).addLabel) !== null && l !== void 0 || (Xu.addLabel = !1), (c = (ef = e.props).addAttrs) !== null && c !== void 0 || (ef.addAttrs = {}), e.props.draggable = undefine(e.props.draggable), e.props.min = e.props.min !== void 0 ? Number(e.props.min) : 1, e.props.max = e.props.max !== void 0 ? Number(e.props.max) : 1 / 0, e.props.min > e.props.max) throw Error("Repeater: min must be less than max");
  if (Array.isArray(e.value)) if (e.value.length < e.props.min) {
    const tf = he$1(e.props.min - e.value.length, () => ({}));
    e.input(e.value.concat(tf), !1);
  } else e.value.length > e.props.max && e.input(e.value.slice(0, e.props.max), !1);
  else e.input(he$1(e.props.min, () => ({})), !1);
  e.context && function(tf, af) {
    af.createShift = (rf, hf) => () => {
      const sf = tf._value;
      sf.splice(rf + hf, 0, sf.splice(rf, 1)[0]), tf.input(sf, !1);
    }, af.createInsert = (rf) => () => {
      const hf = tf._value;
      hf.splice(rf + 1, 0, {}), tf.input(hf, !1);
    }, af.createAppend = () => () => {
      const rf = tf._value;
      rf.push({}), tf.input(rf, !1);
    }, af.createRemover = (rf) => () => {
      const hf = tf._value;
      hf.splice(rf, 1), tf.input(hf, !1);
    };
  }(e, e.context.fns);
}
function Rn(e, t) {
  var n;
  if (!t.context) return;
  const r = (n = t.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${t.props.id}_inner`), i = r == null ? void 0 : r.hasAttribute("data-auto-animate"), s = { group: t.props.id, dragHandle: `#${t.props.id}_drag_handle`, draggingClass: t.context.classes.dragging, dropZoneClass: t.context.classes.dropZone, root: t.props.__root, disabled: !t.props.draggable, plugins: i ? [] : [animations({ duration: 100 })], touchDraggingClass: t.context.classes.touchDragging, touchDropZoneClass: t.context.classes.touchDropZone, draggable: (u) => u.tagName === "LI" };
  function l() {
    return Array.isArray(t.value) ? t.value : [];
  }
  function c(u) {
    t.input(u);
  }
  dragAndDrop({ parent: e, getValues: l, setValues: c, config: s }), t.on("prop:disabled", ({ payload: u }) => {
    s.disabled = u, dragAndDrop({ parent: e, getValues: l, setValues: c, config: s });
  }), t.on("prop:draggable", ({ payload: u }) => {
    s.disabled = !u, dragAndDrop({ parent: e, getValues: l, setValues: c, config: s });
  });
}
const Nn = { schema: /* @__PURE__ */ cn(/* @__PURE__ */ Dn(/* @__PURE__ */ An("$label"), /* @__PURE__ */ hn("$help"), /* @__PURE__ */ un(/* @__PURE__ */ fn(), /* @__PURE__ */ Be("$value.length === 0", /* @__PURE__ */ Be("$slots.empty", /* @__PURE__ */ bn()), /* @__PURE__ */ _n(/* @__PURE__ */ kn(/* @__PURE__ */ Bn(/* @__PURE__ */ Pn(/* @__PURE__ */ $n("dragHandle"))), /* @__PURE__ */ In(/* @__PURE__ */ Cn("$slots.default")), /* @__PURE__ */ Tn(/* @__PURE__ */ Mn(/* @__PURE__ */ Ln(/* @__PURE__ */ Fn("$ui.moveUp.value"), /* @__PURE__ */ $n("moveUp"))), /* @__PURE__ */ En(/* @__PURE__ */ wn(/* @__PURE__ */ Fn("$ui.remove.value"), /* @__PURE__ */ $n("remove"))), /* @__PURE__ */ On(/* @__PURE__ */ yn(/* @__PURE__ */ Fn("$ui.add.value"), /* @__PURE__ */ $n("add"))), /* @__PURE__ */ Vn(/* @__PURE__ */ Sn(/* @__PURE__ */ Fn("$ui.moveDown.value"), /* @__PURE__ */ $n("moveDown"))))), /* @__PURE__ */ vn()))), /* @__PURE__ */ xn('$addLabel || ($ui.add.value + " " + ($label || ""))')), /* @__PURE__ */ mn(/* @__PURE__ */ gn("$message.value"))), type: "list", props: ["min", "max", "total", "upControl", "downControl", "removeControl", "insertControl", "addLabel", "addButton", "addAttrs", "draggable"], features: [
  function(e) {
    e._c.sync = !0, e.on("created", Hn.bind(null, e)), e.on("mounted", () => {
      whenAvailable(`${e.props.id}_items`, (t) => {
        if (t instanceof HTMLElement) {
          let n = function(r) {
            for (const i of r) for (const s of Array.from(i.addedNodes)) if (s instanceof HTMLElement && s.id === `${e.props.id}_items`) return void Rn(s, e);
          };
          Rn(t, e), new MutationObserver(n).observe(t.parentNode, { childList: !0 });
        }
      }, e.props.__root);
    });
  },
  disables,
  /* @__PURE__ */ localize("remove"),
  /* @__PURE__ */ localize("add"),
  /* @__PURE__ */ localize("moveUp"),
  /* @__PURE__ */ localize("moveDown"),
  /* @__PURE__ */ defaultIcon("dragHandle", "dragHandle"),
  /* @__PURE__ */ defaultIcon("remove", "trash"),
  /* @__PURE__ */ defaultIcon("add", "add"),
  /* @__PURE__ */ defaultIcon("moveUp", "arrowUp"),
  /* @__PURE__ */ defaultIcon("moveDown", "arrowDown")
] }, Kn = /* @__PURE__ */ new WeakMap();
function Wn(e, t) {
  const n = { onItems: [], offItems: [] }, r = t || Number(e.value || 0);
  for (let i = 0; i < e.props.max; i++) if (i < r && i + 1 >= r) {
    const s = e.props.rightToLeft ? 100 - 100 * (r - i) : 100 * (r - i);
    n.onItems.push(s + "%"), n.offItems.push(100 - s + "%");
  } else i < r ? (n.offItems.push("0%"), n.onItems.push("100%")) : i >= r && (n.offItems.push("100%"), n.onItems.push("0%"));
  e.props.itemsToPercentages = n;
}
function Un(e, t) {
  var n;
  (n = e.context) === null || n === void 0 || n.handlers.blur(t);
}
function Yn(e, t) {
  const { x: n, y: r } = er(t);
  let i = document.elementFromPoint(n, r);
  const s = Array.from(document.querySelectorAll(`#${e.props.id}_items_wrapper > .formkit-ratingItem`));
  let l = !0;
  for (; i && l; ) {
    if (s.includes(i)) {
      l = !1;
      break;
    }
    i = i.parentNode;
  }
  if (!l) {
    const c = s.indexOf(i);
    if (e.props.step === 1) return void e.input(c + 1, !1);
  }
}
function jn(e, t, n) {
  e.props.disabled || (n.preventDefault(), e.props.hoverHighlight = !0, e.props.touchStarted = !0, e.props.step !== 1 ? tr(e, t, n) : e.input(t + 1, !1));
}
function zn(e, t) {
  if (!e.props.dragStarted) return;
  t.preventDefault(), e.props.hoverHighlight = !1, e.props.dragStarted = !1, Wn(e);
  const n = Kn.get(e);
  n && (n.abort(), Kn.delete(e));
}
function Zn(e, t, n) {
  if (e.props.hoverHighlight || e.props.disabled) return;
  n.preventDefault(), e.props.hoverHighlight = !0, e.props.dragStarted = !0;
  const r = new AbortController();
  document.addEventListener("mouseup", (i) => zn(e, i), { signal: r.signal }), Kn.set(e, r), e.props.step === 1 ? e.input(t + 1, !1) : tr(e, t, n);
}
function Gn(e, t) {
  var n, r;
  if (document.activeElement === t.currentTarget) {
    if (t.key === "ArrowRight" || t.key === "ArrowDown") {
      e.props.arrow = 1;
      const i = e.value ? or(e.value + 1 * e.props.step, e.props.step) : e.props.min + 1 * e.props.step, s = (n = e.props.__root) === null || n === void 0 ? void 0 : n.querySelector(e.value ? `#${e.props.id}_inner input[value="${i}"]` : "#" + (e.props.id + "_0_0"));
      e.props.preventFocus = !0, s && s instanceof HTMLInputElement && s.focus(), e.props.preventFocus = !1, e.input(Number(i));
    } else if (t.key === "ArrowLeft" || t.key === "ArrowUp") {
      e.props.arrow = -1;
      const i = e.value ? or(e.value - 1 * e.props.step, e.props.step) : e.props.max, s = (r = e.props.__root) === null || r === void 0 ? void 0 : r.querySelector(`#${e.props.id}_inner input[value="${i}"]`);
      e.props.preventFocus = !0, s && s instanceof HTMLInputElement && s.focus(), e.props.preventFocus = !0, e.input(Number(i)), e.props.preventFocus = !1;
    }
  }
}
function qn(e, t) {
  if (!e.props.preventFocus) {
    if (e.props.preventFocus = !0, setTimeout(() => {
      e.props.preventFocus = !1;
    }, 50), t.relatedTarget instanceof HTMLElement && t.relatedTarget.id === e.props.id + "_items_wrapper") e.props.arrow > 0 ? setTimeout(() => {
      var n, r;
      (r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + "_0_0")) === null || r === void 0 || r.focus();
    }) : e.props.arrow < 0 && setTimeout(() => {
      var n, r;
      (r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + `_${e.props.max - 1}_${e.props.stepsPerValue - 1}`)) === null || r === void 0 || r.focus();
    });
    else if (t.target instanceof HTMLInputElement) {
      if (Number(t.target.value) === e.props.step && e.value === e.props.max || Number(t.target.value) === e.props.max && e.value === e.props.step) {
        const n = document.getElementById(e.props.id + "_items_wrapper");
        return n == null || n.focus(), void e.input(0);
      }
      e.input(Number(t.target.value));
    }
  }
}
function Xn(e, t, n) {
  e.props.hoverHighlight && (e.props.disabled || (e.props.step === 1 ? (Wn(e, t + 1), e.props.dragStarted && e.input(t + 1, !1)) : tr(e, t, n, !!e.props.dragStarted)));
}
function Jn(e) {
  Wn(e);
}
function Qn(e, t, n) {
  if (!e.props.disabled && n.type !== "touchstart" && (n.preventDefault(), (n.clientX !== 0 || n.clientY !== 0) && n.currentTarget instanceof HTMLElement)) return e.props.step === 1 ? e.props.deselect && Number(e.value) === t + 1 ? void e.input(0) : void e.input(t + 1) : void tr(e, t, n);
}
function er(e) {
  return e instanceof MouseEvent ? { x: e.clientX, y: e.clientY } : { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
}
function tr(e, t, n, r = !0) {
  if (!(n.currentTarget instanceof HTMLElement)) return;
  const { x: i, y: s } = er(n), l = n.currentTarget.getBoundingClientRect();
  let c = or((i - l.x) / l.width + t, e.props.step);
  c = c > e.props.min ? c : e.props.min, c = c < e.props.max ? c : e.props.max, !e.props.deselect || c !== Number(e.value) || e.props.dragStarted ? r ? e.input(c, !1) : Wn(e, c) : e.input(0);
}
function or(e, t) {
  t || (t = 1);
  const n = 1 / t;
  return Math.ceil(e * n) / n;
}
const nr = /* @__PURE__ */ Me("rt"), { outer: rr, wrapper: sr, inner: ar, label: lr, prefix: ir, suffix: pr, help: dr, messages: cr, message: ur, icon: fr } = /* @__PURE__ */ Ve(nr), vr = nr("itemsWrapper", () => ({ $el: "span", attrs: { style: { "flex-direction": '$rightToLeft && "row-reverse" || undefined' }, tabindex: "$value !== undefined && $value !== 0 && '-1' || '0'", id: "$id + _items_wrapper", onKeydown: "$handlers.handleWrapperKeydown", "data-disabled": "$disabled", onBlur: "$handlers.handleWrapperBlur", onMouseleave: "$hoverHighlight && $handlers.handleMouseleave" } })), hr = nr("ratingItem", () => ({ for: ["item", "index", "$max"], $el: "span", attrs: { id: '$id + "_item_" + $index', onClick: "$handlers.handleItemClick($item)", draggable: "$hoverHighlight !== true && && $disabled !== true && true", onMousemove: "$handlers.handleMousemove($item)", onDragstart: "$handlers.handleDragstart($item)", onDragend: "$handlers.handleDragend", onTouchstart: "$handlers.handleTouchstart($item)", onTouchmove: "$handlers.handleTouchmove" } })), mr = nr("template", () => ({ for: ["increment", "stepIndex", "$stepsPerValue"], $el: null })), gr = nr("itemLabel", () => ({ $el: "label", attrs: { id: '$id + "_label_" + $index + "_" + $stepIndex', for: '$id + "_" + $index + "_" + $stepIndex', "data-checked": '$value === $fns.getValue($item, $increment) && "true" || "false"', style: { width: '$fns.showLabel($fns.getValue($item, $increment), $stepIndex, $item) && "100%" || "0%"' } } })), $r = nr("itemLabelInner", () => ({ $el: "span", children: "$fns.getValue($item, $increment)" })), br = nr("input", () => ({ $el: "input", attrs: { type: "radio", value: "$fns.getValue($item, $increment)", id: '$id + "_" + $index + "_" + $stepIndex', onFocus: "$handlers.handleFocus", tabindex: '$value === $fns.getValue($item, $increment) && "0" || "-1"', disabled: "$disabled", name: "$id", "data-value": "$fns.getValue($item, $increment)", checked: "$value === $fns.getValue($item, $increment) && true", onKeydown: "$handlers.handleKeydown($fns.getValue($item, $increment))" } })), yr = nr("onItemRow", () => ({ $el: "span", attrs: { style: { width: "$fns.getPercentage($itemsToPercentages, $item)", display: "flex", position: "relative", overflow: "hidden", top: "0", left: "0", bottom: "0" } } })), xr = nr("offItemRow", () => ({ $el: "span", attrs: { style: { width: "$fns.getPercentage($itemsToPercentages, $item, false)", display: "flex", "flex-direction": "row-reverse", position: "absolute", zIndex: "$offItemStyles && 100", overflow: "hidden", top: "0", right: "0" } } })), wr = nr("onItemWrapper", () => ({ $el: "div", attrs: { style: { color: "$onColor" } } })), _r = nr("offItemWrapper", () => ({ $el: "div", attrs: { style: { color: "$offColor" } } })), kr = () => Be("$slots.onItem", () => () => "$slots.onItem", Be("$slots.default", () => () => "$slots.default", fr("rating"))), Sr = () => Be("$slots.offItem", () => () => "$slots.offItem", Be("$slots.default", () => () => "$slots.default", fr("rating"))), Lr = { schema: /* @__PURE__ */ rr(/* @__PURE__ */ sr(/* @__PURE__ */ lr("$label"), /* @__PURE__ */ ar(/* @__PURE__ */ fr("prefix"), /* @__PURE__ */ ir(), /* @__PURE__ */ vr(/* @__PURE__ */ hr(/* @__PURE__ */ mr(/* @__PURE__ */ gr(/* @__PURE__ */ yr(/* @__PURE__ */ wr(/* @__PURE__ */ kr())), /* @__PURE__ */ xr(/* @__PURE__ */ _r(/* @__PURE__ */ Sr())), /* @__PURE__ */ $r()), /* @__PURE__ */ br()))), /* @__PURE__ */ pr(), /* @__PURE__ */ fr("suffix"))), /* @__PURE__ */ dr("$help"), /* @__PURE__ */ cr(/* @__PURE__ */ ur("$message.value"))), type: "input", props: [], features: [function(e) {
  function t(n) {
    setTimeout(() => {
      const r = Array.from(document.querySelectorAll(`#${n.props.id}_items_wrapper > .formkit-ratingItem`));
      for (let i = 0; i < r.length; i++) {
        const s = r[i].querySelectorAll(".formkit-onItemWrapper"), l = r[i].querySelectorAll(".formkit-offItemWrapper");
        for (let c = 0; c < s.length; c++) s[c].style.flex = `0 0 ${r[i].getBoundingClientRect().width}px`;
        for (let c = 0; c < l.length; c++) l[c].style.flex = `0 0 ${r[i].getBoundingClientRect().width}px`;
      }
    });
  }
  e.addProps(["max", "step", "stepsPerValue", "itemsToPercentages", "rightToLeft", "onItemStyles", "offItemStyles", "hoverHighlight", "deselect", "disabled", "wrapperWidth", "onColor", "offColor"]), e.props.hoverHighlight !== !1 && e.props.hoverHighlight !== "false" && (e.props.hoverHighlight = !0), e.props.deselect = undefine(e.props.deselect), e.props.max = Number(e.props.max) || 5, e.props.min = Number(e.props.min) || 0, e.props.step = Number(e.props.step) || 1, e.props.numberOfSteps = e.props.max / e.props.step, e.props.lastIndex = 1 / e.props.step - 1, e.props.itemsToPercentages = {}, "disabled" in e.props && (e.props.disabled = undefine(e.props.disabled)), e.props.rightToLeft ? (e.props.onItemStyles = void 0, e.props.offItemStyles = { position: "absolute", top: "0", left: "0", overflow: "hidden", height: "100%", zIndex: 100 }) : e.props.onItemStyles = { position: "absolute", top: "0", left: "0", overflow: "hidden", height: "100%" }, e.props.stepsPerValue = 1 / e.props.step, e.hook.input((n, r) => {
    if (n === null || n === "" || isNaN(n)) return r(n);
    const i = Number(n), s = Number(e.props.min), l = Number(e.props.max);
    return i > l ? r(l) : e.props.min && i <= s ? r(s) : r(i);
  }), e.on("commit", ({ payload: n }) => {
    const r = Number(n || 0);
    Wn(e, r);
  }), e.on("created", () => {
    e.context && (whenAvailable(`${e.props.id}_items_wrapper`, () => {
      t(e), function(n) {
        var r;
        const i = (r = n.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${n.props.id}_items_wrapper`);
        i && new ResizeObserver(() => {
          t(n);
        }).observe(i);
      }(e), setTimeout(() => t(e), 100);
    }, e.props.__root), e.context.fns.getPercentage = (n, r, i = !0) => (i ? n.onItems : n.offItems)[r], e.context.fns.getValue = (n, r) => n + Number((r * e.props.step + e.props.step).toFixed(1)), e.context.fns.showLabel = (n, r) => {
      const i = Number(e.value || 0);
      return i === 0 && r === 0 || i && n === i || n > i && r === 0 || i > n && r === e.props.lastIndex;
    }, e.context.handlers.handleFocus = (n) => qn.call(null, e, n), e.context.handlers.handleWrapperKeydown = (n) => Gn.call(null, e, n), e.context.handlers.handleWrapperBlur = (n) => Un.call(null, e, n), e.context.handlers.handleItemClick = (n) => (r) => Qn.call(null, e, n, r), e.context.handlers.handleMousemove = (n) => (r) => Xn.call(null, e, n, r), e.context.handlers.handleMouseleave = () => Jn.call(null, e), e.context.handlers.handleDragstart = (n) => (r) => Zn.call(null, e, n, r), e.context.handlers.handleMouseup = (n) => zn.call(null, e, n), e.context.handlers.handleTouchstart = (n) => (r) => jn.call(null, e, n, r), e.context.handlers.handleTouchmove = (n) => Yn.call(null, e, n), e.context.handlers.handleKeydown = (n) => (r) => function(i, s, l) {
      const c = Number(i.value);
      i.props.deselect && l.key === " " && c === s ? i.input(0) : l.key === " " && i.input(s);
    }(e, n, r));
  });
}, /* @__PURE__ */ defaultIcon("rating", "star")] }, Ir = /* @__PURE__ */ Me("ac"), { outer: Dr, wrapper: Ar, inner: Cr, icon: Tr, label: Er, prefix: Or, suffix: Mr, help: Vr, messages: Fr, message: Br } = /* @__PURE__ */ Ve(Ir), Pr = Ir("input", () => ({ $el: "input", bind: "$attrs", attrs: { id: "$id", type: "text", onClick: "$handlers.click", onBlur: "$handlers.blur", onKeydown: "$handlers.keydown", onInput: "$handlers.input", onFocus: "$handlers.focus", value: "$inputText || undefined", name: "$node.name", placeholder: "$state.loading && $ui.isLoading.value || $placeholder || undefined", tabindex: '$disabled && "-1" || 0', role: "combobox", autocomplete: '$attrs.autocomplete || "off"', autocapitalize: "none", readonly: "$attrs.readonly || $state.loading || $multiple && $max && $value && $value.length >= $max && $hasHighlightedRange !== true || undefined", "data-selection-appearance": "$selectionAppearance", disabled: "$disabled || $disabledInternally || undefined", onTouchmove: "$handlers.touchmove", onTouchstart: "$handlers.touchmove", onTouchend: "$handlers.touchend", "aria-autocomplete": "list", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-describedBy": "$describedBy", "aria-activedescendant": "$expanded && $activeDescendant || undefined" } })), Hr = Ir("listboxButton", () => ({ $el: "div", attrs: { style: "$visibilityStyles", id: '$id + "_listbox_button"', role: "button", "aria-label": "$expanded && $ui.close.value || $ui.open.value", onClick: "$handlers.toggleListbox", onKeydown: "$handlers.toggleListboxKeydown", tabindex: '$disabled && "-1" || 0', "aria-haspopup": "true", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-disabled": "$disabled || $state.loading || undefined", "data-disabled": "$disabled || $disabledInternally || undefined" } })), Rr = Ir("selectionWrapper", () => ({ for: ["option", "index", "$selections"], $el: "div", attrs: { id: '$id + "_selection_wrapper_" + $index', key: "$option.value", "data-value": "$option.value", tabindex: '$disabled && "-1" || 0', onKeydown: "$handlers.selectionKeydown && $handlers.selectionKeydown($multiple && $option || undefined)", onClick: "$handlers.selectionClick && $handlers.selectionClick($multiple && $option || undefined)", onFocus: "$handlers.selectionFocus && $handlers.selectionFocus($multiple && $option || undefined)", onBlur: "$handlers.selectionBlur && $handlers.selectionBlur($multiple && $option || undefined)", "data-is-selection": "true", "data-active-selection": "$fns.isActiveSelection && $fns.isActiveSelection($activeSelectionValue, $option)" } })), Nr = Ir("selection", () => ({ $el: "div", attrs: { id: '$id + "_selection_" + $index' } })), Kr = Ir("selections", () => ({ $el: "div", attrs: { "aria-live": "polite", id: '$id + "_selections"' } })), Wr = Ir("removeSelection", () => ({ $el: "button", attrs: { id: '$selectionAppearance === "option" && $multiple && $id + "_remove_selection_" + $index || $id + "_remove_selection"', tabindex: "0", title: "$ui.remove.value", type: "button", "aria-label": "$ui.remove.value", onClick: "$handlers.removeSelection && $handlers.removeSelection($multiple && $option || undefined)", onTouchend: "$handlers.removeSelection && $handlers.removeSelection($multiple && $option || undefined)", "aria-controls": "$id" } })), Ur = Ir("optionLoading", "span"), Yr = Ir("option", () => ({ $el: "div", if: "$value !== undefined" })), jr = /* @__PURE__ */ Pe(Ir);
function zr(e) {
  e.props.selectionAppearance !== "option" || e.props.multiple || e.props.selectionRemovable === !1 || e.props.selectionRemovable === "false" || (e.props.selectionRemovable = !0), e.props.multiple || (e.props.clearSearchOnOpen = undefine(e.props.clearSearchOnOpen)), e.props.selectionRemovable = undefine(e.props.selectionRemovable), e.props.openOnClick = undefine(e.props.openOnClick), e.props.selectionAppearance !== "option" || e.props.multiple || (e.props.isSingleOption = !0), e.props.closeOnSelect === void 0 && (e.props.closeOnSelect = !0), e.props.selectionAppearance === void 0 && (e.props.selectionAppearance = "text-input"), e.props.closeOnSelect === void 0 && (e.props.closeOnSelect = !0), e.props.closeOnSelect ? e.props.resetSearchOnCommit = !1 : e.props.resetSearchOnCommit === void 0 && (e.props.resetSearchOnCommit = e.props.multiple), e.props.allowNewValues = undefine(e.props.allowNewValues);
}
function Zr(e) {
  e.addProps(["inputText", "selectionAppearance", "searchValue", "openOnClick", "filteredOptions", "search", "debounce", "showInput", "visibilityStyles", "selectionStyles", "multiple", "filter", "hasHighlightedRange", "clearOnClick", "debounce"]), e.props.debounce === void 0 ? e.props.debounce = 200 : e.props.debounce = parseInt(e.props.debounce), e.props.nonceKey = "searchValue", e.props.searchValue = "", e.props.inputText = "", e.props.filterOptions = yt$1.bind(null, e), e.props.reloadOnCommit = undefine(e.props.reloadOnCommit), e.props.alwaysLoadOnOpen === void 0 ? e.props.alwaysLoadOnOpen = !0 : e.props.alwaysLoadOnOpen = undefine(e.props.alwaysLoadOnOpen), typeof e.props.filter != "function" && (e.props.filter = (t, n) => t.label.toLowerCase().includes(n.toLowerCase())), e.on("created", () => {
    e.context && ne && (e.context.handlers.focus = Xr.bind(null, e), e.context.handlers.input = Gr.bind(null, e), e.context.handlers.focus = Xr.bind(null, e), e.context.handlers.click = qr.bind(null, e), e.context.handlers.toggleListbox = Jr.bind(null, e), e.context.handlers.toggleListboxKeydown = Qr.bind(null, e), e.context.handlers.keydown = $o.bind(null, e), e.context.handlers.selectionKeydown = (t) => (n) => mo(e, t, n), e.context.handlers.searchInputTagKeydown = (t) => (n) => function(r, i, s) {
      if (s.stopPropagation(), !r.props.disabled)
        switch (s.key) {
          case "ArrowDown":
            po(r);
            break;
          case "ArrowRight":
          case "ArrowLeft":
            co(r, i, s);
            break;
          case "Delete":
          case "Backspace":
            uo(r, i, s);
        }
    }(e, t, n), e.on("prop:options", ({ payload: t }) => {
      if ((e.props.initialOptions.length === 0 && typeof e.props.optionsLoader != "function" || !e.props.searchValue && t.length) && (e.props.initialOptions = [...t]), e.props.selections && e.props.selections.length && t.length) for (let n = 0; n < e.props.selections.length; n++) {
        const r = e.props.selections[n], i = t.find((s) => gt$1(s) === r.value);
        i && (e.props.selections[n] = i);
      }
    }));
  }), e.on("prop:expanded", ({ payload: t }) => {
    t || $t$1.delete(e);
  });
}
function Gr(e, t) {
  if (e.props.disabled) return;
  const n = t.target;
  e.props.inputText = n.value, e.emit("handleSearchInput", n.value), e.props.searchValue && yt$1(e, e.props.searchValue, !0);
}
function qr(e, t) {
  t.stopPropagation(), e.props.disabled || e.props.disabledInternally || (e.props.attrs.onClick && e.props.attrs.onClick(t), (!e.props.expanded && e.props.openOnClick || e.props.openOnFocus) && (e.props.expanded = !0));
}
function Xr(e) {
  e.props.disabled || e.props.disabledInternally || (e.props.attrs.onFocus && e.props.attrs.onFocus(), e.props.activeSelectionValue = void 0, e.props.skipOpen ? e.props.skipOpen = !1 : e.props.openOnFocus && (e.props.expanded = !0));
}
function Jr(e) {
  var t, n, r;
  e.props.disabled || e.props.disabledInternally || !((t = e.context) === null || t === void 0) && t.state.loading || (e.props.expanded = !e.props.expanded, e.props.openOnFocus || (r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`)) === null || r === void 0 || r.focus());
}
function Qr(e, t) {
  t.key !== "Enter" && t.key !== " " || (t.preventDefault(), t.stopPropagation(), Jr(e));
}
const es = /* @__PURE__ */ new WeakMap(), ts = typeof window < "u", os = /* @__PURE__ */ new WeakMap();
let ns = !1;
function rs(e) {
  e.props.searchValue = null, e.on("commit", () => {
    e.props.searchValue = null, e.props.highlightedRange || ss(e);
  }), e.on("created", () => {
    if (!e.context || !ts) return;
    e.on("handleSearchInput", ({ payload: s }) => {
      s === "" ? (e.props.searchValue = null, e.input([])) : s && e.props.inputStd.length === 0 ? e.props.searchValue = s : s && e.props.inputStd.length > 0 && (e.props.searchValue = function(l) {
        var c;
        const u = ls(l);
        if (l.props.highlightedRange) {
          const [m, qu] = as(l, u);
          return l.props.inputText.slice(m, qu);
        }
        return l.props.inputText.slice(((c = u[u.length - 1]) === null || c === void 0 ? void 0 : c.end) + 2);
      }(e)), !e.props.expanded && s ? e.props.expanded = !0 : !s && e.props.expanded && (e.props.expanded = !1);
    }), function(s) {
      whenAvailable(`${s.props.id}`, (l) => {
        l instanceof HTMLInputElement && os.set(l, s);
      }, s.props.__root), ts && !ns && (ns = !0, document.addEventListener("selectionchange", () => {
        const l = mt$1();
        if (l instanceof HTMLInputElement && os.has(l)) {
          const c = os.get(l);
          c && function(u) {
            clearTimeout(es.get(u)), es.set(u, setTimeout(() => {
              var m, qu, Gu, Qu;
              const Xu = (m = u.props.__root) === null || m === void 0 ? void 0 : m.getElementById(`${u.props.id}`);
              if (Xu instanceof HTMLInputElement) {
                const ef = ls(u), tf = ef.findIndex((rf) => Xu.selectionStart !== null ? Xu.selectionStart >= rf.start && Xu.selectionStart <= rf.end : Xu.selectionEnd !== null && Xu.selectionEnd >= rf.start && Xu.selectionEnd <= rf.end), af = (qu = ef[ef.length - 1]) === null || qu === void 0 ? void 0 : qu.end;
                if (Xu.selectionStart === 0 && Xu.selectionEnd === ((Gu = u.props.inputText) === null || Gu === void 0 ? void 0 : Gu.length)) return;
                if (typeof u.props.searchValue == "string" && u.props.highlightedRange) {
                  if (ef.length) {
                    const rf = u.props.highlightedRange, [hf, sf] = as(u, ef);
                    if (Xu.selectionEnd !== null && (Xu.selectionEnd < hf || Xu.selectionEnd > sf)) {
                      const pf = rf.end - rf.start - (sf - hf), $f = Xu.selectionEnd;
                      u.props.inputText = u.props.option.label, u.props.highlightedRange = void 0, u.props.searchValue = null, Xu.value = u.props.inputText, Xu.selectionStart = Xu.selectionEnd = $f + ($f > hf ? pf : 0);
                    }
                  }
                } else if (tf >= 0 && Xu.selectionStart !== null && (af !== ((Qu = u.props.inputText) === null || Qu === void 0 ? void 0 : Qu.length) || Xu.selectionStart < af)) {
                  const rf = ef[tf], hf = u.props.inputText.substr(0, af), sf = rf.start + (rf.index > 0 ? 1 : 0), pf = rf.end + (ef.length - 1 > rf.index ? -1 : 0);
                  hf !== u.props.inputText && (u.props.inputText = hf, Xu.value = hf), u.props.highlightedRange = rf, Xu.selectionStart = sf, Xu.selectionEnd = pf;
                } else u.props.highlightedRange = void 0, ss(u);
                if (Xu.selectionStart !== null && Xu.selectionStart >= af && u.props.inputText.substring(af, af + 2) !== ", ") {
                  let rf = u.props.inputText.substring(0, af);
                  rf = u.props.multiple && u.props.max && Array.isArray(u.props.inputStd) && u.props.inputStd.length >= u.props.max ? rf : `${rf},`, u.props.inputText = `${rf} ${u.props.inputText.substring(af).replace(/^[,\s]{1,2}/, "")}`;
                }
              }
            }, 5));
          }(c);
        }
      }));
    }(e);
    const r = e.context.handlers.keydown;
    e.context.handlers.keydown = (s) => {
      r(s), function(l, c) {
        var u, m, qu, Gu;
        if (["ArrowRight", "ArrowLeft"].includes(c.key) && c.target instanceof HTMLInputElement && c.target.selectionEnd !== null && c.target.selectionStart !== null) {
          if (c.target.selectionStart === 0 && c.target.selectionEnd === ((u = l.props.inputText) === null || u === void 0 ? void 0 : u.length)) c.key === "ArrowLeft" ? t(0) : t(-1);
          else if (!l.props.searchValue) {
            l.props.searchValue = null;
            const Qu = ls(l), Xu = (m = Qu[Qu.length - 1]) === null || m === void 0 ? void 0 : m.end;
            c.target.selectionStart < Xu && (c.target.selectionStart = Math.max(0, c.key === "ArrowLeft" ? c.target.selectionStart - 2 : c.target.selectionEnd + 2));
          }
        } else if (["Delete", "Backspace"].includes(c.key)) l.props.highlightedRange && !l.props.searchValue ? (Tt$1(l, l.props.highlightedRange.option), l.props.inputStd.length === 0 && (l.props.highlightedRange = void 0)) : c.target instanceof HTMLInputElement && (l.props.searchValue = null, t(-1, !0) && c.preventDefault());
        else if (c.target instanceof HTMLInputElement && c.target.selectionStart === 0 && c.target.selectionEnd === ((qu = l.props.inputText) === null || qu === void 0 ? void 0 : qu.length) && (!((Gu = l.props.inputText) === null || Gu === void 0) && Gu.length) && l.props.selections.length === 0) c.preventDefault();
        else if (c.key === "Tab") return;
        c.key === "ArrowLeft" && t(-1, !0) && c.preventDefault();
      }(e, s);
    };
    const i = e.context.handlers.focus;
    e.context.handlers.focus = (s) => {
      i(e, s);
      const l = new Event("selectionchange");
      document.dispatchEvent(l);
    }, e.on("blur", () => {
      e.props.selections.length ? (e.props.inputText = e.props.selections.map((s) => s.label).join(", "), e.props.searchValue = null) : e.props.selections.length || (e.props.inputText = "", e.props.searchValue = "");
    });
  }), e.on("prop:expanded", ({ payload: r }) => {
    r || e.props.inputStd.length ? r && (e.props.options.length && !e.props.alwaysLoadOnOpen || (e.props.options = [], yt$1(e, e.props.searchValue))) : (e.props.searchValue = "", e.props.inputText = "");
  }), e.on("prop:selections", () => {
    var r;
    const i = [...e.props.selections].map((l) => l.label).join(", ");
    let s = "";
    if (ts && e.isCreated) {
      const l = (r = e.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${e.props.id}`);
      if (mt$1() === l && Array.isArray(e._value) && e._value.length) {
        if (e.props.max && e._value.length >= Number(e.props.max)) return;
        s = ", ";
      }
    }
    e.props.inputText = `${i}${s}`, e.props.reloadOnCommit && (e.props.searchValue = "", yt$1(e, e.props.searchValue));
  });
  const t = (r, i = !1) => {
    var s, l;
    const c = (s = e.props.__root) === null || s === void 0 ? void 0 : s.getElementById(`${e.props.id}`);
    if (!(c instanceof HTMLInputElement)) return !1;
    const u = ls(e), m = r >= 0 ? r : u.length - 1;
    if (u[m] === void 0) return !1;
    const qu = (l = u[m]) === null || l === void 0 ? void 0 : l.end;
    return c.selectionStart !== null && (!i || c.selectionStart >= qu && c.selectionStart <= qu + 2) && (c.selectionStart = u[m].start + (m > 0 ? 1 : 0), c.selectionEnd = u[m].end + (m < u.length - 1 ? -1 : 0), !0);
  };
  let n;
  e.on("selectRange", ({ payload: r }) => t(...r)), e.on("prop:highlightedRange", ({ payload: r }) => {
    e.props.hasHighlightedRange = !!r, r && e.props.expanded && n !== r.option && (n = r.option, Ot$1(e));
  });
}
function ss(e) {
  var t;
  if (!ts) return;
  const n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}`);
  n && n.scrollTo({ left: n.scrollWidth, behavior: "smooth" });
}
function as(e, t) {
  var n;
  const r = e.props.highlightedRange, i = r.index, s = r.start + (i ? 1 : 0), l = t.length - 1 > i ? t[t.length - 1].end - t[i + 1].start : 0;
  return [s, ((n = e.props.inputText) === null || n === void 0 ? void 0 : n.length) - l + (t.length - 1 > r.index ? -1 : 0)];
}
function ls(e) {
  const t = Ct$1(e);
  return Array.isArray(t) && t.length ? t.reduce((n, r, i) => {
    var s;
    const l = ((s = n[i - 1]) === null || s === void 0 ? void 0 : s.end) || 0;
    let c = 0;
    return t.length - 1 !== i && c++, i !== 0 && c++, n.push({ option: r, index: i, start: l, end: l + r.label.length + c }), n;
  }, []) : [];
}
function is(e) {
  (function(t) {
    t.on("prop:expanded", ({ payload: n }) => {
      n ? (t.props.searchValue = "", t.props.options.length && !t.props.alwaysLoadOnOpen || (t.props.options = [], yt$1(t, t.props.searchValue, !0))) : (t.props.searchValue = "", t.props.inputText = "");
    });
  })(e), function(t) {
    t.on("handleSearchInput", ({ payload: n }) => {
      n && !t.props.expanded ? (t.props.searchExpand = !0, t.props.expanded = !0) : !n && t.props.expanded && (t.props.expanded = !1), t.props.searchValue = t.props.inputText;
    });
  }(e), function(t) {
    t.on("prop:selections", () => {
      t.isCreated && (t.props.inputText = "", t.props.searchValue = "", t.props.optionRemoved || t.props.reloadOnCommit && yt$1(t, t.props.searchValue, !0));
    });
  }(e);
}
function ps(e) {
  (function(t) {
    function n(i) {
      i.props.inputStd.length === 0 ? (i.props.inputText = "", i.props.searchValue = "") : (i.props.inputText = i.props.selections[0].label, i.props.searchValue = i.props.selections[0].label);
    }
    function r(i) {
      i.props.clearSearchOnOpen && !i.props.searchExpand && (i.props.inputText = "", i.props.searchValue = ""), i.props.searchValue = i.props.inputText, i.props.options.length && !i.props.alwaysLoadOnOpen || i.props.searchExpand || (i.props.options = [], yt$1(i, i.props.searchValue, !0)), i.props.searchExpand && (i.props.searchExpand = !1);
    }
    t.on("prop:expanded", ({ payload: i }) => {
      i ? r(t) : n(t);
    });
  })(e), function(t) {
    t.on("handleSearchInput", ({ payload: n }) => {
      n === "" ? (t.props.inputStd.length === 0 && (t.props.expanded = !1), t.input(void 0)) : n && !t.props.expanded && (t.props.searchExpand = !0, t.props.expanded = !0), t.props.searchValue = t.props.inputText;
    });
  }(e), function(t) {
    t.on("prop:selections", ({ payload: n }) => {
      t.props.inputText = n.length ? n[0].label : "", t.props.searchValue = n.length ? n[0].label : "", t.isCreated && t.props.expanded && n.length === 0 && yt$1(t, t.props.searchValue, !0);
    });
  }(e);
}
function ds(e) {
  if (e.props.multiple) if (e.props.multiple && e.props.selectionAppearance === "option") {
    let t = function() {
      return Array.isArray(e.value) ? e.value : [];
    }, n = function(r) {
      e.input(r);
    };
    is(e), e.on("created", () => {
      e.props.disabled && (e.props.draggable = !1), whenAvailable(`${e.props.id}_selections`, (r) => {
        if (r instanceof HTMLElement && e.context) {
          const i = { draggingClass: e.context.classes.dragging, dropZoneClass: e.context.classes.dropZone, root: e.props.__root, disabled: !e.props.draggable, plugins: [animations()], touchDraggingClass: e.context.classes.touchDragging, touchDropZoneClass: e.context.classes.touchDropZone, draggable: (s) => s.hasAttribute("data-is-selection") };
          dragAndDrop({ parent: r, getValues: t, setValues: n, config: i }), e.on("prop:disabled", ({ payload: s }) => {
            i.disabled = s, dragAndDrop({ parent: r, getValues: t, setValues: n, config: i });
          }), e.on("prop:draggable", ({ payload: s }) => {
            i.disabled = !s, dragAndDrop({ parent: r, getValues: t, setValues: n, config: i });
          });
        }
      }, e.props.__root);
    });
  } else e.props.multiple && e.props.selectionAppearance === "text-input" && rs(e);
  else ps(e);
}
const cs = { schema: /* @__PURE__ */ Dr(/* @__PURE__ */ Ar(/* @__PURE__ */ Er("$label"), /* @__PURE__ */ Cr(/* @__PURE__ */ Tr("prefix"), /* @__PURE__ */ Or(), /* @__PURE__ */ Pr(), /* @__PURE__ */ Be("$multiple !== true && $selectionAppearance === option && $expanded === false", /* @__PURE__ */ Kr(/* @__PURE__ */ Rr(/* @__PURE__ */ Nr(/* @__PURE__ */ Yr(/* @__PURE__ */ Be("$state.loading", /* @__PURE__ */ Ur("$ui.isLoading.value"), "$option.label"))), /* @__PURE__ */ Be("$state.loading && $isSingleOption !== true && $optionLoaderValues.includes($option.value)", /* @__PURE__ */ Tr("loader")), /* @__PURE__ */ Be("$selectionRemovable && $isSingleOption", /* @__PURE__ */ Wr(/* @__PURE__ */ Tr("close")))))), /* @__PURE__ */ Be("$state.loading && ($isSingleOption !== true || $selections.length === 0)", /* @__PURE__ */ Tr("loader")), /* @__PURE__ */ Be('$selectionRemovable && $selectionAppearance === "text-input" && $selections.length > 0', /* @__PURE__ */ Wr(/* @__PURE__ */ Tr("close")), /* @__PURE__ */ Be('$selectionAppearance === "text-input" || ($selectionAppearance === "option" && $multiple)', /* @__PURE__ */ Hr(/* @__PURE__ */ Tr("select")))), /* @__PURE__ */ Be("$isSingleOption && ($inputStd.length === 0 || $selectionRemovable === undefined || ($expanded) || $state.loading || $optionLoaderValues.length > 0)", /* @__PURE__ */ Hr(/* @__PURE__ */ Tr("select"))), /* @__PURE__ */ jr(), /* @__PURE__ */ Mr(), /* @__PURE__ */ Tr("suffix")), /* @__PURE__ */ Be("$multiple && $selectionAppearance === option", /* @__PURE__ */ Kr(/* @__PURE__ */ Rr(/* @__PURE__ */ Nr(/* @__PURE__ */ Yr(/* @__PURE__ */ Be("$state.loading && $isLoadingOption", /* @__PURE__ */ Ur("$ui.isLoading.value"), "$option.label"))), /* @__PURE__ */ Wr(/* @__PURE__ */ Tr("close")))))), /* @__PURE__ */ Vr("$help"), /* @__PURE__ */ Fr(/* @__PURE__ */ Br("$message.value"))), type: "input", family: "dropdown", props: [], features: [
  /* @__PURE__ */ defaultIcon("select", "select"),
  /* @__PURE__ */ defaultIcon("close", "close"),
  /* @__PURE__ */ defaultIcon("selected", "check"),
  /* @__PURE__ */ defaultIcon("loader", "spinner"),
  /* @__PURE__ */ localize("isLoading"),
  /* @__PURE__ */ localize("loadMore"),
  /* @__PURE__ */ localize("remove"),
  /* @__PURE__ */ localize("open"),
  /* @__PURE__ */ localize("close"),
  options$1,
  /* @__PURE__ */ ro.bind(null, zr, Zr, ds),
  No
] }, us = /* @__PURE__ */ Me("dp"), { outer: fs, wrapper: vs, inner: hs, icon: ms, label: gs, prefix: $s, suffix: bs, help: ys, messages: xs, message: ws } = /* @__PURE__ */ Ve(us), _s = us("input", () => ({ $el: "input", bind: "$attrs", attrs: { name: "$node.name", id: "$id", onKeydown: "$handlers.inputKeydown", value: "$inputText", onInput: "$handlers.dateInput", onClick: "$pickerOnly && $handlers.open", onBlur: "$handlers._blur", onFocus: "$handlers.focus", readonly: "$pickerOnly || $expanded", disabled: "$disabled" } })), ks = us("panelWrapper", () => ({ $el: "div", if: "$expanded", attrs: { id: '$id + "_popover"', role: "dialog", onBlur: "$handlers._blurOut()", tabindex: "-1", popover: "$popover", "aria-modal": "true", "aria-label": "Choose date", "data-panel": "$panel", style: { if: "$usePopover", then: { margin: 0, top: '$popoverCoordinates.y + "px"', left: '$popoverCoordinates.x + "px"', width: '$popoverCoordinates.width + "px"' } } } })), Ss = us("next", () => ({ $el: "button", if: "$showPagination", attrs: { id: "$id + _next_button", type: "button", onClick: "$handlers.next" } })), Ls = us("nextLabel", "span"), Is = us("prev", () => ({ $el: "button", if: "$showPagination", attrs: { id: "$id + _prev_button", type: "button", onClick: "$handlers.prev" } })), Ds = us("prevLabel", "span"), As = us("calendar", () => ({ if: '$panel === "day"', $el: "table", for: ["month", "$calendar"], attrs: { key: '$fns.format($month.monthDay, "YYYY-MM")' } })), Cs = us("calendarWeeks", () => ({ $el: "tbody" })), Ts = us("calendarHeader", () => ({ $el: "thead" })), Es = us("weekDays", () => ({ $el: "tr" })), Os = us("weekDay", () => ({ $el: "th", for: ["day", "$month.weeks.0"], attrs: { "aria-label": '$fns.format($day, "dddd")' } })), Ms = us("week", () => ({ $el: "tr", for: ["week", "weekIndex", "$month.weeks"] })), Vs = us("dayCell", () => ({ $el: "td", for: ["day", "dayIndex", "$week"], attrs: { key: "$day", onClick: "$handlers.setDate($day)", onKeydown: "$handlers.keyDown", onMouseenter: "$handlers.mouseEnter($day)", onMouseleave: "$handlers.mouseLeave", onBlur: "$handlers._blurOut(day)", tabindex: '$fns.sameDay($day) && "0" || "-1"', "data-is-extra": "$fns.notInMonth($month.monthDay, $day)", "data-disabled": "$fns.isDisabled($day)", "aria-selected": "$selectedWeek === $weekIndex && $selectedDay === $dayIndex", "aria-label": '$fns.format($day, "long")' } })), Fs = us("day", "div"), Bs = us("openButton", () => ({ $el: "div", attrs: { style: "$visibilityStyles", id: '$id + "_listbox_button"', type: "div", role: "button", onClick: "$handlers.open", onKeydown: "$handlers.openKeydown", tabIndex: '$pickerOnly && "-1" || "0"', "data-disabled": "$disabled", "aria-disabled": "$disabled", "aria-label": '$value && ($ui.changeDate.value + ", " + $inputText) || $ui.chooseDate.value', "aria-haspopup": "true", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined' } })), Ps = us("years", () => ({ if: '$panel === "year"', $el: "ul", attrs: { id: '$id + "_years"' } })), Hs = us("year", () => ({ for: ["year", "$years"], $el: "li", attrs: { key: '$: "year" + $fns.format($year, "YYYY")', onClick: "$handlers.setDate($year)", onKeydown: "$handlers.keyDown", onMouseenter: "$handlers.mouseEnter($year)", onMouseleave: "$handlers.mouseLeave", onBlur: "$handlers._blurOut(year)", tabindex: '$fns.sameYear($year) && "0" || "-1"', "aria-selected": "$selectedYear === $year", "data-disabled": "$fns.isDisabledYear($year)", "data-test": "$year", "aria-label": "$fns.format($year, $yearFormat)" } })), Rs = us("months", () => ({ if: '$panel === "month"', $el: "ul" })), Ns = us("month", () => ({ $el: "li", for: ["month", "index", "$months"], attrs: { key: "$month", onClick: "$handlers.setDate($month)", onKeydown: "$handlers.keyDown", onMouseenter: "$handlers.mouseEnter($month)", onMouseleave: "$handlers.mouseLeave", onBlur: "$handlers._blurOut(month)", tabindex: '$fns.sameMonth($month) && "0" || "-1"', "aria-selected": "$selectedMonth === $month", "data-disabled": "$fns.isDisabledMonth($month)" } })), Ks = us("panelHeader", () => ({ $el: "header", attrs: { "aria-live": "polite" } })), Ws = us("yearsHeader", () => ({ $el: "div", if: '$panel === "year"' })), Us = us("monthsHeader", () => ({ $el: "div", if: '$panel === "month"' })), Ys = us("daysHeader", () => ({ $el: "div", if: '$panel === "day"' })), js = us("timeHeader", () => ({ $el: "div", if: '$panel === "time"' })), zs = us("yearButton", () => ({ $el: "button", attrs: { type: "button", id: "$id + _year_button", onClick: "$handlers.jumpTo(year)" }, children: "$fns.format($renderedDate, $yearFormat)" })), Zs = us("monthButton", () => ({ $el: "button", attrs: { type: "button", id: "$id + _month_button", onClick: "$handlers.jumpTo(month)" }, children: "$fns.format($renderedDate, $monthButtonFormat)" })), Gs = us("dayButton", () => ({ $el: "button", attrs: { type: "button", id: "$id + _day_button", onClick: "$handlers.jumpTo(day)", tabindex: "2" }, children: "$fns.format($renderedDate, $dayButtonFormat)" })), qs = us("removeSelection", () => ({ $el: "button", if: "$clearable && $_value", attrs: { id: '$id + "_remove_selection"', type: "button", onClick: "$handlers.clear", "aria-controls": "$id" } })), Xs = us("time", () => ({ $el: "div", if: '$panel === "time"' })), Js = us("timeInput", () => ({ $el: "input", attrs: { type: "time", value: "$localTime", onInput: "$handlers.localTime", onKeydown: "$handlers.keyDown", spellcheck: "false", onBlur: "$handlers._blurOut(time)" } })), Qs = us("panelClose", () => ({ $el: "button", if: "$showPanelClose && ($inline === undefined || $inline === false)", attrs: { type: "button", class: "$classes.panelClose", onClick: "$handlers.closePanel", tabindex: -1, "aria-label": "$ui.close.value" } })), { overlayPlaceholder: ea, overlayLiteral: ta, overlayChar: oa, overlayEnum: na, overlay: ra, overlayParts: sa, overlayInner: aa } = /* @__PURE__ */ Fe(us), la = us("panel", "div"), ia = /* @__PURE__ */ new WeakMap(), pa = /* @__PURE__ */ new WeakMap(), da = /* @__PURE__ */ new WeakSet(), ca = /* @__PURE__ */ new WeakMap(), ua = /* @__PURE__ */ new WeakMap(), fa = /* @__PURE__ */ new WeakSet(), va = /* @__PURE__ */ new WeakMap(), ha = /[\uD800-\uDBFF]/, ma = /* @__PURE__ */ new WeakMap(), ga = /* @__PURE__ */ new WeakMap(), $a = /* @__PURE__ */ new WeakMap(), ba = /* @__PURE__ */ new WeakMap(), ya = /* @__PURE__ */ new WeakMap(), xa = /* @__PURE__ */ new WeakSet(), wa = /* @__PURE__ */ new WeakMap(), _a = /* @__PURE__ */ new WeakMap(), ka = /* @__PURE__ */ new WeakMap(), Sa = /* @__PURE__ */ new WeakMap();
let La = !1;
const Ia = () => {
  La = !0, setTimeout(() => {
    La = !1;
  }, 500);
}, Da = { "#": { type: "char", pattern: /\d/, token: "#", placeholder: "_", selectDirection: "right" }, a: { type: "char", pattern: /[a-zA-Z]/, token: "a", placeholder: "_", selectDirection: "left" }, h: { type: "char", pattern: /[0-9a-fA-F]/, token: "h", placeholder: "_", selectDirection: "left" }, "*": { type: "char", pattern: /./, token: "*", placeholder: "_", selectDirection: "left" } }, Aa = /* @__PURE__ */ new WeakMap(), Ca = typeof window < "u";
let Ta = !1, Ea = !1;
function Oa() {
  Ca && !Ea && (Ea = !0, document.addEventListener("selectionchange", () => {
    const e = mt$1();
    if (!(e instanceof HTMLInputElement)) return;
    if (Sa.has(e)) return function(n) {
      const r = Sa.get(n);
      if (r) {
        const [i, s] = r, [l, c] = gl(n), u = c.indexOf(i);
        if (u === -1) return void Sa.delete(n);
        const m = l[u], qu = [m[0] + s[0], m[1], "none"];
        Ya(ja(n), qu) || Ja(n, qu);
      }
    }(e);
    if (va.get(e) !== "select") return;
    const t = ja(e);
    if (!Ya(t, Aa.get(e))) {
      if (Aa.set(e, t), da.has(e)) return da.delete(e);
      e.dispatchEvent(new CustomEvent("selection", { detail: ja(e) }));
    }
  }));
}
function Ma(e, t, n) {
  var r;
  if (Oa(), ia.has(e)) return;
  ia.set(e, []), t.reverse && xa.add(e), t.prefix && wa.set(e, t.prefix), t.suffix && _a.set(e, t.suffix), Ha(e, t.pattern, t.partOverrides, t.explicitParts);
  const i = ua.get(e), s = i == null ? void 0 : i.some((m) => Ka(m)), l = i == null ? void 0 : i.some((m) => function(qu) {
    return !!qu && qu.type === "group" && Array.isArray(qu.parts);
  }(m));
  if (s && l) throw new Error("Cannot use enums and groups in the same mask.");
  const c = s ? "select" : (r = t.mode) !== null && r !== void 0 ? r : "shift";
  if (l && c === "select") throw new Error("Cannot use groups in select mode.");
  (t.placeholder || c === "select") && fa.add(e), va.set(e, c), t.onChange && ba.set(e, t.onChange);
  let u = !1;
  e.addEventListener("beforeinput", (m) => {
    if (Ta || m.inputType === "insertLineBreak") return;
    if (m.inputType.startsWith("history")) return function(ef, tf) {
      ef.addEventListener("input", (af) => {
        var rf;
        af.preventDefault(), af.stopImmediatePropagation();
        const hf = ia.get(ef);
        if (hf != null && hf.length) {
          const sf = ((rf = pa.get(ef)) !== null && rf !== void 0 ? rf : hf.length - 1) + (tf.endsWith("Undo") ? -1 : 1), pf = hf[sf];
          if (!pf) return;
          Qa(ef, pf), ef.setSelectionRange(...pf.selectionAfter), pa.set(ef, sf), ba.has(ef) && ba.get(ef)(pf, ef);
        }
      }, { once: !0 });
    }(e, m.inputType);
    m.preventDefault(), u = !0;
    const qu = (Gu = m.inputType).startsWith("insert") ? "insert" : !!Gu.startsWith("delete") && (Gu === "deleteContentForward" ? "deleteContentForward" : "deleteContentBackward");
    var Gu;
    const Qu = ja(e), Xu = e.value;
    qu && za(e, { type: qu, selectionBefore: Qu, data: m.data, valueBefore: Xu, suffix: t.suffix, prefix: t.prefix });
  }), e.addEventListener("input", (m) => {
    u = !1, "data" in m || !u && n && (n.input(e.value, !1), n.props._maskValue = e.value);
  }), c === "select" && e.addEventListener("keydown", (m) => {
    switch (m.key) {
      case "ArrowRight":
        return m.preventDefault(), wl(e);
      case "ArrowLeft":
        return m.preventDefault(), wl(e, -1);
      case "ArrowUp":
        return void (_l(e, 1) && m.preventDefault());
      case "ArrowDown":
        return void (_l(e, -1) && m.preventDefault());
      case "Tab":
        return La ? void m.preventDefault() : void (wl(e, m.shiftKey ? -1 : 1) && m.preventDefault());
    }
  }), e.addEventListener("focus", () => function(m) {
    var qu;
    const Gu = fa.has(m), Qu = va.get(m);
    if (Gu) {
      let Xu = null, ef = null, tf = !1;
      const af = Qu === "shift" ? 0 : 1, rf = m.value;
      pl(m, { type: "insert", data: rf, selectionBefore: [0, 0, "none"], valueBefore: rf }, Qu === "shift" ? "" : rf, (sf, pf) => (Xu === null && pf.type === "char" && (Xu = sf.pos - af), (Na(pf) || Ka(pf)) && sf.value.endsWith(pf.placeholder) ? (ef = sf.pos - af, !1) : (pf.type === "char" && (tf = !0), !0)));
      const hf = (qu = ef ?? (tf ? rf.length : Xu)) !== null && qu !== void 0 ? qu : null;
      if (hf !== null) {
        let sf = [hf, hf, "none"];
        if (va.get(m) === "select") {
          const [pf] = gl(m), $f = Sl(m, sf);
          $f !== void 0 && $f in pf && (sf = pf[$f]);
        }
        return function(pf, $f, uf = 50) {
          ma.set(pf, Ga(pf, $f));
          const vf = async () => {
            if (!Ca || mt$1() !== pf) return;
            va.get(pf) === "select" && (await new Promise((yf) => setTimeout(yf, 10)), function(yf) {
              let ff = ja(yf);
              if (ff[0] === ff[1] && ff[0] === 0 || yf.value.length === ff[1] && ff[0] === 0) return;
              ff = qa(yf, ff);
              const [gf] = gl(yf), lf = Sl(yf, ff), Sf = ff[0];
              lf !== void 0 && gf.some((Mf) => Sf >= Mf[0] && Sf < Mf[1]) && ma.set(yf, Ga(yf, gf[lf]));
            }(pf));
            const cf = ma.get(pf);
            cf && pf.setSelectionRange(...cf);
          };
          vf(), document.addEventListener("selectionchange", vf), setTimeout(() => {
            document.removeEventListener("selectionchange", vf), ma.delete(pf);
          }, uf);
        }(m, sf);
      }
    }
  }(e)), e.addEventListener("selection", (m) => function(qu, Gu) {
    if (ma.get(qu)) return;
    Cl(qu), Gu = qa(qu, Gu);
    const [Qu] = gl(qu), Xu = Sl(qu, Gu), ef = Xu !== void 0 && Ga(qu, Qu[Xu]);
    ef && !Ya(Gu, ef) && Ja(qu, ef, !0);
  }(e, m.detail)), za(e, { type: "insert", selectionBefore: [0, 0, "forward"], data: e.value, valueBefore: "", suffix: t.suffix, prefix: t.prefix });
}
function Va(e) {
  var t, n;
  if (Sa.has(e)) return;
  const r = (t = ia.get(e)) !== null && t !== void 0 ? t : [], i = r[(n = pa.get(e)) !== null && n !== void 0 ? n : r.length - 1];
  if (i) {
    const s = i.selectionAfter, [l, c] = gl(e, i.valueAfter), u = Sl(e, s, [l, c]);
    if (u !== void 0 && u in l) {
      const m = c[u], qu = l[u], Gu = [s[0] - qu[0], s[1] - qu[0], "none"];
      Sa.set(e, [m, Gu]);
    }
  }
}
function Fa(e) {
  Sa.delete(e);
}
function Ba(e, t, n) {
  const r = typeof e == "string" || !ia.has(e), i = typeof e == "string" ? Pa(e) : e;
  if (r) t.prefix && wa.set(i, t.prefix), t.suffix && _a.set(i, t.suffix), i.value = Za(i, i.value), Ma(i, t, n);
  else {
    const s = Ll(i), l = i.value;
    i.value = "", za(i, { type: "insert", selectionBefore: [0, s ? s.valueAfter.length : 0, "none"], valueBefore: s ? s.valueAfter : "", data: l, suffix: t.suffix, prefix: t.prefix });
  }
  return i.value;
}
function Pa(e) {
  return { value: e, selectionStart: 0, selectionEnd: 0, scrollWidth: 0, clientWidth: 0, addEventListener: () => {
  }, dispatchEvent: () => {
  }, setSelectionRange: () => {
  } };
}
function Ha(e, t, n, r, i) {
  i = e && xa.has(e) || i;
  const s = (r ?? function(Qu) {
    const Xu = Object.values(Da);
    if (!Qu) return Xu;
    const ef = { ...Qu }, tf = [];
    for (const rf of Xu) if (!Ua(rf)) if ("token" in rf && rf.token in Qu) {
      const hf = { ...rf, ...Qu[rf.token] };
      Ra(hf) && tf.push(hf), delete ef[rf.token];
    } else tf.push(rf);
    const af = Object.values(ef);
    for (const rf of af) Ra(rf) ? tf.push(rf) : console.warn(`Invalid ${rf.type} token`, rf);
    return tf;
  }(n)).sort((Qu, Xu) => {
    const ef = "token" in Qu ? Qu.token.length : -1, tf = "token" in Xu ? Xu.token.length : -1;
    return ef === tf ? 0 : ef > tf ? -1 : 1;
  });
  let l = [];
  [t, l] = function(Qu, Xu, ef, tf) {
    let af, rf = 0, hf = "", sf = "", pf = "";
    const $f = [];
    for (; hf = el(Qu); ) hf === Xu && af !== tf ? (rf++, rf > 1 && (pf += hf)) : hf === ef && rf && af !== tf ? (rf--, rf === 0 ? (sf += `{$${$f.length}}`, $f.push(pf), pf = "") : pf += hf) : rf ? pf += hf : af !== tf || hf !== Xu && hf !== ef ? sf += hf : sf = `${sf.substring(0, sf.length - 1)}${hf}`, af = hf, Qu = Qu.substring(hf.length);
    return [sf, $f];
  }(t, "{", "}", "\\");
  const c = l.length;
  t = s.reduce((Qu, Xu, ef) => "token" in Xu ? Qu.replaceAll(`\\${Xu.token}`, "{“!”}").replaceAll(Xu.token, `{$${c + ef}}`).replaceAll("{“!”}", Xu.token) : Qu, t);
  const u = function(Qu, Xu, ef) {
    return Qu.reduce((tf, af) => {
      const [rf, hf] = function($f) {
        const [uf, ...vf] = $f.split("|"), cf = vf.reduce((yf, ff) => {
          const [gf, lf = !0] = ff.split(":");
          return Object.assign(yf, { [gf]: lf });
        }, {});
        return [uf, cf];
      }(af);
      let sf = Ha(null, rf, void 0, Xu, ef);
      sf = sf.map(($f) => {
        const uf = { ...$f };
        if (uf.type === "char" && hf.placeholder) uf.placeholder = hf.placeholder;
        else if (uf.type === "enum") throw new Error("Groups cannot contain enums.");
        return uf;
      });
      const pf = { type: "group", parts: sf, ...hf };
      return tf.push(pf), tf;
    }, []);
  }(l, s, i).concat(s), m = /\{\$\d+\}/g, qu = t.match(m), Gu = t.split(m).reduce((Qu, Xu, ef) => {
    if (Xu && (Xu = Xu.replaceAll("\\", ""), Qu.push({ type: "literal", value: i ? [...Xu].reverse().join("") : Xu })), qu && qu[ef]) {
      const tf = qu[ef], af = Number(tf.substring(2, tf.length - 1));
      !isNaN(af) && u[af] && Qu.push(u[af]);
    }
    return Qu;
  }, []);
  return i && Gu.reverse(), e && ua.set(e, Gu), Gu;
}
function Ra(e) {
  return !!e && (Ua(e) || Na(e) || Ka(e));
}
function Na(e) {
  return !!e && e.type === "char" && e.pattern instanceof RegExp && Wa(e);
}
function Ka(e) {
  return !!e && e.type === "enum" && Array.isArray(e.values) && Wa(e);
}
function Wa(e) {
  return !!e && "placeholder" in e && "token" in e;
}
function Ua(e) {
  return !!e && e.type === "literal" && typeof e.value == "string";
}
function Ya(e, t) {
  return e === t || e !== void 0 && t !== void 0 && e[0] === t[0] && e[1] === t[1];
}
function ja(e) {
  var t, n;
  return [(t = e.selectionStart) !== null && t !== void 0 ? t : e.value.length, (n = e.selectionEnd) !== null && n !== void 0 ? n : e.value.length, "none"];
}
function za(e, t) {
  var n;
  xa.has(e) && Al(t);
  let r = !1;
  switch (ya.set(e, "playing"), t.type) {
    case "insert":
      r = function(i, s) {
        let l = Xa(s);
        const c = s.selectionBefore, u = function(qu, Gu) {
          var Qu, Xu, ef;
          if (va.get(qu) === "select") {
            const [tf, af] = gl(qu), rf = tf.findIndex((sf) => Ya(sf, Gu.selectionBefore)), hf = (Qu = af[rf]) !== null && Qu !== void 0 ? Qu : null;
            if (Na(hf)) {
              const sf = Gu.selectionBefore, pf = sf[1] - sf[0], $f = Gu.valueBefore.substring(sf[0], sf[1]), uf = hf.selectDirection === "left", vf = ll($f, hf), cf = uf ? 0 : function(ff, gf, lf) {
                if (!ff) return 0;
                let Sf = "";
                for (; ff.length; ) {
                  const Mf = el(ff);
                  ff = ff.substring(Mf.length), gf.pattern.test(Mf) && (Sf += Mf);
                }
                return Math.min(Math.max(Sf.length, 1), lf);
              }(Gu.data, hf, pf);
              if (vf.length >= pf) return uf || (Gu.insertPos = sf[1] - cf), ((Xu = hf.selectFill) !== null && Xu !== void 0 ? Xu : hf.placeholder).repeat(pf);
              const yf = ((ef = hf.selectFill) !== null && ef !== void 0 ? ef : hf.placeholder).repeat(pf - vf.length - (uf ? 0 : cf));
              return Gu.insertPos = uf ? sf[0] + vf.length : sf[1] - cf, hf.selectDirection === "left" ? `${vf}${yf}` : `${yf}${vf}${hf.placeholder}`;
            }
            if (Ka(hf)) {
              const sf = Gu.selectionBefore;
              return Gu.valueBefore.substring(sf[0], sf[1]);
            }
          }
          return "";
        }(i, s);
        l = `${l.substring(0, c[0])}${u}${l.substring(c[1])}`;
        const m = pl(i, s, l);
        return ca.set(i, m.endPos), { ...s, valueAfter: m.value, selectionAfter: il(i, m), unmasked: m.unmasked, complete: m.complete, meta: m.meta };
      }(e, t);
      break;
    case "deleteContentBackward":
    case "deleteContentForward":
      r = function(i, s) {
        const l = Xa(s), c = s.selectionBefore, u = xa.has(i);
        let m = c[0], qu = c[1];
        m === qu && (s.type !== "deleteContentBackward" || u ? qu += tl(l, m) : m -= tl(l, m, "backward"));
        const Gu = va.get(i);
        let Qu = "";
        if (Gu === "select") {
          const [tf, af] = gl(i), rf = Sl(i, [m, qu, "none"]);
          if (rf !== void 0) {
            const hf = af[rf], sf = tf[rf];
            Na(hf) ? Qu = hf.placeholder.repeat(qu - m) : Ka(hf) && ([Qu, m] = Ya(sf, ja(i)) ? [hf.placeholder, m] : function(pf, $f, uf, vf) {
              const cf = vf.valueBefore, yf = tl(cf, vf.selectionBefore[0], "backward"), ff = Math.max(uf[0], vf.selectionBefore[0] - yf), gf = cf.substring(uf[0], ff), lf = bl($f.values, gf);
              let Sf = lf == null ? void 0 : lf.substring(gf.length);
              return lf && !Sf && yl($f.values, lf) && (Sf = lf), [Sf ?? $f.placeholder, Sf ? ff : uf[0]];
            }(0, hf, sf, s));
          }
        }
        const Xu = `${l.substring(0, m)}${Qu}${l.substring(qu)}`, ef = pl(i, s, Xu);
        return { ...s, valueAfter: ef.value, selectionAfter: vl(i, ef, s, m), unmasked: ef.unmasked, complete: ef.complete, meta: ef.meta };
      }(e, t);
  }
  if (xa.has(e) && r && Al(r), r && function(i, s) {
    s.prefix && (s.valueAfter = s.prefix + s.valueAfter, s.selectionAfter = Ga(i, s.selectionAfter)), s.suffix && (s.valueAfter += s.suffix);
  }(e, r), r && function(i) {
    return i.valueBefore !== i.valueAfter || i.selectionBefore[0] !== i.selectionAfter[0] || i.selectionBefore[1] !== i.selectionAfter[1];
  }(r)) {
    ba.has(e) && ka.set(e, () => {
      ka.delete(e), r && ba.get(e)(r, e);
    }), ya.set(e, "beforeCallback");
    let i = (n = ia.get(e)) !== null && n !== void 0 ? n : [];
    const s = pa.get(e);
    s && (i = i.slice(0, s), pa.delete(e)), i.push(r), ia.set(e, i), Ca && mt$1() === e && typeof document.execCommand == "function" && !Ta ? (Ja(e, [0, e.value.length, "forward"], !0), Ta = !0, document.execCommand("insertText", void 0, r.valueAfter), Ta = !1) : Qa(e, r), Ca && mt$1() === e && Ja(e, r.selectionAfter);
    const l = ka.get(e);
    l && l(), Cl(e);
  }
  ya.set(e, "complete");
}
function Za(e, t) {
  var n, r;
  const i = (n = wa.get(e)) !== null && n !== void 0 ? n : "", s = (r = _a.get(e)) !== null && r !== void 0 ? r : "";
  return i && t.startsWith(i) && (t = t.substring(i.length)), s && t.endsWith(s) && (t = t.substring(0, t.length - s.length)), t;
}
function Ga(e, t) {
  const n = wa.get(e), r = [...t];
  return n && (r[0] += n.length, r[1] += n.length), r;
}
function qa(e, t) {
  const n = wa.get(e), r = [...t];
  return n && (r[0] -= n.length, r[1] -= n.length), r;
}
function Xa(e) {
  let t = e.valueBefore;
  const n = e.selectionBefore;
  if (e.suffix && t.endsWith(e.suffix) && (t = t.substring(0, t.length - e.suffix.length), e.valueBefore = t, n[0] >= t.length && (n[0] = t.length), n[1] >= t.length && (n[1] = t.length)), e.prefix && t.startsWith(e.prefix)) {
    const r = e.prefix.length;
    t = t.substring(r), e.valueBefore = t, n[0] = Math.max(n[0] - r, 0), n[1] = Math.max(n[1] - r, 0);
  }
  return t;
}
function Ja(e, t, n = !1) {
  n && (da.add(e), setTimeout(() => da.delete(e), 5)), ma.get(e) && ma.set(e, t), e.setSelectionRange(...t);
}
function Qa(e, t, n = "After") {
  if (e.value = t[`value${n}`], Ca) {
    const r = new InputEvent("input", { inputType: t.type === "insert" ? "insertText" : t.type, data: t.data });
    e.dispatchEvent(r);
  }
}
function el(e) {
  if (e == null) return "";
  const t = ha.test(e.charAt(0)) && ha.test(e.charAt(1)) ? 2 : 1;
  return e.substring(0, t);
}
function tl(e, t, n = "forward") {
  if (n === "backward") return t === 0 ? 0 : t === 1 ? 1 : ha.test(e.charAt(t)) && ha.test(e.charAt(t - 1)) ? 2 : 1;
  const r = e.length - t;
  return r === 0 ? 0 : r === 1 ? 1 : el(e.substring(t)).length;
}
function ol(e, t) {
  const n = el(e.data), r = n.length;
  if (e.value += n, e.pos += r, typeof e.data == "string" && (e.data = e.data.substring(r), e.data.length || (e.endPos = e.pos)), t) return t.substring(r);
}
function nl(e) {
  const t = el(e.buffer), n = t.length;
  e.value += t, e.pos += n, e.buffer = e.buffer.substring(n);
}
function rl(e, t) {
  const n = el(t), r = n.length;
  return e.value += n, e.pos += r, t.substring(r);
}
function sl(e, t) {
  for (; t.buffer; ) {
    const n = el(t.buffer);
    if (e.pattern.test(n) || t.placeholder && e.placeholder === n) return void (t.mode !== "replace" && t.mode !== "select" || (t.buffer = t.buffer.substring(n.length)));
    t.buffer = t.buffer.substring(n.length);
  }
}
function al(e, t) {
  const n = e.values.concat([e.placeholder]).map((r) => r.toLowerCase()).sort((r, i) => r.length > i.length ? -1 : 1);
  for (; t.buffer; ) {
    const r = t.buffer.toLowerCase(), i = n.find((s) => r.startsWith(s));
    if (i) {
      const s = t.buffer.substring(0, i.length);
      return t.buffer = t.buffer.substring(i.length), s;
    }
    t.buffer = t.buffer.substring(tl(t.buffer, 0));
  }
  return null;
}
function ll(e, t) {
  let n = e.replaceAll(t.placeholder, "");
  const r = t.selectDirection === "left";
  if (t.selectFill) {
    const s = new RegExp(`${r ? "" : "^"}${i = t.selectFill, i.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")}+${r ? "$" : ""}`);
    n = n.replace(s, "");
  }
  var i;
  return n;
}
function il(e, t) {
  let n = [t.endPos, t.endPos, "forward"];
  if (t.mode !== "select") return n;
  const r = ja(e);
  n = [r[0], t.endPos, "none"];
  const [i, s] = gl(e, t.value), l = Sl(e, n, [i, s]);
  if (l === void 0 || !(l in i) || !(l in s)) return n;
  const c = i[l], u = s[l], m = t.value.slice(c[0], c[1]);
  if (Na(u) && ll(m, u).length === m.length && l < i.length - 1) return Ia(), i[l + 1];
  if (Ka(u) && t.insertPos >= c[0] && t.insertPos <= c[1]) {
    if (t.cycle) return c;
    const qu = function(Qu, Xu, ef) {
      if (Qu.originalData === null) return 0;
      const tf = Qu.insertPos >= Xu ? Qu.value.substring(Xu, Qu.insertPos) : "", af = `${tf}${Qu.originalData}`, rf = bl(ef.values, af);
      return rf ? ml(af, rf).length - tf.length : 0;
    }(t, c[0], u);
    if (t.insertPos + qu === c[1]) return yl(u.values, m) ? [c[1], c[1], "forward"] : (Ia(), i[l + 1] ? i[l + 1] : i[l]);
    const Gu = [t.insertPos + qu, c[1], "none"];
    return Ya(Gu, r) || (da.add(e), setTimeout(() => da.delete(e), 5)), Gu;
  }
  return c;
}
function pl(e, t, n, r) {
  var i, s;
  const l = (i = ua.get(e)) !== null && i !== void 0 ? i : [], c = { pos: 0, insertPos: (s = t.insertPos) !== null && s !== void 0 ? s : t.selectionBefore[0], range: t.selectionBefore, chars: 0, placeholder: fa.has(e), buffer: n, data: t.data, originalData: t.data, value: "", mode: va.get(e) || "replace", endPos: t.selectionBefore[0], rangeParts: gl(e), unmasked: "", complete: !0, cycle: t.cycle, meta: [] };
  return dl(l, c, void 0, r), c;
}
function dl(e, t, n, r) {
  var i, s;
  const l = { ...t };
  n != null && n.placeholder && (t.placeholder = !0);
  const c = n != null && n.repeat && ((i = n.nextPart) === null || i === void 0 ? void 0 : i.type) === "literal" ? n.nextPart.value : null;
  let u = 0;
  const m = e.reduce((Gu, Qu) => Gu + (Qu.type === "char" ? 1 : 0), 0), qu = t.chars;
  for (const Gu of e) {
    const Qu = e[u + 1];
    switch (Gu.type) {
      case "literal":
        ul(Gu, t, e.at(-1) === Gu);
        break;
      case "char":
        fl(Gu, t, c);
        break;
      case "enum":
        cl(Gu, t);
        break;
      case "group":
        const ef = { repeat: (s = Gu.repeat) !== null && s !== void 0 && s, nextPart: Qu, repeats: 0, placeholder: !!Gu.placeholder };
        dl(Gu.parts, t, ef, r);
    }
    if (r && r(t, Gu) === !1)
      break;
    const Xu = Ua(Qu) && u + 2 === e.length && qu !== t.chars;
    if (!(t.buffer || t.data || t.placeholder || Xu)) break;
    u++;
  }
  if (t.chars < m && (t.complete = !1), n) {
    const Gu = t.chars - qu, Qu = Gu === m, Xu = !(!t.data || c && t.data.startsWith(c) && t.insertPos <= t.pos), ef = !(t.buffer && c && t.buffer.startsWith(c) && t.insertPos >= t.pos + c.length) && (t.buffer || Xu);
    if (n.repeat && ef && Qu) return n.repeats++, dl(e, t, n, r);
    if (!Qu) {
      t.complete = !1;
      const tf = e.reverse().find((af) => af.type === "literal");
      e.reverse(), Ua(tf) && t.value.endsWith(tf.value) && (t.value = t.value.substring(0, t.value.length - tf.value.length), t.pos = t.value.length);
    }
    m > 1 && Gu < m && Gu !== 0 && t.insertPos <= t.pos ? t.data = "" : n.repeat && !Qu && n.repeats && Object.assign(t, l);
  }
  t.placeholder = l.placeholder;
}
function cl(e, t) {
  const [n, r] = t.rangeParts, i = n[r.indexOf(e)];
  if (i && (t.insertPos <= t.pos || t.insertPos >= i[0] && t.insertPos <= i[1]) && t.data) {
    const s = t.buffer.substring(0, t.insertPos - t.pos), l = `${s}${t.data}`, c = bl(e.values.concat([e.placeholder]), l);
    if (c) {
      const u = ml(l, c);
      return t.data = t.data.substring(u.length), t.value += c, c !== e.placeholder ? t.unmasked += c : t.complete = !1, t.meta.push({ type: c !== e.placeholder ? "enum" : "placeholder", value: c }), s ? t.buffer = t.buffer.substring(s.length) : al(e, t), t.endPos = t.pos + u.length, void (t.pos = t.value.length);
    }
    t.data = "";
  }
  if (t.buffer) {
    const s = al(e, t);
    if (s) return t.value += s, s !== e.placeholder ? t.unmasked += s : t.complete = !1, t.meta.push({ type: s !== e.placeholder ? "enum" : "placeholder", value: s }), void (t.pos = t.value.length);
  }
  t.complete = !1, t.value += e.placeholder, t.meta.push({ type: "placeholder", value: e.placeholder }), t.pos = t.value.length;
}
function ul(e, t, n) {
  let r = e.value;
  if (t.data === "" && !t.buffer && !t.placeholder && !n) return;
  let i = !1;
  for (; r; ) {
    const s = t.insertPos <= t.pos ? el(t.data) : "", l = el(r);
    if (s === l) r = ol(t, r), t.meta.push({ type: "literal", value: l }), i = !0;
    else if (!i || t.data || t.data === null || t.placeholder || n) r = rl(t, r), t.meta.push({ type: "literal", value: l });
    else if (i && !t.data) break;
    t.buffer.startsWith(l) && (t.buffer = t.buffer.substring(l.length));
  }
  t.data === null && !t.buffer && t.insertPos <= t.pos && !t.placeholder && (t.value = t.value.substring(0, t.value.length - e.value.length), t.pos = t.endPos = t.value.length);
}
function fl(e, t, n) {
  var r;
  let i = !0;
  if (t.insertPos <= t.pos) for (; !((r = t.data) === null || r === void 0) && r.length; ) {
    const s = el(t.data);
    if (e.pattern.test(s)) return ol(t), t.meta.push({ type: "char", value: s }), t.chars++, t.unmasked += s, void sl(e, t);
    if (typeof t.data == "string") {
      if (n && t.data.startsWith(n)) {
        i = !1;
        break;
      }
      t.data = t.data.substring(s.length);
    }
  }
  for (; i && t.buffer; ) {
    const s = el(t.buffer);
    if (e.pattern.test(s)) return t.chars++, t.unmasked += s, nl(t), void t.meta.push({ type: "char", value: s });
    if (t.placeholder && s === e.placeholder) return nl(t), void t.meta.push({ type: "placeholder", value: s });
    if (typeof t.buffer == "string") {
      if (n && t.buffer.startsWith(n)) {
        t.buffer = t.buffer.substring(n.length);
        break;
      }
      t.buffer = t.buffer.substring(s.length);
    }
  }
  t.placeholder ? (t.value += e.placeholder, t.meta.push({ type: "placeholder", value: e.placeholder })) : t.endPos = t.pos;
}
function vl(e, t, n, r) {
  const i = [r, r, "none"];
  if (t.mode === "select") {
    const s = gl(e), l = Sl(e, i, s), [c, u] = gl(e, t.value), m = l !== void 0 && hl(n.valueBefore, s[0][l], s[1][l]);
    if (l !== void 0 && l in c)
      return m ? c.slice(l).every((Gu, Qu) => hl(t.value, Gu, u[l + Qu])) && c[l - 1] ? c[l - 1] : c[l] : [r, c[l][1], "none"];
  }
  return i;
}
function hl(e, t, n) {
  if (Ua(n)) return !1;
  if (Na(n)) {
    let r = t[0];
    for (; r < t[1]; ) {
      const i = el(e.substring(r));
      if (i !== n.placeholder) return !1;
      r += i.length;
    }
  }
  return !Ka(n) || e.substring(t[0], t[1]) === n.placeholder;
}
function ml(e, t) {
  let n = "";
  do {
    const r = el(e).toLowerCase(), i = el(t).toLowerCase();
    if (r !== i) break;
    n += r, e = e.substring(r.length), t = t.substring(i.length);
  } while (e.length && t.length);
  return n;
}
function gl(e, t) {
  const n = ua.get(e);
  if (!n) return [[], []];
  if (ga.has(e)) return ga.get(e);
  const r = t ?? Za(e, e.value), i = [], s = [];
  let l = null, c = null, u = 0, m = !0;
  for (const Gu of n) if (Ua(Gu)) l = Gu, c !== null && (i.push([c, u, "none"]), c = null), u += Gu.value.length;
  else {
    if (Na(l) && Na(Gu) && Gu.token === l.token) u++;
    else if (Na(Gu)) c === null ? (c = u, s.push(Gu)) : (i.push([c, u, "none"]), c = u, s.push(Gu)), u++;
    else if (Ka(Gu)) {
      c && i.push([c, u, "none"]), xl(Gu) || (m = !1);
      const Qu = $l(r, Gu, u);
      c = null, i.push([u, u + Qu, "none"]), s.push(Gu), u += Qu;
    }
    l = Gu;
  }
  c !== null && i.push([c, u, "none"]);
  const qu = [[...i], [...s]];
  return m && !t && ga.set(e, qu), qu;
}
function $l(e, t, n) {
  if (xl(t)) return t.values[0].length;
  const r = e.slice(n), i = bl(t.values.concat([t.placeholder]), r);
  return i ? i.length : 0;
}
function bl(e, t, n = null, r) {
  var i;
  if (t.length === 0) return n;
  if (!r) {
    const m = e.find((qu) => qu.toLowerCase() === t.toLowerCase());
    if (m) return m;
  }
  const s = el(t.toLowerCase()), l = `${r ?? ""}${s}`, c = e.filter((m) => m.toLowerCase().startsWith(l)), u = c.find((m) => m.toLowerCase() === l);
  return u && (n = u), c.length === 0 ? n : c.length === 1 ? c[0] : (c.length > 1 && (n = c[0]), (i = bl(c, t.substring(s.length), n, l)) !== null && i !== void 0 ? i : c[0]);
}
function yl(e, t) {
  return t = t.toLowerCase(), e.some((n) => (n = n.toLowerCase()).startsWith(t.toLocaleLowerCase()) && n !== t);
}
function xl(e) {
  if (!$a.has(e) && Array.isArray(e.values) && e.values.length > 0) {
    const t = e.values[0].length;
    if (e.placeholder.length !== t) return !1;
    $a.set(e, e.values.every((n) => n.length === t));
  }
  return $a.get(e);
}
function wl(e, t = 1) {
  const [n] = gl(e), r = Sl(e, qa(e, ja(e)));
  return r !== void 0 && n[r + t] !== void 0 && (e.setSelectionRange(...Ga(e, n[r + t])), !0);
}
function _l(e, t = 1) {
  const [n, r] = gl(e), i = Sl(e, ja(e));
  if (i !== void 0 && i in r) {
    const s = r[i];
    if (Ka(s)) {
      const l = n[i], c = e.value.slice(l[0], l[1]);
      let u = null, m = s.values.indexOf(c);
      const qu = s.values.length - 1;
      if (m !== -1) {
        const Gu = m + t;
        m = Gu < 0 ? qu : Gu > qu ? 0 : Gu, u = s.values[m];
      } else c === s.placeholder && (u = t > 0 ? s.values[0] : s.values[qu]);
      if (u !== null) {
        const Gu = { selectionBefore: l, insertPos: l[0], type: "insert", data: u, valueBefore: e.value, cycle: !0 };
        return setTimeout(() => za(e, Gu), 0), !0;
      }
    }
  }
  return !1;
}
function kl(e, t) {
  if (!e.length) return -1;
  if (e.length === 1) return e[0];
  const n = e.length / 2, r = Number.isInteger(n) ? n : Math.floor(n), i = Math.abs(t - e[r - 1]) < Math.abs(t - e[r]) ? [0, r] : [r];
  return kl(e.slice(...i), t);
}
function Sl(e, t, n) {
  const [r] = n ?? gl(e), i = r.findIndex((u) => u[0] !== u[1] && (!!Ya(u, t) || t[1] > u[0] && t[1] < u[1]));
  if (i !== -1) return i;
  const [s, l] = r.reduce((u, m, qu) => (u[0].add(m[0]), u[0].add(m[1]), u[1][m[0]] = qu, u[1][m[1]] = qu, u), [/* @__PURE__ */ new Set(), {}]), c = kl([...s], t[0] === 0 && t[1] === e.value.length ? 0 : t[1]);
  return c in l ? l[c] : void 0;
}
function Ll(e) {
  var t, n;
  const r = (t = ia.get(e)) !== null && t !== void 0 ? t : [];
  return r[(n = pa.get(e)) !== null && n !== void 0 ? n : r.length - 1];
}
function Il(e, t = !1) {
  const n = Ll(e);
  return n && (n.complete || t) ? xa.has(e) ? [...n.unmasked].reverse().join("") : n.unmasked : t ? "" : null;
}
function Dl(e) {
  var t;
  const n = Ll(e);
  return (t = n == null ? void 0 : n.meta) !== null && t !== void 0 ? t : null;
}
function Al(e) {
  const t = (r) => [...r].reverse().join(""), n = (r, i) => [i - r[1], i - r[0], r[2]];
  e.data && (e.data = t(e.data)), e.valueBefore = t(e.valueBefore), "valueAfter" in e && (e.valueAfter = t(e.valueAfter)), "selectionAfter" in e && (e.selectionAfter = n(e.selectionBefore, e.valueAfter.length)), e.selectionBefore = n(e.selectionBefore, e.valueBefore.length);
}
function Cl(e) {
  if (e.scrollWidth > e.clientWidth && e.selectionStart !== null && e.selectionEnd !== null) {
    const t = e.selectionStart / e.value.length, n = e.selectionEnd / e.value.length;
    e.scrollLeft = n > 0.9 ? e.scrollWidth : t * e.scrollWidth - 20, e.dispatchEvent(new CustomEvent("input-scroll", { bubbles: !1, detail: e.scrollLeft }));
  }
}
const Tl = typeof window < "u", El = /* @__PURE__ */ new WeakSet(), Ol = /* @__PURE__ */ new WeakSet(), Ml = /* @__PURE__ */ new WeakSet(), Vl = /* @__PURE__ */ new WeakMap(), Fl = /* @__PURE__ */ new WeakMap(), Bl = /* @__PURE__ */ new WeakSet(), Pl = /* @__PURE__ */ new WeakSet();
function Hl(e) {
  e.props.selectedMonth = e.props.selectedYear = e.props.selectedDay = e.props.selectedWeek = void 0;
}
function Rl(e) {
  var t, n, r;
  e.props.selectedMonth = e.props.months.findIndex((i) => Wl(i, e.props.activeDate)), e.props.selectedYear = e.props.years.findIndex((i) => Kl(i, e.props.activeDate));
  for (let i = 0; i < ((t = e.props.calendar[0]) === null || t === void 0 ? void 0 : t.weeks.length); i++) for (let s = 0; s < ((n = e.props.calendar[0]) === null || n === void 0 ? void 0 : n.weeks[i].length); s++) {
    const l = (r = e.props.calendar[0]) === null || r === void 0 ? void 0 : r.weeks[i][s];
    if (sameDay(l, e.props.activeDate)) {
      e.props.selectedWeek = i, e.props.selectedDay = s;
      break;
    }
  }
}
function Nl(e) {
  return e.partName !== "timeZoneName";
}
function Kl(e, t) {
  return t instanceof Date && e.getFullYear() === t.getFullYear();
}
function Wl(e, t) {
  return t instanceof Date && e.getMonth() === t.getMonth();
}
function Ul(e) {
  Hl(e), e.props.selectedIndex = e.props.calendar = he$1(e.props.showMonths, (t) => t).map((t) => function(n, r) {
    const i = [], s = date(r);
    s.setDate(1);
    let l = weekStart(s, n.props.weekStart);
    l.setHours(s.getHours(), s.getMinutes(), s.getSeconds());
    const c = weekEnd(monthEnd(r), n.props.weekStart);
    let u = [];
    do
      u.push(l), u.length === 7 && (i.push(u), u = []), l = addDay(l);
    while (l.getTime() <= c.getTime());
    return { monthDay: s, weeks: i };
  }(e, addMonth(e.props.renderedDate, t))), e.props.years = function(t) {
    const n = Number(format(t.props.renderedDate, "YYYY")), r = n - n % 10;
    return t.props.decade = `${r} - ${r + 9}`, he$1(10, (i) => addYear(t.props.renderedDate, r + i - n));
  }(e), e.props.months = function(t) {
    const n = date(t.props.renderedDate);
    return n.setMonth(0), he$1(12, (r) => addMonth(n, r));
  }(e), e.value && Rl(e);
}
function Yl(e, t) {
  var n;
  t.target && t.target instanceof Element && (t.target.closest(`#${e.props.id}_popover`) || !(!((n = e.props.__root) === null || n === void 0) && n.contains(t.target))) || (e.props.expanded = !1);
}
function jl(e, t) {
  if (!t) return e.props.inputText = "", /* @__PURE__ */ new Date();
  const n = t instanceof Date ? t : parse(t, e.props.valueFormat, e.props.valueLocale);
  return e.props.inputText = e.props.formatDate(n, e.props.format, e.props.locale, !1, Nl), n;
}
function zl(e) {
  return Array.isArray(e.props.sequence) ? clone(e.props.sequence) : ["day"];
}
function Zl(e, t, n = !0) {
  var r, i;
  if (e._value === t) return;
  if (t == null) return e.input(t, n);
  e.props.offset = e.props.timezone ? offset(t, e.props.timezone) : "+0000";
  const s = applyOffset(t, (r = (i = e.props).offset) !== null && r !== void 0 ? r : i.offset = "+0000");
  e.input(format(s, e.props.valueFormat, e.props.valueLocale, !1), n);
}
function Gl(e, t) {
  var n;
  const r = ["prev_button", "month_button", "day_button", "year_button", "next_button"].find((s) => {
    var l;
    return (l = e.props.__root) === null || l === void 0 ? void 0 : l.getElementById(`${e.props.id}_${s}`);
  }), i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_${r}`);
  i instanceof HTMLElement && (t.preventDefault(), i.focus());
}
function ql(e, t) {
  var n;
  let r = "";
  if (!(t instanceof HTMLInputElement) || e.props.pickerOnly) return;
  Vl.set(e, t), (n = e.props.__root) === null || n === void 0 || n.addEventListener("click", (l) => {
    e.props.expanded && l.target instanceof HTMLElement && l.target.closest(`#${e.props.id}_popover`) ? Pl.add(e) : Pl.delete(e);
  }), e.on("prop:inputText", ({ payload: l }) => {
    l !== t.value && (ya.get(t) === "beforeCallback" && (r = t.value), Va(t), t.selectionStart = 0, t.selectionEnd = t.value.length, function(c, u) {
      var m, qu;
      if (!ia.has(c)) return;
      const Gu = (m = wa.get(c)) !== null && m !== void 0 ? m : "", Qu = (qu = _a.get(c)) !== null && qu !== void 0 ? qu : "";
      za(c, { type: "insert", selectionBefore: ja(c), data: u, valueBefore: c.value, suffix: Qu, prefix: Gu });
    }(t, l), t.value = l, setTimeout(() => Fa(t), 10));
  });
  const [i, s] = Jl(e);
  Ma(t, { pattern: i, explicitParts: s, onChange: ({ valueAfter: l }) => {
    if (Xl(e), El.has(e)) return El.delete(e);
    r && r === l ? r = "" : (Va(t), e.props.inputText = l, setTimeout(() => Fa(t), 10));
  } }, e);
}
function Xl(e) {
  var t, n;
  if (e.props.overlay) {
    const r = Vl.get(e);
    !r || !(!((t = e.props.attrs) === null || t === void 0) && t.placeholder) || e._value || Il(r, !0) || e.props._isFocused || e.props.activeDate && e.props.expanded ? r && (e.props._isPlaceholder = !1, e.props._overlayParts = ht$1(Dl(r))) : (e.props._isPlaceholder = !0, e.props._overlayParts = [{ type: "placeholder", value: (n = e.props.attrs) === null || n === void 0 ? void 0 : n.placeholder }]);
  }
}
function Jl(e) {
  const t = e.props.locale, n = ["full", "long", "medium", "short"].includes(e.props.format) || typeof e.props.format == "object", r = parts(e.props.format, t);
  return [formatStr(e.props.format, t, !0, Nl), r.reduce((i, s) => {
    if (s.partName === "literal") return i;
    let l = range(s.token, t, n);
    if (s.token === "YYYY" && e.props.minDate && e.props.maxDate) {
      const u = e.props.minDate.getFullYear();
      l = he$1(e.props.maxDate.getFullYear() - u + 1, (m) => String(u + m));
    }
    const c = { type: "enum", token: s.token, values: l, placeholder: s.token === "A" ? "A/P" : s.token, selectDirection: "left" };
    return i.push(c), s.token.startsWith("D") && Fl.set(e, l), i;
  }, [])];
}
function Ql(e, t) {
  return !t || !(!e.props.minDate || !isBefore(t, e.props.minDate)) || !(!e.props.maxDate || !isAfter(t, e.props.maxDate)) || void 0;
}
function ei(e) {
  return typeof e.props.validationLabel == "function" ? e.props.validationLabel(e) : e.props.validationLabel || e.props.label || e.props.name || String(e.name);
}
const ti = typeof window < "u", oi = /* @__PURE__ */ new WeakMap();
function ni(e, t) {
  var n, r;
  if (t instanceof HTMLInputElement && !oi.get(e) && ti) {
    const i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_overlay`), s = (r = e.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${e.props.id}_overlay_inner`);
    if (i && t && s) {
      oi.set(e, i);
      const l = getComputedStyle(t).color;
      t.style.color = "transparent", t.style.caretColor = l;
      const c = new ResizeObserver(() => {
        var m;
        const qu = getComputedStyle(t), Gu = t.getBoundingClientRect(), Qu = (m = t.parentElement) === null || m === void 0 ? void 0 : m.getBoundingClientRect();
        e.props._overlayStyles = { ...e.props._overlayStyles, width: qu.width, height: qu.height, boxSizing: qu.boxSizing, padding: qu.padding, margin: qu.margin, fontSize: qu.fontSize, lineHeight: qu.lineHeight, top: Gu.top - ((Qu == null ? void 0 : Qu.top) || Gu.top) + "px", left: Gu.left - ((Qu == null ? void 0 : Qu.left) || Gu.left) + "px" };
      });
      c.observe(t);
      const u = (m) => {
        s.scrollLeft = m.detail;
      };
      t.addEventListener("input-scroll", u), e.on("destroyed", () => {
        t.removeEventListener("input-scroll", u), c.disconnect();
      });
    }
  }
}
function ri(e) {
  e.addProps(["_overlayStyles", "_overlayParts", "_overlayInnerStyles", "_isPlaceholder"]), e.props._overlayStyles = { position: "absolute", top: "0", left: "0", pointerEvents: e.props._isPlaceholder ? "auto" : "none" }, e.props._overlayInnerStyles = { overflow: "hidden", whiteSpace: "nowrap", paddingRight: "20px" }, e.on("created", () => {
    e.props.overlay = undefine(e.props.overlay), e.props.pickerOnly = undefine(e.props.pickerOnly), e.props.overlay = e.props.pickerOnly ? void 0 : e.props.overlay, e.props.overlay && whenAvailable(`${e.props.id}`, ni.bind(null, e), e.props.__root);
  }), e.on("prop:_isPlaceholder", () => {
    e.props._overlayStyles = { ...e.props._overlayStyles, pointerEvents: e.props._isPlaceholder ? "auto" : "none" };
  });
}
const si = { schema: /* @__PURE__ */ fs(/* @__PURE__ */ vs(/* @__PURE__ */ gs("$label"), /* @__PURE__ */ hs(/* @__PURE__ */ ms("prefix"), /* @__PURE__ */ $s(), /* @__PURE__ */ ra(/* @__PURE__ */ aa(/* @__PURE__ */ sa(/* @__PURE__ */ ea("$part.value"), /* @__PURE__ */ ta("$part.value"), /* @__PURE__ */ oa("$part.value"), /* @__PURE__ */ na("$part.value")))), /* @__PURE__ */ _s(), /* @__PURE__ */ ks(/* @__PURE__ */ Ks(/* @__PURE__ */ Is(/* @__PURE__ */ Ds("$ui.prev.value"), /* @__PURE__ */ ms("prev")), /* @__PURE__ */ Ws("$decade"), /* @__PURE__ */ Us(/* @__PURE__ */ zs()), /* @__PURE__ */ Ys(/* @__PURE__ */ Zs(), /* @__PURE__ */ zs()), /* @__PURE__ */ js(/* @__PURE__ */ Zs(), /* @__PURE__ */ Gs(), /* @__PURE__ */ zs()), /* @__PURE__ */ Ss(/* @__PURE__ */ Ls("$ui.next.value"), /* @__PURE__ */ ms("next")), /* @__PURE__ */ Qs(/* @__PURE__ */ ms("close"))), /* @__PURE__ */ la(/* @__PURE__ */ Ps(/* @__PURE__ */ Hs("$fns.format($year, $yearFormat)")), /* @__PURE__ */ Rs(/* @__PURE__ */ Ns("$fns.format($month, $monthFormat)")), /* @__PURE__ */ As(/* @__PURE__ */ Ts(/* @__PURE__ */ Es(/* @__PURE__ */ Os("$fns.format($day, $weekdayFormat)"))), /* @__PURE__ */ Cs(/* @__PURE__ */ Ms(/* @__PURE__ */ Vs(/* @__PURE__ */ Fs("$fns.format($day, $dateFormat)"))))), /* @__PURE__ */ Xs(/* @__PURE__ */ Js()))), /* @__PURE__ */ qs(/* @__PURE__ */ ms("clear")), /* @__PURE__ */ Bs(/* @__PURE__ */ ms("calendar")), /* @__PURE__ */ bs(), /* @__PURE__ */ ms("suffix"))), /* @__PURE__ */ ys("$help"), /* @__PURE__ */ xs(/* @__PURE__ */ ws("$message.value"))), type: "input", family: "text", props: ["dateFormat", "dayButtonFormat", "format", "monthButtonFormat", "monthFormat", "overlay", "pickerOnly", "showMonths", "showPagination", "weekStart", "weekdayFormat", "yearFormat", "years"], features: [
  ri,
  function(e) {
    var t, n, r, i, s, l, c, u, m, qu, Gu, Qu, Xu, ef, tf, af, rf, hf, sf, pf, $f, uf;
    e.addProps(["_isDisabled", "_isFocused", "activeDate", "calendar", "clearable", "disabled", "decade", "disabledDays", "expanded", "inputText", "localTime", "maxDate", "maxScan", "minDate", "months", "offset", "paginatedPanels", "panel", "pickerOnly", "renderedDate", "sequence", "timezone", "valueFormat", "valueLocale", "showPanelClose", "selectedDay", "selectedWeek", "selectedMonth", "selectedYear"]), e.hook.prop((cf, yf) => (cf.prop === "expanded" && e.props.disabled && (cf.value = !1), cf.prop === "weekStart" && (cf.value = Number(cf.value || 0)), cf.prop === "showMonths" && (cf.value = Number(cf.value || 1)), cf.prop === "maxScan" && (cf.value = Number(cf.value || 7)), cf.prop === "timezone" && (typeof e._value == "string" || e._value instanceof Date) && (e.props.offset = offset(e._value, cf.value)), yf(cf))), e.props._isFocused = !1, e.props._isPlaceholder = !1, (t = (Qu = e.props).valueFormat) !== null && t !== void 0 || (Qu.valueFormat = "ISO8601"), (n = (Xu = e.props).weekdayFormat) !== null && n !== void 0 || (Xu.weekdayFormat = "d"), (r = (ef = e.props).monthFormat) !== null && r !== void 0 || (ef.monthFormat = "MMM"), (i = (tf = e.props).monthButtonFormat) !== null && i !== void 0 || (tf.monthButtonFormat = "MMMM"), (s = (af = e.props).dayButtonFormat) !== null && s !== void 0 || (af.dayButtonFormat = "D"), (l = (rf = e.props).dateFormat) !== null && l !== void 0 || (rf.dateFormat = "D"), (c = (hf = e.props).yearFormat) !== null && c !== void 0 || (hf.yearFormat = "YYYY"), (u = (sf = e.props).paginatedPanels) !== null && u !== void 0 || (sf.paginatedPanels = ["day", "year"]), (m = (pf = e.props).valueLocale) !== null && m !== void 0 || (pf.valueLocale = e.props.locale), (qu = ($f = e.props).format) !== null && qu !== void 0 || ($f.format = "long"), e.props.panels = zl(e), e.props.pickerOnly = undefine(e.props.pickerOnly), "disabled" in e.props && (e.props.disabled = undefine(e.props.disabled)), "clearable" in e.props && (e.props.clearable = undefine(e.props.clearable)), (Gu = (uf = e.props).maxScan) !== null && Gu !== void 0 || (uf.maxScan = 7), e.props._isDisabled = typeof e.props.disabledDays == "function" ? e.props.disabledDays.bind(null, e) : Ql.bind(null, e), e.props.calendar = [], e.props.inputText = "", e.props.showMonths = e.props.showMonths || 1, typeof e.props.format == "function" ? (e.props.formatDate = e.props.format, e.props.format = null) : e.props.formatDate = format, Ul(e), e.on("mounted", () => {
      whenAvailable(`${e.props.id}`, ql.bind(null, e), e.props.__root);
    }), e.on("created", () => {
      if (function(cf) {
        const yf = cf._value;
        let ff = /* @__PURE__ */ new Date();
        if (yf instanceof Date) ff = date(yf);
        else if (typeof yf == "string") try {
          const lf = parse(yf, cf.props.valueFormat, cf.props.valueLocale);
          ff = date(lf);
        } catch {
          console.warn(`Date (${yf}) does not match format (${formatStr(cf.props.valueFormat, cf.props.valueLocale)})`), ff = void 0;
        }
        else yf || (ff = void 0);
        if (cf.props.offset = cf.props.timezone ? offset(ff || /* @__PURE__ */ new Date(), cf.props.timezone) : "+0000", cf.props.minDate) {
          const lf = typeof cf.props.minDate == "string" ? parse(cf.props.minDate) : cf.props.minDate;
          cf.props.minDate = removeOffset(lf, cf.props.offset);
        }
        if (cf.props.maxDate) {
          const lf = typeof cf.props.maxDate == "string" ? parse(cf.props.maxDate) : cf.props.maxDate;
          cf.props.maxDate = removeOffset(lf, cf.props.offset);
        }
        ff = ff && removeOffset(ff, cf.props.offset), ff && Zl(cf, ff, !1);
        let gf = ff || /* @__PURE__ */ new Date();
        cf.props.minDate && gf < cf.props.minDate ? gf = cf.props.minDate : cf.props.maxDate && gf > cf.props.maxDate && (gf = cf.props.maxDate), cf.props.renderedDate = gf, cf.props.activeDate = gf, cf.props.localTime = ff && format(ff, "HH:mm") || "12:00";
      }(e), e.context) {
        const cf = {};
        let yf;
        e.context.fns.format = (ff, gf) => {
          if (cf[gf] && cf[gf][ff.toString()]) return cf[gf][ff.toString()];
          const lf = format(ff, gf, e.props.locale || "en", !1, Nl);
          return cf[gf] ? cf[gf][ff.toString()] = lf : cf[gf] = { [ff.toString()]: lf }, lf;
        }, e.context.fns.isDisabled = e.props._isDisabled, e.context.fns.isDisabledMonth = (ff) => !nearestDay(ff, (gf) => !e.props._isDisabled(gf), "month"), e.context.fns.isDisabledYear = (ff) => !nearestDay(ff, (gf) => !e.props._isDisabled(gf), "year"), e.context.handlers._blur = (ff) => {
          var gf, lf;
          e.props._isFocused = !1, ff.target instanceof HTMLInputElement && (ff.target.selectionStart = 0, ff.target.selectionEnd = 0), typeof ((gf = e.context) === null || gf === void 0 ? void 0 : gf.handlers.blur) == "function" && ((lf = e.context) === null || lf === void 0 || lf.handlers.blur(ff));
        }, e.context.handlers.closePanel = () => {
          e.props.expanded = !1;
        }, e.context.handlers._blurOut = (ff) => (gf) => {
          var lf;
          gf.preventDefault(), e.props.keydown ? e.props.keydown = !1 : ff && ff !== e.props.panel || e.props.pickerOnly && gf.relatedTarget instanceof Element && (gf.relatedTarget === document.getElementById(`${e.props.id}_inner`) || gf.relatedTarget.closest(`#${e.props.id}_inner`)) || gf.relatedTarget && gf.relatedTarget instanceof Element && (gf.relatedTarget.closest(`#${e.props.id}_popover`) || !(!((lf = e.props.__root) === null || lf === void 0) && lf.contains(gf.relatedTarget)) || gf.relatedTarget.id === `${e.props.id}_popover`) || (e.props.expanded = !1);
        }, e.context.handlers.overlayClick = () => {
          const ff = Vl.get(e);
          ff && (ff.focus(), e.props._isPlaceholder = !1);
        }, e.context.handlers.focus = () => {
          e.props.pickerOnly || (e.props._isFocused = !0, e.props.pickerOnly && !Ol.has(e) && (Ml.add(e), e.props.expanded = !0, setTimeout(() => Ml.delete(e), 200)));
        }, e.context.handlers.clear = () => {
          var ff, gf;
          Zl(e, void 0, !0), jl(e, void 0);
          const lf = (gf = (ff = e.props) === null || ff === void 0 ? void 0 : ff.__root) === null || gf === void 0 ? void 0 : gf.getElementById(`${e.props.id}`);
          lf instanceof HTMLInputElement && (lf.focus(), setTimeout(() => {
            lf.setSelectionRange(0, 0);
          }, 50));
        }, e.context.handlers.dateInput = (ff) => {
          var gf;
          if (Bl.has(e)) return Bl.delete(e);
          if (ff.target instanceof HTMLInputElement && !e.props.expanded) try {
            let lf = parse({ date: ff.target.value, format: e.props.format, locale: e.props.locale, partFilter: Nl });
            if (function(Sf) {
              return parts(Sf.props.format, Sf.props.locale).some((Mf) => Mf.partName === "weekday");
            }(e) && e.props.activeDate instanceof Date && e.props.activeDate.getTime() === lf.getTime() && !Sa.get(ff.target) && format(lf, e.props.format, e.props.locale, !1, Nl) !== ff.target.value) {
              const Sf = range("dddd", e.props.locale), Mf = parts(e.props.format, e.props.locale), Uf = (gf = parseParts(ff.target.value, Mf).find((Rf) => Rf.token === "dddd")) === null || gf === void 0 ? void 0 : gf.value, Zf = format(lf, "dddd", e.props.locale);
              if (Uf && Sf.includes(Uf) && Zf !== Uf) {
                let Rf = Sf.indexOf(Uf) - Sf.indexOf(Zf);
                Rf = Rf < -1 ? 7 + Rf : Rf, lf = addDay(lf, Rf), El.add(e);
              }
            }
            Zl(e, lf);
          } catch {
            Zl(e, void 0);
          }
        }, e.context.handlers.open = () => {
          e.props.expanded = !0;
        }, e.context.handlers.next = () => {
          switch (e.props.panel) {
            case "year":
              return void (e.props.renderedDate = addYear(e.props.renderedDate, 10));
            case "day":
              return void (e.props.renderedDate = addMonth(e.props.renderedDate, 1));
          }
        }, e.context.handlers.prev = () => {
          switch (e.props.panel) {
            case "year":
              return void (e.props.renderedDate = addYear(e.props.renderedDate, -10));
            case "day":
              return void (e.props.renderedDate = addMonth(e.props.renderedDate, -1));
          }
        }, e.context.handlers.setDate = (ff) => () => {
          e.props.panel !== "month" && e.props.panel !== "year" || !e.props.activeDate || (ff = e.props.activeDate), e.emit("dateSelected", ff);
        }, e.context.handlers.localTime = (ff) => {
          const gf = ff.target;
          if (!gf.value) return;
          const [lf, Sf] = gf.value.split(":");
          e.props.localTime = gf.value, e.props.activeDate.setHours(lf, Sf), jl(e, e.props.activeDate);
        }, e.context.handlers.keyDown = (ff) => {
          switch (e.props.keydown = !0, e.props.panel) {
            case "day":
              return e.emit("calendarKeydown", ff);
            case "year":
              return e.emit("yearKeydown", ff);
            case "month":
              return e.emit("monthKeydown", ff);
            case "time":
              return e.emit("timeKeydown", ff);
            default:
              return;
          }
        }, e.context.handlers.inputKeydown = (ff) => {
          e.emit("keydown", ff);
        }, e.context.handlers.openKeydown = (ff) => {
          ff.key !== "Enter" && ff.key !== "Space" || (e.props.expanded = !0);
        }, e.context.handlers.mouseEnter = (ff) => (gf) => {
          if (clearTimeout(yf), gf.target instanceof HTMLElement && gf.target.getAttribute("tabindex") === "-1" && gf.target.getAttribute("data-is-extra") !== "true") if (e.props.panel === "month" || e.props.panel === "year") {
            const lf = nearestDay(ff, () => !0, e.props.panel);
            lf && (e.props.activeDate = lf);
          } else e.props.activeDate = ff;
        }, e.context.handlers.mouseLeave = () => {
          clearTimeout(yf), yf = setTimeout(() => {
          }, 100);
        }, e.context.handlers.jumpTo = (ff) => () => {
          e.props.panels.unshift(e.props.panel), e.props.panel = ff;
        }, e.context.fns.sameDay = (ff) => function(gf, lf) {
          return lf instanceof Date && sameDay(gf, lf);
        }(ff, e.props.activeDate), e.context.fns.sameMonth = (ff) => Wl(ff, e.props.activeDate), e.context.fns.sameYear = (ff) => Kl(ff, e.props.activeDate), e.context.fns.notInMonth = (ff, gf) => {
          const lf = dayStart(gf).getTime();
          return lf < monthStart(ff).getTime() || lf > monthEnd(ff).getTime() || void 0;
        };
      }
    });
    const vf = Yl.bind(null, e);
    e.on("prop:panel", ({ payload: cf }) => {
      e.props.showPagination = e.props.paginatedPanels.includes(cf);
    }), e.on("dateSelected", ({ payload: cf }) => {
      var yf, ff;
      Array.isArray(e.props.panels) && e.props.panels.length ? e.props.panel = e.props.panels.shift() : (e.props.expanded = !1, (ff = (yf = e.props.__root) === null || yf === void 0 ? void 0 : yf.getElementById(`${e.props.id}`)) === null || ff === void 0 || ff.focus()), cf && e.props._isDisabled(cf) || Zl(e, cf);
    }), e.on("input", ({ payload: cf }) => {
      if (cf === void 0 && !e.props._isFocused) return void jl(e, void 0);
      const yf = /* @__PURE__ */ new Date(), ff = cf ? jl(e, removeOffset(typeof cf == "string" ? parse(cf, e.props.valueFormat, e.props.valueLocale) : cf, e.props.offset)) : yf;
      e.props.activeDate = !cf && e.props.activeDate ? e.props.activeDate : ff, e.props.renderedDate = !cf && e.props.renderedDate ? e.props.renderedDate : ff, e.props.localTime = format(ff, "HH:mm"), function(gf) {
        const lf = Fl.get(gf);
        if (gf._value && lf) {
          const Sf = monthDays(gf.props.activeDate);
          if (lf.length > Sf) lf.splice(Sf, lf.length - Sf);
          else if (lf.length < Sf) for (let Mf = lf.length + 1; Mf <= Sf; Mf++) lf.push(String(Mf));
        }
      }(e);
    }), e.on("prop:renderedDate", Ul.bind(null, e)), e.on("prop:expanded", ({ payload: cf }) => {
      if (cf) {
        if (Pl.delete(e), e.props.panels = zl(e), e.props.panel = e.props.panels.shift(), window.innerWidth <= 430 && !window.matchMedia("(hover: hover)").matches ? e.props.showPanelClose = !0 : e.props.showPanelClose = !1, e.props.panel === "day") {
          const yf = e.props.activeDate;
          e.props.activeDate = nearestDay(e.props.activeDate, (ff) => !e.props._isDisabled(ff), "month") || yf;
        }
        Ul(e), whenAvailable(`${e.props.id}_popover`, (yf) => {
          const ff = yf.querySelector('[tabindex="0"]');
          ff && setTimeout(() => {
            ff.focus(), function(gf, lf) {
              const Sf = new MutationObserver((Uf) => {
                for (const Zf of Uf) Zf.type === "attributes" && Zf.target instanceof HTMLElement && Zf.target.getAttribute("tabindex") === "0" ? Zf.target.focus() : Zf.addedNodes.length && Zf.addedNodes.forEach((Rf) => {
                  var Bf;
                  if (Rf instanceof HTMLElement && Rf.getAttribute("tabindex") === "0") Rf.focus();
                  else if (Rf instanceof HTMLElement && Rf.querySelector('[tabindex="0"]')) {
                    const ih = Rf.querySelector('[tabindex="0"]');
                    ih instanceof HTMLElement && ih.focus();
                  } else Rf instanceof HTMLElement && Rf.querySelector('input[type="time"]') && ((Bf = Rf.querySelector('input[type="time"]')) === null || Bf === void 0 || Bf.focus());
                });
              });
              Sf.observe(lf, { attributes: !0, attributeFilter: ["tabindex"], childList: !0, subtree: !0 });
              const Mf = gf.on("prop:expanded", ({ payload: Uf }) => {
                Uf || (gf.off(Mf), Sf.disconnect());
              });
            }(e, yf);
          }, 0);
        }, e.props.__root), Tl && setTimeout(() => {
          document.addEventListener("click", vf);
        }, 10);
      } else {
        if (e.props.panel === "time") e.emit("dateSelected", e.props.activeDate);
        else if (e._value) {
          Bl.add(e);
          const yf = typeof e._value == "string" ? parse(e._value, e.props.valueFormat, e.props.valueLocale) : e._value;
          jl(e, removeOffset(yf, e.props.offset));
        } else jl(e, void 0);
        Tl && (Ol.add(e), document.removeEventListener("click", vf), setTimeout(() => Ol.delete(e), 50));
      }
    }), e.on("prop:activeDate", ({ payload: cf }) => {
      if (Array.isArray(e.props.calendar) && e.props.calendar.length) {
        if (e.props.panel === "day") {
          const yf = e.props.calendar, ff = monthStart(e.props.renderedDate), gf = monthEnd(addMonth(e.props.renderedDate, yf.length - 1));
          cf.getTime() < ff.getTime() ? e.props.renderedDate = addMonth(e.props.renderedDate, -1) : cf.getTime() > gf.getTime() && (e.props.renderedDate = addMonth(e.props.renderedDate));
        } else if (e.props.panel === "year") {
          const yf = e.props.years, ff = yf[0].getFullYear(), gf = yf[yf.length - 1].getFullYear(), lf = e.props.activeDate.getFullYear();
          e.props.renderedDate = lf > gf ? addYear(e.props.renderedDate, 10) : lf < ff ? addYear(e.props.renderedDate, -10) : cf;
        }
      }
      e.props.expanded && jl(e, e.props.activeDate);
    }), e.on("keydown", ({ payload: cf }) => {
      switch (cf.key) {
        case "ArrowDown":
        case "ArrowUp":
        case " ":
          cf.preventDefault(), e.props.pickerOnly && (e.props.expanded = !0);
          break;
        case "Enter":
        case "Return":
          e.props.expanded || (e.props.expanded = !0);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
    }), e.on("calendarKeydown", ({ payload: cf }) => {
      cf.preventDefault();
      let yf = null, ff = 0;
      switch (cf.key) {
        case "ArrowRight":
          ff = 1;
          break;
        case "ArrowLeft":
          ff = -1;
          break;
        case "ArrowDown":
          ff = 7;
          break;
        case "ArrowUp":
          ff = -7;
          break;
        case "Return":
        case "Enter":
          e.emit("dateSelected", e.props.activeDate);
          break;
        case "Tab":
          cf.shiftKey || Gl(e, cf);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
      if (ff && (cf.preventDefault(), yf = addDay(e.props.activeDate, ff)), yf && !e.props._isDisabled(yf)) e.props.activeDate = yf;
      else if (yf && e.props._isDisabled(yf)) {
        const gf = ff > 0 ? 1 : -1;
        he$1(Number(e.props.maxScan), (lf) => gf * lf).some((lf) => {
          const Sf = addDay(yf, lf);
          return !e.props._isDisabled(Sf) && (e.props.activeDate = Sf, !0);
        });
      }
    }), e.on("yearKeydown", ({ payload: cf }) => {
      let yf = 0;
      switch (cf.key) {
        case "ArrowDown":
          yf = 5;
          break;
        case "ArrowRight":
          yf = 1;
          break;
        case "ArrowUp":
          yf = -5;
          break;
        case "ArrowLeft":
          yf = -1;
          break;
        case "Tab":
          cf.shiftKey || Gl(e, cf);
          break;
        case "Return":
        case "Enter":
          e.emit("dateSelected", e.props.activeDate);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
      const ff = e.props.activeDate.getFullYear() + yf - e.props.renderedDate.getFullYear();
      e.props.activeDate = addYear(e.props.renderedDate, ff);
    }), e.on("monthKeydown", ({ payload: cf }) => {
      let yf = 0;
      switch (cf.key) {
        case "ArrowDown":
          yf = 3;
          break;
        case "ArrowRight":
          yf = 1;
          break;
        case "ArrowLeft":
          yf = -1;
          break;
        case "ArrowUp":
          yf = -3;
          break;
        case "Tab":
          cf.shiftKey || Gl(e, cf);
          break;
        case "Return":
        case "Enter":
          e.emit("dateSelected", e.props.activeDate);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
      yf && cf.preventDefault();
      let ff = (e.props.activeDate.getMonth() + yf) % 12;
      ff = ff < 0 ? 12 + ff : ff;
      const gf = ff - e.props.renderedDate.getMonth();
      let lf = addMonth(e.props.renderedDate, gf);
      if (e.props._isDisabled(lf)) {
        const Sf = nearestDay(lf, (Mf) => !e.props._isDisabled(Mf), "month");
        Sf && (lf = Sf);
      }
      e.props.activeDate = lf;
    }), e.on("timeKeydown", ({ payload: cf }) => {
      switch (cf.key) {
        case "Return":
        case "Enter":
          cf.preventDefault(), e.emit("dateSelected", e.props.activeDate);
      }
    }), e.on("prop:_isFocused", () => {
      Vl.get(e) && Xl(e);
    }), e.on("commit", ({ payload: cf }) => {
      if (cf ? Rl(e) : Hl(e), e.props.activeDate && e.props._isDisabled(e.props.activeDate)) {
        const yf = createMessage({ blocking: !0, key: "rule_invalidDate", meta: { messageKey: "invalidDate", removeImmediately: !1, localize: !0, i18nArgs: [{ node: e, name: ei(e), args: [] }] }, type: "validation", value: "The selected date is invalid." });
        e.store.set(yf);
      } else e.store.remove("rule_invalidDate");
    });
  },
  No,
  /* @__PURE__ */ localize("next"),
  /* @__PURE__ */ localize("prev"),
  /* @__PURE__ */ localize("changeDate"),
  /* @__PURE__ */ localize("chooseDate"),
  /* @__PURE__ */ defaultIcon("close", "close"),
  /* @__PURE__ */ defaultIcon("next", "right"),
  /* @__PURE__ */ defaultIcon("clear", "close"),
  /* @__PURE__ */ defaultIcon("prev", "left"),
  /* @__PURE__ */ defaultIcon("calendar", "date")
] }, ai = /* @__PURE__ */ Me("tl"), { outer: li, wrapper: ii, inner: pi, icon: di, label: ci, prefix: ui, suffix: fi, help: vi, messages: hi, message: mi } = /* @__PURE__ */ Ve(ai), gi = ai("input", () => ({ $el: "input", bind: "$attrs", attrs: { id: "$id", type: "text", onClick: "$handlers.click", onBlur: "$handlers.blur", onKeydown: "$handlers.keydown", onInput: "$handlers.input", onFocus: "$handlers.focus", value: "$inputText", name: "$node.name", tabindex: "0", placeholder: "$state.loading && $inputStd.length === 0 && $ui.isLoading.value || $placeholder || undefined", role: "combobox", autocomplete: "off", autocapitalize: "none", readonly: "$attrs.readonly || $isLoadingOption || undefined || $multiple && $max && $value && $value.length >= $max", disabled: "$disabled || $disabledInternally || undefined", "aria-autocomplete": "list", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-describedBy": "$describedBy", "aria-activedescendant": "$expanded && $activeDescendant || undefined" } })), $i = ai("listboxButton", () => ({ $el: "button", attrs: { style: "$visibilityStyles", id: '$id + "_listbox_button"', type: "button", onClick: "$handlers.toggleListbox", tabindex: "-1", "aria-label": "$expanded && $ui.close.value || $ui.open.value", disabled: "$disabled || undefined", "aria-haspopup": "true", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined' } })), bi = ai("tagWrapper", () => ({ $el: "span", for: ["option", "index", "$selections"], attrs: { id: '$id + "_tag-wrapper_" + $index', key: "$option.value", "data-value": "$option.value", tabindex: "-1", onClick: "$handlers.tagClick && $handlers.tagClick($option)", onFocus: "$handlers.tagFocus && $handlers.tagFocus($option)", onBlur: "$handlers.tagBlur && $handlers.tagBlur($option)", onKeydown: "$handlers.searchInputTagKeydown && $handlers.searchInputTagKeydown($option)", "data-is-tag": "true", "data-active-selection": "$fns.isActiveSelection && $fns.isActiveSelection($activeSelectionValue, $option)" } })), yi = ai("tag", () => ({ $el: "div", attrs: { id: '$id + "_tag_" + $index', role: "button" } })), xi = ai("removeSelection", () => ({ $el: "button", if: "$selections.length > 0", attrs: { id: '$id + "_remove_selection_" + $index', tabindex: "-1", "aria-label": "$ui.remove.value", type: "button", onClick: "$handlers.removeSelection && $handlers.removeSelection($option)", onTouchstart: "$handlers.removeSelection && $handlers.removeSelection($option)", "aria-controls": "$id" } })), wi = ai("tagLabel", () => ({ $el: "span" })), _i = ai("tags", () => ({ $el: "div", attrs: { id: '$id + "_selections"', "aria-live": "polite" } })), ki = ai("tagLoading", "span"), Si = /* @__PURE__ */ Pe(ai);
function Li(e) {
  e.props.multiple = !0, e.props.openOnClick = undefine(e.props.openOnClick), e.props.closeOnSelect === void 0 && (e.props.closeOnSelect = !0), e.props.closeOnSelect ? e.props.resetSearchOnCommit = !1 : e.props.resetSearchOnCommit === void 0 && (e.props.resetSearchOnCommit = e.props.multiple), e.props.allowNewValues = undefine(e.props.allowNewValues);
}
function Ii(e) {
  is(e), Fo(e), e.on("created", () => {
    function t() {
      return Array.isArray(e.value) ? e.value : [];
    }
    function n(r) {
      e.input(r);
    }
    e.props.disabled && (e.props.draggable = !1), whenAvailable(`${e.props.id}_selections`, (r) => {
      if (r instanceof HTMLElement) {
        if (!e.context) return;
        const i = { draggingClass: e.context.classes.dragging, dropZoneClass: e.context.classes.dropZone, disabled: !e.props.draggable, threshold: { horizontal: 0.25, vertical: 0 }, plugins: [animations()], root: e.props.__root, touchDraggingClass: e.context.classes.touchDragging, touchDropZoneClass: e.context.classes.touchDropZone, draggable: (s) => s.hasAttribute("data-is-tag"), handleEnd(s) {
          e.props.activeSelectionValue = void 0, handleEnd(s);
        }, handleDragstart(s) {
          e.props.activeSelectionValue = void 0, handleDragstart(s);
        }, handleTouchstart(s) {
          e.props.activeSelectionValue = void 0, handleTouchstart(s);
        } };
        dragAndDrop({ parent: r, getValues: t, setValues: n, config: i }), e.on("prop:disabled", ({ payload: s }) => {
          i.disabled = s, dragAndDrop({ parent: r, getValues: t, setValues: n, config: i });
        }), e.on("prop:draggable", ({ payload: s }) => {
          i.disabled = !s, dragAndDrop({ parent: r, getValues: t, setValues: n, config: i });
        });
      }
    }, e.props.__root);
  });
}
const Di = { schema: /* @__PURE__ */ li(/* @__PURE__ */ ii(/* @__PURE__ */ ci("$label"), /* @__PURE__ */ pi(/* @__PURE__ */ di("prefix"), /* @__PURE__ */ ui(), /* @__PURE__ */ _i(/* @__PURE__ */ bi(/* @__PURE__ */ yi(/* @__PURE__ */ Be("$state.loading && $fns.hasOptionLoaderValue && $fns.hasOptionLoaderValue($option) || $option.label === undefined", /* @__PURE__ */ ki("$ui.isLoading.value"), /* @__PURE__ */ wi("$option.label")), /* @__PURE__ */ xi(/* @__PURE__ */ di("close")))), /* @__PURE__ */ gi()), /* @__PURE__ */ Be("$state.loading", /* @__PURE__ */ di("loader")), /* @__PURE__ */ $i(/* @__PURE__ */ di("select")), /* @__PURE__ */ Si(), /* @__PURE__ */ fi(), /* @__PURE__ */ di("suffix"))), /* @__PURE__ */ vi("$help"), /* @__PURE__ */ hi(/* @__PURE__ */ mi("$message.value"))), type: "input", family: "dropdown", props: [], features: [
  options$1,
  /* @__PURE__ */ ro.bind(null, Li, Zr, Ii),
  /* @__PURE__ */ defaultIcon("select", "select"),
  /* @__PURE__ */ defaultIcon("close", "close"),
  /* @__PURE__ */ defaultIcon("selected", "check"),
  /* @__PURE__ */ defaultIcon("loader", "spinner"),
  /* @__PURE__ */ localize("isLoading"),
  /* @__PURE__ */ localize("loadMore"),
  /* @__PURE__ */ localize("remove"),
  /* @__PURE__ */ localize("open"),
  /* @__PURE__ */ localize("close"),
  No
] }, Ai = /* @__PURE__ */ Me("mk"), { outer: Ci, wrapper: Ti, inner: Ei, label: Oi, prefix: Mi, suffix: Vi, help: Fi, messages: Bi, message: Pi, icon: Hi } = /* @__PURE__ */ Ve(Ai), { overlayPlaceholder: Ri, overlayLiteral: Ni, overlayChar: Ki, overlayEnum: Wi, overlay: Ui, overlayParts: Yi, overlayInner: ji } = /* @__PURE__ */ Fe(Ai), zi = Ai("input", () => ({ $el: "input", bind: "$attrs", attrs: { type: "text", disabled: "$disabled", name: "$node.name", onBlur: "$handlers.blur", onInput: "$handlers.DOMInput", value: "$_maskValue", placeholder: "$placeholder", id: "$id", "aria-describedby": "$describedBy" } })), Zi = /* @__PURE__ */ new WeakMap(), Gi = /* @__PURE__ */ new WeakMap(), qi = /* @__PURE__ */ new WeakMap();
function Xi(e, t) {
  if (!(t instanceof HTMLInputElement)) throw new Error(`Masks can only be applied to an HTMLInputElement (id: ${t.id}).`);
  Gi.set(e, t), Ma(t, { ...Zi.get(e), onChange: ({ valueAfter: n, meta: r }) => {
    e.props._maskValue = n, e.input({ maskValue: n }), e.props._overlayParts = ht$1(r);
  } }, e);
}
const Ji = { schema: /* @__PURE__ */ Ci(/* @__PURE__ */ Ti(/* @__PURE__ */ Oi("$label"), /* @__PURE__ */ Ei(/* @__PURE__ */ Hi("prefix"), /* @__PURE__ */ Mi(), /* @__PURE__ */ Ui(/* @__PURE__ */ ji(/* @__PURE__ */ Yi(/* @__PURE__ */ Ri("$part.value"), /* @__PURE__ */ Ni("$part.value"), /* @__PURE__ */ Ki("$part.value"), /* @__PURE__ */ Wi("$part.value")))), /* @__PURE__ */ zi(), /* @__PURE__ */ Vi(), /* @__PURE__ */ Hi("suffix"))), /* @__PURE__ */ Fi("$help"), /* @__PURE__ */ Bi(/* @__PURE__ */ Pi("$message.value"))), type: "input", props: ["allowIncomplete", "mask", "mode", "tokens", "showMask", "unmaskValue", "prefix", "suffix", "reverse", "overlay"], family: "text", features: [ri, function(e) {
  e.addProps(["_maskValue", "_overlayParts"]), e.on("created", () => {
    var t, n, r, i, s;
    const l = Pa(typeof e._value == "string" ? e._value : "");
    Gi.set(e, l), qi.set(e, l), e.props.allowIncomplete = undefine(e.props.allowIncomplete), e.props.overlay = undefine(e.props.overlay);
    const c = !(e.props.showMask !== void 0 && !undefine(e.props.showMask));
    e.props.unmaskValue = undefine(e.props.unmaskValue), e.hook.prop((m, qu) => (m.prop === "unmaskValue" && (m.value = undefine(m)), qu(m)));
    const u = { placeholder: c, pattern: (t = e.props.mask) !== null && t !== void 0 ? t : "", mode: (n = e.props.mode) !== null && n !== void 0 ? n : "shift", partOverrides: (r = e.props.tokens) !== null && r !== void 0 ? r : {}, prefix: (i = e.props.prefix) !== null && i !== void 0 ? i : void 0, suffix: (s = e.props.suffix) !== null && s !== void 0 ? s : void 0, reverse: undefine(e.props.reverse) };
    Zi.set(e, u), e.hook.input((m, qu) => {
      const Gu = function(Qu, Xu) {
        const ef = Gi.get(Qu), tf = typeof Xu == "object" && "maskValue" in Xu;
        Xu = typeof Xu == "string" ? Xu : tf ? Xu.maskValue : "";
        const af = qi.get(Qu);
        af.value = Za(af, Xu);
        const rf = Ba(af, Zi.get(Qu)), hf = Il(af, Qu.props.allowIncomplete);
        return Xu === ef.value ? Qu.props.unmaskValue ? hf ?? "" : hf === null ? "" : typeof Xu == "string" ? Xu : "" : Xu === "" && ef.value !== "" && !Qu.props.allowIncomplete ? Xu : (tf || rf === Qu.props._maskValue || (ef.value = rf, Qu.props._maskValue = rf, Qu.props._overlayParts = ht$1(Dl(af) || [])), hf === null ? "" : Qu.props.unmaskValue ? hf : rf);
      }(e, m);
      return qu(Gu);
    }), e.props._maskValue = Ba(l, u, e), e.input(e.props._maskValue, !1), e.context && (e.context.handlers.DOMInput = (m) => {
      e.emit("dom-input-event", m);
    }), whenAvailable(`${e.props.id}`, Xi.bind(null, e), e.props.__root);
  });
}] }, Qi = /* @__PURE__ */ Me("tf"), { outer: ep, wrapper: tp, inner: op, icon: np, prefix: rp, suffix: sp, help: ap, messages: lp, message: ip } = /* @__PURE__ */ Ve(Qi), pp = Qi("fieldset", () => ({ $el: "fieldset", attrs: { id: '$id + "_fieldset"', role: "presentation", "aria-describedby": { if: "$help", then: '$: "help-" + $id', else: void 0 } } })), dp = Qi("legend", () => ({ if: "$label", $el: "legend" })), cp = Qi("source", () => ({ $el: "div", attrs: { id: '$id + "_source"', class: '$classes.transferlist + " " + $classes.source' } })), up = Qi("sourceHeader", () => ({ $el: "div", attrs: { id: '$id + "_source_header"', role: "presentation", class: '$classes.transferlistHeader + " " + $classes.sourceHeader' } })), fp = Qi("sourceHeaderLabel", () => ({ if: "$sourceLabel", $el: "label", attrs: { id: '$id + "_source_header_label"', for: '$id + "_source_search_input"', class: '$classes.transferlistHeaderLabel + " " + $classes.sourceHeaderLabel' }, children: "$sourceLabel || $label" })), vp = Qi("sourceHeaderItemCount", () => ({ $el: "span", attrs: { id: '$id + "_source_header_item_count"', role: "presentation", "aria-label": '$sourceOptions.length " items"', class: '$classes.transferlistHeaderItemCount + " " + $classes.sourceHeaderItemCount' } })), hp = Qi("targetHeaderLabel", () => ({ if: "$targetLabel", $el: "label", attrs: { id: '$id + "_target_header_label"', for: '$id + "_target_search_input"', class: '$classes.transferlistHeaderLabel + " " + $classes.targetHeaderLabel' }, children: "$targetLabel || $label" })), mp = Qi("targetHeaderItemCount", () => ({ $el: "span", attrs: { id: '$id + "_target_header_item_count"', role: "presentation", "aria-label": '$targetOptions.length + " items"', class: '$classes.transferlistHeaderItemCount + " " + $classes.targetHeaderItemCount' }, children: "$targetOptions.length" })), gp = Qi("sourceControls", () => ({ $el: "div", if: "$searchable", attrs: { id: '$id + "_source_controls"', class: '$classes.transferlistControls + " " + $classes.sourceControls' } })), $p = Qi("sourceSearch", () => ({ if: "$searchable", $el: "div", attrs: { id: '$id + "_source_search"', class: '$classes.transferlistSearch + " " + $classes.sourceSearch' } })), bp = Qi("sourceSearchInput", () => ({ $el: "input", attrs: { id: '$id + "_source_search_input"', type: "text", placeholder: "$placeholder", onInput: "$handlers.onSearch", value: "$inputText", onKeydown: "$handlers.sourceSearchKeydown", disabled: "$disabled", "aria-label": "Search", role: "searchbox", autocomplete: "off", class: '$classes.transferlistSearchInput + " " + $classes.sourceSearchInput', onFocus: "$handlers.sourceSearchFocus", onBlur: "$handlers.sourceSearchBlur" } })), yp = Qi("targetSearch", () => ({ if: "$targetSearchable", $el: "div", attrs: { id: '$id + "_target_search"', class: '$classes.transferlistSearch + " " + $classes.targetSearch' } })), xp = Qi("targetSearchInput", () => ({ $el: "input", attrs: { id: '$id + "_target_search_input"', type: "text", placeholder: "$placeholder", onInput: "$handlers.onTargetSearch", value: "$targetInputText", onKeydown: "$handlers.targetSearchKeydown", disabled: "$disabled", "aria-label": "Search", role: "searchbox", autocomplete: "off", class: '$classes.transferlistSearchInput + " " + $classes.targetSearchInput', onFocus: "$handlers.targetSearchFocus", onBlur: "$handlers.targetSearchBlur" } })), wp = Qi("targetControls", () => ({ $el: "div", if: "$targetSearchable", attrs: { id: '$id + "_target_controls"', class: '$classes.transferlistControls + " " + $classes.targetControls' } })), _p = Qi("sourceSearchClear", () => ({ $el: "button", if: '$inputText !== ""', attrs: { id: '$id + "_source_search_clear"', type: "button", onClick: "$handlers.clearSearch", "aria-label": "Clear Source Search", class: '$classes.transferlistSearchClear + " " + $classes.sourceSearchClear' } })), kp = Qi("targetSearchClear", () => ({ $el: "button", if: '$targetInputText !== ""', attrs: { id: '$id + "_target_search_clear"', type: "button", onClick: "$handlers.clearTargetSearch", "aria-label": "Clear Target Search", class: '$classes.transferlistSearchClear + " " + $classes.targetSearchClear' } })), Sp = Qi("sourceListItems", () => ({ $el: "ul", attrs: { id: '$id + "_source_list_items"', "aria-activedescendant": "$activeDescendant", onMouseenter: "$handlers.onMouseenter(true)", onMouseout: "$handlers.onMouseleave(true)", role: "listbox", "aria-multiselectable": "true", "aria-roledescription": "List of options to choose from.", class: '$classes.transferlistListItems + " " + $classes.sourceListItems', onKeydown: "$handlers.sourceListKeydown", tabindex: "$searchable || $sourceOptions.length === 0 && -1 || 0", onFocus: "$handlers.sourceListFocused", onBlur: "$handlers.sourceListBlurred", "aria-label": "Source list" } })), Lp = Qi("sourceListItem", () => ({ for: ["option", "index", "$sourceOptions"], $el: "li", attrs: { id: '$id + "_source_list_item_" + $index', "data-value": "$option.value", "aria-selected": "$transferOnSelect === false && $fns.isSelected($option, $selectedSourceItems)", "data-is-active": "$fns.isActive($option, $activeValue)", "data-disabled": "$option.attrs.disabled", role: "option", onClick: "$handlers.listitemClick($option, true)", onTouchstart: "$handlers.listitemTouchstart($option, true)", onTouchmove: "$handlers.listitemTouchmove($option, true)", onTouchend: "$handlers.listitemTouchend($option, true)", key: "$option.value", class: '$classes.transferlistListItem + " " + $classes.sourceListItem' } })), Ip = Qi("sourceOption", () => ({ $el: "div", attrs: { "data-checked": "$fns.isSelected($option, $selectedSourceItems)", class: '$classes.transferlistOption + " " + $classes.sourceOption' } })), Dp = Qi("sourceLoadMore", () => ({ $el: "li", if: "$state.loading || $state.hasNextPage", attrs: { id: '$id + "_source_load_more"', key: "loadMore", onClick: "$handlers.listitemClick($loadMoreOption)", "aria-selected": "false", "data-is-active": "$fns.isActive($loadMoreOption)", tabindex: "-1" } })), Ap = Qi("loadMoreInner", "span"), Cp = Qi("target", () => ({ $el: "div", attrs: { id: '$id + "_target"', class: '$classes.transferlist + " " + $classes.target' } })), Tp = Qi("targetHeader", () => ({ $el: "div", attrs: { id: '$id + "_target_header"', role: "presentation", class: '$classes.transferlistHeader + " " + $classes.targetHeader' } })), Ep = Qi("targetListItems", () => ({ $el: "ul", attrs: { id: "$id", "aria-activedescendant": "$activeDescendant", onMouseenter: "$handlers.onMouseenter(false)", onMouseout: "$handlers.onMouseleave(false)", role: "listbox", class: '$classes.transferlistListItems + " " + $classes.targetListItems', tabindex: "$targetOptions.length === 0 && -1 || 0", onKeydown: "$handlers.targetListKeydown", onFocus: "$handlers.targetListFocused", onBlur: "$handlers.targetListBlurred", "aria-label": "Target list" } })), Op = Qi("targetListItem", () => ({ for: ["option", "index", "$targetOptions"], $el: "li", attrs: { id: '$id + "_target_list_item_" + $index', "data-disabled": "$option.attrs.disabled", "data-value": "$option.value", "aria-selected": "$transferOnSelect === false && $fns.isSelected($option, $selectedTargetItems)", "data-is-active": "$fns.isActive($option, $activeValue)", role: "option", onClick: "$handlers.listitemClick($option, false)", onTouchstart: "$handlers.listitemTouchstart($option, false)", onTouchmove: "$handlers.listitemTouchmove($option, false)", onTouchend: "$handlers.listitemTouchend($option, false)", key: "$option.value", class: '$classes.transferlistListItem + " " + $classes.targetListItem' } })), Mp = Qi("targetOption", () => ({ $el: "div", attrs: { id: '$id + "_target_list_item_" + $index + "_option"', "data-checked": "$fns.isSelected($option, $selectedTargetItems)", class: '$classes.transferlistOption + " " + $classes.targetOption' } })), Vp = Qi("transferControls", () => ({ $el: "div", attrs: { id: '$id + "_transfer_controls"' } })), Fp = Qi("transferButtonForward", () => ({ if: "$transferOnSelect !== true", $el: "button", attrs: { id: '$id + "_transfer_button_forward"', type: "button", disabled: "$selectedSourceItems.length === 0 || $disabled || ($max && $value && $value.length >= $max)", onClick: "$handlers.transferForward", "aria-label": "$ui.addSelectedValues.value", title: "$ui.addSelectedValues.value", class: '$classes.transferlistButton + " " + $classes.transferButtonForward' } })), Bp = Qi("transferButtonForwardAll", () => ({ $el: "button", attrs: { id: '$id + "_transfer_button_forward_all"', type: "button", disabled: "$sourceOptions.length === 0 || $disabled || ($max && $value && $value.length >= $max)", onClick: "$handlers.transferForwardAll", "aria-label": "$ui.addAllValues.value", title: "$ui.addAllValues.value", onFocus: "$handlers.transferForwardAllFocused", class: '$classes.transferlistButton + " " + $classes.transferButtonForwardAll' } })), Pp = Qi("transferButtonBackward", () => ({ if: "$transferOnSelect !== true", $el: "button", attrs: { id: '$id + "_transfer_button_backward"', onClick: "$handlers.transferBackward", type: "button", disabled: "$selectedTargetItems.length === 0 || $targetOptions.length === 0 || $disabled", "aria-label": "$ui.removeSelectedValues.value", title: "$ui.removeSelectedValues.value", class: '$classes.transferlistButton + " " + $classes.transferButtonBackward' } })), Hp = Qi("transferButtonBackwardAll", () => ({ $el: "button", attrs: { id: '$id + "_transfer_button_backward_all"', onClick: "$handlers.transferBackwardAll", type: "button", disabled: "$targetOptions.length === 0 || $disabled", "aria-label": "$ui.removeAllValues.value", title: "$ui.removeAllValues.value", class: '$classes.transferlistButton + " " + $classes.transferButtonBackwardAll' } })), Rp = Qi("controlLabel", "span"), Np = Qi("sourceEmptyMessage", () => ({ $el: "li", if: "$showSourceEmptyMessage && $sourceEmptyMessage && $state.loading !== true", attrs: { id: '$id + "_source_empty_message"', key: "$sourceEmptyMessage", role: "presentation" } })), Kp = Qi("targetEmptyMessage", () => ({ $el: "li", if: "$showTargetEmptyMessage && $targetEmptyMessage", attrs: { id: '$id + "_empty_message"', key: "$emptyMessage", role: "presentation" } })), Wp = Qi("emptyMessageInner", "span"), Up = Symbol(), Yp = /* @__PURE__ */ new WeakSet(), jp = /* @__PURE__ */ new WeakSet();
function zp(e, t, n, r) {
  if (!(e.props.disabled || (e.props.isSourceOption = n, e.props.isSourceOption && Array.isArray(e.value) && e.value.length >= e.props.max))) if (n) {
    if (e.props.selectedSourceItems.includes(t)) return e.props.selectedSourceItems = e.props.selectedSourceItems.filter((i) => i !== t), e.props.activeValue = void 0, void (e.props.activeDescendant = void 0);
    e.props.selectedTargetItems = [], e.props.selectedSourceItems = [...e.props.selectedSourceItems, t];
  } else {
    if (e.props.selectedTargetItems.includes(t)) return void (e.props.selectedTargetItems = e.props.selectedTargetItems.filter((i) => i !== t));
    e.props.selectedSourceItems = [], e.props.selectedTargetItems = [...e.props.selectedTargetItems, t];
  }
}
function Zp(e, t) {
  if (e.props.sourceListOrigin = !0, e.props.maxReached) return;
  if (t) {
    const r = Array.isArray(e.value) ? [...e.value, t] : [t];
    return void e.input(r);
  }
  const n = e.props.selectedSourceItems.map((r) => gt$1(r));
  Array.isArray(e.value) ? e.input([...e.value, ...n]) : e.input(n), e.props.selectedSourceItems = [];
}
function Gp(e, t) {
  if (e.props.sourceListOrigin = !1, t) {
    const r = Array.isArray(e.value) ? e.value.filter((i) => i !== t) : [];
    return void e.input(r);
  }
  const n = e.props.selectedTargetItems.map((r) => gt$1(r));
  if (Array.isArray(e.value)) {
    const r = e.value.filter((i) => !n.includes(i));
    e.input(r);
  }
  e.props.selectedTargetItems = [];
}
function qp(e) {
  var t, n;
  if (e.props.activeValue === Up) {
    const i = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_source_load_more`);
    return void (i && i.scrollIntoView({ block: "nearest", inline: "start" }));
  }
  const r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.activeDescendant);
  r && r.scrollIntoView({ block: "nearest", inline: "start" });
}
function Xp(e) {
  var t;
  if (Array.isArray(e.value)) {
    const n = [];
    let r = [...e.props.options];
    e.value.forEach((i) => {
      const s = e.props.memoOptions.find((l) => eq(gt$1(l), i));
      if (s && !s.noOptionFound)
        n.push(s), e.props.options.findIndex((c) => eq(gt$1(c), i)) !== -1 && (r = r.filter((c) => !eq(gt$1(c), i)));
      else {
        const l = r.find((c) => eq(gt$1(c), i));
        l ? (n.push(l), r = r.filter((c) => !eq(gt$1(c), i))) : n.push({ label: String(i), value: i, noOptionFound: !0 });
      }
    }), e.props.targetOptions = e.props.targetInputText ? n.filter((i) => e.props.filter(i, e.props.targetInputText, e)) : n, e.props.sourceOptions = r;
  } else e.props.sourceOptions = [...e.props.options], e.props.targetOptions = [];
  if (e.props.skipSetActiveValue) return void (e.props.skipSetActiveValue = !1);
  !((t = e.props.__root) === null || t === void 0) && t.getElementById(e.props.id + "_source_list_items") && Jp(e);
}
function Jp(e) {
  var t, n, r, i, s, l, c, u, m;
  if (e.props.isDragging) return;
  if (e.props.targetSearchActive) {
    if (((n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.activeElement) === null || n === void 0 ? void 0 : n.id) === `${e.props.id}_target_search_input`) {
      const Qu = e.props.targetOptions.find((Xu) => {
        var ef;
        return !(!((ef = Xu.attrs) === null || ef === void 0) && ef.disabled);
      });
      return Qu ? void (e.props.activeValue = gt$1(Qu)) : void (e.props.activeValue = void 0);
    }
    return;
  }
  if (e.props.sourceSearchActive) {
    if (((i = (r = e.props.__root) === null || r === void 0 ? void 0 : r.activeElement) === null || i === void 0 ? void 0 : i.id) === `${e.props.id}_source_search_input`) {
      const Qu = e.props.sourceOptions.find((Xu) => {
        var ef;
        return !(!((ef = Xu.attrs) === null || ef === void 0) && ef.disabled);
      });
      return Qu ? void (e.props.activeValue = gt$1(Qu)) : void (e.props.activeValue = void 0);
    }
    e.props.sourceSearchActive = !1;
  }
  if (e.props.transferOnSelect === !1) return void (e.props.activeValue = void 0);
  const qu = e.props.sourceListOrigin ? e.props.sourceOptions : e.props.targetOptions;
  let Gu = !1;
  for (let Qu = e.props.activeIndex; Qu <= qu.length; Qu++) if (!(!((s = qu.attrs) === null || s === void 0) && s.disabled) && qu[Qu]) {
    Gu = !0, e.props.activeValue = gt$1(qu[Qu]);
    break;
  }
  if (!Gu && qu.length) {
    for (let Qu = e.props.activeIndex; Qu >= 0; Qu--) if (!(!((l = qu.attrs) === null || l === void 0) && l.disabled) && qu[Qu]) return Gu = !0, void (e.props.activeValue = gt$1(qu[Qu]));
  }
  if (!Gu) {
    let Qu;
    Qu = e.props.sourceListOrigin ? (m = e.props.__root) === null || m === void 0 ? void 0 : m.getElementById(`${e.props.id}`) : e.props.searchable ? (c = e.props.__root) === null || c === void 0 ? void 0 : c.getElementById(`${e.props.id}_source_search_input`) : (u = e.props.__root) === null || u === void 0 ? void 0 : u.getElementById(`${e.props.id}_source_list_items`), Qu && Qu.focus();
  }
}
function Qp(e, t) {
  return (t ? e.props.sourceOptions : e.props.targetOptions).find((n) => {
    var r;
    return !(!((r = n.attrs) === null || r === void 0) && r.disabled);
  });
}
function ed(e) {
  Array.isArray(e.value) && e.value.forEach(async (t) => {
    Lt$1(e, t, function(n, r) {
      return [...n.props.options, ...n.props.memoOptions].find((s) => eq(gt$1(s), r));
    }(e, t));
  });
}
function td(e) {
  e.context && (e.context.handlers.loadMore = xt$1.bind(null, e), e.context.fns.getSourceItemCount = (t) => e.props.transferOnSelect === !1 && t.length ? t.length + "/" + e.props.sourceOptions.length : e.props.sourceOptions.length, e.context.fns.getTargetItemCount = (t) => e.props.transferOnSelect === !1 && t.length ? t.length + "/" + e.props.targetOptions.length : e.props.targetOptions.length, e.context.fns.isActive = (t, n) => {
    if (!e.props.isDragging && !e.props.touchStarted) return eq(n, gt$1(t)) || void 0;
  }, e.context.fns.isSelected = (t, n) => !!n && !!Array.isArray(n) && n.includes(t), e.context.fns.optionLoading = (t) => e.props.optionLoaderValues.includes(gt$1(t)), e.context.handlers.clearSearch = () => {
    (function(t) {
      var n;
      t.props.sourceSearchActive = !1, t.props.inputText = "", yt$1(t, "", !0);
      const r = (n = t.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${t.props.id}_source_search_input`);
      r && r.focus();
    })(e);
  }, e.context.handlers.clearTargetSearch = () => {
    (function(t) {
      var n;
      t.props.targetSearchActive = !1, t.props.targetInputText = "";
      const r = [.../* @__PURE__ */ new Set([...t.props.options, ...t.props.memoOptions])], i = [];
      for (const l of t.value) {
        const c = r.find((u) => gt$1(u) === l);
        c && i.push(c);
      }
      t.props.targetOptions = i;
      const s = (n = t.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${t.props.id}_target_search_input`);
      s && s.focus();
    })(e);
  }, e.context.handlers.sourceSearchBlur = (t) => {
    setTimeout(() => {
      var n;
      if (t.relatedTarget && t.relatedTarget instanceof HTMLElement && (t.relatedTarget.id === `${e.props.id}_source_list_items` || t.relatedTarget.id === `${e.props.id}`)) {
        const r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_source_search_input`);
        if (!r) return;
        r.focus();
      } else e.props.activeValue = void 0;
    });
  }, e.context.handlers.targetSearchBlur = (t) => {
    setTimeout(() => {
      var n;
      if (t.relatedTarget && t.relatedTarget instanceof HTMLElement && (t.relatedTarget.id === `${e.props.id}_source_list_items` || t.relatedTarget.id === `${e.props.id}`)) {
        const r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_target_search_input`);
        if (!r) return;
        r.focus();
      } else e.props.activeValue = void 0;
    });
  }, e.context.handlers.listitemClick = (t, n) => (r) => {
    od(e, t, n);
  }, e.context.handlers.transferForward = Zp.bind(null, e, void 0), e.context.handlers.transferForwardAll = () => {
    let t;
    if (e.props.maxReached) return;
    const n = e.props.sourceOptions.map((r) => gt$1(r));
    t = Array.isArray(e.value) ? [...e.value, ...n] : [...n], e.input(t), e.props.selectedSourceItems = [];
  }, e.context.handlers.transferBackward = Gp.bind(null, e, void 0), e.context.handlers.transferBackwardAll = () => {
    Array.isArray(e.value) && (e.input([]), e.props.selectedTargetItems = []);
  }, e.context.handlers.onSearch = (t) => {
    (function(n, r) {
      n.props.sourceSearchActive = !0;
      const i = r.target;
      n.props.inputText = i.value, yt$1(n, i.value, !0);
    })(e, t);
  }, e.context.handlers.onTargetSearch = (t) => {
    (function(n, r) {
      n.props.targetSearchActive = !0;
      const i = r.target;
      n.props.targetInputText = i.value;
      const s = [.../* @__PURE__ */ new Set([...n.props.memoOptions, ...n.props.options])], l = [];
      for (const u of n.value) {
        const m = s.find((qu) => gt$1(qu) === u);
        m && l.push(m);
      }
      const c = [...new Map([...n.props.targetOptions, ...l].map((u) => [JSON.stringify(u), u])).values()];
      n.props.targetOptions = c.filter((u) => n.props.filter(u, i.value, n)), n.props.targetOptions.length === 0 ? n.props.showTargetEmptyMessage = !0 : n.props.showTargetEmptyMessage = !1, Jp(n);
    })(e, t);
  }, e.context.handlers.onMouseenter = (t) => (n) => {
    n.type !== "touchstart" && (t ? e.props.mouseOnSource = !0 : e.props.mouseOnTarget = !0);
  }, e.context.handlers.onMouseleave = (t) => (n) => {
    var r;
    if (n.type === "touchend") return;
    const i = (r = e.props.__root) === null || r === void 0 ? void 0 : r.getElementById(t ? `${e.props.id}_source_list_items` : `${e.props.id}`);
    i && (i.contains(n.relatedTarget) || (e.props.trackHover = !1, e.props.activeValue = void 0, e.props.activeDescendant = void 0, e.props.activeIndex = void 0, t ? e.props.mouseOnSource = !1 : e.props.mouseOnTarget = !1));
  }, e.context.handlers.listitemClick = (t, n) => (r) => {
    r instanceof MouseEvent && e.props.touchStarted || od(e, t, n);
  }, e.context.handlers.listitemTouchstart = () => () => {
    (function(t) {
      t.props.touchStarted = !0;
    })(e);
  }, e.context.handlers.listitemTouchend = (t, n) => (r) => {
    (function(i, s, l) {
      if (i.props.touchMoved) return i.props.touchMoved = !1, void (i.props.touchStarted = !1);
      const c = gt$1(s);
      i.props.activeIndex = i.props.sourceOptions.findIndex((u) => gt$1(u) === c), i.props.transferOnSelect ? l ? Zp(i, c) : Gp(i, c) : zp(i, s, l);
    })(e, t, n);
  }, e.context.handlers.listitemTouchmove = () => (t) => {
    (function(n) {
      n.props.touchMoved = !0;
    })(e);
  }, e.context.handlers.sourceSearchFocus = (t) => {
    nd(e, !0);
  }, e.context.handlers.targetSearchFocus = (t) => {
    nd(e, !1);
  }, e.context.handlers.sourceListFocused = (t) => {
    nd(e, !0);
  }, e.context.handlers.targetListFocused = () => {
    nd(e, !1);
  }, e.context.handlers.sourceListBlurred = (t) => {
    e.props.activeValue = void 0;
  }, e.context.handlers.targetListBlurred = (t) => {
    e.props.activeValue = void 0;
  }, e.context.handlers.sourceListKeydown = (t) => {
    rd(e, t, !0);
  }, e.context.handlers.targetListKeydown = (t) => {
    rd(e, t, !1);
  }, e.context.handlers.sourceSearchKeydown = (t) => {
    rd(e, t, !0);
  }, e.context.handlers.targetSearchKeydown = (t) => {
    rd(e, t, !1);
  });
}
function od(e, t, n, r) {
  var i;
  if (gt$1(t) === Up) return void ((i = e.context) === null || i === void 0 || i.handlers.loadMore(!0));
  const s = gt$1(t);
  e.props.activeIndex = e.props.sourceOptions.findIndex((l) => gt$1(l) === s), e.props.transferOnSelect ? n ? Zp(e, s) : Gp(e, s) : zp(e, t, n);
}
function nd(e, t) {
  const n = Qp(e, t);
  n && (e.props.sourceListOrigin = t, e.props.activeValue = gt$1(n));
}
function rd(e, t, n) {
  if (t.key === "ArrowDown" || t.key === "ArrowUp") (function(r, i, s) {
    var l, c, u;
    r.preventDefault();
    const m = s ? i.props.sourceOptions : i.props.targetOptions, qu = m.reduce((Qu, Xu) => {
      var ef;
      return !((ef = Xu == null ? void 0 : Xu.attrs) === null || ef === void 0) && ef.disabled || Qu.push(gt$1(Xu)), Qu;
    }, []);
    !((l = i.store.hasNextPage) === null || l === void 0) && l.value && qu.push(Up);
    const Gu = qu.indexOf(i.props.activeValue);
    if (r.key === "ArrowUp" && Gu !== 0) for (let Qu = Gu - 1; Qu >= 0; Qu--) {
      i.props.sourceListOrigin = s, i.props.activeValue = qu[Gu - 1];
      break;
    }
    else if (r.key === "ArrowDown" && Gu !== qu.length - 1) {
      for (let Qu = Gu + 1; Qu < qu.length; Qu++) if (!(!((u = (c = m[Qu]) === null || c === void 0 ? void 0 : c.attrs) === null || u === void 0) && u.disabled)) {
        i.props.sourceListOrigin = s, i.props.activeValue = qu[Qu];
        break;
      }
    }
    qp(i);
  })(t, e, n);
  else if (t.key === "ArrowRight" || t.key === "ArrowLeft") {
    if (t.key === "ArrowLeft" && n || t.key === "ArrowRight" && !n) return;
    (function(r, i, s) {
      i.props.searchable || (r.preventDefault(), function(l, c) {
        var u, m, qu;
        if (Qp(l, !c)) if (c) {
          const Gu = (u = l.props.__root) === null || u === void 0 ? void 0 : u.getElementById(`${l.props.id}`);
          Gu && Gu.focus();
        } else if (l.props.searchable) {
          const Gu = (m = l.props.__root) === null || m === void 0 ? void 0 : m.getElementById(`${l.props.id}_source_search_input`);
          Gu && Gu.focus();
        } else {
          const Gu = (qu = l.props.__root) === null || qu === void 0 ? void 0 : qu.getElementById(`${l.props.id}_source_list_items`);
          Gu && Gu.focus();
        }
      }(i, s));
    })(t, e, n);
  } else t.key === "Enter" && function(r, i, s) {
    var l;
    if (r.preventDefault(), !i.props.activeValue) return;
    if (i.props.activeValue === Up) return void ((l = i.context) === null || l === void 0 || l.handlers.loadMore(!0));
    const c = s ? i.props.sourceOptions : i.props.targetOptions, u = c.findIndex((qu) => gt$1(qu) === i.props.activeValue);
    i.props.activeIndex = u;
    const m = c[u];
    m && (i.props.transferOnSelect ? s ? Zp(i, gt$1(m)) : Gp(i, gt$1(m)) : zp(i, m, s));
  }(t, e, n);
}
function sd(e) {
  e.on("created", () => {
    if (typeof e.props.optionsLoader == "function" && (e.props.skipSetActiveValue = !0, It$1(e)), td(e), e.props.disabled && (e.props.draggable = !1), ne) {
      whenAvailable(e.props.id + "_source_list_items", (n) => {
        n instanceof HTMLElement && function(r, i) {
          if (!r.context) return;
          function s() {
            return r.props.sourceOptions.map((u) => gt$1(u));
          }
          function l() {
            return [];
          }
          const c = { longTouch: !0, draggingClass: r.context.classes.dragging, dropZoneClass: r.context.classes.dropZone, group: r.props.id, root: r.props.__root || document, disabled: !r.props.draggable || r.props.maxReached, touchDraggingClass: r.context.classes.touchDragging, touchDropZoneClass: r.context.classes.touchDropZone, selectionDraggingClass: r.context.classes.selectionDragging, selectionDropZoneClass: r.context.classes.selectionDropZone, touchSelectionDraggingClass: r.context.classes.touchSelectionDragging, touchSelectionDropZoneClass: r.context.classes.touchSelectionDropZone, longTouchClass: r.context.classes.longTouch, handleTouchmove(u) {
            r.props.selectedSourceItems = [], handleTouchmove(u);
          }, draggable: (u) => u.getAttribute("role") === "option" };
          c.plugins = [multiDrag({ handleDragstart(u) {
            r.props.isDragging = !0, r.props.trackHover = !1, r.props.activeValue = void 0, r.props.activeDescendant = void 0, handleDragstart(u);
          }, handleEnd(u) {
            handleEnd(u), r.props.isDragging = !1, r.props.activeValue = void 0, r.props.activeDescendant = void 0, r.props.activeDescendant = void 0, r.props.isDragging = !1, r.props.selectedTargetItems = [], r.props.selectedSourceItems = [];
          }, handleTouchstart(u) {
            r.props.isDragging = !0, r.props.trackHover = !1, r.props.activeValue = void 0, r.props.activeDescendant = void 0, r.props.mouseOnSource = !1, r.props.mouseOnTarget = !1, handleTouchstart(u);
          }, selections: () => r.props.selectedSourceItems.map((u) => gt$1(u)) })], dragAndDrop({ parent: i, getValues: s, setValues: l, config: c }), r.on("prop:disabled", ({ payload: u }) => {
            c.disabled = u, dragAndDrop({ parent: i, getValues: s, setValues: l, config: c });
          }), r.on("prop:draggable", ({ payload: u }) => {
            c.disabled = !u, dragAndDrop({ parent: i, getValues: s, setValues: l, config: c });
          }), r.on("prop:maxReached", ({ payload: u }) => {
            c.disabled = u, dragAndDrop({ parent: i, getValues: s, setValues: l, config: c });
          });
        }(e, n);
      }, e.props.__root), whenAvailable(`${e.props.id}`, (n) => {
        n instanceof HTMLElement && function(r, i) {
          if (!r.context) return;
          function s() {
            return r.props.targetOptions.map((u) => gt$1(u));
          }
          function l(u, m) {
            r.props.sourceListOrigin = !0, r.input(u);
          }
          const c = { longTouch: !0, root: r.props.__root, group: r.props.id, disabled: !r.props.draggable, draggingClass: r.context.classes.dragging, dropZoneClass: r.context.classes.dropZone, touchDraggingClass: r.context.classes.touchDragging, touchDropZoneClass: r.context.classes.touchDropZone, selectionDraggingClass: r.context.classes.selectionDragging, selectionDropZoneClass: r.context.classes.selectionDropZone, touchSelectionDraggingClass: r.context.classes.touchSelectionDragging, touchSelectionDropZoneClass: r.context.classes.touchSelectionDropZone, longTouchClass: r.context.classes.longTouch, draggable: (u) => u.getAttribute("role") === "option", plugins: [] };
          c.plugins = [multiDrag({ handleDragstart(u) {
            r.props.isDragging = !0, r.props.trackHover = !1, r.props.activeValue = void 0, handleDragstart(u);
          }, handleEnd(u) {
            handleEnd(u), r.props.selectedTargetItems = [], r.props.selectedSourceItems = [], r.props.activeValue = void 0, r.props.trackHover = !0, r.props.isDragging = !1;
          }, handleTouchstart(u) {
            r.props.trackHover = !1, r.props.activeValue = void 0, r.props.isDragging = !0, r.props.activeDescendant = void 0, handleTouchstart(u);
          }, selections: () => r.props.selectedTargetItems.map((u) => gt$1(u)) })], dragAndDrop({ parent: i, getValues: s, setValues: l, config: c }), r.on("prop:disabled", ({ payload: u }) => {
            c.disabled = u, dragAndDrop({ parent: i, getValues: s, setValues: l, config: c });
          }), r.on("prop:draggable", ({ payload: u }) => {
            c.disabled = !u, dragAndDrop({ parent: i, getValues: s, setValues: l, config: c });
          });
        }(e, n);
      }, e.props.__root);
      const t = (n) => {
        var r;
        if (e.props.isDragging) return;
        e.props.mouseX = n.clientX, e.props.mouseY = n.clientY;
        const i = e.props.mouseOnSource ? `${e.props.id}_source_list_items` : `${e.props.id}`, s = (r = e.props.__root) === null || r === void 0 ? void 0 : r.getElementById(i);
        if (s) {
          const l = s.getBoundingClientRect();
          n.clientX > l.x && n.clientX < l.x + l.width && n.clientY > l.y && n.clientY < l.y + l.height && (e.props.trackHover = !0);
        }
      };
      document.addEventListener("mousemove", t);
    }
  });
}
function ad(e, t) {
  var n;
  let r = null, i = "", s = [];
  if (e.props.mouseOnSource) {
    if (r = Yp.has(e), i = `${e.props.id}_source_list_item`, s = [...e.props.sourceOptions], !s || !s.length || r) return s = [], i = "", void (r = null);
  } else if (e.props.mouseOnTarget && (r = jp.has(e), i = `${e.props.id}_target_list_item`, s = [...e.props.targetOptions], !s || !s.length || r)) return s = [], i = "", void (r = null);
  const l = s.reduce((u, m, qu) => {
    var Gu, Qu;
    if (!((Gu = m.attrs) === null || Gu === void 0) && Gu.disabled) return u;
    const Xu = (Qu = e.props.__root) === null || Qu === void 0 ? void 0 : Qu.getElementById(i + `_${qu}`);
    return Xu && u.push([Xu, m]), u;
  }, []), c = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_load_more`);
  c && l.push([c, e.props.loadMoreOption]), e.props.mouseOnSource && Yp.add(e), e.props.mouseOnTarget && jp.add(e), l.length && ld(e, l, null, t);
}
function ld(e, t, n, r) {
  const i = r ? r.getBoundingClientRect() : { top: 0, bottom: 0 };
  if (n = null, e.props.trackHover) {
    if (e.props.mouseY > i.top && e.props.mouseY < i.bottom) {
      let s = n || 0, l = n;
      const c = (u, m) => {
        var qu;
        const Gu = m[0], { y: Qu, height: Xu, x: ef, width: tf } = Gu.getBoundingClientRect();
        if (e.props.mouseX > ef && e.props.mouseX < ef + tf && e.props.mouseY > Qu && e.props.mouseY < Qu + Xu) {
          n = u;
          const af = m[1];
          return e.props.activeValue = af && !(!((qu = af.attrs) === null || qu === void 0) && qu.disabled) ? gt$1(af) : void 0, !0;
        }
        return !1;
      };
      do {
        if (s !== null && c(s, t[s]) || l !== null && c(l, t[l])) break;
        s !== null && (s++, s > t.length - 1 && (s = null)), l !== null && (l--, l < 0 && (l = null));
      } while (s !== null || l !== null);
    }
  } else qp(e);
  e.props.mouseOnSource || e.props.mouseOnTarget ? e.props.mouseOnSource && Yp.has(e) || e.props.mouseOnTarget && jp.has(e) ? requestAnimationFrame(ld.bind(null, e, t, n, r)) : ad(e, r) : (Yp.delete(e), jp.delete(e));
}
const id = { schema: /* @__PURE__ */ ep(/* @__PURE__ */ pp(/* @__PURE__ */ dp("$label"), /* @__PURE__ */ ap("$help"), /* @__PURE__ */ tp(/* @__PURE__ */ cp(/* @__PURE__ */ up(/* @__PURE__ */ fp(), /* @__PURE__ */ vp(/* @__PURE__ */ Be("$optionsLoadingCounter > 0", /* @__PURE__ */ np("loader"), "$fns.getSourceItemCount($selectedSourceItems)"))), /* @__PURE__ */ gp(/* @__PURE__ */ $p(/* @__PURE__ */ bp(), /* @__PURE__ */ _p(/* @__PURE__ */ np("close")))), /* @__PURE__ */ Sp(/* @__PURE__ */ Np(/* @__PURE__ */ Wp("$sourceEmptyMessage")), /* @__PURE__ */ Lp(/* @__PURE__ */ Be("$transferOnSelect !== true && $fns.isSelected($option, $selectedSourceItems)", /* @__PURE__ */ np("selected")), /* @__PURE__ */ Ip("$option.label")), /* @__PURE__ */ Dp(/* @__PURE__ */ Be("$state.loading && $optionLoadingCounter === 0 || $state.hasNextPage", /* @__PURE__ */ Ap(/* @__PURE__ */ Be("$state.loading", /* @__PURE__ */ np("loader")), "$state.loading && $ui.isLoading.value || $ui.loadMore.value"))))), /* @__PURE__ */ Vp(/* @__PURE__ */ Bp(/* @__PURE__ */ Rp("$ui.addAllValues.value"), /* @__PURE__ */ np("fastForward")), /* @__PURE__ */ Fp(/* @__PURE__ */ Rp("$ui.addSelectedValues.value"), /* @__PURE__ */ np("moveRight")), /* @__PURE__ */ Pp(/* @__PURE__ */ Rp("$ui.removeSelectedValues.value"), /* @__PURE__ */ np("moveLeft")), /* @__PURE__ */ Hp(/* @__PURE__ */ Rp("$ui.removeAllValues.value"), /* @__PURE__ */ np("rewind"))), /* @__PURE__ */ Cp(/* @__PURE__ */ Tp(/* @__PURE__ */ hp(), /* @__PURE__ */ mp("$fns.getTargetItemCount($selectedTargetItems)")), /* @__PURE__ */ wp(/* @__PURE__ */ yp(/* @__PURE__ */ xp(), /* @__PURE__ */ kp(/* @__PURE__ */ np("close")))), /* @__PURE__ */ Ep(/* @__PURE__ */ Kp(/* @__PURE__ */ Be("$state.loading !== true", /* @__PURE__ */ Wp("$targetEmptyMessage"))), /* @__PURE__ */ Op(/* @__PURE__ */ Be("$transferOnSelect !== true && $fns.isSelected($option, $selectedTargetItems)", /* @__PURE__ */ np("selected")), /* @__PURE__ */ Mp(/* @__PURE__ */ Be("$fns.optionLoading($option, $optionLoaderValues)", "$ui.isLoading.value", "$option.label")))))), /* @__PURE__ */ lp(/* @__PURE__ */ ip("$message.value")))), type: "input", props: [], features: [
  /* @__PURE__ */ defaultIcon("moveRight", "right"),
  /* @__PURE__ */ defaultIcon("moveLeft", "left"),
  /* @__PURE__ */ defaultIcon("fastForward", "fastForward"),
  /* @__PURE__ */ defaultIcon("rewind", "rewind"),
  /* @__PURE__ */ defaultIcon("close", "close"),
  /* @__PURE__ */ defaultIcon("loader", "spinner"),
  /* @__PURE__ */ defaultIcon("selected", "check"),
  /* @__PURE__ */ localize("isLoading"),
  /* @__PURE__ */ localize("loadMore"),
  /* @__PURE__ */ localize("addAllValues"),
  /* @__PURE__ */ localize("addSelectedValues"),
  /* @__PURE__ */ localize("removeSelectedValues"),
  /* @__PURE__ */ localize("removeAllValues"),
  options$1,
  function(e) {
    (function(t) {
      t.addProps(["search", "options", "selectedItems", "activeValue", "activeIndex", "activeDescendant", "targetOptions", "sourceOptions", "optionLoader", "isLoadingOptions", "filterOptions", "inputText", "hasNextPage", "page", "targetLoading", "searchable", "sourceLabel", "targetLabel", "transferOnSelect", "disabled", "placeholder", "filter", "showSourceEmptyMessage", "showTargetEmptyMessage", "sourceEmptyMessage", "targetEmptyMessage", "clearOnSelect", "max", "maxReached", "debounce", "sourceListActive", "optionLoaderValues", "optionLoadingCounter", "optionsLoadingCounter", "memoOptions", "optionsLoaded", "selectedSourceItems", "selectedTargetItems", "draggable", "loadMore", "loadMoreOption", "targetSearchable", "targetInputText"]), t.props.loadMoreOption = { label: "Load more", value: Up }, t.props.draggable === void 0 ? t.props.draggable = !0 : t.props.draggable === "false" && (t.props.draggable = !1), t.props.optionsLoaderValues = [], t.props.selectedSourceItems = [], t.props.selectedTargetItems = [], t.props.optionsLoaded = void 0, t.props.memoOptions = [], t.props.multiple = !0, t.props.debounce = t.props.debounce ? parseInt(t.props.debounce) : 200, t.props.optionLoaderValues = [], t.props.optionsLoadingCounter = 0, t.props.optionLoadingCounter = 0, t.props.page = 1, t.props.hasNextPage = Dt$1.bind(null, t), t.props.options ? t.props.options = [...t.props.options] : t.props.options = [], t.props.sourceOptions = [], t.props.targetOptions = [], "disabled" in t.props && (t.props.disabled = undefine(t.props.disabled)), t.props.searchable = undefine(t.props.searchable), t.props.searchable && (t.props.inputText = ""), t.props.targetSearchable = undefine(t.props.targetSearchable), t.props.targetSearchable && (t.props.targetInputText = ""), t.props.clearOnSelect = undefine(t.props.clearOnSelect), t.props.transferOnSelect === void 0 ? t.props.transferOnSelect = !0 : t.props.transferOnSelect === "false" && (t.props.transferOnSelect = !1), t.props.targetOptions.length && (t.props.targetOptionValues = t.props.targetOptions.map((n) => gt$1(n))), t.props.initialOptions = [...t.props.options], t.props.max && (t.props.max = parseInt(t.props.max)), t.props.sourceListOrigin = void 0, typeof t.props.filter != "function" && (t.props.filter = (n, r) => n.label.toLowerCase().includes(r.toLowerCase()));
    })(e), function(t) {
      t.on("commit", async ({ payload: n }) => {
        t.props.activeValue = void 0, t.props.max && (t.props.maxReached = n.length >= t.props.max), t.props.clearOnSelect && t.props.inputText && (t.props.reFilter = !0, t.props.inputText = ""), t.props.memoOptions = [.../* @__PURE__ */ new Set([...t.props.targetOptions, ...t.props.memoOptions])], t.props.searchable && t.props.reFilter && !t.props.initialLoad ? (yt$1(t, t.props.inputText), t.props.reFilter = !1) : t.props.initialLoad || (t.isCreated || (t.props.skipSetActiveValue = !0), Xp(t)), typeof t.props.optionLoader == "function" ? ed(t) : t.props.initialLoad || (t.props.memoOptions = [.../* @__PURE__ */ new Set([...t.props.targetOptions, ...t.props.memoOptions])]);
      });
    }(e), sd(e), function(t) {
      t.on("prop:options", () => {
        t.props.appendingOptions && (t.props.skipSetActiveValue = !0, t.props.appendingOptions = !1), Xp(t);
      }), t.on("prop:memoOptions", () => {
        t.props.skipSetActiveValue = !0, Xp(t);
      }), t.on("prop:sourceOptions", () => {
        t.props.sourceOptions.length === 0 ? t.props.showSourceEmptyMessage = !0 : t.props.showSourceEmptyMessage = !1, Yp.delete(t);
      }), t.on("prop:targetOptions", () => {
        t.props.targetOptions.length === 0 ? t.props.showTargetEmptyMessage = !0 : t.props.showTargetEmptyMessage = !1;
      }), t.on("prop:activeValue", ({ payload: n }) => {
        if (t.props.isDragging) return void (t.props.activeDescendant = void 0);
        if (n === Up) return void (t.props.activeDescendant = `${t.props.id}_load_more`);
        const r = (t.props.sourceListOrigin ? t.props.sourceOptions : t.props.targetOptions).findIndex((i) => eq(gt$1(i), n));
        r >= 0 && t.props.sourceListOrigin ? t.props.activeDescendant = `${t.props.id}_source_list_item_${r}` : t.props.activeDescendant = r >= 0 ? `${t.props.id}_target_list_item_${r}` : void 0;
      }), t.on("prop:mouseOnSource", ({ payload: n }) => {
        var r;
        if (n && t.props.disabled !== !0 && !t.props.isDragging) {
          const i = (r = t.props.__root) === null || r === void 0 ? void 0 : r.getElementById(t.props.id + "_source_list_items");
          if (!i) return;
          t.props.mouseOnTarget = !1, t.props.sourceListOrigin = !0, Yp.delete(t), ad(t, i);
        }
      }), t.on("prop:mouseOnTarget", ({ payload: n }) => {
        var r;
        if (n && t.props.disabled !== !0 && !t.props.isDragging) {
          const i = (r = t.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${t.props.id}`);
          if (!i) return;
          t.props.mouseOnSource = !1, t.props.sourceListOrigin = !1, jp.delete(t), ad(t, i);
        }
      }), t.on("prop:optionsLoadingCounter", ({ payload: n }) => {
        n === 0 && t.props.optionLoadingCounter === 0 && t.store.set(_t$1);
      }), t.on("prop:optionLoadingCounter", ({ payload: n }) => {
        n === 0 && t.props.optionsLoadingCounter === 0 && (t.store.set(_t$1), t.props.skipSetActiveValue = !0, Xp(t));
      });
    }(e);
  }
] }, pd = /* @__PURE__ */ Me("sl"), { outer: dd, wrapper: cd, inner: ud, icon: fd, prefix: vd, suffix: hd, help: md, messages: gd, message: $d } = /* @__PURE__ */ Ve(pd), bd = pd("label", () => ({ if: "$label", $el: "label", attrs: { id: "$id + '_label'" } })), yd = pd("chart", () => ({ $el: "div", if: "$chart" })), xd = pd("chartBar", () => ({ $el: "div", for: ["bar", "index", "$chart"], attrs: { "data-active": { if: "$isMulti", then: { if: "$_value.0 < $_value.1", then: "$bar.at >= $_value.0 && $bar.at <= $_value.1", else: "$bar.at >= $_value.1 && $bar.at <= $_value.0" }, else: "$bar.at <= $_value" }, style: { left: '$bar.at / ($max - $min) * 100 + "%"', width: '$: "calc(" + (100 / $chart.length) + "% - 2px)"', height: { if: "$largestBar", then: '$bar.value / $largestBar * 100 + "%"' } } } })), wd = pd("sliderInner", () => ({ $el: "div", attrs: { "data-has-mark-labels": "$markLabels && $marks.length > 0" } })), _d = pd("track", () => ({ $el: "div", attrs: { id: "$: 'track-' + $id", onClick: "$handlers.clickTrack" } })), kd = pd("trackWrapper", () => ({ $el: "div" })), Sd = pd("trackInner", () => ({ $el: "div" })), Ld = pd("fill", () => ({ $el: "div", attrs: { style: "$fillStyles" } })), Id = pd("linkedValues", () => ({ $el: "div" })), Dd = pd("maxValue", () => ({ $formkit: "number", bind: "$computedMaxInputAttrs", ignore: !0, number: !0, value: { if: "$isMulti", then: "$_value.1", else: "$_value" }, tabindex: { if: "$disabled", then: -1 }, onNode: "$handlers.maxNode", onBlur: "$handlers.inputBlur" })), Ad = pd("minValue", () => ({ $formkit: "number", if: "$isMulti", bind: "$computedMinInputAttrs", ignore: !0, number: !0, value: { if: "$isMulti", then: "$_value.0", else: "$_value" }, tabindex: { if: "$disabled", then: -1 }, onNode: "$handlers.minNode", onBlur: "$handlers.inputBlur" })), Cd = pd("marks", () => ({ $el: "div", if: "$marks" })), Td = pd("mark", () => ({ $el: "span", for: ["step", "index", "$marks"], attrs: { "data-active": { if: "$isMulti", then: { if: "$_value.0 < $_value.1", then: "$step.at >= $_value.0 && $step.at <= $_value.1", else: "$step.at >= $_value.1 && $step.at <= $_value.0" }, else: "$step.at <= $_value" }, class: { if: "$step.class", then: '$: $classes.mark + " " + $step.class', else: "$classes.mark" }, style: { left: '$: $fns.calculateMarkPosition($step.at) + "%"' } } })), Ed = pd("markLabel", () => ({ $el: "span", if: "$markLabels", children: { if: "$step.label !== undefined", then: "$step.label", else: "" }, attrs: { class: '$: $classes.markLabel + " " + $step.labelClass' } })), Od = pd("handles", () => ({ $el: "ul" })), Md = pd("handleMax", () => ({ $el: "li", attrs: { "data-active": "$dragging", "data-is-target": '$lastHandleInteraction === "max"', "data-handle": "max", "data-show-tooltip": "$tooltip", class: "$: 'formkit-handle ' + $classes.handle + ' ' + $classes.handleMax", onFocus: "$handlers.focus", onClick: "$handlers.clickHandle", onMousedown: "$handlers.startDrag", onTouchstart: "$handlers.startDrag", style: "$maxHandleStyles", tabindex: { if: "$disabled", then: -1, else: 0 }, onBlur: "$handlers.blur", onKeydown: "$handlers.keydown" } })), Vd = pd("handleMin", () => ({ $el: "li", if: "$isMulti", attrs: { "data-active": "$dragging", "data-is-target": '$lastHandleInteraction === "min"', "data-handle": "min", "data-show-tooltip": "$tooltip", class: "$: $classes.handle + ' ' + $classes.handleMin", onFocus: "$handlers.focus", onClick: "$handlers.clickHandle", onMousedown: "$handlers.startDrag", onTouchstart: "$handlers.startDrag", style: "$minHandleStyles", tabindex: { if: "$disabled", then: -1, else: 0 }, onBlur: "$handlers.blur", onKeydown: "$handlers.keydown" } })), Fd = pd("handleMinInner", () => ({ $el: "div", attrs: { class: '$: $classes.handleInner + " " + $classes.handleMinInner' } })), Bd = pd("handleMaxInner", () => ({ $el: "div", attrs: { class: '$: $classes.handleInner + " " + $classes.handleMaxInner' } })), Pd = pd("tooltipMax", () => ({ $el: "div", if: '$tooltip === true || $tooltip === "auto"', children: { if: "$isMulti", then: { if: "$_value.0 < $_value.1", then: '$tooltipFormat($_value.1, "max")', else: '$tooltipFormat($_value.0, "max")' }, else: '$tooltipFormat($_value, "max")' }, attrs: { class: "$classes.tooltip + ' ' + $classes.tooltipMax" } })), Hd = pd("tooltipMin", () => ({ $el: "div", if: '$isMulti && ($tooltip === true || $tooltip === "auto")', children: { if: "$_value.0 < $_value.1", then: '$tooltipFormat($_value.0, "min")', else: '$tooltipFormat($_value.1, "min")' }, attrs: { class: "$classes.tooltip + ' ' + $classes.tooltipMin" } })), Rd = { schema: /* @__PURE__ */ dd(/* @__PURE__ */ cd(/* @__PURE__ */ bd("$label"), /* @__PURE__ */ md("$help"), /* @__PURE__ */ wd(/* @__PURE__ */ fd("prefix"), /* @__PURE__ */ vd(), /* @__PURE__ */ _d(/* @__PURE__ */ yd(/* @__PURE__ */ xd()), /* @__PURE__ */ kd(/* @__PURE__ */ Sd(/* @__PURE__ */ Ld(), /* @__PURE__ */ Cd(/* @__PURE__ */ Td(/* @__PURE__ */ Ed())), /* @__PURE__ */ Od(/* @__PURE__ */ Vd(/* @__PURE__ */ Hd(), /* @__PURE__ */ Fd()), /* @__PURE__ */ Md(/* @__PURE__ */ Pd(), /* @__PURE__ */ Bd()))))), /* @__PURE__ */ hd(), /* @__PURE__ */ fd("suffix"), /* @__PURE__ */ Be("$showInput && $isMulti === false", /* @__PURE__ */ Dd())), /* @__PURE__ */ Be("$showInput && $isMulti", /* @__PURE__ */ Id(/* @__PURE__ */ Ad(), /* @__PURE__ */ Dd())), /* @__PURE__ */ gd(/* @__PURE__ */ $d("$message.value")))), type: "input", family: "", props: ["min", "max", "step", "showInput", "tooltip", "tooltipFormat", "inputAttrs", "maxInputAttrs", "minInputAttrs", "marks", "markLabels", "snapToMarks", "chart", "scalingFunction", "intervals"], features: [function(e) {
  let t, n, r;
  e.addProps(["isMulti", "maxHandleStyles", "minHandleStyles", "fillStyles", "decimals", "dragging", "lastHandleInteraction", "largestBar", "computedMaxInputAttrs", "computedMinInputAttrs"]);
  const i = { linear: { forward: (sf) => sf, reverse: (sf) => sf }, log: { forward: (sf, pf = e.props.min, $f = e.props.max) => $f * Math.pow(sf / $f, 1.5), reverse: (sf, pf = e.props.min, $f = e.props.max) => $f * Math.pow(sf / $f, 1 / 1.5) } };
  let s = !1;
  function l() {
    const sf = document.activeElement;
    if (sf instanceof HTMLInputElement) {
      const pf = sf.value;
      sf.value = "", sf.value = pf;
    }
  }
  function c(sf) {
    if (!sf) return;
    const pf = { disabled: sf.props.disabled, min: typeof sf.props.min == "number" ? sf.props.min : 0, max: typeof sf.props.max == "number" ? sf.props.max : void 0, step: sf.props.step || 1 };
    sf.props.minInputAttrs = Object.assign(sf.props.minInputAttrs || {}, pf), sf.props.maxInputAttrs = Object.assign(sf.props.maxInputAttrs || {}, pf), sf.props.inputAttrs = sf.props.inputAttrs && typeof sf.props.inputAttrs == "object" ? Object.assign(sf.props.inputAttrs, pf) : pf, sf.props.computedMaxInputAttrs = sf.props.maxInputAttrs && typeof sf.props.maxInputAttrs == "object" ? Object.assign({}, sf.props.inputAttrs, sf.props.maxInputAttrs) : sf.props.inputAttrs, sf.props.computedMinInputAttrs = sf.props.minInputAttrs && typeof sf.props.minInputAttrs == "object" ? Object.assign({}, sf.props.inputAttrs, sf.props.minInputAttrs) : sf.props.inputAttrs;
  }
  function u(sf) {
    const { min: pf, max: $f, intervals: uf } = e.props;
    if (sf = Math.min(Math.max(sf, 0), 100), !uf || uf.length === 0) {
      hf();
      const cf = pf + sf / 100 * ($f - pf);
      return e.props.scalingFunction.reverse(cf, pf, $f);
    }
    const vf = qu(uf, pf, $f);
    for (let cf = 0; cf < vf.length; cf++) {
      const { value: yf, step: ff, left: gf, width: lf, stepsInInterval: Sf } = vf[cf];
      if (sf >= gf && sf <= gf + lf) {
        const Mf = yf + (sf - gf) / lf * Sf * ff, Uf = Mf % ff;
        return tf(Uf < ff / 2 ? Mf - Uf : Mf + (ff - Uf));
      }
    }
    return sf > 100 ? $f : sf < 0 ? pf : void 0;
  }
  function m(sf, pf = e.props.min, $f = e.props.max) {
    const uf = e.props.intervals;
    if (!uf || uf.length === 0)
      return hf(), (e.props.scalingFunction.forward(sf, pf, $f) - pf) / ($f - pf) * 100;
    const vf = qu(uf, pf, $f);
    for (let cf = 0; cf < vf.length; cf++) {
      const { value: yf, step: ff, left: gf, width: lf, stepsInInterval: Sf } = vf[cf], Mf = cf < vf.length - 1 ? vf[cf + 1].value : $f;
      if (sf >= yf && sf <= Mf)
        return 100 * ((gf + (sf - yf) / ff / Sf * lf) / 100);
    }
    return 100;
  }
  function qu(sf, pf = e.props.min, $f = e.props.max) {
    (sf = [...sf]).sort((cf, yf) => cf.value - yf.value), sf[0].value !== pf && sf.unshift({ value: pf, step: e.props.step });
    let uf = 0;
    for (let cf = 0; cf < sf.length; cf++) {
      const yf = sf[cf].value, ff = ((cf < sf.length - 1 ? sf[cf + 1].value : $f) - yf) / sf[cf].step;
      uf += ff;
    }
    let vf = 0;
    return sf.map((cf, yf) => {
      const ff = cf.value, gf = ((yf < sf.length - 1 ? sf[yf + 1].value : $f) - ff) / cf.step, lf = vf / uf * 100;
      return vf += gf, { value: cf.value, step: cf.step, left: lf, width: gf / uf * 100, stepsInInterval: gf, totalSteps: uf };
    });
  }
  function Gu() {
    const sf = parseFloat(`${e.props.min}`), pf = parseFloat(`${e.props.max}`);
    let $f, uf = 0;
    if (Array.isArray(e._value)) {
      const vf = [...e._value].sort(Qu);
      uf = parseFloat(`${vf[0]}`), $f = parseFloat(`${vf[1]}`);
    } else $f = parseFloat(`${e._value}`);
    e.props.maxHandleStyles = { left: `${m($f, sf, pf)}%` }, e.props.isMulti && Array.isArray(e._value) ? (e.props.minHandleStyles = { left: `${m(uf, sf, pf)}%` }, e.props.fillStyles = { left: `${m(uf, sf, pf)}%`, width: m($f, sf, pf) - m(uf, sf, pf) + "%" }) : e.props.fillStyles = { left: "0%", width: `${m($f, sf, pf)}%` };
  }
  function Qu(sf, pf) {
    return parseFloat(`${sf}`) - parseFloat(`${pf}`);
  }
  function Xu(sf, pf = !0) {
    if (e.props.disabled) return;
    let $f;
    if (sf === void 0) {
      if (e.props.isMulti) e.input([af(e.props.min), af(e.props.max)]);
      else {
        const vf = e.props.min + (e.props.max - e.props.min) / 2;
        e.input(af(vf));
      }
      return void Gu();
    }
    if (e.props.isMulti && Array.isArray(e._value) && !Array.isArray(sf)) {
      const vf = e.props.lastHandleInteraction === "min" ? 0 : 1;
      e._value[vf] = sf;
      const [cf, yf] = [...e._value];
      if (cf >= yf) {
        const ff = t == null ? void 0 : t.querySelector(`[data-handle="${e.props.lastHandleInteraction === "min" ? "max" : "min"}"]`);
        ff == null || ff.focus();
      }
      $f = af([...e._value].sort(Qu));
    } else Array.isArray(sf) ? $f = af(sf) : ($f = af(sf), $f = isNaN($f) ? e.props.min : $f);
    e.props.snapToMarks && ($f = rf($f));
    const uf = af(ef($f));
    pf && e.input(uf), Gu();
  }
  function ef(sf) {
    return e.props.isMulti && Array.isArray(sf) ? [ef(sf[0]), ef(sf[1])] : (sf = isNaN(sf) ? e.props.min : sf, Math.min(Math.max(parseFloat(`${sf}`), e.props.min), e.props.max));
  }
  function tf(sf) {
    return parseFloat(sf.toFixed(e.props.decimals));
  }
  function af(sf) {
    if (e.props.snapToMarks) return sf;
    if (!e.props.intervals) return Array.isArray(sf) ? sf.map(($f) => tf(Math.round($f / e.props.step) * e.props.step)) : tf(Math.round(sf / e.props.step) * e.props.step);
    const pf = qu(e.props.intervals);
    if (Array.isArray(sf)) return sf.map(($f) => {
      const uf = pf.find((vf, cf) => {
        var yf;
        return $f >= vf.value && $f < (((yf = pf[cf + 1]) === null || yf === void 0 ? void 0 : yf.value) || e.props.max);
      });
      return uf ? tf(uf.value + Math.round(($f - uf.value) / uf.step) * uf.step) : $f;
    });
    {
      const $f = pf.find((uf, vf) => {
        var cf;
        return sf >= uf.value && sf < (((cf = pf[vf + 1]) === null || cf === void 0 ? void 0 : cf.value) || e.props.max);
      });
      return $f ? tf($f.value + Math.round((sf - $f.value) / $f.step) * $f.step) : sf;
    }
  }
  function rf(sf) {
    if (Array.isArray(sf)) return sf[0] = rf(sf[0]), sf[1] = rf(sf[1]), sf;
    {
      const pf = e.props.marks;
      return pf.reduce((uf, vf) => Math.abs(vf.at - sf) < Math.abs(uf.at - sf) ? vf : uf, pf[0]).at;
    }
  }
  function hf() {
    s || (undefine(e.props.scalingFunction) ? typeof e.props.scalingFunction == "string" ? e.props.scalingFunction = i[e.props.scalingFunction] || i.linear : typeof e.props.scalingFunction == "object" && (e.props.scalingFunction = { ...i.linear, ...e.props.scalingFunction }) : e.props.scalingFunction = i.linear, s = !0);
  }
  e.props.maxHandleStyles = { left: "0%" }, e.props.fillStyles = { left: "0%", width: "0%" }, e.props.isMulti = !1, e.props.step = 1, e.props.min = 0, e.props.max = 100, e.props.tooltipFormat = typeof e.props.tooltipFormat == "function" ? e.props.tooltipFormat : (sf, pf) => {
    if (pf) return sf;
  }, e.props.largestBar = 0, "disabled" in e.props && (e.props.disabled = undefine(e.props.disabled)), e.on("created", () => {
    var sf;
    hf(), e.props.isMulti = Array.isArray(e.value), e.props.step = parseFloat(`${e.props.step}`), e.props.decimals = ((sf = e.props.step.toString().split(".")[1]) === null || sf === void 0 ? void 0 : sf.length) || 0, e.props.min = e.props.min ? parseFloat(`${e.props.min}`) : 0, e.props.max = e.props.max ? parseFloat(`${e.props.max}`) : 100;
    const pf = undefine(e.props.tooltip);
    e.props.tooltip = e.props.tooltip === void 0 ? "auto" : pf;
    const $f = undefine(e.props.marks);
    if (e.props.marks = !!$f && (Array.isArray(e.props.marks) ? e.props.marks : function() {
      const { min: cf, max: yf, step: ff } = e.props, gf = [];
      for (let lf = cf; lf <= yf; lf += ff) gf.push({ at: lf, label: lf });
      return gf;
    }()), e.props.markLabels = undefine(e.props.markLabels), e.props.snapToMarks = undefine(e.props.snapToMarks), e.props.showInput = undefine(e.props.showInput), e.props.largestBar = e.props.chart ? e.props.chart.reduce((cf, yf) => yf.value > cf ? yf.value : cf, 0) : e.props.largestBar, c(e), whenAvailable(`track-${e.props.id}`, () => {
      var cf;
      t = (cf = e.props.__root) === null || cf === void 0 ? void 0 : cf.getElementById(`track-${e.props.id}`), Xu(e.value, !1), Gu();
    }, e.props.__root), e.context) {
      let cf = 0, yf = "";
      const ff = e.context.handlers.blur;
      e.context.handlers.blur = (gf) => {
        ff(gf), e.emit("blur");
      }, e.context.handlers.clickTrack = (gf) => {
        if (!t) return;
        e.props.dragging = !1;
        const { left: lf, width: Sf } = t.getBoundingClientRect(), Mf = (gf.clientX - lf) / Sf;
        if (e.props.isMulti && Array.isArray(e.value)) {
          const [Uf, Zf] = e.value, Rf = Math.abs(Uf - Mf * e.props.max) < Math.abs(Zf - Mf * e.props.max) ? "min" : "max", Bf = Rf === "min" ? 0 : 1;
          e.props.lastHandleInteraction = Rf, e.value[Bf] = u(100 * Mf), Xu(e._value);
        } else Xu(u(100 * Mf));
      }, e.context.handlers.focus = (gf) => {
        if (!t) return;
        const lf = gf.target.dataset.handle;
        lf && (e.props.lastHandleInteraction = lf);
      }, e.context.handlers.clickHandle = (gf) => {
        gf.stopPropagation(), e.props.attrs.onClick && e.props.attrs.onClick(gf), e.props.dragging = !1, Xu(e._value);
      }, e.context.handlers.startDrag = (gf) => {
        if (!t) return;
        e.props.dragging = !0;
        const lf = gf.type === "touchstart", Sf = lf ? "touchmove" : "mousemove", Mf = lf ? "touchend" : "mouseup";
        e.props.lastHandleInteraction = gf.target.dataset.handle || e.props.lastHandleInteraction, document.addEventListener(Sf, vf, { passive: !1 }), document.addEventListener(Mf, () => {
          e.context && (e.props.dragging = !1, document.removeEventListener(Sf, vf), lf && gf.target instanceof HTMLElement && gf.target.blur());
        });
      }, e.context.handlers.keydown = (gf) => {
        if (["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ".", "-"].includes(gf.key)) {
          gf.preventDefault(), clearTimeout(cf), yf += gf.key;
          const lf = yf === "-" ? -1 : 1;
          cf = window.setTimeout(() => {
            yf !== "-" && Xu(parseFloat(yf) * lf), yf = "";
          }, 350);
        }
        if (["ArrowLeft", "ArrowDown", "ArrowRight", "ArrowUp", "PageUp", "PageDown", "Home", "End"].includes(gf.key)) {
          gf.preventDefault();
          const lf = e.props.lastHandleInteraction === "min" ? 0 : 1, Sf = Array.isArray(e._value) ? e._value[lf] : e._value, Mf = function(Uf, Zf) {
            if (!e.props.intervals) return e.props.step;
            const Rf = qu(e.props.intervals);
            if (Uf >= e.props.max) return Rf[Rf.length - 1].step;
            let Bf = Rf.find((ih, lh) => {
              var Wf;
              return Uf >= ih.value && Uf < (((Wf = Rf[lh + 1]) === null || Wf === void 0 ? void 0 : Wf.value) || e.props.max);
            });
            return Bf ? (Zf === -1 && Uf - Bf.step < Bf.value && (Bf = Rf[Rf.indexOf(Bf) - 1] || Bf), Bf.step) : e.props.step;
          }(Sf, ["ArrowLeft", "ArrowDown", "PageDown"].includes(gf.key) ? -1 : 1);
          if (e.props.marks && e.props.snapToMarks) {
            const Uf = rf(Sf), Zf = e.props.marks.find((lh) => lh.at === Uf), Rf = e.props.marks.indexOf(Zf), Bf = ["ArrowLeft", "ArrowDown"].includes(gf.key) ? -1 : 1, ih = Math.min(Math.max(0, Rf + Bf), e.props.marks.length - 1);
            return void Xu(e.props.marks[ih].at);
          }
          if (gf.metaKey) return void (gf.key === "ArrowLeft" || gf.key === "ArrowDown" ? Xu(e.props.min) : Xu(e.props.max));
          if (gf.key === "Home") return void Xu(e.props.min);
          if (gf.key === "End") return void Xu(e.props.max);
          ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(gf.key) && Xu(Sf + (gf.shiftKey ? 10 * Mf : Mf) * (["ArrowLeft", "ArrowDown"].includes(gf.key) ? -1 : 1)), gf.key === "PageUp" ? Xu(Sf + 10 * Mf) : gf.key === "PageDown" && Xu(Sf - 10 * Mf);
        }
      }, e.context.handlers.maxNode = (gf) => {
        r = gf, gf.hook.commit((lf, Sf) => eq(gf.value, lf) ? Sf(lf) : (`${gf.value}`.includes(".") && !`${lf}`.includes(".") && l(), e.props.isMulti && Array.isArray(e.value) ? Xu([e.value[0], lf]) : Xu(lf), Sf(ef(lf))));
      }, e.context.handlers.minNode = (gf) => {
        n = gf, gf.hook.commit((lf, Sf) => eq(gf.value, lf) ? Sf(lf) : (`${gf.value}`.includes(".") && !`${lf}`.includes(".") && l(), e.props.isMulti && Array.isArray(e.value) ? Xu([lf, e.value[1]]) : Xu(lf), Sf(ef(lf))));
      }, e.context.handlers.inputBlur = () => {
        e.props.isMulti && Array.isArray(e._value) && Xu([...e._value].sort(Qu));
      }, e.context.fns.calculateMarkPosition = (gf) => m(gf, e.props.min, e.props.max);
    }
    let uf;
    function vf(cf) {
      var yf;
      if (!t || !e.props.dragging) return;
      cf.preventDefault();
      const ff = cf.clientX || ((yf = cf.touches) === null || yf === void 0 ? void 0 : yf.length) && cf.touches[0].clientX, { left: gf, width: lf } = t.getBoundingClientRect(), Sf = af(u((ff - gf) / lf * 100));
      uf !== Sf && (uf = Sf, Xu(Sf));
    }
    Xu(e.value);
  }), e.on("input", ({ payload: sf }) => {
    Array.isArray(e.value) && Array.isArray(sf) ? e.value[0] === sf[0] && e.value[1] === sf[1] || Xu(sf, !1) : e.value !== sf && Xu(sf, !1), function() {
      if (e.props.isMulti && Array.isArray(e._value)) {
        const [pf, $f] = [...e._value];
        n && n.input(tf(pf)), r && r.input(tf($f));
      } else r && r.input(e._value);
    }();
  }), e.on("prop:max", () => {
    e.props.max = e.props.max ? parseFloat(`${e.props.max}`) : 100, Xu(e.value), c(e);
  }), e.on("prop:min", () => {
    e.props.min = e.props.min ? parseFloat(`${e.props.min}`) : 0, Xu(e.value), c(e);
  });
}] }, Nd = /* @__PURE__ */ Me("cp"), { outer: Kd, wrapper: Wd, inner: Ud, label: Yd, prefix: jd, suffix: zd, help: Zd, messages: Gd, message: qd, icon: Xd } = /* @__PURE__ */ Ve(Nd), Jd = Nd("swatchPreview", () => ({ $el: "div", attrs: { id: "$id", class: "$classes.swatchPreview", tabindex: { if: "$disabled", then: -1, else: 0 }, onClick: "$handlers.inputPreviewClick", onFocusout: "$handlers.inputPreviewFocusout", onKeydown: "$handlers.inputPreviewKeydown", role: "button", "aria-valuetext": '$: "Current color: " + $value' } })), Qd = Nd("valueString", () => ({ $el: "span", attrs: { class: "$classes.valueString" }, children: { if: '$format === "hex"', then: "$hex", else: { if: '$format === "rgba"', then: "$rgbaString", else: { if: '$format === "hsla"', then: "$hslaString", else: "" } } } })), ec = Nd("panel", () => ({ $el: "div", attrs: { id: '$: $id + "_popover"', class: "$classes.panel", onKeydown: "$handlers.panelKeydown", "aria-role": { if: "$layout === popover", then: "dialog" }, "aria-modal": { if: "$layout === popover", then: "true" }, "aria-label": "$label", popover: "$popover", style: { if: "$usePopover", then: { margin: 0, top: '$popoverCoordinates.y + "px"', left: '$popoverCoordinates.x + "px"' }, else: { position: { if: "$inline === undefined || $inline === false", then: "absolute" } } } } })), tc = Nd("panelClose", () => ({ $el: "button", attrs: { type: "button", class: "$classes.panelClose", onClick: "$handlers.closePanel", tabindex: { if: "$showPanelClose", then: -1, else: 0 }, onKeydown: "$handlers.panelCloseKeydown", "aria-label": "$ui.close.value" } })), oc = Nd("controlGroup", () => ({ $el: "div", attrs: { class: "$classes.controlGroup", "data-eye-dropper": "$hasNativeEyeDropper && $eyeDropper", role: "group" } })), nc = Nd("LS", () => ({ $el: "div", attrs: { class: "$classes.LS" } })), rc = Nd("canvasLS", () => ({ $el: "canvas", attrs: { id: '$: "canvas-ls-" + $id', class: '$classes.canvas + " " + $classes.canvasLS', width: 256, height: 256, "aria-hidden": "true" } })), sc = Nd("controlLS", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled", then: -1, else: 0 }, class: '$classes.control + " " + $classes.controlLS', onKeydown: "$handlers.lsKeydown", style: { left: '$controlLSPosition.x + "%"', top: '$controlLSPosition.y + "%"', backgroundColor: '$: "hsl(" + $hsla.h + "deg, " + ($hsla.s / 255) * 100 + "%, " + ($hsla.l / 255) * 100 + "%)"' }, role: "slider", "aria-valuemin": 0, "aria-valuemax": 1, "aria-valuetext": '$: "Lightness: " + $hslaPercent.l + "%, Saturation: " + $hslaPercent.s + "%"' } })), ac = Nd("hue", () => ({ $el: "div", attrs: { class: "$classes.hue" } })), lc = Nd("canvasHue", () => ({ $el: "canvas", attrs: { id: '$: "canvas-hue-" + $id', class: '$classes.canvas + " " + $classes.canvasHue', width: 256, height: 10, "aria-hidden": "true" } })), ic = Nd("controlHue", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled", then: -1, else: 0 }, onKeydown: "$handlers.hueControlKeydown", class: '$classes.control + " " + $classes.controlHue', style: { left: '$: "min(max(" + (($hsla.h / 360) * 100) + "%, 3px), calc(100% - 3px))"', backgroundColor: '$: "hsl(" + $hsla.h + "deg, 100%, 50%)"' }, role: "slider", "aria-valuemin": 0, "aria-valuemax": 360, "aria-valuenow": "$h" } })), pc = Nd("alpha", () => ({ $el: "div", attrs: { class: "$classes.alpha", style: { opacity: { if: "$alpha", then: "1", else: "0.5" }, cursor: { if: "$alpha", then: "", else: "not-allowed" }, filter: { if: "$alpha", then: "", else: "grayscale(1)" } } } })), dc = Nd("canvasAlpha", () => ({ $el: "canvas", attrs: { id: '$: "canvas-alpha-" + $id', class: '$classes.canvas + " " + $classes.canvasAlpha', width: 256, height: 10, "aria-hidden": "true", style: { pointerEvents: { if: "$alpha", then: "auto", else: "none" } } } })), cc = Nd("controlAlpha", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled || $alpha === undefined", then: -1, else: 0 }, onKeydown: "$handlers.alphaControlKeydown", class: '$classes.control + " " + $classes.controlAlpha', style: { left: '$: "min(max(" + ($hsla.a * 100) + "%, 3px), calc(100% - 3px))"', backgroundImage: '$: "linear-gradient(to right, hsla(" + $hsla.h + "deg, " + ($hsla.s / 255) * 100 + "%, " + ($hsla.l / 255) * 100 + "%, " + $hsla.a + "), hsla(" + $hsla.h + "deg, " + ($hsla.s / 255) * 100 + "%, " + ($hsla.l / 255) * 100 + "%, " + $hsla.a + ")), linear-gradient(to right, white, white)"', pointerEvents: { if: "$alpha", then: "auto", else: "none" } }, role: "slider", "aria-valuemin": 0, "aria-valuemax": 1, "aria-valuenow": "$hsla.a" } })), uc = Nd("preview", () => ({ $el: "div", attrs: { class: "$classes.preview" } })), fc = Nd("canvasPreview", () => ({ $el: "canvas", attrs: { id: '$: "canvas-preview-" + $id', class: '$classes.canvas + " " + $classes.canvasPreview', width: 33, height: 33, "aria-hidden": "true" } })), vc = Nd("canvasSwatchPreview", () => ({ $el: "div", attrs: { class: "$classes.canvasSwatchPreviewWrapper" }, children: [{ $el: "canvas", attrs: { id: '$: "canvas-swatch-preview-" + $id', class: '$classes.canvas + " " + $classes.canvasSwatchPreview', width: 33, height: 33, "aria-hidden": "true" } }] })), hc = Nd("eyeDropper", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled", then: -1, else: 0 }, role: "button", onKeydown: "$handlers.eyeDropperKeydown", id: '$: "eye-dropper-" + $id', class: "$classes.eyeDropper" } })), mc = Nd("formatField", () => ({ $el: "div", attrs: { class: "$classes.formatField" } })), gc = Nd("colorInputGroup", () => ({ $el: "div", attrs: { class: "$classes.colorInputGroup", "aria-role": "group" } })), $c = Nd("hexField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.hexFieldGroup' }, children: [{ $el: "input", attrs: { onInput: "$handlers.hexInput", onKeydown: "$handlers.hexKeydown", onFocus: "$handlers.hexFocus", onBlur: "$handlers.hexBlur", id: '$: "hex-" + $id', tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", class: '$classes.colorField + " " + $classes.hexField', value: "$hex", autocomplete: "off" } }, { $el: "label", children: "HEX", attrs: { for: '$: "hex-" + $id', class: "$classes.fieldLabel" } }] })), bc = Nd("rField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.rFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "r-" + $id', onInput: '$handlers.rangeLimitInput("rgba", 0, 255)', onKeydown: '$handlers.rangeLimitKeydown("rgba", 0, 255, 1)', type: "number", class: '$classes.colorField + " " + $classes.rField', min: 0, max: 255, step: 1, tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$rgba.r", autocomplete: "off" } }, { $el: "label", children: "R", attrs: { for: '$: "r-" + $id', class: "$classes.fieldLabel" } }] })), yc = Nd("gField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.gFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "g-" + $id', onInput: '$handlers.rangeLimitInput("rgba", 0, 255)', onKeydown: '$handlers.rangeLimitKeydown("rgba", 0, 255, 1)', type: "number", class: '$classes.colorField + " " + $classes.gField', min: 0, max: 255, step: 1, tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$rgba.g", autocomplete: "off" } }, { $el: "label", children: "G", attrs: { for: '$: "g-" + $id', class: "$classes.fieldLabel" } }] })), xc = Nd("bField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.bFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "b-" + $id', onInput: '$handlers.rangeLimitInput("rgba", 0, 255)', onKeydown: '$handlers.rangeLimitKeydown("rgba", 0, 255, 1)', type: "number", class: '$classes.colorField + " " + $classes.bField', min: 0, max: 255, step: 1, tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$rgba.b", autocomplete: "off" } }, { $el: "label", children: "B", attrs: { for: '$: "b-" + $id', class: "$classes.fieldLabel" } }] })), wc = Nd("aField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.aFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "a-" + $id', onInput: '$handlers.rangeLimitInput("alpha", 0, 1)', onKeydown: '$handlers.rangeLimitKeydown("alpha", 0, 1, 0.01)', type: "text", class: '$classes.colorField + " " + $classes.aField', value: "$rgba.a", tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled || $alpha === undefined", autocomplete: "off", style: { opacity: { if: "$alpha", then: "1", else: "0.33" }, cursor: { if: "$alpha", then: void 0, else: "not-allowed" } }, "aria-valuemin": 0, "aria-valuemax": 1, "aria-valuenow": "$rgba.a" } }, { $el: "label", children: "A", attrs: { for: '$: "a-" + $id', class: "$classes.fieldLabel", style: { opacity: { if: "$alpha", then: "1", else: "0.33" } } } }] })), _c = Nd("hField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.hFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "h-" + $id', onInput: '$handlers.rangeLimitInput("hsla", 0, 360)', onKeydown: '$handlers.rangeLimitKeydown("hsla", 0, 360, 1)', type: "text", class: '$classes.colorField + " " + $classes.hField', tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$hslaPercent.h", autocomplete: "off", "aria-valuemin": 0, "aria-valuemax": 360, "aria-valuenow": "$hsla.h" } }, { $el: "label", children: "H", attrs: { for: '$: "h-" + $id', class: "$classes.fieldLabel" } }] })), kc = Nd("sField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.sFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "s-" + $id', onInput: '$handlers.rangeLimitInput("hsla", 0, 100)', onKeydown: '$handlers.rangeLimitKeydown("hsla", 0, 100, 1)', type: "text", class: '$classes.colorField + " " + $classes.sField', tabindex: { if: "$disabled", then: -1, else: 0 }, value: "$hslaPercent.s", autocomplete: "off", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": "$hsla.s" } }, { $el: "label", children: "S", attrs: { for: '$: "s-" + $id', class: "$classes.fieldLabel" } }] })), Sc = Nd("lField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.lFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "l-" + $id', onInput: '$handlers.rangeLimitInput("hsla", 0, 100)', onKeydown: '$handlers.rangeLimitKeydown("hsla", 0, 100, 1)', type: "text", class: '$classes.colorField + " " + $classes.lField', tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$hslaPercent.l", autocomplete: "off", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": "$hsla.l" } }, { $el: "label", children: "L", attrs: { for: '$: "l-" + $id', class: "$classes.fieldLabel" } }] })), Lc = Nd("formatSwitcher", () => ({ $el: "div", attrs: { class: "$classes.formatSwitcher", onClick: "$handlers.toggleFormat", tabindex: { if: "$disabled", then: -1, else: 0 }, onKeydown: "$handlers.formatSwitcherKeydown", role: "button", "aria-label": "$ui.next.value" } })), Ic = Nd("swatches", () => ({ $el: "div", attrs: { id: '$: "swatches-" + $id', class: "$classes.swatches", "data-keyboard-nav": "$swatchIsUsingKeyboardNav" } })), Dc = Nd("swatch", () => ({ $el: "div", for: ["swatch", "index", "$options"], if: "$swatch", attrs: { if: "$swatch.group", then: { class: "$classes.swatchGroup" }, else: { class: "$classes.swatch", title: "$swatch.label" } }, children: { if: "$swatch.group", then: [{ $el: "span", attrs: { class: "$classes.swatchGroupLabel" }, children: "$swatch.group" }, { $el: "div", for: ["groupSwatch", "swatchIndex", "$swatch.options"], attrs: { class: "$classes.swatch", title: "$groupSwatch.label" }, children: [{ $el: "canvas", attrs: { class: "$classes.swatchCanvas", width: 21, height: 21, onClick: "$handlers.swatchClick", onKeydown: "$handlers.swatchKeydown", tabindex: { if: "$: ($focusedSwatch === $fns.anyToHsvaString($groupSwatch.value, 0))", then: { if: "$disabled", then: -1, else: 0 }, else: -1 }, key: '$groupSwatch.label + "-" + $groupSwatch.value', "data-color": "$fns.anyToHsvaString($groupSwatch.value, 0)", "data-color-precise": "$fns.anyToHsvaString($groupSwatch.value, 2)", "data-group": "$index", "data-label": "$swatch.label", role: "button", "aria-label": "$swatch.label" } }] }], else: { $el: "canvas", attrs: { class: "$classes.swatchCanvas", width: 21, height: 21, onClick: "$handlers.swatchClick", onKeydown: "$handlers.swatchKeydown", tabindex: { if: "$: ($focusedSwatch === $fns.anyToHsvaString($swatch.value, 0))", then: { if: "$disabled", then: -1, else: 0 }, else: -1 }, key: '$swatch.label + "-" + $swatch.value', "data-color": "$fns.anyToHsvaString($swatch.value, 0)", "data-color-precise": "$fns.anyToHsvaString($swatch.value, 2)", "data-group": 0, "data-label": "$swatch.label", role: "button", "aria-label": "$swatch.label" } } } })), Ac = /rgba?\((\d+%?)\s*(?:,?\s*|\s+)(\d+%?)\s*(?:,?\s*|\s+)(\d+%?)(?:\s*(?:,?\s*|\s+|\/\s*)(\d*(?:\.\d+)?%?))?\)/i, Cc = /^hsla?\((\d{1,3}deg|[\d.]+)\s*,?\s*([\d.]+%)\s*,?\s*([\d.]+%)(?:\s*,?\s*([\d.]+%?))?\)$/i;
function Tc(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
function Ec(e) {
  const [t, n, r, i] = function(s) {
    s = s.replace("#", ""), s.length === 3 && (s = s[0] + s[0] + s[1] + s[1] + s[2] + s[2]);
    const l = parseInt(s.slice(0, 2), 16), c = parseInt(s.slice(2, 4), 16), u = parseInt(s.slice(4, 6), 16), m = s.length >= 8 ? parseInt(s.slice(6, 8), 16) / 255 : 1;
    return function(qu, Gu, Qu, Xu = 1) {
      const ef = qu / 255, tf = Gu / 255, af = Qu / 255, rf = Math.max(ef, tf, af), hf = Math.min(ef, tf, af);
      let sf, pf = 0;
      const $f = (rf + hf) / 2;
      if (rf === hf) pf = sf = 0;
      else {
        const uf = rf - hf;
        switch (sf = $f > 0.5 ? uf / (2 - rf - hf) : uf / (rf + hf), rf) {
          case ef:
            pf = (tf - af) / uf + (tf < af ? 6 : 0);
            break;
          case tf:
            pf = (af - ef) / uf + 2;
            break;
          case af:
            pf = (ef - tf) / uf + 4;
        }
        pf *= 60;
      }
      return [pf, 255 * sf, 255 * $f, Xu];
    }(l, c, u, m);
  }(e);
  return [...Mc(t, n, r, i)];
}
function Oc(e, t, n, r = 1) {
  const i = t / 100, s = n / 100, l = (2 - i) * s / 2;
  return l !== 0 && (l === 1 || (t = l < 0.5 ? i * s / (2 * l) : i * s / (2 - 2 * l))), [e, Tc(255 * t, 2), Tc(255 * l, 2), r];
}
function Mc(e, t, n, r = 1) {
  const i = Tc(t / 255, 4), s = Tc(n / 255, 4);
  if (s === 1) return [e, 0, 100, r];
  const l = Tc(s + i * Math.min(s, 1 - s), 4);
  let c = t / 2.55;
  return l !== 0 && (c = s !== 1 && s !== 0 ? 2 * (l - s) / l * 100 : t / 2.55), [e, Tc(c, 2), Tc(100 * l, 2), r];
}
function Vc(e, t, n, r = 1) {
  const i = n / 100, s = i * (t / 100), l = s * (1 - Math.abs(e / 60 % 2 - 1)), c = i - s;
  let u = 0, m = 0, qu = 0;
  return [u, m, qu] = e < 60 ? [s, l, 0] : e < 120 ? [l, s, 0] : e < 180 ? [0, s, l] : e < 240 ? [0, l, s] : e < 300 ? [l, 0, s] : [s, 0, l], u = Math.round(255 * (u + c)), m = Math.round(255 * (m + c)), qu = Math.round(255 * (qu + c)), [Math.min(Math.max(u, 0), 255), Math.min(Math.max(m, 0), 255), Math.min(Math.max(qu, 0), 255), r];
}
function Fc(e, t, n, r = 1) {
  const i = e / 255, s = t / 255, l = n / 255, c = Math.max(i, s, l), u = Math.min(i, s, l);
  let m = 0;
  const qu = c, Gu = c - u, Qu = c === 0 ? 0 : Gu / c;
  if (c !== u) {
    switch (c) {
      case i:
        m = (s - l) / Gu + (s < l ? 6 : 0);
        break;
      case s:
        m = (l - i) / Gu + 2;
        break;
      case l:
        m = (i - s) / Gu + 4;
    }
    m /= 6;
  }
  return [360 * m, 100 * Qu, 100 * qu, r];
}
function Bc(e, t, n, r = 1) {
  const [i, s, l, c] = Vc(e, t, n, r);
  return function(u, m, qu, Gu = 1) {
    const Qu = (ef) => Math.round(ef).toString(16).padStart(2, "0").toUpperCase(), Xu = function(ef) {
      return Math.round(255 * ef).toString(16).padStart(2, "0").toUpperCase();
    }(Gu);
    return "#" + Qu(u) + Qu(m) + Qu(qu) + `${Xu === "FF" ? "" : Xu}`;
  }(i, s, l, c);
}
function Pc(e) {
  return /^(#?)([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(e);
}
function Hc(e) {
  if (e) {
    if (Pc(e)) return Ec(e);
    if (e.startsWith("rgb")) {
      const t = e.match(Ac);
      if (!t) return [0, 0, 0, 1];
      const n = (r) => r.endsWith("%") ? Math.round(2.55 * Number(r.slice(0, -1))) : Number(r);
      return Fc(n(t[1]), n(t[2]), n(t[3]), t[4] ? t[4].endsWith("%") ? Number(t[4].slice(0, -1)) / 100 : Number(t[4]) : 1);
    }
    if (e.startsWith("hsl")) {
      const t = e.match(Cc);
      if (!t) return [0, 0, 0, 1];
      const n = Number(t[1].replace("deg", "").trim()), r = Number(t[2].slice(0, -1)) / 100, i = Number(t[3].slice(0, -1)) / 100, s = t[4] ? t[4].endsWith("%") ? Number(t[4].slice(0, -1)) / 100 : Number(t[4]) : 1;
      return Mc(n, Tc(255 * r, 2), Tc(255 * i, 2), s);
    }
  }
}
function Rc(e) {
  const [t, n, r, i] = e.split("-").map((s) => Number(s));
  return [t, n, r, i];
}
function Nc(e, t = 150, n = !0) {
  let r = null, i = !0;
  return (...s) => {
    const l = () => {
      e(...s), r = null;
    };
    n && i && (i = !1, l()), r || (r = setTimeout(l, t));
  };
}
function Kc(e) {
  return e !== !1 && e !== "false";
}
function Wc(e) {
  return e.tabIndex >= 0 && !e.disabled && e.offsetParent !== null;
}
const Uc = { "canvas-ls": "LS", "canvas-hue": "Hue", "canvas-alpha": "Alpha" }, Yc = { schema: /* @__PURE__ */ Kd(/* @__PURE__ */ Wd(/* @__PURE__ */ Yd("$label"), /* @__PURE__ */ Be("$inline && $help", /* @__PURE__ */ Zd("$help")), /* @__PURE__ */ Ud(/* @__PURE__ */ Be("($inline === undefined || $inline === false) && $prefixIcon !== undefined", /* @__PURE__ */ Xd("prefix", "label")), /* @__PURE__ */ Be("$inline === undefined || $inline === false", /* @__PURE__ */ jd()), /* @__PURE__ */ Be("$inline === undefined || $inline === false", /* @__PURE__ */ Jd(/* @__PURE__ */ vc(), /* @__PURE__ */ Be("$showValue", /* @__PURE__ */ Qd()))), /* @__PURE__ */ Be("$inline || $expanded)", /* @__PURE__ */ ec(/* @__PURE__ */ Be("$showPanelClose && ($inline === undefined || $inline === false)", /* @__PURE__ */ tc(/* @__PURE__ */ Xd("close"))), /* @__PURE__ */ Be("$panelControls", /* @__PURE__ */ oc(/* @__PURE__ */ nc(/* @__PURE__ */ rc(), /* @__PURE__ */ sc()), /* @__PURE__ */ uc(/* @__PURE__ */ fc()), /* @__PURE__ */ ac(/* @__PURE__ */ lc(), /* @__PURE__ */ ic()), /* @__PURE__ */ pc(/* @__PURE__ */ dc(), /* @__PURE__ */ cc()), /* @__PURE__ */ Be("$eyeDropper && $hasNativeEyeDropper", /* @__PURE__ */ hc(/* @__PURE__ */ Xd("eyeDropper"))))), /* @__PURE__ */ Be("$panelFormat", /* @__PURE__ */ mc(/* @__PURE__ */ gc(/* @__PURE__ */ Be('$panelActiveFormat === "hex"', /* @__PURE__ */ $c()), /* @__PURE__ */ Be('$panelActiveFormat === "rgba"', /* @__PURE__ */ bc()), /* @__PURE__ */ Be('$panelActiveFormat === "rgba"', /* @__PURE__ */ yc()), /* @__PURE__ */ Be('$panelActiveFormat === "rgba"', /* @__PURE__ */ xc()), /* @__PURE__ */ Be('$panelActiveFormat === "hsla"', /* @__PURE__ */ _c()), /* @__PURE__ */ Be('$panelActiveFormat === "hsla"', /* @__PURE__ */ kc()), /* @__PURE__ */ Be('$panelActiveFormat === "hsla"', /* @__PURE__ */ Sc()), /* @__PURE__ */ Be('$panelActiveFormat === "rgba" || $panelActiveFormat === "hsla"', /* @__PURE__ */ wc())), /* @__PURE__ */ Lc(/* @__PURE__ */ Xd("switch")))), /* @__PURE__ */ Be("$options", /* @__PURE__ */ Ic(/* @__PURE__ */ Dc())))), /* @__PURE__ */ Be("$inline === undefined || $inline === false", /* @__PURE__ */ zd()), /* @__PURE__ */ Be("($inline === undefined || $inline === false) && $suffixIcon !== undefined", /* @__PURE__ */ Xd("suffix"))), /* @__PURE__ */ Be("$: ($inline === undefined || $inline === false) && $help", /* @__PURE__ */ Zd("$help"))), /* @__PURE__ */ Gd(/* @__PURE__ */ qd("$message.value"))), type: "input", family: "text", props: ["disbaled", "format", "valueFormat", "alpha", "panelControls", "panelFormat", "eyeDropper", "inline", "options", "showValue", "closeOnSelect", "allowPaste"], features: [
  function(e) {
    let t, n = null, r = null, i = null, s = null, l = null, c = null, u = null, m = 0;
    const qu = ["hex", "rgba", "hsla"], Gu = Nc(function() {
      if (!r) return;
      const Ef = r.getContext("2d");
      if (!Ef) return;
      const { width: Pf, height: _f } = r, Cf = e.props.h || 0;
      Ef.fillStyle = `hsl(${Cf}, 100%, 50%)`, Ef.fillRect(0, 0, Pf, _f);
      const kf = Ef.createLinearGradient(0, 0, Pf, 0);
      kf.addColorStop(0, "rgba(255, 255, 255, 1)"), kf.addColorStop(1, "rgba(255, 255, 255, 0)"), Ef.fillStyle = kf, Ef.fillRect(0, 0, Pf, _f);
      const If = Ef.createLinearGradient(0, 0, 0, _f);
      If.addColorStop(0, "rgba(0,0,0,0)"), If.addColorStop(1, "rgba(0,0,0,1)"), Ef.fillStyle = If, Ef.fillRect(0, 0, Pf, _f);
    }, 2), Qu = Nc(function() {
      if (!s) return;
      const Ef = s.getContext("2d");
      if (!Ef) return;
      const Pf = Math.round(s.width), _f = Math.round(s.height);
      Ef.clearRect(0, 0, Pf, _f), Bf(s, _f / 2);
      const Cf = e.props.rgba.r || 0, kf = e.props.rgba.g || 0, If = e.props.rgba.b || 0, Of = Ef.createLinearGradient(0, 0, Pf, 0);
      Of.addColorStop(0, `rgba(${Cf}, ${kf}, ${If}, 0)`), Of.addColorStop(1, `rgba(${Cf}, ${kf}, ${If}, 1)`), Ef.fillStyle = Of, Ef.fillRect(0, 0, Pf, _f);
    }, 2), Xu = Nc(gf, 2), ef = Nc(lf, 2), tf = Nc(Wf, 2), af = Nc(ih, 10, !1);
    function rf(Ef) {
      var Pf, _f;
      if (!e.context || !e.props.allowPaste || e.props.disabled) return;
      const Cf = (Pf = e.props.__root) === null || Pf === void 0 ? void 0 : Pf.activeElement;
      if (n && n.contains(Cf)) {
        const kf = (_f = Ef.clipboardData) === null || _f === void 0 ? void 0 : _f.getData("text");
        if (!kf || Cf.tagName === "INPUT" && !Pc(kf) && !Ac.test(kf) && !Cc.test(kf)) return;
        (Pc(kf) || kf.startsWith("hsl") || kf.startsWith("rgb")) && (e.props.hexInputFocused && (e.props.hexInputFocused = !1, setTimeout(() => {
          e.props.hexInputFocused = !0;
        }, 10)), Ef.preventDefault(), hf(kf));
      }
    }
    function hf(Ef) {
      var Pf;
      if (!Ef) return;
      const _f = Hc(Ef);
      if (_f) {
        const [Cf, kf, If, Of] = _f;
        Ef !== "undefined" && (typeof Cf != "number" || isNaN(Cf) || typeof kf != "number" || isNaN(kf) || typeof If != "number" || isNaN(If) || typeof Of != "number" || isNaN(Of) || Tc(Cf, 2) === e.props.h && Tc(kf, 2) === e.props.s && Tc(If, 2) === e.props.v && Tc(Of, 2) === e.props.a) || (e.props.alpha && (e.props.a = Tc(Of, 2)), Wf(Cf, kf, If));
      } else {
        const Cf = (Pf = e.props.options) === null || Pf === void 0 ? void 0 : Pf.find((kf) => {
          var If;
          return ((If = kf.label) === null || If === void 0 ? void 0 : If.toLowerCase()) === Ef.toLowerCase();
        });
        if (Cf && Cf.value) {
          const kf = Hc(Cf.value);
          if (kf) {
            const [If, Of, Hf, Ff] = kf;
            e.props.alpha && (e.props.a = Tc(Ff, 2)), Wf(If, Of, Hf);
          } else Wf(e.props.h, e.props.s, e.props.v);
        } else Wf(e.props.h, e.props.s, e.props.v);
      }
    }
    function sf(Ef) {
      if (!e.context || !u) return;
      const Pf = u[Ef];
      Pf && (e.props.focusedSwatch = Pf.dataset.color);
    }
    function pf(Ef, Pf) {
      new ResizeObserver(() => {
        const _f = Ef.getBoundingClientRect();
        Ef.width = Math.round(_f.width), Ef.height = Math.round(_f.height), Pf(Ef);
      }).observe(Ef);
    }
    function $f() {
      e.context && e.props.eyeDropper && (e.context.hasNativeEyeDropper = !(typeof window > "u" || !window.EyeDropper), whenAvailable(`eye-dropper-${e.props.id}`, () => {
        var Ef;
        const Pf = new window.EyeDropper(), _f = (Ef = e.props.__root) === null || Ef === void 0 ? void 0 : Ef.getElementById(`eye-dropper-${e.props.id}`);
        _f == null || _f.addEventListener("click", async () => {
          const Cf = await Pf.open();
          if (!Cf.sRGBHex) return;
          const [kf, If, Of] = Ec(Cf.sRGBHex);
          e.props.alpha && (e.props.a = 1), Wf(kf, If, Of);
        });
      }, e.props.__root));
    }
    function uf() {
      vf("canvas-ls", (Ef) => {
        r = Ef;
      }, Gu, Uf), vf("canvas-hue", (Ef) => {
        i = Ef;
      }, ff, Zf), vf("canvas-alpha", (Ef) => {
        s = Ef;
      }, Qu, Rf), cf(`canvas-preview-${e.props.id}`, (Ef) => {
        l = Ef, gf();
      }, Xu), cf(`canvas-swatch-preview-${e.props.id}`, (Ef) => {
        c = Ef, lf();
      }, ef), yf();
    }
    function vf(Ef, Pf, _f, Cf) {
      let kf = !1;
      const If = () => {
        document.removeEventListener("mousemove", Of), document.removeEventListener("mouseup", Ff), document.removeEventListener("touchmove", Hf), document.removeEventListener("touchend", zf);
      }, Of = (Qf) => {
        Qf.buttons === 1 && t && Cf(Qf);
      }, Hf = (Qf) => {
        t && Cf(Qf);
      }, Ff = () => {
        t = void 0, If();
      }, zf = () => {
        t = void 0, If();
      };
      cf(`${Ef}-${e.props.id}`, (Qf) => {
        const qf = Qf.nextElementSibling;
        Pf(Qf), _f(), function(jf, Sh) {
          const $h = (Ch) => {
            jf && (Ch.preventDefault(), Sh(Ch));
          };
          jf == null || jf.addEventListener("mousedown", $h), jf == null || jf.addEventListener("touchstart", $h);
        }(Qf, Cf), kf || function(jf, Sh) {
          kf = !0, jf.addEventListener("blur", () => {
            jf.removeAttribute("data-prevent-focus-style");
          }), Sh.addEventListener("touchend", () => {
            jf.removeAttribute("data-prevent-focus-style"), jf.blur();
          }), jf.addEventListener("keydown", ($h) => {
            ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes($h.key) && jf.removeAttribute("data-prevent-focus-style");
          });
        }(qf, Qf), Qf.addEventListener("mousedown", (jf) => {
          qf.focus(), qf.setAttribute("data-prevent-focus-style", "true"), t = Uc[Ef], Cf(jf), document.addEventListener("mousemove", Of), document.addEventListener("mouseup", Ff);
        }), Qf.addEventListener("touchstart", () => {
          qf.setAttribute("data-prevent-focus-style", "true"), qf.focus(), t = Uc[Ef], document.addEventListener("touchmove", Hf), document.addEventListener("touchend", zf);
        });
      }, _f);
    }
    function cf(Ef, Pf, _f) {
      whenAvailable(Ef, () => {
        var Cf;
        const kf = (Cf = e.props.__root) === null || Cf === void 0 ? void 0 : Cf.getElementById(Ef);
        kf && (Pf(kf), _f && pf(kf, _f));
      }, e.props.__root);
    }
    function yf() {
      whenAvailable(`swatches-${e.props.id}`, () => {
        var Ef, Pf, _f;
        u = Array.from(((Ef = e.props.__root) === null || Ef === void 0 ? void 0 : Ef.querySelectorAll(`#swatches-${e.props.id} canvas`)) || []), u.forEach((Cf) => {
          pf(Cf, Sf);
        }), e.props.focusedSwatch = (_f = (Pf = u[0]) === null || Pf === void 0 ? void 0 : Pf.dataset) === null || _f === void 0 ? void 0 : _f.color, ih();
      }, e.props.__root);
    }
    function ff() {
      if (!i) return;
      const Ef = i.getContext("2d");
      if (!Ef) return;
      const Pf = i.width, _f = i.height;
      for (let Cf = 0; Cf < Pf; Cf++) {
        const kf = Math.floor(Cf / Pf * 360);
        Ef.fillStyle = `hsl(${kf}, 100%, 50%)`, Ef.fillRect(Cf, 0, 1, _f);
      }
    }
    function gf() {
      if (!l) return;
      const Ef = l.getContext("2d");
      if (!Ef) return;
      Bf(l, l.width / 3);
      const { r: Pf, g: _f, b: Cf, a: kf } = e.props.rgba;
      Ef.fillStyle = `rgba(${Pf}, ${_f}, ${Cf}, ${kf})`, Ef.fillRect(0, 0, l.width, l.height);
    }
    function lf() {
      if (!c) return;
      const Ef = c.getContext("2d");
      if (!Ef) return;
      Bf(c, c.height / 2);
      const { r: Pf, g: _f, b: Cf, a: kf } = e.props.rgba;
      Ef.fillStyle = `rgba(${Pf}, ${_f}, ${Cf}, ${kf})`, Ef.fillRect(0, 0, c.width, c.height);
    }
    function Sf(Ef) {
      if (!Ef) return;
      const Pf = Ef.getContext("2d");
      if (!Pf) return;
      Bf(Ef, Ef.width / 2);
      const _f = Ef.dataset.colorPrecise;
      if (!_f) return;
      const [Cf, kf, If, Of] = Rc(_f), [Hf, Ff, zf, Qf] = Oc(Cf, kf, If, Of);
      Pf.fillStyle = `hsla(${Hf}, ${Ff / 255 * 100}%, ${zf / 255 * 100}%, ${Qf})`, Pf.fillRect(0, 0, Math.round(Ef.width), Math.round(Ef.height));
    }
    function Mf(Ef, Pf, _f) {
      let Cf = null;
      const kf = (zf) => {
        Cf !== null && cancelAnimationFrame(Cf), Cf = requestAnimationFrame(() => {
          if (!Pf) return;
          const Qf = Pf.getBoundingClientRect();
          let qf, jf;
          "touches" in zf ? (qf = zf.touches[0].clientX - Qf.left, jf = zf.touches[0].clientY - Qf.top) : (qf = zf.clientX - Qf.left, jf = zf.clientY - Qf.top), qf = Math.min(Math.max(qf, 0), Qf.width), jf = Math.min(Math.max(jf, 0), Qf.height), _f(qf, jf);
        });
      };
      kf(Ef);
      const If = (zf) => {
        zf.preventDefault(), kf(zf);
      }, Of = (zf) => {
        zf.preventDefault(), kf(zf);
      }, Hf = () => {
        t = void 0, document.removeEventListener("mousemove", If), document.removeEventListener("mouseup", Hf);
      }, Ff = () => {
        t = void 0, document.removeEventListener("touchmove", Of), document.removeEventListener("touchend", Ff);
      };
      "touches" in Ef ? (document.addEventListener("touchmove", Of), document.addEventListener("touchend", Ff)) : (document.addEventListener("mousemove", If), document.addEventListener("mouseup", Hf));
    }
    function Uf(Ef) {
      Mf(Ef, r, (Pf, _f) => {
        const Cf = Pf / r.width * 100, kf = 100 - _f / r.height * 100;
        tf(e.props.hue, Cf, kf);
      });
    }
    function Zf(Ef) {
      Mf(Ef, i, (Pf, _f) => {
        if (!i) return;
        const Cf = i.width, kf = Math.floor(Pf / Cf * 360);
        e.props.h = kf, tf(e.props.h, e.props.s, e.props.v);
      });
    }
    function Rf(Ef) {
      e.props.alpha && Mf(Ef, s, (Pf, _f) => {
        const Cf = Pf / s.width * 100 / 100;
        e.props.a = Cf, tf(e.props.hue, e.props.s, e.props.v);
      });
    }
    function Bf(Ef, Pf) {
      const _f = Ef.getContext("2d");
      if (!_f) return;
      const Cf = Math.ceil(Ef.height / Pf), kf = Math.ceil(Ef.width / Pf);
      for (let If = 0; If < Cf; If++) for (let Of = 0; Of < kf; Of++) _f.fillStyle = (If + Of) % 2 == 1 ? "#FFFFFF" : "#CCCCCC", _f.fillRect(Of * Pf, If * Pf, Pf, Pf);
    }
    function ih() {
      var Ef, Pf;
      if (!e.context || !e.props.options || !u) return;
      const { h: _f, s: Cf, v: kf, a: If } = e.props, Of = function(zf, Qf, qf, jf = 1) {
        const Sh = qf === 0 ? 0 : Qf;
        return `${Tc(qf === 0 || qf === 100 && Qf === 0 ? 0 : zf, 0)}-${Tc(Sh, 0)}-${Tc(qf, 0)}-${Tc(jf, 2)}`;
      }(_f, Cf, kf, If);
      let Hf = !1, Ff = !1;
      u.forEach((zf) => {
        const Qf = zf.dataset.color;
        if (!Qf) return;
        const [qf, jf, Sh, $h] = Qf.split("-");
        Sh === "0" && kf === 0 && $h === `${If}` && (Ff = !0);
        const Ch = zf.parentElement;
        Ff || Qf === Of ? (Ch.dataset.active = "true", zf.ariaSelected = "true", Ff = !1, !Hf && u && (sf(u.indexOf(zf)), Hf = !0)) : (delete Ch.dataset.active, zf.ariaSelected = "false");
      }), Hf || (e.props.focusedSwatch = (Pf = (Ef = u[0]) === null || Ef === void 0 ? void 0 : Ef.dataset) === null || Pf === void 0 ? void 0 : Pf.color);
    }
    function lh(Ef) {
      Ef = Ef.replace("#", ""), e.props.hexInputFocused || Ef.length !== 3 || (Ef = Ef[0] + Ef[0] + Ef[1] + Ef[1] + Ef[2] + Ef[2]), Ef = `#${Ef = Ef.toUpperCase()}`, e.props.hex = Ef.slice(0, 9);
    }
    function Wf(Ef, Pf, _f, Cf = !1) {
      e.props.h = Ef === void 0 || isNaN(Ef) ? e.props.h : Tc(Math.max(Math.min(Ef, 360), 0), 2), e.props.s = Pf === void 0 || isNaN(Pf) ? e.props.s : Tc(Math.max(Math.min(Pf, 100), 0), 2), e.props.v = _f === void 0 || isNaN(_f) ? e.props.v : Tc(Math.max(Math.min(_f, 100), 0), 2);
      const { h: kf, s: If, v: Of, a: Hf } = e.props, [Ff, zf, Qf] = Oc(kf, If, Of), [qf, jf, Sh] = Vc(kf, If, Of), $h = e.props.hexInputFocused ? e.props.hex : Bc(kf, If, Of, Hf), Ch = Tc(Hf, 2);
      e.props.hsla = { h: kf, s: zf, l: Qf, a: Ch }, e.props.hslaPercent = { h: Tc(kf, 0), s: Of === 100 && If === 0 ? 0 : Tc(Of === 0 ? zf / 255 : Math.max(Math.min(zf / 255 * 100, 100), 0), 0), l: Tc(Math.max(Math.min(e.props.hsla.l / 255 * 100, 100), 0), 0), a: Ch }, e.props.hslaString = `hsla(${e.props.hslaPercent.h}, ${e.props.hslaPercent.s}%, ${e.props.hslaPercent.l}%, ${Ch})`, e.props.hslaStringPrecise = `hsla(${kf}, ${Tc(Of === 0 ? zf / 255 : zf / 255 * 100, 2)}%, ${Tc(Qf / 255 * 100, 2)}%, ${Ch})`, e.props.rgba = { r: qf, g: jf, b: Sh, a: Ch }, e.props.rgbaString = `rgba(${qf}, ${jf}, ${Sh}, ${Ch})`, lh($h), setTimeout(() => {
        var Ah;
        vh(), function() {
          const bh = e.props.s, Yh = 100 - e.props.v;
          e.props.controlLSPosition = { x: bh, y: Yh };
        }(), af(), n || typeof window > "u" || (n = (Ah = e.props.__root) === null || Ah === void 0 ? void 0 : Ah.querySelector(`[data-id="${e.props.id}"]`));
      }, 0);
      const wh = e.props.valueFormat ? e.props.valueFormat : e.props.format;
      Cf || (wh === "hex" ? e.input(e.props.hex) : wh === "rgba" ? e.input(e.props.rgbaString) : wh === "hsla" && e.input(e.props.hslaStringPrecise));
    }
    function vh() {
      Gu(), Qu(), Xu(), ef();
    }
    e.addProps(["expanded", "h", "s", "v", "a", "hsla", "hslaPercent", "hslaString", "hslaStringPrecise", "rgba", "rgbaString", "hex", "controlLSPosition", "panelActiveFormat", "hexInputFocused", "hasNativeEyeDropper", "focusedSwatch", "swatchIsUsingKeyboardNav", "showPanelClose"]), e.props.h = e.props.h || void 0, e.props.s = e.props.s || void 0, e.props.v = e.props.v || void 0, e.props.a = e.props.a || 1, e.props.controlLSPosition = e.props.controlLSPosition || { x: 0, y: 0 }, e.props.switchIcon = e.props.switchIcon || '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M34.2 179.7L154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 179.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2zm-22-23.3C4.4 163.8 0 174.1 0 184.9C0 206.5 17.5 224 39.1 224H280.9c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.4L187.6 42.9C180.1 35.9 170.2 32 160 32s-20.1 3.9-27.6 10.9L12.3 156.4zm22 175.9c-1.4-1.3-2.2-3.2-2.2-5.2c0-3.9 3.2-7.1 7.1-7.1H280.9c3.9 0 7.1 3.2 7.1 7.1c0 2-.8 3.8-2.2 5.2L165.6 445.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 332.3zm-22 23.3L132.4 469.1c7.4 7 17.4 10.9 27.6 10.9s20.1-3.9 27.6-10.9L307.7 355.6c7.8-7.4 12.3-17.7 12.3-28.5c0-21.6-17.5-39.1-39.1-39.1H39.1C17.5 288 0 305.5 0 327.1c0 10.8 4.4 21.1 12.3 28.5z"/></svg>', e.props.hexInputFocused = !1, e.props.swatchIsUsingKeyboardNav = !1, e.on("destroying", () => {
      e.context && typeof document < "u" && document.removeEventListener("paste", rf);
    }), e.on("created", () => {
      var Ef, Pf;
      e.context && (typeof window < "u" && document.addEventListener("paste", rf), e.props.expanded = !1, e.props.panelActiveFormat = e.props.format || qu[0], e.props.panelControls = Kc(e.props.panelControls), e.props.eyeDropper = Kc(e.props.eyeDropper), e.props.panelFormat = Kc(e.props.panelFormat), e.props.showValue = Kc(e.props.showValue), e.props.allowPaste = Kc(e.props.allowPaste), e.props.inline = undefine(e.props.inline), e.props.disabled = undefine(e.props.disabled), e.props.format = e.props.format || "hex", e.props.alpha = undefine((Pf = (Ef = e.props) === null || Ef === void 0 ? void 0 : Ef.alpha) === null || Pf === void 0 || Pf), e.props.valueFormat = e.props.valueFormat || e.props.format, e.props.closeOnSelect = undefine(e.props.closeOnSelect), e.props.focusedSwatch = void 0, e.value === void 0 || e.value === "" || e.value === null ? (e.props.rgba = { r: 0, g: 0, b: 0 }, Wf(0, 0, 0, !0)) : hf(`${e.value}`), e.on("input", ({ payload: _f }) => {
        n && e.props.__root !== void 0 && !n.contains(e.props.__root.activeElement) && hf(_f);
      }), setTimeout(() => {
        $f();
      }, 5), uf(), e.on("prop:expanded", () => {
        var _f;
        e.props.expanded ? ($f(), uf(), yf(), document.addEventListener("keydown", Cf), window.innerWidth <= 430 && !window.matchMedia("(hover: hover)").matches ? e.props.showPanelClose = !0 : e.props.showPanelClose = !1, setTimeout(() => {
          var kf;
          const If = (kf = e.props.__root) === null || kf === void 0 ? void 0 : kf.querySelector(`[data-id="${e.props.id}"] *:not(.formkit-swatch-preview)[tabindex="0"]`);
          If && If.focus();
        }, 0)) : (document.removeEventListener("keydown", Cf), ((_f = e.props.__root) === null || _f === void 0 ? void 0 : _f.querySelector(`[data-id="${e.props.id}"] *[tabindex="0"]`)).focus());
        function Cf(kf) {
          kf.key === "Escape" && (kf.preventDefault(), e.props.expanded = !1);
        }
      }), e.context.fns.anyToHsvaString = (_f, Cf) => {
        const kf = Hc(_f);
        if (!kf) return "0-0-0-1";
        let [If, Of, Hf, Ff] = kf;
        return Cf === 0 && (If = Hf === 0 || Hf === 100 && Of === 0 ? 0 : If), `${Tc(If, Cf)}-${Tc(Of, Cf)}-${Tc(Hf, Cf)}-${Tc(Ff, 2)}`;
      }, e.context.handlers.inputPreviewClick = (_f) => {
        e.props.expanded = !e.props.expanded;
      }, e.context.handlers.inputPreviewFocusout = (_f) => {
        var Cf, kf, If;
        const Of = (Cf = e.props.__root) === null || Cf === void 0 ? void 0 : Cf.querySelector(`[data-id="${e.props.id}"] .formkit-inner`), Hf = _f.relatedTarget;
        if (Of.contains(Hf)) {
          let Ff = function(zf) {
            var Qf, qf;
            Of.contains(zf.target) || (e.props.expanded = !1, (Qf = e.props.__root) === null || Qf === void 0 || Qf.removeEventListener("mousedown", Ff), (qf = e.props.__root) === null || qf === void 0 || qf.removeEventListener("touchstart", Ff));
          };
          (kf = e.props.__root) === null || kf === void 0 || kf.addEventListener("mousedown", Ff), (If = e.props.__root) === null || If === void 0 || If.addEventListener("touchstart", Ff);
        } else e.props.expanded = !1;
      }, e.context.handlers.inputPreviewKeydown = (_f) => {
        _f.key === "Escape" && (_f.preventDefault(), e.props.expanded = !1), _f.key !== "Enter" && _f.key !== " " || (_f.preventDefault(), e.props.expanded = !e.props.expanded);
      }, e.context.handlers.closePanel = () => {
        e.props.expanded = !1;
      }, e.context.handlers.panelCloseKeydown = (_f) => {
        _f.key !== "Enter" && _f.key !== " " || (_f.preventDefault(), e.props.expanded = !1);
      }, e.context.handlers.toggleFormat = (_f = 1) => {
        _f = typeof _f == "number" ? _f : 1;
        const Cf = (qu.indexOf(e.props.panelActiveFormat) + _f + qu.length) % qu.length;
        e.props.panelActiveFormat = qu[Cf];
      }, e.context.handlers.panelKeydown = (_f) => {
        var Cf, kf, If;
        if (_f.key === "Tab" && e.props.expanded) {
          _f.preventDefault();
          const Of = Array.from(((Cf = e.props.__root) === null || Cf === void 0 ? void 0 : Cf.querySelectorAll(`[data-id="${e.props.id}"] *:not(.formkit-swatch-preview)[tabindex="0"]`)) || []).filter(Wc), Hf = Of.indexOf(!((kf = e.props.__root) === null || kf === void 0) && kf.activeElement ? (If = e.props.__root) === null || If === void 0 ? void 0 : If.activeElement : e.props.__root);
          let Ff;
          Ff = _f.shiftKey ? (Hf - 1 + Of.length) % Of.length : (Hf + 1) % Of.length, Of[Ff].focus();
        }
      }, e.context.handlers.lsKeydown = (_f) => {
        if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(_f.key)) {
          _f.preventDefault();
          const { h: Cf, s: kf, v: If } = e.props, Of = _f.shiftKey ? 10 : 1;
          switch (_f.key) {
            case "ArrowLeft":
              Wf(Cf, kf - Of, If);
              break;
            case "ArrowRight":
              Wf(Cf, kf + Of, If);
              break;
            case "ArrowUp":
              Wf(Cf, kf, If + Of);
              break;
            case "ArrowDown":
              Wf(Cf, kf, If - Of);
              break;
            case "PageUp":
              Wf(Cf, kf, If + 10);
              break;
            case "PageDown":
              Wf(Cf, kf, If - 10);
              break;
            case "Home":
              Wf(Cf, kf - 10, If);
              break;
            case "End":
              Wf(Cf, kf + 10, If);
          }
          vh();
        }
      }, e.context.handlers.hueControlKeydown = (_f) => {
        if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(_f.key)) {
          _f.preventDefault();
          const { h: Cf, s: kf, v: If } = e.props, Of = _f.shiftKey ? 10 : 1;
          switch (_f.key) {
            case "ArrowLeft":
            case "ArrowDown":
              Wf(Cf - Of, kf, If);
              break;
            case "ArrowRight":
            case "ArrowUp":
              Wf(Cf + Of, kf, If);
              break;
            case "PageUp":
              Wf(Cf + 10, kf, If);
              break;
            case "PageDown":
              Wf(Cf - 10, kf, If);
              break;
            case "Home":
              Wf(0, kf, If);
              break;
            case "End":
              Wf(360, kf, If);
          }
          vh();
        }
      }, e.context.handlers.alphaControlKeydown = (_f) => {
        if (e.props.alpha && ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(_f.key)) {
          _f.preventDefault();
          const { h: Cf, s: kf, v: If, a: Of } = e.props, Hf = _f.shiftKey ? 0.1 : 0.01;
          switch (_f.key) {
            case "ArrowLeft":
            case "ArrowDown":
              e.props.a = Tc(Math.min(Math.max(Of - Hf, 0), 1), 2);
              break;
            case "ArrowRight":
            case "ArrowUp":
              e.props.a = Tc(Math.min(Math.max(Of + Hf, 0), 1), 2);
              break;
            case "PageUp":
              e.props.a = Tc(Math.min(Math.max(Of + 0.1, 0), 1), 2);
              break;
            case "PageDown":
              e.props.a = Tc(Math.min(Math.max(Of - 0.1, 0), 1), 2);
              break;
            case "Home":
              e.props.a = 0;
              break;
            case "End":
              e.props.a = 1;
          }
          Wf(Cf, kf, If);
        }
      }, e.context.handlers.eyeDropperKeydown = (_f) => {
        var Cf;
        if (_f.key === "Enter" || _f.key === " ") {
          _f.preventDefault();
          const kf = (Cf = e.props.__root) === null || Cf === void 0 ? void 0 : Cf.getElementById(`eye-dropper-${e.props.id}`);
          kf == null || kf.click();
        }
      }, e.context.handlers.formatSwitcherKeydown = (_f) => {
        e.context && (_f.key !== "Enter" && _f.key !== " " && _f.key !== "ArrowDown" || (_f.preventDefault(), e.context.handlers.toggleFormat()), _f.key === "ArrowUp" && (_f.preventDefault(), e.context.handlers.toggleFormat(-1)));
      }, e.context.handlers.hexInput = (_f) => {
        const Cf = _f.target, kf = Cf.value.startsWith("#") ? 9 : 8, If = Cf.value.slice(0, kf);
        if (Cf.value = e.props.alpha ? If : If.slice(0, 7), Pc(If)) {
          const [Of, Hf, Ff, zf] = Ec(If);
          e.props.alpha && (e.props.a = zf), lh(If), Wf(Of, Hf, Ff);
        }
      }, e.context.handlers.hexKeydown = (_f) => {
        const Cf = _f.target, kf = Cf.value;
        let If = "";
        if (!Pc(kf)) return;
        const Of = kf.startsWith("#") ? kf.slice(1) : kf, Hf = Of.length === 8, Ff = Hf ? Of.substring(0, 6) : Of, zf = Hf ? Of.substring(6, 8) : "", Qf = _f.shiftKey ? 10 : 1, qf = 16777215;
        let jf;
        if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(_f.key)) switch (_f.preventDefault(), _f.key) {
          case "ArrowUp":
            jf = (parseInt(Ff, 16) + Qf) % 16777216;
            break;
          case "ArrowDown":
            jf = (parseInt(Ff, 16) - Qf + qf + 1) % 16777216;
            break;
          case "PageUp":
            jf = (parseInt(Ff, 16) + 10) % 16777216;
            break;
          case "PageDown":
            jf = (parseInt(Ff, 16) - 10 + qf + 1) % 16777216;
            break;
          case "Home":
            jf = 0;
            break;
          case "End":
            jf = qf;
        }
        jf !== void 0 && (If = jf.toString(16).padStart(6, "0").toUpperCase()), If && (Cf.value = Hf ? `#${If}${zf}` : `#${If}`), e.context && e.context.handlers.hexInput(_f);
      }, e.context.handlers.hexFocus = () => {
        e.context && (e.props.hexInputFocused = !0);
      }, e.context.handlers.hexBlur = (_f) => {
        if (!e.context) return;
        e.props.hexInputFocused = !1;
        const Cf = _f.target.value;
        Pc(Cf) && lh(Cf);
      }, e.context.handlers.rangeLimitInput = (_f, Cf, kf, If) => (Of) => {
        const Hf = If || Of;
        if (!Hf || !e.context) return;
        const Ff = Hf.target;
        if (Ff.value.endsWith(".")) return;
        const zf = Math.max(Math.min(Number(Ff.value), kf), Cf);
        Ff.value = `${zf}`;
        const Qf = Ff.id;
        if (_f === "hsla") {
          switch (Qf) {
            case `h-${e.props.id}`:
              e.props.h = zf;
              break;
            case `s-${e.props.id}`:
              e.props.hslaPercent.s = zf;
              break;
            case `l-${e.props.id}`:
              e.props.hslaPercent.l = zf;
          }
          const [qf, jf, Sh] = Mc(e.props.h, 2.55 * e.props.hslaPercent.s, 2.55 * e.props.hslaPercent.l);
          Wf(qf, jf, Sh);
        } else if (_f === "rgba") {
          switch (Qf) {
            case `r-${e.props.id}`:
              e.props.rgba.r = zf;
              break;
            case `g-${e.props.id}`:
              e.props.rgba.g = zf;
              break;
            case `b-${e.props.id}`:
              e.props.rgba.b = zf;
          }
          const [qf, jf, Sh] = Fc(e.props.rgba.r, e.props.rgba.g, e.props.rgba.b);
          Wf(qf, jf, Sh);
        } else _f == "alpha" && e.props.alpha && (e.props.a = zf, Wf());
      }, e.context.handlers.rangeLimitKeydown = (_f, Cf, kf, If) => (Of) => {
        if (e.context)
          if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", "Backspace", "Tab", "Enter"].includes(Of.key) || Of.metaKey || !/[a-zA-Z!@#$%^&*()_+={}\[\]:;"'<,>?\/|\\`~]/g.test(Of.key)) {
            if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(Of.key)) {
              const Hf = Of.target, Ff = Number(Hf.value), zf = Of.shiftKey ? 10 * If : If;
              switch (Of.key) {
                case "ArrowUp":
                  Of.preventDefault(), Hf.value = `${Math.min(Ff + zf, kf)}`;
                  break;
                case "ArrowDown":
                  Of.preventDefault(), Hf.value = `${Math.max(Ff - zf, Cf)}`;
                  break;
                case "PageUp":
                  Of.preventDefault(), Hf.value = `${Math.min(Ff + 10 * If, kf)}`;
                  break;
                case "PageDown":
                  Of.preventDefault(), Hf.value = `${Math.max(Ff - 10 * If, Cf)}`;
                  break;
                case "Home":
                  Of.preventDefault(), Hf.value = `${Cf}`;
                  break;
                case "End":
                  Of.preventDefault(), Hf.value = `${kf}`;
              }
              e.context.handlers.rangeLimitInput(_f, Cf, kf, Of)();
            }
          } else Of.preventDefault();
      }, e.context.handlers.swatchClick = (_f) => {
        const Cf = _f.target;
        if (Cf.dataset.colorPrecise) {
          const [kf, If, Of, Hf] = Rc(Cf.dataset.colorPrecise);
          e.props.alpha && (e.props.a = Hf), Wf(kf, If, Of), e.props.closeOnSelect && (e.props.expanded = !1);
        }
        e.context && _f.type !== "keydown" && e.context.handlers.swatchKeydown(_f);
      }, e.context.handlers.swatchKeydown = (_f) => {
        var Cf, kf, If, Of;
        if (!e.context || !u || !u.length) return;
        const Hf = u.indexOf(_f.currentTarget);
        let Ff = null;
        const zf = function(wh) {
          var Ah;
          if (!wh.length) return 0;
          const bh = (Ah = wh[0].parentElement) === null || Ah === void 0 ? void 0 : Ah.parentElement;
          if (!bh) return 0;
          const Yh = bh.getBoundingClientRect().width, ag = wh[0].parentElement;
          if (!ag) return 0;
          const em = ag.getBoundingClientRect(), Oh = window.getComputedStyle(ag), ov = parseFloat(Oh.marginLeft) + parseFloat(Oh.marginRight), Tg = em.width + ov;
          return Math.floor(Yh / Tg);
        }(u), Qf = u.length;
        let qf = 0, jf = Qf, Sh = !1;
        const $h = u[Hf].dataset.group;
        if ($h !== void 0) {
          const wh = u.filter((Ah) => Ah.dataset.group === $h);
          qf = u.indexOf(wh[0]), jf = u.indexOf(wh[wh.length - 1]);
        }
        const Ch = (Hf - qf) % zf;
        if (!_f.key || _f.key === "Tab") return _f.key || (e.props.swatchIsUsingKeyboardNav = !1, m = Ch, sf(Hf)), _f.key === "Tab" && (e.props.swatchIsUsingKeyboardNav = !1), void u.forEach((wh) => {
          delete wh.parentElement.dataset.focused;
        });
        if (_f.key === "Enter" || _f.key === " ") return _f.preventDefault(), m = Ch, e.context.handlers.swatchClick(_f), void sf(Hf);
        switch (_f.key !== "ArrowUp" && _f.key !== "ArrowDown" && _f.key !== "ArrowLeft" && _f.key !== "ArrowRight" || (e.props.swatchIsUsingKeyboardNav = !0, _f.preventDefault()), _f.key) {
          case "ArrowUp":
            Ff = Math.max(Hf - zf, Hf - (zf - (m - Ch))), Sh = !0;
            break;
          case "ArrowDown":
            Ff = Math.max(Hf + zf, Hf + (zf + (m - Ch))), Sh = !0;
            break;
          case "ArrowLeft":
            Ff = Hf - 1, m = (Ff - qf) % zf;
            break;
          case "ArrowRight":
            Ff = Hf + 1, m = (Ff - qf) % zf;
        }
        if (Sh && Ff !== null && (Ff < qf || Ff > jf)) {
          let wh;
          wh = Ff < qf ? (kf = (Cf = u[qf - 1]) === null || Cf === void 0 ? void 0 : Cf.dataset) === null || kf === void 0 ? void 0 : kf.group : (Of = (If = u[jf + 1]) === null || If === void 0 ? void 0 : If.dataset) === null || Of === void 0 ? void 0 : Of.group;
          const Ah = u.filter((Oh) => Oh.dataset.group === $h), bh = u.filter((Oh) => Oh.dataset.group === wh), Yh = (Hf - qf) % zf, ag = Ah.length % zf || zf, em = Hf >= qf + Ah.length - ag;
          if (Ff < qf) {
            const Oh = bh.length % zf || zf;
            Ff = qf - Oh + Math.min(Math.max(Yh, m), Oh - 1);
          } else Ff > jf && (Ff = em ? Math.min(jf + Math.max(Yh, m) + 1, u.indexOf(bh[bh.length - 1])) : Math.min(Ff, jf));
        }
        if (Ff !== null && Ff >= 0 && Ff < Qf) {
          sf(Ff), u.forEach((bh) => {
            delete bh.parentElement.dataset.focused;
          });
          const wh = u[Ff], Ah = wh.parentElement;
          wh.focus(), Ah.dataset.focused = "true";
        }
      });
    });
  },
  No,
  options$1,
  /* @__PURE__ */ defaultIcon("eyeDropper", "color"),
  /* @__PURE__ */ defaultIcon("close", "close"),
  /* @__PURE__ */ localize("close"),
  /* @__PURE__ */ localize("next")
] }, jc = /* @__PURE__ */ Me("tb"), { outer: zc, inner: Zc, wrapper: Gc, prefix: qc, suffix: Xc, help: Jc, messages: Qc, message: eu, icon: tu } = /* @__PURE__ */ Ve(jc), ou = jc("label", () => ({ if: "$label", $el: "label", attrs: { id: "$id + '_label'" } })), nu = jc("singleToggle", () => ({ bind: "$attrs", $el: "button", attrs: { id: "$id", type: "button", "aria-label": "$label", "aria-pressed": "$fns.isChecked($onValue, $value)", onClick: "$handlers.toggleValue()", disabled: "$disabled", class: "$classes.input", onBlur: "$handlers.blur" } })), ru = jc("multiToggle", () => ({ bind: "$attrs", $el: "button", attrs: { type: "button", id: "$id+'_'+$index", "aria-label": "$label", "aria-pressed": "$fns.isChecked($option, $value)", onClick: "$handlers.toggleValue($option)", class: "$classes.input", title: "$option.help", disabled: "$disabled || $option.disabled", onBlur: "$handlers.blur" } })), su = jc("inputInner", () => ({ bind: "$attrs", $el: "span" })), au = jc("options", () => ({ $el: "ul", attrs: { id: "$id", "data-vertical": '$vertical && "true" || "false"', "aria-labelledby": "$id" } })), lu = jc("option", () => ({ $el: "li", for: ["option", "index", "$options"], attrs: { key: "$option.value", "data-index": "$index" } }));
function iu(e, t) {
  return t = t != null && t.hasOwnProperty("__original") ? t == null ? void 0 : t.__original : t == null ? void 0 : t.value, e.props.multiple ? !!Array.isArray(e.value) && e.value.filter((n) => eq(n, t)).length > 0 : t !== void 0 ? eq(e.value, t) : (e.props._isChecked = eq(e.value, e.props.onValue), e.props._isChecked);
}
const pu = { schema: /* @__PURE__ */ zc(/* @__PURE__ */ Be("$options", /* @__PURE__ */ Gc(/* @__PURE__ */ ou("$label"), /* @__PURE__ */ au(/* @__PURE__ */ lu(/* @__PURE__ */ ru(/* @__PURE__ */ Be("$fns.isChecked($option) === true", /* @__PURE__ */ su("$slots.default || $slots.on || $option.onLabel || $option.label"), /* @__PURE__ */ su("$slots.default || $slots.off || $option.offLabel || $option.label")))))), /* @__PURE__ */ Gc(/* @__PURE__ */ Be("$label && ($slots.default || $slots.on || $onLabel)", /* @__PURE__ */ ou("$label")), /* @__PURE__ */ nu(/* @__PURE__ */ tu("prefix"), /* @__PURE__ */ qc(), /* @__PURE__ */ Be("$_isChecked === true", /* @__PURE__ */ su("$slots.default || $slots.on || $onLabel || $label"), /* @__PURE__ */ su("$slots.default || $slots.off || $offLabel || $label")), /* @__PURE__ */ Xc(), /* @__PURE__ */ tu("suffix")))), /* @__PURE__ */ Jc("$help"), /* @__PURE__ */ Qc(/* @__PURE__ */ eu("$message.value"))), type: "input", family: "button", props: ["options"], features: [function(e) {
  var t, n, r, i;
  e.addProps(["enforced", "multiple", "offLabel", "offValue", "onLabel", "onValue", "vertical", "_isChecked"]), e.props._isChecked = !1, e.props.enforced = undefine(e.props.enforced), e.props.multiple = undefine(e.props.multiple), e.props.vertical = undefine(e.props.vertical), e.props.disabled = undefine(e.props.disabled), (t = (r = e.props).onValue) !== null && t !== void 0 || (r.onValue = !0), (n = (i = e.props).offValue) !== null && n !== void 0 || (i.offValue = !1), e.on("created", () => {
    var s;
    e.props._isChecked = iu(e, null), e.props.options && e.props.multiple && e.input((s = e.value) !== null && s !== void 0 ? s : [], !1), e.context && (e.context.fns.isChecked = (l) => iu(e, l), e.context.handlers.toggleValue = (l) => (c) => function(u, m, qu) {
      if (qu.preventDefault(), m = m && gt$1(m), u.props.options) if (u.props.multiple) {
        const Gu = Array.isArray(u.value) ? [...u.value] : [], Qu = Gu.findIndex((Xu) => eq(Xu, m));
        Qu > -1 && (!u.props.enforced || Gu.length > 1) ? Gu.splice(Qu, 1) : Qu === -1 && Gu.push(m), u.input(Gu);
      } else eq(u.value, m) && !u.props.enforced ? u.input(void 0) : u.input(m);
      else u.input(eq(u.value, u.props.onValue) ? u.props.offValue : u.props.onValue);
    }(e, l, c));
  });
}, options$1] }, du = /* @__PURE__ */ Me("ut"), { outer: cu, inner: uu, wrapper: fu, label: vu, prefix: hu, suffix: mu, help: gu, messages: $u, message: bu, icon: yu } = /* @__PURE__ */ Ve(du), xu = du("input", () => ({ $el: "input", bind: "$attrs", attrs: { name: "$node.name", autocomplete: "$attrs.autocomplete || off", id: "$id", onChange: "$handlers.handleInput", onBlur: "$handlers.unitBlur", onInput: "$handlers.handleInput", onKeydown: "$handlers.handleKeyDown", onBeforeinput: "$handlers.handleBeforeInput", readonly: "$readonly", inputmode: "decimal", placeholder: "$placeholder || $unitParts.unit", disabled: "$disabled", "data-unit": "$unit", "data-currency": "$currency", "data-display-locale": "$displayLocale", "data-value-locale": "$valueLocale", "data-decimals": "$decimals", "data-trailing": "$trailingZeros", "data-numeric-value": "$_numericValue", "data-align": "$_valueAlignAuto" } })), wu = { meter: { kilometer: 1e-3, meter: 1, centimeter: 100, millimeter: 1e3, mile: 621371e-9, yard: 1.09361, foot: 3.28084, inch: 39.3701, "mile-scandinavian": 1e-4 }, kilometer: { kilometer: 1, meter: 1e3, centimeter: 1e5, millimeter: 1e6, mile: 0.621371, yard: 1093.61, foot: 3280.84, inch: 39370.1, "mile-scandinavian": 10 }, centimeter: { kilometer: 1e-5, meter: 0.01, centimeter: 1, millimeter: 10, mile: 62137e-10, yard: 0.0109361, foot: 0.0328084, inch: 0.393701, "mile-scandinavian": 1e-6 }, millimeter: { kilometer: 1e-6, meter: 1e-3, centimeter: 0.1, millimeter: 1, mile: 621371e-12, yard: 109361e-8, foot: 328084e-8, inch: 0.0393701, "mile-scandinavian": 1e-7 }, mile: { kilometer: 1.60934, meter: 1609.34, centimeter: 160934, millimeter: 1609340, mile: 1, yard: 1760, foot: 5280, inch: 63360, "mile-scandinavian": 0.160934 }, yard: { kilometer: 9144e-7, meter: 0.9144, centimeter: 91.44, millimeter: 914.4, mile: 568182e-9, yard: 1, foot: 3, inch: 36, "mile-scandinavian": 9144e-8 }, foot: { kilometer: 3048e-7, meter: 0.3048, centimeter: 30.48, millimeter: 304.8, mile: 189394e-9, yard: 0.333333, foot: 1, inch: 12, "mile-scandinavian": 3048e-8 }, inch: { kilometer: 254e-7, meter: 0.0254, centimeter: 2.54, millimeter: 25.4, mile: 15783e-9, yard: 0.0277778, foot: 0.0833333, inch: 1, "mile-scandinavian": 254e-8 }, "mile-scandinavian": { kilometer: 10, meter: 1e4, centimeter: 1e6, millimeter: 1e7, mile: 6.21371, yard: 10936.1, foot: 32808.4, inch: 393701, "mile-scandinavian": 1 } }, _u = { celsius: { celsius: (e) => e, fahrenheit: (e) => 1.8 * e + 32 }, fahrenheit: { celsius: (e) => 5 / 9 * (e - 32), fahrenheit: (e) => e } }, ku = { acre: { acre: 1, hectare: 0.404686 }, hectare: { acre: 2.47105, hectare: 1 } }, Su = { gram: { gram: 1, kilogram: 1e-3, ounce: 0.035274, pound: 220462e-8 }, kilogram: { gram: 1e3, kilogram: 1, ounce: 35.274, pound: 2.20462 }, ounce: { gram: 28.3495, kilogram: 0.0283495, ounce: 1, pound: 0.0625 }, pound: { gram: 453.592, kilogram: 0.453592, ounce: 16, pound: 1 }, stone: { gram: 6350.29, kilogram: 6.35029, ounce: 224, pound: 14, stone: 1 } }, Lu = { liter: { liter: 1, milliliter: 1e3, gallon: 0.264172, "fluid-ounce": 33.814 }, milliliter: { liter: 1e-3, milliliter: 1, gallon: 264172e-9, "fluid-ounce": 0.033814 }, gallon: { liter: 3.78541, milliliter: 3785.41, gallon: 1, "fluid-ounce": 128 }, "fluid-ounce": { liter: 0.0295735, milliliter: 29.5735, gallon: 78125e-7, "fluid-ounce": 1 } }, Iu = { day: { day: 1, hour: 24, microsecond: 864e8, millisecond: 864e5, minute: 1440, month: 0.0328767, nanosecond: 864e14, second: 86400, week: 0.142857, year: 273973e-8 }, hour: { day: 0.0416667, hour: 1, microsecond: 36e8, millisecond: 36e5, minute: 60, month: 136986e-8, nanosecond: 36e11, second: 3600, week: 595238e-8, year: 114155e-9 }, microsecond: { day: 115741e-19, hour: 277778e-18, microsecond: 1, millisecond: 1e-3, minute: 166667e-13, month: 380517e-24, nanosecond: 1e3, second: 1e-6, week: 165344e-20, year: 3171e-20 }, millisecond: { day: 115741e-13, hour: 277778e-12, microsecond: 1e3, millisecond: 1, minute: 166667e-10, month: 380517e-19, nanosecond: 1e6, second: 1e-3, week: 165344e-16, year: 3171e-16 }, minute: { day: 694444e-9, hour: 0.0166667, microsecond: 6e7, millisecond: 6e4, minute: 1, month: 228311e-10, nanosecond: 6e10, second: 60, week: 992063e-10, year: 190132e-11 }, month: { day: 30.4368, hour: 730.484, microsecond: 2628e12, millisecond: 2628e9, minute: 43800, month: 1, nanosecond: 2628e15, second: 2628e6, week: 4.34524, year: 0.0833333 }, nanosecond: { day: 115741e-25, hour: 277778e-24, microsecond: 1e-3, millisecond: 1e-6, minute: 166667e-19, month: 380517e-28, nanosecond: 1, second: 1e-9, week: 165344e-26, year: 3171e-26 }, second: { day: 115741e-10, hour: 277778e-9, microsecond: 1e6, millisecond: 1e3, minute: 0.0166667, month: 380517e-16, nanosecond: 1e9, second: 1, week: 165344e-13, year: 3171e-13 }, week: { day: 7, hour: 168, microsecond: 6048e11, millisecond: 6048e8, minute: 10080, month: 0.230137, nanosecond: 6048e14, second: 604800, week: 1, year: 0.0191781 }, year: { day: 365, hour: 8760, microsecond: 3154e13, millisecond: 3154e10, minute: 525600, month: 12, nanosecond: 3154e16, second: 3154e4, week: 52.1429, year: 1 } }, Du = { bit: { bit: 1, byte: 0.125, kilobit: 1e-3, kilobyte: 125e-6, megabit: 1e-6, megabyte: 125e-9, gigabit: 1e-9, gigabyte: 125e-12, terabit: 1e-12, terabyte: 125e-15, petabyte: 125e-18 }, byte: { bit: 8, byte: 1, kilobit: 8e-3, kilobyte: 1e-3, megabit: 8e-6, megabyte: 1e-6, gigabit: 8e-9, gigabyte: 1e-9, terabit: 8e-12, terabyte: 1e-12, petabyte: 1e-15 }, kilobit: { bit: 1e3, byte: 125, kilobit: 1, kilobyte: 0.125, megabit: 1e-3, megabyte: 125e-6, gigabit: 1e-6, gigabyte: 125e-9, terabit: 1e-9, terabyte: 125e-12, petabyte: 125e-15 }, kilobyte: { bit: 8e3, byte: 1e3, kilobit: 8, kilobyte: 1, megabit: 8e-3, megabyte: 1e-3, gigabit: 8e-6, gigabyte: 1e-6, terabit: 8e-9, terabyte: 1e-9, petabyte: 1e-12 }, megabit: { bit: 1e6, byte: 125e3, kilobit: 1e3, kilobyte: 125, megabit: 1, megabyte: 0.125, gigabit: 1e-3, gigabyte: 125e-6, terabit: 1e-6, terabyte: 125e-9, petabyte: 125e-12 }, megabyte: { bit: 8e6, byte: 1e6, kilobit: 8e3, kilobyte: 1e3, megabit: 8, megabyte: 1, gigabit: 8e-3, gigabyte: 1e-3, terabit: 8e-6, terabyte: 1e-6, petabyte: 1e-9 }, gigabit: { bit: 1e9, byte: 125e6, kilobit: 1e6, kilobyte: 125e3, megabit: 1e3, megabyte: 125, gigabit: 1, gigabyte: 0.125, terabit: 1e-3, terabyte: 125e-6, petabyte: 125e-9 }, gigabyte: { bit: 8e9, byte: 1e9, kilobit: 8e6, kilobyte: 1e6, megabit: 8e3, megabyte: 1e3, gigabit: 8, gigabyte: 1, terabit: 8e-3, terabyte: 1e-3, petabyte: 1e-6 }, terabit: { bit: 1e12, byte: 125e9, kilobit: 1e9, kilobyte: 125e6, megabit: 1e6, megabyte: 125e3, gigabit: 1e3, gigabyte: 125, terabit: 1, terabyte: 0.125, petabyte: 125e-6 }, terabyte: { bit: 8e12, byte: 1e12, kilobit: 8e9, kilobyte: 1e9, megabit: 8e6, megabyte: 1e6, gigabit: 8e3, gigabyte: 1e3, terabit: 8, terabyte: 1, petabyte: 1e-3 }, petabyte: { bit: 1e15, byte: 125e12, kilobit: 1e12, kilobyte: 125e9, megabit: 1e9, megabyte: 125e6, gigabit: 1e6, gigabyte: 125e3, terabit: 1e3, terabyte: 125, petabyte: 1 } };
function Au(e) {
  let t = !1;
  function n(m) {
    var qu, Gu, Qu;
    const Xu = (`${m}`.match(/\-/g) || []).length % 2 == 1;
    m = function(hf) {
      if (hf = function(sf) {
        return sf.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, (pf) => (15 & pf.charCodeAt(0)).toString());
      }(`${hf}`), isNaN(hf) && (hf = hf.split(e.props.unitParts.decimal).map((sf) => sf.replace(/[^0-9]/g, "")).join(".")), hf = hf.replace(/[^0-9\.]/g, ""), hf.includes(".")) {
        const sf = hf.split(".");
        e.props.decimals === 0 ? hf = sf[0] : e.props.type === "currency" && (sf[1] = sf[1].padEnd(u(), "0").slice(0, u()), hf = sf.join("."));
      }
      return hf;
    }(m);
    const ef = {};
    s() !== "unit" && s() !== "decimal" || (ef.minimumFractionDigits = m.includes(".") ? 1 : 0), ef.maximumFractionDigits = e.props.type === "currency" ? u() : e.props.decimals, e.props.minDecimals && (ef.minimumFractionDigits = e.props.minDecimals, m && !m.includes(".") && (m += ".".padEnd(e.props.minDecimals + 1, "0"))), ef.maximumFractionDigits === 0 && m.includes(".") && (m = m.split(".")[0]);
    let tf = "";
    if (!isNaN(m) && m.trim() !== "" && (m = Xu ? `-${m}` : m, e.props.max && !isNaN(e.props.max) && (m = Number(m) > e.props.max ? `${e.props.max}` : m), e.props.min && !isNaN(e.props.min) && (m = Number(m) < e.props.min ? `${e.props.min}` : m), m.includes(".") && e.props.type === "currency" ? m = m.split(".")[0].padStart(1, "0") + "." + ((qu = m.split(".")[1]) !== null && qu !== void 0 ? qu : "0") : e.props.type === "currency" && (ef.maximumFractionDigits = (Gu = ef.minimumFractionDigits) !== null && Gu !== void 0 ? Gu : 0), tf = l(e.props.displayLocale, ef).format(m), e.props.type === "unit" && m[m.length - 1] === ".")) {
      const hf = tf.lastIndexOf(e.props.unitParts.decimal);
      tf = tf.slice(0, hf + 1) + tf.slice(hf + 2), m = m.slice(0, -1);
    }
    let af, rf = m.split(".");
    e.props.type === "currency" && (rf = rf[0] + ((Qu = rf[1]) !== null && Qu !== void 0 ? Qu : "").padEnd(u(), "0"), rf.length > 1 && (rf = rf.replace(/^0+/, ""), rf = m !== "" && rf === "" ? "0" : rf)), e.props.valueStore = { number: m, integer: rf, string: tf }, t = !0, e.props.valueStore && (af = e.props.valueStore.hasOwnProperty(e.props.valueFormat) ? e.props.valueStore[e.props.valueFormat] : e.props.valueStore.number), e.input(af === "" ? void 0 : af).then(() => (t = !1, Promise.resolve()));
  }
  function r() {
    whenAvailable(`${e.props.id}`, (m) => {
      var qu, Gu;
      m instanceof HTMLInputElement && (m.value = (Gu = (qu = e.props.valueStore) === null || qu === void 0 ? void 0 : qu.string) !== null && Gu !== void 0 ? Gu : "");
    }, e.props.__root);
  }
  function i() {
    var m, qu;
    const Gu = (m = e.props.__root) === null || m === void 0 ? void 0 : m.querySelector(`#${e.props.id}_inner input`);
    return (qu = Gu == null ? void 0 : Gu.value) !== null && qu !== void 0 ? qu : "";
  }
  function s() {
    return e.props.currency ? "currency" : e.props.unit ? "unit" : "decimal";
  }
  function l(m, qu = {}) {
    const Gu = s(), Qu = Object.assign({}, { style: Gu, roundingMode: "trunc" }, qu);
    return e.props.type === "unit" && (Qu.unitDisplay = e.props.unitDisplay), e.props.type === "currency" && (Qu.currencyDisplay = e.props.currencyDisplay), Qu[Gu] = e.props[Gu], new Intl.NumberFormat(m, Qu);
  }
  function c(m, qu) {
    var Gu, Qu, Xu, ef, tf;
    const af = (Gu = e.props.__root) === null || Gu === void 0 ? void 0 : Gu.querySelector(`#${e.props.id}_inner input`);
    if (!af) return;
    const rf = ((Xu = (Qu = e.props.unitParts.unit) === null || Qu === void 0 ? void 0 : Qu.length) !== null && Xu !== void 0 ? Xu : 0) + ((tf = (ef = e.props.unitParts.literal) === null || ef === void 0 ? void 0 : ef.length) !== null && tf !== void 0 ? tf : 0);
    e.props.unitParts.unitLeft ? m = Math.max(m, rf) : (m = Math.min(m, i().length - rf), qu === "insertText" && m === 0 && (m = 1)), af.setSelectionRange(m, m);
  }
  function u() {
    return e.props.decimals !== void 0 ? e.props.decimals : e.props.minDecimals !== void 0 && e.props.minDecimals > e.props.unitParts.fractionLength ? e.props.minDecimals : e.props.unitParts.fractionLength;
  }
  e.props.valueStore = null, e.on("input", ({ payload: m }) => {
    t || (n(m), r());
  }), e.context && (e.context.handlers.init = (m = null) => {
    var qu;
    e.props.skipInit ? e.props.skipInit = !1 : function() {
      var Qu, Xu, ef, tf, af, rf, hf;
      e.props.skipInit = !0;
      const sf = l(e.props.displayLocale).formatToParts(1234567812345678e-8);
      e.props.unitParts = { decimal: (Qu = sf.find((pf) => pf.type == "decimal")) === null || Qu === void 0 ? void 0 : Qu.value, group: (Xu = sf.find((pf) => pf.type == "group")) === null || Xu === void 0 ? void 0 : Xu.value, unit: (ef = sf.find((pf) => ["unit", "currency"].includes(pf.type))) === null || ef === void 0 ? void 0 : ef.value, unitLeft: ["unit", "currency"].includes(sf[0].type), literal: (af = (tf = sf.find((pf) => pf.type == "literal")) === null || tf === void 0 ? void 0 : tf.value) !== null && af !== void 0 ? af : "", fractionLength: (hf = (rf = sf.find((pf) => pf.type == "fraction")) === null || rf === void 0 ? void 0 : rf.value.length) !== null && hf !== void 0 ? hf : 0 };
    }();
    let Gu = (qu = m ?? e._value) !== null && qu !== void 0 ? qu : "";
    e.props.valueStore ? Gu = e.props.valueStore.number : e.props.valueFormat === "integer" && (Gu = function(Qu) {
      var Xu;
      return (parseFloat(`${Qu}`) / Math.pow(10, (Xu = u()) !== null && Xu !== void 0 ? Xu : 0)).toString().replace(".", u());
    }(`${Gu ?? ""}`)), e.props.type === "unit" && e.props.valueUnit && e.props.unit && e.props.valueUnit !== e.props.unit && e.hook.input((Qu, Xu) => {
      const ef = function(tf, af, rf) {
        if (wu[tf] && wu[tf][rf]) return af * wu[tf][rf];
        if (_u[tf] && _u[tf][rf]) return _u[tf][rf](af);
        if (ku[tf] && ku[tf][rf]) return af * ku[tf][rf];
        if (Su[tf] && Su[tf][rf]) return af * Su[tf][rf];
        if (Lu[tf] && Lu[tf][rf]) return af * Lu[tf][rf];
        if (Iu[tf] && Iu[tf][rf]) return af * Iu[tf][rf];
        if (Du[tf] && Du[tf][rf]) return af * Du[tf][rf];
        throw new Error("Conversion not supported");
      }(e.props.unit, Qu, e.props.valueUnit);
      return isNaN(ef) ? Xu(Qu) : Xu(+ef.toFixed(Number(e.props.valueDecimals) || 2));
    }), n(Gu), r();
  }, e.context.handlers.handleBeforeInput = (m) => {
    var qu, Gu, Qu, Xu, ef, tf, af, rf, hf;
    if (!e.props.inExecCommand && (m.preventDefault(), m.stopPropagation(), m.target instanceof HTMLInputElement)) {
      const sf = m.target, pf = (qu = m.data) !== null && qu !== void 0 ? qu : "", $f = (Gu = m.target.value) !== null && Gu !== void 0 ? Gu : "", uf = (Qu = m.target.selectionStart) !== null && Qu !== void 0 ? Qu : 0, vf = (Xu = m.target.selectionEnd) !== null && Xu !== void 0 ? Xu : 0, cf = vf - uf, yf = $f.indexOf(e.props.unitParts.decimal);
      let ff = ((ef = m.target.selectionStart) !== null && ef !== void 0 ? ef : 0) + (m.data ? 0 : -1);
      m.target.selectionStart, m.data;
      let gf = $f, lf = 1;
      if ($f.includes(e.props.unitParts.decimal) && pf === e.props.unitParts.decimal) return pf === e.props.unitParts.decimal && (ff = gf.indexOf(e.props.unitParts.decimal) + 1), void c(ff);
      if (!(e.props.min === null || e.props.min < 0 || e.props.max < 0) && pf === "-" || pf.match(/[a-zA-Z]/) || pf === e.props.unitParts.decimal && e.props.decimals === 0) return;
      if (m.inputType === "deleteByCut" && cf > 0 && (gf = gf.slice(0, uf) + gf.slice(vf), ff = vf), m.inputType === "insertFromPaste") {
        const Sf = (tf = m.data) !== null && tf !== void 0 ? tf : "";
        gf = gf.slice(0, uf) + Sf + gf.slice(vf);
      }
      if (m.inputType === "deleteContentBackward" && $f[uf - 1] === e.props.unitParts.group ? (lf += 1, ff -= 1) : m.inputType === "deleteContentForward" && $f[uf] === e.props.unitParts.group && (lf += 1, ff += 1), yf !== -1 && ff > yf && m.inputType === "insertText" ? gf = function(Sf, Mf, Uf) {
        return Sf.substring(0, Mf) + Uf + Sf.substring(Mf + Uf.length);
      }(gf, ff, (af = m.data) !== null && af !== void 0 ? af : "0") : m.inputType === "insertText" ? (ff = vf, gf = gf.slice(0, uf) + m.data + gf.slice(vf)) : m.inputType === "deleteContentForward" ? (ff += 2, gf = cf === 0 ? gf.slice(0, uf) + gf.slice(vf + lf) : gf.slice(0, uf) + gf.slice(vf)) : m.inputType === "deleteContentBackward" && (ff += 1, cf === 0 ? gf = gf.slice(0, Math.max(uf - lf, 0)) + gf.slice(vf) : cf > 0 && (gf = gf.slice(0, uf) + gf.slice(vf))), m.inputType === "deleteContentForward" && $f[uf] === e.props.unitParts.decimal) {
        const Sf = gf.slice(uf - 1);
        gf = gf.slice(0, uf), Sf.includes(e.props.unitParts.unit) && (gf += " " + e.props.unitParts.unit);
      } else if (m.inputType === "deleteContentBackward" && $f[uf - 1] === e.props.unitParts.decimal) {
        const Sf = gf.slice(uf - 1);
        gf = gf.slice(0, uf - 1), Sf.includes(e.props.unitParts.unit) && (gf += " " + e.props.unitParts.unit);
      }
      if (n(gf), gf = ((rf = e.props.valueStore) === null || rf === void 0 ? void 0 : rf.string) || ((hf = e.props.valueStore) === null || hf === void 0 ? void 0 : hf.number) || "", ff = gf.length - $f.length + ff, gf.length === $f.length && ff > yf && (ff += m.inputType.includes("delete") ? -1 : 1), sf.setSelectionRange(0, $f.length), e.props.inExecCommand = !0, document.execCommand("insertText", void 0, gf), e.props.inExecCommand = !1, pf === e.props.unitParts.decimal ? ff = gf.indexOf(e.props.unitParts.decimal) + 1 : $f.includes(e.props.unitParts.decimal) && !gf.includes(e.props.unitParts.decimal) && (ff = gf.length), m.inputType === "insertText" && e.props.minDecimals && (!e.value || uf === 0 && vf === $f.length || yf === -1 && e.props.minDecimals && $f)) {
        let Sf = 0;
        Sf = e.props.unitParts.unit ? e.props.unitParts.unit.length + 1 : 0, ff -= e.props.minDecimals, e.props.unitParts.unitLeft ? ff -= Sf - 1 : ff -= Sf + 1;
      }
      c(Math.max(0, ff), m.inputType);
    }
  }, e.context.handlers.handleInput = (m) => {
    e.emit("dom-input-event", m), m.target instanceof HTMLInputElement && (e.props.inputText = m.target.value, n(m.target.value));
  }, e.context.handlers.handleKeyDown = (m) => {
    var qu, Gu;
    if (m.target instanceof HTMLInputElement && (m.key === "ArrowUp" || m.key === "ArrowDown")) {
      const Qu = m.key === "ArrowUp" ? 1 * e.props.step : -1 * e.props.step;
      n(function(Xu, ef) {
        var tf, af, rf, hf;
        const sf = `${Xu}`.split("."), pf = `${ef}`.split(".");
        let $f = (tf = sf[0]) !== null && tf !== void 0 ? tf : "0", uf = (af = pf[0]) !== null && af !== void 0 ? af : "0";
        const vf = (rf = sf[1]) !== null && rf !== void 0 ? rf : "", cf = (hf = pf[1]) !== null && hf !== void 0 ? hf : "", yf = Math.max(vf.length, cf.length);
        yf > 0 && ($f += vf.padEnd(yf, "0"), uf += cf.padEnd(yf, "0"));
        const ff = BigInt(BigInt($f) + BigInt(uf)).toString();
        return yf > 0 ? ff.slice(0, -1 * yf) + "." + ff.slice(-1 * yf) : ff;
      }((Gu = (qu = e.props.valueStore) === null || qu === void 0 ? void 0 : qu.number) !== null && Gu !== void 0 ? Gu : 0, Qu)), r(), setTimeout(() => {
        c(i().length);
      }, 1);
    }
  });
}
const Cu = { schema: /* @__PURE__ */ cu(/* @__PURE__ */ fu(/* @__PURE__ */ vu("$label"), /* @__PURE__ */ uu(/* @__PURE__ */ yu("prefix"), /* @__PURE__ */ hu(), /* @__PURE__ */ xu(), /* @__PURE__ */ mu(), /* @__PURE__ */ yu("suffix"))), /* @__PURE__ */ gu("$help"), /* @__PURE__ */ $u(/* @__PURE__ */ bu("$message.value"))), type: "input", family: "text", features: [function(e) {
  var t, n, r, i, s, l;
  const c = ["unit", "decimals", "minDecimals", "displayLocale", "min", "max", "step", "valueFormat", "unitDisplay", "placeholder", "unitParts", "valueUnit", "valueDecimals"];
  e.addProps(c), (t = (i = e.props).displayLocale) !== null && t !== void 0 || (i.displayLocale = e.props.locale || "en-US"), e.props.unitDisplay = e.props.unitDisplay || "short", e.props.decimals === "false" || e.props.decimals === !1 ? e.props.decimals = 0 : e.props.decimals !== void 0 ? e.props.decimals = Number(e.props.decimals) : e.props.decimals = 2, e.props.minDecimals = e.props.minDecimals !== void 0 ? Number(e.props.minDecimals) : void 0, e.props.min !== void 0 && (e.props.min = Number(e.props.min)), e.props.max !== void 0 && (e.props.max = Number(e.props.max)), (n = (s = e.props).step) !== null && n !== void 0 || (s.step = 1), (r = (l = e.props).valueFormat) !== null && r !== void 0 || (l.valueFormat = "number"), ["string", "number"].indexOf(e.props.valueFormat) === -1 && (e.props.valueFormat = "number"), e.on("created", () => {
    e.context && (e.context.handlers.unitBlur = (u) => {
      if (!(u.target instanceof HTMLInputElement)) return;
      let m = u.target.value;
      (function(qu) {
        qu = qu.trim();
        const Gu = /\d+\,\s*%?$/;
        return /\d+\.\s*%?$/.test(qu) || Gu.test(qu);
      })(m) && (m = m.replace(e.props.unitParts.decimal, ""), u.target.value = m);
    }, Au(e), e.context.handlers.init(), c.forEach((u) => {
      e.on(`prop:${u}`, () => {
        var m;
        (m = e == null ? void 0 : e.context) === null || m === void 0 || m.handlers.init();
      });
    }));
  });
}] }, Tu = /* @__PURE__ */ Me("cr"), { outer: Eu, inner: Ou, wrapper: Mu, label: Vu, prefix: Fu, suffix: Bu, help: Pu, messages: Hu, message: Ru, icon: Nu } = /* @__PURE__ */ Ve(Tu), Ku = Tu("input", () => ({ $el: "input", bind: "$attrs", attrs: { name: "$node.name", autocomplete: "$attrs.autocomplete || off", id: "$id", onChange: "$handlers.handleInput", onInput: "$handlers.handleInput", onKeydown: "$handlers.handleKeyDown", onBeforeinput: "$handlers.handleBeforeInput", readonly: "$readonly", disabled: "$disabled", placeholder: "$placeholder || $unitParts.unit", inputmode: "decimal", "data-unit": "$unit", "data-currency": "$currency", "data-display-locale": "$displayLocale", "data-value-locale": "$valueLocale", "data-decimals": "$decimals", "data-trailing": "$trailingZeros", "data-numeric-value": "$_numericValue", "data-align": "$_valueAlignAuto" } })), Wu = { schema: /* @__PURE__ */ Eu(/* @__PURE__ */ Mu(/* @__PURE__ */ Vu("$label"), /* @__PURE__ */ Ou(/* @__PURE__ */ Nu("prefix"), /* @__PURE__ */ Fu(), /* @__PURE__ */ Ku(), /* @__PURE__ */ Bu(), /* @__PURE__ */ Nu("suffix"))), /* @__PURE__ */ Pu("$help"), /* @__PURE__ */ Hu(/* @__PURE__ */ Ru("$message.value"))), type: "input", family: "text", props: ["options"], features: [function(e) {
  var t, n, r, i, s, l, c, u;
  const m = ["currency", "decimals", "maxDecimals", "minDecimals", "displayLocale", "min", "max", "step", "valueFormat", "currencyDisplay", "placeholder", "unitParts"];
  e.addProps(m), e.addProps(["inputText"]), (t = (s = e.props).displayLocale) !== null && t !== void 0 || (s.displayLocale = e.props.locale || "en-US"), (n = (l = e.props).currency) !== null && n !== void 0 || (l.currency = e.props.currency || "USD"), e.props.decimals === "false" || e.props.decimals === !1 ? e.props.decimals = 0 : e.props.decimals !== void 0 && (e.props.decimals = Number(e.props.decimals)), e.props.minDecimals = e.props.minDecimals !== void 0 ? Number(e.props.minDecimals) : void 0, e.props.min !== void 0 && (e.props.min = Number(e.props.min)), e.props.max !== void 0 && (e.props.max = Number(e.props.max)), (r = (c = e.props).step) !== null && r !== void 0 || (c.step = 1), (i = (u = e.props).valueFormat) !== null && i !== void 0 || (u.valueFormat = "number"), ["string", "number", "integer"].indexOf(e.props.valueFormat) === -1 && (e.props.valueFormat = "number"), e.on("created", () => {
    e.context && (Au(e), e.context.handlers.init(), m.forEach((qu) => {
      e.on(`prop:${qu}`, () => {
        var Gu;
        (Gu = e == null ? void 0 : e.context) === null || Gu === void 0 || Gu.handlers.init();
      });
    }));
  });
}] };
var Uu = /* @__PURE__ */ Object.freeze({ __proto__: null, autocomplete: cs, colorpicker: Yc, currency: Wu, datepicker: si, dropdown: Ko, mask: Ji, rating: Lr, repeater: Nn, slider: Rd, taglist: Di, toggle: pn, togglebuttons: pu, transferlist: id, unit: Cu });
const Yu = typeof window < "u" ? setInterval : () => 0, ju = /* @__PURE__ */ new WeakSet();
function zu(e, t = {}) {
  const n = e;
  try {
    let r = function(i) {
      ju.has(i) && function(l, c) {
        me$1[l] ? me$1[l].add(c) : me$1[l] = /* @__PURE__ */ new Set([c]);
      }(e, (l) => {
        i.props.definition && (i.props.definition.schema = l || [{ $el: le$1(13919), children: `${le$1(451228594)}${le$1(32863693)}` }]), i.emit("schema"), setTimeout(() => i.destroy(), 1e3);
      });
    };
    if (!n) throw new Error("FormKitNoKey");
    return function(i) {
      const s = () => {
        throw new Error(`InvalidFormKitKey ${i}`);
      };
      if (!/^fk-/i.test(i)) return s();
      const l = i.substring(3);
      if (!oe$1.test(l)) return s();
      const c = parseInt(l, 16).toString(), u = Number(c[0]) < 6 ? Number(c[0]) : 6, m = c.substring(u, u + (c.length - 6)), qu = c.substring(0, u) + c.substring(u + m.length), Gu = qu.slice(0, 2), Qu = `${qu[qu.length - 1]}${qu[0]}`;
      Number(m) !== Math.floor(Number(qu) * Number(Gu) / Number(Qu)) && s();
    }(n), r.library = (i) => {
      if (i.props.type in t) {
        const { schema: s, ...l } = t[i.props.type];
        ju.add(i), i.define({ ...l, schema: s(e) });
      }
      Yu(() => ce$1.has(e) && i.emit("schema"), 4e3);
    }, r;
  } catch (r) {
    throw r instanceof Error && function(i) {
      if (i.message === "FormKitNoKey") throw new Error("A FormKit API key is required, please visit https://formkit.com/pro");
    }(r), r;
  }
}
function p(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function g(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? p(Object(n), !0).forEach(function(r) {
      f(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function f(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function v(e, t) {
  if (e == null) return {};
  var n, r, i = function(l, c) {
    if (l == null) return {};
    var u, m, qu = {}, Gu = Object.keys(l);
    for (m = 0; m < Gu.length; m++) u = Gu[m], c.indexOf(u) >= 0 || (qu[u] = l[u]);
    return qu;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) n = s[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
function b(e) {
  return function(t) {
    if (Array.isArray(t)) return w(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
  }(e) || function(t, n) {
    if (t) {
      if (typeof t == "string") return w(t, n);
      var r = Object.prototype.toString.call(t).slice(8, -1);
      if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return w(t, n);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function w(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var y, z, R, A = (y = function(e) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var s = arguments[i];
        if (s) {
          var l = typeof s;
          if (l === "string" || l === "number") r.push(s);
          else if (Array.isArray(s)) {
            if (s.length) {
              var c = n.apply(null, s);
              c && r.push(c);
            }
          } else if (l === "object") if (s.toString === Object.prototype.toString) for (var u in s) t.call(s, u) && s[u] && r.push(u);
          else r.push(s.toString());
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
}, y(R = { path: z, exports: {}, require: function(e, t) {
  return function() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }(t == null && R.path);
} }, R.exports), R.exports), M = function(e) {
  return function(t, n) {
    if (!t) return e;
    var r;
    typeof t == "string" ? r = t : n = t;
    var i = e;
    return r && (i += "__" + r), i + (n ? Object.keys(n).reduce(function(s, l) {
      var c = n[l];
      return c && (s += " " + (typeof c == "boolean" ? i + "--" + l : i + "--" + l + "_" + c)), s;
    }, "") : "");
  };
};
function S(e, t, n) {
  var r, i, s, l, c;
  function u() {
    var qu = Date.now() - l;
    qu < t && qu >= 0 ? r = setTimeout(u, t - qu) : (r = null, n || (c = e.apply(s, i), s = i = null));
  }
  t == null && (t = 100);
  var m = function() {
    s = this, i = arguments, l = Date.now();
    var qu = n && !r;
    return r || (r = setTimeout(u, t)), qu && (c = e.apply(s, i), s = i = null), c;
  };
  return m.clear = function() {
    r && (clearTimeout(r), r = null);
  }, m.flush = function() {
    r && (c = e.apply(s, i), s = i = null, clearTimeout(r), r = null);
  }, m;
}
S.debounce = S;
var x = S, C = function() {
  return C = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    return e;
  }, C.apply(this, arguments);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function E(e, t) {
  var n, r;
  return e && t ? (n = "" + e + t[0].toUpperCase() + t.slice(1), r = e + "-" + t) : (n = e || t, r = e || t), { name: n, classname: r };
}
function W(e) {
  return /^blob:/.test(e);
}
function T(e) {
  return W(e) || function(t) {
    return /^data:/.test(t);
  }(e);
}
function O(e) {
  return !!(e && e.constructor && e.call && e.apply);
}
function D(e) {
  return e === void 0;
}
function H(e) {
  return typeof e == "object" && e !== null;
}
function j(e, t, n) {
  var r = {};
  return H(e) ? (Object.keys(t).forEach(function(i) {
    D(e[i]) ? r[i] = t[i] : H(t[i]) ? H(e[i]) ? r[i] = j(e[i], t[i], n[i]) : r[i] = e[i] ? t[i] : n[i] : t[i] === !0 || t[i] === !1 ? r[i] = !!e[i] : r[i] = e[i];
  }), r) : e ? t : n;
}
function L(e) {
  var t = Number(e);
  return Number.isNaN(t) ? e : t;
}
function P(e) {
  return typeof (e == "number" || /* @__PURE__ */ function(t) {
    return typeof t == "object" && t !== null;
  }(e) && toString.call(e) == "[object Number]") && !$(e);
}
function $(e) {
  return e != e;
}
function I(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
var B = function(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = {}), this.type = "manipulateImage", this.move = e, this.scale = t;
}, X = function(e, t) {
  t === void 0 && (t = {}), this.type = "resize", this.directions = e, this.params = t;
}, Y = function(e) {
  this.type = "move", this.directions = e;
}, k = function() {
  function e(t, n, r, i, s) {
    this.type = "drag", this.nativeEvent = t, this.position = r, this.previousPosition = i, this.element = n, this.anchor = s;
  }
  return e.prototype.shift = function() {
    var t = this, n = t.element, r = t.anchor, i = t.position;
    if (n) {
      var s = n.getBoundingClientRect(), l = s.left, c = s.top;
      return { left: i.left - l - r.left, top: i.top - c - r.top };
    }
    return { left: 0, top: 0 };
  }, e;
}(), F = { name: "DraggableElement", props: { classname: { type: String } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  if (!this.$refs.draggable) throw new Error('You should add ref "draggable" to your root element to use draggable mixin');
  this.touches = [], this.hovered = !1;
}, methods: { onMouseOver: function() {
  this.hovered || (this.hovered = !0, this.$emit("enter"));
}, onMouseLeave: function() {
  this.hovered && !this.touches.length && (this.hovered = !1, this.$emit("leave"));
}, onTouchStart: function(e) {
  e.cancelable && !this.disabled && e.touches.length === 1 && (this.touches = b(e.touches), this.hovered || (this.$emit("enter"), this.hovered = !0), e.touches.length && this.initAnchor(this.touches.reduce(function(t, n) {
    return { clientX: t.clientX + n.clientX / e.touches.length, clientY: t.clientY + n.clientY / e.touches.length };
  }, { clientX: 0, clientY: 0 })), e.preventDefault && e.preventDefault(), e.stopPropagation());
}, onTouchEnd: function() {
  this.processEnd();
}, onTouchMove: function(e) {
  this.touches.length && (this.processMove(e, e.touches), e.preventDefault && e.preventDefault(), e.stopPropagation && e.stopPropagation());
}, onMouseDown: function(e) {
  if (!this.disabled) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.initAnchor(t), e.stopPropagation();
  }
}, onMouseMove: function(e) {
  this.touches.length && (this.processMove(e, [{ fake: !0, clientX: e.clientX, clientY: e.clientY }]), e.preventDefault && e.preventDefault());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(e) {
  var t = this.$refs.draggable.getBoundingClientRect(), n = t.left, r = t.right, i = t.bottom, s = t.top;
  this.anchor = { left: e.clientX - n, top: e.clientY - s, bottom: i - e.clientY, right: r - e.clientX };
}, processMove: function(e, t) {
  var n = b(t);
  if (this.touches.length) {
    if (this.touches.length === 1 && n.length === 1) {
      var r = this.$refs.draggable;
      this.$emit("drag", new k(e, r, { left: n[0].clientX, top: n[0].clientY }, { left: this.touches[0].clientX, top: this.touches[0].clientY }, this.anchor));
    }
    this.touches = n;
  }
}, processEnd: function() {
  this.touches.length && this.$emit("drag-end"), this.hovered && (this.$emit("leave"), this.hovered = !1), this.touches = [];
} }, emits: ["drag", "drag-end", "leave", "enter"] };
F.render = function(e, t, n, r, i, s) {
  return openBlock(), createBlock("div", { ref: "draggable", class: n.classname, onTouchstart: t[1] || (t[1] = function() {
    return s.onTouchStart && s.onTouchStart.apply(s, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return s.onMouseDown && s.onMouseDown.apply(s, arguments);
  }), onMouseover: t[3] || (t[3] = function() {
    return s.onMouseOver && s.onMouseOver.apply(s, arguments);
  }), onMouseleave: t[4] || (t[4] = function() {
    return s.onMouseLeave && s.onMouseLeave.apply(s, arguments);
  }) }, [renderSlot(e.$slots, "default")], 34);
};
var U = M("vue-handler-wrapper"), N = { name: "HandlerWrapper", components: { DraggableElement: F }, props: { horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, computed: { classes: function() {
  var e;
  if (this.horizontalPosition || this.verticalPosition) {
    var t, n = E(this.horizontalPosition, this.verticalPosition);
    e = U((f(t = {}, n.classname, !0), f(t, "disabled", this.disabled), t));
  } else e = U({ disabled: this.disabled });
  return { root: e, draggable: U("draggable") };
} }, emits: ["leave", "enter", "drag", "drag-end"] };
N.render = function(e, t, n, r, i, s) {
  var l = resolveComponent("DraggableElement");
  return openBlock(), createBlock("div", { class: s.classes.root }, [createVNode(l, { class: s.classes.draggable, onDrag: t[1] || (t[1] = function(c) {
    return e.$emit("drag", c);
  }), onDragEnd: t[2] || (t[2] = function(c) {
    return e.$emit("drag-end");
  }), onLeave: t[3] || (t[3] = function(c) {
    return e.$emit("leave");
  }), onEnter: t[4] || (t[4] = function(c) {
    return e.$emit("enter");
  }) }, { default: withCtx(function() {
    return [renderSlot(e.$slots, "default")];
  }), _: 3 }, 8, ["class"])], 2);
};
var Z = M("vue-line-wrapper"), q = { name: "LineWrapper", components: { DraggableElement: F }, props: { position: { type: String, required: !0 }, disabled: { type: Boolean, default: !1 } }, computed: { classname: function() {
  var e;
  return Z((f(e = {}, this.position, !0), f(e, "disabled", this.disabled), e));
} }, emits: ["leave", "enter", "drag", "drag-end"] };
q.render = function(e, t, n, r, i, s) {
  var l = resolveComponent("DraggableElement");
  return openBlock(), createBlock(l, { class: s.classname, onDrag: t[1] || (t[1] = function(c) {
    return e.$emit("drag", c);
  }), onDragEnd: t[2] || (t[2] = function(c) {
    return e.$emit("drag-end");
  }), onLeave: t[3] || (t[3] = function(c) {
    return e.$emit("leave");
  }), onEnter: t[4] || (t[4] = function(c) {
    return e.$emit("enter");
  }) }, { default: withCtx(function() {
    return [renderSlot(e.$slots, "default")];
  }), _: 3 }, 8, ["class"]);
};
var V = ["left", "right", "top", "bottom"], _ = ["left", "right"], G = ["top", "bottom"], Q = ["left", "top"], K = ["fill-area", "fit-area", "stencil", "none"], J = { left: 0, top: 0, width: 0, height: 0 };
function tt(e, t, n) {
  return !(n = n || ["width", "height", "left", "top"]).some(function(r) {
    return e[r] !== t[r];
  });
}
function et(e) {
  return { left: e.left, top: e.top, right: e.left + e.width, bottom: e.top + e.height };
}
function it(e, t) {
  return { left: e.left - t.left, top: e.top - t.top };
}
function nt(e) {
  return { left: e.left + e.width / 2, top: e.top + e.height / 2 };
}
function st(e, t) {
  var n = { left: 0, top: 0, right: 0, bottom: 0 };
  return V.forEach(function(r) {
    var i = t[r], s = et(e)[r];
    n[r] = i !== void 0 && s !== void 0 ? r === "left" || r === "top" ? Math.max(0, i - s) : Math.max(0, s - i) : 0;
  }), n;
}
function ot(e, t) {
  return { left: e.left - t.left, top: e.top - t.top, width: e.width + t.left + t.right, height: e.height + t.top + t.bottom };
}
function rt(e) {
  return { left: -e.left, top: -e.top };
}
function at(e, t) {
  return C(C({}, e), { left: e.left + t.left, top: e.top + t.top });
}
function ht(e, t, n, r) {
  if (t !== 1) {
    if (n) {
      var i = nt(e);
      return { width: e.width * t, height: e.height * t, left: e.left + e.width * (1 - t) / 2 + (n.left - i.left) * (1 - t), top: e.top + e.height * (1 - t) / 2 + (n.top - i.top) * (1 - t) };
    }
    return { width: e.width * t, height: e.height * t, left: e.left + e.width * (1 - t) / 2, top: e.top + e.height * (1 - t) / 2 };
  }
  return e;
}
function ct(e) {
  return e.width / e.height;
}
function lt(e, t) {
  return Math.min(t.right !== void 0 && t.left !== void 0 ? (t.right - t.left) / e.width : 1 / 0, t.bottom !== void 0 && t.top !== void 0 ? (t.bottom - t.top) / e.height : 1 / 0);
}
function ut(e, t) {
  var n = { left: 0, top: 0 }, r = st(e, t);
  return r.left && r.left > 0 ? n.left = r.left : r.right && r.right > 0 && (n.left = -r.right), r.top && r.top > 0 ? n.top = r.top : r.bottom && r.bottom > 0 && (n.top = -r.bottom), n;
}
function dt(e, t) {
  var n;
  return t.minimum && e < t.minimum ? n = t.minimum : t.maximum && e > t.maximum && (n = t.maximum), n;
}
function mt(e, t) {
  var n = ct(e), r = ct(t);
  return t.width < 1 / 0 && t.height < 1 / 0 ? n > r ? { width: t.width, height: t.width / n } : { width: t.height * n, height: t.height } : t.width < 1 / 0 ? { width: t.width, height: t.width / n } : t.height < 1 / 0 ? { width: t.height * n, height: t.height } : e;
}
function pt(e, t) {
  var n = t * Math.PI / 180;
  return { width: Math.abs(e.width * Math.cos(n)) + Math.abs(e.height * Math.sin(n)), height: Math.abs(e.width * Math.sin(n)) + Math.abs(e.height * Math.cos(n)) };
}
function gt(e, t) {
  var n = t * Math.PI / 180;
  return { left: e.left * Math.cos(n) - e.top * Math.sin(n), top: e.left * Math.sin(n) + e.top * Math.cos(n) };
}
function ft(e, t) {
  var n = st(vt(e, t), t);
  return n.left + n.right + n.top + n.bottom ? n.left + n.right > n.top + n.bottom ? Math.min((e.width + n.left + n.right) / e.width, lt(e, t)) : Math.min((e.height + n.top + n.bottom) / e.height, lt(e, t)) : 1;
}
function vt(e, t, n) {
  n === void 0 && (n = !1);
  var r = ut(e, t);
  return at(e, n ? rt(r) : r);
}
function bt(e) {
  return { width: e.right !== void 0 && e.left !== void 0 ? e.right - e.left : 1 / 0, height: e.bottom !== void 0 && e.top !== void 0 ? e.bottom - e.top : 1 / 0 };
}
function wt(e, t) {
  return C(C({}, e), { minWidth: Math.min(t.width, e.minWidth), minHeight: Math.min(t.height, e.minHeight), maxWidth: Math.min(t.width, e.maxWidth), maxHeight: Math.min(t.height, e.maxHeight) });
}
function yt(e, t, n) {
  n === void 0 && (n = !0);
  var r = {};
  return V.forEach(function(i) {
    var s = e[i], l = t[i];
    s !== void 0 && l !== void 0 ? r[i] = i === "left" || i === "top" ? n ? Math.max(s, l) : Math.min(s, l) : n ? Math.min(s, l) : Math.max(s, l) : l !== void 0 ? r[i] = l : s !== void 0 && (r[i] = s);
  }), r;
}
function zt(e, t) {
  return yt(e, t, !0);
}
function Rt(e) {
  var t = e.size, n = e.aspectRatio, r = e.ignoreMinimum, i = e.sizeRestrictions;
  return !!((t.correctRatio || ct(t) >= n.minimum && ct(t) <= n.maximum) && t.height <= i.maxHeight && t.width <= i.maxWidth && t.width && t.height && (r || t.height >= i.minHeight && t.width >= i.minWidth));
}
function At(e, t) {
  return Math.pow(e.width - t.width, 2) + Math.pow(e.height - t.height, 2);
}
function Mt(e) {
  var t = e.width, n = e.height, r = e.sizeRestrictions, i = { minimum: e.aspectRatio && e.aspectRatio.minimum || 0, maximum: e.aspectRatio && e.aspectRatio.maximum || 1 / 0 }, s = { width: Math.max(r.minWidth, Math.min(r.maxWidth, t)), height: Math.max(r.minHeight, Math.min(r.maxHeight, n)) };
  function l(m, qu) {
    return qu === void 0 && (qu = !1), m.reduce(function(Gu, Qu) {
      return Rt({ size: Qu, aspectRatio: i, sizeRestrictions: r, ignoreMinimum: qu }) && (!Gu || At(Qu, { width: t, height: n }) < At(Gu, { width: t, height: n })) ? Qu : Gu;
    }, null);
  }
  var c = [];
  i && [i.minimum, i.maximum].forEach(function(m) {
    m && c.push({ width: s.width, height: s.width / m, correctRatio: !0 }, { width: s.height * m, height: s.height, correctRatio: !0 });
  }), Rt({ size: s, aspectRatio: i, sizeRestrictions: r }) && c.push(s);
  var u = l(c) || l(c, !0);
  return u && { width: u.width, height: u.height };
}
function St(e) {
  var t = e.event, n = e.coordinates, r = e.positionRestrictions, i = r === void 0 ? {} : r, s = at(n, t.directions);
  return at(s, ut(s, i));
}
function xt(e) {
  var t = e.coordinates, n = e.transform, r = e.imageSize, i = e.sizeRestrictions, s = e.positionRestrictions, l = e.aspectRatio, c = e.visibleArea, u = function(qu, Gu) {
    return St({ coordinates: qu, positionRestrictions: s, event: new Y({ left: Gu.left - qu.left, top: Gu.top - qu.top }) });
  }, m = C({}, t);
  return (Array.isArray(n) ? n : [n]).forEach(function(qu) {
    var Gu = {};
    D((Gu = typeof qu == "function" ? qu({ coordinates: m, imageSize: r, visibleArea: c }) : qu).width) && D(Gu.height) || (m = function(Qu, Xu) {
      var ef = C(C(C({}, Qu), Mt({ width: Xu.width, height: Xu.height, sizeRestrictions: i, aspectRatio: l })), { left: 0, top: 0 });
      return u(ef, { left: Qu.left, top: Qu.top });
    }(m, C(C({}, m), Gu))), D(Gu.left) && D(Gu.top) || (m = u(m, C(C({}, m), Gu)));
  }), m;
}
function Ct(e) {
  e.event;
  var t = e.getAreaRestrictions, n = e.boundaries, r = e.coordinates, i = e.visibleArea;
  e.aspectRatio;
  var s = e.stencilSize, l = e.sizeRestrictions, c = e.positionRestrictions;
  e.stencilReference;
  var u, m, qu, Gu = C({}, r), Qu = C({}, i), Xu = C({}, s);
  u = ct(Xu), m = ct(Gu), qu === void 0 && (qu = 1e-3), (u === 0 || m === 0 ? Math.abs(m - u) < qu : Math.abs(m / u) < 1 + qu && Math.abs(m / u) > 1 - qu) || (Gu = C(C({}, Gu), Mt({ sizeRestrictions: l, width: Gu.width, height: Gu.height, aspectRatio: { minimum: ct(Xu), maximum: ct(Xu) } })));
  var ef = ft(Qu = ht(Qu, Gu.width * n.width / (Qu.width * Xu.width)), t({ visibleArea: Qu, type: "resize" }));
  return ef !== 1 && (Qu = ht(Qu, ef), Gu = ht(Gu, ef)), Qu = vt(Qu = at(Qu, it(nt(Gu), nt(Qu))), t({ visibleArea: Qu, type: "move" })), { coordinates: Gu = vt(Gu, zt(et(Qu), c)), visibleArea: Qu };
}
function Et(e) {
  var t = e.event, n = e.getAreaRestrictions, r = e.boundaries, i = e.coordinates, s = e.visibleArea;
  e.aspectRatio, e.stencilSize, e.sizeRestrictions;
  var l = e.positionRestrictions;
  e.stencilReference;
  var c = C({}, i), u = C({}, s);
  if (i && s && t.type !== "manipulateImage") {
    var m = { width: 0, height: 0 };
    u.width, r.width, ct(r) > ct(c) ? (m.height = 0.8 * r.height, m.width = m.height * ct(c)) : (m.width = 0.8 * r.width, m.height = m.width * ct(c));
    var qu = ft(u = ht(u, c.width * r.width / (u.width * m.width)), n({ visibleArea: u, type: "resize" }));
    u = ht(u, qu), qu !== 1 && (m.height /= qu, m.width /= qu), u = vt(u = at(u, it(nt(c), nt(u))), n({ visibleArea: u, type: "move" })), c = vt(c, zt(et(u), l));
  }
  return { coordinates: c, visibleArea: u };
}
function Wt(e) {
  var t = e.event, n = e.coordinates, r = e.visibleArea, i = e.getAreaRestrictions, s = C({}, r), l = C({}, n);
  if (t.type === "setCoordinates") {
    var c = Math.max(0, l.width - s.width), u = Math.max(0, l.height - s.height);
    c > u ? s = ht(s, Math.min(l.width / s.width, lt(s, i({ visibleArea: s, type: "resize" })))) : u > c && (s = ht(s, Math.min(l.height / s.height, lt(s, i({ visibleArea: s, type: "resize" }))))), s = vt(s = at(s, rt(ut(l, et(s)))), i({ visibleArea: s, type: "move" }));
  }
  return { visibleArea: s, coordinates: l };
}
function Tt(e) {
  var t = e.imageSize, n = e.visibleArea, r = e.coordinates, i = n || t;
  return { left: (n ? n.left : 0) + i.width / 2 - r.width / 2, top: (n ? n.top : 0) + i.height / 2 - r.height / 2 };
}
function Ot(e) {
  var t = e.imageSize, n = e.visibleArea, r = e.aspectRatio, i = e.sizeRestrictions, s = n || t, l = Math.min(r.maximum || 1 / 0, Math.max(r.minimum || 0, ct(s))), c = s.width < s.height ? { width: 0.8 * s.width, height: 0.8 * s.width / l } : { height: 0.8 * s.height, width: 0.8 * s.height * l };
  return Mt(C(C({}, c), { aspectRatio: r, sizeRestrictions: i }));
}
function Dt(e) {
  var t, n, r = e.imageSize, i = e.visibleArea, s = e.boundaries, l = e.aspectRatio, c = e.sizeRestrictions, u = e.stencilSize, m = i || r;
  return ct(m) > ct(s) ? n = (t = u.height * m.height / s.height) * ct(u) : t = (n = u.width * m.width / s.width) / ct(u), Mt({ width: n, height: t, aspectRatio: l, sizeRestrictions: c });
}
function Ht(e) {
  var t = e.getAreaRestrictions, n = e.coordinates, r = e.imageSize, i = ct(e.boundaries);
  if (n) {
    var s = { height: Math.max(n.height, r.height), width: Math.max(n.width, r.width) }, l = mt({ width: ct(s) > i ? s.width : s.height * i, height: ct(s) > i ? s.width / i : s.height }, bt(t())), c = { left: n.left + n.width / 2 - l.width / 2, top: n.top + n.height / 2 - l.height / 2, width: l.width, height: l.height }, u = st(n, et(C({ left: 0, top: 0 }, r))), m = {};
    return !u.left && !u.right && c.width <= r.width && (m.left = 0, m.right = r.width), !u.top && !u.bottom && c.height <= r.height && (m.top = 0, m.bottom = r.height), vt(c, m);
  }
  var qu = ct(r);
  return l = { height: qu > i ? r.height : r.width / i, width: qu > i ? r.height * i : r.width }, { left: r.width / 2 - l.width / 2, top: r.height / 2 - l.height / 2, width: l.width, height: l.height };
}
function jt(e, t) {
  return yt(e, et(t));
}
function Lt(e) {
  var t = e.event, n = e.coordinates, r = e.visibleArea, i = e.sizeRestrictions, s = e.getAreaRestrictions, l = e.positionRestrictions, c = e.adjustStencil, u = t.scale, m = t.move, qu = C({}, r), Gu = C({}, n), Qu = 1, Xu = 1, ef = u.factor && Math.abs(u.factor - 1) > 1e-3;
  qu = at(qu, { left: m.left || 0, top: m.top || 0 });
  var tf = { stencil: { minimum: Math.max(i.minWidth ? i.minWidth / Gu.width : 0, i.minHeight ? i.minHeight / Gu.height : 0), maximum: Math.min(i.maxWidth ? i.maxWidth / Gu.width : 1 / 0, i.maxHeight ? i.maxHeight / Gu.height : 1 / 0, lt(Gu, l)) }, area: { maximum: lt(qu, s({ visibleArea: qu, type: "resize" })) } };
  u.factor && ef && (u.factor < 1 ? (Xu = Math.max(u.factor, tf.stencil.minimum)) > 1 && (Xu = 1) : u.factor > 1 && (Xu = Math.min(u.factor, Math.min(tf.area.maximum, tf.stencil.maximum))) < 1 && (Xu = 1)), Xu && (qu = ht(qu, Xu, u.center));
  var af = n.left - r.left, rf = r.width + r.left - (n.width + n.left), hf = n.top - r.top, sf = r.height + r.top - (n.height + n.top);
  return qu = vt(qu = at(qu, ut(qu, { left: l.left !== void 0 ? l.left - af * Xu : void 0, top: l.top !== void 0 ? l.top - hf * Xu : void 0, bottom: l.bottom !== void 0 ? l.bottom + sf * Xu : void 0, right: l.right !== void 0 ? l.right + rf * Xu : void 0 })), s({ visibleArea: qu, type: "move" })), Gu.width = Gu.width * Xu, Gu.height = Gu.height * Xu, Gu.left = qu.left + af * Xu, Gu.top = qu.top + hf * Xu, Gu = vt(Gu, zt(et(qu), l)), u.factor && ef && c && (u.factor > 1 ? Qu = Math.min(tf.area.maximum, u.factor) / Xu : u.factor < 1 && (Qu = Math.max(Gu.height / qu.height, Gu.width / qu.width, u.factor / Xu)), Qu !== 1 && (qu = at(qu = vt(qu = ht(qu, Qu, u.factor > 1 ? u.center : nt(Gu)), s({ visibleArea: qu, type: "move" })), rt(ut(Gu, et(qu)))))), { coordinates: Gu, visibleArea: qu };
}
function Pt(e) {
  var t = e.aspectRatio, n = e.getAreaRestrictions, r = e.coordinates, i = e.visibleArea, s = e.sizeRestrictions, l = e.positionRestrictions, c = e.imageSize, u = e.previousImageSize, m = e.angle, qu = C({}, r), Gu = C({}, i), Qu = gt(nt(C({ left: 0, top: 0 }, u)), m);
  return (qu = C(C({}, Mt({ sizeRestrictions: s, aspectRatio: t, width: qu.width, height: qu.height })), gt(nt(qu), m))).left -= Qu.left - c.width / 2 + qu.width / 2, qu.top -= Qu.top - c.height / 2 + qu.height / 2, Gu = ht(Gu, ft(Gu, n({ visibleArea: Gu, type: "resize" }))), { coordinates: qu = vt(qu, l), visibleArea: Gu = vt(Gu = at(Gu, it(nt(qu), nt(r))), n({ visibleArea: Gu, type: "move" })) };
}
function $t(e) {
  var t = e.flip, n = e.previousFlip, r = e.rotate, i = e.getAreaRestrictions, s = e.coordinates, l = e.visibleArea, c = e.imageSize, u = C({}, s), m = C({}, l), qu = n.horizontal !== t.horizontal, Gu = n.vertical !== t.vertical;
  if (qu || Gu) {
    var Qu = gt({ left: c.width / 2, top: c.height / 2 }, -r), Xu = gt(nt(u), -r), ef = gt({ left: qu ? Qu.left - (Xu.left - Qu.left) : Xu.left, top: Gu ? Qu.top - (Xu.top - Qu.top) : Xu.top }, r);
    u = at(u, it(ef, nt(u))), Xu = gt(nt(m), -r), m = vt(m = at(m, it(ef = gt({ left: qu ? Qu.left - (Xu.left - Qu.left) : Xu.left, top: Gu ? Qu.top - (Xu.top - Qu.top) : Xu.top }, r), nt(m))), i({ visibleArea: m, type: "move" }));
  }
  return { coordinates: u, visibleArea: m };
}
function It(e) {
  var t = e.directions, n = e.coordinates, r = e.positionRestrictions, i = r === void 0 ? {} : r, s = e.sizeRestrictions, l = e.preserveRatio, c = e.compensate, u = C({}, t), m = ot(n, u).width, qu = ot(n, u).height;
  m < 0 && (u.left < 0 && u.right < 0 ? (u.left = -(n.width - s.minWidth) / (u.left / u.right), u.right = -(n.width - s.minWidth) / (u.right / u.left)) : u.left < 0 ? u.left = -(n.width - s.minWidth) : u.right < 0 && (u.right = -(n.width - s.minWidth))), qu < 0 && (u.top < 0 && u.bottom < 0 ? (u.top = -(n.height - s.minHeight) / (u.top / u.bottom), u.bottom = -(n.height - s.minHeight) / (u.bottom / u.top)) : u.top < 0 ? u.top = -(n.height - s.minHeight) : u.bottom < 0 && (u.bottom = -(n.height - s.minHeight)));
  var Gu = st(ot(n, u), i);
  c && (Gu.left && Gu.left > 0 && Gu.right === 0 ? (u.right += Gu.left, u.left -= Gu.left) : Gu.right && Gu.right > 0 && Gu.left === 0 && (u.left += Gu.right, u.right -= Gu.right), Gu.top && Gu.top > 0 && Gu.bottom === 0 ? (u.bottom += Gu.top, u.top -= Gu.top) : Gu.bottom && Gu.bottom > 0 && Gu.top === 0 && (u.top += Gu.bottom, u.bottom -= Gu.bottom), Gu = st(ot(n, u), i));
  var Qu = { width: 1 / 0, height: 1 / 0, left: 1 / 0, right: 1 / 0, top: 1 / 0, bottom: 1 / 0 };
  if (V.forEach(function(tf) {
    var af = Gu[tf];
    af && u[tf] && (Qu[tf] = Math.max(0, 1 - af / u[tf]));
  }), l) {
    var Xu = Math.min.apply(null, V.map(function(tf) {
      return Qu[tf];
    }));
    Xu !== 1 / 0 && V.forEach(function(tf) {
      u[tf] *= Xu;
    });
  } else V.forEach(function(tf) {
    Qu[tf] !== 1 / 0 && (u[tf] *= Qu[tf]);
  });
  if (m = ot(n, u).width, qu = ot(n, u).height, u.right + u.left && (m > s.maxWidth ? Qu.width = (s.maxWidth - n.width) / (u.right + u.left) : m < s.minWidth && (Qu.width = (s.minWidth - n.width) / (u.right + u.left))), u.bottom + u.top && (qu > s.maxHeight ? Qu.height = (s.maxHeight - n.height) / (u.bottom + u.top) : qu < s.minHeight && (Qu.height = (s.minHeight - n.height) / (u.bottom + u.top))), l) {
    var ef = Math.min(Qu.width, Qu.height);
    ef !== 1 / 0 && V.forEach(function(tf) {
      u[tf] *= ef;
    });
  } else Qu.width !== 1 / 0 && _.forEach(function(tf) {
    u[tf] *= Qu.width;
  }), Qu.height !== 1 / 0 && G.forEach(function(tf) {
    u[tf] *= Qu.height;
  });
  return u;
}
function Bt(e, t, n) {
  return t == 0 && n == 0 ? e / 2 : t == 0 ? 0 : n == 0 ? e : e * Math.abs(t / (t + n));
}
var Xt = M("vue-simple-handler"), Yt = M("vue-simple-handler-wrapper"), kt = { name: "SimpleHandler", components: { HandlerWrapper: N }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  var e, t = (f(e = {}, this.horizontalPosition, !!this.horizontalPosition), f(e, this.verticalPosition, !!this.verticalPosition), f(e, "".concat(this.horizontalPosition, "-").concat(this.verticalPosition), !!(this.verticalPosition && this.horizontalPosition)), f(e, "hover", this.hover), e);
  return { default: A(Xt(t), this.defaultClass, this.hover && this.hoverClass), wrapper: A(Yt(t), this.wrapperClass) };
} }, methods: { onDrag: function(e) {
  this.$emit("drag", e);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
kt.render = function(e, t, n, r, i, s) {
  var l = resolveComponent("HandlerWrapper");
  return openBlock(), createBlock(l, { class: s.classes.wrapper, "vertical-position": n.verticalPosition, "horizontal-position": n.horizontalPosition, disabled: n.disabled, onDrag: s.onDrag, onDragEnd: s.onDragEnd, onEnter: s.onEnter, onLeave: s.onLeave }, { default: withCtx(function() {
    return [createVNode("div", { class: s.classes.default }, null, 2)];
  }), _: 1 }, 8, ["class", "vertical-position", "horizontal-position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var Ft = M("vue-simple-line"), Ut = M("vue-simple-line-wrapper"), Nt = { name: "SimpleLine", components: { LineWrapper: q }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, position: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  return { root: A(Ft(f({}, this.position, !0)), this.defaultClass, this.hover && this.hoverClass), wrapper: A(Ut(f({}, this.position, !0)), this.wrapperClass) };
} }, methods: { onDrag: function(e) {
  this.$emit("drag", e);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
Nt.render = function(e, t, n, r, i, s) {
  var l = resolveComponent("LineWrapper");
  return openBlock(), createBlock(l, { class: s.classes.wrapper, position: n.position, disabled: n.disabled, onDrag: s.onDrag, onDragEnd: s.onDragEnd, onEnter: s.onEnter, onLeave: s.onLeave }, { default: withCtx(function() {
    return [createVNode("div", { class: s.classes.root }, null, 2)];
  }), _: 1 }, 8, ["class", "position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var Zt = M("vue-bounding-box"), qt = ["east", "west", null], Vt = ["south", "north", null], _t = { name: "BoundingBox", props: { width: { type: Number }, height: { type: Number }, transitions: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, north: !0, westNorth: !0, west: !0, westSouth: !0, south: !0, eastSouth: !0, east: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return kt;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object, default: function() {
  return { west: !0, north: !0, east: !0, south: !0 };
} }, linesComponent: { type: [Object, String], default: function() {
  return Nt;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, resizable: { type: Boolean, default: !0 } }, data: function() {
  var e = [];
  return qt.forEach(function(t) {
    Vt.forEach(function(n) {
      if (t !== n) {
        var r = E(t, n), i = r.name, s = r.classname;
        e.push({ name: i, classname: s, verticalDirection: n, horizontalDirection: t });
      }
    });
  }), { points: e };
}, computed: { style: function() {
  var e = {};
  return this.width && this.height && (e.width = "".concat(this.width, "px"), e.height = "".concat(this.height, "px"), this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction))), e;
}, classes: function() {
  var e = this.handlersClasses, t = this.handlersWrappersClasses, n = this.linesClasses, r = this.linesWrappersClasses;
  return { root: Zt(), handlers: e, handlersWrappers: t, lines: n, linesWrappers: r };
}, lineNodes: function() {
  var e = this, t = [];
  return this.points.forEach(function(n) {
    n.horizontalDirection && n.verticalDirection || !e.lines[n.name] || t.push({ name: n.name, component: e.linesComponent, class: A(e.classes.lines.default, e.classes.lines[n.name], !e.resizable && e.classes.lines.disabled), wrapperClass: A(e.classes.linesWrappers.default, e.classes.linesWrappers[n.name], !e.resizable && e.classes.linesWrappers.disabled), hoverClass: e.classes.lines.hover, verticalDirection: n.verticalDirection, horizontalDirection: n.horizontalDirection, disabled: !e.resizable });
  }), t;
}, handlerNodes: function() {
  var e = this, t = [], n = this.width, r = this.height;
  return this.points.forEach(function(i) {
    if (e.handlers[i.name]) {
      var s = { name: i.name, component: e.handlersComponent, class: A(e.classes.handlers.default, e.classes.handlers[i.name]), wrapperClass: A(e.classes.handlersWrappers.default, e.classes.handlersWrappers[i.name]), hoverClass: e.classes.handlers.hover, verticalDirection: i.verticalDirection, horizontalDirection: i.horizontalDirection, disabled: !e.resizable };
      if (n && r) {
        var l = i.horizontalDirection, c = i.verticalDirection, u = l === "east" ? n : l === "west" ? 0 : n / 2, m = c === "south" ? r : c === "north" ? 0 : r / 2;
        s.wrapperClass = Zt("handler"), s.wrapperStyle = { transform: "translate(".concat(u, "px, ").concat(m, "px)") }, e.transitions && e.transitions.enabled && (s.wrapperStyle.transition = "".concat(e.transitions.time, "ms ").concat(e.transitions.timingFunction));
      } else s.wrapperClass = Zt("handler", f({}, i.classname, !0));
      t.push(s);
    }
  }), t;
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [];
}, methods: { onEnd: function() {
  this.$emit("resize-end");
}, onHandlerDrag: function(e, t, n) {
  var r, i = e.shift(), s = i.left, l = i.top, c = { left: 0, right: 0, top: 0, bottom: 0 };
  t === "west" ? c.left -= s : t === "east" && (c.right += s), n === "north" ? c.top -= l : n === "south" && (c.bottom += l), !n && t ? r = "width" : n && !t && (r = "height"), this.resizable && this.$emit("resize", new X(c, { allowedDirections: { left: t === "west" || !t, right: t === "east" || !t, bottom: n === "south" || !n, top: n === "north" || !n }, preserveAspectRatio: e.nativeEvent && e.nativeEvent.shiftKey, respectDirection: r }));
} }, emits: ["resize", "resize-end"] };
_t.render = function(e, t, n, r, i, s) {
  return openBlock(), createBlock("div", { ref: "box", class: s.classes.root, style: s.style }, [renderSlot(e.$slots, "default"), createVNode("div", null, [(openBlock(!0), createBlock(Fragment, null, renderList(s.lineNodes, function(l) {
    return openBlock(), createBlock(resolveDynamicComponent(l.component), { key: l.name, "default-class": l.class, "hover-class": l.hoverClass, "wrapper-class": l.wrapperClass, position: l.name, disabled: l.disabled, onDrag: function(c) {
      return s.onHandlerDrag(c, l.horizontalDirection, l.verticalDirection);
    }, onDragEnd: t[1] || (t[1] = function(c) {
      return s.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "position", "disabled", "onDrag"]);
  }), 128))]), (openBlock(!0), createBlock(Fragment, null, renderList(s.handlerNodes, function(l) {
    return openBlock(), createBlock("div", { key: l.name, style: l.wrapperStyle, class: l.wrapperClass }, [(openBlock(), createBlock(resolveDynamicComponent(l.component), { "default-class": l.class, "hover-class": l.hoverClass, "wrapper-class": l.wrapperClass, "horizontal-position": l.horizontalDirection, "vertical-position": l.verticalDirection, disabled: l.disabled, onDrag: function(c) {
      return s.onHandlerDrag(c, l.horizontalDirection, l.verticalDirection);
    }, onDragEnd: t[2] || (t[2] = function(c) {
      return s.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "horizontal-position", "vertical-position", "disabled", "onDrag"]))], 6);
  }), 128))], 6);
};
var Gt = M("vue-draggable-area"), Qt = { name: "DraggableArea", props: { movable: { type: Boolean, default: !0 }, activationDistance: { type: Number, default: 20 } }, computed: { classnames: function() {
  return { default: Gt() };
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [], this.touchStarted = !1;
}, methods: { onTouchStart: function(e) {
  if (e.cancelable) {
    var t = this.movable && e.touches.length === 1;
    t && (this.touches = b(e.touches)), (this.touchStarted || t) && (e.preventDefault(), e.stopPropagation());
  }
}, onTouchEnd: function() {
  this.touchStarted = !1, this.processEnd();
}, onTouchMove: function(e) {
  this.touches.length >= 1 && (this.touchStarted ? (this.processMove(e, e.touches), e.preventDefault(), e.stopPropagation()) : I({ x: this.touches[0].clientX, y: this.touches[0].clientY }, { x: e.touches[0].clientX, y: e.touches[0].clientY }) > this.activationDistance && (this.initAnchor({ clientX: e.touches[0].clientX, clientY: e.touches[0].clientY }), this.touchStarted = !0));
}, onMouseDown: function(e) {
  if (this.movable && e.button === 0) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.initAnchor(t), e.stopPropagation();
  }
}, onMouseMove: function(e) {
  this.touches.length && (this.processMove(e, [{ fake: !0, clientX: e.clientX, clientY: e.clientY }]), e.preventDefault && e.cancelable && e.preventDefault(), e.stopPropagation());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(e) {
  var t = this.$refs.container.getBoundingClientRect(), n = t.left, r = t.top;
  this.anchor = { x: e.clientX - n, y: e.clientY - r };
}, processMove: function(e, t) {
  var n = b(t);
  if (this.touches.length) {
    var r = this.$refs.container.getBoundingClientRect(), i = r.left, s = r.top;
    this.touches.length === 1 && n.length === 1 && this.$emit("move", new Y({ left: n[0].clientX - (i + this.anchor.x), top: n[0].clientY - (s + this.anchor.y) }));
  }
}, processEnd: function() {
  this.touches.length && this.$emit("move-end"), this.touches = [];
} }, emits: ["move", "move-end"] };
Qt.render = function(e, t, n, r, i, s) {
  return openBlock(), createBlock("div", { ref: "container", onTouchstart: t[1] || (t[1] = function() {
    return s.onTouchStart && s.onTouchStart.apply(s, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return s.onMouseDown && s.onMouseDown.apply(s, arguments);
  }) }, [renderSlot(e.$slots, "default")], 544);
};
function Kt(e) {
  var t, n;
  return { rotate: e.rotate || 0, flip: { horizontal: ((t = e == null ? void 0 : e.flip) === null || t === void 0 ? void 0 : t.horizontal) || !1, vertical: ((n = e == null ? void 0 : e.flip) === null || n === void 0 ? void 0 : n.vertical) || !1 } };
}
function Jt(e) {
  return new Promise(function(t, n) {
    try {
      if (e) if (/^data:/i.test(e)) t(function(u) {
        u = u.replace(/^data:([^;]+);base64,/gim, "");
        for (var m = atob(u), qu = m.length, Gu = new ArrayBuffer(qu), Qu = new Uint8Array(Gu), Xu = 0; Xu < qu; Xu++) Qu[Xu] = m.charCodeAt(Xu);
        return Gu;
      }(e));
      else if (/^blob:/i.test(e)) {
        var r = new FileReader();
        r.onload = function(u) {
          t(u.target.result);
        }, s = e, l = function(u) {
          r.readAsArrayBuffer(u);
        }, (c = new XMLHttpRequest()).open("GET", s, !0), c.responseType = "blob", c.onload = function() {
          this.status != 200 && this.status !== 0 || l(this.response);
        }, c.send();
      } else {
        var i = new XMLHttpRequest();
        i.onreadystatechange = function() {
          i.readyState === 4 && (i.status === 200 || i.status === 0 ? t(i.response) : n("Warning: could not load an image to parse its orientation"), i = null);
        }, i.onprogress = function() {
          i.getResponseHeader("content-type") !== "image/jpeg" && i.abort();
        }, i.withCredentials = !1, i.open("GET", e, !0), i.responseType = "arraybuffer", i.send(null);
      }
      else n("Error: the image is empty");
    } catch (u) {
      n(u);
    }
    var s, l, c;
  });
}
function te(e) {
  var t = e.rotate, n = e.flip, r = e.scaleX, i = e.scaleY, s = "";
  return s += " rotate(" + t + "deg) ", s += " scaleX(" + r * (n.horizontal ? -1 : 1) + ") ", s += " scaleY(" + i * (n.vertical ? -1 : 1) + ") ";
}
function ee(e) {
  try {
    var t, n = new DataView(e), r = void 0, i = void 0, s = void 0, l = void 0;
    if (n.getUint8(0) === 255 && n.getUint8(1) === 216) for (var c = n.byteLength, u = 2; u + 1 < c; ) {
      if (n.getUint8(u) === 255 && n.getUint8(u + 1) === 225) {
        s = u;
        break;
      }
      u++;
    }
    if (s && (r = s + 10, function(Xu, ef, tf) {
      var af, rf = "";
      for (af = ef, tf += ef; af < tf; af++) rf += String.fromCharCode(Xu.getUint8(af));
      return rf;
    }(n, s + 4, 4) === "Exif")) {
      var m = n.getUint16(r);
      if (((i = m === 18761) || m === 19789) && n.getUint16(r + 2, i) === 42) {
        var qu = n.getUint32(r + 4, i);
        qu >= 8 && (l = r + qu);
      }
    }
    if (l) {
      for (var Gu = n.getUint16(l, i), Qu = 0; Qu < Gu; Qu++)
        if (u = l + 12 * Qu + 2, n.getUint16(u, i) === 274) {
          u += 8, t = n.getUint16(u, i), n.setUint16(u, 1, i);
          break;
        }
    }
    return t;
  } catch {
    return null;
  }
}
function se(e, t) {
  var n = t.getBoundingClientRect(), r = n.left, i = n.top, s = { left: 0, top: 0 }, l = 0;
  return e.forEach(function(c) {
    s.left += (c.clientX - r) / e.length, s.top += (c.clientY - i) / e.length;
  }), e.forEach(function(c) {
    l += I({ x: s.left, y: s.top }, { x: c.clientX - r, y: c.clientY - i });
  }), { centerMass: s, spread: l, count: e.length };
}
var oe = { props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 }, eventsFilter: { type: Function, required: !1 } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, created: function() {
  this.transforming = !1, this.debouncedProcessEnd = x(this.processEnd), this.touches = [];
}, methods: { processMove: function(e, t) {
  if (this.touches.length) {
    if (this.touches.length === 1 && t.length === 1) this.$emit("move", new B({ left: this.touches[0].clientX - t[0].clientX, top: this.touches[0].clientY - t[0].clientY }));
    else if (this.touches.length > 1 && this.touchResize) {
      var n = se(t, this.$refs.container), r = this.oldGeometricProperties;
      r.count === n.count && r.count > 1 && this.$emit("resize", new B({ left: r.centerMass.left - n.centerMass.left, top: r.centerMass.top - n.centerMass.top }, { factor: r.spread / n.spread, center: n.centerMass })), this.oldGeometricProperties = n;
    }
    this.touches = t;
  }
}, processEnd: function() {
  this.transforming && (this.transforming = !1, this.$emit("transform-end"));
}, processStart: function() {
  this.transforming = !0, this.debouncedProcessEnd.clear();
}, processEvent: function(e) {
  return this.eventsFilter ? this.eventsFilter(e, this.transforming) !== !1 : (e.preventDefault(), e.stopPropagation(), !0);
}, onTouchStart: function(e) {
  if (e.cancelable && (this.touchMove || this.touchResize && e.touches.length > 1) && this.processEvent(e)) {
    var t = this.$refs.container, n = t.getBoundingClientRect(), r = n.left, i = n.top, s = n.bottom, l = n.right;
    this.touches = b(e.touches).filter(function(c) {
      return c.clientX > r && c.clientX < l && c.clientY > i && c.clientY < s;
    }), this.oldGeometricProperties = se(this.touches, t);
  }
}, onTouchEnd: function(e) {
  e.touches.length === 0 && (this.touches = [], this.processEnd());
}, onTouchMove: function(e) {
  var t = this;
  if (this.touches.length) {
    var n = b(e.touches).filter(function(r) {
      return !r.identifier || t.touches.find(function(i) {
        return i.identifier === r.identifier;
      });
    });
    this.processEvent(e) && (this.processMove(e, n), this.processStart());
  }
}, onMouseDown: function(e) {
  if (this.mouseMove && "buttons" in e && e.buttons === 1 && this.processEvent(e)) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.processStart();
  }
}, onMouseMove: function(e) {
  this.touches.length && this.processEvent(e) && this.processMove(e, [{ clientX: e.clientX, clientY: e.clientY }]);
}, onMouseUp: function() {
  this.touches = [], this.processEnd();
}, onWheel: function(e) {
  if (this.wheelResize && this.processEvent(e)) {
    var t = this.$refs.container.getBoundingClientRect(), n = t.left, r = t.top, i = 1 + this.wheelResize.ratio * (l = e.deltaY || e.detail || e.wheelDelta, (c = +l) == 0 || $(c) ? c : c > 0 ? 1 : -1), s = { left: e.clientX - n, top: e.clientY - r };
    this.$emit("resize", new B({}, { factor: i, center: s })), this.touches.length || this.debouncedProcessEnd();
  }
  var l, c;
} }, emits: ["resize", "move", "transform-end"] };
oe.render = function(e, t, n, r, i, s) {
  return openBlock(), createBlock("div", { ref: "container", onTouchstart: t[1] || (t[1] = function() {
    return s.onTouchStart && s.onTouchStart.apply(s, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return s.onMouseDown && s.onMouseDown.apply(s, arguments);
  }), onWheel: t[3] || (t[3] = function() {
    return s.onWheel && s.onWheel.apply(s, arguments);
  }) }, [renderSlot(e.$slots, "default")], 544);
};
var re = { components: { TransformableImage: oe }, props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 } }, emits: ["resize", "move"] };
re.render = function(e, t, n, r, i, s) {
  var l = resolveComponent("transformable-image");
  return openBlock(), createBlock(l, { "touch-move": n.touchMove, "touch-resize": n.touchResize, "mouse-move": n.mouseMove, "wheel-resize": n.wheelResize, onMove: t[1] || (t[1] = function(c) {
    return e.$emit("move", c);
  }), onResize: t[2] || (t[2] = function(c) {
    return e.$emit("resize", c);
  }) }, { default: withCtx(function() {
    return [renderSlot(e.$slots, "default")];
  }), _: 3 }, 8, ["touch-move", "touch-resize", "mouse-move", "wheel-resize"]);
};
var ae = M("vue-preview"), he = { props: { coordinates: { type: Object }, transitions: { type: Object }, image: { type: Object, default: function() {
  return {};
} }, imageClass: { type: String }, width: { type: Number }, height: { type: Number }, fill: { type: Boolean } }, data: function() {
  return { calculatedImageSize: { width: 0, height: 0 }, calculatedSize: { width: 0, height: 0 } };
}, computed: { classes: function() {
  return { root: ae({ fill: this.fill }), wrapper: ae("wrapper"), imageWrapper: ae("image-wrapper"), image: A(ae("image"), this.imageClass) };
}, style: function() {
  if (this.fill) return {};
  var e = {};
  return this.width && (e.width = "".concat(this.size.width, "px")), this.height && (e.height = "".concat(this.size.height, "px")), this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), e;
}, wrapperStyle: function() {
  var e = { width: "".concat(this.size.width, "px"), height: "".concat(this.size.height, "px"), left: "calc(50% - ".concat(this.size.width / 2, "px)"), top: "calc(50% - ".concat(this.size.height / 2, "px)") };
  return this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), e;
}, imageStyle: function() {
  if (this.coordinates && this.image) {
    var e = this.coordinates.width / this.size.width, t = g(g({ rotate: 0, flip: { horizontal: !1, vertical: !1 } }, this.image.transforms), {}, { scaleX: 1 / e, scaleY: 1 / e }), n = this.imageSize.width, r = this.imageSize.height, i = pt({ width: n, height: r }, t.rotate), s = { width: "".concat(n, "px"), height: "".concat(r, "px"), left: "0px", top: "0px" }, l = { rotate: { left: (n - i.width) * t.scaleX / 2, top: (r - i.height) * t.scaleY / 2 }, scale: { left: (1 - t.scaleX) * n / 2, top: (1 - t.scaleY) * r / 2 } };
    return s.transform = `translate(
				`.concat(-this.coordinates.left / e - l.rotate.left - l.scale.left, "px,").concat(-this.coordinates.top / e - l.rotate.top - l.scale.top, "px) ") + te(t), this.transitions && this.transitions.enabled && (s.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), s;
  }
  return {};
}, size: function() {
  return { width: this.width || this.calculatedSize.width, height: this.height || this.calculatedSize.height };
}, imageSize: function() {
  return { width: this.image.width || this.calculatedImageSize.width, height: this.image.height || this.calculatedImageSize.height };
} }, watch: { image: function(e) {
  (e.width || e.height) && this.onChangeImage();
} }, mounted: function() {
  var e = this;
  this.onChangeImage(), this.$refs.image.addEventListener("load", function() {
    e.refreshImage();
  }), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh);
}, methods: { refreshImage: function() {
  var e = this.$refs.image;
  this.calculatedImageSize.height = e.naturalHeight, this.calculatedImageSize.width = e.naturalWidth;
}, refresh: function() {
  var e = this.$refs.root;
  this.width || (this.calculatedSize.width = e.clientWidth), this.height || (this.calculatedSize.height = e.clientHeight);
}, onChangeImage: function() {
  var e = this.$refs.image;
  e && e.complete && this.refreshImage(), this.refresh();
} } };
he.render = function(e, t, n, r, i, s) {
  return openBlock(), createBlock("div", { ref: "root", class: s.classes.root, style: s.style }, [createVNode("div", { ref: "wrapper", class: s.classes.wrapper, style: s.wrapperStyle }, [withDirectives(createVNode("img", { ref: "image", src: n.image && n.image.src, class: s.classes.image, style: s.imageStyle }, null, 14, ["src"]), [[vShow, n.image && n.image.src]])], 6)], 6);
};
var ce = { components: { Preview: he }, inheritAttrs: !1 };
ce.render = function(e, t, n, r, i, s) {
  var l = resolveComponent("preview");
  return openBlock(), createBlock(l, mergeProps$1(e.$attrs, { fill: !0 }), null, 16);
};
var le = M("vue-rectangle-stencil"), ue = { name: "RectangleStencil", components: { StencilPreview: ce, BoundingBox: _t, DraggableArea: Qt }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object }, handlersComponent: { type: [Object, String], default: function() {
  return kt;
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return Nt;
} }, aspectRatio: { type: [Number, String] }, minAspectRatio: { type: [Number, String] }, maxAspectRatio: { type: [Number, String] }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: A(le({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: A(le("preview"), this.previewClass), boundingBox: A(le("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var e = this.stencilCoordinates, t = e.height, n = e.width, r = e.left, i = e.top, s = { width: "".concat(n, "px"), height: "".concat(t, "px"), transform: "translate(".concat(r, "px, ").concat(i, "px)") };
  return this.transitions && this.transitions.enabled && (s.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), s;
} }, methods: { onMove: function(e) {
  this.$emit("move", e), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(e) {
  this.$emit("resize", e), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: this.aspectRatio || this.minAspectRatio, maximum: this.aspectRatio || this.maxAspectRatio };
} }, emits: ["resize", "resize-end", "move", "move-end"] };
ue.render = function(e, t, n, r, i, s) {
  var l = resolveComponent("stencil-preview"), c = resolveComponent("draggable-area"), u = resolveComponent("bounding-box");
  return openBlock(), createBlock("div", { class: s.classes.stencil, style: s.style }, [createVNode(u, { width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, transitions: n.transitions, class: s.classes.boundingBox, handlers: n.handlers, "handlers-component": n.handlersComponent, "handlers-classes": n.handlersClasses, "handlers-wrappers-classes": n.handlersWrappersClasses, lines: n.lines, "lines-component": n.linesComponent, "lines-classes": n.linesClasses, "lines-wrappers-classes": n.linesWrappersClasses, resizable: n.resizable, onResize: s.onResize, onResizeEnd: s.onResizeEnd }, { default: withCtx(function() {
    return [createVNode(c, { movable: n.movable, onMove: s.onMove, onMoveEnd: s.onMoveEnd }, { default: withCtx(function() {
      return [createVNode(l, { image: n.image, coordinates: n.coordinates, width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, class: s.classes.preview, transitions: n.transitions }, null, 8, ["image", "coordinates", "width", "height", "class", "transitions"])];
    }), _: 1 }, 8, ["movable", "onMove", "onMoveEnd"])];
  }), _: 1 }, 8, ["width", "height", "transitions", "class", "handlers", "handlers-component", "handlers-classes", "handlers-wrappers-classes", "lines", "lines-component", "lines-classes", "lines-wrappers-classes", "resizable", "onResize", "onResizeEnd"])], 6);
};
var de = M("vue-circle-stencil"), me = { components: { StencilPreview: ce, BoundingBox: _t, DraggableArea: Qt }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, westNorth: !0, westSouth: !0, eastSouth: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return kt;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return Nt;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: A(de({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: A(de("preview"), this.previewClass), boundingBox: A(de("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var e = this.stencilCoordinates, t = e.height, n = e.width, r = e.left, i = e.top, s = { width: "".concat(n, "px"), height: "".concat(t, "px"), transform: "translate(".concat(r, "px, ").concat(i, "px)") };
  return this.transitions && this.transitions.enabled && (s.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), s;
} }, methods: { onMove: function(e) {
  this.$emit("move", e), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(e) {
  this.$emit("resize", e), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: 1, maximum: 1 };
} }, emits: ["resize", "resize-end", "move", "move-end"] };
me.render = function(e, t, n, r, i, s) {
  var l = resolveComponent("stencil-preview"), c = resolveComponent("draggable-area"), u = resolveComponent("bounding-box");
  return openBlock(), createBlock("div", { class: s.classes.stencil, style: s.style }, [createVNode(u, { width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, transitions: n.transitions, class: s.classes.boundingBox, handlers: n.handlers, "handlers-component": n.handlersComponent, "handlers-classes": n.handlersClasses, "handlers-wrappers-classes": n.handlersWrappersClasses, lines: n.lines, "lines-component": n.linesComponent, "lines-classes": n.linesClasses, "lines-wrappers-classes": n.linesWrappersClasses, resizable: n.resizable, onResize: s.onResize, onResizeEnd: s.onResizeEnd }, { default: withCtx(function() {
    return [createVNode(c, { movable: n.movable, onMove: s.onMove, onMoveEnd: s.onMoveEnd }, { default: withCtx(function() {
      return [createVNode(l, { image: n.image, coordinates: n.coordinates, width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, class: s.classes.preview, transitions: n.transitions }, null, 8, ["image", "coordinates", "width", "height", "class", "transitions"])];
    }), _: 1 }, 8, ["movable", "onMove", "onMoveEnd"])];
  }), _: 1 }, 8, ["width", "height", "transitions", "class", "handlers", "handlers-component", "handlers-classes", "handlers-wrappers-classes", "lines", "lines-component", "lines-classes", "lines-wrappers-classes", "resizable", "onResize", "onResizeEnd"])], 6);
};
var pe = ["transitions"], ge = M("vue-advanced-cropper"), fe = { name: "Cropper", components: { BackgroundWrapper: re }, props: { src: { type: String, default: null }, stencilComponent: { type: [Object, String], default: function() {
  return ue;
} }, backgroundWrapperComponent: { type: [Object, String], default: function() {
  return re;
} }, stencilProps: { type: Object, default: function() {
  return {};
} }, autoZoom: { type: Boolean, default: !1 }, imageClass: { type: String }, boundariesClass: { type: String }, backgroundClass: { type: String }, foregroundClass: { type: String }, minWidth: { type: [Number, String] }, minHeight: { type: [Number, String] }, maxWidth: { type: [Number, String] }, maxHeight: { type: [Number, String] }, debounce: { type: [Boolean, Number], default: 500 }, transitions: { type: Boolean, default: !0 }, checkOrientation: { type: Boolean, default: !0 }, canvas: { type: [Object, Boolean], default: !0 }, crossOrigin: { type: [Boolean, String], default: void 0 }, transitionTime: { type: Number, default: 300 }, imageRestriction: { type: String, default: "fit-area", validator: function(e) {
  return K.indexOf(e) !== -1;
} }, roundResult: { type: Boolean, default: !0 }, defaultSize: { type: [Function, Object] }, defaultPosition: { type: [Function, Object] }, defaultVisibleArea: { type: [Function, Object] }, defaultTransforms: { type: [Function, Object] }, defaultBoundaries: { type: [Function, String], validator: function(e) {
  return !(typeof e == "string" && e !== "fill" && e !== "fit");
} }, priority: { type: String, default: "coordinates" }, stencilSize: { type: [Object, Function] }, resizeImage: { type: [Boolean, Object], default: !0 }, moveImage: { type: [Boolean, Object], default: !0 }, autoZoomAlgorithm: { type: Function }, resizeAlgorithm: { type: Function, default: function(e) {
  var t = e.event, n = e.coordinates, r = e.aspectRatio, i = e.positionRestrictions, s = e.sizeRestrictions, l = C(C({}, n), { right: n.left + n.width, bottom: n.top + n.height }), c = t.params || {}, u = C({}, t.directions), m = c.allowedDirections || { left: !0, right: !0, bottom: !0, top: !0 };
  s.widthFrozen && (u.left = 0, u.right = 0), s.heightFrozen && (u.top = 0, u.bottom = 0), V.forEach(function(pf) {
    m[pf] || (u[pf] = 0);
  });
  var qu = ot(l, u = It({ coordinates: l, directions: u, sizeRestrictions: s, positionRestrictions: i })).width, Gu = ot(l, u).height, Qu = c.preserveRatio ? ct(l) : dt(qu / Gu, r);
  if (Qu) {
    var Xu = c.respectDirection;
    if (Xu || (Xu = l.width >= l.height || Qu === 1 ? "width" : "height"), Xu === "width") {
      var ef = qu / Qu - l.height;
      if (m.top && m.bottom) {
        var tf = u.top, af = u.bottom;
        u.bottom = Bt(ef, af, tf), u.top = Bt(ef, tf, af);
      } else m.bottom ? u.bottom = ef : m.top ? u.top = ef : m.right ? u.right = 0 : m.left && (u.left = 0);
    } else if (Xu === "height") {
      var rf = l.width - Gu * Qu;
      if (m.left && m.right) {
        var hf = u.left, sf = u.right;
        u.left = -Bt(rf, hf, sf), u.right = -Bt(rf, sf, hf);
      } else m.left ? u.left = -rf : m.right ? u.right = -rf : m.top ? u.top = 0 : m.bottom && (u.bottom = 0);
    }
    u = It({ directions: u, coordinates: l, sizeRestrictions: s, positionRestrictions: i, preserveRatio: !0, compensate: c.compensate });
  }
  return qu = ot(l, u).width, Gu = ot(l, u).height, (Qu = c.preserveRatio ? ct(l) : dt(qu / Gu, r)) && Math.abs(Qu - qu / Gu) > 1e-3 && V.forEach(function(pf) {
    m[pf] || (u[pf] = 0);
  }), St({ event: new Y({ left: -u.left, top: -u.top }), coordinates: { width: n.width + u.right + u.left, height: n.height + u.top + u.bottom, left: n.left, top: n.top }, positionRestrictions: i });
} }, moveAlgorithm: { type: Function, default: St }, initStretcher: { type: Function, default: function(e) {
  var t = e.stretcher, n = e.imageSize, r = ct(n);
  t.style.width = n.width + "px", t.style.height = t.clientWidth / r + "px", t.style.width = t.clientWidth + "px";
} }, fitCoordinates: { type: Function, default: function(e) {
  var t = e.visibleArea, n = e.coordinates, r = e.aspectRatio, i = e.sizeRestrictions, s = e.positionRestrictions, l = C(C({}, n), Mt({ width: n.width, height: n.height, aspectRatio: r, sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minHeight: Math.min(t.height, i.minHeight), minWidth: Math.min(t.width, i.minWidth) } }));
  return l = vt(l = at(l, it(nt(n), nt(l))), zt(et(t), s));
} }, fitVisibleArea: { type: Function, default: function(e) {
  var t = e.visibleArea, n = e.boundaries, r = e.getAreaRestrictions, i = e.coordinates, s = C({}, t);
  s.height = s.width / ct(n), s.top += (t.height - s.height) / 2, (i.height - s.height > 0 || i.width - s.width > 0) && (s = ht(s, Math.max(i.height / s.height, i.width / s.width)));
  var l = rt(ut(i, et(s = ht(s, ft(s, r({ visibleArea: s, type: "resize" }))))));
  return s.width < i.width && (l.left = 0), s.height < i.height && (l.top = 0), s = vt(s = at(s, l), r({ visibleArea: s, type: "move" }));
} }, areaRestrictionsAlgorithm: { type: Function, default: function(e) {
  var t = e.visibleArea, n = e.boundaries, r = e.imageSize, i = e.imageRestriction, s = e.type, l = {};
  return i === "fill-area" ? l = { left: 0, top: 0, right: r.width, bottom: r.height } : i === "fit-area" && (ct(n) > ct(r) ? (l = { top: 0, bottom: r.height }, t && s === "move" && (t.width > r.width ? (l.left = -(t.width - r.width) / 2, l.right = r.width - l.left) : (l.left = 0, l.right = r.width))) : (l = { left: 0, right: r.width }, t && s === "move" && (t.height > r.height ? (l.top = -(t.height - r.height) / 2, l.bottom = r.height - l.top) : (l.top = 0, l.bottom = r.height)))), l;
} }, sizeRestrictionsAlgorithm: { type: Function, default: function(e) {
  return { minWidth: e.minWidth, minHeight: e.minHeight, maxWidth: e.maxWidth, maxHeight: e.maxHeight };
} }, positionRestrictionsAlgorithm: { type: Function, default: function(e) {
  var t = e.imageSize, n = {};
  return e.imageRestriction !== "none" && (n = { left: 0, top: 0, right: t.width, bottom: t.height }), n;
} } }, data: function() {
  return { transitionsActive: !1, imageLoaded: !1, imageAttributes: { width: null, height: null, crossOrigin: null, src: null }, defaultImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, appliedImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, boundaries: { width: 0, height: 0 }, visibleArea: null, coordinates: g({}, J) };
}, computed: { image: function() {
  return { src: this.imageAttributes.src, width: this.imageAttributes.width, height: this.imageAttributes.height, transforms: this.imageTransforms };
}, imageTransforms: function() {
  return { rotate: this.appliedImageTransforms.rotate, flip: { horizontal: this.appliedImageTransforms.flip.horizontal, vertical: this.appliedImageTransforms.flip.vertical }, translateX: this.visibleArea ? this.visibleArea.left / this.coefficient : 0, translateY: this.visibleArea ? this.visibleArea.top / this.coefficient : 0, scaleX: 1 / this.coefficient, scaleY: 1 / this.coefficient };
}, imageSize: function() {
  var e = function(t) {
    return t * Math.PI / 180;
  }(this.imageTransforms.rotate);
  return { width: Math.abs(this.imageAttributes.width * Math.cos(e)) + Math.abs(this.imageAttributes.height * Math.sin(e)), height: Math.abs(this.imageAttributes.width * Math.sin(e)) + Math.abs(this.imageAttributes.height * Math.cos(e)) };
}, initialized: function() {
  return !!(this.visibleArea && this.imageLoaded);
}, settings: function() {
  var e = j(this.resizeImage, { touch: !0, wheel: { ratio: 0.1 }, adjustStencil: !0 }, { touch: !1, wheel: !1, adjustStencil: !1 });
  return { moveImage: j(this.moveImage, { touch: !0, mouse: !0 }, { touch: !1, mouse: !1 }), resizeImage: e };
}, coefficient: function() {
  return this.visibleArea ? this.visibleArea.width / this.boundaries.width : 0;
}, areaRestrictions: function() {
  return this.imageLoaded ? this.areaRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction, boundaries: this.boundaries }) : {};
}, transitionsOptions: function() {
  return { enabled: this.transitionsActive, timingFunction: "ease-in-out", time: 350 };
}, sizeRestrictions: function() {
  if (this.boundaries.width && this.boundaries.height && this.imageSize.width && this.imageSize.height) {
    var e = this.sizeRestrictionsAlgorithm({ imageSize: this.imageSize, minWidth: D(this.minWidth) ? 0 : L(this.minWidth), minHeight: D(this.minHeight) ? 0 : L(this.minHeight), maxWidth: D(this.maxWidth) ? 1 / 0 : L(this.maxWidth), maxHeight: D(this.maxHeight) ? 1 / 0 : L(this.maxHeight) });
    if (e = function(r) {
      var i = r.areaRestrictions, s = r.sizeRestrictions, l = r.boundaries, c = r.positionRestrictions, u = C(C({}, s), { minWidth: s.minWidth !== void 0 ? s.minWidth : 0, minHeight: s.minHeight !== void 0 ? s.minHeight : 0, maxWidth: s.maxWidth !== void 0 ? s.maxWidth : 1 / 0, maxHeight: s.maxHeight !== void 0 ? s.maxHeight : 1 / 0 });
      c.left !== void 0 && c.right !== void 0 && (u.maxWidth = Math.min(u.maxWidth, c.right - c.left)), c.bottom !== void 0 && c.top !== void 0 && (u.maxHeight = Math.min(u.maxHeight, c.bottom - c.top));
      var m = bt(i), qu = mt(l, m);
      return m.width < 1 / 0 && (!u.maxWidth || u.maxWidth > qu.width) && (u.maxWidth = Math.min(u.maxWidth, qu.width)), m.height < 1 / 0 && (!u.maxHeight || u.maxHeight > qu.height) && (u.maxHeight = Math.min(u.maxHeight, qu.height)), u.minWidth > u.maxWidth && (u.minWidth = u.maxWidth, u.widthFrozen = !0), u.minHeight > u.maxHeight && (u.minHeight = u.maxHeight, u.heightFrozen = !0), u;
    }({ sizeRestrictions: e, areaRestrictions: this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }), imageSize: this.imageSize, boundaries: this.boundaries, positionRestrictions: this.positionRestrictions, imageRestriction: this.imageRestriction, visibleArea: this.visibleArea, stencilSize: this.getStencilSize() }), this.visibleArea && this.stencilSize) {
      var t = this.getStencilSize(), n = bt(this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }));
      e.maxWidth = Math.min(e.maxWidth, n.width * t.width / this.boundaries.width), e.maxHeight = Math.min(e.maxHeight, n.height * t.height / this.boundaries.height), e.maxWidth < e.minWidth && (e.minWidth = e.maxWidth), e.maxHeight < e.minHeight && (e.minHeight = e.maxHeight);
    }
    return e;
  }
  return { minWidth: 0, minHeight: 0, maxWidth: 0, maxHeight: 0 };
}, positionRestrictions: function() {
  return this.positionRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction });
}, classes: function() {
  return { cropper: ge(), image: A(ge("image"), this.imageClass), stencil: ge("stencil"), boundaries: A(ge("boundaries"), this.boundariesClass), stretcher: A(ge("stretcher")), background: A(ge("background"), this.backgroundClass), foreground: A(ge("foreground"), this.foregroundClass), imageWrapper: A(ge("image-wrapper")), cropperWrapper: A(ge("cropper-wrapper")) };
}, stencilCoordinates: function() {
  if (this.initialized) {
    var e = this.coordinates, t = e.width, n = e.height, r = e.left, i = e.top;
    return { width: t / this.coefficient, height: n / this.coefficient, left: (r - this.visibleArea.left) / this.coefficient, top: (i - this.visibleArea.top) / this.coefficient };
  }
  return this.defaultCoordinates();
}, boundariesStyle: function() {
  var e = { width: this.boundaries.width ? "".concat(Math.round(this.boundaries.width), "px") : "auto", height: this.boundaries.height ? "".concat(Math.round(this.boundaries.height), "px") : "auto", transition: "opacity ".concat(this.transitionTime, "ms"), pointerEvents: this.imageLoaded ? "all" : "none" };
  return this.imageLoaded || (e.opacity = "0"), e;
}, imageStyle: function() {
  var e = this.imageAttributes.width > this.imageAttributes.height ? { width: Math.min(1024, this.imageAttributes.width), height: Math.min(1024, this.imageAttributes.width) / (this.imageAttributes.width / this.imageAttributes.height) } : { height: Math.min(1024, this.imageAttributes.height), width: Math.min(1024, this.imageAttributes.height) * (this.imageAttributes.width / this.imageAttributes.height) }, t = { left: (e.width - this.imageSize.width) / (2 * this.coefficient), top: (e.height - this.imageSize.height) / (2 * this.coefficient) }, n = { left: (1 - 1 / this.coefficient) * e.width / 2, top: (1 - 1 / this.coefficient) * e.height / 2 }, r = g(g({}, this.imageTransforms), {}, { scaleX: this.imageTransforms.scaleX * (this.imageAttributes.width / e.width), scaleY: this.imageTransforms.scaleY * (this.imageAttributes.height / e.height) }), i = { width: "".concat(e.width, "px"), height: "".concat(e.height, "px"), left: "0px", top: "0px", transform: "translate(".concat(-t.left - n.left - this.imageTransforms.translateX, "px, ").concat(-t.top - n.top - this.imageTransforms.translateY, "px)") + te(r) };
  return this.transitionsOptions.enabled && (i.transition = "".concat(this.transitionsOptions.time, "ms ").concat(this.transitionsOptions.timingFunction)), i;
} }, watch: { src: function() {
  this.onChangeImage();
}, stencilComponent: function() {
  var e = this;
  this.$nextTick(function() {
    e.resetCoordinates(), e.runAutoZoom("setCoordinates"), e.onChange();
  });
}, minWidth: function() {
  this.onPropsChange();
}, maxWidth: function() {
  this.onPropsChange();
}, minHeight: function() {
  this.onPropsChange();
}, maxHeight: function() {
  this.onPropsChange();
}, imageRestriction: function() {
  this.reset();
}, stencilProps: function(e, t) {
  ["aspectRatio", "minAspectRatio", "maxAspectRatio"].find(function(n) {
    return e[n] !== t[n];
  }) && this.$nextTick(this.onPropsChange);
} }, created: function() {
  this.debouncedUpdate = x(this.update, this.debounce), this.debouncedDisableTransitions = x(this.disableTransitions, this.transitionsOptions.time), this.awaiting = !1;
}, mounted: function() {
  this.$refs.image.addEventListener("load", this.onSuccessLoadImage), this.$refs.image.addEventListener("error", this.onFailLoadImage), this.onChangeImage(), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh), this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.debouncedUpdate.clear(), this.debouncedDisableTransitions.clear();
}, methods: { getResult: function() {
  var e = this.initialized ? this.prepareResult(g({}, this.coordinates)) : this.defaultCoordinates(), t = { rotate: this.imageTransforms.rotate % 360, flip: g({}, this.imageTransforms.flip) };
  if (this.src && this.imageLoaded) {
    var n = this;
    return { image: this.image, coordinates: e, visibleArea: this.visibleArea ? g({}, this.visibleArea) : null, imageTransforms: t, get canvas() {
      return n.canvas ? n.getCanvas() : void 0;
    } };
  }
  return { image: this.image, coordinates: e, visibleArea: this.visibleArea ? g({}, this.visibleArea) : null, canvas: void 0, imageTransforms: t };
}, zoom: function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.transitions, i = r === void 0 || r;
  this.onManipulateImage(new B({}, { factor: 1 / e, center: t }), { normalize: !1, transitions: i });
}, move: function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.transitions, i = r === void 0 || r;
  this.onManipulateImage(new B({ left: e || 0, top: t || 0 }), { normalize: !1, transitions: i });
}, setCoordinates: function(e) {
  var t = this, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.autoZoom, i = r === void 0 || r, s = n.transitions, l = s === void 0 || s;
  this.$nextTick(function() {
    t.imageLoaded ? (t.transitionsActive || (l && t.enableTransitions(), t.coordinates = t.applyTransform(e), i && t.runAutoZoom("setCoordinates"), l && t.debouncedDisableTransitions()), t.onChange()) : t.delayedTransforms = e;
  });
}, refresh: function() {
  var e = this, t = this.$refs.image;
  if (this.src && t) return this.initialized ? this.updateVisibleArea().then(function() {
    e.onChange();
  }) : this.resetVisibleArea().then(function() {
    e.onChange();
  });
}, reset: function() {
  var e = this;
  return this.resetVisibleArea().then(function() {
    e.onChange(!1);
  });
}, awaitRender: function(e) {
  var t = this;
  this.awaiting || (this.awaiting = !0, this.$nextTick(function() {
    e(), t.awaiting = !1;
  }));
}, prepareResult: function(e) {
  return this.roundResult ? function(t) {
    var n = t.coordinates, r = t.sizeRestrictions, i = t.positionRestrictions, s = { width: Math.round(n.width), height: Math.round(n.height), left: Math.round(n.left), top: Math.round(n.top) };
    return s.width > r.maxWidth ? s.width = Math.floor(n.width) : s.width < r.minWidth && (s.width = Math.ceil(n.width)), s.height > r.maxHeight ? s.height = Math.floor(n.height) : s.height < r.minHeight && (s.height = Math.ceil(n.height)), vt(s, i);
  }(g(g({}, this.getPublicProperties()), {}, { positionRestrictions: jt(this.positionRestrictions, this.visibleArea), coordinates: e })) : e;
}, processAutoZoom: function(e, t, n, r) {
  var i = this.autoZoomAlgorithm;
  i || (i = this.stencilSize ? Ct : this.autoZoom ? Et : Wt);
  var s = i({ event: { type: e, params: r }, visibleArea: t, coordinates: n, boundaries: this.boundaries, aspectRatio: this.getAspectRatio(), positionRestrictions: this.positionRestrictions, getAreaRestrictions: this.getAreaRestrictions, sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize() });
  return g(g({}, s), {}, { changed: !tt(s.visibleArea, t) || !tt(s.coordinates, n) });
}, runAutoZoom: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.transitions, r = n !== void 0 && n, i = v(t, pe), s = this.processAutoZoom(e, this.visibleArea, this.coordinates, i), l = s.visibleArea, c = s.coordinates, u = s.changed;
  r && u && this.enableTransitions(), this.visibleArea = l, this.coordinates = c, r && u && this.debouncedDisableTransitions();
}, normalizeEvent: function(e) {
  return function(t) {
    var n = t.event, r = t.visibleArea, i = t.coefficient;
    if (n.type === "manipulateImage") return C(C({}, n), { move: { left: n.move && n.move.left ? i * n.move.left : 0, top: n.move && n.move.top ? i * n.move.top : 0 }, scale: { factor: n.scale && n.scale.factor ? n.scale.factor : 1, center: n.scale && n.scale.center ? { left: n.scale.center.left * i + r.left, top: n.scale.center.top * i + r.top } : null } });
    if (n.type === "resize") {
      var s = C(C({}, n), { directions: C({}, n.directions) });
      return V.forEach(function(c) {
        s.directions[c] *= i;
      }), s;
    }
    if (n.type === "move") {
      var l = C(C({}, n), { directions: C({}, n.directions) });
      return Q.forEach(function(c) {
        l.directions[c] *= i;
      }), l;
    }
    return n;
  }(g(g({}, this.getPublicProperties()), {}, { event: e }));
}, getCanvas: function() {
  if (this.$refs.canvas) {
    var e = this.$refs.canvas, t = this.$refs.image, n = this.imageTransforms.rotate !== 0 || this.imageTransforms.flip.horizontal || this.imageTransforms.flip.vertical ? function(c, u, m) {
      var qu = m.rotate, Gu = m.flip, Qu = { width: u.naturalWidth, height: u.naturalHeight }, Xu = pt(Qu, qu), ef = c.getContext("2d");
      c.height = Xu.height, c.width = Xu.width, ef.save();
      var tf = gt(nt(C({ left: 0, top: 0 }, Qu)), qu);
      return ef.translate(-(tf.left - Xu.width / 2), -(tf.top - Xu.height / 2)), ef.rotate(qu * Math.PI / 180), ef.translate(Gu.horizontal ? Qu.width : 0, Gu.vertical ? Qu.height : 0), ef.scale(Gu.horizontal ? -1 : 1, Gu.vertical ? -1 : 1), ef.drawImage(u, 0, 0, Qu.width, Qu.height), ef.restore(), c;
    }(this.$refs.sourceCanvas, t, this.imageTransforms) : t, r = g({ minWidth: 0, minHeight: 0, maxWidth: 1 / 0, maxHeight: 1 / 0, maxArea: this.maxCanvasSize, imageSmoothingEnabled: !0, imageSmoothingQuality: "high", fillColor: "transparent" }, this.canvas), i = function(c) {
      return c.find(function(u) {
        return m = u, !Number.isNaN(parseFloat(m)) && isFinite(m);
        var m;
      });
    }, s = Mt({ sizeRestrictions: { minWidth: i([r.width, r.minWidth]) || 0, minHeight: i([r.height, r.minHeight]) || 0, maxWidth: i([r.width, r.maxWidth]) || 1 / 0, maxHeight: i([r.height, r.maxHeight]) || 1 / 0 }, width: this.coordinates.width, height: this.coordinates.height, aspectRatio: { minimum: this.coordinates.width / this.coordinates.height, maximum: this.coordinates.width / this.coordinates.height } });
    if (r.maxArea && s.width * s.height > r.maxArea) {
      var l = Math.sqrt(r.maxArea / (s.width * s.height));
      s = { width: Math.round(l * s.width), height: Math.round(l * s.height) };
    }
    return function(c, u, m, qu, Gu) {
      c.width = qu ? qu.width : m.width, c.height = qu ? qu.height : m.height;
      var Qu = c.getContext("2d");
      Qu.clearRect(0, 0, c.width, c.height), Gu && (Gu.imageSmoothingEnabled && (Qu.imageSmoothingEnabled = Gu.imageSmoothingEnabled), Gu.imageSmoothingQuality && (Qu.imageSmoothingQuality = Gu.imageSmoothingQuality), Gu.fillColor && (Qu.fillStyle = Gu.fillColor, Qu.fillRect(0, 0, c.width, c.height), Qu.save()));
      var Xu = m.left < 0 ? -m.left : 0, ef = m.top < 0 ? -m.top : 0;
      Qu.drawImage(u, m.left + Xu, m.top + ef, m.width, m.height, Xu * (c.width / m.width), ef * (c.height / m.height), c.width, c.height);
    }(e, n, this.coordinates, s, r), e;
  }
}, update: function() {
  this.$emit("change", this.getResult());
}, applyTransform: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = this.visibleArea && t ? wt(this.sizeRestrictions, this.visibleArea) : this.sizeRestrictions, r = this.visibleArea && t ? jt(this.positionRestrictions, this.visibleArea) : this.positionRestrictions;
  return xt({ transform: e, coordinates: this.coordinates, imageSize: this.imageSize, sizeRestrictions: n, positionRestrictions: r, aspectRatio: this.getAspectRatio(), visibleArea: this.visibleArea });
}, resetCoordinates: function() {
  var e = this;
  if (this.$refs.image) {
    this.$refs.cropper, this.$refs.image;
    var t = this.defaultSize;
    t || (t = this.stencilSize ? Dt : Ot);
    var n = this.sizeRestrictions;
    n.minWidth, n.minHeight, n.maxWidth, n.maxHeight;
    var r = O(t) ? t({ boundaries: this.boundaries, imageSize: this.imageSize, aspectRatio: this.getAspectRatio(), sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize(), visibleArea: this.visibleArea }) : t, i = this.defaultPosition || Tt, s = [r, function(l) {
      var c = l.coordinates;
      return g({}, O(i) ? i({ coordinates: c, imageSize: e.imageSize, visibleArea: e.visibleArea }) : e.defaultPosition);
    }];
    this.delayedTransforms && s.push.apply(s, b(Array.isArray(this.delayedTransforms) ? this.delayedTransforms : [this.delayedTransforms])), this.coordinates = this.applyTransform(s, !0), this.delayedTransforms = null;
  }
}, clearImage: function() {
  var e = this;
  this.imageLoaded = !1, setTimeout(function() {
    var t = e.$refs.stretcher;
    t && (t.style.height = "auto", t.style.width = "auto"), e.coordinates = e.defaultCoordinates(), e.boundaries = { width: 0, height: 0 };
  }, this.transitionTime);
}, enableTransitions: function() {
  this.transitions && (this.transitionsActive = !0);
}, disableTransitions: function() {
  this.transitionsActive = !1;
}, updateBoundaries: function() {
  var e = this, t = this.$refs.stretcher, n = this.$refs.cropper;
  return this.initStretcher({ cropper: n, stretcher: t, imageSize: this.imageSize }), this.$nextTick().then(function() {
    var r = { cropper: n, imageSize: e.imageSize };
    if (O(e.defaultBoundaries) ? e.boundaries = e.defaultBoundaries(r) : e.defaultBoundaries === "fit" ? e.boundaries = function(i) {
      var s = i.cropper, l = i.imageSize, c = s.clientHeight, u = s.clientWidth, m = c, qu = l.width * c / l.height;
      return qu > u && (qu = u, m = l.height * u / l.width), { width: qu, height: m };
    }(r) : e.boundaries = function(i) {
      var s = i.cropper;
      return { width: s.clientWidth, height: s.clientHeight };
    }(r), !e.boundaries.width || !e.boundaries.height) throw new Error("It's impossible to fit the cropper in the current container");
  });
}, resetVisibleArea: function() {
  var e = this;
  return this.appliedImageTransforms = g(g({}, this.defaultImageTransforms), {}, { flip: g({}, this.defaultImageTransforms.flip) }), this.updateBoundaries().then(function() {
    e.priority !== "visible-area" && (e.visibleArea = null, e.resetCoordinates());
    var t, n, r, i, s, l, c = e.defaultVisibleArea || Ht;
    e.visibleArea = O(c) ? c({ imageSize: e.imageSize, boundaries: e.boundaries, coordinates: e.priority !== "visible-area" ? e.coordinates : null, getAreaRestrictions: e.getAreaRestrictions, stencilSize: e.getStencilSize() }) : e.defaultVisibleArea, e.visibleArea = (t = { visibleArea: e.visibleArea, boundaries: e.boundaries, getAreaRestrictions: e.getAreaRestrictions }, n = t.visibleArea, r = t.boundaries, i = t.getAreaRestrictions, s = C({}, n), l = ct(r), s.width / s.height !== l && (s.height = s.width / l), vt(s, i({ visibleArea: s, type: "move" }))), e.priority === "visible-area" ? e.resetCoordinates() : e.coordinates = e.fitCoordinates({ visibleArea: e.visibleArea, coordinates: e.coordinates, aspectRatio: e.getAspectRatio(), positionRestrictions: e.positionRestrictions, sizeRestrictions: e.sizeRestrictions }), e.runAutoZoom("resetVisibleArea");
  }).catch(function() {
    e.visibleArea = null;
  });
}, updateVisibleArea: function() {
  var e = this;
  return this.updateBoundaries().then(function() {
    e.visibleArea = e.fitVisibleArea({ imageSize: e.imageSize, boundaries: e.boundaries, visibleArea: e.visibleArea, coordinates: e.coordinates, getAreaRestrictions: e.getAreaRestrictions }), e.coordinates = e.fitCoordinates({ visibleArea: e.visibleArea, coordinates: e.coordinates, aspectRatio: e.getAspectRatio(), positionRestrictions: e.positionRestrictions, sizeRestrictions: e.sizeRestrictions }), e.runAutoZoom("updateVisibleArea");
  }).catch(function() {
    e.visibleArea = null;
  });
}, onChange: function() {
  var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
  e && this.debounce ? this.debouncedUpdate() : this.update();
}, onChangeImage: function() {
  var e, t = this;
  if (this.imageLoaded = !1, this.delayedTransforms = null, this.src) {
    if (function(i) {
      if (T(i)) return !1;
      var s = window.location, l = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/.exec(i) || [], c = { protocol: l[1] || "", host: l[2] || "", port: l[3] || "" }, u = function(m) {
        return m.port || ((m.protocol || s.protocol) === "http" ? 80 : 433);
      };
      return !(!c.protocol && !c.host && !c.port || c.protocol && c.protocol == s.protocol && c.host && c.host == s.host && c.host && u(c) == u(s));
    }(this.src)) {
      var n = D(this.crossOrigin) ? this.canvas : this.crossOrigin;
      n === !0 && (n = "anonymous"), this.imageAttributes.crossOrigin = n || null;
    }
    if (this.checkOrientation) {
      var r = (e = this.src, new Promise(function(i) {
        Jt(e).then(function(s) {
          var l = ee(s);
          i(s ? { source: e, arrayBuffer: s, orientation: l } : { source: e, arrayBuffer: null, orientation: null });
        }).catch(function(s) {
          console.warn(s), i({ source: e, arrayBuffer: null, orientation: null });
        });
      }));
      setTimeout(function() {
        r.then(t.onParseImage);
      }, this.transitionTime);
    } else setTimeout(function() {
      t.onParseImage({ source: t.src });
    }, this.transitionTime);
  } else this.clearImage();
}, onFailLoadImage: function() {
  this.imageAttributes.src && (this.clearImage(), this.$emit("error"));
}, onSuccessLoadImage: function() {
  var e = this, t = this.$refs.image;
  t && !this.imageLoaded && (this.imageAttributes.height = t.naturalHeight, this.imageAttributes.width = t.naturalWidth, this.imageLoaded = !0, this.resetVisibleArea().then(function() {
    e.$emit("ready"), e.onChange(!1);
  }));
}, onParseImage: function(e) {
  var t = this, n = e.source, r = e.arrayBuffer, i = e.orientation;
  this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.imageAttributes.revoke = !1, r && i && i > 1 ? W(n) || !T(n) ? (this.imageAttributes.src = URL.createObjectURL(new Blob([r])), this.imageAttributes.revoke = !0) : this.imageAttributes.src = function(s) {
    for (var l = [], c = new Uint8Array(s); c.length > 0; ) {
      var u = c.subarray(0, 8192);
      l.push(String.fromCharCode.apply(null, Array.from ? Array.from(u) : u.slice())), c = c.subarray(8192);
    }
    return "data:image/jpeg;base64," + btoa(l.join(""));
  }(r) : this.imageAttributes.src = n, O(this.defaultTransforms) ? this.appliedImageTransforms = Kt(this.defaultTransforms()) : H(this.defaultTransforms) ? this.appliedImageTransforms = Kt(this.defaultTransforms) : this.appliedImageTransforms = function(s) {
    var l = Kt({});
    if (s) switch (s) {
      case 2:
        l.flip.horizontal = !0;
        break;
      case 3:
        l.rotate = -180;
        break;
      case 4:
        l.flip.vertical = !0;
        break;
      case 5:
        l.rotate = 90, l.flip.vertical = !0;
        break;
      case 6:
        l.rotate = 90;
        break;
      case 7:
        l.rotate = 90, l.flip.horizontal = !0;
        break;
      case 8:
        l.rotate = -90;
    }
    return l;
  }(i), this.defaultImageTransforms = g(g({}, this.appliedImageTransforms), {}, { flip: g({}, this.appliedImageTransforms.flip) }), this.$nextTick(function() {
    var s = t.$refs.image;
    s && s.complete && (function(l) {
      return !!l.naturalWidth;
    }(s) ? t.onSuccessLoadImage() : t.onFailLoadImage());
  });
}, onResizeEnd: function() {
  this.runAutoZoom("resize", { transitions: !0 });
}, onMoveEnd: function() {
  this.runAutoZoom("move", { transitions: !0 });
}, onMove: function(e) {
  var t = this;
  this.transitionsOptions.enabled || this.awaitRender(function() {
    t.coordinates = t.moveAlgorithm(g(g({}, t.getPublicProperties()), {}, { positionRestrictions: jt(t.positionRestrictions, t.visibleArea), coordinates: t.coordinates, event: t.normalizeEvent(e) })), t.onChange();
  });
}, onResize: function(e) {
  var t = this;
  this.transitionsOptions.enabled || this.stencilSize && !this.autoZoom || this.awaitRender(function() {
    var n = t.sizeRestrictions, r = Math.min(t.coordinates.width, t.coordinates.height, 20 * t.coefficient);
    t.coordinates = t.resizeAlgorithm(g(g({}, t.getPublicProperties()), {}, { positionRestrictions: jt(t.positionRestrictions, t.visibleArea), sizeRestrictions: { maxWidth: Math.min(n.maxWidth, t.visibleArea.width), maxHeight: Math.min(n.maxHeight, t.visibleArea.height), minWidth: Math.max(n.minWidth, r), minHeight: Math.max(n.minHeight, r) }, event: t.normalizeEvent(e) })), t.onChange(), t.ticking = !1;
  });
}, onManipulateImage: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!this.transitionsOptions.enabled) {
    var n = t.transitions, r = n !== void 0 && n, i = t.normalize, s = i === void 0 || i;
    r && this.enableTransitions();
    var l = Lt(g(g({}, this.getPublicProperties()), {}, { event: s ? this.normalizeEvent(e) : e, getAreaRestrictions: this.getAreaRestrictions, imageRestriction: this.imageRestriction, adjustStencil: !this.stencilSize && this.settings.resizeImage.adjustStencil })), c = l.visibleArea, u = l.coordinates;
    this.visibleArea = c, this.coordinates = u, this.runAutoZoom("manipulateImage"), this.onChange(), r && this.debouncedDisableTransitions();
  }
}, onPropsChange: function() {
  this.coordinates = this.applyTransform(this.coordinates, !0), this.onChange(!1);
}, getAreaRestrictions: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.visibleArea, n = e.type, r = n === void 0 ? "move" : n;
  return this.areaRestrictionsAlgorithm({ boundaries: this.boundaries, imageSize: this.imageSize, imageRestriction: this.imageRestriction, visibleArea: t, type: r });
}, getAspectRatio: function(e) {
  var t, n, r = this.stencilProps, i = r.aspectRatio, s = r.minAspectRatio, l = r.maxAspectRatio;
  if (this.$refs.stencil && this.$refs.stencil.aspectRatios) {
    var c = this.$refs.stencil.aspectRatios();
    t = c.minimum, n = c.maximum;
  }
  if (D(t) && (t = D(i) ? s : i), D(n) && (n = D(i) ? l : i), !e && (D(t) || D(n))) {
    var u = this.getStencilSize(), m = u ? ct(u) : null;
    D(t) && (t = P(m) ? m : void 0), D(n) && (n = P(m) ? m : void 0);
  }
  return { minimum: t, maximum: n };
}, getStencilSize: function() {
  if (this.stencilSize) return e = { currentStencilSize: { width: this.stencilCoordinates.width, height: this.stencilCoordinates.height }, stencilSize: this.stencilSize, boundaries: this.boundaries, coefficient: this.coefficient, coordinates: this.coordinates, aspectRatio: this.getAspectRatio(!0) }, t = e.boundaries, n = e.stencilSize, r = e.aspectRatio, dt(ct(i = O(n) ? n({ boundaries: t, aspectRatio: r }) : n), r) && (i = Mt({ sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minWidth: 0, minHeight: 0 }, width: i.width, height: i.height, aspectRatio: { minimum: r.minimum, maximum: r.maximum } })), (i.width > t.width || i.height > t.height) && (i = Mt({ sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minWidth: 0, minHeight: 0 }, width: i.width, height: i.height, aspectRatio: { minimum: ct(i), maximum: ct(i) } })), i;
  var e, t, n, r, i;
}, getPublicProperties: function() {
  return { coefficient: this.coefficient, visibleArea: this.visibleArea, coordinates: this.coordinates, boundaries: this.boundaries, sizeRestrictions: this.sizeRestrictions, positionRestrictions: this.positionRestrictions, aspectRatio: this.getAspectRatio(), imageRestriction: this.imageRestriction };
}, defaultCoordinates: function() {
  return g({}, J);
}, flip: function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.transitions, i = r === void 0 || r;
  if (!this.transitionsActive) {
    i && this.enableTransitions();
    var s = g({}, this.imageTransforms.flip), l = $t({ flip: { horizontal: e ? !s.horizontal : s.horizontal, vertical: t ? !s.vertical : s.vertical }, previousFlip: s, rotate: this.imageTransforms.rotate, visibleArea: this.visibleArea, coordinates: this.coordinates, imageSize: this.imageSize, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), c = l.visibleArea, u = l.coordinates;
    e && (this.appliedImageTransforms.flip.horizontal = !this.appliedImageTransforms.flip.horizontal), t && (this.appliedImageTransforms.flip.vertical = !this.appliedImageTransforms.flip.vertical), this.visibleArea = c, this.coordinates = u, this.onChange(), i && this.debouncedDisableTransitions();
  }
}, rotate: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.transitions, r = n === void 0 || n;
  if (!this.transitionsActive) {
    r && this.enableTransitions();
    var i = g({}, this.imageSize);
    this.appliedImageTransforms.rotate += e;
    var s = Pt({ visibleArea: this.visibleArea, coordinates: this.coordinates, previousImageSize: i, imageSize: this.imageSize, angle: e, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), l = s.visibleArea, c = s.coordinates, u = this.processAutoZoom("rotateImage", l, c);
    l = u.visibleArea, c = u.coordinates, this.visibleArea = l, this.coordinates = c, this.onChange(), r && this.debouncedDisableTransitions();
  }
} }, emits: ["change", "error", "ready"] }, ve = { key: 0, ref: "canvas", style: { display: "none" } }, be = { key: 1, ref: "sourceCanvas", style: { display: "none" } };
fe.render = function(e, t, n, r, i, s) {
  return openBlock(), createBlock("div", { ref: "cropper", class: s.classes.cropper }, [createVNode("div", { ref: "stretcher", class: s.classes.stretcher }, null, 2), createVNode("div", { class: s.classes.boundaries, style: s.boundariesStyle }, [(openBlock(), createBlock(resolveDynamicComponent(n.backgroundWrapperComponent), { class: s.classes.cropperWrapper, "wheel-resize": s.settings.resizeImage.wheel, "touch-resize": s.settings.resizeImage.touch, "touch-move": s.settings.moveImage.touch, "mouse-move": s.settings.moveImage.mouse, onMove: s.onManipulateImage, onResize: s.onManipulateImage }, { default: withCtx(function() {
    return [createVNode("div", { class: s.classes.background, style: s.boundariesStyle }, null, 6), createVNode("div", { class: s.classes.imageWrapper }, [createVNode("img", { ref: "image", crossorigin: i.imageAttributes.crossOrigin, src: i.imageAttributes.src, class: s.classes.image, style: s.imageStyle, onMousedown: t[1] || (t[1] = withModifiers(function() {
    }, ["prevent"])) }, null, 46, ["crossorigin", "src"])], 2), createVNode("div", { class: s.classes.foreground, style: s.boundariesStyle }, null, 6), withDirectives((openBlock(), createBlock(resolveDynamicComponent(n.stencilComponent), mergeProps$1({ ref: "stencil", image: s.image, coordinates: i.coordinates, "stencil-coordinates": s.stencilCoordinates, transitions: s.transitionsOptions }, n.stencilProps, { onResize: s.onResize, onResizeEnd: s.onResizeEnd, onMove: s.onMove, onMoveEnd: s.onMoveEnd }), null, 16, ["image", "coordinates", "stencil-coordinates", "transitions", "onResize", "onResizeEnd", "onMove", "onMoveEnd"])), [[vShow, i.imageLoaded]]), n.canvas ? (openBlock(), createBlock("canvas", ve, null, 512)) : createCommentVNode("", !0), n.canvas ? (openBlock(), createBlock("canvas", be, null, 512)) : createCommentVNode("", !0)];
  }), _: 1 }, 8, ["class", "wheel-resize", "touch-resize", "touch-move", "mouse-move", "onMove", "onResize"]))], 6)], 2);
};
function QsUtils() {
  const e = (rf) => String(rf).normalize("NFKD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-"), t = (rf) => {
    const hf = rf.lastIndexOf(".");
    return console.log(hf), hf === -1 ? rf : `${e(rf.substring(0, hf))}.${rf.substring(hf + 1)}`;
  }, n = () => getNode("qsWrapper"), r = () => n().props, i = () => r().id, s = () => r().identifier, l = () => r().endpoint, c = () => r().actions, u = () => c().set, m = () => c().get, qu = () => c().ping, Gu = () => c().upload;
  return {
    slugify: e,
    sanitizeFilename: t,
    getWrapperNode: n,
    getWrapperProps: r,
    getFormId: i,
    getFormIdentifier: s,
    getEndpoint: l,
    getActions: c,
    getSetAction: u,
    getGetAction: m,
    getUploadAction: Gu,
    getSetUrl: () => l() + "?action=" + u(),
    getGetUrl: () => l() + "?action=" + m(),
    getPingUrl: () => l() + "?action=" + qu(),
    getUploadUrl: () => l() + "?action=" + Gu(),
    getPropertyByStringPath: (rf, hf) => {
      hf = hf.replace(/\[(\w+)\]/g, ".$1"), hf = hf.replace(/^\./, "");
      const sf = hf.split(".");
      for (let pf = 0, $f = sf.length; pf < $f; ++pf) {
        let uf = sf[pf];
        if (uf in rf)
          rf = rf[uf];
        else
          return;
      }
      return rf;
    }
  };
}
const progress = ref({
  total: 0,
  current: 0,
  touched: {},
  progress: 0,
  validity: [],
  //"feedbacks": {},
  lastValid: -1,
  answerPerc: 75,
  currentPerc: 0,
  /*"stepProgress": [
    {
      "keys": [],
      "names": [
        "formly_1_super-input_name_0",
        "formly_1_textarea_proposition_value_2",
        "formly_1_cropper_n23_picture_17",
        "formly_1_cropper_n23_logo_18",
        "formly_1_radio_n23_cause_1",
        "formly_1_radio-boolean_has_products_3",
        "formly_1_radio-boolean_has_campaigning_7",
        "formly_1_radio-boolean_has_agency_campaigning_13",
        "formly_1_radio-boolean_has_agency_fundraising_plan_15",
        "formly_1_radio-boolean_has_ecommerce_5",
        "formly_1_input_url_6",
        "formly_1_input_campaigning_8"
      ],
      "total": 12,
      "valid": false,
      "labels": [],
      "status": "invalid",
      "progress": 9,
      "requiredTrue": 0,
      "requiredFalse": 0,
      "eProgressPercent": 75,
      "disabledElementNames": []
    }
  ],
  */
  totalAnswers: 9,
  lastValidGroup: null,
  totalQuestions: 12
});
function useQsProgress() {
  return {
    progress,
    recoverProgress: (i) => {
      console.log(i), progress.value = {
        ...progress.value,
        ...i
      }, progress.value.touched.step0 = !0;
    },
    updateValidity: (i, s) => {
      progress.value.validity[i] = s.context.isValid;
    },
    updateTotal: (i, s) => {
      progress.value.total = i, s.forEach((l, c) => {
        l.props.isTouched = progress.value.touched["step" + c];
      });
    },
    updateProgress: (i, s) => (progress.value.current = i, progress.value.touched["step" + i] = !0, s.props.isTouched = !0, progress)
  };
}
function useGoogleApi() {
  let e = !1;
  return {
    loadGoogleMapsScript: (n) => new Promise((r, i) => {
      if (window.google && window.google.maps && window.google.maps.places)
        r();
      else if (!e) {
        e = !0;
        const s = document.createElement("script");
        s.setAttribute(
          "src",
          `https://maps.googleapis.com/maps/api/js?key=${n}&libraries=places&callback=initMap`
        ), window.initMap = () => {
          r();
        }, s.onerror = (l) => {
          i(l);
        }, document.head.appendChild(s);
      }
    })
  };
}
function mitt(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, n) {
    var r = e.get(t);
    r ? r.push(n) : e.set(t, [n]);
  }, off: function(t, n) {
    var r = e.get(t);
    r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, n) {
    var r = e.get(t);
    r && r.slice().map(function(i) {
      i(n);
    }), (r = e.get("*")) && r.slice().map(function(i) {
      i(t, n);
    });
  } };
}
const emitter = mitt();
function useEventBus() {
  return {
    emitter
  };
}
const legends = ["checkbox_multi", "radio_multi", "repeater", "transferlist"];
function useQsSteps(e) {
  const { updateProgress: t, updateTotal: n, updateValidity: r, recoverProgress: i } = useQsProgress(), s = ref([]), l = ref(null), c = computed(() => l.value.context.activeStep), u = (Xu) => {
    let ef, tf;
    return s.value.forEach((af, rf) => {
      af.name === Xu && (ef = af, tf = rf);
    }), { stepObj: ef, stepIndex: tf };
  }, m = computed(() => {
    var Xu;
    return (Xu = l.value) == null ? void 0 : Xu.context.state.valid;
  }), qu = (Xu) => {
    if (Xu.props.type === "multi-step") {
      if (!Xu.context)
        return;
      l.value = Xu, Xu.on("created", ({ payload: ef }) => {
        i(e.progress);
      }), Xu.on("prop:steps", ({ payload: ef }) => {
        n(ef.length, s.value);
      }), Xu.on("prop:activeStep", ({ payload: ef }) => {
        const { stepIndex: tf, stepObj: af } = u(ef);
        t(tf, af);
      });
    }
    if (Xu.props.type === "step")
      return Xu.on("prop:isValid", ({ payload: ef }) => {
        const { stepIndex: tf, stepObj: af } = u(Xu.name);
        r(tf, af);
      }), Xu.on("created", ({ payload: ef }) => {
        u(Xu.name);
      }), s.value.push(Xu), !1;
  };
  function Gu(Xu) {
    ["button", "submit", "hidden", "group", "list", "meta", "multi-step", "step", "repeater"].includes(Xu.props.type) || Xu.on("created", () => {
      const ef = legends.includes(`${Xu.props.type}${Xu.props.options ? "_multi" : ""}`) ? "legend" : "label";
      Xu.props.definition.schemaMemoKey = `required_${Xu.props.definition.schemaMemoKey}`, Xu.context.isRequired = Xu.props.parsedRules.some((af) => af.name === "required"), Xu.on("prop:validation", () => {
        Xu.context.isRequired = Xu.props.parsedRules.some((af) => af.name === "required");
      });
      const tf = Xu.props.definition.schema;
      Xu.props.definition.schema = (af = {}) => (af[ef] = {
        children: ["$label", {
          $el: "span",
          if: "$isRequired",
          attrs: {
            class: "$classes.asterisk"
          },
          children: ["*"]
        }]
      }, tf(af));
    });
  }
  return {
    getNextLabel: (Xu) => {
      var ef;
      return e.stepOverrides && ((ef = e.stepOverrides[Xu]) != null && ef.buttons.nextLabel) ? e.stepOverrides[Xu].buttons.nextLabel : "Prossimo";
    },
    isValid: m,
    multiStepNode: l,
    activeStep: c,
    steps: s,
    addAsteriskPlugin: Gu,
    stepPlugin: qu
  };
}
const suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function jsonParseTransform(e, t) {
  if (e === "__proto__" || e === "constructor" && t && typeof t == "object" && "prototype" in t) {
    warnKeyDropped(e);
    return;
  }
  return t;
}
function warnKeyDropped(e) {
  console.warn(`[destr] Dropping "${e}" key to prevent prototype pollution.`);
}
function destr(e, t = {}) {
  if (typeof e != "string")
    return e;
  const n = e.trim();
  if (
    // eslint-disable-next-line unicorn/prefer-at
    e[0] === '"' && e.endsWith('"') && !e.includes("\\")
  )
    return n.slice(1, -1);
  if (n.length <= 9) {
    const r = n.toLowerCase();
    if (r === "true")
      return !0;
    if (r === "false")
      return !1;
    if (r === "undefined")
      return;
    if (r === "null")
      return null;
    if (r === "nan")
      return Number.NaN;
    if (r === "infinity")
      return Number.POSITIVE_INFINITY;
    if (r === "-infinity")
      return Number.NEGATIVE_INFINITY;
  }
  if (!JsonSigRx.test(e)) {
    if (t.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return e;
  }
  try {
    if (suspectProtoRx.test(e) || suspectConstructorRx.test(e)) {
      if (t.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(e, jsonParseTransform);
    }
    return JSON.parse(e);
  } catch (r) {
    if (t.strict)
      throw r;
    return e;
  }
}
const HASH_RE = /#/g, AMPERSAND_RE = /&/g, SLASH_RE = /\//g, EQUAL_RE = /=/g, PLUS_RE = /\+/g, ENC_CARET_RE = /%5e/gi, ENC_BACKTICK_RE = /%60/gi, ENC_PIPE_RE = /%7c/gi, ENC_SPACE_RE = /%20/gi;
function encode(e) {
  return encodeURI("" + e).replace(ENC_PIPE_RE, "|");
}
function encodeQueryValue(e) {
  return encode(typeof e == "string" ? e : JSON.stringify(e)).replace(PLUS_RE, "%2B").replace(ENC_SPACE_RE, "+").replace(HASH_RE, "%23").replace(AMPERSAND_RE, "%26").replace(ENC_BACKTICK_RE, "`").replace(ENC_CARET_RE, "^").replace(SLASH_RE, "%2F");
}
function encodeQueryKey(e) {
  return encodeQueryValue(e).replace(EQUAL_RE, "%3D");
}
function decode(e = "") {
  try {
    return decodeURIComponent("" + e);
  } catch {
    return "" + e;
  }
}
function decodeQueryKey(e) {
  return decode(e.replace(PLUS_RE, " "));
}
function decodeQueryValue(e) {
  return decode(e.replace(PLUS_RE, " "));
}
function parseQuery(e = "") {
  const t = {};
  e[0] === "?" && (e = e.slice(1));
  for (const n of e.split("&")) {
    const r = n.match(/([^=]+)=?(.*)/) || [];
    if (r.length < 2)
      continue;
    const i = decodeQueryKey(r[1]);
    if (i === "__proto__" || i === "constructor")
      continue;
    const s = decodeQueryValue(r[2] || "");
    t[i] === void 0 ? t[i] = s : Array.isArray(t[i]) ? t[i].push(s) : t[i] = [t[i], s];
  }
  return t;
}
function encodeQueryItem(e, t) {
  return (typeof t == "number" || typeof t == "boolean") && (t = String(t)), t ? Array.isArray(t) ? t.map((n) => `${encodeQueryKey(e)}=${encodeQueryValue(n)}`).join("&") : `${encodeQueryKey(e)}=${encodeQueryValue(t)}` : encodeQueryKey(e);
}
function stringifyQuery(e) {
  return Object.keys(e).filter((t) => e[t] !== void 0).map((t) => encodeQueryItem(t, e[t])).filter(Boolean).join("&");
}
const PROTOCOL_STRICT_REGEX = /^[\s\w\0+.-]{2,}:([/\\]{1,2})/, PROTOCOL_REGEX = /^[\s\w\0+.-]{2,}:([/\\]{2})?/, PROTOCOL_RELATIVE_REGEX = /^([/\\]\s*){2,}[^/\\]/, JOIN_LEADING_SLASH_RE = /^\.?\//;
function hasProtocol(e, t = {}) {
  return typeof t == "boolean" && (t = { acceptRelative: t }), t.strict ? PROTOCOL_STRICT_REGEX.test(e) : PROTOCOL_REGEX.test(e) || (t.acceptRelative ? PROTOCOL_RELATIVE_REGEX.test(e) : !1);
}
function hasTrailingSlash(e = "", t) {
  return e.endsWith("/");
}
function withoutTrailingSlash(e = "", t) {
  return (hasTrailingSlash(e) ? e.slice(0, -1) : e) || "/";
}
function withTrailingSlash(e = "", t) {
  return e.endsWith("/") ? e : e + "/";
}
function withBase(e, t) {
  if (isEmptyURL(t) || hasProtocol(e))
    return e;
  const n = withoutTrailingSlash(t);
  return e.startsWith(n) ? e : joinURL(n, e);
}
function withQuery(e, t) {
  const n = parseURL(e), r = { ...parseQuery(n.search), ...t };
  return n.search = stringifyQuery(r), stringifyParsedURL(n);
}
function isEmptyURL(e) {
  return !e || e === "/";
}
function isNonEmptyURL(e) {
  return e && e !== "/";
}
function joinURL(e, ...t) {
  let n = e || "";
  for (const r of t.filter((i) => isNonEmptyURL(i)))
    if (n) {
      const i = r.replace(JOIN_LEADING_SLASH_RE, "");
      n = withTrailingSlash(n) + i;
    } else
      n = r;
  return n;
}
const protocolRelative = Symbol.for("ufo:protocolRelative");
function parseURL(e = "", t) {
  const n = e.match(
    /^[\s\0]*(blob:|data:|javascript:|vbscript:)(.*)/i
  );
  if (n) {
    const [, Gu, Qu = ""] = n;
    return {
      protocol: Gu.toLowerCase(),
      pathname: Qu,
      href: Gu + Qu,
      auth: "",
      host: "",
      search: "",
      hash: ""
    };
  }
  if (!hasProtocol(e, { acceptRelative: !0 }))
    return parsePath(e);
  const [, r = "", i, s = ""] = e.replace(/\\/g, "/").match(/^[\s\0]*([\w+.-]{2,}:)?\/\/([^/@]+@)?(.*)/) || [];
  let [, l = "", c = ""] = s.match(/([^#/?]*)(.*)?/) || [];
  r === "file:" && (c = c.replace(/\/(?=[A-Za-z]:)/, ""));
  const { pathname: u, search: m, hash: qu } = parsePath(c);
  return {
    protocol: r.toLowerCase(),
    auth: i ? i.slice(0, Math.max(0, i.length - 1)) : "",
    host: l,
    pathname: u,
    search: m,
    hash: qu,
    [protocolRelative]: !r
  };
}
function parsePath(e = "") {
  const [t = "", n = "", r = ""] = (e.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1);
  return {
    pathname: t,
    search: n,
    hash: r
  };
}
function stringifyParsedURL(e) {
  const t = e.pathname || "", n = e.search ? (e.search.startsWith("?") ? "" : "?") + e.search : "", r = e.hash || "", i = e.auth ? e.auth + "@" : "", s = e.host || "";
  return (e.protocol || e[protocolRelative] ? (e.protocol || "") + "//" : "") + i + s + t + n + r;
}
class FetchError extends Error {
  constructor(t, n) {
    super(t, n), this.name = "FetchError", n != null && n.cause && !this.cause && (this.cause = n.cause);
  }
}
function createFetchError(e) {
  var u, m, qu, Gu, Qu;
  const t = ((u = e.error) == null ? void 0 : u.message) || ((m = e.error) == null ? void 0 : m.toString()) || "", n = ((qu = e.request) == null ? void 0 : qu.method) || ((Gu = e.options) == null ? void 0 : Gu.method) || "GET", r = ((Qu = e.request) == null ? void 0 : Qu.url) || String(e.request) || "/", i = `[${n}] ${JSON.stringify(r)}`, s = e.response ? `${e.response.status} ${e.response.statusText}` : "<no response>", l = `${i}: ${s}${t ? ` ${t}` : ""}`, c = new FetchError(
    l,
    e.error ? { cause: e.error } : void 0
  );
  for (const Xu of ["request", "options", "response"])
    Object.defineProperty(c, Xu, {
      get() {
        return e[Xu];
      }
    });
  for (const [Xu, ef] of [
    ["data", "_data"],
    ["status", "status"],
    ["statusCode", "status"],
    ["statusText", "statusText"],
    ["statusMessage", "statusText"]
  ])
    Object.defineProperty(c, Xu, {
      get() {
        return e.response && e.response[ef];
      }
    });
  return c;
}
const payloadMethods = new Set(
  Object.freeze(["PATCH", "POST", "PUT", "DELETE"])
);
function isPayloadMethod(e = "GET") {
  return payloadMethods.has(e.toUpperCase());
}
function isJSONSerializable(e) {
  if (e === void 0)
    return !1;
  const t = typeof e;
  return t === "string" || t === "number" || t === "boolean" || t === null ? !0 : t !== "object" ? !1 : Array.isArray(e) ? !0 : e.buffer ? !1 : e.constructor && e.constructor.name === "Object" || typeof e.toJSON == "function";
}
const textTypes = /* @__PURE__ */ new Set([
  "image/svg",
  "application/xml",
  "application/xhtml",
  "application/html"
]), JSON_RE = /^application\/(?:[\w!#$%&*.^`~-]*\+)?json(;.+)?$/i;
function detectResponseType(e = "") {
  if (!e)
    return "json";
  const t = e.split(";").shift() || "";
  return JSON_RE.test(t) ? "json" : textTypes.has(t) || t.startsWith("text/") ? "text" : "blob";
}
function mergeFetchOptions(e, t, n = globalThis.Headers) {
  const r = {
    ...t,
    ...e
  };
  if (t != null && t.params && (e != null && e.params) && (r.params = {
    ...t == null ? void 0 : t.params,
    ...e == null ? void 0 : e.params
  }), t != null && t.query && (e != null && e.query) && (r.query = {
    ...t == null ? void 0 : t.query,
    ...e == null ? void 0 : e.query
  }), t != null && t.headers && (e != null && e.headers)) {
    r.headers = new n((t == null ? void 0 : t.headers) || {});
    for (const [i, s] of new n((e == null ? void 0 : e.headers) || {}))
      r.headers.set(i, s);
  }
  return r;
}
const retryStatusCodes = /* @__PURE__ */ new Set([
  408,
  // Request Timeout
  409,
  // Conflict
  425,
  // Too Early
  429,
  // Too Many Requests
  500,
  // Internal Server Error
  502,
  // Bad Gateway
  503,
  // Service Unavailable
  504
  //  Gateway Timeout
]), nullBodyResponses = /* @__PURE__ */ new Set([101, 204, 205, 304]);
function createFetch(e = {}) {
  const {
    fetch: t = globalThis.fetch,
    Headers: n = globalThis.Headers,
    AbortController: r = globalThis.AbortController
  } = e;
  async function i(c) {
    const u = c.error && c.error.name === "AbortError" && !c.options.timeout || !1;
    if (c.options.retry !== !1 && !u) {
      let qu;
      typeof c.options.retry == "number" ? qu = c.options.retry : qu = isPayloadMethod(c.options.method) ? 0 : 1;
      const Gu = c.response && c.response.status || 500;
      if (qu > 0 && (Array.isArray(c.options.retryStatusCodes) ? c.options.retryStatusCodes.includes(Gu) : retryStatusCodes.has(Gu))) {
        const Qu = c.options.retryDelay || 0;
        return Qu > 0 && await new Promise((Xu) => setTimeout(Xu, Qu)), s(c.request, {
          ...c.options,
          retry: qu - 1
        });
      }
    }
    const m = createFetchError(c);
    throw Error.captureStackTrace && Error.captureStackTrace(m, s), m;
  }
  const s = async function(u, m = {}) {
    var Xu;
    const qu = {
      request: u,
      options: mergeFetchOptions(m, e.defaults, n),
      response: void 0,
      error: void 0
    };
    qu.options.method = (Xu = qu.options.method) == null ? void 0 : Xu.toUpperCase(), qu.options.onRequest && await qu.options.onRequest(qu), typeof qu.request == "string" && (qu.options.baseURL && (qu.request = withBase(qu.request, qu.options.baseURL)), (qu.options.query || qu.options.params) && (qu.request = withQuery(qu.request, {
      ...qu.options.params,
      ...qu.options.query
    }))), qu.options.body && isPayloadMethod(qu.options.method) && (isJSONSerializable(qu.options.body) ? (qu.options.body = typeof qu.options.body == "string" ? qu.options.body : JSON.stringify(qu.options.body), qu.options.headers = new n(qu.options.headers || {}), qu.options.headers.has("content-type") || qu.options.headers.set("content-type", "application/json"), qu.options.headers.has("accept") || qu.options.headers.set("accept", "application/json")) : (
      // ReadableStream Body
      ("pipeTo" in qu.options.body && typeof qu.options.body.pipeTo == "function" || // Node.js Stream Body
      typeof qu.options.body.pipe == "function") && ("duplex" in qu.options || (qu.options.duplex = "half"))
    ));
    let Gu;
    if (!qu.options.signal && qu.options.timeout) {
      const ef = new r();
      Gu = setTimeout(
        () => ef.abort(),
        qu.options.timeout
      ), qu.options.signal = ef.signal;
    }
    try {
      qu.response = await t(
        qu.request,
        qu.options
      );
    } catch (ef) {
      return qu.error = ef, qu.options.onRequestError && await qu.options.onRequestError(qu), await i(qu);
    } finally {
      Gu && clearTimeout(Gu);
    }
    if (qu.response.body && !nullBodyResponses.has(qu.response.status) && qu.options.method !== "HEAD") {
      const ef = (qu.options.parseResponse ? "json" : qu.options.responseType) || detectResponseType(qu.response.headers.get("content-type") || "");
      switch (ef) {
        case "json": {
          const tf = await qu.response.text(), af = qu.options.parseResponse || destr;
          qu.response._data = af(tf);
          break;
        }
        case "stream": {
          qu.response._data = qu.response.body;
          break;
        }
        default:
          qu.response._data = await qu.response[ef]();
      }
    }
    return qu.options.onResponse && await qu.options.onResponse(qu), !qu.options.ignoreResponseError && qu.response.status >= 400 && qu.response.status < 600 ? (qu.options.onResponseError && await qu.options.onResponseError(qu), await i(qu)) : qu.response;
  }, l = async function(u, m) {
    return (await s(u, m))._data;
  };
  return l.raw = s, l.native = (...c) => t(...c), l.create = (c = {}) => createFetch({
    ...e,
    defaults: {
      ...e.defaults,
      ...c
    }
  }), l;
}
const _globalThis = function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
}(), fetch$1 = _globalThis.fetch || (() => Promise.reject(new Error("[ofetch] global.fetch is not supported!"))), Headers = _globalThis.Headers, AbortController$1 = _globalThis.AbortController, ofetch = createFetch({ fetch: fetch$1, Headers, AbortController: AbortController$1 });
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", i = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", c = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", m = 500, qu = "__lodash_placeholder__", Gu = 1, Qu = 2, Xu = 4, ef = 1, tf = 2, af = 1, rf = 2, hf = 4, sf = 8, pf = 16, $f = 32, uf = 64, vf = 128, cf = 256, yf = 512, ff = 30, gf = "...", lf = 800, Sf = 16, Mf = 1, Uf = 2, Zf = 3, Rf = 1 / 0, Bf = 9007199254740991, ih = 17976931348623157e292, lh = NaN, Wf = 4294967295, vh = Wf - 1, Ef = Wf >>> 1, Pf = [
      ["ary", vf],
      ["bind", af],
      ["bindKey", rf],
      ["curry", sf],
      ["curryRight", pf],
      ["flip", yf],
      ["partial", $f],
      ["partialRight", uf],
      ["rearg", cf]
    ], _f = "[object Arguments]", Cf = "[object Array]", kf = "[object AsyncFunction]", If = "[object Boolean]", Of = "[object Date]", Hf = "[object DOMException]", Ff = "[object Error]", zf = "[object Function]", Qf = "[object GeneratorFunction]", qf = "[object Map]", jf = "[object Number]", Sh = "[object Null]", $h = "[object Object]", Ch = "[object Promise]", wh = "[object Proxy]", Ah = "[object RegExp]", bh = "[object Set]", Yh = "[object String]", ag = "[object Symbol]", em = "[object Undefined]", Oh = "[object WeakMap]", ov = "[object WeakSet]", Tg = "[object ArrayBuffer]", Fg = "[object DataView]", iv = "[object Float32Array]", sv = "[object Float64Array]", av = "[object Int8Array]", lv = "[object Int16Array]", pv = "[object Int32Array]", cv = "[object Uint8Array]", uv = "[object Uint8ClampedArray]", dv = "[object Uint16Array]", fv = "[object Uint32Array]", ty = /\b__p \+= '';/g, ny = /\b(__p \+=) '' \+/g, ry = /(__e\(.*?\)|\b__t\)) \+\n'';/g, A0 = /&(?:amp|lt|gt|quot|#39);/g, k0 = /[&<>"']/g, oy = RegExp(A0.source), iy = RegExp(k0.source), sy = /<%-([\s\S]+?)%>/g, ay = /<%([\s\S]+?)%>/g, E0 = /<%=([\s\S]+?)%>/g, ly = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, py = /^\w*$/, cy = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hv = /[\\^$.*+?()[\]{}|]/g, uy = RegExp(hv.source), gv = /^\s+/, dy = /\s/, fy = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, hy = /\{\n\/\* \[wrapped with (.+)\] \*/, gy = /,? & /, my = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, vy = /[()=,{}\[\]\/\s]/, $y = /\\(\\)?/g, by = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, T0 = /\w*$/, yy = /^[-+]0x[0-9a-f]+$/i, wy = /^0b[01]+$/i, _y = /^\[object .+?Constructor\]$/, xy = /^0o[0-7]+$/i, Sy = /^(?:0|[1-9]\d*)$/, Cy = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, mm = /($^)/, Ay = /['\n\r\u2028\u2029\\]/g, vm = "\\ud800-\\udfff", ky = "\\u0300-\\u036f", Ey = "\\ufe20-\\ufe2f", Ty = "\\u20d0-\\u20ff", D0 = ky + Ey + Ty, M0 = "\\u2700-\\u27bf", I0 = "a-z\\xdf-\\xf6\\xf8-\\xff", Dy = "\\xac\\xb1\\xd7\\xf7", My = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Iy = "\\u2000-\\u206f", Ly = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", L0 = "A-Z\\xc0-\\xd6\\xd8-\\xde", O0 = "\\ufe0e\\ufe0f", P0 = Dy + My + Iy + Ly, mv = "['’]", Oy = "[" + vm + "]", R0 = "[" + P0 + "]", $m = "[" + D0 + "]", N0 = "\\d+", Py = "[" + M0 + "]", B0 = "[" + I0 + "]", F0 = "[^" + vm + P0 + N0 + M0 + I0 + L0 + "]", vv = "\\ud83c[\\udffb-\\udfff]", Ry = "(?:" + $m + "|" + vv + ")", V0 = "[^" + vm + "]", $v = "(?:\\ud83c[\\udde6-\\uddff]){2}", bv = "[\\ud800-\\udbff][\\udc00-\\udfff]", Vg = "[" + L0 + "]", z0 = "\\u200d", H0 = "(?:" + B0 + "|" + F0 + ")", Ny = "(?:" + Vg + "|" + F0 + ")", W0 = "(?:" + mv + "(?:d|ll|m|re|s|t|ve))?", U0 = "(?:" + mv + "(?:D|LL|M|RE|S|T|VE))?", K0 = Ry + "?", q0 = "[" + O0 + "]?", By = "(?:" + z0 + "(?:" + [V0, $v, bv].join("|") + ")" + q0 + K0 + ")*", Fy = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Vy = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", j0 = q0 + K0 + By, zy = "(?:" + [Py, $v, bv].join("|") + ")" + j0, Hy = "(?:" + [V0 + $m + "?", $m, $v, bv, Oy].join("|") + ")", Wy = RegExp(mv, "g"), Uy = RegExp($m, "g"), yv = RegExp(vv + "(?=" + vv + ")|" + Hy + j0, "g"), Ky = RegExp([
      Vg + "?" + B0 + "+" + W0 + "(?=" + [R0, Vg, "$"].join("|") + ")",
      Ny + "+" + U0 + "(?=" + [R0, Vg + H0, "$"].join("|") + ")",
      Vg + "?" + H0 + "+" + W0,
      Vg + "+" + U0,
      Vy,
      Fy,
      N0,
      zy
    ].join("|"), "g"), qy = RegExp("[" + z0 + vm + D0 + O0 + "]"), jy = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Yy = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Zy = -1, hh = {};
    hh[iv] = hh[sv] = hh[av] = hh[lv] = hh[pv] = hh[cv] = hh[uv] = hh[dv] = hh[fv] = !0, hh[_f] = hh[Cf] = hh[Tg] = hh[If] = hh[Fg] = hh[Of] = hh[Ff] = hh[zf] = hh[qf] = hh[jf] = hh[$h] = hh[Ah] = hh[bh] = hh[Yh] = hh[Oh] = !1;
    var fh = {};
    fh[_f] = fh[Cf] = fh[Tg] = fh[Fg] = fh[If] = fh[Of] = fh[iv] = fh[sv] = fh[av] = fh[lv] = fh[pv] = fh[qf] = fh[jf] = fh[$h] = fh[Ah] = fh[bh] = fh[Yh] = fh[ag] = fh[cv] = fh[uv] = fh[dv] = fh[fv] = !0, fh[Ff] = fh[zf] = fh[Oh] = !1;
    var Gy = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Xy = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Qy = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Jy = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, e1 = parseFloat, t1 = parseInt, Y0 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, n1 = typeof self == "object" && self && self.Object === Object && self, Dh = Y0 || n1 || Function("return this")(), wv = t && !t.nodeType && t, Dg = wv && !0 && e && !e.nodeType && e, Z0 = Dg && Dg.exports === wv, _v = Z0 && Y0.process, Zh = function() {
      try {
        var bf = Dg && Dg.require && Dg.require("util").types;
        return bf || _v && _v.binding && _v.binding("util");
      } catch {
      }
    }(), G0 = Zh && Zh.isArrayBuffer, X0 = Zh && Zh.isDate, Q0 = Zh && Zh.isMap, J0 = Zh && Zh.isRegExp, e$ = Zh && Zh.isSet, t$ = Zh && Zh.isTypedArray;
    function Hh(bf, Af, xf) {
      switch (xf.length) {
        case 0:
          return bf.call(Af);
        case 1:
          return bf.call(Af, xf[0]);
        case 2:
          return bf.call(Af, xf[0], xf[1]);
        case 3:
          return bf.call(Af, xf[0], xf[1], xf[2]);
      }
      return bf.apply(Af, xf);
    }
    function r1(bf, Af, xf, Vf) {
      for (var Jf = -1, ph = bf == null ? 0 : bf.length; ++Jf < ph; ) {
        var kh = bf[Jf];
        Af(Vf, kh, xf(kh), bf);
      }
      return Vf;
    }
    function Gh(bf, Af) {
      for (var xf = -1, Vf = bf == null ? 0 : bf.length; ++xf < Vf && Af(bf[xf], xf, bf) !== !1; )
        ;
      return bf;
    }
    function o1(bf, Af) {
      for (var xf = bf == null ? 0 : bf.length; xf-- && Af(bf[xf], xf, bf) !== !1; )
        ;
      return bf;
    }
    function n$(bf, Af) {
      for (var xf = -1, Vf = bf == null ? 0 : bf.length; ++xf < Vf; )
        if (!Af(bf[xf], xf, bf))
          return !1;
      return !0;
    }
    function yg(bf, Af) {
      for (var xf = -1, Vf = bf == null ? 0 : bf.length, Jf = 0, ph = []; ++xf < Vf; ) {
        var kh = bf[xf];
        Af(kh, xf, bf) && (ph[Jf++] = kh);
      }
      return ph;
    }
    function bm(bf, Af) {
      var xf = bf == null ? 0 : bf.length;
      return !!xf && zg(bf, Af, 0) > -1;
    }
    function xv(bf, Af, xf) {
      for (var Vf = -1, Jf = bf == null ? 0 : bf.length; ++Vf < Jf; )
        if (xf(Af, bf[Vf]))
          return !0;
      return !1;
    }
    function gh(bf, Af) {
      for (var xf = -1, Vf = bf == null ? 0 : bf.length, Jf = Array(Vf); ++xf < Vf; )
        Jf[xf] = Af(bf[xf], xf, bf);
      return Jf;
    }
    function wg(bf, Af) {
      for (var xf = -1, Vf = Af.length, Jf = bf.length; ++xf < Vf; )
        bf[Jf + xf] = Af[xf];
      return bf;
    }
    function Sv(bf, Af, xf, Vf) {
      var Jf = -1, ph = bf == null ? 0 : bf.length;
      for (Vf && ph && (xf = bf[++Jf]); ++Jf < ph; )
        xf = Af(xf, bf[Jf], Jf, bf);
      return xf;
    }
    function i1(bf, Af, xf, Vf) {
      var Jf = bf == null ? 0 : bf.length;
      for (Vf && Jf && (xf = bf[--Jf]); Jf--; )
        xf = Af(xf, bf[Jf], Jf, bf);
      return xf;
    }
    function Cv(bf, Af) {
      for (var xf = -1, Vf = bf == null ? 0 : bf.length; ++xf < Vf; )
        if (Af(bf[xf], xf, bf))
          return !0;
      return !1;
    }
    var s1 = Av("length");
    function a1(bf) {
      return bf.split("");
    }
    function l1(bf) {
      return bf.match(my) || [];
    }
    function r$(bf, Af, xf) {
      var Vf;
      return xf(bf, function(Jf, ph, kh) {
        if (Af(Jf, ph, kh))
          return Vf = ph, !1;
      }), Vf;
    }
    function ym(bf, Af, xf, Vf) {
      for (var Jf = bf.length, ph = xf + (Vf ? 1 : -1); Vf ? ph-- : ++ph < Jf; )
        if (Af(bf[ph], ph, bf))
          return ph;
      return -1;
    }
    function zg(bf, Af, xf) {
      return Af === Af ? y1(bf, Af, xf) : ym(bf, o$, xf);
    }
    function p1(bf, Af, xf, Vf) {
      for (var Jf = xf - 1, ph = bf.length; ++Jf < ph; )
        if (Vf(bf[Jf], Af))
          return Jf;
      return -1;
    }
    function o$(bf) {
      return bf !== bf;
    }
    function i$(bf, Af) {
      var xf = bf == null ? 0 : bf.length;
      return xf ? Ev(bf, Af) / xf : lh;
    }
    function Av(bf) {
      return function(Af) {
        return Af == null ? n : Af[bf];
      };
    }
    function kv(bf) {
      return function(Af) {
        return bf == null ? n : bf[Af];
      };
    }
    function s$(bf, Af, xf, Vf, Jf) {
      return Jf(bf, function(ph, kh, dh) {
        xf = Vf ? (Vf = !1, ph) : Af(xf, ph, kh, dh);
      }), xf;
    }
    function c1(bf, Af) {
      var xf = bf.length;
      for (bf.sort(Af); xf--; )
        bf[xf] = bf[xf].value;
      return bf;
    }
    function Ev(bf, Af) {
      for (var xf, Vf = -1, Jf = bf.length; ++Vf < Jf; ) {
        var ph = Af(bf[Vf]);
        ph !== n && (xf = xf === n ? ph : xf + ph);
      }
      return xf;
    }
    function Tv(bf, Af) {
      for (var xf = -1, Vf = Array(bf); ++xf < bf; )
        Vf[xf] = Af(xf);
      return Vf;
    }
    function u1(bf, Af) {
      return gh(Af, function(xf) {
        return [xf, bf[xf]];
      });
    }
    function a$(bf) {
      return bf && bf.slice(0, u$(bf) + 1).replace(gv, "");
    }
    function Wh(bf) {
      return function(Af) {
        return bf(Af);
      };
    }
    function Dv(bf, Af) {
      return gh(Af, function(xf) {
        return bf[xf];
      });
    }
    function tm(bf, Af) {
      return bf.has(Af);
    }
    function l$(bf, Af) {
      for (var xf = -1, Vf = bf.length; ++xf < Vf && zg(Af, bf[xf], 0) > -1; )
        ;
      return xf;
    }
    function p$(bf, Af) {
      for (var xf = bf.length; xf-- && zg(Af, bf[xf], 0) > -1; )
        ;
      return xf;
    }
    function d1(bf, Af) {
      for (var xf = bf.length, Vf = 0; xf--; )
        bf[xf] === Af && ++Vf;
      return Vf;
    }
    var f1 = kv(Gy), h1 = kv(Xy);
    function g1(bf) {
      return "\\" + Jy[bf];
    }
    function m1(bf, Af) {
      return bf == null ? n : bf[Af];
    }
    function Hg(bf) {
      return qy.test(bf);
    }
    function v1(bf) {
      return jy.test(bf);
    }
    function $1(bf) {
      for (var Af, xf = []; !(Af = bf.next()).done; )
        xf.push(Af.value);
      return xf;
    }
    function Mv(bf) {
      var Af = -1, xf = Array(bf.size);
      return bf.forEach(function(Vf, Jf) {
        xf[++Af] = [Jf, Vf];
      }), xf;
    }
    function c$(bf, Af) {
      return function(xf) {
        return bf(Af(xf));
      };
    }
    function _g(bf, Af) {
      for (var xf = -1, Vf = bf.length, Jf = 0, ph = []; ++xf < Vf; ) {
        var kh = bf[xf];
        (kh === Af || kh === qu) && (bf[xf] = qu, ph[Jf++] = xf);
      }
      return ph;
    }
    function wm(bf) {
      var Af = -1, xf = Array(bf.size);
      return bf.forEach(function(Vf) {
        xf[++Af] = Vf;
      }), xf;
    }
    function b1(bf) {
      var Af = -1, xf = Array(bf.size);
      return bf.forEach(function(Vf) {
        xf[++Af] = [Vf, Vf];
      }), xf;
    }
    function y1(bf, Af, xf) {
      for (var Vf = xf - 1, Jf = bf.length; ++Vf < Jf; )
        if (bf[Vf] === Af)
          return Vf;
      return -1;
    }
    function w1(bf, Af, xf) {
      for (var Vf = xf + 1; Vf--; )
        if (bf[Vf] === Af)
          return Vf;
      return Vf;
    }
    function Wg(bf) {
      return Hg(bf) ? x1(bf) : s1(bf);
    }
    function rg(bf) {
      return Hg(bf) ? S1(bf) : a1(bf);
    }
    function u$(bf) {
      for (var Af = bf.length; Af-- && dy.test(bf.charAt(Af)); )
        ;
      return Af;
    }
    var _1 = kv(Qy);
    function x1(bf) {
      for (var Af = yv.lastIndex = 0; yv.test(bf); )
        ++Af;
      return Af;
    }
    function S1(bf) {
      return bf.match(yv) || [];
    }
    function C1(bf) {
      return bf.match(Ky) || [];
    }
    var A1 = function bf(Af) {
      Af = Af == null ? Dh : Ug.defaults(Dh.Object(), Af, Ug.pick(Dh, Yy));
      var xf = Af.Array, Vf = Af.Date, Jf = Af.Error, ph = Af.Function, kh = Af.Math, dh = Af.Object, Iv = Af.RegExp, k1 = Af.String, Xh = Af.TypeError, _m = xf.prototype, E1 = ph.prototype, Kg = dh.prototype, xm = Af["__core-js_shared__"], Sm = E1.toString, uh = Kg.hasOwnProperty, T1 = 0, d$ = function() {
        var o = /[^.]+$/.exec(xm && xm.keys && xm.keys.IE_PROTO || "");
        return o ? "Symbol(src)_1." + o : "";
      }(), Cm = Kg.toString, D1 = Sm.call(dh), M1 = Dh._, I1 = Iv(
        "^" + Sm.call(uh).replace(hv, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Am = Z0 ? Af.Buffer : n, xg = Af.Symbol, km = Af.Uint8Array, f$ = Am ? Am.allocUnsafe : n, Em = c$(dh.getPrototypeOf, dh), h$ = dh.create, g$ = Kg.propertyIsEnumerable, Tm = _m.splice, m$ = xg ? xg.isConcatSpreadable : n, nm = xg ? xg.iterator : n, Mg = xg ? xg.toStringTag : n, Dm = function() {
        try {
          var o = Rg(dh, "defineProperty");
          return o({}, "", {}), o;
        } catch {
        }
      }(), L1 = Af.clearTimeout !== Dh.clearTimeout && Af.clearTimeout, O1 = Vf && Vf.now !== Dh.Date.now && Vf.now, P1 = Af.setTimeout !== Dh.setTimeout && Af.setTimeout, Mm = kh.ceil, Im = kh.floor, Lv = dh.getOwnPropertySymbols, R1 = Am ? Am.isBuffer : n, v$ = Af.isFinite, N1 = _m.join, B1 = c$(dh.keys, dh), Eh = kh.max, Ih = kh.min, F1 = Vf.now, V1 = Af.parseInt, $$ = kh.random, z1 = _m.reverse, Ov = Rg(Af, "DataView"), rm = Rg(Af, "Map"), Pv = Rg(Af, "Promise"), qg = Rg(Af, "Set"), om = Rg(Af, "WeakMap"), im = Rg(dh, "create"), Lm = om && new om(), jg = {}, H1 = Ng(Ov), W1 = Ng(rm), U1 = Ng(Pv), K1 = Ng(qg), q1 = Ng(om), Om = xg ? xg.prototype : n, sm = Om ? Om.valueOf : n, b$ = Om ? Om.toString : n;
      function nf(o) {
        if (yh(o) && !eh(o) && !(o instanceof sh)) {
          if (o instanceof Qh)
            return o;
          if (uh.call(o, "__wrapped__"))
            return yb(o);
        }
        return new Qh(o);
      }
      var Yg = /* @__PURE__ */ function() {
        function o() {
        }
        return function(a) {
          if (!mh(a))
            return {};
          if (h$)
            return h$(a);
          o.prototype = a;
          var d = new o();
          return o.prototype = n, d;
        };
      }();
      function Pm() {
      }
      function Qh(o, a) {
        this.__wrapped__ = o, this.__actions__ = [], this.__chain__ = !!a, this.__index__ = 0, this.__values__ = n;
      }
      nf.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: sy,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: ay,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: E0,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: nf
        }
      }, nf.prototype = Pm.prototype, nf.prototype.constructor = nf, Qh.prototype = Yg(Pm.prototype), Qh.prototype.constructor = Qh;
      function sh(o) {
        this.__wrapped__ = o, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Wf, this.__views__ = [];
      }
      function j1() {
        var o = new sh(this.__wrapped__);
        return o.__actions__ = Bh(this.__actions__), o.__dir__ = this.__dir__, o.__filtered__ = this.__filtered__, o.__iteratees__ = Bh(this.__iteratees__), o.__takeCount__ = this.__takeCount__, o.__views__ = Bh(this.__views__), o;
      }
      function Y1() {
        if (this.__filtered__) {
          var o = new sh(this);
          o.__dir__ = -1, o.__filtered__ = !0;
        } else
          o = this.clone(), o.__dir__ *= -1;
        return o;
      }
      function Z1() {
        var o = this.__wrapped__.value(), a = this.__dir__, d = eh(o), Zu = a < 0, Ju = d ? o.length : 0, of = a_(0, Ju, this.__views__), df = of.start, mf = of.end, wf = mf - df, Tf = Zu ? mf : df - 1, Df = this.__iteratees__, Lf = Df.length, Nf = 0, Kf = Ih(wf, this.__takeCount__);
        if (!d || !Zu && Ju == wf && Kf == wf)
          return W$(o, this.__actions__);
        var Gf = [];
        e:
          for (; wf-- && Nf < Kf; ) {
            Tf += a;
            for (var nh = -1, Xf = o[Tf]; ++nh < Lf; ) {
              var oh = Df[nh], ah = oh.iteratee, qh = oh.type, Nh = ah(Xf);
              if (qh == Uf)
                Xf = Nh;
              else if (!Nh) {
                if (qh == Mf)
                  continue e;
                break e;
              }
            }
            Gf[Nf++] = Xf;
          }
        return Gf;
      }
      sh.prototype = Yg(Pm.prototype), sh.prototype.constructor = sh;
      function Ig(o) {
        var a = -1, d = o == null ? 0 : o.length;
        for (this.clear(); ++a < d; ) {
          var Zu = o[a];
          this.set(Zu[0], Zu[1]);
        }
      }
      function G1() {
        this.__data__ = im ? im(null) : {}, this.size = 0;
      }
      function X1(o) {
        var a = this.has(o) && delete this.__data__[o];
        return this.size -= a ? 1 : 0, a;
      }
      function Q1(o) {
        var a = this.__data__;
        if (im) {
          var d = a[o];
          return d === u ? n : d;
        }
        return uh.call(a, o) ? a[o] : n;
      }
      function J1(o) {
        var a = this.__data__;
        return im ? a[o] !== n : uh.call(a, o);
      }
      function ew(o, a) {
        var d = this.__data__;
        return this.size += this.has(o) ? 0 : 1, d[o] = im && a === n ? u : a, this;
      }
      Ig.prototype.clear = G1, Ig.prototype.delete = X1, Ig.prototype.get = Q1, Ig.prototype.has = J1, Ig.prototype.set = ew;
      function ug(o) {
        var a = -1, d = o == null ? 0 : o.length;
        for (this.clear(); ++a < d; ) {
          var Zu = o[a];
          this.set(Zu[0], Zu[1]);
        }
      }
      function tw() {
        this.__data__ = [], this.size = 0;
      }
      function nw(o) {
        var a = this.__data__, d = Rm(a, o);
        if (d < 0)
          return !1;
        var Zu = a.length - 1;
        return d == Zu ? a.pop() : Tm.call(a, d, 1), --this.size, !0;
      }
      function rw(o) {
        var a = this.__data__, d = Rm(a, o);
        return d < 0 ? n : a[d][1];
      }
      function ow(o) {
        return Rm(this.__data__, o) > -1;
      }
      function iw(o, a) {
        var d = this.__data__, Zu = Rm(d, o);
        return Zu < 0 ? (++this.size, d.push([o, a])) : d[Zu][1] = a, this;
      }
      ug.prototype.clear = tw, ug.prototype.delete = nw, ug.prototype.get = rw, ug.prototype.has = ow, ug.prototype.set = iw;
      function dg(o) {
        var a = -1, d = o == null ? 0 : o.length;
        for (this.clear(); ++a < d; ) {
          var Zu = o[a];
          this.set(Zu[0], Zu[1]);
        }
      }
      function sw() {
        this.size = 0, this.__data__ = {
          hash: new Ig(),
          map: new (rm || ug)(),
          string: new Ig()
        };
      }
      function aw(o) {
        var a = Ym(this, o).delete(o);
        return this.size -= a ? 1 : 0, a;
      }
      function lw(o) {
        return Ym(this, o).get(o);
      }
      function pw(o) {
        return Ym(this, o).has(o);
      }
      function cw(o, a) {
        var d = Ym(this, o), Zu = d.size;
        return d.set(o, a), this.size += d.size == Zu ? 0 : 1, this;
      }
      dg.prototype.clear = sw, dg.prototype.delete = aw, dg.prototype.get = lw, dg.prototype.has = pw, dg.prototype.set = cw;
      function Lg(o) {
        var a = -1, d = o == null ? 0 : o.length;
        for (this.__data__ = new dg(); ++a < d; )
          this.add(o[a]);
      }
      function uw(o) {
        return this.__data__.set(o, u), this;
      }
      function dw(o) {
        return this.__data__.has(o);
      }
      Lg.prototype.add = Lg.prototype.push = uw, Lg.prototype.has = dw;
      function og(o) {
        var a = this.__data__ = new ug(o);
        this.size = a.size;
      }
      function fw() {
        this.__data__ = new ug(), this.size = 0;
      }
      function hw(o) {
        var a = this.__data__, d = a.delete(o);
        return this.size = a.size, d;
      }
      function gw(o) {
        return this.__data__.get(o);
      }
      function mw(o) {
        return this.__data__.has(o);
      }
      function vw(o, a) {
        var d = this.__data__;
        if (d instanceof ug) {
          var Zu = d.__data__;
          if (!rm || Zu.length < i - 1)
            return Zu.push([o, a]), this.size = ++d.size, this;
          d = this.__data__ = new dg(Zu);
        }
        return d.set(o, a), this.size = d.size, this;
      }
      og.prototype.clear = fw, og.prototype.delete = hw, og.prototype.get = gw, og.prototype.has = mw, og.prototype.set = vw;
      function y$(o, a) {
        var d = eh(o), Zu = !d && Bg(o), Ju = !d && !Zu && Eg(o), of = !d && !Zu && !Ju && Qg(o), df = d || Zu || Ju || of, mf = df ? Tv(o.length, k1) : [], wf = mf.length;
        for (var Tf in o)
          (a || uh.call(o, Tf)) && !(df && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Tf == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          Ju && (Tf == "offset" || Tf == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          of && (Tf == "buffer" || Tf == "byteLength" || Tf == "byteOffset") || // Skip index properties.
          mg(Tf, wf))) && mf.push(Tf);
        return mf;
      }
      function w$(o) {
        var a = o.length;
        return a ? o[qv(0, a - 1)] : n;
      }
      function $w(o, a) {
        return Zm(Bh(o), Og(a, 0, o.length));
      }
      function bw(o) {
        return Zm(Bh(o));
      }
      function Rv(o, a, d) {
        (d !== n && !ig(o[a], d) || d === n && !(a in o)) && fg(o, a, d);
      }
      function am(o, a, d) {
        var Zu = o[a];
        (!(uh.call(o, a) && ig(Zu, d)) || d === n && !(a in o)) && fg(o, a, d);
      }
      function Rm(o, a) {
        for (var d = o.length; d--; )
          if (ig(o[d][0], a))
            return d;
        return -1;
      }
      function yw(o, a, d, Zu) {
        return Sg(o, function(Ju, of, df) {
          a(Zu, Ju, d(Ju), df);
        }), Zu;
      }
      function _$(o, a) {
        return o && pg(a, Th(a), o);
      }
      function ww(o, a) {
        return o && pg(a, Vh(a), o);
      }
      function fg(o, a, d) {
        a == "__proto__" && Dm ? Dm(o, a, {
          configurable: !0,
          enumerable: !0,
          value: d,
          writable: !0
        }) : o[a] = d;
      }
      function Nv(o, a) {
        for (var d = -1, Zu = a.length, Ju = xf(Zu), of = o == null; ++d < Zu; )
          Ju[d] = of ? n : v0(o, a[d]);
        return Ju;
      }
      function Og(o, a, d) {
        return o === o && (d !== n && (o = o <= d ? o : d), a !== n && (o = o >= a ? o : a)), o;
      }
      function Jh(o, a, d, Zu, Ju, of) {
        var df, mf = a & Gu, wf = a & Qu, Tf = a & Xu;
        if (d && (df = Ju ? d(o, Zu, Ju, of) : d(o)), df !== n)
          return df;
        if (!mh(o))
          return o;
        var Df = eh(o);
        if (Df) {
          if (df = p_(o), !mf)
            return Bh(o, df);
        } else {
          var Lf = Lh(o), Nf = Lf == zf || Lf == Qf;
          if (Eg(o))
            return q$(o, mf);
          if (Lf == $h || Lf == _f || Nf && !Ju) {
            if (df = wf || Nf ? {} : ub(o), !mf)
              return wf ? Qw(o, ww(df, o)) : Xw(o, _$(df, o));
          } else {
            if (!fh[Lf])
              return Ju ? o : {};
            df = c_(o, Lf, mf);
          }
        }
        of || (of = new og());
        var Kf = of.get(o);
        if (Kf)
          return Kf;
        of.set(o, df), Vb(o) ? o.forEach(function(Xf) {
          df.add(Jh(Xf, a, d, Xf, o, of));
        }) : Bb(o) && o.forEach(function(Xf, oh) {
          df.set(oh, Jh(Xf, a, d, oh, o, of));
        });
        var Gf = Tf ? wf ? r0 : n0 : wf ? Vh : Th, nh = Df ? n : Gf(o);
        return Gh(nh || o, function(Xf, oh) {
          nh && (oh = Xf, Xf = o[oh]), am(df, oh, Jh(Xf, a, d, oh, o, of));
        }), df;
      }
      function _w(o) {
        var a = Th(o);
        return function(d) {
          return x$(d, o, a);
        };
      }
      function x$(o, a, d) {
        var Zu = d.length;
        if (o == null)
          return !Zu;
        for (o = dh(o); Zu--; ) {
          var Ju = d[Zu], of = a[Ju], df = o[Ju];
          if (df === n && !(Ju in o) || !of(df))
            return !1;
        }
        return !0;
      }
      function S$(o, a, d) {
        if (typeof o != "function")
          throw new Xh(l);
        return hm(function() {
          o.apply(n, d);
        }, a);
      }
      function lm(o, a, d, Zu) {
        var Ju = -1, of = bm, df = !0, mf = o.length, wf = [], Tf = a.length;
        if (!mf)
          return wf;
        d && (a = gh(a, Wh(d))), Zu ? (of = xv, df = !1) : a.length >= i && (of = tm, df = !1, a = new Lg(a));
        e:
          for (; ++Ju < mf; ) {
            var Df = o[Ju], Lf = d == null ? Df : d(Df);
            if (Df = Zu || Df !== 0 ? Df : 0, df && Lf === Lf) {
              for (var Nf = Tf; Nf--; )
                if (a[Nf] === Lf)
                  continue e;
              wf.push(Df);
            } else of(a, Lf, Zu) || wf.push(Df);
          }
        return wf;
      }
      var Sg = X$(lg), C$ = X$(Fv, !0);
      function xw(o, a) {
        var d = !0;
        return Sg(o, function(Zu, Ju, of) {
          return d = !!a(Zu, Ju, of), d;
        }), d;
      }
      function Nm(o, a, d) {
        for (var Zu = -1, Ju = o.length; ++Zu < Ju; ) {
          var of = o[Zu], df = a(of);
          if (df != null && (mf === n ? df === df && !Kh(df) : d(df, mf)))
            var mf = df, wf = of;
        }
        return wf;
      }
      function Sw(o, a, d, Zu) {
        var Ju = o.length;
        for (d = th(d), d < 0 && (d = -d > Ju ? 0 : Ju + d), Zu = Zu === n || Zu > Ju ? Ju : th(Zu), Zu < 0 && (Zu += Ju), Zu = d > Zu ? 0 : Hb(Zu); d < Zu; )
          o[d++] = a;
        return o;
      }
      function A$(o, a) {
        var d = [];
        return Sg(o, function(Zu, Ju, of) {
          a(Zu, Ju, of) && d.push(Zu);
        }), d;
      }
      function Mh(o, a, d, Zu, Ju) {
        var of = -1, df = o.length;
        for (d || (d = d_), Ju || (Ju = []); ++of < df; ) {
          var mf = o[of];
          a > 0 && d(mf) ? a > 1 ? Mh(mf, a - 1, d, Zu, Ju) : wg(Ju, mf) : Zu || (Ju[Ju.length] = mf);
        }
        return Ju;
      }
      var Bv = Q$(), k$ = Q$(!0);
      function lg(o, a) {
        return o && Bv(o, a, Th);
      }
      function Fv(o, a) {
        return o && k$(o, a, Th);
      }
      function Bm(o, a) {
        return yg(a, function(d) {
          return vg(o[d]);
        });
      }
      function Pg(o, a) {
        a = Ag(a, o);
        for (var d = 0, Zu = a.length; o != null && d < Zu; )
          o = o[cg(a[d++])];
        return d && d == Zu ? o : n;
      }
      function E$(o, a, d) {
        var Zu = a(o);
        return eh(o) ? Zu : wg(Zu, d(o));
      }
      function Ph(o) {
        return o == null ? o === n ? em : Sh : Mg && Mg in dh(o) ? s_(o) : b_(o);
      }
      function Vv(o, a) {
        return o > a;
      }
      function Cw(o, a) {
        return o != null && uh.call(o, a);
      }
      function Aw(o, a) {
        return o != null && a in dh(o);
      }
      function kw(o, a, d) {
        return o >= Ih(a, d) && o < Eh(a, d);
      }
      function zv(o, a, d) {
        for (var Zu = d ? xv : bm, Ju = o[0].length, of = o.length, df = of, mf = xf(of), wf = 1 / 0, Tf = []; df--; ) {
          var Df = o[df];
          df && a && (Df = gh(Df, Wh(a))), wf = Ih(Df.length, wf), mf[df] = !d && (a || Ju >= 120 && Df.length >= 120) ? new Lg(df && Df) : n;
        }
        Df = o[0];
        var Lf = -1, Nf = mf[0];
        e:
          for (; ++Lf < Ju && Tf.length < wf; ) {
            var Kf = Df[Lf], Gf = a ? a(Kf) : Kf;
            if (Kf = d || Kf !== 0 ? Kf : 0, !(Nf ? tm(Nf, Gf) : Zu(Tf, Gf, d))) {
              for (df = of; --df; ) {
                var nh = mf[df];
                if (!(nh ? tm(nh, Gf) : Zu(o[df], Gf, d)))
                  continue e;
              }
              Nf && Nf.push(Gf), Tf.push(Kf);
            }
          }
        return Tf;
      }
      function Ew(o, a, d, Zu) {
        return lg(o, function(Ju, of, df) {
          a(Zu, d(Ju), of, df);
        }), Zu;
      }
      function pm(o, a, d) {
        a = Ag(a, o), o = gb(o, a);
        var Zu = o == null ? o : o[cg(tg(a))];
        return Zu == null ? n : Hh(Zu, o, d);
      }
      function T$(o) {
        return yh(o) && Ph(o) == _f;
      }
      function Tw(o) {
        return yh(o) && Ph(o) == Tg;
      }
      function Dw(o) {
        return yh(o) && Ph(o) == Of;
      }
      function cm(o, a, d, Zu, Ju) {
        return o === a ? !0 : o == null || a == null || !yh(o) && !yh(a) ? o !== o && a !== a : Mw(o, a, d, Zu, cm, Ju);
      }
      function Mw(o, a, d, Zu, Ju, of) {
        var df = eh(o), mf = eh(a), wf = df ? Cf : Lh(o), Tf = mf ? Cf : Lh(a);
        wf = wf == _f ? $h : wf, Tf = Tf == _f ? $h : Tf;
        var Df = wf == $h, Lf = Tf == $h, Nf = wf == Tf;
        if (Nf && Eg(o)) {
          if (!Eg(a))
            return !1;
          df = !0, Df = !1;
        }
        if (Nf && !Df)
          return of || (of = new og()), df || Qg(o) ? lb(o, a, d, Zu, Ju, of) : o_(o, a, wf, d, Zu, Ju, of);
        if (!(d & ef)) {
          var Kf = Df && uh.call(o, "__wrapped__"), Gf = Lf && uh.call(a, "__wrapped__");
          if (Kf || Gf) {
            var nh = Kf ? o.value() : o, Xf = Gf ? a.value() : a;
            return of || (of = new og()), Ju(nh, Xf, d, Zu, of);
          }
        }
        return Nf ? (of || (of = new og()), i_(o, a, d, Zu, Ju, of)) : !1;
      }
      function Iw(o) {
        return yh(o) && Lh(o) == qf;
      }
      function Hv(o, a, d, Zu) {
        var Ju = d.length, of = Ju, df = !Zu;
        if (o == null)
          return !of;
        for (o = dh(o); Ju--; ) {
          var mf = d[Ju];
          if (df && mf[2] ? mf[1] !== o[mf[0]] : !(mf[0] in o))
            return !1;
        }
        for (; ++Ju < of; ) {
          mf = d[Ju];
          var wf = mf[0], Tf = o[wf], Df = mf[1];
          if (df && mf[2]) {
            if (Tf === n && !(wf in o))
              return !1;
          } else {
            var Lf = new og();
            if (Zu)
              var Nf = Zu(Tf, Df, wf, o, a, Lf);
            if (!(Nf === n ? cm(Df, Tf, ef | tf, Zu, Lf) : Nf))
              return !1;
          }
        }
        return !0;
      }
      function D$(o) {
        if (!mh(o) || h_(o))
          return !1;
        var a = vg(o) ? I1 : _y;
        return a.test(Ng(o));
      }
      function Lw(o) {
        return yh(o) && Ph(o) == Ah;
      }
      function Ow(o) {
        return yh(o) && Lh(o) == bh;
      }
      function Pw(o) {
        return yh(o) && tv(o.length) && !!hh[Ph(o)];
      }
      function M$(o) {
        return typeof o == "function" ? o : o == null ? zh : typeof o == "object" ? eh(o) ? O$(o[0], o[1]) : L$(o) : Jb(o);
      }
      function Wv(o) {
        if (!fm(o))
          return B1(o);
        var a = [];
        for (var d in dh(o))
          uh.call(o, d) && d != "constructor" && a.push(d);
        return a;
      }
      function Rw(o) {
        if (!mh(o))
          return $_(o);
        var a = fm(o), d = [];
        for (var Zu in o)
          Zu == "constructor" && (a || !uh.call(o, Zu)) || d.push(Zu);
        return d;
      }
      function Uv(o, a) {
        return o < a;
      }
      function I$(o, a) {
        var d = -1, Zu = Fh(o) ? xf(o.length) : [];
        return Sg(o, function(Ju, of, df) {
          Zu[++d] = a(Ju, of, df);
        }), Zu;
      }
      function L$(o) {
        var a = i0(o);
        return a.length == 1 && a[0][2] ? fb(a[0][0], a[0][1]) : function(d) {
          return d === o || Hv(d, o, a);
        };
      }
      function O$(o, a) {
        return a0(o) && db(a) ? fb(cg(o), a) : function(d) {
          var Zu = v0(d, o);
          return Zu === n && Zu === a ? $0(d, o) : cm(a, Zu, ef | tf);
        };
      }
      function Fm(o, a, d, Zu, Ju) {
        o !== a && Bv(a, function(of, df) {
          if (Ju || (Ju = new og()), mh(of))
            Nw(o, a, df, d, Fm, Zu, Ju);
          else {
            var mf = Zu ? Zu(p0(o, df), of, df + "", o, a, Ju) : n;
            mf === n && (mf = of), Rv(o, df, mf);
          }
        }, Vh);
      }
      function Nw(o, a, d, Zu, Ju, of, df) {
        var mf = p0(o, d), wf = p0(a, d), Tf = df.get(wf);
        if (Tf) {
          Rv(o, d, Tf);
          return;
        }
        var Df = of ? of(mf, wf, d + "", o, a, df) : n, Lf = Df === n;
        if (Lf) {
          var Nf = eh(wf), Kf = !Nf && Eg(wf), Gf = !Nf && !Kf && Qg(wf);
          Df = wf, Nf || Kf || Gf ? eh(mf) ? Df = mf : _h(mf) ? Df = Bh(mf) : Kf ? (Lf = !1, Df = q$(wf, !0)) : Gf ? (Lf = !1, Df = j$(wf, !0)) : Df = [] : gm(wf) || Bg(wf) ? (Df = mf, Bg(mf) ? Df = Wb(mf) : (!mh(mf) || vg(mf)) && (Df = ub(wf))) : Lf = !1;
        }
        Lf && (df.set(wf, Df), Ju(Df, wf, Zu, of, df), df.delete(wf)), Rv(o, d, Df);
      }
      function P$(o, a) {
        var d = o.length;
        if (d)
          return a += a < 0 ? d : 0, mg(a, d) ? o[a] : n;
      }
      function R$(o, a, d) {
        a.length ? a = gh(a, function(of) {
          return eh(of) ? function(df) {
            return Pg(df, of.length === 1 ? of[0] : of);
          } : of;
        }) : a = [zh];
        var Zu = -1;
        a = gh(a, Wh(Yf()));
        var Ju = I$(o, function(of, df, mf) {
          var wf = gh(a, function(Tf) {
            return Tf(of);
          });
          return { criteria: wf, index: ++Zu, value: of };
        });
        return c1(Ju, function(of, df) {
          return Gw(of, df, d);
        });
      }
      function Bw(o, a) {
        return N$(o, a, function(d, Zu) {
          return $0(o, Zu);
        });
      }
      function N$(o, a, d) {
        for (var Zu = -1, Ju = a.length, of = {}; ++Zu < Ju; ) {
          var df = a[Zu], mf = Pg(o, df);
          d(mf, df) && um(of, Ag(df, o), mf);
        }
        return of;
      }
      function Fw(o) {
        return function(a) {
          return Pg(a, o);
        };
      }
      function Kv(o, a, d, Zu) {
        var Ju = Zu ? p1 : zg, of = -1, df = a.length, mf = o;
        for (o === a && (a = Bh(a)), d && (mf = gh(o, Wh(d))); ++of < df; )
          for (var wf = 0, Tf = a[of], Df = d ? d(Tf) : Tf; (wf = Ju(mf, Df, wf, Zu)) > -1; )
            mf !== o && Tm.call(mf, wf, 1), Tm.call(o, wf, 1);
        return o;
      }
      function B$(o, a) {
        for (var d = o ? a.length : 0, Zu = d - 1; d--; ) {
          var Ju = a[d];
          if (d == Zu || Ju !== of) {
            var of = Ju;
            mg(Ju) ? Tm.call(o, Ju, 1) : Zv(o, Ju);
          }
        }
        return o;
      }
      function qv(o, a) {
        return o + Im($$() * (a - o + 1));
      }
      function Vw(o, a, d, Zu) {
        for (var Ju = -1, of = Eh(Mm((a - o) / (d || 1)), 0), df = xf(of); of--; )
          df[Zu ? of : ++Ju] = o, o += d;
        return df;
      }
      function jv(o, a) {
        var d = "";
        if (!o || a < 1 || a > Bf)
          return d;
        do
          a % 2 && (d += o), a = Im(a / 2), a && (o += o);
        while (a);
        return d;
      }
      function rh(o, a) {
        return c0(hb(o, a, zh), o + "");
      }
      function zw(o) {
        return w$(Jg(o));
      }
      function Hw(o, a) {
        var d = Jg(o);
        return Zm(d, Og(a, 0, d.length));
      }
      function um(o, a, d, Zu) {
        if (!mh(o))
          return o;
        a = Ag(a, o);
        for (var Ju = -1, of = a.length, df = of - 1, mf = o; mf != null && ++Ju < of; ) {
          var wf = cg(a[Ju]), Tf = d;
          if (wf === "__proto__" || wf === "constructor" || wf === "prototype")
            return o;
          if (Ju != df) {
            var Df = mf[wf];
            Tf = Zu ? Zu(Df, wf, mf) : n, Tf === n && (Tf = mh(Df) ? Df : mg(a[Ju + 1]) ? [] : {});
          }
          am(mf, wf, Tf), mf = mf[wf];
        }
        return o;
      }
      var F$ = Lm ? function(o, a) {
        return Lm.set(o, a), o;
      } : zh, Ww = Dm ? function(o, a) {
        return Dm(o, "toString", {
          configurable: !0,
          enumerable: !1,
          value: y0(a),
          writable: !0
        });
      } : zh;
      function Uw(o) {
        return Zm(Jg(o));
      }
      function eg(o, a, d) {
        var Zu = -1, Ju = o.length;
        a < 0 && (a = -a > Ju ? 0 : Ju + a), d = d > Ju ? Ju : d, d < 0 && (d += Ju), Ju = a > d ? 0 : d - a >>> 0, a >>>= 0;
        for (var of = xf(Ju); ++Zu < Ju; )
          of[Zu] = o[Zu + a];
        return of;
      }
      function Kw(o, a) {
        var d;
        return Sg(o, function(Zu, Ju, of) {
          return d = a(Zu, Ju, of), !d;
        }), !!d;
      }
      function Vm(o, a, d) {
        var Zu = 0, Ju = o == null ? Zu : o.length;
        if (typeof a == "number" && a === a && Ju <= Ef) {
          for (; Zu < Ju; ) {
            var of = Zu + Ju >>> 1, df = o[of];
            df !== null && !Kh(df) && (d ? df <= a : df < a) ? Zu = of + 1 : Ju = of;
          }
          return Ju;
        }
        return Yv(o, a, zh, d);
      }
      function Yv(o, a, d, Zu) {
        var Ju = 0, of = o == null ? 0 : o.length;
        if (of === 0)
          return 0;
        a = d(a);
        for (var df = a !== a, mf = a === null, wf = Kh(a), Tf = a === n; Ju < of; ) {
          var Df = Im((Ju + of) / 2), Lf = d(o[Df]), Nf = Lf !== n, Kf = Lf === null, Gf = Lf === Lf, nh = Kh(Lf);
          if (df)
            var Xf = Zu || Gf;
          else Tf ? Xf = Gf && (Zu || Nf) : mf ? Xf = Gf && Nf && (Zu || !Kf) : wf ? Xf = Gf && Nf && !Kf && (Zu || !nh) : Kf || nh ? Xf = !1 : Xf = Zu ? Lf <= a : Lf < a;
          Xf ? Ju = Df + 1 : of = Df;
        }
        return Ih(of, vh);
      }
      function V$(o, a) {
        for (var d = -1, Zu = o.length, Ju = 0, of = []; ++d < Zu; ) {
          var df = o[d], mf = a ? a(df) : df;
          if (!d || !ig(mf, wf)) {
            var wf = mf;
            of[Ju++] = df === 0 ? 0 : df;
          }
        }
        return of;
      }
      function z$(o) {
        return typeof o == "number" ? o : Kh(o) ? lh : +o;
      }
      function Uh(o) {
        if (typeof o == "string")
          return o;
        if (eh(o))
          return gh(o, Uh) + "";
        if (Kh(o))
          return b$ ? b$.call(o) : "";
        var a = o + "";
        return a == "0" && 1 / o == -Rf ? "-0" : a;
      }
      function Cg(o, a, d) {
        var Zu = -1, Ju = bm, of = o.length, df = !0, mf = [], wf = mf;
        if (d)
          df = !1, Ju = xv;
        else if (of >= i) {
          var Tf = a ? null : n_(o);
          if (Tf)
            return wm(Tf);
          df = !1, Ju = tm, wf = new Lg();
        } else
          wf = a ? [] : mf;
        e:
          for (; ++Zu < of; ) {
            var Df = o[Zu], Lf = a ? a(Df) : Df;
            if (Df = d || Df !== 0 ? Df : 0, df && Lf === Lf) {
              for (var Nf = wf.length; Nf--; )
                if (wf[Nf] === Lf)
                  continue e;
              a && wf.push(Lf), mf.push(Df);
            } else Ju(wf, Lf, d) || (wf !== mf && wf.push(Lf), mf.push(Df));
          }
        return mf;
      }
      function Zv(o, a) {
        return a = Ag(a, o), o = gb(o, a), o == null || delete o[cg(tg(a))];
      }
      function H$(o, a, d, Zu) {
        return um(o, a, d(Pg(o, a)), Zu);
      }
      function zm(o, a, d, Zu) {
        for (var Ju = o.length, of = Zu ? Ju : -1; (Zu ? of-- : ++of < Ju) && a(o[of], of, o); )
          ;
        return d ? eg(o, Zu ? 0 : of, Zu ? of + 1 : Ju) : eg(o, Zu ? of + 1 : 0, Zu ? Ju : of);
      }
      function W$(o, a) {
        var d = o;
        return d instanceof sh && (d = d.value()), Sv(a, function(Zu, Ju) {
          return Ju.func.apply(Ju.thisArg, wg([Zu], Ju.args));
        }, d);
      }
      function Gv(o, a, d) {
        var Zu = o.length;
        if (Zu < 2)
          return Zu ? Cg(o[0]) : [];
        for (var Ju = -1, of = xf(Zu); ++Ju < Zu; )
          for (var df = o[Ju], mf = -1; ++mf < Zu; )
            mf != Ju && (of[Ju] = lm(of[Ju] || df, o[mf], a, d));
        return Cg(Mh(of, 1), a, d);
      }
      function U$(o, a, d) {
        for (var Zu = -1, Ju = o.length, of = a.length, df = {}; ++Zu < Ju; ) {
          var mf = Zu < of ? a[Zu] : n;
          d(df, o[Zu], mf);
        }
        return df;
      }
      function Xv(o) {
        return _h(o) ? o : [];
      }
      function Qv(o) {
        return typeof o == "function" ? o : zh;
      }
      function Ag(o, a) {
        return eh(o) ? o : a0(o, a) ? [o] : bb(ch(o));
      }
      var qw = rh;
      function kg(o, a, d) {
        var Zu = o.length;
        return d = d === n ? Zu : d, !a && d >= Zu ? o : eg(o, a, d);
      }
      var K$ = L1 || function(o) {
        return Dh.clearTimeout(o);
      };
      function q$(o, a) {
        if (a)
          return o.slice();
        var d = o.length, Zu = f$ ? f$(d) : new o.constructor(d);
        return o.copy(Zu), Zu;
      }
      function Jv(o) {
        var a = new o.constructor(o.byteLength);
        return new km(a).set(new km(o)), a;
      }
      function jw(o, a) {
        var d = a ? Jv(o.buffer) : o.buffer;
        return new o.constructor(d, o.byteOffset, o.byteLength);
      }
      function Yw(o) {
        var a = new o.constructor(o.source, T0.exec(o));
        return a.lastIndex = o.lastIndex, a;
      }
      function Zw(o) {
        return sm ? dh(sm.call(o)) : {};
      }
      function j$(o, a) {
        var d = a ? Jv(o.buffer) : o.buffer;
        return new o.constructor(d, o.byteOffset, o.length);
      }
      function Y$(o, a) {
        if (o !== a) {
          var d = o !== n, Zu = o === null, Ju = o === o, of = Kh(o), df = a !== n, mf = a === null, wf = a === a, Tf = Kh(a);
          if (!mf && !Tf && !of && o > a || of && df && wf && !mf && !Tf || Zu && df && wf || !d && wf || !Ju)
            return 1;
          if (!Zu && !of && !Tf && o < a || Tf && d && Ju && !Zu && !of || mf && d && Ju || !df && Ju || !wf)
            return -1;
        }
        return 0;
      }
      function Gw(o, a, d) {
        for (var Zu = -1, Ju = o.criteria, of = a.criteria, df = Ju.length, mf = d.length; ++Zu < df; ) {
          var wf = Y$(Ju[Zu], of[Zu]);
          if (wf) {
            if (Zu >= mf)
              return wf;
            var Tf = d[Zu];
            return wf * (Tf == "desc" ? -1 : 1);
          }
        }
        return o.index - a.index;
      }
      function Z$(o, a, d, Zu) {
        for (var Ju = -1, of = o.length, df = d.length, mf = -1, wf = a.length, Tf = Eh(of - df, 0), Df = xf(wf + Tf), Lf = !Zu; ++mf < wf; )
          Df[mf] = a[mf];
        for (; ++Ju < df; )
          (Lf || Ju < of) && (Df[d[Ju]] = o[Ju]);
        for (; Tf--; )
          Df[mf++] = o[Ju++];
        return Df;
      }
      function G$(o, a, d, Zu) {
        for (var Ju = -1, of = o.length, df = -1, mf = d.length, wf = -1, Tf = a.length, Df = Eh(of - mf, 0), Lf = xf(Df + Tf), Nf = !Zu; ++Ju < Df; )
          Lf[Ju] = o[Ju];
        for (var Kf = Ju; ++wf < Tf; )
          Lf[Kf + wf] = a[wf];
        for (; ++df < mf; )
          (Nf || Ju < of) && (Lf[Kf + d[df]] = o[Ju++]);
        return Lf;
      }
      function Bh(o, a) {
        var d = -1, Zu = o.length;
        for (a || (a = xf(Zu)); ++d < Zu; )
          a[d] = o[d];
        return a;
      }
      function pg(o, a, d, Zu) {
        var Ju = !d;
        d || (d = {});
        for (var of = -1, df = a.length; ++of < df; ) {
          var mf = a[of], wf = Zu ? Zu(d[mf], o[mf], mf, d, o) : n;
          wf === n && (wf = o[mf]), Ju ? fg(d, mf, wf) : am(d, mf, wf);
        }
        return d;
      }
      function Xw(o, a) {
        return pg(o, s0(o), a);
      }
      function Qw(o, a) {
        return pg(o, pb(o), a);
      }
      function Hm(o, a) {
        return function(d, Zu) {
          var Ju = eh(d) ? r1 : yw, of = a ? a() : {};
          return Ju(d, o, Yf(Zu, 2), of);
        };
      }
      function Zg(o) {
        return rh(function(a, d) {
          var Zu = -1, Ju = d.length, of = Ju > 1 ? d[Ju - 1] : n, df = Ju > 2 ? d[2] : n;
          for (of = o.length > 3 && typeof of == "function" ? (Ju--, of) : n, df && Rh(d[0], d[1], df) && (of = Ju < 3 ? n : of, Ju = 1), a = dh(a); ++Zu < Ju; ) {
            var mf = d[Zu];
            mf && o(a, mf, Zu, of);
          }
          return a;
        });
      }
      function X$(o, a) {
        return function(d, Zu) {
          if (d == null)
            return d;
          if (!Fh(d))
            return o(d, Zu);
          for (var Ju = d.length, of = a ? Ju : -1, df = dh(d); (a ? of-- : ++of < Ju) && Zu(df[of], of, df) !== !1; )
            ;
          return d;
        };
      }
      function Q$(o) {
        return function(a, d, Zu) {
          for (var Ju = -1, of = dh(a), df = Zu(a), mf = df.length; mf--; ) {
            var wf = df[o ? mf : ++Ju];
            if (d(of[wf], wf, of) === !1)
              break;
          }
          return a;
        };
      }
      function Jw(o, a, d) {
        var Zu = a & af, Ju = dm(o);
        function of() {
          var df = this && this !== Dh && this instanceof of ? Ju : o;
          return df.apply(Zu ? d : this, arguments);
        }
        return of;
      }
      function J$(o) {
        return function(a) {
          a = ch(a);
          var d = Hg(a) ? rg(a) : n, Zu = d ? d[0] : a.charAt(0), Ju = d ? kg(d, 1).join("") : a.slice(1);
          return Zu[o]() + Ju;
        };
      }
      function Gg(o) {
        return function(a) {
          return Sv(Xb(Gb(a).replace(Wy, "")), o, "");
        };
      }
      function dm(o) {
        return function() {
          var a = arguments;
          switch (a.length) {
            case 0:
              return new o();
            case 1:
              return new o(a[0]);
            case 2:
              return new o(a[0], a[1]);
            case 3:
              return new o(a[0], a[1], a[2]);
            case 4:
              return new o(a[0], a[1], a[2], a[3]);
            case 5:
              return new o(a[0], a[1], a[2], a[3], a[4]);
            case 6:
              return new o(a[0], a[1], a[2], a[3], a[4], a[5]);
            case 7:
              return new o(a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
          }
          var d = Yg(o.prototype), Zu = o.apply(d, a);
          return mh(Zu) ? Zu : d;
        };
      }
      function e_(o, a, d) {
        var Zu = dm(o);
        function Ju() {
          for (var of = arguments.length, df = xf(of), mf = of, wf = Xg(Ju); mf--; )
            df[mf] = arguments[mf];
          var Tf = of < 3 && df[0] !== wf && df[of - 1] !== wf ? [] : _g(df, wf);
          if (of -= Tf.length, of < d)
            return ob(
              o,
              a,
              Wm,
              Ju.placeholder,
              n,
              df,
              Tf,
              n,
              n,
              d - of
            );
          var Df = this && this !== Dh && this instanceof Ju ? Zu : o;
          return Hh(Df, this, df);
        }
        return Ju;
      }
      function eb(o) {
        return function(a, d, Zu) {
          var Ju = dh(a);
          if (!Fh(a)) {
            var of = Yf(d, 3);
            a = Th(a), d = function(mf) {
              return of(Ju[mf], mf, Ju);
            };
          }
          var df = o(a, d, Zu);
          return df > -1 ? Ju[of ? a[df] : df] : n;
        };
      }
      function tb(o) {
        return gg(function(a) {
          var d = a.length, Zu = d, Ju = Qh.prototype.thru;
          for (o && a.reverse(); Zu--; ) {
            var of = a[Zu];
            if (typeof of != "function")
              throw new Xh(l);
            if (Ju && !df && jm(of) == "wrapper")
              var df = new Qh([], !0);
          }
          for (Zu = df ? Zu : d; ++Zu < d; ) {
            of = a[Zu];
            var mf = jm(of), wf = mf == "wrapper" ? o0(of) : n;
            wf && l0(wf[0]) && wf[1] == (vf | sf | $f | cf) && !wf[4].length && wf[9] == 1 ? df = df[jm(wf[0])].apply(df, wf[3]) : df = of.length == 1 && l0(of) ? df[mf]() : df.thru(of);
          }
          return function() {
            var Tf = arguments, Df = Tf[0];
            if (df && Tf.length == 1 && eh(Df))
              return df.plant(Df).value();
            for (var Lf = 0, Nf = d ? a[Lf].apply(this, Tf) : Df; ++Lf < d; )
              Nf = a[Lf].call(this, Nf);
            return Nf;
          };
        });
      }
      function Wm(o, a, d, Zu, Ju, of, df, mf, wf, Tf) {
        var Df = a & vf, Lf = a & af, Nf = a & rf, Kf = a & (sf | pf), Gf = a & yf, nh = Nf ? n : dm(o);
        function Xf() {
          for (var oh = arguments.length, ah = xf(oh), qh = oh; qh--; )
            ah[qh] = arguments[qh];
          if (Kf)
            var Nh = Xg(Xf), jh = d1(ah, Nh);
          if (Zu && (ah = Z$(ah, Zu, Ju, Kf)), of && (ah = G$(ah, of, df, Kf)), oh -= jh, Kf && oh < Tf) {
            var xh = _g(ah, Nh);
            return ob(
              o,
              a,
              Wm,
              Xf.placeholder,
              d,
              ah,
              xh,
              mf,
              wf,
              Tf - oh
            );
          }
          var sg = Lf ? d : this, bg = Nf ? sg[o] : o;
          return oh = ah.length, mf ? ah = y_(ah, mf) : Gf && oh > 1 && ah.reverse(), Df && wf < oh && (ah.length = wf), this && this !== Dh && this instanceof Xf && (bg = nh || dm(bg)), bg.apply(sg, ah);
        }
        return Xf;
      }
      function nb(o, a) {
        return function(d, Zu) {
          return Ew(d, o, a(Zu), {});
        };
      }
      function Um(o, a) {
        return function(d, Zu) {
          var Ju;
          if (d === n && Zu === n)
            return a;
          if (d !== n && (Ju = d), Zu !== n) {
            if (Ju === n)
              return Zu;
            typeof d == "string" || typeof Zu == "string" ? (d = Uh(d), Zu = Uh(Zu)) : (d = z$(d), Zu = z$(Zu)), Ju = o(d, Zu);
          }
          return Ju;
        };
      }
      function e0(o) {
        return gg(function(a) {
          return a = gh(a, Wh(Yf())), rh(function(d) {
            var Zu = this;
            return o(a, function(Ju) {
              return Hh(Ju, Zu, d);
            });
          });
        });
      }
      function Km(o, a) {
        a = a === n ? " " : Uh(a);
        var d = a.length;
        if (d < 2)
          return d ? jv(a, o) : a;
        var Zu = jv(a, Mm(o / Wg(a)));
        return Hg(a) ? kg(rg(Zu), 0, o).join("") : Zu.slice(0, o);
      }
      function t_(o, a, d, Zu) {
        var Ju = a & af, of = dm(o);
        function df() {
          for (var mf = -1, wf = arguments.length, Tf = -1, Df = Zu.length, Lf = xf(Df + wf), Nf = this && this !== Dh && this instanceof df ? of : o; ++Tf < Df; )
            Lf[Tf] = Zu[Tf];
          for (; wf--; )
            Lf[Tf++] = arguments[++mf];
          return Hh(Nf, Ju ? d : this, Lf);
        }
        return df;
      }
      function rb(o) {
        return function(a, d, Zu) {
          return Zu && typeof Zu != "number" && Rh(a, d, Zu) && (d = Zu = n), a = $g(a), d === n ? (d = a, a = 0) : d = $g(d), Zu = Zu === n ? a < d ? 1 : -1 : $g(Zu), Vw(a, d, Zu, o);
        };
      }
      function qm(o) {
        return function(a, d) {
          return typeof a == "string" && typeof d == "string" || (a = ng(a), d = ng(d)), o(a, d);
        };
      }
      function ob(o, a, d, Zu, Ju, of, df, mf, wf, Tf) {
        var Df = a & sf, Lf = Df ? df : n, Nf = Df ? n : df, Kf = Df ? of : n, Gf = Df ? n : of;
        a |= Df ? $f : uf, a &= ~(Df ? uf : $f), a & hf || (a &= ~(af | rf));
        var nh = [
          o,
          a,
          Ju,
          Kf,
          Lf,
          Gf,
          Nf,
          mf,
          wf,
          Tf
        ], Xf = d.apply(n, nh);
        return l0(o) && mb(Xf, nh), Xf.placeholder = Zu, vb(Xf, o, a);
      }
      function t0(o) {
        var a = kh[o];
        return function(d, Zu) {
          if (d = ng(d), Zu = Zu == null ? 0 : Ih(th(Zu), 292), Zu && v$(d)) {
            var Ju = (ch(d) + "e").split("e"), of = a(Ju[0] + "e" + (+Ju[1] + Zu));
            return Ju = (ch(of) + "e").split("e"), +(Ju[0] + "e" + (+Ju[1] - Zu));
          }
          return a(d);
        };
      }
      var n_ = qg && 1 / wm(new qg([, -0]))[1] == Rf ? function(o) {
        return new qg(o);
      } : x0;
      function ib(o) {
        return function(a) {
          var d = Lh(a);
          return d == qf ? Mv(a) : d == bh ? b1(a) : u1(a, o(a));
        };
      }
      function hg(o, a, d, Zu, Ju, of, df, mf) {
        var wf = a & rf;
        if (!wf && typeof o != "function")
          throw new Xh(l);
        var Tf = Zu ? Zu.length : 0;
        if (Tf || (a &= ~($f | uf), Zu = Ju = n), df = df === n ? df : Eh(th(df), 0), mf = mf === n ? mf : th(mf), Tf -= Ju ? Ju.length : 0, a & uf) {
          var Df = Zu, Lf = Ju;
          Zu = Ju = n;
        }
        var Nf = wf ? n : o0(o), Kf = [
          o,
          a,
          d,
          Zu,
          Ju,
          Df,
          Lf,
          of,
          df,
          mf
        ];
        if (Nf && v_(Kf, Nf), o = Kf[0], a = Kf[1], d = Kf[2], Zu = Kf[3], Ju = Kf[4], mf = Kf[9] = Kf[9] === n ? wf ? 0 : o.length : Eh(Kf[9] - Tf, 0), !mf && a & (sf | pf) && (a &= ~(sf | pf)), !a || a == af)
          var Gf = Jw(o, a, d);
        else a == sf || a == pf ? Gf = e_(o, a, mf) : (a == $f || a == (af | $f)) && !Ju.length ? Gf = t_(o, a, d, Zu) : Gf = Wm.apply(n, Kf);
        var nh = Nf ? F$ : mb;
        return vb(nh(Gf, Kf), o, a);
      }
      function sb(o, a, d, Zu) {
        return o === n || ig(o, Kg[d]) && !uh.call(Zu, d) ? a : o;
      }
      function ab(o, a, d, Zu, Ju, of) {
        return mh(o) && mh(a) && (of.set(a, o), Fm(o, a, n, ab, of), of.delete(a)), o;
      }
      function r_(o) {
        return gm(o) ? n : o;
      }
      function lb(o, a, d, Zu, Ju, of) {
        var df = d & ef, mf = o.length, wf = a.length;
        if (mf != wf && !(df && wf > mf))
          return !1;
        var Tf = of.get(o), Df = of.get(a);
        if (Tf && Df)
          return Tf == a && Df == o;
        var Lf = -1, Nf = !0, Kf = d & tf ? new Lg() : n;
        for (of.set(o, a), of.set(a, o); ++Lf < mf; ) {
          var Gf = o[Lf], nh = a[Lf];
          if (Zu)
            var Xf = df ? Zu(nh, Gf, Lf, a, o, of) : Zu(Gf, nh, Lf, o, a, of);
          if (Xf !== n) {
            if (Xf)
              continue;
            Nf = !1;
            break;
          }
          if (Kf) {
            if (!Cv(a, function(oh, ah) {
              if (!tm(Kf, ah) && (Gf === oh || Ju(Gf, oh, d, Zu, of)))
                return Kf.push(ah);
            })) {
              Nf = !1;
              break;
            }
          } else if (!(Gf === nh || Ju(Gf, nh, d, Zu, of))) {
            Nf = !1;
            break;
          }
        }
        return of.delete(o), of.delete(a), Nf;
      }
      function o_(o, a, d, Zu, Ju, of, df) {
        switch (d) {
          case Fg:
            if (o.byteLength != a.byteLength || o.byteOffset != a.byteOffset)
              return !1;
            o = o.buffer, a = a.buffer;
          case Tg:
            return !(o.byteLength != a.byteLength || !of(new km(o), new km(a)));
          case If:
          case Of:
          case jf:
            return ig(+o, +a);
          case Ff:
            return o.name == a.name && o.message == a.message;
          case Ah:
          case Yh:
            return o == a + "";
          case qf:
            var mf = Mv;
          case bh:
            var wf = Zu & ef;
            if (mf || (mf = wm), o.size != a.size && !wf)
              return !1;
            var Tf = df.get(o);
            if (Tf)
              return Tf == a;
            Zu |= tf, df.set(o, a);
            var Df = lb(mf(o), mf(a), Zu, Ju, of, df);
            return df.delete(o), Df;
          case ag:
            if (sm)
              return sm.call(o) == sm.call(a);
        }
        return !1;
      }
      function i_(o, a, d, Zu, Ju, of) {
        var df = d & ef, mf = n0(o), wf = mf.length, Tf = n0(a), Df = Tf.length;
        if (wf != Df && !df)
          return !1;
        for (var Lf = wf; Lf--; ) {
          var Nf = mf[Lf];
          if (!(df ? Nf in a : uh.call(a, Nf)))
            return !1;
        }
        var Kf = of.get(o), Gf = of.get(a);
        if (Kf && Gf)
          return Kf == a && Gf == o;
        var nh = !0;
        of.set(o, a), of.set(a, o);
        for (var Xf = df; ++Lf < wf; ) {
          Nf = mf[Lf];
          var oh = o[Nf], ah = a[Nf];
          if (Zu)
            var qh = df ? Zu(ah, oh, Nf, a, o, of) : Zu(oh, ah, Nf, o, a, of);
          if (!(qh === n ? oh === ah || Ju(oh, ah, d, Zu, of) : qh)) {
            nh = !1;
            break;
          }
          Xf || (Xf = Nf == "constructor");
        }
        if (nh && !Xf) {
          var Nh = o.constructor, jh = a.constructor;
          Nh != jh && "constructor" in o && "constructor" in a && !(typeof Nh == "function" && Nh instanceof Nh && typeof jh == "function" && jh instanceof jh) && (nh = !1);
        }
        return of.delete(o), of.delete(a), nh;
      }
      function gg(o) {
        return c0(hb(o, n, xb), o + "");
      }
      function n0(o) {
        return E$(o, Th, s0);
      }
      function r0(o) {
        return E$(o, Vh, pb);
      }
      var o0 = Lm ? function(o) {
        return Lm.get(o);
      } : x0;
      function jm(o) {
        for (var a = o.name + "", d = jg[a], Zu = uh.call(jg, a) ? d.length : 0; Zu--; ) {
          var Ju = d[Zu], of = Ju.func;
          if (of == null || of == o)
            return Ju.name;
        }
        return a;
      }
      function Xg(o) {
        var a = uh.call(nf, "placeholder") ? nf : o;
        return a.placeholder;
      }
      function Yf() {
        var o = nf.iteratee || w0;
        return o = o === w0 ? M$ : o, arguments.length ? o(arguments[0], arguments[1]) : o;
      }
      function Ym(o, a) {
        var d = o.__data__;
        return f_(a) ? d[typeof a == "string" ? "string" : "hash"] : d.map;
      }
      function i0(o) {
        for (var a = Th(o), d = a.length; d--; ) {
          var Zu = a[d], Ju = o[Zu];
          a[d] = [Zu, Ju, db(Ju)];
        }
        return a;
      }
      function Rg(o, a) {
        var d = m1(o, a);
        return D$(d) ? d : n;
      }
      function s_(o) {
        var a = uh.call(o, Mg), d = o[Mg];
        try {
          o[Mg] = n;
          var Zu = !0;
        } catch {
        }
        var Ju = Cm.call(o);
        return Zu && (a ? o[Mg] = d : delete o[Mg]), Ju;
      }
      var s0 = Lv ? function(o) {
        return o == null ? [] : (o = dh(o), yg(Lv(o), function(a) {
          return g$.call(o, a);
        }));
      } : S0, pb = Lv ? function(o) {
        for (var a = []; o; )
          wg(a, s0(o)), o = Em(o);
        return a;
      } : S0, Lh = Ph;
      (Ov && Lh(new Ov(new ArrayBuffer(1))) != Fg || rm && Lh(new rm()) != qf || Pv && Lh(Pv.resolve()) != Ch || qg && Lh(new qg()) != bh || om && Lh(new om()) != Oh) && (Lh = function(o) {
        var a = Ph(o), d = a == $h ? o.constructor : n, Zu = d ? Ng(d) : "";
        if (Zu)
          switch (Zu) {
            case H1:
              return Fg;
            case W1:
              return qf;
            case U1:
              return Ch;
            case K1:
              return bh;
            case q1:
              return Oh;
          }
        return a;
      });
      function a_(o, a, d) {
        for (var Zu = -1, Ju = d.length; ++Zu < Ju; ) {
          var of = d[Zu], df = of.size;
          switch (of.type) {
            case "drop":
              o += df;
              break;
            case "dropRight":
              a -= df;
              break;
            case "take":
              a = Ih(a, o + df);
              break;
            case "takeRight":
              o = Eh(o, a - df);
              break;
          }
        }
        return { start: o, end: a };
      }
      function l_(o) {
        var a = o.match(hy);
        return a ? a[1].split(gy) : [];
      }
      function cb(o, a, d) {
        a = Ag(a, o);
        for (var Zu = -1, Ju = a.length, of = !1; ++Zu < Ju; ) {
          var df = cg(a[Zu]);
          if (!(of = o != null && d(o, df)))
            break;
          o = o[df];
        }
        return of || ++Zu != Ju ? of : (Ju = o == null ? 0 : o.length, !!Ju && tv(Ju) && mg(df, Ju) && (eh(o) || Bg(o)));
      }
      function p_(o) {
        var a = o.length, d = new o.constructor(a);
        return a && typeof o[0] == "string" && uh.call(o, "index") && (d.index = o.index, d.input = o.input), d;
      }
      function ub(o) {
        return typeof o.constructor == "function" && !fm(o) ? Yg(Em(o)) : {};
      }
      function c_(o, a, d) {
        var Zu = o.constructor;
        switch (a) {
          case Tg:
            return Jv(o);
          case If:
          case Of:
            return new Zu(+o);
          case Fg:
            return jw(o, d);
          case iv:
          case sv:
          case av:
          case lv:
          case pv:
          case cv:
          case uv:
          case dv:
          case fv:
            return j$(o, d);
          case qf:
            return new Zu();
          case jf:
          case Yh:
            return new Zu(o);
          case Ah:
            return Yw(o);
          case bh:
            return new Zu();
          case ag:
            return Zw(o);
        }
      }
      function u_(o, a) {
        var d = a.length;
        if (!d)
          return o;
        var Zu = d - 1;
        return a[Zu] = (d > 1 ? "& " : "") + a[Zu], a = a.join(d > 2 ? ", " : " "), o.replace(fy, `{
/* [wrapped with ` + a + `] */
`);
      }
      function d_(o) {
        return eh(o) || Bg(o) || !!(m$ && o && o[m$]);
      }
      function mg(o, a) {
        var d = typeof o;
        return a = a ?? Bf, !!a && (d == "number" || d != "symbol" && Sy.test(o)) && o > -1 && o % 1 == 0 && o < a;
      }
      function Rh(o, a, d) {
        if (!mh(d))
          return !1;
        var Zu = typeof a;
        return (Zu == "number" ? Fh(d) && mg(a, d.length) : Zu == "string" && a in d) ? ig(d[a], o) : !1;
      }
      function a0(o, a) {
        if (eh(o))
          return !1;
        var d = typeof o;
        return d == "number" || d == "symbol" || d == "boolean" || o == null || Kh(o) ? !0 : py.test(o) || !ly.test(o) || a != null && o in dh(a);
      }
      function f_(o) {
        var a = typeof o;
        return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? o !== "__proto__" : o === null;
      }
      function l0(o) {
        var a = jm(o), d = nf[a];
        if (typeof d != "function" || !(a in sh.prototype))
          return !1;
        if (o === d)
          return !0;
        var Zu = o0(d);
        return !!Zu && o === Zu[0];
      }
      function h_(o) {
        return !!d$ && d$ in o;
      }
      var g_ = xm ? vg : C0;
      function fm(o) {
        var a = o && o.constructor, d = typeof a == "function" && a.prototype || Kg;
        return o === d;
      }
      function db(o) {
        return o === o && !mh(o);
      }
      function fb(o, a) {
        return function(d) {
          return d == null ? !1 : d[o] === a && (a !== n || o in dh(d));
        };
      }
      function m_(o) {
        var a = Jm(o, function(Zu) {
          return d.size === m && d.clear(), Zu;
        }), d = a.cache;
        return a;
      }
      function v_(o, a) {
        var d = o[1], Zu = a[1], Ju = d | Zu, of = Ju < (af | rf | vf), df = Zu == vf && d == sf || Zu == vf && d == cf && o[7].length <= a[8] || Zu == (vf | cf) && a[7].length <= a[8] && d == sf;
        if (!(of || df))
          return o;
        Zu & af && (o[2] = a[2], Ju |= d & af ? 0 : hf);
        var mf = a[3];
        if (mf) {
          var wf = o[3];
          o[3] = wf ? Z$(wf, mf, a[4]) : mf, o[4] = wf ? _g(o[3], qu) : a[4];
        }
        return mf = a[5], mf && (wf = o[5], o[5] = wf ? G$(wf, mf, a[6]) : mf, o[6] = wf ? _g(o[5], qu) : a[6]), mf = a[7], mf && (o[7] = mf), Zu & vf && (o[8] = o[8] == null ? a[8] : Ih(o[8], a[8])), o[9] == null && (o[9] = a[9]), o[0] = a[0], o[1] = Ju, o;
      }
      function $_(o) {
        var a = [];
        if (o != null)
          for (var d in dh(o))
            a.push(d);
        return a;
      }
      function b_(o) {
        return Cm.call(o);
      }
      function hb(o, a, d) {
        return a = Eh(a === n ? o.length - 1 : a, 0), function() {
          for (var Zu = arguments, Ju = -1, of = Eh(Zu.length - a, 0), df = xf(of); ++Ju < of; )
            df[Ju] = Zu[a + Ju];
          Ju = -1;
          for (var mf = xf(a + 1); ++Ju < a; )
            mf[Ju] = Zu[Ju];
          return mf[a] = d(df), Hh(o, this, mf);
        };
      }
      function gb(o, a) {
        return a.length < 2 ? o : Pg(o, eg(a, 0, -1));
      }
      function y_(o, a) {
        for (var d = o.length, Zu = Ih(a.length, d), Ju = Bh(o); Zu--; ) {
          var of = a[Zu];
          o[Zu] = mg(of, d) ? Ju[of] : n;
        }
        return o;
      }
      function p0(o, a) {
        if (!(a === "constructor" && typeof o[a] == "function") && a != "__proto__")
          return o[a];
      }
      var mb = $b(F$), hm = P1 || function(o, a) {
        return Dh.setTimeout(o, a);
      }, c0 = $b(Ww);
      function vb(o, a, d) {
        var Zu = a + "";
        return c0(o, u_(Zu, w_(l_(Zu), d)));
      }
      function $b(o) {
        var a = 0, d = 0;
        return function() {
          var Zu = F1(), Ju = Sf - (Zu - d);
          if (d = Zu, Ju > 0) {
            if (++a >= lf)
              return arguments[0];
          } else
            a = 0;
          return o.apply(n, arguments);
        };
      }
      function Zm(o, a) {
        var d = -1, Zu = o.length, Ju = Zu - 1;
        for (a = a === n ? Zu : a; ++d < a; ) {
          var of = qv(d, Ju), df = o[of];
          o[of] = o[d], o[d] = df;
        }
        return o.length = a, o;
      }
      var bb = m_(function(o) {
        var a = [];
        return o.charCodeAt(0) === 46 && a.push(""), o.replace(cy, function(d, Zu, Ju, of) {
          a.push(Ju ? of.replace($y, "$1") : Zu || d);
        }), a;
      });
      function cg(o) {
        if (typeof o == "string" || Kh(o))
          return o;
        var a = o + "";
        return a == "0" && 1 / o == -Rf ? "-0" : a;
      }
      function Ng(o) {
        if (o != null) {
          try {
            return Sm.call(o);
          } catch {
          }
          try {
            return o + "";
          } catch {
          }
        }
        return "";
      }
      function w_(o, a) {
        return Gh(Pf, function(d) {
          var Zu = "_." + d[0];
          a & d[1] && !bm(o, Zu) && o.push(Zu);
        }), o.sort();
      }
      function yb(o) {
        if (o instanceof sh)
          return o.clone();
        var a = new Qh(o.__wrapped__, o.__chain__);
        return a.__actions__ = Bh(o.__actions__), a.__index__ = o.__index__, a.__values__ = o.__values__, a;
      }
      function __(o, a, d) {
        (d ? Rh(o, a, d) : a === n) ? a = 1 : a = Eh(th(a), 0);
        var Zu = o == null ? 0 : o.length;
        if (!Zu || a < 1)
          return [];
        for (var Ju = 0, of = 0, df = xf(Mm(Zu / a)); Ju < Zu; )
          df[of++] = eg(o, Ju, Ju += a);
        return df;
      }
      function x_(o) {
        for (var a = -1, d = o == null ? 0 : o.length, Zu = 0, Ju = []; ++a < d; ) {
          var of = o[a];
          of && (Ju[Zu++] = of);
        }
        return Ju;
      }
      function S_() {
        var o = arguments.length;
        if (!o)
          return [];
        for (var a = xf(o - 1), d = arguments[0], Zu = o; Zu--; )
          a[Zu - 1] = arguments[Zu];
        return wg(eh(d) ? Bh(d) : [d], Mh(a, 1));
      }
      var C_ = rh(function(o, a) {
        return _h(o) ? lm(o, Mh(a, 1, _h, !0)) : [];
      }), A_ = rh(function(o, a) {
        var d = tg(a);
        return _h(d) && (d = n), _h(o) ? lm(o, Mh(a, 1, _h, !0), Yf(d, 2)) : [];
      }), k_ = rh(function(o, a) {
        var d = tg(a);
        return _h(d) && (d = n), _h(o) ? lm(o, Mh(a, 1, _h, !0), n, d) : [];
      });
      function E_(o, a, d) {
        var Zu = o == null ? 0 : o.length;
        return Zu ? (a = d || a === n ? 1 : th(a), eg(o, a < 0 ? 0 : a, Zu)) : [];
      }
      function T_(o, a, d) {
        var Zu = o == null ? 0 : o.length;
        return Zu ? (a = d || a === n ? 1 : th(a), a = Zu - a, eg(o, 0, a < 0 ? 0 : a)) : [];
      }
      function D_(o, a) {
        return o && o.length ? zm(o, Yf(a, 3), !0, !0) : [];
      }
      function M_(o, a) {
        return o && o.length ? zm(o, Yf(a, 3), !0) : [];
      }
      function I_(o, a, d, Zu) {
        var Ju = o == null ? 0 : o.length;
        return Ju ? (d && typeof d != "number" && Rh(o, a, d) && (d = 0, Zu = Ju), Sw(o, a, d, Zu)) : [];
      }
      function wb(o, a, d) {
        var Zu = o == null ? 0 : o.length;
        if (!Zu)
          return -1;
        var Ju = d == null ? 0 : th(d);
        return Ju < 0 && (Ju = Eh(Zu + Ju, 0)), ym(o, Yf(a, 3), Ju);
      }
      function _b(o, a, d) {
        var Zu = o == null ? 0 : o.length;
        if (!Zu)
          return -1;
        var Ju = Zu - 1;
        return d !== n && (Ju = th(d), Ju = d < 0 ? Eh(Zu + Ju, 0) : Ih(Ju, Zu - 1)), ym(o, Yf(a, 3), Ju, !0);
      }
      function xb(o) {
        var a = o == null ? 0 : o.length;
        return a ? Mh(o, 1) : [];
      }
      function L_(o) {
        var a = o == null ? 0 : o.length;
        return a ? Mh(o, Rf) : [];
      }
      function O_(o, a) {
        var d = o == null ? 0 : o.length;
        return d ? (a = a === n ? 1 : th(a), Mh(o, a)) : [];
      }
      function P_(o) {
        for (var a = -1, d = o == null ? 0 : o.length, Zu = {}; ++a < d; ) {
          var Ju = o[a];
          Zu[Ju[0]] = Ju[1];
        }
        return Zu;
      }
      function Sb(o) {
        return o && o.length ? o[0] : n;
      }
      function R_(o, a, d) {
        var Zu = o == null ? 0 : o.length;
        if (!Zu)
          return -1;
        var Ju = d == null ? 0 : th(d);
        return Ju < 0 && (Ju = Eh(Zu + Ju, 0)), zg(o, a, Ju);
      }
      function N_(o) {
        var a = o == null ? 0 : o.length;
        return a ? eg(o, 0, -1) : [];
      }
      var B_ = rh(function(o) {
        var a = gh(o, Xv);
        return a.length && a[0] === o[0] ? zv(a) : [];
      }), F_ = rh(function(o) {
        var a = tg(o), d = gh(o, Xv);
        return a === tg(d) ? a = n : d.pop(), d.length && d[0] === o[0] ? zv(d, Yf(a, 2)) : [];
      }), V_ = rh(function(o) {
        var a = tg(o), d = gh(o, Xv);
        return a = typeof a == "function" ? a : n, a && d.pop(), d.length && d[0] === o[0] ? zv(d, n, a) : [];
      });
      function z_(o, a) {
        return o == null ? "" : N1.call(o, a);
      }
      function tg(o) {
        var a = o == null ? 0 : o.length;
        return a ? o[a - 1] : n;
      }
      function H_(o, a, d) {
        var Zu = o == null ? 0 : o.length;
        if (!Zu)
          return -1;
        var Ju = Zu;
        return d !== n && (Ju = th(d), Ju = Ju < 0 ? Eh(Zu + Ju, 0) : Ih(Ju, Zu - 1)), a === a ? w1(o, a, Ju) : ym(o, o$, Ju, !0);
      }
      function W_(o, a) {
        return o && o.length ? P$(o, th(a)) : n;
      }
      var U_ = rh(Cb);
      function Cb(o, a) {
        return o && o.length && a && a.length ? Kv(o, a) : o;
      }
      function K_(o, a, d) {
        return o && o.length && a && a.length ? Kv(o, a, Yf(d, 2)) : o;
      }
      function q_(o, a, d) {
        return o && o.length && a && a.length ? Kv(o, a, n, d) : o;
      }
      var j_ = gg(function(o, a) {
        var d = o == null ? 0 : o.length, Zu = Nv(o, a);
        return B$(o, gh(a, function(Ju) {
          return mg(Ju, d) ? +Ju : Ju;
        }).sort(Y$)), Zu;
      });
      function Y_(o, a) {
        var d = [];
        if (!(o && o.length))
          return d;
        var Zu = -1, Ju = [], of = o.length;
        for (a = Yf(a, 3); ++Zu < of; ) {
          var df = o[Zu];
          a(df, Zu, o) && (d.push(df), Ju.push(Zu));
        }
        return B$(o, Ju), d;
      }
      function u0(o) {
        return o == null ? o : z1.call(o);
      }
      function Z_(o, a, d) {
        var Zu = o == null ? 0 : o.length;
        return Zu ? (d && typeof d != "number" && Rh(o, a, d) ? (a = 0, d = Zu) : (a = a == null ? 0 : th(a), d = d === n ? Zu : th(d)), eg(o, a, d)) : [];
      }
      function G_(o, a) {
        return Vm(o, a);
      }
      function X_(o, a, d) {
        return Yv(o, a, Yf(d, 2));
      }
      function Q_(o, a) {
        var d = o == null ? 0 : o.length;
        if (d) {
          var Zu = Vm(o, a);
          if (Zu < d && ig(o[Zu], a))
            return Zu;
        }
        return -1;
      }
      function J_(o, a) {
        return Vm(o, a, !0);
      }
      function ex(o, a, d) {
        return Yv(o, a, Yf(d, 2), !0);
      }
      function tx(o, a) {
        var d = o == null ? 0 : o.length;
        if (d) {
          var Zu = Vm(o, a, !0) - 1;
          if (ig(o[Zu], a))
            return Zu;
        }
        return -1;
      }
      function nx(o) {
        return o && o.length ? V$(o) : [];
      }
      function rx(o, a) {
        return o && o.length ? V$(o, Yf(a, 2)) : [];
      }
      function ox(o) {
        var a = o == null ? 0 : o.length;
        return a ? eg(o, 1, a) : [];
      }
      function ix(o, a, d) {
        return o && o.length ? (a = d || a === n ? 1 : th(a), eg(o, 0, a < 0 ? 0 : a)) : [];
      }
      function sx(o, a, d) {
        var Zu = o == null ? 0 : o.length;
        return Zu ? (a = d || a === n ? 1 : th(a), a = Zu - a, eg(o, a < 0 ? 0 : a, Zu)) : [];
      }
      function ax(o, a) {
        return o && o.length ? zm(o, Yf(a, 3), !1, !0) : [];
      }
      function lx(o, a) {
        return o && o.length ? zm(o, Yf(a, 3)) : [];
      }
      var px = rh(function(o) {
        return Cg(Mh(o, 1, _h, !0));
      }), cx = rh(function(o) {
        var a = tg(o);
        return _h(a) && (a = n), Cg(Mh(o, 1, _h, !0), Yf(a, 2));
      }), ux = rh(function(o) {
        var a = tg(o);
        return a = typeof a == "function" ? a : n, Cg(Mh(o, 1, _h, !0), n, a);
      });
      function dx(o) {
        return o && o.length ? Cg(o) : [];
      }
      function fx(o, a) {
        return o && o.length ? Cg(o, Yf(a, 2)) : [];
      }
      function hx(o, a) {
        return a = typeof a == "function" ? a : n, o && o.length ? Cg(o, n, a) : [];
      }
      function d0(o) {
        if (!(o && o.length))
          return [];
        var a = 0;
        return o = yg(o, function(d) {
          if (_h(d))
            return a = Eh(d.length, a), !0;
        }), Tv(a, function(d) {
          return gh(o, Av(d));
        });
      }
      function Ab(o, a) {
        if (!(o && o.length))
          return [];
        var d = d0(o);
        return a == null ? d : gh(d, function(Zu) {
          return Hh(a, n, Zu);
        });
      }
      var gx = rh(function(o, a) {
        return _h(o) ? lm(o, a) : [];
      }), mx = rh(function(o) {
        return Gv(yg(o, _h));
      }), vx = rh(function(o) {
        var a = tg(o);
        return _h(a) && (a = n), Gv(yg(o, _h), Yf(a, 2));
      }), $x = rh(function(o) {
        var a = tg(o);
        return a = typeof a == "function" ? a : n, Gv(yg(o, _h), n, a);
      }), bx = rh(d0);
      function yx(o, a) {
        return U$(o || [], a || [], am);
      }
      function wx(o, a) {
        return U$(o || [], a || [], um);
      }
      var _x = rh(function(o) {
        var a = o.length, d = a > 1 ? o[a - 1] : n;
        return d = typeof d == "function" ? (o.pop(), d) : n, Ab(o, d);
      });
      function kb(o) {
        var a = nf(o);
        return a.__chain__ = !0, a;
      }
      function xx(o, a) {
        return a(o), o;
      }
      function Gm(o, a) {
        return a(o);
      }
      var Sx = gg(function(o) {
        var a = o.length, d = a ? o[0] : 0, Zu = this.__wrapped__, Ju = function(of) {
          return Nv(of, o);
        };
        return a > 1 || this.__actions__.length || !(Zu instanceof sh) || !mg(d) ? this.thru(Ju) : (Zu = Zu.slice(d, +d + (a ? 1 : 0)), Zu.__actions__.push({
          func: Gm,
          args: [Ju],
          thisArg: n
        }), new Qh(Zu, this.__chain__).thru(function(of) {
          return a && !of.length && of.push(n), of;
        }));
      });
      function Cx() {
        return kb(this);
      }
      function Ax() {
        return new Qh(this.value(), this.__chain__);
      }
      function kx() {
        this.__values__ === n && (this.__values__ = zb(this.value()));
        var o = this.__index__ >= this.__values__.length, a = o ? n : this.__values__[this.__index__++];
        return { done: o, value: a };
      }
      function Ex() {
        return this;
      }
      function Tx(o) {
        for (var a, d = this; d instanceof Pm; ) {
          var Zu = yb(d);
          Zu.__index__ = 0, Zu.__values__ = n, a ? Ju.__wrapped__ = Zu : a = Zu;
          var Ju = Zu;
          d = d.__wrapped__;
        }
        return Ju.__wrapped__ = o, a;
      }
      function Dx() {
        var o = this.__wrapped__;
        if (o instanceof sh) {
          var a = o;
          return this.__actions__.length && (a = new sh(this)), a = a.reverse(), a.__actions__.push({
            func: Gm,
            args: [u0],
            thisArg: n
          }), new Qh(a, this.__chain__);
        }
        return this.thru(u0);
      }
      function Mx() {
        return W$(this.__wrapped__, this.__actions__);
      }
      var Ix = Hm(function(o, a, d) {
        uh.call(o, d) ? ++o[d] : fg(o, d, 1);
      });
      function Lx(o, a, d) {
        var Zu = eh(o) ? n$ : xw;
        return d && Rh(o, a, d) && (a = n), Zu(o, Yf(a, 3));
      }
      function Ox(o, a) {
        var d = eh(o) ? yg : A$;
        return d(o, Yf(a, 3));
      }
      var Px = eb(wb), Rx = eb(_b);
      function Nx(o, a) {
        return Mh(Xm(o, a), 1);
      }
      function Bx(o, a) {
        return Mh(Xm(o, a), Rf);
      }
      function Fx(o, a, d) {
        return d = d === n ? 1 : th(d), Mh(Xm(o, a), d);
      }
      function Eb(o, a) {
        var d = eh(o) ? Gh : Sg;
        return d(o, Yf(a, 3));
      }
      function Tb(o, a) {
        var d = eh(o) ? o1 : C$;
        return d(o, Yf(a, 3));
      }
      var Vx = Hm(function(o, a, d) {
        uh.call(o, d) ? o[d].push(a) : fg(o, d, [a]);
      });
      function zx(o, a, d, Zu) {
        o = Fh(o) ? o : Jg(o), d = d && !Zu ? th(d) : 0;
        var Ju = o.length;
        return d < 0 && (d = Eh(Ju + d, 0)), nv(o) ? d <= Ju && o.indexOf(a, d) > -1 : !!Ju && zg(o, a, d) > -1;
      }
      var Hx = rh(function(o, a, d) {
        var Zu = -1, Ju = typeof a == "function", of = Fh(o) ? xf(o.length) : [];
        return Sg(o, function(df) {
          of[++Zu] = Ju ? Hh(a, df, d) : pm(df, a, d);
        }), of;
      }), Wx = Hm(function(o, a, d) {
        fg(o, d, a);
      });
      function Xm(o, a) {
        var d = eh(o) ? gh : I$;
        return d(o, Yf(a, 3));
      }
      function Ux(o, a, d, Zu) {
        return o == null ? [] : (eh(a) || (a = a == null ? [] : [a]), d = Zu ? n : d, eh(d) || (d = d == null ? [] : [d]), R$(o, a, d));
      }
      var Kx = Hm(function(o, a, d) {
        o[d ? 0 : 1].push(a);
      }, function() {
        return [[], []];
      });
      function qx(o, a, d) {
        var Zu = eh(o) ? Sv : s$, Ju = arguments.length < 3;
        return Zu(o, Yf(a, 4), d, Ju, Sg);
      }
      function jx(o, a, d) {
        var Zu = eh(o) ? i1 : s$, Ju = arguments.length < 3;
        return Zu(o, Yf(a, 4), d, Ju, C$);
      }
      function Yx(o, a) {
        var d = eh(o) ? yg : A$;
        return d(o, ev(Yf(a, 3)));
      }
      function Zx(o) {
        var a = eh(o) ? w$ : zw;
        return a(o);
      }
      function Gx(o, a, d) {
        (d ? Rh(o, a, d) : a === n) ? a = 1 : a = th(a);
        var Zu = eh(o) ? $w : Hw;
        return Zu(o, a);
      }
      function Xx(o) {
        var a = eh(o) ? bw : Uw;
        return a(o);
      }
      function Qx(o) {
        if (o == null)
          return 0;
        if (Fh(o))
          return nv(o) ? Wg(o) : o.length;
        var a = Lh(o);
        return a == qf || a == bh ? o.size : Wv(o).length;
      }
      function Jx(o, a, d) {
        var Zu = eh(o) ? Cv : Kw;
        return d && Rh(o, a, d) && (a = n), Zu(o, Yf(a, 3));
      }
      var eS = rh(function(o, a) {
        if (o == null)
          return [];
        var d = a.length;
        return d > 1 && Rh(o, a[0], a[1]) ? a = [] : d > 2 && Rh(a[0], a[1], a[2]) && (a = [a[0]]), R$(o, Mh(a, 1), []);
      }), Qm = O1 || function() {
        return Dh.Date.now();
      };
      function tS(o, a) {
        if (typeof a != "function")
          throw new Xh(l);
        return o = th(o), function() {
          if (--o < 1)
            return a.apply(this, arguments);
        };
      }
      function Db(o, a, d) {
        return a = d ? n : a, a = o && a == null ? o.length : a, hg(o, vf, n, n, n, n, a);
      }
      function Mb(o, a) {
        var d;
        if (typeof a != "function")
          throw new Xh(l);
        return o = th(o), function() {
          return --o > 0 && (d = a.apply(this, arguments)), o <= 1 && (a = n), d;
        };
      }
      var f0 = rh(function(o, a, d) {
        var Zu = af;
        if (d.length) {
          var Ju = _g(d, Xg(f0));
          Zu |= $f;
        }
        return hg(o, Zu, a, d, Ju);
      }), Ib = rh(function(o, a, d) {
        var Zu = af | rf;
        if (d.length) {
          var Ju = _g(d, Xg(Ib));
          Zu |= $f;
        }
        return hg(a, Zu, o, d, Ju);
      });
      function Lb(o, a, d) {
        a = d ? n : a;
        var Zu = hg(o, sf, n, n, n, n, n, a);
        return Zu.placeholder = Lb.placeholder, Zu;
      }
      function Ob(o, a, d) {
        a = d ? n : a;
        var Zu = hg(o, pf, n, n, n, n, n, a);
        return Zu.placeholder = Ob.placeholder, Zu;
      }
      function Pb(o, a, d) {
        var Zu, Ju, of, df, mf, wf, Tf = 0, Df = !1, Lf = !1, Nf = !0;
        if (typeof o != "function")
          throw new Xh(l);
        a = ng(a) || 0, mh(d) && (Df = !!d.leading, Lf = "maxWait" in d, of = Lf ? Eh(ng(d.maxWait) || 0, a) : of, Nf = "trailing" in d ? !!d.trailing : Nf);
        function Kf(xh) {
          var sg = Zu, bg = Ju;
          return Zu = Ju = n, Tf = xh, df = o.apply(bg, sg), df;
        }
        function Gf(xh) {
          return Tf = xh, mf = hm(oh, a), Df ? Kf(xh) : df;
        }
        function nh(xh) {
          var sg = xh - wf, bg = xh - Tf, ey = a - sg;
          return Lf ? Ih(ey, of - bg) : ey;
        }
        function Xf(xh) {
          var sg = xh - wf, bg = xh - Tf;
          return wf === n || sg >= a || sg < 0 || Lf && bg >= of;
        }
        function oh() {
          var xh = Qm();
          if (Xf(xh))
            return ah(xh);
          mf = hm(oh, nh(xh));
        }
        function ah(xh) {
          return mf = n, Nf && Zu ? Kf(xh) : (Zu = Ju = n, df);
        }
        function qh() {
          mf !== n && K$(mf), Tf = 0, Zu = wf = Ju = mf = n;
        }
        function Nh() {
          return mf === n ? df : ah(Qm());
        }
        function jh() {
          var xh = Qm(), sg = Xf(xh);
          if (Zu = arguments, Ju = this, wf = xh, sg) {
            if (mf === n)
              return Gf(wf);
            if (Lf)
              return K$(mf), mf = hm(oh, a), Kf(wf);
          }
          return mf === n && (mf = hm(oh, a)), df;
        }
        return jh.cancel = qh, jh.flush = Nh, jh;
      }
      var nS = rh(function(o, a) {
        return S$(o, 1, a);
      }), rS = rh(function(o, a, d) {
        return S$(o, ng(a) || 0, d);
      });
      function oS(o) {
        return hg(o, yf);
      }
      function Jm(o, a) {
        if (typeof o != "function" || a != null && typeof a != "function")
          throw new Xh(l);
        var d = function() {
          var Zu = arguments, Ju = a ? a.apply(this, Zu) : Zu[0], of = d.cache;
          if (of.has(Ju))
            return of.get(Ju);
          var df = o.apply(this, Zu);
          return d.cache = of.set(Ju, df) || of, df;
        };
        return d.cache = new (Jm.Cache || dg)(), d;
      }
      Jm.Cache = dg;
      function ev(o) {
        if (typeof o != "function")
          throw new Xh(l);
        return function() {
          var a = arguments;
          switch (a.length) {
            case 0:
              return !o.call(this);
            case 1:
              return !o.call(this, a[0]);
            case 2:
              return !o.call(this, a[0], a[1]);
            case 3:
              return !o.call(this, a[0], a[1], a[2]);
          }
          return !o.apply(this, a);
        };
      }
      function iS(o) {
        return Mb(2, o);
      }
      var sS = qw(function(o, a) {
        a = a.length == 1 && eh(a[0]) ? gh(a[0], Wh(Yf())) : gh(Mh(a, 1), Wh(Yf()));
        var d = a.length;
        return rh(function(Zu) {
          for (var Ju = -1, of = Ih(Zu.length, d); ++Ju < of; )
            Zu[Ju] = a[Ju].call(this, Zu[Ju]);
          return Hh(o, this, Zu);
        });
      }), h0 = rh(function(o, a) {
        var d = _g(a, Xg(h0));
        return hg(o, $f, n, a, d);
      }), Rb = rh(function(o, a) {
        var d = _g(a, Xg(Rb));
        return hg(o, uf, n, a, d);
      }), aS = gg(function(o, a) {
        return hg(o, cf, n, n, n, a);
      });
      function lS(o, a) {
        if (typeof o != "function")
          throw new Xh(l);
        return a = a === n ? a : th(a), rh(o, a);
      }
      function pS(o, a) {
        if (typeof o != "function")
          throw new Xh(l);
        return a = a == null ? 0 : Eh(th(a), 0), rh(function(d) {
          var Zu = d[a], Ju = kg(d, 0, a);
          return Zu && wg(Ju, Zu), Hh(o, this, Ju);
        });
      }
      function cS(o, a, d) {
        var Zu = !0, Ju = !0;
        if (typeof o != "function")
          throw new Xh(l);
        return mh(d) && (Zu = "leading" in d ? !!d.leading : Zu, Ju = "trailing" in d ? !!d.trailing : Ju), Pb(o, a, {
          leading: Zu,
          maxWait: a,
          trailing: Ju
        });
      }
      function uS(o) {
        return Db(o, 1);
      }
      function dS(o, a) {
        return h0(Qv(a), o);
      }
      function fS() {
        if (!arguments.length)
          return [];
        var o = arguments[0];
        return eh(o) ? o : [o];
      }
      function hS(o) {
        return Jh(o, Xu);
      }
      function gS(o, a) {
        return a = typeof a == "function" ? a : n, Jh(o, Xu, a);
      }
      function mS(o) {
        return Jh(o, Gu | Xu);
      }
      function vS(o, a) {
        return a = typeof a == "function" ? a : n, Jh(o, Gu | Xu, a);
      }
      function $S(o, a) {
        return a == null || x$(o, a, Th(a));
      }
      function ig(o, a) {
        return o === a || o !== o && a !== a;
      }
      var bS = qm(Vv), yS = qm(function(o, a) {
        return o >= a;
      }), Bg = T$(/* @__PURE__ */ function() {
        return arguments;
      }()) ? T$ : function(o) {
        return yh(o) && uh.call(o, "callee") && !g$.call(o, "callee");
      }, eh = xf.isArray, wS = G0 ? Wh(G0) : Tw;
      function Fh(o) {
        return o != null && tv(o.length) && !vg(o);
      }
      function _h(o) {
        return yh(o) && Fh(o);
      }
      function _S(o) {
        return o === !0 || o === !1 || yh(o) && Ph(o) == If;
      }
      var Eg = R1 || C0, xS = X0 ? Wh(X0) : Dw;
      function SS(o) {
        return yh(o) && o.nodeType === 1 && !gm(o);
      }
      function CS(o) {
        if (o == null)
          return !0;
        if (Fh(o) && (eh(o) || typeof o == "string" || typeof o.splice == "function" || Eg(o) || Qg(o) || Bg(o)))
          return !o.length;
        var a = Lh(o);
        if (a == qf || a == bh)
          return !o.size;
        if (fm(o))
          return !Wv(o).length;
        for (var d in o)
          if (uh.call(o, d))
            return !1;
        return !0;
      }
      function AS(o, a) {
        return cm(o, a);
      }
      function kS(o, a, d) {
        d = typeof d == "function" ? d : n;
        var Zu = d ? d(o, a) : n;
        return Zu === n ? cm(o, a, n, d) : !!Zu;
      }
      function g0(o) {
        if (!yh(o))
          return !1;
        var a = Ph(o);
        return a == Ff || a == Hf || typeof o.message == "string" && typeof o.name == "string" && !gm(o);
      }
      function ES(o) {
        return typeof o == "number" && v$(o);
      }
      function vg(o) {
        if (!mh(o))
          return !1;
        var a = Ph(o);
        return a == zf || a == Qf || a == kf || a == wh;
      }
      function Nb(o) {
        return typeof o == "number" && o == th(o);
      }
      function tv(o) {
        return typeof o == "number" && o > -1 && o % 1 == 0 && o <= Bf;
      }
      function mh(o) {
        var a = typeof o;
        return o != null && (a == "object" || a == "function");
      }
      function yh(o) {
        return o != null && typeof o == "object";
      }
      var Bb = Q0 ? Wh(Q0) : Iw;
      function TS(o, a) {
        return o === a || Hv(o, a, i0(a));
      }
      function DS(o, a, d) {
        return d = typeof d == "function" ? d : n, Hv(o, a, i0(a), d);
      }
      function MS(o) {
        return Fb(o) && o != +o;
      }
      function IS(o) {
        if (g_(o))
          throw new Jf(s);
        return D$(o);
      }
      function LS(o) {
        return o === null;
      }
      function OS(o) {
        return o == null;
      }
      function Fb(o) {
        return typeof o == "number" || yh(o) && Ph(o) == jf;
      }
      function gm(o) {
        if (!yh(o) || Ph(o) != $h)
          return !1;
        var a = Em(o);
        if (a === null)
          return !0;
        var d = uh.call(a, "constructor") && a.constructor;
        return typeof d == "function" && d instanceof d && Sm.call(d) == D1;
      }
      var m0 = J0 ? Wh(J0) : Lw;
      function PS(o) {
        return Nb(o) && o >= -Bf && o <= Bf;
      }
      var Vb = e$ ? Wh(e$) : Ow;
      function nv(o) {
        return typeof o == "string" || !eh(o) && yh(o) && Ph(o) == Yh;
      }
      function Kh(o) {
        return typeof o == "symbol" || yh(o) && Ph(o) == ag;
      }
      var Qg = t$ ? Wh(t$) : Pw;
      function RS(o) {
        return o === n;
      }
      function NS(o) {
        return yh(o) && Lh(o) == Oh;
      }
      function BS(o) {
        return yh(o) && Ph(o) == ov;
      }
      var FS = qm(Uv), VS = qm(function(o, a) {
        return o <= a;
      });
      function zb(o) {
        if (!o)
          return [];
        if (Fh(o))
          return nv(o) ? rg(o) : Bh(o);
        if (nm && o[nm])
          return $1(o[nm]());
        var a = Lh(o), d = a == qf ? Mv : a == bh ? wm : Jg;
        return d(o);
      }
      function $g(o) {
        if (!o)
          return o === 0 ? o : 0;
        if (o = ng(o), o === Rf || o === -Rf) {
          var a = o < 0 ? -1 : 1;
          return a * ih;
        }
        return o === o ? o : 0;
      }
      function th(o) {
        var a = $g(o), d = a % 1;
        return a === a ? d ? a - d : a : 0;
      }
      function Hb(o) {
        return o ? Og(th(o), 0, Wf) : 0;
      }
      function ng(o) {
        if (typeof o == "number")
          return o;
        if (Kh(o))
          return lh;
        if (mh(o)) {
          var a = typeof o.valueOf == "function" ? o.valueOf() : o;
          o = mh(a) ? a + "" : a;
        }
        if (typeof o != "string")
          return o === 0 ? o : +o;
        o = a$(o);
        var d = wy.test(o);
        return d || xy.test(o) ? t1(o.slice(2), d ? 2 : 8) : yy.test(o) ? lh : +o;
      }
      function Wb(o) {
        return pg(o, Vh(o));
      }
      function zS(o) {
        return o ? Og(th(o), -Bf, Bf) : o === 0 ? o : 0;
      }
      function ch(o) {
        return o == null ? "" : Uh(o);
      }
      var HS = Zg(function(o, a) {
        if (fm(a) || Fh(a)) {
          pg(a, Th(a), o);
          return;
        }
        for (var d in a)
          uh.call(a, d) && am(o, d, a[d]);
      }), Ub = Zg(function(o, a) {
        pg(a, Vh(a), o);
      }), rv = Zg(function(o, a, d, Zu) {
        pg(a, Vh(a), o, Zu);
      }), WS = Zg(function(o, a, d, Zu) {
        pg(a, Th(a), o, Zu);
      }), US = gg(Nv);
      function KS(o, a) {
        var d = Yg(o);
        return a == null ? d : _$(d, a);
      }
      var qS = rh(function(o, a) {
        o = dh(o);
        var d = -1, Zu = a.length, Ju = Zu > 2 ? a[2] : n;
        for (Ju && Rh(a[0], a[1], Ju) && (Zu = 1); ++d < Zu; )
          for (var of = a[d], df = Vh(of), mf = -1, wf = df.length; ++mf < wf; ) {
            var Tf = df[mf], Df = o[Tf];
            (Df === n || ig(Df, Kg[Tf]) && !uh.call(o, Tf)) && (o[Tf] = of[Tf]);
          }
        return o;
      }), jS = rh(function(o) {
        return o.push(n, ab), Hh(Kb, n, o);
      });
      function YS(o, a) {
        return r$(o, Yf(a, 3), lg);
      }
      function ZS(o, a) {
        return r$(o, Yf(a, 3), Fv);
      }
      function GS(o, a) {
        return o == null ? o : Bv(o, Yf(a, 3), Vh);
      }
      function XS(o, a) {
        return o == null ? o : k$(o, Yf(a, 3), Vh);
      }
      function QS(o, a) {
        return o && lg(o, Yf(a, 3));
      }
      function JS(o, a) {
        return o && Fv(o, Yf(a, 3));
      }
      function eC(o) {
        return o == null ? [] : Bm(o, Th(o));
      }
      function tC(o) {
        return o == null ? [] : Bm(o, Vh(o));
      }
      function v0(o, a, d) {
        var Zu = o == null ? n : Pg(o, a);
        return Zu === n ? d : Zu;
      }
      function nC(o, a) {
        return o != null && cb(o, a, Cw);
      }
      function $0(o, a) {
        return o != null && cb(o, a, Aw);
      }
      var rC = nb(function(o, a, d) {
        a != null && typeof a.toString != "function" && (a = Cm.call(a)), o[a] = d;
      }, y0(zh)), oC = nb(function(o, a, d) {
        a != null && typeof a.toString != "function" && (a = Cm.call(a)), uh.call(o, a) ? o[a].push(d) : o[a] = [d];
      }, Yf), iC = rh(pm);
      function Th(o) {
        return Fh(o) ? y$(o) : Wv(o);
      }
      function Vh(o) {
        return Fh(o) ? y$(o, !0) : Rw(o);
      }
      function sC(o, a) {
        var d = {};
        return a = Yf(a, 3), lg(o, function(Zu, Ju, of) {
          fg(d, a(Zu, Ju, of), Zu);
        }), d;
      }
      function aC(o, a) {
        var d = {};
        return a = Yf(a, 3), lg(o, function(Zu, Ju, of) {
          fg(d, Ju, a(Zu, Ju, of));
        }), d;
      }
      var lC = Zg(function(o, a, d) {
        Fm(o, a, d);
      }), Kb = Zg(function(o, a, d, Zu) {
        Fm(o, a, d, Zu);
      }), pC = gg(function(o, a) {
        var d = {};
        if (o == null)
          return d;
        var Zu = !1;
        a = gh(a, function(of) {
          return of = Ag(of, o), Zu || (Zu = of.length > 1), of;
        }), pg(o, r0(o), d), Zu && (d = Jh(d, Gu | Qu | Xu, r_));
        for (var Ju = a.length; Ju--; )
          Zv(d, a[Ju]);
        return d;
      });
      function cC(o, a) {
        return qb(o, ev(Yf(a)));
      }
      var uC = gg(function(o, a) {
        return o == null ? {} : Bw(o, a);
      });
      function qb(o, a) {
        if (o == null)
          return {};
        var d = gh(r0(o), function(Zu) {
          return [Zu];
        });
        return a = Yf(a), N$(o, d, function(Zu, Ju) {
          return a(Zu, Ju[0]);
        });
      }
      function dC(o, a, d) {
        a = Ag(a, o);
        var Zu = -1, Ju = a.length;
        for (Ju || (Ju = 1, o = n); ++Zu < Ju; ) {
          var of = o == null ? n : o[cg(a[Zu])];
          of === n && (Zu = Ju, of = d), o = vg(of) ? of.call(o) : of;
        }
        return o;
      }
      function fC(o, a, d) {
        return o == null ? o : um(o, a, d);
      }
      function hC(o, a, d, Zu) {
        return Zu = typeof Zu == "function" ? Zu : n, o == null ? o : um(o, a, d, Zu);
      }
      var jb = ib(Th), Yb = ib(Vh);
      function gC(o, a, d) {
        var Zu = eh(o), Ju = Zu || Eg(o) || Qg(o);
        if (a = Yf(a, 4), d == null) {
          var of = o && o.constructor;
          Ju ? d = Zu ? new of() : [] : mh(o) ? d = vg(of) ? Yg(Em(o)) : {} : d = {};
        }
        return (Ju ? Gh : lg)(o, function(df, mf, wf) {
          return a(d, df, mf, wf);
        }), d;
      }
      function mC(o, a) {
        return o == null ? !0 : Zv(o, a);
      }
      function vC(o, a, d) {
        return o == null ? o : H$(o, a, Qv(d));
      }
      function $C(o, a, d, Zu) {
        return Zu = typeof Zu == "function" ? Zu : n, o == null ? o : H$(o, a, Qv(d), Zu);
      }
      function Jg(o) {
        return o == null ? [] : Dv(o, Th(o));
      }
      function bC(o) {
        return o == null ? [] : Dv(o, Vh(o));
      }
      function yC(o, a, d) {
        return d === n && (d = a, a = n), d !== n && (d = ng(d), d = d === d ? d : 0), a !== n && (a = ng(a), a = a === a ? a : 0), Og(ng(o), a, d);
      }
      function wC(o, a, d) {
        return a = $g(a), d === n ? (d = a, a = 0) : d = $g(d), o = ng(o), kw(o, a, d);
      }
      function _C(o, a, d) {
        if (d && typeof d != "boolean" && Rh(o, a, d) && (a = d = n), d === n && (typeof a == "boolean" ? (d = a, a = n) : typeof o == "boolean" && (d = o, o = n)), o === n && a === n ? (o = 0, a = 1) : (o = $g(o), a === n ? (a = o, o = 0) : a = $g(a)), o > a) {
          var Zu = o;
          o = a, a = Zu;
        }
        if (d || o % 1 || a % 1) {
          var Ju = $$();
          return Ih(o + Ju * (a - o + e1("1e-" + ((Ju + "").length - 1))), a);
        }
        return qv(o, a);
      }
      var xC = Gg(function(o, a, d) {
        return a = a.toLowerCase(), o + (d ? Zb(a) : a);
      });
      function Zb(o) {
        return b0(ch(o).toLowerCase());
      }
      function Gb(o) {
        return o = ch(o), o && o.replace(Cy, f1).replace(Uy, "");
      }
      function SC(o, a, d) {
        o = ch(o), a = Uh(a);
        var Zu = o.length;
        d = d === n ? Zu : Og(th(d), 0, Zu);
        var Ju = d;
        return d -= a.length, d >= 0 && o.slice(d, Ju) == a;
      }
      function CC(o) {
        return o = ch(o), o && iy.test(o) ? o.replace(k0, h1) : o;
      }
      function AC(o) {
        return o = ch(o), o && uy.test(o) ? o.replace(hv, "\\$&") : o;
      }
      var kC = Gg(function(o, a, d) {
        return o + (d ? "-" : "") + a.toLowerCase();
      }), EC = Gg(function(o, a, d) {
        return o + (d ? " " : "") + a.toLowerCase();
      }), TC = J$("toLowerCase");
      function DC(o, a, d) {
        o = ch(o), a = th(a);
        var Zu = a ? Wg(o) : 0;
        if (!a || Zu >= a)
          return o;
        var Ju = (a - Zu) / 2;
        return Km(Im(Ju), d) + o + Km(Mm(Ju), d);
      }
      function MC(o, a, d) {
        o = ch(o), a = th(a);
        var Zu = a ? Wg(o) : 0;
        return a && Zu < a ? o + Km(a - Zu, d) : o;
      }
      function IC(o, a, d) {
        o = ch(o), a = th(a);
        var Zu = a ? Wg(o) : 0;
        return a && Zu < a ? Km(a - Zu, d) + o : o;
      }
      function LC(o, a, d) {
        return d || a == null ? a = 0 : a && (a = +a), V1(ch(o).replace(gv, ""), a || 0);
      }
      function OC(o, a, d) {
        return (d ? Rh(o, a, d) : a === n) ? a = 1 : a = th(a), jv(ch(o), a);
      }
      function PC() {
        var o = arguments, a = ch(o[0]);
        return o.length < 3 ? a : a.replace(o[1], o[2]);
      }
      var RC = Gg(function(o, a, d) {
        return o + (d ? "_" : "") + a.toLowerCase();
      });
      function NC(o, a, d) {
        return d && typeof d != "number" && Rh(o, a, d) && (a = d = n), d = d === n ? Wf : d >>> 0, d ? (o = ch(o), o && (typeof a == "string" || a != null && !m0(a)) && (a = Uh(a), !a && Hg(o)) ? kg(rg(o), 0, d) : o.split(a, d)) : [];
      }
      var BC = Gg(function(o, a, d) {
        return o + (d ? " " : "") + b0(a);
      });
      function FC(o, a, d) {
        return o = ch(o), d = d == null ? 0 : Og(th(d), 0, o.length), a = Uh(a), o.slice(d, d + a.length) == a;
      }
      function VC(o, a, d) {
        var Zu = nf.templateSettings;
        d && Rh(o, a, d) && (a = n), o = ch(o), a = rv({}, a, Zu, sb);
        var Ju = rv({}, a.imports, Zu.imports, sb), of = Th(Ju), df = Dv(Ju, of), mf, wf, Tf = 0, Df = a.interpolate || mm, Lf = "__p += '", Nf = Iv(
          (a.escape || mm).source + "|" + Df.source + "|" + (Df === E0 ? by : mm).source + "|" + (a.evaluate || mm).source + "|$",
          "g"
        ), Kf = "//# sourceURL=" + (uh.call(a, "sourceURL") ? (a.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Zy + "]") + `
`;
        o.replace(Nf, function(Xf, oh, ah, qh, Nh, jh) {
          return ah || (ah = qh), Lf += o.slice(Tf, jh).replace(Ay, g1), oh && (mf = !0, Lf += `' +
__e(` + oh + `) +
'`), Nh && (wf = !0, Lf += `';
` + Nh + `;
__p += '`), ah && (Lf += `' +
((__t = (` + ah + `)) == null ? '' : __t) +
'`), Tf = jh + Xf.length, Xf;
        }), Lf += `';
`;
        var Gf = uh.call(a, "variable") && a.variable;
        if (!Gf)
          Lf = `with (obj) {
` + Lf + `
}
`;
        else if (vy.test(Gf))
          throw new Jf(c);
        Lf = (wf ? Lf.replace(ty, "") : Lf).replace(ny, "$1").replace(ry, "$1;"), Lf = "function(" + (Gf || "obj") + `) {
` + (Gf ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (mf ? ", __e = _.escape" : "") + (wf ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Lf + `return __p
}`;
        var nh = Qb(function() {
          return ph(of, Kf + "return " + Lf).apply(n, df);
        });
        if (nh.source = Lf, g0(nh))
          throw nh;
        return nh;
      }
      function zC(o) {
        return ch(o).toLowerCase();
      }
      function HC(o) {
        return ch(o).toUpperCase();
      }
      function WC(o, a, d) {
        if (o = ch(o), o && (d || a === n))
          return a$(o);
        if (!o || !(a = Uh(a)))
          return o;
        var Zu = rg(o), Ju = rg(a), of = l$(Zu, Ju), df = p$(Zu, Ju) + 1;
        return kg(Zu, of, df).join("");
      }
      function UC(o, a, d) {
        if (o = ch(o), o && (d || a === n))
          return o.slice(0, u$(o) + 1);
        if (!o || !(a = Uh(a)))
          return o;
        var Zu = rg(o), Ju = p$(Zu, rg(a)) + 1;
        return kg(Zu, 0, Ju).join("");
      }
      function KC(o, a, d) {
        if (o = ch(o), o && (d || a === n))
          return o.replace(gv, "");
        if (!o || !(a = Uh(a)))
          return o;
        var Zu = rg(o), Ju = l$(Zu, rg(a));
        return kg(Zu, Ju).join("");
      }
      function qC(o, a) {
        var d = ff, Zu = gf;
        if (mh(a)) {
          var Ju = "separator" in a ? a.separator : Ju;
          d = "length" in a ? th(a.length) : d, Zu = "omission" in a ? Uh(a.omission) : Zu;
        }
        o = ch(o);
        var of = o.length;
        if (Hg(o)) {
          var df = rg(o);
          of = df.length;
        }
        if (d >= of)
          return o;
        var mf = d - Wg(Zu);
        if (mf < 1)
          return Zu;
        var wf = df ? kg(df, 0, mf).join("") : o.slice(0, mf);
        if (Ju === n)
          return wf + Zu;
        if (df && (mf += wf.length - mf), m0(Ju)) {
          if (o.slice(mf).search(Ju)) {
            var Tf, Df = wf;
            for (Ju.global || (Ju = Iv(Ju.source, ch(T0.exec(Ju)) + "g")), Ju.lastIndex = 0; Tf = Ju.exec(Df); )
              var Lf = Tf.index;
            wf = wf.slice(0, Lf === n ? mf : Lf);
          }
        } else if (o.indexOf(Uh(Ju), mf) != mf) {
          var Nf = wf.lastIndexOf(Ju);
          Nf > -1 && (wf = wf.slice(0, Nf));
        }
        return wf + Zu;
      }
      function jC(o) {
        return o = ch(o), o && oy.test(o) ? o.replace(A0, _1) : o;
      }
      var YC = Gg(function(o, a, d) {
        return o + (d ? " " : "") + a.toUpperCase();
      }), b0 = J$("toUpperCase");
      function Xb(o, a, d) {
        return o = ch(o), a = d ? n : a, a === n ? v1(o) ? C1(o) : l1(o) : o.match(a) || [];
      }
      var Qb = rh(function(o, a) {
        try {
          return Hh(o, n, a);
        } catch (d) {
          return g0(d) ? d : new Jf(d);
        }
      }), ZC = gg(function(o, a) {
        return Gh(a, function(d) {
          d = cg(d), fg(o, d, f0(o[d], o));
        }), o;
      });
      function GC(o) {
        var a = o == null ? 0 : o.length, d = Yf();
        return o = a ? gh(o, function(Zu) {
          if (typeof Zu[1] != "function")
            throw new Xh(l);
          return [d(Zu[0]), Zu[1]];
        }) : [], rh(function(Zu) {
          for (var Ju = -1; ++Ju < a; ) {
            var of = o[Ju];
            if (Hh(of[0], this, Zu))
              return Hh(of[1], this, Zu);
          }
        });
      }
      function XC(o) {
        return _w(Jh(o, Gu));
      }
      function y0(o) {
        return function() {
          return o;
        };
      }
      function QC(o, a) {
        return o == null || o !== o ? a : o;
      }
      var JC = tb(), eA = tb(!0);
      function zh(o) {
        return o;
      }
      function w0(o) {
        return M$(typeof o == "function" ? o : Jh(o, Gu));
      }
      function tA(o) {
        return L$(Jh(o, Gu));
      }
      function nA(o, a) {
        return O$(o, Jh(a, Gu));
      }
      var rA = rh(function(o, a) {
        return function(d) {
          return pm(d, o, a);
        };
      }), oA = rh(function(o, a) {
        return function(d) {
          return pm(o, d, a);
        };
      });
      function _0(o, a, d) {
        var Zu = Th(a), Ju = Bm(a, Zu);
        d == null && !(mh(a) && (Ju.length || !Zu.length)) && (d = a, a = o, o = this, Ju = Bm(a, Th(a)));
        var of = !(mh(d) && "chain" in d) || !!d.chain, df = vg(o);
        return Gh(Ju, function(mf) {
          var wf = a[mf];
          o[mf] = wf, df && (o.prototype[mf] = function() {
            var Tf = this.__chain__;
            if (of || Tf) {
              var Df = o(this.__wrapped__), Lf = Df.__actions__ = Bh(this.__actions__);
              return Lf.push({ func: wf, args: arguments, thisArg: o }), Df.__chain__ = Tf, Df;
            }
            return wf.apply(o, wg([this.value()], arguments));
          });
        }), o;
      }
      function iA() {
        return Dh._ === this && (Dh._ = M1), this;
      }
      function x0() {
      }
      function sA(o) {
        return o = th(o), rh(function(a) {
          return P$(a, o);
        });
      }
      var aA = e0(gh), lA = e0(n$), pA = e0(Cv);
      function Jb(o) {
        return a0(o) ? Av(cg(o)) : Fw(o);
      }
      function cA(o) {
        return function(a) {
          return o == null ? n : Pg(o, a);
        };
      }
      var uA = rb(), dA = rb(!0);
      function S0() {
        return [];
      }
      function C0() {
        return !1;
      }
      function fA() {
        return {};
      }
      function hA() {
        return "";
      }
      function gA() {
        return !0;
      }
      function mA(o, a) {
        if (o = th(o), o < 1 || o > Bf)
          return [];
        var d = Wf, Zu = Ih(o, Wf);
        a = Yf(a), o -= Wf;
        for (var Ju = Tv(Zu, a); ++d < o; )
          a(d);
        return Ju;
      }
      function vA(o) {
        return eh(o) ? gh(o, cg) : Kh(o) ? [o] : Bh(bb(ch(o)));
      }
      function $A(o) {
        var a = ++T1;
        return ch(o) + a;
      }
      var bA = Um(function(o, a) {
        return o + a;
      }, 0), yA = t0("ceil"), wA = Um(function(o, a) {
        return o / a;
      }, 1), _A = t0("floor");
      function xA(o) {
        return o && o.length ? Nm(o, zh, Vv) : n;
      }
      function SA(o, a) {
        return o && o.length ? Nm(o, Yf(a, 2), Vv) : n;
      }
      function CA(o) {
        return i$(o, zh);
      }
      function AA(o, a) {
        return i$(o, Yf(a, 2));
      }
      function kA(o) {
        return o && o.length ? Nm(o, zh, Uv) : n;
      }
      function EA(o, a) {
        return o && o.length ? Nm(o, Yf(a, 2), Uv) : n;
      }
      var TA = Um(function(o, a) {
        return o * a;
      }, 1), DA = t0("round"), MA = Um(function(o, a) {
        return o - a;
      }, 0);
      function IA(o) {
        return o && o.length ? Ev(o, zh) : 0;
      }
      function LA(o, a) {
        return o && o.length ? Ev(o, Yf(a, 2)) : 0;
      }
      return nf.after = tS, nf.ary = Db, nf.assign = HS, nf.assignIn = Ub, nf.assignInWith = rv, nf.assignWith = WS, nf.at = US, nf.before = Mb, nf.bind = f0, nf.bindAll = ZC, nf.bindKey = Ib, nf.castArray = fS, nf.chain = kb, nf.chunk = __, nf.compact = x_, nf.concat = S_, nf.cond = GC, nf.conforms = XC, nf.constant = y0, nf.countBy = Ix, nf.create = KS, nf.curry = Lb, nf.curryRight = Ob, nf.debounce = Pb, nf.defaults = qS, nf.defaultsDeep = jS, nf.defer = nS, nf.delay = rS, nf.difference = C_, nf.differenceBy = A_, nf.differenceWith = k_, nf.drop = E_, nf.dropRight = T_, nf.dropRightWhile = D_, nf.dropWhile = M_, nf.fill = I_, nf.filter = Ox, nf.flatMap = Nx, nf.flatMapDeep = Bx, nf.flatMapDepth = Fx, nf.flatten = xb, nf.flattenDeep = L_, nf.flattenDepth = O_, nf.flip = oS, nf.flow = JC, nf.flowRight = eA, nf.fromPairs = P_, nf.functions = eC, nf.functionsIn = tC, nf.groupBy = Vx, nf.initial = N_, nf.intersection = B_, nf.intersectionBy = F_, nf.intersectionWith = V_, nf.invert = rC, nf.invertBy = oC, nf.invokeMap = Hx, nf.iteratee = w0, nf.keyBy = Wx, nf.keys = Th, nf.keysIn = Vh, nf.map = Xm, nf.mapKeys = sC, nf.mapValues = aC, nf.matches = tA, nf.matchesProperty = nA, nf.memoize = Jm, nf.merge = lC, nf.mergeWith = Kb, nf.method = rA, nf.methodOf = oA, nf.mixin = _0, nf.negate = ev, nf.nthArg = sA, nf.omit = pC, nf.omitBy = cC, nf.once = iS, nf.orderBy = Ux, nf.over = aA, nf.overArgs = sS, nf.overEvery = lA, nf.overSome = pA, nf.partial = h0, nf.partialRight = Rb, nf.partition = Kx, nf.pick = uC, nf.pickBy = qb, nf.property = Jb, nf.propertyOf = cA, nf.pull = U_, nf.pullAll = Cb, nf.pullAllBy = K_, nf.pullAllWith = q_, nf.pullAt = j_, nf.range = uA, nf.rangeRight = dA, nf.rearg = aS, nf.reject = Yx, nf.remove = Y_, nf.rest = lS, nf.reverse = u0, nf.sampleSize = Gx, nf.set = fC, nf.setWith = hC, nf.shuffle = Xx, nf.slice = Z_, nf.sortBy = eS, nf.sortedUniq = nx, nf.sortedUniqBy = rx, nf.split = NC, nf.spread = pS, nf.tail = ox, nf.take = ix, nf.takeRight = sx, nf.takeRightWhile = ax, nf.takeWhile = lx, nf.tap = xx, nf.throttle = cS, nf.thru = Gm, nf.toArray = zb, nf.toPairs = jb, nf.toPairsIn = Yb, nf.toPath = vA, nf.toPlainObject = Wb, nf.transform = gC, nf.unary = uS, nf.union = px, nf.unionBy = cx, nf.unionWith = ux, nf.uniq = dx, nf.uniqBy = fx, nf.uniqWith = hx, nf.unset = mC, nf.unzip = d0, nf.unzipWith = Ab, nf.update = vC, nf.updateWith = $C, nf.values = Jg, nf.valuesIn = bC, nf.without = gx, nf.words = Xb, nf.wrap = dS, nf.xor = mx, nf.xorBy = vx, nf.xorWith = $x, nf.zip = bx, nf.zipObject = yx, nf.zipObjectDeep = wx, nf.zipWith = _x, nf.entries = jb, nf.entriesIn = Yb, nf.extend = Ub, nf.extendWith = rv, _0(nf, nf), nf.add = bA, nf.attempt = Qb, nf.camelCase = xC, nf.capitalize = Zb, nf.ceil = yA, nf.clamp = yC, nf.clone = hS, nf.cloneDeep = mS, nf.cloneDeepWith = vS, nf.cloneWith = gS, nf.conformsTo = $S, nf.deburr = Gb, nf.defaultTo = QC, nf.divide = wA, nf.endsWith = SC, nf.eq = ig, nf.escape = CC, nf.escapeRegExp = AC, nf.every = Lx, nf.find = Px, nf.findIndex = wb, nf.findKey = YS, nf.findLast = Rx, nf.findLastIndex = _b, nf.findLastKey = ZS, nf.floor = _A, nf.forEach = Eb, nf.forEachRight = Tb, nf.forIn = GS, nf.forInRight = XS, nf.forOwn = QS, nf.forOwnRight = JS, nf.get = v0, nf.gt = bS, nf.gte = yS, nf.has = nC, nf.hasIn = $0, nf.head = Sb, nf.identity = zh, nf.includes = zx, nf.indexOf = R_, nf.inRange = wC, nf.invoke = iC, nf.isArguments = Bg, nf.isArray = eh, nf.isArrayBuffer = wS, nf.isArrayLike = Fh, nf.isArrayLikeObject = _h, nf.isBoolean = _S, nf.isBuffer = Eg, nf.isDate = xS, nf.isElement = SS, nf.isEmpty = CS, nf.isEqual = AS, nf.isEqualWith = kS, nf.isError = g0, nf.isFinite = ES, nf.isFunction = vg, nf.isInteger = Nb, nf.isLength = tv, nf.isMap = Bb, nf.isMatch = TS, nf.isMatchWith = DS, nf.isNaN = MS, nf.isNative = IS, nf.isNil = OS, nf.isNull = LS, nf.isNumber = Fb, nf.isObject = mh, nf.isObjectLike = yh, nf.isPlainObject = gm, nf.isRegExp = m0, nf.isSafeInteger = PS, nf.isSet = Vb, nf.isString = nv, nf.isSymbol = Kh, nf.isTypedArray = Qg, nf.isUndefined = RS, nf.isWeakMap = NS, nf.isWeakSet = BS, nf.join = z_, nf.kebabCase = kC, nf.last = tg, nf.lastIndexOf = H_, nf.lowerCase = EC, nf.lowerFirst = TC, nf.lt = FS, nf.lte = VS, nf.max = xA, nf.maxBy = SA, nf.mean = CA, nf.meanBy = AA, nf.min = kA, nf.minBy = EA, nf.stubArray = S0, nf.stubFalse = C0, nf.stubObject = fA, nf.stubString = hA, nf.stubTrue = gA, nf.multiply = TA, nf.nth = W_, nf.noConflict = iA, nf.noop = x0, nf.now = Qm, nf.pad = DC, nf.padEnd = MC, nf.padStart = IC, nf.parseInt = LC, nf.random = _C, nf.reduce = qx, nf.reduceRight = jx, nf.repeat = OC, nf.replace = PC, nf.result = dC, nf.round = DA, nf.runInContext = bf, nf.sample = Zx, nf.size = Qx, nf.snakeCase = RC, nf.some = Jx, nf.sortedIndex = G_, nf.sortedIndexBy = X_, nf.sortedIndexOf = Q_, nf.sortedLastIndex = J_, nf.sortedLastIndexBy = ex, nf.sortedLastIndexOf = tx, nf.startCase = BC, nf.startsWith = FC, nf.subtract = MA, nf.sum = IA, nf.sumBy = LA, nf.template = VC, nf.times = mA, nf.toFinite = $g, nf.toInteger = th, nf.toLength = Hb, nf.toLower = zC, nf.toNumber = ng, nf.toSafeInteger = zS, nf.toString = ch, nf.toUpper = HC, nf.trim = WC, nf.trimEnd = UC, nf.trimStart = KC, nf.truncate = qC, nf.unescape = jC, nf.uniqueId = $A, nf.upperCase = YC, nf.upperFirst = b0, nf.each = Eb, nf.eachRight = Tb, nf.first = Sb, _0(nf, function() {
        var o = {};
        return lg(nf, function(a, d) {
          uh.call(nf.prototype, d) || (o[d] = a);
        }), o;
      }(), { chain: !1 }), nf.VERSION = r, Gh(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(o) {
        nf[o].placeholder = nf;
      }), Gh(["drop", "take"], function(o, a) {
        sh.prototype[o] = function(d) {
          d = d === n ? 1 : Eh(th(d), 0);
          var Zu = this.__filtered__ && !a ? new sh(this) : this.clone();
          return Zu.__filtered__ ? Zu.__takeCount__ = Ih(d, Zu.__takeCount__) : Zu.__views__.push({
            size: Ih(d, Wf),
            type: o + (Zu.__dir__ < 0 ? "Right" : "")
          }), Zu;
        }, sh.prototype[o + "Right"] = function(d) {
          return this.reverse()[o](d).reverse();
        };
      }), Gh(["filter", "map", "takeWhile"], function(o, a) {
        var d = a + 1, Zu = d == Mf || d == Zf;
        sh.prototype[o] = function(Ju) {
          var of = this.clone();
          return of.__iteratees__.push({
            iteratee: Yf(Ju, 3),
            type: d
          }), of.__filtered__ = of.__filtered__ || Zu, of;
        };
      }), Gh(["head", "last"], function(o, a) {
        var d = "take" + (a ? "Right" : "");
        sh.prototype[o] = function() {
          return this[d](1).value()[0];
        };
      }), Gh(["initial", "tail"], function(o, a) {
        var d = "drop" + (a ? "" : "Right");
        sh.prototype[o] = function() {
          return this.__filtered__ ? new sh(this) : this[d](1);
        };
      }), sh.prototype.compact = function() {
        return this.filter(zh);
      }, sh.prototype.find = function(o) {
        return this.filter(o).head();
      }, sh.prototype.findLast = function(o) {
        return this.reverse().find(o);
      }, sh.prototype.invokeMap = rh(function(o, a) {
        return typeof o == "function" ? new sh(this) : this.map(function(d) {
          return pm(d, o, a);
        });
      }), sh.prototype.reject = function(o) {
        return this.filter(ev(Yf(o)));
      }, sh.prototype.slice = function(o, a) {
        o = th(o);
        var d = this;
        return d.__filtered__ && (o > 0 || a < 0) ? new sh(d) : (o < 0 ? d = d.takeRight(-o) : o && (d = d.drop(o)), a !== n && (a = th(a), d = a < 0 ? d.dropRight(-a) : d.take(a - o)), d);
      }, sh.prototype.takeRightWhile = function(o) {
        return this.reverse().takeWhile(o).reverse();
      }, sh.prototype.toArray = function() {
        return this.take(Wf);
      }, lg(sh.prototype, function(o, a) {
        var d = /^(?:filter|find|map|reject)|While$/.test(a), Zu = /^(?:head|last)$/.test(a), Ju = nf[Zu ? "take" + (a == "last" ? "Right" : "") : a], of = Zu || /^find/.test(a);
        Ju && (nf.prototype[a] = function() {
          var df = this.__wrapped__, mf = Zu ? [1] : arguments, wf = df instanceof sh, Tf = mf[0], Df = wf || eh(df), Lf = function(oh) {
            var ah = Ju.apply(nf, wg([oh], mf));
            return Zu && Nf ? ah[0] : ah;
          };
          Df && d && typeof Tf == "function" && Tf.length != 1 && (wf = Df = !1);
          var Nf = this.__chain__, Kf = !!this.__actions__.length, Gf = of && !Nf, nh = wf && !Kf;
          if (!of && Df) {
            df = nh ? df : new sh(this);
            var Xf = o.apply(df, mf);
            return Xf.__actions__.push({ func: Gm, args: [Lf], thisArg: n }), new Qh(Xf, Nf);
          }
          return Gf && nh ? o.apply(this, mf) : (Xf = this.thru(Lf), Gf ? Zu ? Xf.value()[0] : Xf.value() : Xf);
        });
      }), Gh(["pop", "push", "shift", "sort", "splice", "unshift"], function(o) {
        var a = _m[o], d = /^(?:push|sort|unshift)$/.test(o) ? "tap" : "thru", Zu = /^(?:pop|shift)$/.test(o);
        nf.prototype[o] = function() {
          var Ju = arguments;
          if (Zu && !this.__chain__) {
            var of = this.value();
            return a.apply(eh(of) ? of : [], Ju);
          }
          return this[d](function(df) {
            return a.apply(eh(df) ? df : [], Ju);
          });
        };
      }), lg(sh.prototype, function(o, a) {
        var d = nf[a];
        if (d) {
          var Zu = d.name + "";
          uh.call(jg, Zu) || (jg[Zu] = []), jg[Zu].push({ name: a, func: d });
        }
      }), jg[Wm(n, rf).name] = [{
        name: "wrapper",
        func: n
      }], sh.prototype.clone = j1, sh.prototype.reverse = Y1, sh.prototype.value = Z1, nf.prototype.at = Sx, nf.prototype.chain = Cx, nf.prototype.commit = Ax, nf.prototype.next = kx, nf.prototype.plant = Tx, nf.prototype.reverse = Dx, nf.prototype.toJSON = nf.prototype.valueOf = nf.prototype.value = Mx, nf.prototype.first = nf.prototype.head, nm && (nf.prototype[nm] = Ex), nf;
    }, Ug = A1();
    Dg ? ((Dg.exports = Ug)._ = Ug, wv._ = Ug) : Dh._ = Ug;
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var lodashExports = lodash.exports;
const _hoisted_1$8 = { class: "qs-tab__label" }, _hoisted_2$7 = ["innerHTML"], _sfc_main$8 = {
  __name: "QsTabItem",
  props: ["step"],
  setup(e) {
    const t = e, n = ref(""), r = ref(!1), i = ref(!1), s = ref(!1);
    onMounted(() => {
      n.value = t.step.name, r.value = t.step.props.isTouched;
    }), onMounted(() => {
      t.step.on("prop:isActiveStep", ({ payload: c }) => {
        s.value = c;
      }), t.step.on("prop:isValid", ({ payload: c }) => {
        i.value = c;
      }), t.step.on("prop:isTouched", ({ payload: c }) => {
        r.value = c;
      });
    });
    const l = computed(() => i.value ? "&check;" : "&times;");
    return (c, u) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([s.value ? "active" : "", "formkit-tab qs-tab"])
    }, [
      createElementVNode("span", _hoisted_1$8, toDisplayString(n.value), 1),
      r.value ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: normalizeClass(["qs-tab__icon", i.value ? "valid" : "not-valid"]),
        innerHTML: l.value
      }, null, 10, _hoisted_2$7)) : createCommentVNode("", !0)
    ], 2));
  }
}, _hoisted_1$7 = { class: "qs-preview-modal__header" }, _hoisted_2$6 = /* @__PURE__ */ createElementVNode("h2", { class: "" }, "Anteprima del form", -1), _hoisted_3$5 = { class: "qs-preview-modal__body" }, _hoisted_4$4 = { class: "qs-preview-modal__body" }, _hoisted_5$4 = { class: "formkit-tabs__wrapper" }, _hoisted_6$3 = { class: "formkit-tabs" }, _hoisted_7$3 = /* @__PURE__ */ createElementVNode("i", { class: "ri-eye-line" }, null, -1), _hoisted_8$2 = /* @__PURE__ */ createElementVNode("i", { class: "ri-save-3-line" }, null, -1), _hoisted_9$2 = ["disabled"], _hoisted_10$1 = /* @__PURE__ */ createElementVNode("i", { class: "ri-send-plane-line" }, null, -1), _sfc_main$7 = {
  __name: "QsWrapper",
  props: ["modelValue", "settings", "beforeSubmit", "allowIncomplete", "onBeforeStepChange", "saveProgressOptions"],
  emits: ["update:modelValue", "sessionError", "pingFailure", "complete", "afterSubmit", "afterSave"],
  setup(e, { expose: t, emit: n }) {
    const { emitter: r } = useEventBus();
    r.on("saveProgress", async (Rf = {}) => await Mf(Rf));
    const i = ref(null), s = n, l = e, c = ref(l.modelValue), { loadGoogleMapsScript: u } = useGoogleApi();
    u(l.settings.googleApiKey || "AIzaSyBHwgd2BNLGOrt_o5Q19B_42Ma25Z5u6o0");
    const m = ref(!1);
    let qu;
    const Gu = ref({}), Qu = () => {
      Xu.value = !0;
    }, Xu = ref(!1), { steps: ef, activeStep: tf, stepPlugin: af, addAsteriskPlugin: rf, multiStepNode: hf, isValid: sf, getNextLabel: pf } = useQsSteps(l.settings), { progress: $f } = useQsProgress(), { getPingUrl: uf, getSetUrl: vf, getFormId: cf, getFormIdentifier: yf } = QsUtils();
    onUnmounted(() => {
      Xu.value = !1;
    }), onMounted(() => {
      l.settings.pingRemote && lodashExports.isUndefined(qu) && (qu = setInterval(Zf, 1e4), l.settings.pingIntervalId = qu), setTimeout(() => {
        gf();
      }, 0);
      const Rf = getNode("qsWrapper");
      Rf.props = { ...Rf.props, ...l.settings }, watch$1(() => ff.value, (Bf) => {
        s("update:modelValue", Bf);
      }, { deep: !0 }), watch$1(() => sf.value, (Bf) => {
        Bf && s("complete");
      });
    });
    const ff = computed(() => {
      let Rf = {};
      function Bf(ih, lh) {
        if (lodashExports.isFunction(lh) && (Rf[ih] = lh), lh === null || typeof lh != "object")
          console.log("Non è un oggetto ", lh);
        else
          for (const [Wf, vh] of Object.entries(lh))
            Rf[Wf] = vh;
      }
      return Object.keys(Gu.value).forEach((ih) => {
        Bf(ih, Gu.value[ih]);
      }), { ...Rf };
    }), gf = () => {
      const Rf = lodashExports.cloneDeep(c.value);
      Object.entries(Gu.value).map(([Bf, ih]) => {
        Gu.value[Bf] = Rf;
      });
    }, lf = (Rf, Bf) => {
      hf.value.goTo(Bf);
    }, Sf = async ({ currentStep: Rf, targetStep: Bf, delta: ih }) => {
      if (l.onBeforeStepChange && typeof l.onBeforeStepChange == "function")
        return await l.onBeforeStepChange({ currentStep: Rf, targetStep: Bf, delta: ih });
      await Mf({ "form-action": "step-change" });
    }, Mf = async (Rf = {}) => {
      const Bf = vf(), ih = cf(), lh = yf(), Wf = {
        ...ff.value,
        identifier: lh
      }, vh = new FormData();
      vh.set("json", JSON.stringify(Wf)), vh.set("progress", JSON.stringify($f.value));
      const Ef = {
        ...l.saveProgressOptions || {},
        ...Rf
      };
      try {
        const Pf = await ofetch(Bf, {
          method: "POST",
          credentials: "include",
          // include
          /* headers: {
            'Content-Type': 'multipart/form-data'
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },*/
          params: {
            id: ih,
            ...Ef
            // Aggiungo tutte le opzioni come parametri della richiesta
          },
          body: vh
        });
        s("afterSave", Pf);
      } catch (Pf) {
        s("afterSave", { success: !1, error: Pf });
      }
    }, Uf = async () => {
      if (m.value = !0, l.beforeSubmit && !await l.beforeSubmit(sf)) {
        m.value = !1;
        return;
      }
      const Rf = vf(), Bf = cf(), ih = yf(), lh = {
        ...ff.value,
        identifier: ih
      }, Wf = new FormData();
      Wf.set("json", JSON.stringify(lh)), Wf.set("progress", JSON.stringify($f.value)), Wf.set("send", 1);
      try {
        const vh = await ofetch(Rf, {
          method: "POST",
          credentials: "include",
          // include
          /* headers: {
            'Content-Type': 'multipart/form-data'
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },*/
          params: {
            id: Bf
          },
          body: Wf
        });
        s("afterSubmit", vh);
      } catch (vh) {
        console.log(vh), s("afterSubmit", { success: !1, error: vh });
      } finally {
        debugger;
        m.value = !1;
      }
    };
    function Zf() {
      return ofetch(uf(), {
        data: { action: "ping_remote" },
        params: { t: (/* @__PURE__ */ new Date()).getTime() },
        type: "POST",
        dataType: "json",
        credentials: "include"
      }).then((Rf) => {
        JSON.parse(Rf).success || (s("sessionError"), clearInterval(qu));
      }).catch((Rf) => {
        s("pingFailure"), clearInterval(qu), console.log(Rf);
      });
    }
    return t({
      submit: Uf,
      saveProgress: Mf,
      showPreviewModal: Qu
    }), (Rf, Bf) => {
      const ih = resolveComponent("QsPreview"), lh = resolveComponent("QsModal"), Wf = resolveComponent("QsToolbar"), vh = resolveComponent("FormKit"), Ef = resolveComponent("FormKitSchema");
      return openBlock(), createElementBlock("div", null, [
        createVNode(lh, {
          modelValue: Xu.value,
          "onUpdate:modelValue": Bf[3] || (Bf[3] = (Pf) => Xu.value = Pf),
          onDismiss: Bf[4] || (Bf[4] = (Pf) => Xu.value = !1)
        }, {
          header: withCtx(() => [
            createElementVNode("div", _hoisted_1$7, [
              _hoisted_2$6,
              createElementVNode("button", {
                class: "qs-btn",
                type: "button",
                onClick: Bf[0] || (Bf[0] = (Pf) => Xu.value = !1)
              }, " × ")
            ])
          ]),
          body: withCtx(() => [
            createElementVNode("div", _hoisted_3$5, [
              createVNode(ih, {
                modelValue: ff.value,
                "onUpdate:modelValue": Bf[1] || (Bf[1] = (Pf) => ff.value = Pf),
                settings: e.settings
              }, null, 8, ["modelValue", "settings"])
            ])
          ]),
          footer: withCtx(() => [
            createElementVNode("div", _hoisted_4$4, [
              createElementVNode("button", {
                class: "qs-btn",
                type: "button",
                onClick: Bf[2] || (Bf[2] = (Pf) => Xu.value = !1)
              }, " Chiudi ")
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        createVNode(vh, {
          type: "form",
          onSubmit: Uf,
          ref_key: "form",
          ref: i,
          id: "qsWrapper",
          actions: !1
        }, {
          default: withCtx(() => [
            createVNode(vh, {
              type: "multi-step",
              plugins: [unref(af), unref(rf)],
              "valid-step-icon": "star",
              "tab-style": "tab",
              id: "multiStepNode",
              "hide-progress-labels": !0,
              "allow-incomplete": e.allowIncomplete,
              "before-step-change": Sf,
              modelValue: Gu.value,
              "onUpdate:modelValue": Bf[7] || (Bf[7] = (Pf) => Gu.value = Pf)
            }, {
              tabs: withCtx(() => [
                createElementVNode("div", _hoisted_5$4, [
                  renderSlot(Rf.$slots, "beforeTabs"),
                  createElementVNode("div", _hoisted_6$3, [
                    (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(ef), (Pf, _f) => (openBlock(), createBlock(_sfc_main$8, {
                      step: Pf,
                      "is-active": unref(tf) === Pf.name,
                      onClick: (Cf) => lf(Pf, _f)
                    }, null, 8, ["step", "is-active", "onClick"]))), 256))
                  ]),
                  renderSlot(Rf.$slots, "afterTabs")
                ])
              ]),
              default: withCtx(() => [
                createVNode(Wf, null, {
                  default: withCtx(() => [
                    createElementVNode("div", null, [
                      renderSlot(Rf.$slots, "toolbarActions")
                    ]),
                    createElementVNode("div", null, [
                      renderSlot(Rf.$slots, "toolbarActionsRight", {}, () => [
                        e.settings.hidePreviewBtn ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", {
                          key: 0,
                          onClick: Bf[5] || (Bf[5] = (Pf) => Xu.value = !Xu.value),
                          class: "qs-btn qs-btn-primary-outline",
                          role: "button",
                          onComplete: Bf[6] || (Bf[6] = (Pf) => Xu.value = !Xu.value)
                        }, [
                          createTextVNode(" Anteprima "),
                          _hoisted_7$3
                        ], 32)),
                        e.settings.hideSaveBtn ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", {
                          key: 1,
                          onClick: Mf,
                          class: "qs-btn qs-btn-primary-outline",
                          role: "button"
                        }, [
                          createTextVNode(" Salva "),
                          _hoisted_8$2
                        ])),
                        createElementVNode("div", {
                          onClick: Uf,
                          class: "qs-btn qs-btn-primary",
                          role: "button",
                          disabled: !unref(sf)
                        }, [
                          createTextVNode(" Invia "),
                          _hoisted_10$1
                        ], 8, _hoisted_9$2)
                      ])
                    ])
                  ]),
                  _: 3
                }),
                (openBlock(!0), createElementBlock(Fragment, null, renderList(e.settings.schema, (Pf, _f) => (openBlock(), createBlock(vh, {
                  type: "step",
                  "next-label": unref(pf)(_f),
                  name: Pf.name
                }, createSlots({
                  stepInner: withCtx(() => [
                    (openBlock(!0), createElementBlock(Fragment, null, renderList(Pf.children, (Cf) => (openBlock(), createBlock(Ef, {
                      schema: Cf,
                      data: e.modelValue,
                      actions: !1
                    }, null, 8, ["schema", "data"]))), 256))
                  ]),
                  _: 2
                }, [
                  _f === e.settings.schema.length - 1 ? {
                    name: "stepNext",
                    fn: withCtx(() => [
                      createVNode(vh, {
                        disabled: m.value,
                        type: "submit",
                        class: "qs-btn qs-btn-primary"
                      }, null, 8, ["disabled"])
                    ]),
                    key: "0"
                  } : void 0
                ]), 1032, ["next-label", "name"]))), 256))
              ]),
              _: 3
            }, 8, ["plugins", "allow-incomplete", "modelValue"])
          ]),
          _: 3
        }, 512)
      ]);
    };
  }
}, _hoisted_1$6 = {
  key: 0,
  class: "qs-modal"
}, _hoisted_2$5 = { class: "qs-modal-content" }, _hoisted_3$4 = {
  key: 0,
  class: "qs-modal-header"
}, _hoisted_4$3 = {
  key: 1,
  class: "qs-modal-body"
}, _hoisted_5$3 = {
  key: 2,
  class: "qs-modal-footer"
}, _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "QsModal",
  props: ["modelValue"],
  emits: ["dismiss", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = useSlots(), r = e, i = t, s = computed({
      get() {
        return r.modelValue;
      },
      set(c) {
        i("update:modelValue", c);
      }
    }), l = () => {
      s.value = !1, console.log("dismiss della modale"), i("dismiss");
    };
    return (c, u) => (openBlock(), createBlock(Teleport, { to: "body" }, [
      s.value ? (openBlock(), createElementBlock("div", _hoisted_1$6, [
        createElementVNode("div", {
          class: "qs-modal-overlay",
          onClick: l
        }),
        createElementVNode("div", _hoisted_2$5, [
          unref(n).header ? (openBlock(), createElementBlock("div", _hoisted_3$4, [
            renderSlot(c.$slots, "header")
          ])) : createCommentVNode("", !0),
          unref(n).body ? (openBlock(), createElementBlock("div", _hoisted_4$3, [
            renderSlot(c.$slots, "body")
          ])) : createCommentVNode("", !0),
          unref(n).footer ? (openBlock(), createElementBlock("div", _hoisted_5$3, [
            renderSlot(c.$slots, "footer")
          ])) : createCommentVNode("", !0)
        ])
      ])) : createCommentVNode("", !0)
    ]));
  }
}), _export_sfc = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, _sfc_main$5 = {}, _hoisted_1$5 = { id: "qsToolbar" };
function _sfc_render(e, t) {
  return openBlock(), createElementBlock("div", _hoisted_1$5, [
    renderSlot(e.$slots, "default")
  ]);
}
const QsToolbar = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render]]);
function useQsPreview() {
  const getLabelOfValueOptions = (e, t) => {
    let n;
    if (isProxy(e) && (e = toRaw(e)), lodashExports.isArray(e)) {
      n = [];
      for (let r of e)
        for (let i of t)
          (i.__original === r || i.value === r) && n.push(i.label);
      return n.join(", ");
    } else {
      for (let r of t)
        (r.__original === e || r.value === e) && (n = r.label);
      if (!n)
        for (let r of t)
          r.children;
    }
    return n;
  }, getLabelOfRepeaterKey = (e, t) => {
    let n;
    for (let r of t)
      r.children ? n = getLabelOfRepeaterKey(e, r.children) : r.name === e && (n = r.label);
    return n;
  }, getValueOfRepeaterKey = (e, t, n) => {
    let r = e;
    for (let i of n)
      i.children ? r = getValueOfRepeaterKey(e, t, i.children) : i.name === t && i.options ? r = getLabelOfValueOptions(e, i.options) : i.name === t && (r = formatValue(i, e));
    return r;
  }, formatValue = (e, t = null) => (t || (t = e.value), e.$formkit === "radio" || e.$formkit === "select" || e.$formkit === "checkbox" ? lodashExports.isUndefined(t) ? "-" : getLabelOfValueOptions(t, e.options) : e.$formkit === "location" ? lodashExports.isUndefined(t) ? "-" : t.formatted_address : e.$formkit === "imageCropper" ? !lodashExports.isUndefined(t) && !lodashExports.isUndefined(t.cropped) && !lodashExports.isUndefined(t.cropped.fileUrl) ? `<img src="${t.cropped.fileUrl}" style="max-height: 300px; max-width: 600px"/>` : "-" : e.$formkit === "fileUploader" ? lodashExports.isUndefined(t) ? "-" : `<a target="_blank" href="${t.fileUrl}">${t.fileName}</a>` : e.$formkit === "datepicker" ? lodashExports.isUndefined(t) ? "-" : new Date(t).toLocaleDateString() : e.$formkit === "number" && (console.log(e, t), !lodashExports.isUndefined(t) && e.prefixIcon === "euro") ? new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(t) : t || "-"), populatePreviewModel = (props) => {
    let previewModel = [];
    const completeModel = cleanFlatSchema(props.settings.schema).map((item) => {
      let value;
      try {
        value = eval("props.modelValue." + item.modelPath);
      } catch (e) {
      }
      if (lodashExports.isUndefined(value))
        try {
          value = eval("props.modelValue." + item.parent.modelPath + "." + item.name);
        } catch (e) {
        }
      return {
        ...item,
        value
      };
    }).filter((item) => {
      if (item.if) {
        try {
          return eval(item.if.replace(/\$/, "props.modelValue."));
        } catch (e) {
          console.log(e);
        }
        return !0;
      }
      return !0;
    });
    for (let e in completeModel) {
      const t = completeModel[e];
      if (console.log(t, t.$formkit), t.$formkit)
        switch (t.$formkit) {
          default:
          case "website":
          case "number":
          case "text":
          case "select":
          case "checkbox":
          case "radio":
          case "imageCropper":
          case "fileUploader":
          case "location":
            previewModel.push({
              label: t.label,
              value: formatValue(t)
            });
            break;
          case "repeater":
            let n = {
              label: t.label,
              children: []
            };
            const r = isProxy(t.value) ? toRaw(t.value) : t.value;
            if (r)
              for (const [, i] of Object.entries(r))
                for (const [s, l] of Object.entries(i))
                  n.children.push({
                    label: getLabelOfRepeaterKey(s, t.children),
                    value: l ? getValueOfRepeaterKey(l, s, t.children) : "-"
                  });
            previewModel.push(n);
            break;
        }
      else console.log(t);
    }
    return previewModel;
  }, flatSchema = (e) => {
    const t = [], n = (r, i = "", s = 0, l = null) => {
      for (let c of r) {
        if (!lodashExports.isObject(c)) return;
        if (l) {
          const u = lodashExports.cloneDeep(l);
          delete u.children, c.parent = u;
        }
        if (c.name, lodashExports.isUndefined(c.name))
          c.children && Array.isArray(c.children) && c.children.length > 0 && n(c.children, i, s + 1, c);
        else if (c.modelPath = i + c.name, c.deep = s, c.children && Array.isArray(c.children) && c.children.length > 0) {
          let u = "";
          c.name && s > 0 && (u += c.name + "."), c.label && s > 0 && t.push(c), c.$formkit !== "repeater" && n(c.children, u, s + 1, c);
        } else
          t.push(c);
      }
    };
    return n(e), t;
  }, cleanFlatSchema = (e) => flatSchema(e).filter((t) => t.name !== void 0);
  return {
    populatePreviewModel,
    formatValue,
    getLabelOfRepeaterKey
  };
}
const _hoisted_1$4 = { class: "qs-preview" }, _hoisted_2$4 = { class: "qs-preview__question" }, _hoisted_3$3 = { class: "qs-preview__label" }, _hoisted_4$2 = ["innerHTML"], _hoisted_5$2 = ["innerHTML"], _hoisted_6$2 = { class: "qs-preview__answer" }, _hoisted_7$2 = { key: 0 }, _hoisted_8$1 = { key: 0 }, _hoisted_9$1 = /* @__PURE__ */ createElementVNode("br", null, null, -1), _hoisted_10 = ["innerHTML"], _hoisted_11 = { key: 1 }, _sfc_main$4 = {
  __name: "QsPreview",
  props: ["modelValue", "settings"],
  setup(e) {
    const t = e, n = ref([]), { populatePreviewModel: r } = useQsPreview();
    return onMounted(() => {
      try {
        n.value = r(lodashExports.cloneDeep(t));
      } catch (i) {
        console.log(i);
      }
    }), onUnmounted(() => {
      n.value = [];
    }), (i, s) => (openBlock(), createElementBlock("ul", _hoisted_1$4, [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(n.value, (l) => (openBlock(), createElementBlock("li", null, [
        createElementVNode("div", _hoisted_2$4, [
          createElementVNode("div", _hoisted_3$3, [
            l.previewLabel ? (openBlock(), createElementBlock("span", {
              key: 0,
              innerHTML: l.previewLabel
            }, null, 8, _hoisted_4$2)) : (openBlock(), createElementBlock("span", {
              key: 1,
              innerHTML: l.label
            }, null, 8, _hoisted_5$2))
          ]),
          createElementVNode("div", _hoisted_6$2, [
            l.value !== null ? (openBlock(), createElementBlock("div", _hoisted_7$2, [
              l.children ? (openBlock(), createElementBlock("div", _hoisted_8$1, [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(l.children, (c) => (openBlock(), createElementBlock("div", null, [
                  createElementVNode("span", null, toDisplayString(c.label), 1),
                  _hoisted_9$1,
                  createElementVNode("span", null, toDisplayString(c.value), 1)
                ]))), 256))
              ])) : (openBlock(), createElementBlock("div", {
                key: 1,
                innerHTML: l.value
              }, null, 8, _hoisted_10))
            ])) : (openBlock(), createElementBlock("div", _hoisted_11, " -"))
          ])
        ])
      ]))), 256))
    ]));
  }
}, _hoisted_1$3 = { class: "qs-location-input" }, _hoisted_2$3 = ["value", "placeholder"], _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "QsLocation",
  props: {
    context: Object
  },
  setup(e) {
    const t = ref(null), n = e, r = (m) => new Promise((qu) => setTimeout(qu, m)), i = async () => {
      window.hasOwnProperty("google") ? s() : (await r(100), i());
    };
    onMounted(async () => {
      i();
    });
    function s() {
      const m = window.hasOwnProperty("google") ? window.google : null;
      if (m && t.value) {
        const qu = new m.maps.places.Autocomplete(
          t.value
        );
        qu.addListener("place_changed", () => {
          const Gu = qu.getPlace();
          c(Gu);
        });
      }
    }
    ref("");
    const l = ref({}), c = (m) => {
      l.value = u(m), n.context.node.input(l.value);
    }, u = function(m) {
      var qu = m.address_components, Gu = {};
      if (lodashExports.forEach(qu, function(Qu, Xu) {
        Gu[Qu.types[0]] = Qu;
      }), Gu.getProp = function(Qu) {
        return this.hasOwnProperty(Qu) ? this[Qu] : { long_name: "", short_name: "" };
      }, Gu.getProp("locality").long_name.length === 0) {
        const Qu = function() {
          let Xu;
          for (var ef = 3; ef <= 5; ef++)
            if (Gu["administrative_area_level_" + ef] && Gu["administrative_area_level_" + ef].long_name.length > 0) {
              Gu["administrative_area_level_" + ef].types[0] = "locality", Xu = Gu["administrative_area_level_" + ef];
              break;
            } else
              Xu = { long_name: "", short_name: "" };
          return Xu;
        }();
        Gu.locality = Qu;
      }
      return {
        // @ts-ignore
        country: Gu.getProp("country").long_name,
        // @ts-ignore
        street: Gu.getProp("route").long_name,
        // @ts-ignore
        city: Gu.getProp("locality").long_name,
        // @ts-ignore
        cities: Gu.getProp("locality").long_name,
        // @ts-ignore
        street_number: Gu.getProp("street_number").long_name,
        // @ts-ignore
        zip: Gu.getProp("postal_code").long_name,
        // @ts-ignore
        state: Gu.getProp("administrative_area_level_2").short_name,
        // @ts-ignore
        region: Gu.getProp("administrative_area_level_1").long_name,
        place_id: m.place_id,
        lat: function() {
          return m.geometry ? typeof m.geometry.location.lat == "number" ? m.geometry.location.lat : m.geometry.location.lat() : null;
        }(),
        lng: function() {
          return m.geometry ? typeof m.geometry.location.lng == "number" ? m.geometry.location.lng : m.geometry.location.lng() : null;
        }(),
        formatted_address: m.formatted_address
      };
    };
    return (m, qu) => {
      var Gu, Qu, Xu;
      return openBlock(), createElementBlock("div", _hoisted_1$3, [
        createElementVNode("input", {
          ref_key: "autocompleteInput",
          ref: t,
          type: "text",
          autocomplete: "off",
          value: (Gu = e.context.node.value) == null ? void 0 : Gu.formatted_address,
          placeholder: (Xu = (Qu = e.context.node.props) == null ? void 0 : Qu.attrs) == null ? void 0 : Xu.placeholder,
          class: "formkit-input"
        }, null, 8, _hoisted_2$3)
      ]);
    };
  }
}), _hoisted_1$2 = {
  key: 0,
  class: "cropper__placeholder"
}, _hoisted_2$2 = ["src"], _hoisted_3$2 = { key: 1 }, _hoisted_4$1 = { class: "cropper__wrapper" }, _hoisted_5$1 = { class: "cropper__preview" }, _hoisted_6$1 = ["src"], _hoisted_7$1 = { class: "cropper__footer" }, _hoisted_8 = ["disabled"], _hoisted_9 = ["disabled"], _sfc_main$2 = {
  __name: "QsImageCropper",
  props: {
    context: Object
  },
  setup(e) {
    const { emitter: t } = useEventBus(), { getUploadUrl: n, getFormId: r, sanitizeFilename: i } = QsUtils(), s = ref(""), l = e;
    console.log("context", l.context);
    const c = l.context.node, u = ref({});
    c.on("input", ({ payload: pf }) => {
      u.value = pf;
    });
    const m = ref(!1), qu = ref(!1), Gu = {
      name: l.context.imageName,
      title: "",
      src: null,
      preview: null,
      coordinates: null,
      blob: null
    }, Qu = ref("image"), Xu = ref({ ...Gu }), ef = () => {
      Xu.value = { ...Gu }, l.context.node.input({});
    }, tf = (pf) => {
      const $f = pf.target.files[0], uf = new FileReader();
      if (Qu.value = pf.target.files[0].name, l.context.maxSize && $f.size > l.context.maxSize) {
        s.value = `Il file è troppo grande, massimo ${l.context.maxSize / 1024 / 1024}MB`, alert(`Il file è troppo grande, massimo ${l.context.maxSize / 1024 / 1024}MB`);
        return;
      }
      if (l.context.acceptedFormats) {
        const vf = l.context.acceptedFormats.split(","), cf = $f.type.split("/")[1];
        if (!vf.includes(cf)) {
          s.value = `Formato non supportato, i formati supportati sono: ${vf.join(", ")}`, alert(`Formato non supportato, i formati supportati sono: ${vf.join(", ")}`);
          return;
        }
      }
      qu.value = !0, uf.onload = function(vf) {
        Xu.value.title = $f.name, Xu.value.src = vf.target.result;
      }, uf.readAsDataURL($f);
    }, af = async ({ coordinates: pf, canvas: $f }) => {
      Xu.value.preview = $f.toDataURL(), Xu.value.coordinates = pf, m.value = !0, $f.toBlob(async (uf) => {
        Xu.value.blob = uf, m.value = !1;
      }, "image/png", 1);
    }, rf = async () => {
      m.value = !0;
      const { success: pf, object: $f } = await sf(!0, Xu.value.blob);
      if (!pf) {
        m.value = !1;
        return;
      }
      $f.fileUrl += "?r=" + Math.random() * 1100;
      const uf = Xu.value.src.split(","), vf = uf[0].split(":")[1].split(";")[0], { success: cf, object: yf } = await sf(!1, hf(uf[1], vf));
      if (!cf) {
        m.value = !1;
        return;
      }
      yf.fileUrl += "?r=" + Math.random() * 1100, l.context.node.input({
        cropped: $f,
        original: yf,
        cropperData: Xu.value.coordinates
      }), t.emit("saveProgress", { "form-action": "save-after-image-cropper" }), m.value = !1, qu.value = !1;
    }, hf = (pf, $f = "", uf = 512) => {
      const vf = atob(pf), cf = [];
      for (let ff = 0; ff < vf.length; ff += uf) {
        const gf = vf.slice(ff, ff + uf), lf = new Array(gf.length);
        for (let Mf = 0; Mf < gf.length; Mf++)
          lf[Mf] = gf.charCodeAt(Mf);
        const Sf = new Uint8Array(lf);
        cf.push(Sf);
      }
      return new Blob(cf, { type: $f });
    }, sf = async (pf, $f) => {
      const uf = n(), vf = new FormData();
      vf.append("file", $f);
      const cf = i(l.context.node.name + (pf ? "-cropped" : "") + "-" + Qu.value);
      m.value = !0;
      const yf = await ofetch(uf, {
        method: "POST",
        credentials: "include",
        params: {
          id: r(),
          type: l.context.node.name,
          filename: cf,
          t: (/* @__PURE__ */ new Date()).getTime(),
          cropped: pf ? 1 : 0
          // per php a cui non piacciono i bool in stringa
        },
        body: vf,
        processData: !1,
        contentType: !1,
        crossDomain: !0
      });
      return JSON.parse(yf);
    };
    return (pf, $f) => {
      var cf;
      const uf = resolveComponent("Cropper"), vf = resolveComponent("QsModal");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", null, [
          (cf = e.context.node.value) != null && cf.cropped ? (openBlock(), createElementBlock("div", _hoisted_1$2, [
            createElementVNode("img", {
              src: `${e.context.node.value.cropped.fileUrl}`,
              alt: "",
              class: ""
            }, null, 8, _hoisted_2$2),
            createElementVNode("button", {
              class: "qs-btn",
              onClick: $f[0] || ($f[0] = (yf) => ef())
            }, "cambia immagine")
          ])) : (openBlock(), createElementBlock("div", _hoisted_3$2, [
            createElementVNode("input", {
              type: "file",
              onChange: tf,
              accept: "image/*",
              class: "formkit-input"
            }, null, 32)
          ]))
        ]),
        createVNode(vf, {
          modelValue: qu.value,
          "onUpdate:modelValue": $f[2] || ($f[2] = (yf) => qu.value = yf)
        }, {
          header: withCtx(() => [
            createTextVNode(" Inserisci una immagine ")
          ]),
          body: withCtx(() => [
            createElementVNode("div", _hoisted_4$1, [
              createVNode(uf, {
                class: "cropper",
                src: Xu.value.src,
                "stencil-props": {
                  aspectRatio: e.context.aspectRatio
                },
                onChange: af
              }, null, 8, ["src", "stencil-props"]),
              createElementVNode("div", _hoisted_5$1, [
                createElementVNode("img", {
                  src: Xu.value.preview,
                  alt: ""
                }, null, 8, _hoisted_6$1)
              ])
            ])
          ]),
          footer: withCtx(() => [
            createElementVNode("div", _hoisted_7$1, [
              createElementVNode("button", {
                class: "qs-btn",
                type: "button",
                onClick: $f[1] || ($f[1] = (yf) => qu.value = !1),
                disabled: m.value
              }, " Annulla ", 8, _hoisted_8),
              createElementVNode("button", {
                class: "qs-btn qs-btn-primary",
                type: "button",
                onClick: rf,
                disabled: m.value
              }, " Salva ", 8, _hoisted_9)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 64);
    };
  }
}, QsImageCropper = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["__scopeId", "data-v-1c56e6a5"]]), _hoisted_1$1 = {
  key: 0,
  class: "file-link-container"
}, _hoisted_2$1 = ["href"], _hoisted_3$1 = ["accept"], _sfc_main$1 = {
  __name: "QsFile",
  props: {
    context: Object
  },
  setup(e) {
    const { emitter: t } = useEventBus(), { getUploadUrl: n, getFormId: r, sanitizeFilename: i } = QsUtils(), s = e, l = s.context.node, c = ref({});
    l.on("input", ({ payload: qu }) => {
      c.value = qu;
    });
    const u = ref(!1), m = async (qu) => {
      const Gu = qu.target.files[0];
      if (Gu.type !== s.context.accept)
        return window.alert("formato file non valido"), {};
      const Qu = n(), Xu = new FormData();
      Xu.append("file", Gu);
      const tf = i((/* @__PURE__ */ new Date()).getTime() + "-" + Gu.name);
      u.value = !0;
      const af = await ofetch(Qu, {
        method: "POST",
        credentials: "include",
        params: {
          id: r(),
          type: s.context.node.name,
          filename: tf,
          t: (/* @__PURE__ */ new Date()).getTime()
          //cropped: cropped ? 1 : 0 // per php a cui non piacciono i bool in stringa
        },
        body: Xu,
        processData: !1,
        contentType: !1,
        crossDomain: !0
      }), rf = JSON.parse(af);
      return rf.success ? (s.context.node.input(rf.object), t.emit("saveProgress", { "form-action": "save-after-file-upload" }), rf) : (window.alert("Errore durante il caricamento del file"), c.value = {}, s.context.node.input({}), {});
    };
    return (qu, Gu) => (openBlock(), createElementBlock("div", null, [
      e.context.node.value ? (openBlock(), createElementBlock("div", _hoisted_1$1, [
        createElementVNode("a", {
          href: e.context.node.value.fileUrl,
          target: "_blank"
        }, toDisplayString(e.context.node.value.fileName), 9, _hoisted_2$1)
      ])) : createCommentVNode("", !0),
      createElementVNode("div", null, [
        createElementVNode("input", {
          type: "file",
          onChange: m,
          accept: e.context.accept,
          class: "formkit-input"
        }, null, 40, _hoisted_3$1)
      ])
    ]));
  }
}, _hoisted_1 = /* @__PURE__ */ createElementVNode("th", null, null, -1), _hoisted_2 = ["colspan"], _hoisted_3 = { class: "formkit-option" }, _hoisted_4 = ["onClick"], _hoisted_5 = { class: "" }, _hoisted_6 = ["name", "value", "onUpdate:modelValue"], _hoisted_7 = /* @__PURE__ */ createElementVNode("span", { class: "formkit-decorator" }, [
  /* @__PURE__ */ createElementVNode("span", { class: "formkit-decorator-icon formkit-icon" }, [
    /* @__PURE__ */ createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32"
    }, [
      /* @__PURE__ */ createElementVNode("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "16",
        r: "16"
      })
    ])
  ])
], -1), _sfc_main = {
  __name: "QsMatrix",
  props: {
    context: Object
  },
  setup(e) {
    const t = e, n = t.context.node.context.id, r = t.context.node.name, i = ref({});
    onMounted(async () => {
      await nextTick();
      const c = t.context.node.value;
      i.value = { ...c };
    });
    const s = computed(() => Math.floor(t.context.values.length / t.context.labels.length)), l = computed(() => Math.floor(50 / t.context.values.length) + "%");
    return watch$1(() => i.value, async (c) => {
      t.context.node.input(0), t.context.node.input(c);
    }, { deep: !0 }), (c, u) => (openBlock(), createElementBlock("table", null, [
      createElementVNode("thead", null, [
        createElementVNode("tr", null, [
          _hoisted_1,
          (openBlock(!0), createElementBlock(Fragment, null, renderList(e.context.labels, (m, qu) => (openBlock(), createElementBlock("th", { colspan: s.value }, [
            createElementVNode("small", null, toDisplayString(m), 1)
          ], 8, _hoisted_2))), 256))
        ])
      ]),
      createElementVNode("tbody", null, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(e.context.questions, (m, qu) => (openBlock(), createElementBlock("tr", {
          key: unref(r) + qu
        }, [
          createElementVNode("td", null, toDisplayString(m), 1),
          (openBlock(!0), createElementBlock(Fragment, null, renderList(e.context.values, (Gu, Qu) => (openBlock(), createElementBlock("td", {
            key: unref(r) + qu + Qu,
            style: normalizeStyle(`width:${l.value}`)
          }, [
            createElementVNode("div", _hoisted_3, [
              createElementVNode("label", {
                for: "",
                class: "formkit-wrapper",
                onClick: (Xu) => i.value[m] = Gu
              }, [
                createElementVNode("div", _hoisted_5, [
                  withDirectives(createElementVNode("input", {
                    type: "radio",
                    name: `radio-${unref(r)}-${qu}-${unref(n)}`,
                    value: Gu,
                    "onUpdate:modelValue": (Xu) => i.value[m] = Xu,
                    class: "formkit-input"
                  }, null, 8, _hoisted_6), [
                    [vModelRadio, i.value[m]]
                  ]),
                  _hoisted_7
                ])
              ], 8, _hoisted_4)
            ])
          ], 4))), 128))
        ]))), 128))
      ])
    ]));
  }
}, matrixRequired = function(e) {
  return e.value && Object.entries(e.value) ? e.props.questions.length === Object.entries(e.value).length : !0;
};
matrixRequired.blocking = !0;
matrixRequired.skipEmpty = !1;
matrixRequired.debounce = 20;
matrixRequired.force = !0;
const imageCropper = createInput(QsImageCropper, {
  props: ["aspectRatio", "movable", "resizable", "imageName", "maxSize", "acceptedFormats"]
}), fileUploader = createInput(_sfc_main$1, {
  props: ["accept"]
}), location = createInput(_sfc_main$3, {
  //props : ['accept']
}), matrix = createInput(_sfc_main, {
  props: ["questions", "values", "labels"]
}), questionabile = {
  install: (e, t) => {
    const n = {
      theme: "genesis",
      locales: { it: it$2 },
      locale: "it",
      plugins: [createMultiStepPlugin()],
      inputs: {
        imageCropper,
        fileUploader,
        location,
        matrix
      },
      // queste sono le property generali
      props: {
        // endpoint: options?.endpoint
      },
      rules: { matrixRequired },
      messages: {
        en: {
          validation: {
            requiredMatrix({ name: r }) {
              return `Please fill out the ${r} field.`;
            }
          }
        }
      }
    };
    if (t.config && (console.log("configurazione custom"), n.config = t.config), t.modules.indexOf("pro") > -1) {
      const r = (t == null ? void 0 : t.apiKey) || "fk-5c046e28fb";
      n.plugins.push(zu(r, Uu));
    }
    console.log("mount di questionabile"), e.use(plugin, defaultConfig(n)), e.use(FormKitSchema), e.component("QsWrapper", _sfc_main$7), e.component("QsToolbar", QsToolbar), e.component("QsModal", _sfc_main$6), e.component("QsPreview", _sfc_main$4), e.component("Cropper", fe), e.component("CircleStencil", me);
  }
};
export {
  _sfc_main$6 as QsModal,
  _sfc_main$4 as QsPreview,
  _sfc_main$7 as QsWrapper,
  questionabile as QuestionabilePlugin
};
